webpackJsonp([35783957827783],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = assertString;
	function assertString(input) {
	  var isString = typeof input === 'string' || input instanceof String;
	
	  if (!isString) {
	    throw new TypeError('This library (validator.js) validates strings only');
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = deprecated;
	
	var _warning = __webpack_require__(18);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function deprecated(validator, reason) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] != null) {
	      var messageKey = componentName + '.' + propName;
	
	      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));
	
	      warned[messageKey] = true;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}
	
	/* eslint-disable no-underscore-dangle */
	function _resetWarned() {
	  warned = {};
	}
	
	deprecated._resetWarned = _resetWarned;
	/* eslint-enable no-underscore-dangle */

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getField;
	/** @module utils/getField */
	
	/**
	 * Gets the current field for a component that can the field
	 * as either uncontrolled or controlled.
	 *
	 * @param {Object} props - the props object.
	 * @param {Object} state = the state object.
	 * @param {string=} field - the field to extract a value from. Defaults to 'value'.
	 *
	 * @return the field's value.
	 */
	function getField(props, state) {
	  var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'value';
	
	  return typeof props[field] !== 'undefined' ? props[field] : state[field];
	}
	//# sourceMappingURL=getField.js.map

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = themeColors;
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This is a utility function to apply the different text colors as a class name.
	 *
	 * @param {Object} options - The options to use to figure out which styles to apply.
	 * @param {boolean?} options.text - Boolean if the base text color should attempt to be
	 *    applied. This will only be applied if all the other states are not true.
	 * @param {boolean?} options.disabled - Boolean if the text should be disabled.
	 * @param {boolean?} options.error - Boolean if the error color should attempt to be applied.
	 *    This will only be applied if the disabled state is false.
	 * @param {boolean?} options.primary - Boolean if the primary color should be applied. This
	 *    will only be applied if all the other states are false.
	 * @param {boolean?} options.secondary - Boolean if the secondary color should be applied.
	 *    This will only be applied if all the other states are false.
	 * @param {boolean?} options.inherit - Boolean if the color should be inherited by a parent.
	 *    This will only be applied if the error and disabled states are false.
	 * @return {String} the class name
	 */
	function themeColors() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$themeText = _ref.themeText,
	      themeText = _ref$themeText === undefined ? true : _ref$themeText,
	      _ref$text = _ref.text,
	      text = _ref$text === undefined ? false : _ref$text,
	      _ref$background = _ref.background,
	      background = _ref$background === undefined ? false : _ref$background,
	      _ref$disabled = _ref.disabled,
	      disabled = _ref$disabled === undefined ? false : _ref$disabled,
	      _ref$error = _ref.error,
	      error = _ref$error === undefined ? false : _ref$error,
	      _ref$hint = _ref.hint,
	      hint = _ref$hint === undefined ? false : _ref$hint,
	      _ref$primary = _ref.primary,
	      primary = _ref$primary === undefined ? false : _ref$primary,
	      _ref$secondary = _ref.secondary,
	      secondary = _ref$secondary === undefined ? false : _ref$secondary,
	      _ref$inherit = _ref.inherit,
	      inherit = _ref$inherit === undefined ? false : _ref$inherit,
	      _ref$ink = _ref.ink,
	      ink = _ref$ink === undefined ? false : _ref$ink,
	      _ref$card = _ref.card,
	      card = _ref$card === undefined ? false : _ref$card,
	      _ref$hover = _ref.hover,
	      hover = _ref$hover === undefined ? false : _ref$hover;
	
	  var className = arguments[1];
	
	  var colors = '';
	  if (themeText) {
	    if (disabled) {
	      colors = 'md-text--disabled';
	    } else if (error) {
	      colors = 'md-text--error';
	    } else if (inherit) {
	      colors = 'md-text--inherit';
	    } else {
	      colors = (0, _classnames2.default)({
	        'md-text': text && !primary && !secondary && !hint,
	        'md-text--secondary': hint,
	        'md-text--theme-primary': !hint && primary,
	        'md-text--theme-secondary': !hint && secondary,
	        'md-ink--primary': ink && primary,
	        'md-ink--secondary': ink && secondary
	      });
	    }
	  } else {
	    colors = (0, _classnames2.default)({
	      'md-background': background && !primary && !secondary && !card,
	      'md-background--card': card,
	      'md-background--primary': primary,
	      'md-background--primary-hover': primary && hover,
	      'md-background--secondary': secondary,
	      'md-background--secondary-hover': secondary && hover
	    });
	  }
	
	  return (0, _classnames2.default)(colors, className);
	} /** @module utils/themeColors */
	//# sourceMappingURL=themeColors.js.map

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(12);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ICON_SIZE = 24;
	
	/**
	 * The \`FontIcon\` component is used for rendering a font-icon library's
	 * icon. The default is to use the `material-icons` library, but others
	 * can be used as well.
	 *
	 * If you are using another font-icon library that does not always create
	 * icons with a perfect 1:1 scale (such as font-awesome), it is recommended
	 * to update the `.md-icon` styles to set the width and height to `$md-font-icon-size`.
	 * However, this will prevent different sided icons.
	 *
	 * ```scss
	 * .md-icon.fa {
	 *   height: $md-font-icon-size;
	 *   width: $md-font-icon-size;
	 * }
	 * ```
	 */
	
	var FontIcon = function (_PureComponent) {
	  _inherits(FontIcon, _PureComponent);
	
	  function FontIcon(props) {
	    _classCallCheck(this, FontIcon);
	
	    var _this = _possibleConstructorReturn(this, (FontIcon.__proto__ || Object.getPrototypeOf(FontIcon)).call(this));
	
	    _initialiseProps.call(_this);
	
	    _this.state = { styles: _this._mergeStyles(props) };
	    return _this;
	  }
	
	  _createClass(FontIcon, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          style = _props.style,
	          forceSize = _props.forceSize,
	          forceFontSize = _props.forceFontSize;
	
	      if (style !== nextProps.style || forceSize !== nextProps.forceSize || forceFontSize !== nextProps.forceFontSize) {
	        this.setState({ styles: this._mergeStyles(nextProps) });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = this.state.styles;
	
	      var _props2 = this.props,
	          iconClassName = _props2.iconClassName,
	          className = _props2.className,
	          children = _props2.children,
	          disabled = _props2.disabled,
	          primary = _props2.primary,
	          secondary = _props2.secondary,
	          error = _props2.error,
	          inherit = _props2.inherit,
	          style = _props2.style,
	          forceSize = _props2.forceSize,
	          forceFontSize = _props2.forceFontSize,
	          props = _objectWithoutProperties(_props2, ['iconClassName', 'className', 'children', 'disabled', 'primary', 'secondary', 'error', 'inherit', 'style', 'forceSize', 'forceFontSize']);
	
	      var classes = (0, _classnames2.default)('md-icon', iconClassName, (0, _themeColors2.default)({
	        disabled: disabled,
	        error: error,
	        inherit: inherit,
	        primary: primary,
	        secondary: secondary
	      }), className);
	
	      return _react2.default.createElement(
	        'i',
	        _extends({}, props, { style: styles, className: classes }),
	        children
	      );
	    }
	  }]);
	
	  return FontIcon;
	}(_react.PureComponent);
	
	FontIcon.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `FontIcon`.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The icon font library className to use to display the icon.
	   */
	  iconClassName: _propTypes2.default.string.isRequired,
	
	  /**
	   * Boolean if the primary theme color should be applied.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the secondary theme color should be applied.
	   */
	  secondary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the icon is considered disabled and should inherit the
	   * disabled color.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the error color should be applied to the icon.
	   */
	  error: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the color of the icon should be inherited by parent elements.
	   */
	  inherit: _propTypes2.default.bool,
	
	  /**
	   * Either a boolean that will enforce the 24x24 size of the font icon or a number of the size
	   * to enforce. This is useful when using other font icon libraries that do not have a consistent
	   * size.
	   */
	  forceSize: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number]),
	
	  /**
	   * Boolean if the `forceSize` prop should also force the `font-size` instead of only `width` and `height`.
	   */
	  forceFontSize: function forceFontSize(props, propName, component) {
	    for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      args[_key - 3] = arguments[_key];
	    }
	
	    var error = _propTypes2.default.bool.apply(_propTypes2.default, [props, propName, component].concat(args));
	    if (!error && typeof props.forceSize === 'undefined' && props[propName]) {
	      error = new Error('You provided a `forceFontSize` prop to the ' + component + ' component, without specifying the `forceSize` ' + ('prop. Either set the `forceSize` prop to a boolean or a number, or disable `' + propName + '`.'));
	    }
	
	    return error;
	  },
	
	  /**
	   * Any children required to display the icon with the font library.
	   */
	  children: _propTypes2.default.node
	};
	FontIcon.defaultProps = {
	  iconClassName: 'material-icons'
	};
	
	var _initialiseProps = function _initialiseProps() {
	  this._mergeStyles = function (_ref) {
	    var style = _ref.style,
	        forceSize = _ref.forceSize,
	        forceFontSize = _ref.forceFontSize;
	
	    var styles = style;
	    if (typeof forceSize === 'boolean') {
	      styles = _extends({
	        height: ICON_SIZE,
	        width: ICON_SIZE,
	        fontSize: forceFontSize ? ICON_SIZE : undefined
	      }, style);
	    } else if (typeof forceSize === 'number') {
	      styles = _extends({
	        height: forceSize,
	        width: forceSize,
	        fontSize: forceFontSize ? forceSize : undefined
	      }, style);
	    }
	
	    return styles;
	  };
	};
	
	exports.default = FontIcon;
	//# sourceMappingURL=FontIcon.js.map

/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LEFT_MOUSE = exports.LEFT_MOUSE = 0;
	var RIGHT_MOUSE = exports.RIGHT_MOUSE = 2;
	
	var TAB = exports.TAB = 9;
	var ENTER = exports.ENTER = 13;
	var ESC = exports.ESC = 27;
	var SPACE = exports.SPACE = 32;
	var PAGE_UP = exports.PAGE_UP = 33;
	var PAGE_DOWN = exports.PAGE_DOWN = 34;
	var END = exports.END = 35;
	var HOME = exports.HOME = 36;
	var LEFT = exports.LEFT = 37;
	var UP = exports.UP = 38;
	var RIGHT = exports.RIGHT = 39;
	var DOWN = exports.DOWN = 40;
	
	var ZERO = exports.ZERO = 48;
	var NINE = exports.NINE = 57;
	var KEYPAD_ZERO = exports.KEYPAD_ZERO = 96;
	var KEYPAD_NINE = exports.KEYPAD_NINE = 105;
	//# sourceMappingURL=keyCodes.js.map

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = controlled;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Validates the a component is fully controlled or uncontrolled.  If the given prop is not
	 * `undefined`, it will check if the `funcName` is defined and a function. A missing function
	 * will generate an error similar to the built-in React controlled validation message.
	 *
	 * @param {String} funcName - The function name to use for additional validation.
	 * @param {function} validator - The PropTypes validator to use for the given prop.
	 * @return {Error} an error or null.
	 */
	function controlled(validator, funcName) {
	  var fallbackPropName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'defaultValue';
	
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	    if (!err && typeof props[propName] !== 'undefined' && !props.readOnly && !props.disabled) {
	      var _PropTypes$func;
	
	      var funcError = (_PropTypes$func = _propTypes2.default.func).isRequired.apply(_PropTypes$func, [props, funcName, componentName, location, propFullName].concat(args));
	      if (funcError) {
	        err = new Error('You provided a `' + propFullNameSafe + '` ' + location + ' to the ' + componentNameSafe + ' without a ' + ('`' + funcName + '` handler. This will render a read only field. Set either the `' + funcName + '` ') + ('or use the `' + fallbackPropName + '` instead.'));
	      }
	    }
	
	    return err;
	  };
	} /** @module utils/PropTypes/controlled */
	//# sourceMappingURL=controlled.js.map

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isRequiredForA11y;
	function isRequiredForA11y(validator) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}

/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _keyCodes = __webpack_require__(15);
	
	var _CSSTransitionGroupTick = __webpack_require__(34);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	var _getBtnStyles2 = __webpack_require__(259);
	
	var _getBtnStyles3 = _interopRequireDefault(_getBtnStyles2);
	
	var _invalidIf = __webpack_require__(48);
	
	var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	var _captureNextEvent = __webpack_require__(82);
	
	var _captureNextEvent2 = _interopRequireDefault(_captureNextEvent);
	
	var _FontIcon = __webpack_require__(13);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _IconSeparator = __webpack_require__(61);
	
	var _IconSeparator2 = _interopRequireDefault(_IconSeparator);
	
	var _injectInk = __webpack_require__(171);
	
	var _injectInk2 = _interopRequireDefault(_injectInk);
	
	var _injectTooltip = __webpack_require__(111);
	
	var _injectTooltip2 = _interopRequireDefault(_injectTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Button` component can either be a `FlatButton`, `RaisedButton`, `IconButton`, or a
	 * `FloatingButton`.
	 *
	 * A `FlatButton` is a button with no depth on the screen that is ideally used in `Dialog`s
	 * or `CardActions`. The text can be optionally styled with the `primary` or `secondary` colors.
	 *
	 * A `RaisedButton` is a button with some depth to help actions have more prominent in flat
	 * layouts or layouts with varying content. The background can be styled by the light/dark theme,
	 * or optionally the `primary` or `secondary` color.
	 *
	 * An `IconButton` is a button that just displays a `FontIcon` as the child in a circle.
	 * The `FontIcon` can be optionally styled with the `primary` or `secondary` color.
	 *
	 * A `FloatingButton` is a special case. Woop
	 */
	var Button = function (_PureComponent) {
	  _inherits(Button, _PureComponent);
	
	  function Button() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Button);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Button, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.disabled && !nextProps.disabled && this.state.hover) {
	        this.setState({ hover: false });
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      var _this2 = this;
	
	      if (!this.state.pressed && nextState.pressed) {
	        this._timeout = setTimeout(function () {
	          _this2._timeout = null;
	          if (_this2._attemptedBlur) {
	            _this2._attemptedBlur = false;
	
	            _this2.setState({ pressed: false });
	          }
	        }, 450);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	
	      if (this._snackbarTimeout) {
	        clearTimeout(this._snackbarTimeout);
	      }
	
	      window.removeEventListener('click', this._blur);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          iconClassName = _props.iconClassName,
	          iconChildren = _props.iconChildren,
	          iconBefore = _props.iconBefore,
	          href = _props.href,
	          primary = _props.primary,
	          secondary = _props.secondary,
	          flat = _props.flat,
	          raised = _props.raised,
	          floating = _props.floating,
	          mini = _props.mini,
	          fixed = _props.fixed,
	          fixedPosition = _props.fixedPosition,
	          disabled = _props.disabled,
	          component = _props.component,
	          ink = _props.ink,
	          tooltip = _props.tooltip,
	          icon = _props.icon,
	          forceIconSize = _props.forceIconSize,
	          forceIconFontSize = _props.forceIconFontSize,
	          type = _props.type,
	          children = _props.children,
	          swapTheming = _props.swapTheming,
	          svg = _props.svg,
	          propIconEl = _props.iconEl,
	          label = _props.label,
	          props = _objectWithoutProperties(_props, ['className', 'iconClassName', 'iconChildren', 'iconBefore', 'href', 'primary', 'secondary', 'flat', 'raised', 'floating', 'mini', 'fixed', 'fixedPosition', 'disabled', 'component', 'ink', 'tooltip', 'icon', 'forceIconSize', 'forceIconFontSize', 'type', 'children', 'swapTheming', 'svg', 'iconEl', 'label']);
	
	      var iconEl = this.props.iconEl;
	
	
	      if (!href) {
	        props.type = type;
	      }
	
	      var _state = this.state,
	          pressed = _state.pressed,
	          hover = _state.hover,
	          snackbar = _state.snackbar,
	          snackbarType = _state.snackbarType;
	
	      var iconBtnType = icon || floating;
	
	      var visibleChildren = void 0;
	      if (!iconEl && !svg && (iconClassName || iconChildren || iconBtnType || label && children)) {
	        var resolvedIconChildren = iconChildren;
	        if (typeof iconChildren === 'undefined') {
	          resolvedIconChildren = iconBtnType || label ? children : null;
	        }
	
	        iconEl = _react2.default.createElement(
	          _FontIcon2.default,
	          { iconClassName: iconClassName, forceSize: forceIconSize, forceFontSize: forceIconFontSize, inherit: true },
	          resolvedIconChildren
	        );
	      } else if (iconEl || svg) {
	        var el = _react2.default.Children.only(iconEl || children);
	        iconEl = _react2.default.cloneElement(el, { inherit: !el.props.error });
	      }
	
	      if (!iconBtnType) {
	        visibleChildren = label || children;
	        if (iconEl) {
	          visibleChildren = _react2.default.createElement(
	            _IconSeparator2.default,
	            { label: visibleChildren, iconBefore: iconBefore },
	            iconEl
	          );
	        }
	      } else {
	        visibleChildren = iconEl;
	      }
	
	      var Component = component || (href ? 'a' : 'button');
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, {
	          disabled: disabled,
	          onTouchStart: this._handleTouchStart,
	          onTouchEnd: this._handleTouchEnd,
	          onMouseDown: this._handleMouseDown,
	          onMouseUp: this._handleMouseUp,
	          onKeyDown: this._handleKeyDown,
	          onKeyUp: this._handleKeyUp,
	          onMouseEnter: this._handleMouseEnter,
	          onMouseLeave: this._handleMouseLeave,
	          href: href,
	          className: (0, _getBtnStyles3.default)({
	            flat: flat,
	            raised: raised,
	            icon: icon,
	            floating: floating,
	            disabled: disabled,
	            primary: primary,
	            secondary: secondary,
	            hover: hover,
	            swapTheming: swapTheming,
	            pressed: pressed,
	            mini: mini,
	            fixed: fixed,
	            fixedPosition: fixedPosition
	          }, _defineProperty({
	            'md-btn--tooltip': tooltip,
	            'md-btn--snackbar-floating': snackbar
	          }, 'md-btn--snackbar-floating-' + snackbarType + 'adjust', snackbar && snackbarType !== null), 'md-inline-block', className)
	        }),
	        ink,
	        tooltip,
	        visibleChildren
	      );
	    }
	  }]);
	
	  return Button;
	}(_react.PureComponent);
	
	Button.propTypes = {
	  /**
	   * An optional style to apply to the button.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the button.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * A boolean if the icon should appear before or after the text for a `FlatButton` or
	   * a `RaisedButton`.
	   */
	  iconBefore: _propTypes2.default.bool,
	
	  /**
	   * Any children used to display the button. When the button type is `icon` or `floating`,
	   * this can be used to render the `FontIcon` instead of the `iconChildren` prop.
	   *
	   * When the button type is `raised` or `flat`, this will be the label or any other elements
	   * you'd like to display in the button. This can work hand-in-hand with the `iconClassName`
	   * and `iconChildren` to make a button with an icon and text.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An icon className to use in an optional `FontIcon` in any version of the button. This will
	   * be used with the `children` prop. If the `floating` or `icon` props are set to true, this or
	   * the children are required.
	   *
	   * @see {@link #iconEl}
	   */
	  iconClassName: _propTypes2.default.string,
	
	  /**
	   * Any children to use to display an icon in the button.
	   *
	   * @see {@link #iconEl}
	   */
	  iconChildren: _propTypes2.default.node,
	
	  /**
	   * An optional icon to display. This prop is recommended over the `iconClassName` and `iconChildren`
	   * props since it allows more control for you. There is also better SVG support since it won't wrap
	   * the SVG with the `FontIcon` element.
	   */
	  iconEl: _propTypes2.default.element,
	
	  /**
	   * The type for the button. This is required when the `component` prop is not
	   * the 'a' tag, a `function`, or when the `href` prop is defined.
	   */
	  type: function type(props, propName, component) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	      args[_key2 - 3] = arguments[_key2];
	    }
	
	    var c = props.component;
	    var validator = _propTypes2.default.oneOf(['button', 'submit', 'reset']);
	    if (!props.href && c !== 'a' && typeof c !== 'function') {
	      validator = validator.isRequired;
	    }
	
	    return validator.apply(undefined, [props, propName, component].concat(args));
	  },
	
	  /**
	   * Boolean if the button should be styled with the primary color.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the button should be styled with the secondary color.
	   */
	  secondary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the button is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional href for the button. This will style the `a` tag as a button.
	   */
	  href: _propTypes2.default.string,
	
	  /**
	   * An optional component to render the button as. This allows you to get all the styles and functionality
	   * of the Button, but as a custom React component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	
	  /**
	   * An optional function to call when the `click` event is triggered.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `touchstart` event is triggered.
	   */
	  onTouchStart: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `touchend` event is triggered.
	   */
	  onTouchEnd: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mousedown` event is triggered.
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseup` event is triggered.
	   */
	  onMouseUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `keyup` event is triggered.
	   */
	  onKeyUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `keydown` event is triggered.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseenter` event is triggered.
	   */
	  onMouseEnter: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseleave` event is triggered.
	   */
	  onMouseLeave: _propTypes2.default.func,
	
	  /**
	   * Boolean if the `FloatingButton` should be fixed to the page. This prop can
	   * only be enabled if the `floating` prop is true.
	   */
	  fixed: (0, _invalidIf2.default)(_propTypes2.default.bool, 'flat', 'raised', 'icon'),
	
	  /**
	   * The position that the `FloatingButton` should be fixed to the page. It will
	   * either be fixed to the top right, top left, bottom right, or bottom left of
	   * the page. This prop is only used if the `floating` prop and `fixed` prop are
	   * `true`.
	   */
	  fixedPosition: _propTypes2.default.oneOf(['tr', 'tl', 'br', 'bl']).isRequired,
	
	  /**
	   * Boolean if the `FloatingButton` should be `mini`. This prop can only be used
	   * when the `floating` prop is true.
	   */
	  mini: (0, _invalidIf2.default)(_propTypes2.default.bool, 'flat', 'raised', 'icon'),
	
	  /**
	   * Boolean if the `Button` should be styled as a `FlatButton`.
	   */
	  flat: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `Button` should be styled as a `RaisedButton`.
	   */
	  raised: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `Button` should be styled as a `IconButton`.
	   *
	   * @see {@link #svg}
	   */
	  icon: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `Button` should be styled as a `FloatingButton`.
	   *
	   * @see {@link #svg}
	   */
	  floating: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the theming of `primary` or `secondary` should be swapped. By default,
	   * only flat and icon buttons can gain the theme colors as text color while the raised
	   * and floating buttons can gain the theme colors as background color.
	   *
	   * If this prop is enabled, the flat and icon buttons will gain the theme background colors
	   * while the raised and icon will gain the theme text colors instead.
	   *
	   * @see {@link #primary}
	   * @see {@link #secondary}
	   */
	  swapTheming: _propTypes2.default.bool,
	
	  /**
	   * An optional label to use for the tooltip. This is normally only used for
	   * `IconButton`s or `FloatingButton`s, but can be used on `FlatButton`s and
	   * `RaisedButton`s if you wish. Knock yourself out!
	   *
	   * If this prop is omitted, no tooltip will be included.
	   */
	  tooltipLabel: _propTypes2.default.node,
	
	  /**
	   * An optional delay before the tooltip appears on mouse over.
	   */
	  tooltipDelay: _propTypes2.default.number,
	
	  /**
	   * The position for the tooltip.
	   */
	  tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * An ink from `injectInk`.
	   * @access private
	   */
	  ink: _propTypes2.default.node,
	
	  /**
	   * A tooltip from `injectTooltip`
	   * @access private
	   */
	  tooltip: _propTypes2.default.node,
	
	  /**
	   * Custom validator for verifying that only one type is defined and that
	   * at one type is defined.
	   */
	  _typeValidator: function _typeValidator(props, propName, component) {
	    var flat = props.flat,
	        raised = props.raised,
	        icon = props.icon,
	        floating = props.floating;
	
	
	    var defined = [raised, flat, icon, floating].filter(function (d) {
	      return d;
	    });
	    var len = defined.length;
	    if (len === 0) {
	      return new Error('A material design button type must be specified in the `' + component + '` but none were ' + 'given. Valid types are `flat`, `raised`, `icon`, or `floating`.');
	    } else if (len !== 1) {
	      return new Error('Only one material design button type may be specified in the `' + component + '` but `' + len + '` ' + 'were given. Select only one of `flat`, `raised`, `icon`, or `floating`.');
	    }
	
	    return null;
	  },
	
	  /**
	   * Either a boolean that will enforce the 24x24 size of the font icon or a number of the size
	   * to enforce. This is useful when using other font icon libraries that do not have a consistent
	   * size.
	   */
	  forceIconSize: _FontIcon2.default.propTypes.forceSize,
	
	  /**
	   * Boolean if the `forceIconSize` prop should also force the `font-size` instead of only `width` and `height`.
	   */
	  forceIconFontSize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the child is an SVGIcon or FontIcon when using the `icon` or `floating` props. This is only needed
	   * until the next release when the `label` migration can be removed.
	   */
	  svg: _propTypes2.default.bool,
	
	  label: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `children` prop instead'),
	  noIcon: (0, _deprecated2.default)(_propTypes2.default.bool, 'This has been removed during the alpha release. Children will always attempt to be rendered outside of an ' + 'icon by default for flat and raised buttons.')
	};
	Button.defaultProps = {
	  type: 'button',
	  iconBefore: true,
	  fixedPosition: 'br'
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.state = {
	    pressed: false,
	    snackbar: false,
	    snackbarType: null
	  };
	
	  this._blur = function () {
	    if (_this3.props.disabled) {
	      return;
	    }
	
	    if (_this3._timeout) {
	      _this3._attemptedBlur = true;
	    } else {
	      _this3.setState({ pressed: false });
	    }
	  };
	
	  this._handleMouseUp = function (e) {
	    if (_this3.props.onMouseUp) {
	      _this3.props.onMouseUp(e);
	    }
	
	    _this3._blur();
	  };
	
	  this._handleMouseDown = function (e) {
	    if (_this3.props.onMouseDown) {
	      _this3.props.onMouseDown(e);
	    }
	
	    if (!_this3.props.disabled) {
	      _this3.setState({ pressed: true });
	    }
	  };
	
	  this._handleTouchStart = function (e) {
	    if (_this3.props.onTouchStart) {
	      _this3.props.onTouchStart(e);
	    }
	
	    if (!_this3.props.disabled) {
	      _this3.setState({ pressed: true });
	    }
	  };
	
	  this._handleTouchEnd = function (e) {
	    if (_this3.props.onTouchEnd) {
	      _this3.props.onTouchEnd(e);
	    }
	
	    _this3._blur();
	    (0, _captureNextEvent2.default)('mouseover');
	  };
	
	  this._handleKeyUp = function (e) {
	    if (_this3.props.onKeyUp) {
	      _this3.props.onKeyUp(e);
	    }
	
	    if ((e.which || e.keyCode) === _keyCodes.TAB) {
	      window.addEventListener('click', _this3._blur);
	      _this3.setState({ pressed: true });
	    }
	  };
	
	  this._handleKeyDown = function (e) {
	    if (_this3.props.onKeyDown) {
	      _this3.props.onKeyDown(e);
	    }
	
	    if ((e.which || e.keyCode) === _keyCodes.TAB) {
	      window.removeEventListener('click', _this3._blur);
	      _this3.setState({ pressed: false });
	    }
	  };
	
	  this._handleMouseEnter = function (e) {
	    if (_this3.props.onMouseEnter) {
	      _this3.props.onMouseEnter(e);
	    }
	
	    if (!_this3.props.disabled) {
	      _this3.setState({ hover: true });
	    }
	  };
	
	  this._handleMouseLeave = function (e) {
	    if (_this3.props.onMouseLeave) {
	      _this3.props.onMouseLeave(e);
	    }
	
	    if (!_this3.props.disabled) {
	      _this3.setState({ hover: false });
	    }
	  };
	
	  this._animateForSnackbar = function (multiline, leaveTimeout) {
	    if (typeof leaveTimeout === 'number') {
	      _this3._snackbarTimeout = setTimeout(function () {
	        _this3._snackbarTimeout = setTimeout(function () {
	          _this3._snackbarTimeout = null;
	
	          _this3.setState({ snackbar: false });
	        }, leaveTimeout + 150);
	
	        _this3.setState({ snackbarType: null });
	      }, _CSSTransitionGroupTick2.default);
	    } else {
	      _this3._snackbarTimeout = setTimeout(function () {
	        _this3._snackbarTimeout = null;
	
	        _this3.setState({ snackbar: true, snackbarType: multiline ? 'multiline-' : '' });
	      }, _CSSTransitionGroupTick2.default);
	    }
	  };
	};
	
	exports.default = (0, _injectInk2.default)((0, _injectTooltip2.default)(Button));
	//# sourceMappingURL=Button.js.map

/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDeprecatedIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FontIcon = __webpack_require__(13);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDeprecatedIcon(className, children, icon) {
	  if (className || children) {
	    return _react2.default.createElement(
	      _FontIcon2.default,
	      { iconClassName: className },
	      children
	    );
	  }
	
	  return icon;
	}
	//# sourceMappingURL=getDeprecatedIcon.js.map

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.shape({
	  x: _propTypes2.default.object,
	  y: _propTypes2.default.object
	})]);
	//# sourceMappingURL=fixedToShape.js.map

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AccessibleFakeButton = __webpack_require__(80);
	
	var _AccessibleFakeButton2 = _interopRequireDefault(_AccessibleFakeButton);
	
	var _injectInk = __webpack_require__(171);
	
	var _injectInk2 = _interopRequireDefault(_injectInk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _injectInk2.default)(_AccessibleFakeButton2.default);
	//# sourceMappingURL=AccessibleFakeInkedButton.js.map

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _resizeObserverPolyfill = __webpack_require__(743);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `ResizeObserver` component is a component hook for the
	 * [ResizeObserver](http://rawgit.com/WICG/ResizeObserver/master/index.html)
	 * using the [resize-observer-polyfill](https://github.com/que-etc/resize-observer-polyfill)
	 * for browsers that don't support it yet.
	 *
	 * This component displays an empty `span` with `aria-hidden` to allow access to the DOM. By
	 * default it will attempt to watch changes on its parent component, but it can be configured
	 * to watch any element by using the `target` prop.
	 */
	var ResizeObserver = function (_PureComponent) {
	  _inherits(ResizeObserver, _PureComponent);
	
	  function ResizeObserver() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ResizeObserver);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ResizeObserver.__proto__ || Object.getPrototypeOf(ResizeObserver)).call.apply(_ref, [this].concat(args))), _this), _this._container = null, _this._target = null, _this._observer = null, _this._height = null, _this._width = null, _this._scrollHeight = null, _this._scrollWidth = null, _this._measure = function (entries) {
	      if (!_this._observer || !_this._target) {
	        return;
	      }
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var entry = _step.value;
	
	          if (!entry) {
	            return;
	          }
	
	          var _entry$contentRect = entry.contentRect,
	              height = _entry$contentRect.height,
	              width = _entry$contentRect.width;
	          var _entry$target = entry.target,
	              scrollHeight = _entry$target.scrollHeight,
	              scrollWidth = _entry$target.scrollWidth;
	
	          if (_this._isHeightChange(height, scrollHeight) || _this._isWidthChange(width, scrollWidth)) {
	            _this._height = height;
	            _this._width = width;
	            _this._scrollHeight = scrollHeight;
	            _this._scrollWidth = scrollWidth;
	            _this.props.onResize({ height: height, width: width, scrollHeight: scrollHeight, scrollWidth: scrollWidth, el: entry.target });
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }, _this._isHeightChange = function (height, scrollHeight) {
	      return _this.props.watchHeight && (height !== _this._height || scrollHeight !== _this._scrollHeight);
	    }, _this._isWidthChange = function (width, scrollWidth) {
	      return _this.props.watchWidth && (width !== _this._width || scrollWidth !== _this._scrollWidth);
	    }, _this._handleRef = function (container) {
	      if (container) {
	        _this._container = container;
	        _this._target = _this._getTarget(container, _this.props.target);
	        _this._observer = new _resizeObserverPolyfill2.default(_this._measure);
	
	        if (_this._target) {
	          _this._observer.observe(_this._target);
	        }
	      } else {
	        if (_this._observer) {
	          _this._observer.disconnect();
	        }
	
	        _this._container = null;
	        _this._target = null;
	        _this._observer = null;
	        _this._height = null;
	        _this._width = null;
	        _this._scrollHeight = null;
	        _this._scrollWidth = null;
	      }
	
	      if (_this.props.elRef) {
	        _this.props.elRef(_this._target);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ResizeObserver, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var target = this.props.target;
	
	      var nextTarget = nextProps.target;
	      if (target === nextTarget) {
	        return;
	      } else if (nextTarget) {
	        if (this._target) {
	          this._observer.unobserve(this._target);
	        }
	        this._target = this._getTarget(this._container, nextTarget);
	        this._observer.observe(this._target);
	      }
	    }
	  }, {
	    key: '_getTarget',
	    value: function _getTarget(container, target) {
	      if (target === null || target && typeof target !== 'string') {
	        return target;
	      }
	
	      var t = null;
	      if (target) {
	        t = document.getElementById(target) || document.querySelector(target);
	      } else {
	        t = container.parentNode;
	      }
	
	      if (!t) {
	        throw new Error('An HTMLDOMNode is required as the `ResizeObserver`\'s watch target but none were provided/found. ' + ('Please update the target prop to find a valid node since the provided target is invalid. `' + target + '`.'));
	      }
	
	      return t;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var Component = this.props.component;
	
	      return _react2.default.createElement(Component, { ref: this._handleRef, 'aria-hidden': true });
	    }
	  }]);
	
	  return ResizeObserver;
	}(_react.PureComponent);
	
	ResizeObserver.propTypes = {
	  /**
	   * Boolean if the height should be watched for the resize target.
	   */
	  watchHeight: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the width should be watched for the resize target.
	   */
	  watchWidth: _propTypes2.default.bool,
	
	  /**
	   * An optional target that should be used for detecting resize events. This can either
	   * be a HTMLDOMNode or a string to use with `document.getElementById` or `document.querySelector`.
	   *
	   * If this prop is not provided and not null, it will default to the parent node of this component.
	   * If the provided `target={null}`, the observer will not begin until the `target` is `undefined` or
	   * it has been correctly passed a target string or object.
	   */
	  target: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	
	  /**
	   * The component to be rendered as. This should normally just be the default `span`, but there are cases
	   * where the component should be switched to something else for valid html.
	   */
	  component: _propTypes2.default.string,
	
	  /**
	   * A function to call when the height or width has been changed and that attribute is being watched.
	   * The callback will include the current height, width, scrollHeight and scrollWidth of the target.
	   *
	   * ```js
	   * onResize({
	   *   height: nextHeight,
	   *   width: nextWidth,
	   *   scrollHeight: nextScrollHeight,
	   *   scrollWidth: nextScrollWidth,
	   *   el: resizeTarget,
	   * });
	   * ```
	   */
	  onResize: _propTypes2.default.func.isRequired,
	
	  /**
	   * An optional ref callback that will include the `target` or the parent node of the resize observer. Just
	   * like other refs, this will provide null when it unmounts.
	   *
	   * This is really only helpful if you'd like the DOM node for a parent Component without needing to use
	   * `ReactDOM.findDOMNode(this)`.
	   */
	  elRef: _propTypes2.default.func
	};
	ResizeObserver.defaultProps = {
	  watchHeight: false,
	  watchWidth: false,
	  component: 'span'
	};
	exports.default = ResizeObserver;
	//# sourceMappingURL=ResizeObserver.js.map

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _between = __webpack_require__(85);
	
	var _between2 = _interopRequireDefault(_between);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Paper` component is a simple wrapper that adds box-shadow.
	 *
	 * You can also use the SCSS mixin instead of paper.
	 *
	 * ```scss
	 * @include md-box-shadow(5);
	 * ```
	 */
	var Paper = function (_PureComponent) {
	  _inherits(Paper, _PureComponent);
	
	  function Paper() {
	    _classCallCheck(this, Paper);
	
	    return _possibleConstructorReturn(this, (Paper.__proto__ || Object.getPrototypeOf(Paper)).apply(this, arguments));
	  }
	
	  _createClass(Paper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.component,
	          zDepth = _props.zDepth,
	          className = _props.className,
	          raiseOnHover = _props.raiseOnHover,
	          props = _objectWithoutProperties(_props, ['component', 'zDepth', 'className', 'raiseOnHover']);
	
	      return _react2.default.createElement(Component, _extends({}, props, {
	        className: (0, _classnames2.default)('md-paper md-paper--' + zDepth, {
	          'md-paper--0-hover': zDepth === 0 && raiseOnHover
	        }, className)
	      }));
	    }
	  }]);
	
	  return Paper;
	}(_react.PureComponent);
	
	Paper.propTypes = {
	  /**
	   * The component to render the paper as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The depth of the paper. This should be a number between 0 - 5. If
	   * the depth is 0, it will raise to a depth of 3 on hover.
	   */
	  zDepth: (0, _between2.default)(_propTypes2.default.number.isRequired, 0, 5),
	
	  /**
	   * Any children to display in the paper.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the paper should raise to the `zDepth` of `3` on hover when the initial
	   * `zDepth` is `0`.
	   */
	  raiseOnHover: _propTypes2.default.bool
	};
	Paper.defaultProps = {
	  zDepth: 1,
	  component: 'div'
	};
	exports.default = Paper;
	//# sourceMappingURL=Paper.js.map

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// This will need to keep in sync with the `ReactCSSTransitionGroupChild` `TICK` const.
	// https://github.com/facebook/react/blob/master/src/addons/transitions/ReactCSSTransitionGroupChild.js#L22
	
	exports.default = 17;
	//# sourceMappingURL=CSSTransitionGroupTick.js.map

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _HorizontalAnchors = __webpack_require__(274);
	
	var _HorizontalAnchors2 = _interopRequireDefault(_HorizontalAnchors);
	
	var _VerticalAnchors = __webpack_require__(276);
	
	var _VerticalAnchors2 = _interopRequireDefault(_VerticalAnchors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.shape({
	  x: _propTypes2.default.oneOf([_HorizontalAnchors2.default.LEFT, _HorizontalAnchors2.default.INNER_LEFT, _HorizontalAnchors2.default.CENTER, _HorizontalAnchors2.default.RIGHT, _HorizontalAnchors2.default.INNER_RIGHT]).isRequired,
	  y: _propTypes2.default.oneOf([_VerticalAnchors2.default.TOP, _VerticalAnchors2.default.CENTER, _VerticalAnchors2.default.OVERLAP, _VerticalAnchors2.default.BOTTOM]).isRequired
	});
	//# sourceMappingURL=anchorShape.js.map

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Positions = __webpack_require__(275);
	
	var _Positions2 = _interopRequireDefault(_Positions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.oneOfType([_propTypes2.default.oneOf([_Positions2.default.TOP_LEFT, _Positions2.default.TOP_RIGHT, _Positions2.default.BOTTOM_LEFT, _Positions2.default.BOTTOM_RIGHT, _Positions2.default.BELOW]), _propTypes2.default.string]);
	//# sourceMappingURL=positionShape.js.map

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _reactMotion = __webpack_require__(309);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Collapse` component is used to animate a single child entering
	 * or leaving. This uses the `react-motion` library to animate the height,
	 * padding-top, and padding-bottom of an element when the `collapsed` prop
	 * changes.
	 */
	var Collapse = function (_PureComponent) {
	  _inherits(Collapse, _PureComponent);
	
	  function Collapse(props) {
	    _classCallCheck(this, Collapse);
	
	    var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));
	
	    _this._setHeight = function (child) {
	      if (_this._child && typeof _this._child.ref === 'function') {
	        _this._child.ref(child);
	      }
	
	      var height = 0;
	      var paddingTop = 0;
	      var paddingBottom = 0;
	      if (child !== null) {
	        var node = (0, _reactDom.findDOMNode)(child);
	        var cs = window.getComputedStyle(node);
	        height = node.offsetHeight;
	        paddingTop = parseInt(cs.getPropertyValue('padding-top'), 10);
	        paddingBottom = parseInt(cs.getPropertyValue('padding-bottom'), 10);
	      }
	
	      height = Math.max(_this.props.minHeight, height);
	
	      _this.setState({ height: height, paddingTop: paddingTop, paddingBottom: paddingBottom });
	    };
	
	    if (!props.collapsed) {
	      _this.state = { initialOpen: true };
	    } else {
	      _this.state = {
	        height: props.minHeight,
	        paddingTop: 0,
	        paddingBottom: 0
	      };
	    }
	    return _this;
	  }
	
	  _createClass(Collapse, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.initialOpen && nextProps.collapsed) {
	        this.setState({ initialOpen: false });
	      }
	    }
	  }, {
	    key: '_spring',
	    value: function _spring(collapsed, initialOpen, value, config) {
	      var min = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	
	      var nextValue = !collapsed ? Math.max(min, value) : min;
	      if (initialOpen && !collapsed) {
	        return nextValue;
	      }
	
	      return (0, _reactMotion.spring)(nextValue, config);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          height = _state.height,
	          paddingTop = _state.paddingTop,
	          paddingBottom = _state.paddingBottom,
	          initialOpen = _state.initialOpen;
	      var _props = this.props,
	          children = _props.children,
	          collapsed = _props.collapsed,
	          defaultStyle = _props.defaultStyle,
	          motionStyle = _props.style,
	          springConfig = _props.springConfig,
	          animate = _props.animate,
	          minHeight = _props.minHeight;
	
	
	      if (!animate) {
	        return collapsed ? null : children;
	      }
	
	      return _react2.default.createElement(
	        _reactMotion.Motion,
	        {
	          style: _extends({}, motionStyle, {
	            height: this._spring(collapsed, initialOpen, height, springConfig, minHeight),
	            paddingTop: this._spring(collapsed, initialOpen, paddingTop, springConfig),
	            paddingBottom: this._spring(collapsed, initialOpen, paddingBottom, springConfig)
	          }),
	          defaultStyle: _extends({}, defaultStyle, {
	            height: height,
	            paddingTop: paddingTop,
	            paddingBottom: paddingBottom
	          })
	        },
	        function (style) {
	          if (collapsed && !style.height) {
	            return null;
	          }
	
	          var child = _react.Children.only(children);
	          _this2._child = child;
	          var nextStyle = child.props.style;
	          if (collapsed && (!minHeight || style.height !== minHeight) || style.height !== height) {
	            nextStyle = _extends({}, child.props.style, style, {
	              overflow: 'hidden'
	            });
	          }
	          return (0, _react.cloneElement)(child, {
	            ref: !collapsed && _this2._setHeight,
	            style: nextStyle
	          });
	        }
	      );
	    }
	  }]);
	
	  return Collapse;
	}(_react.PureComponent);
	
	Collapse.propTypes = {
	  /**
	   * An optional style to merge with the `Motion` style.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional default style to merge with the `Motion` default style.
	   */
	  defaultStyle: _propTypes2.default.object,
	
	  /**
	   * Boolean if the children are currently collapsed.
	   */
	  collapsed: _propTypes2.default.bool.isRequired,
	
	  /**
	   * A single child to collapse or expand.
	   */
	  children: _propTypes2.default.element.isRequired,
	
	  /**
	   * The spring config to use for the animation.
	   */
	  springConfig: _propTypes2.default.object.isRequired,
	
	  /**
	   * Boolean if the single child entering or leaving should be animated.
	   */
	  animate: _propTypes2.default.bool,
	
	  /**
	   * The min height to apply for the collapse div.
	   */
	  minHeight: _propTypes2.default.number.isRequired
	};
	Collapse.defaultProps = {
	  animate: true,
	  springConfig: {
	    precision: 0.5
	  },
	  minHeight: 0
	};
	exports.default = Collapse;
	//# sourceMappingURL=Collapse.js.map

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = componentDeprecated;
	/** @module utils/PropTypes/componentDeprecated */
	
	/**
	 * A simple PropType validation that shows that a component is deprecated and also prints
	 * a reason for the deprecation.
	 *
	 * @param {String} reason - The reason that the component is deprecated.
	 * @return {Error} a prop type validation error.
	 */
	function componentDeprecated(reason) {
	  return function validate(props, propName, componentName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	
	    return new Error('The `' + componentNameSafe + '` has been deprecated and will be removed in the next release. ' + reason);
	  };
	}
	//# sourceMappingURL=componentDeprecated.js.map

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = invalidIf;
	/** @module utils/PropTypes/invalidIf */
	
	/**
	 * A custom validator that will throw an error if any of the `ifDefinedProps` are also defined.
	 *
	 * @param {function} validator - The PropTypes validator to use.
	 * @param {String...} ifDefinedProps - any othe rprop names to validate against
	 * @return {Error} an error or null
	 */
	function invalidIf(validator) {
	  for (var _len = arguments.length, ifDefinedProps = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    ifDefinedProps[_key - 1] = arguments[_key];
	  }
	
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    for (var _len2 = arguments.length, args = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	      args[_key2 - 5] = arguments[_key2];
	    }
	
	    var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	    if (err) {
	      return err;
	    }
	
	    var defined = typeof props[propName] !== 'undefined' && !!props[propName];
	    var othersDefined = ifDefinedProps.filter(function (name) {
	      return typeof props[name] !== 'undefined' && !!props[name];
	    });
	    if (defined && othersDefined.length) {
	      var names = '`' + othersDefined.join('`, `') + '`';
	      if (othersDefined.length === 1) {
	        return new Error('You provided both a `' + propFullNameSafe + '` and ' + names + ' prop to the ' + componentNameSafe + ' ' + 'but only one can be given.');
	      }
	
	      return new Error('You provided a `' + propFullNameSafe + '` ' + location + ' to the ' + componentNameSafe + ' when ' + ('the following props were defined: ' + names + '. Either remove the `' + propFullNameSafe + '` ') + 'or use the remove all the other props.');
	    }
	
	    return null;
	  };
	}
	//# sourceMappingURL=invalidIf.js.map

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(190);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransitionGroupChild = __webpack_require__(729);
	
	var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);
	
	var _PropTypes = __webpack_require__(316);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  transitionName: _PropTypes.nameShape.isRequired,
	
	  transitionAppear: _propTypes2.default.bool,
	  transitionEnter: _propTypes2.default.bool,
	  transitionLeave: _propTypes2.default.bool,
	  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
	  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
	  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
	};
	
	var defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	var CSSTransitionGroup = function (_React$Component) {
	  _inherits(CSSTransitionGroup, _React$Component);
	
	  function CSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // We need to provide this childFactory so that
	  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	  // leave while it is leaving.
	
	
	  CSSTransitionGroup.prototype.render = function render() {
	    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return CSSTransitionGroup;
	}(_react2.default.Component);
	
	CSSTransitionGroup.displayName = 'CSSTransitionGroup';
	
	
	CSSTransitionGroup.propTypes =  false ? propTypes : {};
	CSSTransitionGroup.defaultProps = defaultProps;
	
	exports.default = CSSTransitionGroup;
	module.exports = exports['default'];

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _themeColors = __webpack_require__(12);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _getCollapserStyles = __webpack_require__(114);
	
	var _getCollapserStyles2 = _interopRequireDefault(_getCollapserStyles);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _injectTooltip = __webpack_require__(111);
	
	var _injectTooltip2 = _interopRequireDefault(_injectTooltip);
	
	var _FontIcon = __webpack_require__(13);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(21);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _IconSeparator = __webpack_require__(61);
	
	var _IconSeparator2 = _interopRequireDefault(_IconSeparator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CELL_SCOPE = {
	  header: {
	    scope: 'col'
	  },
	  noop: {}
	};
	
	/**
	 * A column in a table. This is either the `th` or `td` component.
	 */
	
	var TableColumn = function (_PureComponent) {
	  _inherits(TableColumn, _PureComponent);
	
	  function TableColumn() {
	    _classCallCheck(this, TableColumn);
	
	    return _possibleConstructorReturn(this, (TableColumn.__proto__ || Object.getPrototypeOf(TableColumn)).apply(this, arguments));
	  }
	
	  _createClass(TableColumn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          fixedStyle = _props.fixedStyle,
	          fixedClassName = _props.fixedClassName,
	          numeric = _props.numeric,
	          header = _props.header,
	          children = _props.children,
	          sorted = _props.sorted,
	          sortIcon = _props.sortIcon,
	          tooltip = _props.tooltip,
	          selectColumnHeader = _props.selectColumnHeader,
	          adjusted = _props.adjusted,
	          grow = _props.grow,
	          sortIconBefore = _props.sortIconBefore,
	          propPlain = _props.plain,
	          propScope = _props.scope,
	          cellIndex = _props.cellIndex,
	          sortIconChildren = _props.sortIconChildren,
	          sortIconClassName = _props.sortIconClassName,
	          props = _objectWithoutProperties(_props, ['className', 'fixedStyle', 'fixedClassName', 'numeric', 'header', 'children', 'sorted', 'sortIcon', 'tooltip', 'selectColumnHeader', 'adjusted', 'grow', 'sortIconBefore', 'plain', 'scope', 'cellIndex', 'sortIconChildren', 'sortIconClassName']);
	
	      var sortable = typeof sorted === 'boolean';
	      var plain = (0, _getField2.default)(this.props, this.context, 'plain');
	      var Component = header ? 'th' : 'td';
	      var scope = (0, _getField2.default)(this.props, CELL_SCOPE[header ? 'header' : 'noop'], 'scope');
	
	      var displayedChildren = children;
	      var ariaSort = void 0;
	      if (sortable) {
	        ariaSort = sorted ? 'ascending' : 'descending';
	        var icon = _react2.default.Children.only((0, _getDeprecatedIcon2.default)(sortIconClassName, sortIconChildren, sortIcon));
	        displayedChildren = _react2.default.createElement(
	          _IconSeparator2.default,
	          { label: children, iconBefore: sortIconBefore },
	          _react2.default.cloneElement(icon, { className: (0, _getCollapserStyles2.default)({ flipped: !sorted }, icon.props.className) })
	        );
	      }
	
	      var fixedHeader = header && this.context.fixedHeader;
	      var fixedFooter = this.context.footer && this.context.fixedFooter;
	      var fixed = fixedHeader || fixedFooter;
	      var baseClassNames = (0, _themeColors2.default)({ text: !header, hint: header }, {
	        'md-table-column--relative': tooltip,
	        'md-table-column--select-field': selectColumnHeader
	      });
	
	      var mergedClassNames = (0, _classnames2.default)(_defineProperty({
	        'md-table-column--header': header,
	        'md-table-column--data': !header && !plain,
	        'md-table-column--plain': !header && plain,
	        'md-table-column--adjusted': adjusted && !grow && !selectColumnHeader,
	        'md-table-column--grow': grow,
	        'md-table-column--sortable md-pointer--hover': sortable
	      }, baseClassNames, !fixed), className);
	
	      if (fixed) {
	        displayedChildren = _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)('md-table-column__fixed', {
	              'md-table-column__fixed--header': fixedHeader,
	              'md-table-column__fixed--footer': fixedFooter
	            })
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              style: fixedStyle,
	              className: (0, _classnames2.default)(baseClassNames, mergedClassNames, 'md-table-column__fixed--flex', {
	                'md-table-column__fixed--flex-right': numeric
	              }, fixedClassName)
	            },
	            tooltip,
	            displayedChildren
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        Component,
	        _extends({
	          'aria-sort': ariaSort
	        }, props, {
	          scope: scope,
	          className: (0, _classnames2.default)('md-table-column', {
	            'md-table-column--fixed': fixed,
	            'md-text-left': !numeric && !fixed,
	            'md-text-right': numeric && !fixed
	          }, mergedClassNames)
	        }),
	        !fixedHeader && !fixedFooter && tooltip,
	        displayedChildren
	      );
	    }
	  }]);
	
	  return TableColumn;
	}(_react.PureComponent);
	
	TableColumn.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * The optional className for the table column
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the surrounding div when the DataTable has been
	   * set to include a fixed header or a fixed footer.
	   */
	  fixedStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the surrounding div when the DataTable has been
	   * set to include a fixed header or a fixed footer.
	   */
	  fixedClassName: _propTypes2.default.string,
	
	  /**
	   * The children to display in the column.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the column is currently sorted. If this prop is not `undefined`,
	   * it will add the sort icon unto this column. You will also need to use the
	   * `onClick` function to toggle the `sorted` prop as well as handling the sorting
	   * of data.
	   *
	   * This value should really only be set in the `TableHeader` component.
	   */
	  sorted: _propTypes2.default.bool,
	
	  /**
	   * The icon to show when a column is sortable.
	   */
	  sortIcon: _propTypes2.default.element,
	
	  /**
	   * Boolean if the sortIcon should appear before the text in the column.
	   */
	  sortIconBefore: _propTypes2.default.bool,
	
	  /**
	   * A boolean if the column has numeric data. It will right-align the data.
	   */
	  numeric: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the table column should gain the `.md-data-table--adjusted` class name. By default,
	   * every column will gain this class name unless it is an `EditDialogColumn`, a `SelectFieldColumn`,
	   * or the `grow` prop is enabled.
	   */
	  adjusted: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the column should expand to fill any remaining width in the container. There should
	   * really only be one column with the `grow` prop enabled. In addition, it should really only be
	   * applied to one of the columns in the TableHeader.
	   */
	  grow: _propTypes2.default.bool,
	
	  /**
	   * Boolean if this column is the `th` for a column of `SelectFieldColumn`. This will apply
	   * additional styling to the column to position with the select field.
	   */
	  selectColumnHeader: _propTypes2.default.bool,
	
	  /**
	   * Boolean if this is a `th` component. This value **should** be set
	   * automatically for you if it is in the `TableHeader` component.
	   */
	  header: _propTypes2.default.bool.isRequired,
	
	  /**
	   * The optional tooltip to render on hover.
	   */
	  tooltipLabel: _propTypes2.default.node,
	
	  /**
	   * An optional delay to apply to the tooltip before it appears.
	   */
	  tooltipDelay: _propTypes2.default.number,
	
	  /**
	   * The position of the tooltip.
	   */
	  tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The injected tooltip.
	   * @access private
	   */
	  tooltip: _propTypes2.default.node,
	
	  /**
	   * Boolean if the `TableColumn` should gain the `plain` styles. This means that the text
	   * in the column can wrap and there is no height limit enforced with some additional padding.
	   */
	  plain: _propTypes2.default.bool,
	
	  /**
	   * An optional scope to apply to the table column. If omitted, the scope will be set to
	   * `'col'` if inside of the `TableHeader` component. This is really only needed for
	   * header columns.
	   */
	  scope: _propTypes2.default.oneOf(['row', 'col']),
	
	  /**
	   * This is injected by the `TableRow` component to help with generating ids
	   * @access private
	   */
	  cellIndex: _propTypes2.default.number,
	  sortIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `sortIcon` prop instead'),
	  sortIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `sortIcon` prop instead')
	};
	TableColumn.defaultProps = {
	  header: false,
	  adjusted: true,
	  sortIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'arrow_upward'
	  ),
	  sortIconBefore: true
	};
	TableColumn.contextTypes = {
	  plain: _propTypes2.default.bool,
	  footer: _propTypes2.default.bool,
	  fixedHeader: _propTypes2.default.bool,
	  fixedFooter: _propTypes2.default.bool
	};
	exports.default = (0, _injectTooltip2.default)(TableColumn);
	//# sourceMappingURL=TableColumn.js.map

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `IconSeparator` component is a simple helper component to render some text and
	 * an icon with some space between them while centering the text. The icon can either
	 * come before or after the text.
	 */
	var IconSeparator = function (_PureComponent) {
	  _inherits(IconSeparator, _PureComponent);
	
	  function IconSeparator() {
	    _classCallCheck(this, IconSeparator);
	
	    return _possibleConstructorReturn(this, (IconSeparator.__proto__ || Object.getPrototypeOf(IconSeparator)).apply(this, arguments));
	  }
	
	  _createClass(IconSeparator, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          labelStyle = _props.labelStyle,
	          labelClassName = _props.labelClassName,
	          component = _props.component,
	          label = _props.label,
	          iconBefore = _props.iconBefore,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['className', 'labelStyle', 'labelClassName', 'component', 'label', 'iconBefore', 'children']);
	
	      var text = void 0;
	      if ((0, _react.isValidElement)(label)) {
	        var labelProps = _react.Children.only(label).props;
	        text = (0, _react.cloneElement)(label, {
	          className: (0, _classnames2.default)('md-icon-text', labelClassName, labelProps.className),
	          style: _extends({}, labelStyle, labelProps.style)
	        });
	      } else {
	        text = _react2.default.createElement(
	          'span',
	          { style: labelStyle, className: (0, _classnames2.default)('md-icon-text', labelClassName) },
	          label
	        );
	      }
	
	      var Component = component;
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, { className: (0, _classnames2.default)('md-icon-separator', className) }),
	        iconBefore && children,
	        text,
	        !iconBefore && children
	      );
	    }
	  }]);
	
	  return IconSeparator;
	}(_react.PureComponent);
	
	IconSeparator.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the label.
	   */
	  labelStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the label.
	   */
	  labelClassName: _propTypes2.default.string,
	
	  /**
	   * The label to display.
	   */
	  label: _propTypes2.default.node.isRequired,
	
	  /**
	   * The icon to display.
	   */
	  children: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the icon should appear before or after the text
	   */
	  iconBefore: _propTypes2.default.bool,
	
	  /**
	   * The component to be rendered as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired
	};
	IconSeparator.defaultProps = {
	  component: 'div'
	};
	exports.default = IconSeparator;
	//# sourceMappingURL=IconSeparator.js.map

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isReact16 = typeof _reactDom.createPortal === 'function';
	
	/**
	 * Creates a "Portal" for the children to be rendered in. Basically it will render the
	 * children only when the `visible` prop is `true`. When it is visible, a new `component`
	 * will be rendered as the first child in the body with the children inside.
	 *
	 * Unlike all the other components, `style` will not be applied for the `Portal`.
	 */
	
	var Portal = function (_PureComponent) {
	  _inherits(Portal, _PureComponent);
	
	  function Portal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Portal.__proto__ || Object.getPrototypeOf(Portal)).call.apply(_ref, [this].concat(args))), _this), _this._container = null, _this._portal = null, _this._applyStyles = function (props) {
	      if (props.className) {
	        _this._container.className = props.className;
	      }
	    }, _this._renderPortal = function (props) {
	      if (!_this._container) {
	        _this._container = document.createElement(props.component);
	
	        _this._applyStyles(props);
	        var node = props.renderNode || document.body;
	        if (props.lastChild) {
	          node.appendChild(_this._container);
	        } else {
	          node.insertBefore(_this._container, node.firstChild);
	        }
	      } else {
	        _this._applyStyles(props);
	      }
	
	      if (!isReact16) {
	        _this._portal = (0, _reactDom.unstable_renderSubtreeIntoContainer)(_this, props.children, _this._container);
	      }
	    }, _this._removePortal = function () {
	      if (_this.props.onClose) {
	        _this.props.onClose();
	      }
	
	      if (_this._container) {
	        if (!isReact16) {
	          (0, _reactDom.unmountComponentAtNode)(_this._container);
	        }
	
	        (_this.props.renderNode || document.body).removeChild(_this._container);
	      }
	
	      _this._portal = null;
	      _this._container = null;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.visible) {
	        this._renderPortal(this.props);
	
	        if (isReact16) {
	          // Need to update after the renderPortal created the DOM element.
	          this.forceUpdate();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var visible = nextProps.visible,
	          onOpen = nextProps.onOpen;
	
	      if (this.props.visible === visible) {
	        if (visible && !isReact16) {
	          // Need to just re-render the subtree
	          this._renderPortal(nextProps);
	        }
	
	        return;
	      }
	
	      if (visible) {
	        if (onOpen) {
	          onOpen();
	        }
	
	        this._renderPortal(nextProps);
	      } else {
	        this._removePortal();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._removePortal();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.component,
	          className = _props.className,
	          children = _props.children,
	          visible = _props.visible;
	
	      // When doing server side rendering, actually render the component as a direct child of its parent.
	      // Once it has been rendered and working client side, it will be removed correctly.
	
	      if (typeof window === 'undefined' && visible) {
	        return _react2.default.createElement(
	          Component,
	          { className: className },
	          children
	        );
	      } else if (isReact16 && visible && this._container && typeof window !== 'undefined') {
	        return (0, _reactDom.createPortal)(children, this._container);
	      }
	
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react.PureComponent);
	
	Portal.propTypes = {
	  /**
	   * An optional className to apply to the newly created `component` when visible.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if the children are visible.
	   */
	  visible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * The children to render when visible.
	   */
	  children: _propTypes2.default.element,
	
	  /**
	   * The component to render as. This should be a valid DOM element.
	   */
	  component: _propTypes2.default.string.isRequired,
	
	  /**
	   * An optional function to call when the portal is opened.
	   */
	  onOpen: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the portal is closed
	   */
	  onClose: _propTypes2.default.func,
	
	  /**
	   * An optional DOM Node to render the portal into. The default is to render as
	   * the first child in the `body`.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the portal should render the children as the last child of the `renderNode`
	   * or `body` instead of the first.
	   */
	  lastChild: _propTypes2.default.bool
	};
	Portal.defaultProps = {
	  component: 'span'
	};
	exports.default = Portal;
	//# sourceMappingURL=Portal.js.map

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(17);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _CSSTransitionGroupTick = __webpack_require__(34);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _handleKeyboardAccessibility = __webpack_require__(83);
	
	var _handleKeyboardAccessibility2 = _interopRequireDefault(_handleKeyboardAccessibility);
	
	var _anchorShape = __webpack_require__(38);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(22);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(39);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _Layover = __webpack_require__(109);
	
	var _Layover2 = _interopRequireDefault(_Layover);
	
	var _List = __webpack_require__(81);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Menu` controlled component is used to display a list of children in the `List`
	 * component once the `visible` prop is true.
	 */
	var Menu = function (_PureComponent) {
	  _inherits(Menu, _PureComponent);
	
	  function Menu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Menu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref, [this].concat(args))), _this), _this._handleClose = function (e) {
	      var _this$props = _this.props,
	          close = _this$props.close,
	          onClose = _this$props.onClose;
	
	      if (close || onClose) {
	        (close || onClose)(e);
	      }
	    }, _this._handleClick = function (e) {
	      if (_this.props.onClick) {
	        _this.props.onClick(e);
	      }
	
	      var node = e.target;
	      while (_this._container && _this._container.contains(node)) {
	        if (_this._isIgnoreTarget(node)) {
	          return;
	        } else if (_this._isCloseTarget(node)) {
	          e.persist();
	          // set a timeout so item click events still trigger, and then close
	          _this._timeout = setTimeout(function () {
	            _this._timeout = null;
	            _this._handleClose(e);
	          }, _CSSTransitionGroupTick2.default);
	
	          return;
	        }
	
	        node = node.parentNode;
	      }
	    }, _this._handleKeyDown = function (e) {
	      if (_this.props.onKeyDown) {
	        _this.props.onKeyDown(e);
	      }
	
	      (0, _handleKeyboardAccessibility2.default)(e, _this._handleClick, true, true);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Menu, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _props = this.props,
	          cascading = _props.cascading,
	          id = _props.id,
	          fixedTo = _props.fixedTo,
	          cascadingAnchor = _props.cascadingAnchor;
	
	      var listLevel = this.context.listLevel || 0;
	      var cascadingMenu = typeof cascading !== 'undefined' ? cascading : this.context.cascadingMenu;
	      var cascadingZDepth = (0, _getField2.default)(this.context, this.props, 'cascadingZDepth');
	      var cascadingFixedTo = typeof fixedTo !== 'undefined' ? fixedTo : this.context.cascadingFixedTo;
	
	      return {
	        listLevel: listLevel,
	        cascadingId: id + '-level-' + (listLevel + 1),
	        cascadingMenu: cascadingMenu,
	        cascadingAnchor: cascadingAnchor,
	        cascadingZDepth: cascadingZDepth,
	        cascadingFixedTo: cascadingFixedTo
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._container = (0, _reactDom.findDOMNode)(this);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	    }
	  }, {
	    key: '_isCloseTarget',
	
	
	    /**
	     * Checks if a provided event target or HTML Element is considered a menu click target.
	     * This normally is just a ListItem.
	     */
	    value: function _isCloseTarget(target) {
	      return target.classList.contains('md-list-item') && !target.classList.contains('md-list-item--nested-container');
	    }
	
	    /**
	     * Checks if a provided event target or HTML Element is something that should shortcut/break
	     * out of the click event loop because it **should not** close menus when clicked.
	     */
	
	  }, {
	    key: '_isIgnoreTarget',
	    value: function _isIgnoreTarget(target) {
	      return target.getAttribute('disabled') !== null || target.classList.contains('md-list-control');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cn;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          className = _props2.className,
	          listStyle = _props2.listStyle,
	          listClassName = _props2.listClassName,
	          visible = _props2.visible,
	          children = _props2.children,
	          listProps = _props2.listProps,
	          listZDepth = _props2.listZDepth,
	          listInline = _props2.listInline,
	          listHeightRestricted = _props2.listHeightRestricted,
	          cascading = _props2.cascading,
	          sameWidth = _props2.sameWidth,
	          simplified = _props2.simplified,
	          contained = _props2.contained,
	          isOpen = _props2.isOpen,
	          propFixedTo = _props2.fixedTo,
	          propListId = _props2.listId,
	          cascadingAnchor = _props2.cascadingAnchor,
	          cascadingZDepth = _props2.cascadingZDepth,
	          onClose = _props2.onClose,
	          propPosition = _props2.position,
	          close = _props2.close,
	          autoclose = _props2.autoclose,
	          limitHeight = _props2.limitHeight,
	          expanderIconChildren = _props2.expanderIconChildren,
	          expanderIconClassName = _props2.expanderIconClassName,
	          props = _objectWithoutProperties(_props2, ['id', 'className', 'listStyle', 'listClassName', 'visible', 'children', 'listProps', 'listZDepth', 'listInline', 'listHeightRestricted', 'cascading', 'sameWidth', 'simplified', 'contained', 'isOpen', 'fixedTo', 'listId', 'cascadingAnchor', 'cascadingZDepth', 'onClose', 'position', 'close', 'autoclose', 'limitHeight', 'expanderIconChildren', 'expanderIconClassName']);
	
	      var _props3 = this.props,
	          listId = _props3.listId,
	          position = _props3.position;
	
	      if (!listId) {
	        listId = id + '-list';
	      }
	
	      // can't have a simplified menu for cascading and context menus
	      var simple = !cascading && !props.onContextMenu && position !== 'context' && simplified;
	      if (position === 'context') {
	        position = Menu.Positions.BELOW;
	      }
	
	      var below = position === Menu.Positions.BELOW;
	      var fixedTo = typeof propFixedTo !== 'undefined' ? propFixedTo : this.context.cascadingFixedTo;
	      var listVisible = typeof isOpen !== 'undefined' ? isOpen : visible;
	      return _react2.default.createElement(
	        _Layover2.default,
	        _extends({}, props, {
	          id: id,
	          className: (0, _classnames2.default)('md-menu-container', {
	            'md-menu-container--menu-below': simplified && below
	          }, className),
	          simplified: simple,
	          sameWidth: contained || sameWidth,
	          fixedTo: fixedTo,
	          onClick: this._handleClick,
	          onKeyDown: this._handleKeyDown,
	          onClose: this._handleClose,
	          animationPosition: position,
	          visible: listVisible,
	          'aria-haspopup': true,
	          'aria-expanded': listVisible,
	          'aria-owns': listId
	        }),
	        _react2.default.createElement(
	          _List2.default,
	          _extends({}, listProps, {
	            id: listId,
	            key: 'menu-list',
	            style: listStyle,
	            className: (0, _classnames2.default)('md-list--menu', (_cn = {
	              'md-list--menu-restricted': listHeightRestricted,
	              'md-list--menu-contained': simplified && (sameWidth || contained)
	            }, _defineProperty(_cn, 'md-list--menu-' + position, simplified), _defineProperty(_cn, 'md-paper md-paper--' + listZDepth, listZDepth), _cn), listClassName),
	            inline: listInline
	          }),
	          children
	        )
	      );
	    }
	  }]);
	
	  return Menu;
	}(_react.PureComponent);
	
	Menu.HorizontalAnchors = _Layover2.default.HorizontalAnchors;
	Menu.VerticalAnchors = _Layover2.default.VerticalAnchors;
	Menu.Positions = {
	  // Can't do ...Layover.Positions since it triggers the get for CONTEXT
	  TOP_LEFT: _Layover2.default.Positions.TOP_LEFT,
	  TOP_RIGHT: _Layover2.default.Positions.TOP_RIGHT,
	  BOTTOM_LEFT: _Layover2.default.Positions.BOTTOM_LEFT,
	  BOTTOM_RIGHT: _Layover2.default.Positions.BOTTOM_RIGHT,
	  BELOW: _Layover2.default.Positions.BELOW,
	  _warned: false,
	  get CONTEXT() {
	    if (!this._warned) {
	      /* eslint-disable no-console */
	      console.error('The `Menu.Positions.CONTEXT` position has been deprecated and will be removed ' + 'in the next major release. To make the `Menu` behave as a context menu, provide ' + 'the `onContextMenu` prop instead.');
	      /* eslint-enable no-console */
	    }
	
	    this._warned = true;
	    return 'context';
	  }
	};
	Menu.propTypes = {
	  /**
	   * An id to provide to the menu's container. This is required for accessibility as it generates
	   * the `aria-` attributes for dynamic content.
	   *
	   * @see {@link #listId}
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * An optional id to provide to the menu's list. If this prop is omitted, the list's id will be
	   * `\`${id}-list\``
	   */
	  listId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the main container for the menu.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional class name to apply to the main container for the menu.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the list once the menu has opened.
	   */
	  listStyle: _propTypes2.default.object,
	
	  /**
	   * An optional class name to apply to the list once the menu has opened.
	   */
	  listClassName: _propTypes2.default.string,
	
	  /**
	   * The component to render the main container as.
	   *
	   * @see {@link Helpers/Layover#component}
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	
	  /**
	   * This is how the menu's `List` gets anchored to the `toggle` element.
	   *
	   * @see {@link Helpers/Layover#anchor}
	   */
	  anchor: _anchorShape2.default,
	
	  /**
	   * This is the optional anchor to use when the `position` is set to `Menu.Positions.BELOW`.
	   * Set this to `null` to use the default `anchor` prop.
	   *
	   * @see {@link Helpers/Layover#belowAnchor}
	   */
	  belowAnchor: _anchorShape2.default,
	
	  /**
	   * This is the animation position for the list that appears.
	   *
	   * @see {@link Helpers/Layover#animationPosition}
	   */
	  position: _positionShape2.default,
	
	  /**
	   * This is the component/element that should toggle the menu open.
	   *
	   * @see {@link Helpers/Layover#toggle}
	   */
	  toggle: _propTypes2.default.node,
	
	  /**
	   * This is how the menu's list will be "fixed" to the `toggle` component.
	   *
	   * @see {@link Helpers/Layover#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * Any additional props that should be applied to the list in the menu. This is really used
	   * when additional `aria-` tags need to be applied.
	   */
	  listProps: _propTypes2.default.object,
	
	  /**
	   * Boolean if the menu's list should appear horizontally instead of vertically.
	   */
	  listInline: _propTypes2.default.bool,
	
	  /**
	   * The list's z-depth for applying box shadow. This should be a number from 0 to 5.
	   */
	  listZDepth: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the list should have its height restricted to the `$md-menu-mobile-max-height`/
	   * `$md-menu-desktop-max-height` values.
	   *
	   * @see [md-menu-mobile-max-height](/components/menus?tab=2#variable-md-menu-mobile-max-height)
	   * @see [md-menu-desktop-max-height](/components/menus?tab=2#variable-md-menu-desktop-max-height)
	   */
	  listHeightRestricted: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu's list is visible.
	   */
	  visible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * Any children to render in the menu's list. This _should_ normally be `ListItem`, or
	   * `ListItemControl`.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An optional function to call when en element in the menu has been clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when a key is pressed anywhere in the menu.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * A function to call to close the menu. This is used for closing on outside clicks,
	   * closing when a list item has been clicked, or the user presses escape.
	   */
	  onClose: _propTypes2.default.func.isRequired,
	
	  /**
	   * Boolean if the menu should be cascading. This means that the menu will pop the additional
	   * `nestedItems` on any `ListItem` to be appear either to the right or left of the visible list.
	   */
	  cascading: _propTypes2.default.bool,
	
	  /**
	   * This is how the cascading lists get anchored to the list item.
	   *
	   * @see {@link Helpers/Layover#anchor}
	   */
	  cascadingAnchor: _Layover2.default.propTypes.anchor,
	
	  /**
	   * This is the z-depth the list should gain for a cascading menu. This only gets applied on
	   * items that are more than 1 level deep.
	   */
	  cascadingZDepth: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the `md-full-width` class name should get applied to the menu's container.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should be displayed as a block instead of as an inline block.
	   *
	   * @see {@link #fullWidth}
	   */
	  block: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#centered}
	   */
	  centered: _Layover2.default.propTypes.centered,
	
	  /**
	   * @see {@link Helpers/Layover#sameWidth}
	   */
	  sameWidth: _Layover2.default.propTypes.sameWidth,
	
	  /**
	   * If you would like the menu to interact as a context menu, provide this prop.
	   *
	   * @see {@link Helpers/Layover#onContextMenu}
	   */
	  onContextMenu: _Layover2.default.propTypes.onContextMenu,
	
	  /**
	   * Boolean if the default behavior of the context menu should be prevented when using the
	   * `onContextMenu` prop.
	   *
	   * @see {@link Helpers/Layover#preventContextMenu}
	   */
	  preventContextMenu: _Layover2.default.propTypes.preventContextMenu,
	
	  /**
	   * @see {@link Helpers/Layover#xThreshold}
	   */
	  xThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#yThreshold}
	   */
	  yThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#closeOnOutsideClick}
	   */
	  closeOnOutsideClick: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#toggleQuery}
	   */
	  toggleQuery: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.string]),
	
	  /**
	   * An optional transition name to use for the list appearing/disappearing.
	   *
	   * @see {@link Helpers/Layover#transitionName}
	   */
	  transitionName: _propTypes2.default.string,
	
	  /**
	   * @see {@link Helpers/Layover#transitionEnterTimeout}
	   */
	  transitionEnterTimeout: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#transitionLeaveTimeout}
	   */
	  transitionLeaveTimeout: _propTypes2.default.number,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplified: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#minLeft}
	   */
	  minLeft: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * @see {@link Helpers/Layover#minRight}
	   */
	  minRight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * @see {@link Helpers/Layover#minBottom}
	   */
	  minBottom: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportWidth}
	   */
	  fillViewportWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportHeight}
	   */
	  fillViewportHeight: _propTypes2.default.bool,
	
	  isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead'),
	  close: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onClose` instead'),
	  autoclose: (0, _deprecated2.default)(_propTypes2.default.bool, 'The menus will always autoclose as according to the specs'),
	  contained: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `sameWidth` instead'),
	  limitHeight: (0, _deprecated2.default)(_propTypes2.default.bool, 'The menus will always be limited in height as according to the specs'),
	  expanderIconClassName: (0, _deprecated2.default)(_propTypes2.default.node, 'The expander for cascading menus will now just be a simple rotate of the existing `ListItem` ' + 'expander icon'),
	  expanderIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'The expander for cascading menus will now just be a simple rotate of the existing `ListItem` ' + 'expander icon')
	};
	Menu.defaultProps = {
	  anchor: {
	    x: _Layover2.default.HorizontalAnchors.INNER_RIGHT,
	    y: _Layover2.default.VerticalAnchors.OVERLAP
	  },
	  cascadingAnchor: {
	    x: _Layover2.default.HorizontalAnchors.RIGHT,
	    y: _Layover2.default.VerticalAnchors.OVERLAP
	  },
	  position: _Layover2.default.Positions.TOP_RIGHT,
	  fixedTo: typeof window !== 'undefined' ? window : {},
	  listZDepth: 2,
	  listHeightRestricted: true,
	  cascadingZDepth: 3,
	  repositionOnScroll: true,
	  repositionOnResize: false,
	  simplified: true
	};
	Menu.contextTypes = {
	  listLevel: _propTypes2.default.number,
	  cascadingId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  cascadingMenu: _propTypes2.default.bool,
	  cascadingAnchor: _anchorShape2.default,
	  cascadingZDepth: _propTypes2.default.number
	};
	Menu.childContextTypes = {
	  listLevel: _propTypes2.default.number,
	  cascadingId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  cascadingMenu: _propTypes2.default.bool,
	  cascadingFixedTo: _fixedToShape2.default,
	  cascadingAnchor: _anchorShape2.default,
	  cascadingZDepth: _propTypes2.default.number
	};
	exports.default = Menu;
	//# sourceMappingURL=Menu.js.map

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(17);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _keyCodes = __webpack_require__(15);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _themeColors = __webpack_require__(12);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _oneRequiredForA11y = __webpack_require__(113);
	
	var _oneRequiredForA11y2 = _interopRequireDefault(_oneRequiredForA11y);
	
	var _capitalizeFirst = __webpack_require__(684);
	
	var _capitalizeFirst2 = _interopRequireDefault(_capitalizeFirst);
	
	var _AccessibleFakeInkedButton = __webpack_require__(29);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	var _FontIcon = __webpack_require__(13);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _SwitchTrack = __webpack_require__(634);
	
	var _SwitchTrack2 = _interopRequireDefault(_SwitchTrack);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Prevents a second warning from appearing when using the deprecated or a11y required
	 * props by using the `__superSecretProp`.... So secret!
	 */
	function preventDouble(validator) {
	  return function validate(props, propName) {
	    for (var _len = arguments.length, others = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      others[_key - 2] = arguments[_key];
	    }
	
	    var err = validator.apply(undefined, [props, propName].concat(others));
	    if (err && props.__superSecreteProp) {
	      err = null;
	    }
	
	    return err;
	  };
	}
	
	/**
	 * The `SelectionControl` component is used to render any of the `Radio`, `Checkbox`, or `Switch`
	 * selection control type. This component might eventually replace all three since they use this
	 * anyways. I am not sure yet though.
	 */
	
	var SelectionControl = function (_PureComponent) {
	  _inherits(SelectionControl, _PureComponent);
	
	  function SelectionControl(props) {
	    _classCallCheck(this, SelectionControl);
	
	    var _this = _possibleConstructorReturn(this, (SelectionControl.__proto__ || Object.getPrototypeOf(SelectionControl)).call(this, props));
	
	    _this._setInput = function (input) {
	      _this._input = input;
	    };
	
	    _this._setControl = function (control) {
	      _this._control = control;
	    };
	
	    _this._setContainer = function (container) {
	      _this._container = container;
	    };
	
	    _this._getIcon = function () {
	      var _this$props = _this.props,
	          checkedIcon = _this$props.checkedIcon,
	          uncheckedIcon = _this$props.uncheckedIcon,
	          type = _this$props.type;
	
	      var checked = (0, _getField2.default)(_this.props, _this.state, 'checked');
	      if (checkedIcon || uncheckedIcon) {
	        return checked ? checkedIcon : uncheckedIcon;
	      }
	
	      var prefix = (checked ? '' : 'un') + 'checked' + (0, _capitalizeFirst2.default)(type) + 'Icon';
	      var iconClassName = _this.props[prefix + 'ClassName'];
	      var children = _this.props[prefix + 'Children'];
	
	      if (iconClassName || children) {
	        return _react2.default.createElement(
	          _FontIcon2.default,
	          { iconClassName: iconClassName, inherit: true },
	          children
	        );
	      }
	
	      var icon = _this.props[prefix];
	      return icon ? _react2.default.cloneElement(icon, { inherit: true }) : null;
	    };
	
	    _this._handleKeyDown = function (e) {
	      if (_this.props.onKeyDown) {
	        _this.props.onKeyDown(e);
	      }
	
	      var key = e.which || e.keyCode;
	      if (key === _keyCodes.SPACE) {
	        _this._input.click();
	      }
	    };
	
	    _this._handleChange = function (e) {
	      var _this$props2 = _this.props,
	          type = _this$props2.type,
	          onChange = _this$props2.onChange;
	
	      var checked = !(0, _getField2.default)(_this.props, _this.state, 'checked');
	      if (onChange) {
	        onChange(type === 'radio' ? e.target.value : checked, e);
	      }
	
	      if (typeof _this.props.checked === 'undefined') {
	        _this.setState({ checked: checked });
	      }
	    };
	
	    _this.state = {};
	    if (typeof props.checked === 'undefined') {
	      _this.state.checked = !!props.defaultChecked;
	    }
	    return _this;
	  }
	
	  /**
	   * Gets the current checked value from the selection control. This is used when you have
	   * an uncontrolled selection control and simply need the checked state from a ref callback.
	   *
	   * @return {boolean} the checked state for the selection control.\
	   */
	
	
	  _createClass(SelectionControl, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          style = _props.style,
	          className = _props.className,
	          inline = _props.inline,
	          type = _props.type,
	          name = _props.name,
	          value = _props.value,
	          disabled = _props.disabled,
	          labelBefore = _props.labelBefore,
	          tabIndex = _props.tabIndex,
	          inkDisabled = _props.inkDisabled,
	          disabledInteractions = _props.disabledInteractions,
	          ariaLabel = _props['aria-label'],
	          ariaLabelledBy = _props['aria-labelledby'],
	          propLabel = _props.label,
	          propChildren = _props.checked,
	          onChange = _props.onChange,
	          tooltip = _props.tooltip,
	          checkedCheckboxIcon = _props.checkedCheckboxIcon,
	          uncheckedCheckboxIcon = _props.uncheckedCheckboxIcon,
	          checkedRadioIcon = _props.checkedRadioIcon,
	          uncheckedRadioIcon = _props.uncheckedRadioIcon,
	          __superSecreteProp = _props.__superSecreteProp,
	          checkedIcon = _props.checkedIcon,
	          uncheckedIcon = _props.uncheckedIcon,
	          checkedRadioIconChildren = _props.checkedRadioIconChildren,
	          checkedRadioIconClassName = _props.checkedRadioIconClassName,
	          uncheckedRadioIconChildren = _props.uncheckedRadioIconChildren,
	          uncheckedRadioIconClassName = _props.uncheckedRadioIconClassName,
	          checkedCheckboxIconChildren = _props.checkedCheckboxIconChildren,
	          checkedCheckboxIconClassName = _props.checkedCheckboxIconClassName,
	          uncheckedCheckboxIconChildren = _props.uncheckedCheckboxIconChildren,
	          uncheckedCheckboxIconClassName = _props.uncheckedCheckboxIconClassName,
	          props = _objectWithoutProperties(_props, ['id', 'style', 'className', 'inline', 'type', 'name', 'value', 'disabled', 'labelBefore', 'tabIndex', 'inkDisabled', 'disabledInteractions', 'aria-label', 'aria-labelledby', 'label', 'checked', 'onChange', 'tooltip', 'checkedCheckboxIcon', 'uncheckedCheckboxIcon', 'checkedRadioIcon', 'uncheckedRadioIcon', '__superSecreteProp', 'checkedIcon', 'uncheckedIcon', 'checkedRadioIconChildren', 'checkedRadioIconClassName', 'uncheckedRadioIconChildren', 'uncheckedRadioIconClassName', 'checkedCheckboxIconChildren', 'checkedCheckboxIconClassName', 'uncheckedCheckboxIconChildren', 'uncheckedCheckboxIconClassName']);
	
	      var checked = (0, _getField2.default)(this.props, this.state, 'checked');
	      var isSwitch = type === 'switch';
	      var label = this.props.label && _react2.default.createElement(
	        'span',
	        null,
	        this.props.label
	      );
	
	      var control = void 0;
	      if (isSwitch) {
	        control = _react2.default.createElement(_SwitchTrack2.default, { disabled: disabled, checked: checked });
	      } else {
	        control = _react2.default.createElement(
	          _AccessibleFakeInkedButton2.default,
	          {
	            inkDisabled: inkDisabled,
	            disabledInteractions: disabledInteractions,
	            role: type,
	            className: (0, _classnames2.default)('md-selection-control-toggle md-btn md-btn--icon', (0, _themeColors2.default)({
	              disabled: disabled,
	              hint: !checked,
	              secondary: checked
	            })),
	            'aria-checked': checked,
	            tabIndex: tabIndex,
	            disabled: disabled
	          },
	          tooltip,
	          this._getIcon()
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, {
	          style: style,
	          className: (0, _classnames2.default)('md-selection-control-container', {
	            'md-selection-control-container--inline': inline,
	            'md-switch-container': isSwitch
	          }, className),
	          onKeyDown: this._handleKeyDown
	        }),
	        _react2.default.createElement('input', {
	          ref: this._setInput,
	          id: id,
	          type: isSwitch ? 'checkbox' : type,
	          checked: checked,
	          onChange: this._handleChange,
	          disabled: disabled,
	          className: 'md-selection-control-input',
	          name: name,
	          value: value,
	          'aria-hidden': true,
	          'aria-label': ariaLabel,
	          'aria-labelledby': ariaLabelledBy
	        }),
	        _react2.default.createElement(
	          'label',
	          {
	            htmlFor: id,
	            className: (0, _classnames2.default)('md-selection-control-label', {
	              'md-pointer--hover': !disabled
	            }, (0, _themeColors2.default)({ disabled: disabled, text: !disabled }))
	          },
	          labelBefore && label,
	          control,
	          !labelBefore && label
	        )
	      );
	    }
	  }, {
	    key: 'checked',
	    get: function get() {
	      return (0, _getField2.default)(this.props, this.state, 'checked');
	    }
	  }]);
	
	  return SelectionControl;
	}(_react.PureComponent);
	
	SelectionControl.propTypes = {
	  /**
	   * An id to use with the selection control. This is used for accessibility and so that the label
	   * triggers the selection control toggle.
	   */
	  id: preventDouble((0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))),
	
	  /**
	   * An optional label to apply to the checkbox when there is no visible label.
	   */
	  'aria-label': (0, _oneRequiredForA11y2.default)(_propTypes2.default.string, 'label', 'aria-labelledby'),
	
	  /**
	   * An optional id that points to a label for the selection control when there is no visible label.
	   */
	  'aria-labelledby': _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the selection control's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the selection control's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The type of selection control to render.
	   */
	  type: _propTypes2.default.oneOf(['checkbox', 'radio', 'switch']).isRequired,
	
	  /**
	   * A label to display with the selection control. This is required for accessibility and triggering
	   * the toggle.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * Boolean if the label should appear before the checkbox/radio icon or switch.
	   */
	  labelBefore: _propTypes2.default.bool,
	
	  /**
	   * A name to use for the `SelectionControl`. This is required for accessibility. If the `type`
	   * is a `checkbox` and it is part of a group, it is recommended to make this a string ending
	   * in `[]` so that the value can be found from `document.querySelector('input[name="someName[]"]').value`.
	   */
	  name: preventDouble((0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))),
	
	  /**
	   * Boolean if the `Radio` is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * A function to call when the `SelectionControl` triggers the `change` event. The `onChange`
	   * callback will either include:
	   * - the currently changed radio's value
	   * - the next checked state for the `Switch` or `Checkbox`.
	   *
	   * as the first parameter followed by the change event.
	   *
	   * ```js
	   * // Radio
	   * onChange(changeEvent.target.value, changeEvent);
	   *
	   * // Checkbox or Switch
	   * onChange(changeEvent.target.checked, changeEvent);
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `keydown` event is triggered.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * The value for the `SelectionControl`. It is not required for `Checkbox` and `Switch`,
	   * but it is recommended.
	   */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * A boolean if the `SelectionControl` is currently checked. This _really_ makes the `onChange`
	   * prop required, but since there are cases you might want to have the `onChange` listener on a
	   * `fieldset` or something above the component, it is never set to `required`. It will however
	   * prevent updates if there is no change listener.
	   */
	  checked: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `Checkbox` or `Switch` are checked by default. This prop is invalid for a
	   * `Radio`.
	   */
	  defaultChecked: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `SelectionControl` should be displayed inline instead of a block.
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * The icon to use for a checked `checkbox` selection control.
	   */
	  checkedCheckboxIcon: _propTypes2.default.element,
	
	  /**
	   * The icon to use for an unchecked `checkbox` selection control.
	   */
	  uncheckedCheckboxIcon: _propTypes2.default.element,
	
	  /**
	   * The icon to use for a checked `radio` selection control.
	   */
	  checkedRadioIcon: _propTypes2.default.element,
	
	  /**
	   * The icon to use for an unchecked `radio` selection control.
	   */
	  uncheckedRadioIcon: _propTypes2.default.element,
	
	  /**
	   * An optional tooltip to render with the control. This is only used if you inject the
	   * tooltip manually yourself.
	   *
	   * `const TooltippedSelectionControl = injectTooltip(SelectionControl);`
	   */
	  tooltip: _propTypes2.default.node,
	
	  /**
	   * Boolean if the ink should be disabled for radios or checkboxes.
	   *
	   * @see {@link Inks#inkDisabled}
	   */
	  inkDisabled: _propTypes2.default.bool,
	
	  /**
	   * An optional list of ink interactions that should be disabled.
	   *
	   * @see {@link Inks#disabledInteractions}
	   */
	  disabledInteractions: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['keyboard', 'touch', 'mouse'])),
	
	  /**
	   * An optional tab index to apply to the selection control.
	   */
	  tabIndex: _propTypes2.default.number,
	
	  checkedIcon: preventDouble((0, _deprecated2.default)(_propTypes2.default.node, 'Use the `checkedCheckboxIconChildren` and `checkedCheckboxIconClassName`  or the ' + '`checkedRadioIconChildren` and `checkedRadioIconClassName` props instead')),
	  uncheckedIcon: preventDouble((0, _deprecated2.default)(_propTypes2.default.node, 'Use the `uncheckedCheckboxIconChildren` and `uncheckedCheckboxIconClassName`  or the ' + '`uncheckedRadioIconChildren` and `uncheckedRadioIconClassName` props instead')),
	  checkedCheckboxIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `checkedCheckboxIcon` prop instead'),
	  checkedCheckboxIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `checkedCheckboxIcon` prop instead'),
	  uncheckedCheckboxIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `uncheckedCheckboxIcon` prop instead'),
	  uncheckedCheckboxIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `uncheckedCheckboxIcon` prop instead'),
	  checkedRadioIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `checkedRadioIcon` prop instead'),
	  checkedRadioIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `checkedRadioIcon` prop instead'),
	  uncheckedRadioIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `uncheckedRadioIcon` prop instead'),
	  uncheckedRadioIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `uncheckedRadioIcon` prop instead'),
	
	  /* maybe removed once upgrade again? */
	  __superSecreteProp: _propTypes2.default.bool
	};
	SelectionControl.defaultProps = {
	  checkedCheckboxIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'check_box'
	  ),
	  uncheckedCheckboxIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'check_box_outline_blank'
	  ),
	  checkedRadioIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'radio_button_checked'
	  ),
	  uncheckedRadioIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'radio_button_unchecked'
	  )
	};
	exports.default = SelectionControl;
	//# sourceMappingURL=SelectionControl.js.map

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(17);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _isValued = __webpack_require__(115);
	
	var _isValued2 = _interopRequireDefault(_isValued);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _getTextWidth = __webpack_require__(178);
	
	var _getTextWidth2 = _interopRequireDefault(_getTextWidth);
	
	var _controlled = __webpack_require__(16);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _invalidIf = __webpack_require__(48);
	
	var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	var _minNumber = __webpack_require__(681);
	
	var _minNumber2 = _interopRequireDefault(_minNumber);
	
	var _addSuffix = __webpack_require__(306);
	
	var _addSuffix2 = _interopRequireDefault(_addSuffix);
	
	var _FontIcon = __webpack_require__(13);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(21);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _FloatingLabel = __webpack_require__(290);
	
	var _FloatingLabel2 = _interopRequireDefault(_FloatingLabel);
	
	var _TextFieldMessage = __webpack_require__(292);
	
	var _TextFieldMessage2 = _interopRequireDefault(_TextFieldMessage);
	
	var _PasswordButton = __webpack_require__(656);
	
	var _PasswordButton2 = _interopRequireDefault(_PasswordButton);
	
	var _InputField = __webpack_require__(654);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _TextFieldDivider = __webpack_require__(291);
	
	var _TextFieldDivider2 = _interopRequireDefault(_TextFieldDivider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_TEXT_FIELD_SIZE = 180;
	
	var WILL_RECEIVE_KEYS = ['style', 'value', 'resize'];
	var DID_UPDATE_KEYS = ['leftIcon', 'rightIcon', 'passwordIcon', 'inlineIndicator'];
	
	/**
	 * The `TextField` component can either be a single line `input` field or a multiline
	 * `textarea` field. `FontIcon`s, messages, and password indicators can also be added
	 * to this field.
	 *
	 * The optional mouse and touch events will be added to the entire container while the
	 * text specific events will be added to the `input` or `textarea` tags.
	 */
	
	var TextField = function (_PureComponent) {
	  _inherits(TextField, _PureComponent);
	
	  function TextField(props) {
	    _classCallCheck(this, TextField);
	
	    var _this = _possibleConstructorReturn(this, (TextField.__proto__ || Object.getPrototypeOf(TextField)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var currentLength = _this._getLength(typeof props.value !== 'undefined' ? props.value : props.defaultValue);
	
	    _this._canvas = null;
	    var width = null;
	    if (typeof props.resize !== 'undefined') {
	      width = typeof props.resize.min === 'number' ? props.resize.min : DEFAULT_TEXT_FIELD_SIZE;
	    }
	
	    _this.state = {
	      active: false,
	      error: props.maxLength ? props.maxLength < currentLength : false,
	      floating: (0, _isValued2.default)(props.defaultValue) || (0, _isValued2.default)(props.value),
	      passwordVisible: props.passwordInitiallyVisible,
	      currentLength: currentLength,
	      styles: width ? _extends({ width: width }, props.style) : props.style
	    };
	    return _this;
	  }
	
	  _createClass(TextField, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          value = _props.value,
	          defaultValue = _props.defaultValue,
	          resize = _props.resize;
	
	      var v = typeof value !== 'undefined' ? value : defaultValue;
	      if (resize) {
	        // always want to set width on mount
	        this.setState({ width: this._calcWidth(v) }); // eslint-disable-line react/no-did-mount-set-state
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var value = nextProps.value,
	          resize = nextProps.resize,
	          style = nextProps.style;
	
	      var nextState = {};
	      if (value !== this.props.value) {
	        nextState.error = this._isErrored(nextProps);
	        nextState.floating = (0, _isValued2.default)(value);
	        nextState.currentLength = this._getLength(value);
	      }
	
	      if (WILL_RECEIVE_KEYS.some(function (key) {
	        return _this2.props[key] !== nextProps[key];
	      })) {
	        if (!resize) {
	          nextState.styles = style;
	        } else {
	          var width = this._calcWidth(value, nextProps);
	          nextState.styles = _extends({ width: width }, style);
	        }
	      }
	
	      this.setState(nextState);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          resize = _props2.resize,
	          value = _props2.value,
	          style = _props2.style;
	
	      if (resize && DID_UPDATE_KEYS.some(function (key) {
	        return _this3.props[key] !== prevProps[key];
	      })) {
	        var width = this._calcWidth(value, this.props);
	        this.setState({ styles: _extends({ width: width }, style) }); // eslint-disable-line react/no-did-update-set-state
	      }
	    }
	
	    /**
	     * A helper function for getting the specific `input` field or the `textarea` in the `TextField`.
	     * This is accessible if you use `refs`.
	     *
	     * Example:
	     *
	     * ```js
	     * <TextField ref={field => this._field = field;} label="Hello" />;
	     *
	     * this._field.getField(); // `input` node
	     * ```
	     */
	
	
	    /**
	     * A helper function for focusing the `input` field or the `textarea` in the `TextField`.
	     * This is accessibile if you use `refs`.
	     * Example:
	     *
	     * ```js
	     * <TextField ref={field => this._field = field;} label="Hello" />;
	     *
	     * this._field.focus();
	     * ```
	     */
	
	  }, {
	    key: 'blur',
	
	
	    /**
	     * A helper function for blurring the `input` field or the `textarea` in the `TextField`.
	     * This is accessible if you use `refs`.
	     * Example:
	     *
	     * ```js
	     * <TextField ref={field => this._field = field;} label="Hello" />;
	     *
	     * this._field.blur();
	     * ```
	     */
	    value: function blur() {
	      this._field.blur();
	    }
	  }, {
	    key: '_cloneIcon',
	    value: function _cloneIcon(icon, active, error, disabled, stateful, block, dir) {
	      if (!icon) {
	        return icon;
	      }
	
	      try {
	        var iconEl = _react.Children.only(icon);
	        return (0, _react.cloneElement)(iconEl, {
	          key: iconEl.key || 'icon-' + dir,
	          disabled: stateful ? disabled : undefined,
	          primary: stateful ? !error && active : undefined,
	          error: stateful ? error : undefined,
	          className: (0, _classnames2.default)('md-text-field-icon', {
	            'md-text-field-icon--positioned': !block
	          }, iconEl.props.className)
	        });
	      } catch (e) {
	        return icon;
	      }
	    }
	
	    /**
	     * A small utility function for calculating an inline-icon's width keeping the SVG Icons
	     * in mind and any margin that gets applied for spacing.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          currentLength = _state.currentLength,
	          passwordVisible = _state.passwordVisible,
	          styles = _state.styles;
	
	      var _props3 = this.props,
	          id = _props3.id,
	          type = _props3.type,
	          className = _props3.className,
	          inputStyle = _props3.inputStyle,
	          inputClassName = _props3.inputClassName,
	          block = _props3.block,
	          fullWidth = _props3.fullWidth,
	          required = _props3.required,
	          customSize = _props3.customSize,
	          maxLength = _props3.maxLength,
	          errorText = _props3.errorText,
	          helpText = _props3.helpText,
	          helpOnFocus = _props3.helpOnFocus,
	          disabled = _props3.disabled,
	          leftIconStateful = _props3.leftIconStateful,
	          rightIconStateful = _props3.rightIconStateful,
	          passwordIcon = _props3.passwordIcon,
	          lineDirection = _props3.lineDirection,
	          paddedBlock = _props3.paddedBlock,
	          onDoubleClick = _props3.onDoubleClick,
	          onTouchStart = _props3.onTouchStart,
	          onTouchMove = _props3.onTouchMove,
	          onTouchCancel = _props3.onTouchCancel,
	          onTouchEnd = _props3.onTouchEnd,
	          onMouseDown = _props3.onMouseDown,
	          onMouseUp = _props3.onMouseUp,
	          onMouseOver = _props3.onMouseOver,
	          onMouseLeave = _props3.onMouseLeave,
	          ink = _props3.ink,
	          inlineIndicator = _props3.inlineIndicator,
	          toolbar = _props3.toolbar,
	          icon = _props3.icon,
	          passwordIconChildren = _props3.passwordIconChildren,
	          passwordIconClassName = _props3.passwordIconClassName,
	          style = _props3.style,
	          propLabel = _props3.label,
	          propPlaceholder = _props3.placeholder,
	          propError = _props3.error,
	          propActive = _props3.active,
	          propFloating = _props3.floating,
	          propLeftIcon = _props3.leftIcon,
	          propRightIcon = _props3.rightIcon,
	          onClick = _props3.onClick,
	          onChange = _props3.onChange,
	          onBlur = _props3.onBlur,
	          onFocus = _props3.onFocus,
	          resize = _props3.resize,
	          adjustMinWidth = _props3.adjustMinWidth,
	          propFloatingLabel = _props3.floatingLabel,
	          props = _objectWithoutProperties(_props3, ['id', 'type', 'className', 'inputStyle', 'inputClassName', 'block', 'fullWidth', 'required', 'customSize', 'maxLength', 'errorText', 'helpText', 'helpOnFocus', 'disabled', 'leftIconStateful', 'rightIconStateful', 'passwordIcon', 'lineDirection', 'paddedBlock', 'onDoubleClick', 'onTouchStart', 'onTouchMove', 'onTouchCancel', 'onTouchEnd', 'onMouseDown', 'onMouseUp', 'onMouseOver', 'onMouseLeave', 'ink', 'inlineIndicator', 'toolbar', 'icon', 'passwordIconChildren', 'passwordIconClassName', 'style', 'label', 'placeholder', 'error', 'active', 'floating', 'leftIcon', 'rightIcon', 'onClick', 'onChange', 'onBlur', 'onFocus', 'resize', 'adjustMinWidth', 'floatingLabel']);
	
	      var _props4 = this.props,
	          label = _props4.label,
	          placeholder = _props4.placeholder,
	          error = _props4.error,
	          active = _props4.active,
	          floating = _props4.floating,
	          leftIcon = _props4.leftIcon,
	          rightIcon = _props4.rightIcon;
	
	      active = active || this.state.active;
	      error = error || this.state.error;
	      floating = floating || this.state.floating;
	
	      if (required) {
	        if (label) {
	          label = (0, _addSuffix2.default)(label, '*');
	        }
	
	        if (placeholder && !label) {
	          placeholder = (0, _addSuffix2.default)(placeholder, '*');
	        }
	      }
	
	      if (label && !floating) {
	        placeholder = null;
	      }
	
	      leftIcon = this._cloneIcon(icon || leftIcon, active, error, disabled, leftIconStateful, block, 'left');
	      if (type === 'password' && !disabled) {
	        rightIcon = _react2.default.createElement(_PasswordButton2.default, {
	          key: 'password-btn',
	          onClick: this._togglePasswordField,
	          active: active,
	          passwordVisible: passwordVisible,
	          icon: (0, _getDeprecatedIcon2.default)(passwordIconClassName, passwordIconChildren, passwordIcon),
	          block: block,
	          floating: !!label
	        });
	      } else if (inlineIndicator) {
	        var el = _react.Children.only(inlineIndicator);
	        rightIcon = (0, _react.cloneElement)(inlineIndicator, {
	          key: 'icon-right',
	          className: (0, _classnames2.default)('md-text-field-inline-indicator', {
	            'md-text-field-inline-indicator--floating': label,
	            'md-text-field-inline-indicator--block': block
	          }, el.props.className)
	        });
	      } else {
	        rightIcon = this._cloneIcon(rightIcon, active, error, disabled, rightIconStateful, block, 'right');
	      }
	      var rightIconed = !!rightIcon && type !== 'password' && !inlineIndicator;
	
	      var floatingLabel = _react2.default.createElement(_FloatingLabel2.default, {
	        key: 'label',
	        label: label,
	        htmlFor: id,
	        active: active,
	        error: error,
	        floating: floating,
	        customSize: customSize,
	        disabled: disabled,
	        iconOffset: !!leftIcon
	      });
	
	      var message = _react2.default.createElement(_TextFieldMessage2.default, {
	        key: 'message',
	        active: active,
	        error: error,
	        errorText: errorText,
	        helpText: helpText,
	        helpOnFocus: helpOnFocus,
	        block: block,
	        maxLength: maxLength,
	        leftIcon: !!leftIcon,
	        rightIcon: !!rightIcon,
	        currentLength: currentLength
	      });
	
	      var field = _react2.default.createElement(_InputField2.default, _extends({}, props, {
	        key: 'field',
	        ref: this._setField,
	        id: id,
	        type: type,
	        label: label,
	        style: inputStyle,
	        className: (0, _classnames2.default)({ 'md-text-field--toolbar': toolbar }, inputClassName),
	        disabled: disabled,
	        customSize: customSize,
	        fullWidth: fullWidth,
	        passwordVisible: passwordVisible,
	        placeholder: placeholder,
	        block: block,
	        onFocus: this._handleFocus,
	        onBlur: this._handleBlur,
	        onChange: this._handleChange,
	        inlineIndicator: !!inlineIndicator
	      }));
	
	      var divider = void 0;
	      if (!block) {
	        divider = _react2.default.createElement(_TextFieldDivider2.default, {
	          key: 'text-divider',
	          active: active,
	          error: error,
	          lineDirection: lineDirection
	        });
	      }
	
	      var children = void 0;
	      if (leftIcon || rightIconed) {
	        children = _react2.default.createElement(
	          'div',
	          { key: 'icon-divider', className: 'md-text-field-icon-container' },
	          leftIcon,
	          _react2.default.createElement(
	            'div',
	            {
	              key: 'divider-container',
	              className: (0, _classnames2.default)('md-text-field-divider-container', {
	                'md-text-field-divider-container--grow': fullWidth
	              })
	            },
	            field,
	            divider
	          ),
	          rightIcon
	        );
	      } else {
	        children = [leftIcon, field, divider, rightIcon];
	      }
	
	      children = [floatingLabel, children, message];
	
	      var multiline = typeof props.rows !== 'undefined';
	      return _react2.default.createElement(
	        'div',
	        {
	          style: styles,
	          className: (0, _classnames2.default)('md-text-field-container', {
	            'md-inline-block': !fullWidth && !block,
	            'md-full-width': block || fullWidth,
	            'md-text-field-container--disabled': disabled,
	            'md-text-field-container--input': !multiline,
	            'md-text-field-container--input-block': block && !multiline,
	            'md-text-field-container--multiline': multiline,
	            'md-text-field-container--multiline-block': multiline && block,
	            'md-text-field-container--padded-block': block && paddedBlock
	          }, className),
	          onClick: this._handleContainerClick,
	          onDoubleClick: onDoubleClick,
	          onMouseOver: onMouseOver,
	          onMouseLeave: onMouseLeave,
	          onMouseDown: onMouseDown,
	          onMouseUp: onMouseUp,
	          onTouchStart: onTouchStart,
	          onTouchEnd: onTouchEnd,
	          onTouchCancel: onTouchCancel,
	          onTouchMove: onTouchMove,
	          ref: this._setContainer
	        },
	        ink,
	        children
	      );
	    }
	  }, {
	    key: 'value',
	
	
	    /**
	     * Gets the current value from the text field. This is used when you have an uncontrolled
	     * text field and simply need the value from a ref callback.
	     *
	     * @return {String} the text field's value
	     */
	    get: function get() {
	      return this.getField().value;
	    }
	  }]);
	
	  return TextField;
	}(_react.PureComponent);
	
	TextField.propTypes = {
	  /**
	   * The id for a text field. This is required when using the `label` prop for accessibility,
	   * but normally a good idea to include one anyways.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * An optional style to apply to the text field's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the text field's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `input` or `textarea` tag.
	   */
	  inputStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `input` or `textarea` tag.
	   */
	  inputClassName: _propTypes2.default.string,
	
	  /**
	   * An optional value to apply to the text field. This will make the component
	   * controlled and require the `onChange` prop.
	   */
	  value: (0, _controlled2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]), 'onChange'),
	
	  /**
	   * An optional default value for the text field.
	   */
	  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  /**
	   * Boolean if the text field should be displayed as a `block`. This is equivalent to
	   * the `full width` text field in the Material Design specs. This view will disable
	   * floating labels and remove the text divider from the component.
	   */
	  block: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `block` text field should include padding to the left and right of
	   * the text field.
	   */
	  paddedBlock: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the text field is currently disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional label to display with the text field. This will convert the text field
	   * into a floating label text field. You can make it single line by only using the
	   * `placeholder` prop.
	   */
	  label: (0, _invalidIf2.default)(_propTypes2.default.node, 'block'),
	
	  /**
	   * An optional placeholder text to display in the text field. If there is no `label` prop,
	   * the text field will be displayed as a single line text field. If there is a `label` prop,
	   * this will only be visible when there is no value and the user focused the text field.
	   */
	  placeholder: _propTypes2.default.string,
	
	  /**
	   * The type for the text field. This is one of the most import props for mobile accessibility
	   * as it will update the keyboard for the text type. This does not get applied on multiline
	   * text fields.
	   */
	  type: _propTypes2.default.oneOf(['text', 'number', 'email', 'search', 'tel', 'url', 'password']).isRequired,
	
	  /**
	   * An optional function to call when the text field's container triggers the `click` event.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `doubleclick`
	   * event.
	   */
	  onDoubleClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `touchstart`
	   * event.
	   */
	  onTouchStart: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `touchmove`
	   * event.
	   */
	  onTouchMove: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `touchcancel`
	   * event.
	   */
	  onTouchCancel: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `touchend`
	   * event.
	   */
	  onTouchEnd: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `mousedown`
	   * event.
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `mouseup`
	   * event.
	   */
	  onMouseUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `mouseover`
	   * event.
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `mouseleave`
	   * event.
	   */
	  onMouseLeave: _propTypes2.default.func,
	
	  /**
	   * An optional onChange function to call. If the `value` prop is defined, this is
	   * required.
	   *
	   * When the value changes in the text field, this will be called with the new text
	   * field's value and the change event.
	   *
	   * ```js
	   * onChange(e.target.value, e);
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field is blurred.
	   */
	  onBlur: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field is focused.
	   */
	  onFocus: _propTypes2.default.func,
	
	  /**
	   * An optional boolean if the `active` state of the text field can be externally
	   * modified as well. The text field is usually considered active when it gains focus.
	   *
	   * If this prop is set, it will check both the active prop and the active state to
	   * determine if one is true.
	   */
	  active: _propTypes2.default.bool,
	
	  /**
	   * An optional boolean if the `error` state of the text field can be externally
	   * modified as well. The text field is usually considered errored when it is required
	   * and there is no value or the current length of the text field's value is greater
	   * than the `maxLength` prop.
	   *
	   * If this prop is set, it will check both the error prop and the error state to
	   * determine if one is true.
	   */
	  error: _propTypes2.default.bool,
	
	  /**
	   * An optional boolean if the `floating` state of the text field's floating label can be
	   * externally modified as well. The floating state is true when the text field gains focus
	   * or there is a value in the text field.
	   *
	   * If this prop is set, it will check both the floating prop and the floating state to
	   * determine if one is true.
	   */
	  floating: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the text field is required. If the user blurs the text field while there is
	   * no value and it is required, the `error` state will be set to true.
	   */
	  required: _propTypes2.default.bool,
	
	  /**
	   * The direction that the underline should appear from.
	   */
	  lineDirection: _propTypes2.default.oneOf(['left', 'center', 'right']).isRequired,
	
	  /**
	   * An optional icon to place to the left of the text field.
	   */
	  leftIcon: _propTypes2.default.element,
	
	  /**
	   * Boolean if the left icon should be stateful. This means that the icon will
	   * gain the active or error colors with the text field.
	   */
	  leftIconStateful: _propTypes2.default.bool,
	
	  /**
	   * An optional icon to place to the right of the text field.
	   */
	  rightIcon: _propTypes2.default.element,
	
	  /**
	   * Boolean if the right icon should be stateful. This means that the icon will
	   * gain the active or error colors with the text field.
	   */
	  rightIconStateful: _propTypes2.default.bool,
	
	  /**
	   * The icon to use for a password text field.
	   */
	  passwordIcon: _propTypes2.default.element,
	
	  /**
	   * Boolean if the password is initially visible.
	   */
	  passwordInitiallyVisible: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the text field should be displayed as full width.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * The number of rows for the `multiline` text field. This value must be greater than
	   * or equal to 1. When this value is set, the text field will be converted to a multiline
	   * field.
	   */
	  rows: (0, _minNumber2.default)(1, false),
	
	  /**
	   * The maximum number of rows for a `multiline` text field. If this value is
	   * `undefined`, `0`, or a number less than `0`, the multiline text field will
	   * infinitely expand.
	   */
	  maxRows: _propTypes2.default.number,
	
	  /**
	   * An optional custom size to apply to the text field. This is used along with
	   * the `$md-text-field-custom-sizes` variable. It basically applies a className of
	   * `md-text-field--NAME`.
	   */
	  customSize: _propTypes2.default.string,
	
	  /**
	   * An optional error text to display below the text field. This will only appear when
	   * the text field has the `error` state through the `error` prop, the current length
	   * of the text field's value is greater than the `maxLength` prop, or the field is
	   * required and the user blurs the text field with no value.
	   */
	  errorText: _propTypes2.default.node,
	
	  /**
	   * An optional help text to display below the text field. This will always be visible
	   * unless the `helpOnFocus` prop is set to true. Otherwise it will appear on focus.
	   */
	  helpText: _propTypes2.default.node,
	
	  /**
	   * Boolean if the help text should display on focus only.
	   */
	  helpOnFocus: _propTypes2.default.bool,
	
	  /**
	   * An optional max length for the text field. This will insert a counter underneath the
	   * text field that appears on focus.
	   */
	  maxLength: _propTypes2.default.number,
	
	  /**
	   * The ink when there is an injectInk above the text field. Used from the SelectField.
	   *
	   * @access private
	   */
	  ink: _propTypes2.default.node,
	
	  /**
	   * An optional element to display inside of the `TextField` to the farthest right. This will
	   * position the indicator absolutely and add some additional padding to the `TextField`.
	   */
	  inlineIndicator: _propTypes2.default.element,
	
	  /**
	   * This prop allows the text field to resize its width to stay between the min and max sizes provided. By
	   * default, the field will expand and collapse based on the amount of text provided. The collapsing can
	   * be disabled by providing `disableShrink` to the configuration object.
	   *
	   * If the `min` prop is not provided, it will default to `180` which is about the same size as a default
	   * text field.
	   */
	  resize: _propTypes2.default.shape({
	    min: _propTypes2.default.number,
	    max: _propTypes2.default.number.isRequired,
	    disableShrink: _propTypes2.default.bool
	  }),
	
	  /**
	   * Boolean if the TextField is in a toolbar and acting as a title. This will apply additional styles to the
	   * text field to make it look like the toolbar's title.
	   */
	  toolbar: _propTypes2.default.bool,
	
	  passwordIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `passwordIcon` prop instead'),
	  passwordIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `passwordIcon` prop instead'),
	  icon: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `leftIcon` or `rightIcon` prop instead'),
	  floatingLabel: (0, _deprecated2.default)(_propTypes2.default.bool, 'The `label` prop is now always floating. To create a non-floating text field, only use the `placeholder` prop'),
	  adjustMinWidth: (0, _deprecated2.default)(_propTypes2.default.bool, 'Manually add a min width style instead')
	};
	TextField.defaultProps = {
	  type: 'text',
	  lineDirection: 'left',
	  passwordIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'remove_red_eye'
	  ),
	  leftIconStateful: true,
	  rightIconStateful: true,
	  fullWidth: true
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.getField = function () {
	    return _this4._field.getField();
	  };
	
	  this.focus = function () {
	    _this4._field.focus();
	  };
	
	  this._getLength = function (v) {
	    if ((0, _isValued2.default)(v)) {
	      return String(v).length;
	    }
	
	    return 0;
	  };
	
	  this._setContainer = function (div) {
	    _this4._container = div;
	  };
	
	  this._setField = function (field) {
	    if (field !== null) {
	      _this4._field = field;
	    }
	  };
	
	  this._calcIconWidth = function (icon) {
	    var style = window.getComputedStyle(icon);
	
	    return icon.getBoundingClientRect().width + parseInt(style.marginLeft, 10);
	  };
	
	  this._calcWidth = function (value) {
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this4.props;
	
	    var text = value;
	    // if it is a password, use the bullet unicode instead
	    if (props.type === 'password') {
	      text = [].concat(_toConsumableArray(new Array(value.length))).reduce(function (s) {
	        return s + '\u2022';
	      }, '');
	    }
	
	    var field = _this4._field && _this4._field.getField();
	    if (!(0, _isValued2.default)(text) && field) {
	      text = field.value;
	    }
	
	    var width = (0, _getTextWidth2.default)(text, field);
	    if (width === null || !field) {
	      // some error happened, don't do other logic
	      return width;
	    }
	
	    var max = props.resize.max;
	
	    var min = (0, _getField2.default)(props.resize, { min: DEFAULT_TEXT_FIELD_SIZE }, 'min');
	
	    if (_this4._container) {
	      var indicator = _this4._container.querySelector('.md-text-field-inline-indicator');
	      if (indicator) {
	        width += indicator.getBoundingClientRect().width;
	      }
	
	      var iconContainer = _this4._container.querySelector('.md-text-field-icon-container');
	      if (iconContainer) {
	        // There is conditionally an icon before and after the text field, or only an icon before/after
	        var _iconContainer$childr = _slicedToArray(iconContainer.children, 3),
	            first = _iconContainer$childr[0],
	            second = _iconContainer$childr[1],
	            third = _iconContainer$childr[2];
	
	        if (first.classList.contains('md-icon')) {
	          width += first.getBoundingClientRect().width;
	          width += parseInt(window.getComputedStyle(second).marginLeft, 10);
	
	          if (third) {
	            width += _this4._calcIconWidth(third);
	          }
	        } else if (second) {
	          width += _this4._calcIconWidth(second);
	        }
	      }
	    }
	
	    return Math.ceil(Math.min(max, Math.max(min, width)));
	  };
	
	  this._isErrored = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this4.props,
	        value = _ref.value,
	        maxLength = _ref.maxLength,
	        required = _ref.required;
	
	    var error = _this4.state.error;
	
	    var currentLength = _this4._getLength(value);
	    if (required && error) {
	      error = !(0, _isValued2.default)(value);
	    }
	
	    if (maxLength) {
	      error = error || currentLength > maxLength;
	    }
	
	    return error;
	  };
	
	  this._handleContainerClick = function (e) {
	    if (_this4.props.onClick) {
	      _this4.props.onClick(e);
	    }
	
	    if (!_this4.props.disabled) {
	      _this4.focus();
	    }
	  };
	
	  this._handleBlur = function (e) {
	    var _props5 = _this4.props,
	        required = _props5.required,
	        maxLength = _props5.maxLength,
	        onBlur = _props5.onBlur;
	
	    if (onBlur) {
	      onBlur(e);
	    }
	
	    var value = e.target.value;
	
	    var state = {
	      active: false,
	      error: required && !(0, _isValued2.default)(value) || maxLength && String(value).length > maxLength
	    };
	
	    if (!_this4.props.block) {
	      state.floating = (0, _isValued2.default)(value);
	    }
	
	    _this4.setState(state);
	  };
	
	  this._handleFocus = function (e) {
	    var _props6 = _this4.props,
	        onFocus = _props6.onFocus,
	        block = _props6.block;
	
	    if (onFocus) {
	      onFocus(e);
	    }
	
	    var state = { active: true };
	    if (!block) {
	      state.floating = true;
	    }
	
	    _this4.setState(state);
	  };
	
	  this._handleChange = function (e) {
	    var _props7 = _this4.props,
	        onChange = _props7.onChange,
	        maxLength = _props7.maxLength,
	        required = _props7.required,
	        resize = _props7.resize;
	    var value = e.target.value;
	
	    if (onChange) {
	      onChange(e.target.value, e);
	    }
	
	    var currentLength = value.length;
	    var state = void 0;
	    if (typeof maxLength !== 'undefined') {
	      state = { currentLength: currentLength, error: currentLength > maxLength };
	    } else if (required && _this4.state.error) {
	      state = { error: !currentLength };
	    }
	
	    if (typeof _this4.props.value === 'undefined' && resize) {
	      var width = _this4._calcWidth(value);
	      if (!resize.disableShrink || !_this4.state.styles || width > _this4.state.styles.width) {
	        state = state || {};
	        state.styles = _extends({}, _this4.state.styles, { width: width });
	      }
	    }
	
	    if (state) {
	      _this4.setState(state);
	    }
	  };
	
	  this._togglePasswordField = function () {
	    _this4.setState({ passwordVisible: !_this4.state.passwordVisible }, _this4.focus);
	  };
	};
	
	exports.default = TextField;
	//# sourceMappingURL=TextField.js.map

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = merge;
	function merge() {
	  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var defaults = arguments[1];
	
	  for (var key in defaults) {
	    if (typeof obj[key] === 'undefined') {
	      obj[key] = defaults[key];
	    }
	  }
	  return obj;
	}
	module.exports = exports['default'];

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keyCodes = __webpack_require__(15);
	
	var _handleKeyboardAccessibility = __webpack_require__(83);
	
	var _handleKeyboardAccessibility2 = _interopRequireDefault(_handleKeyboardAccessibility);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `AccessibleFakeButton` is a generic component that can be used to render
	 * a `div` or any other non `button` components as a button. This should not be
	 * used often.
	 *
	 * The `AccessibleFakeButton` allows the user to tab focus the element, use the
	 * space or enter key to trigger the `onClick` event, and toggles the `aria-pressed`
	 * attribute.
	 */
	var AccessibleFakeButton = function (_PureComponent) {
	  _inherits(AccessibleFakeButton, _PureComponent);
	
	  function AccessibleFakeButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AccessibleFakeButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AccessibleFakeButton.__proto__ || Object.getPrototypeOf(AccessibleFakeButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = { pressed: false, tabFocused: false }, _this.focus = function () {
	      if (_this._node) {
	        _this._node.focus();
	      }
	    }, _this.blur = function () {
	      if (_this._node) {
	        _this._node.blur();
	      }
	    }, _this._setNode = function (node) {
	      if (node) {
	        _this._node = (0, _reactDom.findDOMNode)(node);
	      }
	    }, _this._handleClick = function (e) {
	      if (_this.props.disabled) {
	        return;
	      }
	
	      if (_this.props.onClick) {
	        _this.props.onClick(e);
	      }
	
	      _this._node.focus();
	      _this.setState({ pressed: !_this.state.pressed });
	    }, _this._handleKeyDown = function (e) {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          onKeyDown = _this$props.onKeyDown,
	          listenToEnter = _this$props.listenToEnter,
	          listenToSpace = _this$props.listenToSpace;
	
	      if (disabled) {
	        return;
	      }
	
	      if (onKeyDown) {
	        onKeyDown(e);
	      }
	
	      (0, _handleKeyboardAccessibility2.default)(e, _this._handleClick, listenToEnter, listenToSpace);
	    }, _this._handleKeyUp = function (e) {
	      var _this$props2 = _this.props,
	          onKeyUp = _this$props2.onKeyUp,
	          onTabFocus = _this$props2.onTabFocus;
	
	      if (onKeyUp) {
	        onKeyUp(e);
	      }
	
	      if ((e.which || e.keyCode) === _keyCodes.TAB) {
	        if (onTabFocus) {
	          onTabFocus(e);
	        }
	
	        _this.setState({ tabFocused: true });
	      }
	    }, _this._handleBlur = function (e) {
	      if (_this.props.onBlur) {
	        _this.props.onBlur(e);
	      }
	
	      if (_this.state.tabFocused) {
	        _this.setState({ tabFocused: false });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Focuses the button.
	   */
	
	
	  /**
	   * Blurs the button.
	   */
	
	
	  _createClass(AccessibleFakeButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.component,
	          children = _props.children,
	          className = _props.className,
	          tabbedClassName = _props.tabbedClassName,
	          disabled = _props.disabled,
	          tabIndex = _props.tabIndex,
	          ink = _props.ink,
	          noFocusOutline = _props.noFocusOutline,
	          onBlur = _props.onBlur,
	          onClick = _props.onClick,
	          onKeyUp = _props.onKeyUp,
	          onKeyDown = _props.onKeyDown,
	          onTabFocus = _props.onTabFocus,
	          listenToEnter = _props.listenToEnter,
	          listenToSpace = _props.listenToSpace,
	          props = _objectWithoutProperties(_props, ['component', 'children', 'className', 'tabbedClassName', 'disabled', 'tabIndex', 'ink', 'noFocusOutline', 'onBlur', 'onClick', 'onKeyUp', 'onKeyDown', 'onTabFocus', 'listenToEnter', 'listenToSpace']);
	
	      var childElements = children;
	      if (ink) {
	        childElements = _react.Children.toArray(children);
	        childElements.unshift(ink);
	      }
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, {
	          ref: this._setNode,
	          className: (0, _classnames2.default)('md-fake-btn', _defineProperty({
	            'md-pointer--hover': !disabled,
	            'md-fake-btn--no-outline': noFocusOutline
	          }, tabbedClassName, tabbedClassName && this.state.tabFocused), className),
	          disabled: disabled,
	          tabIndex: disabled ? null : tabIndex,
	          onBlur: this._handleBlur,
	          onClick: this._handleClick,
	          onKeyUp: this._handleKeyUp,
	          onKeyDown: this._handleKeyDown,
	          'aria-pressed': this.state.pressed
	        }),
	        childElements
	      );
	    }
	  }]);
	
	  return AccessibleFakeButton;
	}(_react.PureComponent);
	
	AccessibleFakeButton.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional function to call only when the button has been focused with the tab key.
	   */
	  tabbedClassName: _propTypes2.default.string,
	
	  /**
	   * Any children to display in the Accessible Fake Button.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An optional onClick function to call when the user clicks the
	   * button or presses space || enter.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional onKeyDown function to call.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional onBlur function to call.
	   */
	  onBlur: _propTypes2.default.func,
	
	  /**
	   * An optional onKeyUp function to call.
	   */
	  onKeyUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the element is focused with the tab key.
	   */
	  onTabFocus: _propTypes2.default.func,
	
	  /**
	   * The component to render the Fake button as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * Boolean if the default outline should be removed the when the fake button has been focused.
	   *
	   * @see {@link #tabbedClassName}
	   */
	  noFocusOutline: _propTypes2.default.bool,
	
	  /**
	   * The tab index to use for the Fake button so it is keyboard focusable.
	   */
	  tabIndex: _propTypes2.default.number,
	
	  /**
	   * Boolean if the Button is disabled. This will prevent tab focus.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * The role for the accessible fake button. It is recommended to keep it
	   * the default of `button` unless you are rendering it as an `a` tag.
	   */
	  role: _propTypes2.default.string,
	
	  /**
	   * The ink when coming from the AccessibleFakeInkedButton
	   * @access private
	   */
	  ink: _propTypes2.default.node,
	
	  /**
	   * Boolean if the spacebar should be used to trigger the click event. This _should_ be `true`
	   * is almost all cases.
	   */
	  listenToSpace: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the enter key should be used to trigger the click event. This _should_ be `true`
	   * in most cases. By default, the param will be ignored if the `role` attribute is for a `checkbox`
	   * or `radio`. When it is a checkbox or radio, it will attempt to submit the form on the enter
	   * keypress instead like the native elements.
	   */
	  listenToEnter: _propTypes2.default.bool
	};
	AccessibleFakeButton.defaultProps = {
	  component: 'div',
	  tabIndex: 0,
	  role: 'button',
	  noFocusOutline: true,
	  listenToEnter: true,
	  listenToSpace: true
	};
	exports.default = AccessibleFakeButton;
	//# sourceMappingURL=AccessibleFakeButton.js.map

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _fixedToShape = __webpack_require__(22);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _Subheaders = __webpack_require__(287);
	
	var _Subheaders2 = _interopRequireDefault(_Subheaders);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Lists present multiple line items vertically as a single continuous element.
	 */
	var List = function (_PureComponent) {
	  _inherits(List, _PureComponent);
	
	  function List() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, List);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = List.__proto__ || Object.getPrototypeOf(List)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(List, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _context = this.context,
	          listLevel = _context.listLevel,
	          context = _objectWithoutProperties(_context, ['listLevel']);
	
	      var cascadingFixedTo = (0, _getField2.default)(this.state, this.context, 'cascadingFixedTo');
	      return _extends({}, context, {
	        cascadingFixedTo: cascadingFixedTo,
	        listLevel: typeof listLevel === 'undefined' ? 1 : listLevel + 1
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.context.cascadingMenu) {
	        var list = (0, _reactDom.findDOMNode)(this);
	        if (list.offsetHeight < list.scrollHeight) {
	          var cascadingFixedTo = { y: (0, _reactDom.findDOMNode)(this) };
	          this.setState({ cascadingFixedTo: cascadingFixedTo }); // eslint-disable-line react/no-did-mount-set-state
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cn;
	
	      var _props = this.props,
	          className = _props.className,
	          ordered = _props.ordered,
	          children = _props.children,
	          subheader = _props.subheader,
	          inline = _props.inline,
	          primarySubheader = _props.primarySubheader,
	          props = _objectWithoutProperties(_props, ['className', 'ordered', 'children', 'subheader', 'inline', 'primarySubheader']);
	
	      var _context2 = this.context,
	          cascadingMenu = _context2.cascadingMenu,
	          cascadingZDepth = _context2.cascadingZDepth,
	          listLevel = _context2.listLevel;
	
	
	      var subheaderEl = void 0;
	      if (subheader) {
	        subheaderEl = _react2.default.createElement(_Subheaders2.default, { key: 'subheader', primaryText: subheader, primary: primarySubheader });
	      }
	
	      var Component = ordered ? 'ol' : 'ul';
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, {
	          className: (0, _classnames2.default)('md-list', (_cn = {
	            'md-list--inline': inline,
	            'md-list--menu-cascading': cascadingMenu
	          }, _defineProperty(_cn, 'md-paper md-paper--' + cascadingZDepth, cascadingZDepth && cascadingMenu && listLevel > 0), _defineProperty(_cn, 'md-list--nested-' + listLevel, listLevel && !cascadingMenu), _cn), className)
	        }),
	        subheaderEl,
	        children
	      );
	    }
	  }]);
	
	  return List;
	}(_react.PureComponent);
	
	List.propTypes = {
	  /**
	   * An optional style to apply to the list.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the list.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if this should be an ordered list (`<ol>`) component. Otherwise, it will
	   * be rendered as `<ul>`.
	   */
	  ordered: _propTypes2.default.bool,
	
	  /**
	   * This *should* be a list of `ListItem`, `ListItemControl`, `Divider`, or
	   * `Subheader`.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the list should appear horizontally instead of vertically.
	   */
	  inline: _propTypes2.default.bool,
	  subheader: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `Subheader` component as a child instead'),
	  primarySubheader: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use the `Subheader` component as a child instead')
	};
	List.childContextTypes = {
	  listLevel: _propTypes2.default.number,
	  cascadingMenu: _propTypes2.default.bool,
	  cascadingFixedTo: _fixedToShape2.default,
	  cascadingZDepth: _propTypes2.default.number
	};
	List.contextTypes = {
	  listLevel: _propTypes2.default.number,
	  cascadingMenu: _propTypes2.default.bool,
	  cascadingFixedTo: _fixedToShape2.default,
	  cascadingZDepth: _propTypes2.default.number
	};
	exports.default = List;
	//# sourceMappingURL=List.js.map

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = captureNextEvent;
	/** @module utils/EventUtils/captureNextEvent */
	
	/**
	 * This function will capture the next event and stop propagation during the
	 * bubbling cycle of events. This is really only useful if you want to stop
	 * the default behavior of chained events.
	 *
	 * @param {String} type - The event type to capture.
	 * @param {Object|func=} target - Either the DOM node to target, a callback function
	 *      to call once the event has been captured, or undefined. If this is undefined,
	 *      the event will be captured on the window.
	 * @param {func=} callback - An optional callback function to call once the event
	 *      has been captured.
	 */
	function captureNextEvent(type, target, callback) {
	  var el = typeof target !== 'function' && target ? target : window;
	  var cb = typeof target === 'function' ? target : callback;
	
	  var capture = function capture(e) {
	    e.stopPropagation();
	    if (cb) {
	      cb(e);
	    }
	
	    el.removeEventListener(type, capture, true);
	  };
	
	  el.addEventListener(type, capture, true);
	}
	//# sourceMappingURL=captureNextEvent.js.map

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = handleKeyboardAccessibility;
	
	var _keyCodes = __webpack_require__(15);
	
	var _closest = __webpack_require__(686);
	
	var _closest2 = _interopRequireDefault(_closest);
	
	var _isFormPartRole = __webpack_require__(307);
	
	var _isFormPartRole2 = _interopRequireDefault(_isFormPartRole);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A utility function for adding keyboard accessibility to elements that are not a natively
	 * clickable (div, span, etc). When the space or enter key is pressed while focusing the
	 * element, different flows will happen.
	 *
	 * - space - The click event will be triggered and the default page scrolling behavior of the
	 *      spacebar will be prevented
	 * - enter - If the element has a form role ('checkbox' or 'radio'), the click event will not
	 *      be triggered. Instead, it will find out if the element is inside a form. If it is, it
	 *      will emulate the default behavior of attempting to submit the form. If the element does
	 *      not have a form role, the click event will be triggered.
	 *
	 * @param {Event} e - the keydown event
	 * @param {function} onClick - the on click event to be triggered if space or enter was pressed
	 * @param {boolean=true} listenToEnter - boolean if the enter key should be used to trigger the
	 *      the click event. Even if this is true, the click event will not be triggered if the role
	 *      is for a form role.
	 * @param {boolean=true} listenToSpace - boolean if the space key should be used to trigger the
	 *      click event.
	 * @return {Boolean} true if the enter or space keys were pressed while their listener is also active.
	 */
	function handleKeyboardAccessibility(e, onClick) {
	  var listenToEnter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  var listenToSpace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	  var key = e.which || e.keyCode;
	  var space = listenToSpace && key === _keyCodes.SPACE;
	  var enter = key === _keyCodes.ENTER;
	
	  var tagName = e.target.tagName;
	
	  if (space && !tagName.match(/input|textarea|button/i)) {
	    // it is valid to press space in text fields and buttons
	    // Stop page scrolling
	    e.preventDefault();
	  }
	
	  if (enter && (0, _isFormPartRole2.default)(e.target)) {
	    var form = (0, _closest2.default)(e.target, 'form');
	    var submit = form ? form.querySelector('*[type="submit"]') : null;
	    if (submit) {
	      submit.click();
	    }
	
	    return true;
	  }
	
	  if (enter && listenToEnter || space) {
	    onClick(e);
	
	    return true;
	  }
	
	  return false;
	} /** @module utils/EventUtils/handleKeyboardAccessibility */
	//# sourceMappingURL=handleKeyboardAccessibility.js.map

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.setTouchEvent = setTouchEvent;
	exports.addTouchEvent = addTouchEvent;
	exports.removeTouchEvent = removeTouchEvent;
	// https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
	var supportsPassive = void 0;
	try {
	  var opts = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      supportsPassive = true;
	    }
	  });
	  window.addEventListener('test', null, opts);
	} catch (e) {
	  supportsPassive = false;
	}
	
	/**
	 * A helper function for manually setting touch events on elements with the passive
	 * option (when it is supported).
	 *
	 * @param {boolean} add - Boolean if the event listener should be added or removed.
	 * @param {HTMLElement} el - The element to add the listener to.
	 * @param {String} type - the event type to set. This should be 'start', 'move', or 'end'
	 * @param {function} callback - The event listener callback function.
	 * @param {Object=} options - any additional options to apply.
	 */
	function setTouchEvent(add, el, eventType, callback, options) {
	  return el[(add ? 'add' : 'remove') + 'EventListener']('touch' + eventType, callback, supportsPassive ? _extends({ passive: true }, options) : false);
	}
	
	/**
	 * A helper function for manually adding touch events on elements with the passive
	 * option (when it is supported).
	 *
	 * @param {HTMLElement} el - The element to add the listener to.
	 * @param {String} type - the event type to set. This should be 'start', 'move', or 'end'
	 * @param {function} callback - The event listener callback function.
	 * @param {Object=} options - any additional options to apply.
	 */
	function addTouchEvent(el, type, callback, options) {
	  return setTouchEvent(true, el, type, callback, options);
	}
	
	/**
	 * A helper function for manually removing touch events on elements with the passive
	 * option (when it is supported).
	 *
	 * @param {HTMLElement} el - The element to add the listener to.
	 * @param {String} type - the event type to set. This should be 'start', 'move', or 'end'
	 * @param {function} callback - The event listener callback function.
	 * @param {Object=} options - any additional options to apply.
	 */
	function removeTouchEvent(el, type, callback, options) {
	  return setTouchEvent(false, el, type, callback, options);
	}
	//# sourceMappingURL=touches.js.map

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = between;
	
	var _isBetween = __webpack_require__(300);
	
	var _isBetween2 = _interopRequireDefault(_isBetween);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Validates that a number is between a min and max value.
	 *
	 * @param {function} validator - The number validator to use.
	 * @param {number} min - The min number to use.
	 * @param {number} max - The max number to use.
	 * @return {Error} the prop type error or null
	 */
	function between(validator, min, max) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	    var value = props[propName];
	    if (!err && typeof value !== 'undefined' && !(0, _isBetween2.default)(value, min, max)) {
	      err = new Error('You provided a `' + propFullNameSafe + '` ' + location + ' to the ' + componentNameSafe + ' that was ' + ('not within the range from \'' + min + ' - ' + max + '\'. `' + propFullNameSafe + '`: ' + value + '.'));
	    }
	
	    return err;
	  };
	} /** @module utils/PropTypes/between */
	//# sourceMappingURL=between.js.map

/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(74)))

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  checkedIcon: _propTypes2.default.element,
	  uncheckedIcon: _propTypes2.default.element,
	  indeterminateIcon: _propTypes2.default.element,
	  indeterminate: _propTypes2.default.bool,
	  plain: _propTypes2.default.bool,
	  selectableRows: _propTypes2.default.bool.isRequired,
	  allSelected: _propTypes2.default.bool.isRequired,
	  selectedRows: _propTypes2.default.arrayOf(_propTypes2.default.bool).isRequired,
	  createCheckbox: _propTypes2.default.func.isRequired,
	  removeCheckbox: _propTypes2.default.func.isRequired,
	  toggleSelectedRow: _propTypes2.default.func.isRequired,
	  baseId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  baseName: _propTypes2.default.string,
	  checkboxHeaderLabel: _propTypes2.default.string.isRequired,
	  checkboxLabelTemplate: _propTypes2.default.string.isRequired,
	  fixedHeader: _propTypes2.default.bool.isRequired,
	  fixedFooter: _propTypes2.default.bool.isRequired
	};
	//# sourceMappingURL=contextTypes.js.map

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findTable;
	/**
	 * Attempts fo find the base table component from an element in the table.
	 * This will either be the wrapper for responsive data tables, or the table element.
	 *
	 * @param {Object} el - The element to traverse from
	 * @param {Object} the table or null.
	 */
	function findTable(el) {
	  var table = void 0;
	  var node = el;
	  while (node && node.parentNode) {
	    if (node.classList) {
	      if (node.classList.contains('md-data-table')) {
	        table = node;
	      } else if (node.classList.contains('md-data-table--responsive')) {
	        return node;
	      } else if (node.classList.contains('md-data-table__scroll-wrapper')) {
	        // fixed-wrapper then responsive
	        return node.parentNode.parentNode;
	      } else if (table) {
	        return table;
	      }
	    }
	
	    node = node.parentNode;
	  }
	
	  return null;
	}
	//# sourceMappingURL=findTable.js.map

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(19);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FOOTER_PADDING = 8;
	
	var DialogFooter = function (_PureComponent) {
	  _inherits(DialogFooter, _PureComponent);
	
	  function DialogFooter() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DialogFooter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DialogFooter.__proto__ || Object.getPrototypeOf(DialogFooter)).call.apply(_ref, [this].concat(args))), _this), _this.state = { stacked: false }, _this._setContainer = function (container) {
	      if (container !== null) {
	        _this._container = container;
	        var maxWidth = (_this._container.offsetWidth - FOOTER_PADDING * 3) / 2;
	
	        var stacked = false;
	        Array.prototype.slice.call(_this._container.querySelectorAll('.md-btn')).some(function (_ref2) {
	          var offsetWidth = _ref2.offsetWidth;
	
	          stacked = offsetWidth > maxWidth;
	          return stacked;
	        });
	
	        _this.setState({ stacked: stacked });
	      }
	    }, _this._generateActions = function () {
	      var actions = _this.props.actions;
	
	      if (!actions) {
	        return null;
	      } else if (Array.isArray(actions)) {
	        return actions.map(_this._toElement);
	      }
	
	      return _this._toElement(actions);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DialogFooter, [{
	    key: '_toElement',
	    value: function _toElement(action, index) {
	      if ((0, _react.isValidElement)(action)) {
	        var button = _react.Children.only(action);
	
	        return (0, _react.cloneElement)(action, {
	          key: button.key || index,
	          className: (0, _classnames2.default)('md-btn--dialog', button.props.className)
	        });
	      }
	
	      // Both label and children are valid for dialog actions
	
	      var label = action.label,
	          children = action.children,
	          remaining = _objectWithoutProperties(action, ['label', 'children']);
	
	      return _react2.default.createElement(
	        _Button2.default,
	        _extends({
	          key: index,
	          flat: true
	        }, remaining, {
	          className: (0, _classnames2.default)('md-btn--dialog', action.className)
	        }),
	        label || children
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actions = _props.actions,
	          className = _props.className,
	          children = _props.children,
	          propStacked = _props.stacked,
	          props = _objectWithoutProperties(_props, ['actions', 'className', 'children', 'stacked']);
	
	      if (!children && (!actions || Array.isArray(actions) && !actions.length)) {
	        return null;
	      }
	
	      var stacked = this.props.stacked;
	
	      var stackedDefined = typeof propStacked !== 'undefined';
	      if (!stackedDefined) {
	        stacked = this.state.stacked;
	      }
	
	      return _react2.default.createElement(
	        'footer',
	        _extends({}, props, {
	          className: (0, _classnames2.default)('md-dialog-footer', {
	            'md-dialog-footer--inline': !stacked,
	            'md-dialog-footer--stacked': stacked
	          }, className),
	          ref: !stackedDefined ? this._setContainer : null
	        }),
	        this._generateActions(),
	        children
	      );
	    }
	  }]);
	
	  return DialogFooter;
	}(_react.PureComponent);
	
	DialogFooter.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  actions: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.object, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.object]))]),
	  stacked: _propTypes2.default.bool
	};
	exports.default = DialogFooter;
	//# sourceMappingURL=DialogFooter.js.map

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(9);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CSSTransitionGroup = __webpack_require__(49);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _handleWindowClickListeners = __webpack_require__(112);
	
	var _handleWindowClickListeners2 = _interopRequireDefault(_handleWindowClickListeners);
	
	var _getSelectedTextPosition = __webpack_require__(679);
	
	var _getSelectedTextPosition2 = _interopRequireDefault(_getSelectedTextPosition);
	
	var _getScroll = __webpack_require__(678);
	
	var _getScroll2 = _interopRequireDefault(_getScroll);
	
	var _viewport = __webpack_require__(304);
	
	var _viewport2 = _interopRequireDefault(_viewport);
	
	var _isOutOfBounds = __webpack_require__(680);
	
	var _isOutOfBounds2 = _interopRequireDefault(_isOutOfBounds);
	
	var _anchorShape = __webpack_require__(38);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(22);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(39);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _HorizontalAnchors = __webpack_require__(274);
	
	var _HorizontalAnchors2 = _interopRequireDefault(_HorizontalAnchors);
	
	var _VerticalAnchors = __webpack_require__(276);
	
	var _VerticalAnchors2 = _interopRequireDefault(_VerticalAnchors);
	
	var _Positions = __webpack_require__(275);
	
	var _Positions2 = _interopRequireDefault(_Positions);
	
	var _ResizeObserver = __webpack_require__(32);
	
	var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Layover component is used to keep a component fixed to another component
	 * while the page is scrolling or a container is scrolling. When the fixed component
	 * is considered out of view, it will be closed.
	 *
	 * > NOTE: Don't look at source code. Plz.
	 */
	var Layover = function (_PureComponent) {
	  _inherits(Layover, _PureComponent);
	
	  function Layover(props) {
	    _classCallCheck(this, Layover);
	
	    var _this = _possibleConstructorReturn(this, (Layover.__proto__ || Object.getPrototypeOf(Layover)).call(this));
	
	    _initialiseProps.call(_this);
	
	    var child = _react2.default.Children.only(props.children);
	    _this.state = {
	      below: false,
	      right: false,
	      styles: child.props.style
	    };
	
	    _this._lastXFix = null;
	    _this._lastYFix = null;
	    _this._initialX = null;
	    _this._initialY = null;
	    _this._initialTop = null;
	    _this._initialLeft = null;
	    _this._child = null;
	    _this._toggle = null;
	    return _this;
	  }
	
	  _createClass(Layover, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (false) {
	        window.addEventListener('load', function () {
	          _this2._setContainer(_this2._container);
	        });
	      }
	
	      var _props = this.props,
	          visible = _props.visible,
	          fixedTo = _props.fixedTo,
	          sameWidth = _props.sameWidth,
	          centered = _props.centered,
	          simplified = _props.simplified;
	
	      var anchor = this._getAnchor(this.props);
	      if (visible) {
	        (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, true);
	
	        // Don't worry about any of the other logic for a "simple" layover
	        if (simplified) {
	          return;
	        }
	
	        var rect = this._contextRect || this._toggle.getBoundingClientRect();
	        if (this._dialog) {
	          this._manageFixedToListener(this._dialog, true);
	        } else if (!this._inFixed) {
	          this._manageFixedToListener(fixedTo, true);
	        }
	
	        this._init(fixedTo, anchor, sameWidth, centered, rect);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var fixedTo = nextProps.fixedTo,
	          visible = nextProps.visible,
	          children = nextProps.children,
	          sameWidth = nextProps.sameWidth,
	          centered = nextProps.centered,
	          simplified = nextProps.simplified;
	
	      if (simplified) {
	        if (this.props.simplified !== simplified) {
	          this._reset();
	        }
	        return;
	      }
	
	      var anchor = this._getAnchor(nextProps);
	      var visibileDiff = visible !== this.props.visible;
	      var childStyle = _react2.default.Children.only(children).props.style;
	
	      if (visibileDiff) {
	        if (!visible) {
	          this._reset();
	        } else {
	          // Initialize the layover logic
	          var rect = this._contextRect || this._toggle.getBoundingClientRect();
	          if (this._dialog) {
	            this._manageFixedToListener(this._dialog, true);
	          } else if (!this._inFixed) {
	            this._manageFixedToListener(fixedTo, true);
	          }
	
	          this._init(fixedTo, anchor, sameWidth, centered, rect);
	        }
	      } else if (fixedTo !== this.props.fixedTo && visible) {
	        // swap the fixedTo listeners
	        this._manageFixedToListener(this.props.fixedTo, false);
	        this._manageFixedToListener(fixedTo, true);
	      } else if (childStyle !== _react2.default.Children.only(this.props.children).props.style) {
	        // Re-merge styles... This is only required if all the others fail since all the other
	        // logic always merges styles with the children styles
	        this.setState({ styles: _extends({}, this.state.styles, childStyle) });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          visible = _props2.visible,
	          closeOnOutsideClick = _props2.closeOnOutsideClick;
	
	      var enabled = visible && closeOnOutsideClick;
	      var prevEnabled = prevProps.visible && prevProps.closeOnOutsideClick;
	      if (enabled !== prevEnabled) {
	        if (this._clickTimeout) {
	          clearTimeout(this._clickTimeout);
	          this._clickTimeout = null;
	        }
	
	        // This is really an arbitrary timeout time, but firefox needs to have a timeout
	        // so the context menu doesn't close automatically due to an "outside click" being
	        // triggered
	        this._clickTimeout = setTimeout(function () {
	          _this3._clickTimeout = null;
	          (0, _handleWindowClickListeners2.default)(_this3._handleOutsideClick, enabled);
	        }, enabled ? 300 : 0);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._clickTimeout) {
	        clearTimeout(this._clickTimeout);
	        this._clickTimeout = null;
	      }
	      (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, false);
	
	      if (!this.props.simplified) {
	        this._manageFixedToListener(this.props.fixedTo, false);
	        this._manageWindowResizeListener(false);
	      }
	    }
	  }, {
	    key: '_getAnchor',
	    value: function _getAnchor(_ref) {
	      var anchor = _ref.anchor,
	          belowAnchor = _ref.belowAnchor,
	          animationPosition = _ref.animationPosition;
	
	      return animationPosition === Layover.Positions.BELOW && belowAnchor || anchor;
	    }
	
	    /**
	     * Whew. Ok. So since the fixedTo prop can either be two elements or a single item,
	     * this utility function is used to add/remove the scrolling event listeners for
	     * this prop.
	     *
	     * When the fixedTo prop has a horizontal and/or vertical attribute, the `window`
	     * will be the fallback option. If both the horizontal and vertical attributes are
	     * defined, the `window` still needs to have a scroll listener to make sure it
	     * doesn't go off screen.
	     */
	
	
	    /**
	     * This is just a simple utility function to merge the existing state styles,
	     * any new styles, and the children's styles (with most precedence).
	     */
	
	
	    /**
	     * This initializes the popover with the default styles, and the initial bookkeeping
	     * variables to update while it is open.
	     */
	
	
	    /**
	     * Attempts to fix the child by setting it's location ONLY for the entire
	     * page viewport. I didn't bother attempting to fix it for additional fixedTo
	     * stuff.
	     */
	
	
	    /**
	     * When the child is initially mounted, it will update the styles for centering
	     * the element (if enabled) and then attempt to fix any viewport issues.
	     */
	
	
	    /**
	     * This is the meat of the stuff. Do lots of viewport / container checks to make sure
	     * the element should still be visible. If it is still visible, it will update its
	     * x and y position for the new scroll position.
	     */
	
	
	    /**
	     * Attempts to fix a viewport problem by swapping the positioning. This only does
	     * vertical switching right now.
	     *
	     * @param {Object} vp - The result of the viewport function
	     * @return {boolean} true if the fix was able to be done and successful.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          className = _props3.className,
	          block = _props3.block,
	          toggle = _props3.toggle,
	          visible = _props3.visible,
	          children = _props3.children,
	          fullWidth = _props3.fullWidth,
	          animationPosition = _props3.animationPosition,
	          simplified = _props3.simplified,
	          fillViewportWidth = _props3.fillViewportWidth,
	          fillViewportHeight = _props3.fillViewportHeight,
	          anchor = _props3.anchor,
	          belowAnchor = _props3.belowAnchor,
	          onClose = _props3.onClose,
	          repositionOnScroll = _props3.repositionOnScroll,
	          repositionOnResize = _props3.repositionOnResize,
	          sameWidth = _props3.sameWidth,
	          centered = _props3.centered,
	          fixedTo = _props3.fixedTo,
	          toggleQuery = _props3.toggleQuery,
	          yThreshold = _props3.yThreshold,
	          xThreshold = _props3.xThreshold,
	          onContextMenu = _props3.onContextMenu,
	          preventContextMenu = _props3.preventContextMenu,
	          closeOnOutsideClick = _props3.closeOnOutsideClick,
	          minLeft = _props3.minLeft,
	          minRight = _props3.minRight,
	          minBottom = _props3.minBottom,
	          props = _objectWithoutProperties(_props3, ['className', 'block', 'toggle', 'visible', 'children', 'fullWidth', 'animationPosition', 'simplified', 'fillViewportWidth', 'fillViewportHeight', 'anchor', 'belowAnchor', 'onClose', 'repositionOnScroll', 'repositionOnResize', 'sameWidth', 'centered', 'fixedTo', 'toggleQuery', 'yThreshold', 'xThreshold', 'onContextMenu', 'preventContextMenu', 'closeOnOutsideClick', 'minLeft', 'minRight', 'minBottom']);
	
	      var child = void 0;
	      var childId = void 0;
	      if (visible) {
	        child = _react2.default.Children.only(children);
	        if (child.props.id) {
	          childId = child.props.id;
	        } else if (props.id) {
	          childId = props.id + '-layover';
	        }
	
	        child = _react2.default.cloneElement(children, {
	          ref: this._fixateChild,
	          id: childId,
	          style: simplified ? child.props.style : this.state.styles,
	          className: (0, _classnames2.default)('md-layover-child md-layover-child--' + animationPosition, {
	            'md-layover-child--simplified': simplified
	          }, child.props.className)
	        });
	      }
	
	      var observer = null;
	      if (!simplified && !fillViewportWidth && !fillViewportHeight) {
	        observer = _react2.default.createElement(_ResizeObserver2.default, {
	          watchWidth: !fillViewportWidth,
	          watchHeight: !fillViewportHeight,
	          target: this._child,
	          onResize: this._handleResize
	        });
	      }
	
	      return _react2.default.createElement(
	        _CSSTransitionGroup2.default,
	        _extends({}, props, {
	          className: (0, _classnames2.default)('md-layover', {
	            'md-layover--simplified': simplified,
	            'md-inline-block': !block && !fullWidth,
	            'md-full-width': fullWidth
	          }, className),
	          ref: this._setContainer,
	          'aria-haspopup': true,
	          'aria-owns': childId,
	          'aria-expanded': visible,
	          transitionEnter: props.transitionEnterTimeout !== 0,
	          transitionLeave: props.transitionLeaveTimeout !== 0,
	          onContextMenu: this._handleContextMenu
	        }),
	        observer,
	        toggle,
	        child
	      );
	    }
	  }]);
	
	  return Layover;
	}(_react.PureComponent);
	
	Layover.HorizontalAnchors = _HorizontalAnchors2.default;
	Layover.VerticalAnchors = _VerticalAnchors2.default;
	Layover.Positions = _Positions2.default;
	Layover.propTypes = {
	  /**
	   * A id to give the layover itself. This is generally recommended for accessibility. If the
	   * child does not have an id, the child will automatically be updated to be `${id}-layover`.
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the layover.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the layover.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if the layover's child is currently visible.
	   */
	  visible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * This should either be a single element or two elements that the layover recalculates
	   * its fixed position when scrolling for horizontal and vertical.
	   *
	   * When it is a single element, it will recalculate for both horizontal and vertical
	   * scrolling. Otherwise, you can specify the element for horizontal scrolling and a
	   * separate element for vertical scrolling. If one is omitted, it will default to `window`.
	   *
	   * If the component is no longer considered to be in view after scrolling, the `onClose`
	   * prop will be called.
	   */
	  fixedTo: _fixedToShape2.default.isRequired,
	
	  /**
	   * The renderable item that causes the Layover to become visible. This _should_
	   * most likely be an `element` or `arrayOf(element)`, but anything is allowed.
	   */
	  toggle: _propTypes2.default.node,
	
	  /**
	   * Since the `toggle` prop can be anything, I need a way to be able to find an
	   * element to base all the calculations on. This can either be a string that
	   * gets passed to `layover.querySelector`, a DOM Element, or a function that
	   * returns a DOM Element.
	   */
	  toggleQuery: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.string]).isRequired,
	
	  /**
	   * A single child that should be fixed to the toggle element.
	   */
	  children: _propTypes2.default.element.isRequired,
	
	  /**
	   * Boolean if the Layover should be displayed as a block instead of as an inline block.
	   */
	  block: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `children` should be centered horizontally and vertically while keeping
	   * its height in mind as well. This is *only* valid if both the x and y `anchor` targets
	   * are `CENTER`.
	   */
	  centered: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the layover should gain the `md-full-width` class name.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the width of the children should be updated automatically to be the width
	   * of the toggle element.
	   */
	  sameWidth: _propTypes2.default.bool,
	
	  /**
	   * The minimum value the `left` style can be for the child component. This is really just used
	   * to make sure it doesn't scroll off the left of the page. It can also be used to make
	   * full screen layovers on devices when when the `fillViewportWidth` prop is enabled.
	   *
	   * This can either be a number of pixels or a string for percentages. If this value is a string
	   * **it will always be used over the calculated values** so it is preferred to use a number.
	   *
	   * @see {@link #minRight}
	   * @see {@link #fillViewportWidth}
	   */
	  minLeft: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	
	  /**
	   * The minimum value the `right` style can be for the child component. This is really just used
	   * to make sure it doesn't scroll off the right of the page when the `fillViewportWidth` prop is
	   * enabled.
	   *
	   * This can either be a number of pixels or a string for percentages. If this value is a string
	   * **it will always be used over the calculated values** so it is preferred to use a number.
	   *
	   * @see {@link #minLeft}
	   * @see {@link #fillViewportWidth}
	   */
	  minRight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	
	  /**
	   * The minimum value that can be used for the `bottom` prop when the `fillViewportHeight` prop is enabled.
	   * It is generally recommended to keep this value at `0` to keep it stretched to the bottom of the viewport
	   * or setting it to a small positive number to add some padding.
	   *
	   * This can either be a number of pixels or a string for percentages. If this value is a string
	   * **it will always be used over the calculated values** so it is preferred to use a number.
	   *
	   * @see {@link #fillViewportHeight}
	   */
	  minBottom: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the layover should make the child fill the entire viewport's width. This will just
	   * style the child element with:
	   *
	   * ```js
	   * childStyle = {
	   *   left: this.props.minLeft,
	   *   right: this.props.minRight,
	   * };
	   * ```
	   *
	   * If you add any additional constraints such as `width` or `max-width`, it will not span the entire viewport's
	   * width. This prop should generally really only be used on mobile devices. Using this prop along with
	   * `fillViewportHeight` for Autocompletes can create great Android mobile searches. See the `fillViewportHeight`
	   * for more information about why it is *only Android*.
	   *
	   * @see {@link #minLeft}
	   * @see {@link #minRight}
	   * @see {@link #fillViewportHeight}
	   */
	  fillViewportWidth: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the layover should fill the height of the viewport from the current calculated `top`. This will just
	   * style the child element with:
	   *
	   * ```js
	   * childStyle = {
	   *   top: currentCalculatedTop,
	   *   bottom: this.props.minBottom,
	   *   maxHeight: 'none',
	   * };
	   * ```
	   *
	   * This is *super* nice on Android devices since it will allow you to create nice toolbar search autocompletes
	   * in your app and the list of items will grow until it reaches the soft keyboard. It isn't as nice on iOS since
	   * iOS does not subtract the soft keyboard from the viewport's size so the list will still extend to the bottom
	   * of the page.
	   *
	   * @see {@link #minBottom}
	   * @see {@link #fillViewportWidth}
	   */
	  fillViewportHeight: _propTypes2.default.bool,
	
	  /**
	   * A function used to hide the visibility of the children when the children are no longer
	   * visible or an element outside of the layover is clicked.
	   */
	  onClose: _propTypes2.default.func.isRequired,
	
	  /**
	   * The component to render the Layover as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * The transition name to use for the children appearing/disappearing.
	   */
	  transitionName: _propTypes2.default.string.isRequired,
	
	  /**
	   * The transition duration for the enter animation. The animation can be disabled by setting
	   * this value to 0.
	   */
	  transitionEnterTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * The transition duration for the leave animation. The animation can be disabled by setting
	   * this value to 0.
	   */
	  transitionLeaveTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * This is a threshold that is used to calculate if the `children` is still in
	   * view by applying this multiplier to the `children`'s width.
	   */
	  xThreshold: _propTypes2.default.number.isRequired,
	
	  /**
	   * This is a threshold that is used to calculate if the `children` is still in
	   * view by applying this multiplier to the `toggle`'s height.
	   */
	  yThreshold: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the `children` should be hidden when an element outside
	   * of the `Layout` component has been clicked.
	   */
	  closeOnOutsideClick: _propTypes2.default.bool.isRequired,
	
	  /**
	   * This is how the children get "anchored" to the `toggle` element and how the
	   * auto-fix attempts will be made. Right now, the auto fixes will only be handled
	   * on viewport boundaries instead of `fixedTo` boundaries. It was too hard for
	   * first attempt.
	   *
	   * The general behavior will be that an equal-opposite of an anchor will be chosen
	   * when that direction is out of viewport. So for example, the children are out
	   * of viewport for the right of the screen, and the `anchor.x` value is
	   * `Layover.HorizontalPositions.RIGHT`, the children will be swapped to be the `LEFT`
	   * of the `toggle` component now.
	   *
	   * So a full list:
	   * - `LEFT` / `RIGHT`
	   * - `INNER_LEFT` / `INNER_RIGHT`
	   * - `TOP` / `BOTTOM`
	   *
	   * The `CENTER` and `OVERLAP` positions can not be automatically adjusted.
	   *
	   * > To be safe, you should use the enum values for the `x` and `y` values.
	   * @see {@link #VerticalAnchors}
	   * @see {@link #HorizontalAnchors}
	   */
	  anchor: _anchorShape2.default.isRequired,
	
	  /**
	   * This is how the children get "anchored" when the `animationPositions` is set to `Layover.Positions.BELOW`.
	   * Set this to `null` to continue using the base `anchor` prop instead of switching to this anchor.
	   *
	   * @see {@link #anchor}
	   */
	  belowAnchor: _anchorShape2.default,
	
	  /**
	   * This is the position that the children should animate from. It directly ties into
	   * the `$md-layover-child-positions` Sass variable.
	   */
	  animationPosition: _positionShape2.default.isRequired,
	
	  /**
	   * If you would like the layover to interact as a context menu, provide this prop. It will
	   * make the children appear relative to the context menu origin automatically.
	   *
	   * @see {@link #preventContextMenu}
	   */
	  onContextMenu: _propTypes2.default.func,
	
	  /**
	   * Boolean if the default behavior of the context menu should be prevented when using the
	   * `onContextMenu` prop.
	   *
	   * @see {@link #onContextMenu}
	   */
	  preventContextMenu: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the layover should attempt to automatically adjust the position of the element to
	   * keep it within the viewport. If this value is set to `false`, the `onClose` prop will be called
	   * instead.
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the layover should attempt to automatically adjust the position of the element to
	   * keep it within the viewport. If this value is set to `false`, the `onClose` prop will be called
	   * instead.
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the layover should become "simplified". This basically disables all the logic for
	   * keeping the child within the viewport and allows you to manage all the positioning via CSS.
	   *
	   * When this is enabled, it updates the `Layover` to have `position: relative` while the child will
	   * have `position: absolute` which will allow for simple `top`, `right`, `bottom`, and/or `left` CSS
	   * to position as wanted.
	   *
	   * This is really only helpful in cases where the layover can't calculate things correctly due to
	   * being in fixed containers somewhere in the page or some other weird stuff. Hopefully this won't
	   * really need to be used much.
	   */
	  simplified: _propTypes2.default.bool
	};
	Layover.defaultProps = {
	  anchor: {
	    x: Layover.HorizontalAnchors.INNER_LEFT,
	    y: Layover.VerticalAnchors.OVERLAP
	  },
	  belowAnchor: {
	    x: Layover.HorizontalAnchors.CENTER,
	    y: Layover.VerticalAnchors.BOTTOM
	  },
	  animationPosition: Layover.Positions.BELOW,
	  repositionOnScroll: true,
	  repositionOnResize: false,
	  component: 'div',
	  fixedTo: typeof window !== 'undefined' ? window : {},
	  toggleQuery: '.md-text-field-container,button,*[role="button"],*[role="listbox"]',
	  transitionName: 'md-layover',
	  transitionEnterTimeout: 200,
	  transitionLeaveTimeout: 200,
	  yThreshold: 0.38,
	  xThreshold: 0.38,
	  closeOnOutsideClick: true,
	  preventContextMenu: true,
	  simplified: false,
	  minLeft: 0,
	  minRight: 0,
	  minBottom: 0,
	  fillViewportWidth: false,
	  fillViewportHeight: false
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this._isCenteredDialog = function () {
	    return _this4._dialog && _this4._dialog.classList.contains('md-dialog--centered');
	  };
	
	  this._createStyles = function (anchor, centered, child, rect) {
	    var x = anchor.x,
	        y = anchor.y;
	    var offsetWidth = child.offsetWidth,
	        offsetHeight = child.offsetHeight;
	
	
	    var left = void 0;
	    var top = void 0;
	    if (x === _HorizontalAnchors2.default.CENTER) {
	      left = rect.left + rect.width / 2 - offsetWidth / 2;
	    } else if (x === _HorizontalAnchors2.default.INNER_RIGHT) {
	      left = rect.right - offsetWidth;
	    } else if (x === _HorizontalAnchors2.default.LEFT) {
	      left = rect.left - offsetWidth;
	    } else if (x === _HorizontalAnchors2.default.RIGHT) {
	      left = rect.right;
	    }
	
	    if (centered && x === _HorizontalAnchors2.default.CENTER && y === _VerticalAnchors2.default.CENTER) {
	      top = rect.top - offsetHeight / 2 + rect.height / 2;
	    } else if (y === _VerticalAnchors2.default.TOP) {
	      top = rect.top - offsetHeight;
	    } else if (y === _VerticalAnchors2.default.CENTER) {
	      top = rect.top + rect.height / 2;
	    } else if (y === _VerticalAnchors2.default.BOTTOM) {
	      top = rect.bottom;
	    }
	
	    if (_this4._isCenteredDialog()) {
	      var dialogRect = _this4._dialog.getBoundingClientRect();
	      left -= dialogRect.left;
	      top -= dialogRect.top;
	    }
	
	    var style = {};
	    if (top) {
	      style.top = top;
	    }
	
	    if (left) {
	      style.left = left;
	    }
	
	    return style;
	  };
	
	  this._manageFixedToListener = function (fixedTo, add) {
	    var listener = (add ? 'add' : 'remove') + 'EventListener';
	    if (fixedTo !== window && (fixedTo.x || fixedTo.y)) {
	      var x = fixedTo.x,
	          y = fixedTo.y;
	
	      if (x) {
	        x[listener]('scroll', _this4._handleScroll);
	      } else {
	        window[listener]('scroll', _this4._handleScroll);
	      }
	
	      if (y) {
	        y[listener]('scroll', _this4._handleScroll);
	      } else if (!x) {
	        // Only add the window event listener once
	        window[listener]('scroll', _this4._handleScroll);
	      }
	
	      if (y && y !== window && x && x !== window) {
	        window[listener]('scroll', _this4._handleScroll);
	      }
	    } else {
	      fixedTo[listener]('scroll', _this4._handleScroll);
	
	      if (fixedTo !== window) {
	        window[listener]('scroll', _this4._handleScroll);
	      }
	    }
	  };
	
	  this._manageWindowResizeListener = function (enabled) {
	    if (_this4._windowResizeTimeout) {
	      clearTimeout(_this4._windowResizeTimeout);
	      _this4._windowResizeTimeout = null;
	    }
	
	    if (enabled) {
	      // add a 2 second delay before watching resize events since Android soft keyboards trigger a resize event.
	      _this4._windowResizeTimeout = setTimeout(function () {
	        _this4._windowResizeTimeout = null;
	        window.addEventListener('resize', _this4._handleWindowResize);
	      }, 2000);
	    } else {
	      window.removeEventListener('resize', _this4._handleWindowResize);
	    }
	  };
	
	  this._mergeStyles = function (style) {
	    var _props4 = _this4.props,
	        minLeft = _props4.minLeft,
	        minRight = _props4.minRight,
	        minBottom = _props4.minBottom,
	        fillViewportWidth = _props4.fillViewportWidth,
	        fillViewportHeight = _props4.fillViewportHeight;
	
	    if (fillViewportWidth) {
	      style.left = minLeft;
	      style.right = minRight;
	    } else {
	      if (style.left) {
	        style.left = Math.max(minLeft, style.left);
	      }
	
	      if (style.right) {
	        style.right = Math.max(minRight, style.right);
	      }
	    }
	
	    if (fillViewportHeight) {
	      style.bottom = minBottom;
	      style.maxHeight = 'none';
	    } else {
	      // These styles are only created when filling the viewport height, so clear
	      // them out again
	      style.bottom = null;
	      style.maxHeight = null;
	    }
	
	    return _extends({}, _this4.state.styles, style, _react2.default.Children.only(_this4.props.children).props.style);
	  };
	
	  this._init = function (fixedTo, anchor, sameWidth, centered, rect) {
	    if (_this4._child) {
	      // The init function can be called again if the user quickly toggles the layover. If that
	      // is the case, we want the styles that were set after the _positionChild _attemptFix.
	      return;
	    }
	
	    var height = rect.height,
	        width = rect.width;
	    var top = rect.top,
	        left = rect.left,
	        right = rect.right;
	
	    var x = void 0;
	    var y = void 0;
	    if (_this4._dialog) {
	      var scroll = (0, _getScroll2.default)(_this4._dialog);
	      x = scroll.x;
	      y = scroll.y;
	
	      if (_this4._isCenteredDialog()) {
	        var dialogRect = _this4._dialog.getBoundingClientRect();
	        left -= dialogRect.left;
	        top -= dialogRect.top;
	        right -= dialogRect.right;
	      }
	    } else if (fixedTo !== window && (fixedTo.y || fixedTo.x)) {
	      x = (0, _getScroll2.default)(fixedTo.x || window).x;
	      y = (0, _getScroll2.default)(fixedTo.y || window).y;
	    } else {
	      var _scroll = (0, _getScroll2.default)(fixedTo);
	      x = _scroll.x;
	      y = _scroll.y;
	    }
	
	    _this4._initialX = x;
	    _this4._initialY = y;
	    _this4._initialLeft = left;
	    _this4._initialTop = top;
	
	    if (anchor.x === _HorizontalAnchors2.default.INNER_RIGHT) {
	      _this4._initialLeft = left + width;
	    } else if (anchor.x === _HorizontalAnchors2.default.RIGHT) {
	      _this4._initialLeft = right;
	    }
	
	    if (!centered) {
	      _this4._lastYFix = anchor.y === _VerticalAnchors2.default.TOP ? 'bottom' : 'top';
	    } else {
	      // Centered is not fixable
	      _this4._lastYFix = null;
	    }
	    if (anchor.x === _HorizontalAnchors2.default.LEFT || anchor.x === _HorizontalAnchors2.default.INNER_LEFT) {
	      _this4._lastXFix = 'right';
	    } else if (anchor.x === _HorizontalAnchors2.default.RIGHT || anchor.x === _HorizontalAnchors2.default.INNER_RIGHT) {
	      _this4._lastXFix = 'left';
	    } else {
	      // Can't fix others
	      _this4._lastXFix = null;
	    }
	
	    if (anchor.y === _VerticalAnchors2.default.BOTTOM) {
	      _this4._initialTop = top + height;
	    }
	
	    if (fixedTo !== window && !fixedTo.y && !fixedTo.x) {
	      var _scroll2 = (0, _getScroll2.default)(window);
	      _this4._initialWinX = _scroll2.x;
	      _this4._initialWinY = _scroll2.y;
	    }
	
	    var styles = _this4._mergeStyles({
	      left: _this4._initialLeft,
	      top: _this4._initialTop,
	      transformOrigin: undefined,
	      width: sameWidth ? width : undefined
	    });
	
	    _this4.setState({ styles: styles });
	  };
	
	  this._reset = function () {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this4.props,
	        fixedTo = _ref2.fixedTo;
	
	    // Reset all the bookkeeping variables for a fresh start on re-visible
	    _this4._lastXFix = null;
	    _this4._lastYFix = null;
	    _this4._initialX = null;
	    _this4._initialY = null;
	    _this4._initialTop = null;
	    _this4._initialLeft = null;
	
	    if (!_this4._inFixed) {
	      if (_this4._dialog) {
	        _this4._manageFixedToListener(_this4._dialog, false);
	      }
	
	      _this4._manageFixedToListener(fixedTo, false);
	    }
	  };
	
	  this._setContainer = function (container) {
	    _this4._container = (0, _reactDom.findDOMNode)(container);
	    _this4._toggle = null;
	    if (!_this4._container) {
	      return;
	    }
	
	    var _props5 = _this4.props,
	        toggleQuery = _props5.toggleQuery,
	        onContextMenu = _props5.onContextMenu;
	
	    if (typeof toggleQuery === 'function') {
	      _this4._toggle = toggleQuery();
	    } else if (typeof toggleQuery === 'string') {
	      _this4._toggle = _this4._container.querySelector(toggleQuery);
	    } else {
	      _this4._toggle = toggleQuery;
	    }
	
	    if (!_this4._toggle && !onContextMenu && ("production") !== 'production') {
	      var error = new Error('Unable to find a toggle component with the provided `toggleQuery` and `toggle` element. \n' + ('`toggleQuery`: `' + toggleQuery + '`'));
	      error.toggleQuery = toggleQuery;
	      error.toggle = _this4.props.toggle;
	
	      throw error;
	    }
	
	    var node = _this4._container;
	    while (node) {
	      var fixed = window.getComputedStyle(node).position === 'fixed';
	      if (fixed && node.className.match(/md-dialog--(full-page|centered)/)) {
	        _this4._dialog = node;
	        return;
	      } else if (fixed && !node.classList.contains('md-layover-child')) {
	        _this4._inFixed = true;
	        return;
	      }
	
	      node = node.offsetParent;
	    }
	  };
	
	  this._initialFix = function () {
	    // Need to make a clone that disables any transitions to calculate positioning stuff
	    var clone = _this4._child.cloneNode(true);
	    clone.style.webkitTransform = 'none';
	    clone.style.transfrom = 'none';
	    clone.style.webkitTransition = 'none';
	    clone.style.transition = 'none';
	
	    _this4._child.parentNode.appendChild(clone);
	    var vp = (0, _viewport2.default)(clone);
	    var childHeight = clone.offsetHeight,
	        childWidth = clone.offsetWidth;
	
	    _this4._child.parentNode.removeChild(clone);
	
	    if (vp === true || !_this4._toggle || !_this4._child) {
	      return;
	    }
	
	    var _getAnchor2 = _this4._getAnchor(_this4.props),
	        x = _getAnchor2.x,
	        y = _getAnchor2.y;
	
	    var toggleHeight = void 0;
	    var toggleWidth = void 0;
	    if (_this4._contextRect) {
	      toggleHeight = _this4._contextRect.height;
	      toggleWidth = _this4._contextRect.width;
	    } else {
	      toggleHeight = _this4._toggle.offsetHeight;
	      toggleWidth = _this4._toggle.offsetWidth;
	    }
	
	    var addToTop = 0;
	    var addToLeft = 0;
	
	    // Android devices will never get this far because they consider the keyboard as part
	    // of the viewport, iOS will and cause it to be a giant negative number. *sigh*
	    // Prevent any additional vertical positioning for iOS
	    if (!_this4.props.fillViewportHeight && (!vp.top || !vp.bottom)) {
	      var multiplier = vp.top ? -1 : 1;
	      if (!vp.bottom && y === _VerticalAnchors2.default.OVERLAP) {
	        addToTop += toggleHeight;
	      } else if (y === _VerticalAnchors2.default.TOP || y === _VerticalAnchors2.default.BOTTOM) {
	        addToTop += multiplier * toggleHeight;
	      }
	
	      addToTop += multiplier * childHeight;
	
	      _this4._lastYFix = vp.top ? 'bottom' : 'top';
	    }
	
	    if (!_this4.props.fillViewportWidth && x !== _HorizontalAnchors2.default.CENTER && (!vp.left || !vp.right)) {
	      if (!vp.left && x === _HorizontalAnchors2.default.LEFT) {
	        addToLeft += toggleWidth + childWidth;
	        _this4._lastXFix = 'left';
	      } else if (!vp.left && x === _HorizontalAnchors2.default.INNER_LEFT) {
	        addToLeft += toggleWidth;
	        _this4._lastXFix = 'left';
	      } else if (!vp.right && x === _HorizontalAnchors2.default.RIGHT) {
	        addToLeft -= toggleWidth + childWidth;
	        _this4._lastXFix = 'right';
	      } else if (!vp.right && x === _HorizontalAnchors2.default.INNER_RIGHT) {
	        addToLeft -= toggleWidth;
	        _this4._lastXFix = 'right';
	      }
	    }
	
	    if (addToTop !== 0 || addToLeft !== 0) {
	      _this4._initialTop += addToTop;
	      _this4._initialLeft += addToLeft;
	
	      _this4.setState({ styles: _this4._mergeStyles({ top: _this4._initialTop, left: _this4._initialLeft }) });
	    }
	  };
	
	  this._fixateChild = function (child) {
	    _this4._child = (0, _reactDom.findDOMNode)(child);
	
	    if (_this4._child !== null) {
	      _this4._childComponent = _react2.default.Children.only(_this4.props.children);
	
	      // If child also has a ref callback, simulate the same thing
	      if (typeof _this4._childComponent.ref === 'function') {
	        _this4._childComponent.ref(child);
	      }
	
	      if (_this4.props.simplified || !_this4._child || !_this4._toggle && !_this4._contextRect) {
	        return;
	      }
	
	      if (_this4._dialog && _this4._dialog.classList.contains('md-dialog--centered')) {
	        return;
	      }
	
	      _this4._manageWindowResizeListener(true);
	      _this4._positionChild();
	    } else if (_this4._childComponent && typeof _this4._childComponent.ref === 'function') {
	      _this4._childComponent.ref(child);
	    }
	  };
	
	  this._positionChild = function () {
	    var centered = _this4.props.centered;
	
	    var anchor = _this4._getAnchor(_this4.props);
	    var rect = _this4._contextRect || _this4._toggle.getBoundingClientRect();
	    _this4._height = rect.height;
	    _this4._width = rect.width;
	    var styles = _this4._createStyles(anchor, centered, _this4._child, rect);
	    if (styles.top || styles.left) {
	      _this4._initialLeft = styles.left || _this4._initialLeft;
	      _this4._initialTop = styles.top || _this4._initialTop;
	      _this4.setState({ styles: _this4._mergeStyles(styles) }, _this4._initialFix);
	    } else {
	      _this4._initialFix();
	    }
	  };
	
	  this._handleResize = function () {
	    if (_this4.props.visible) {
	      _this4._positionChild();
	    }
	  };
	
	  this._handleScroll = function (e) {
	    if (!_this4.props.repositionOnScroll) {
	      _this4._manageFixedToListener(_this4.props.fixedTo, false);
	      _this4.props.onClose(e);
	    }
	
	    if (!_this4._ticking) {
	      requestAnimationFrame(function () {
	        return _this4._handleTick(e);
	      });
	    }
	
	    _this4._ticking = true;
	  };
	
	  this._handleTick = function (e) {
	    var _props6 = _this4.props,
	        fixedTo = _props6.fixedTo,
	        xThreshold = _props6.xThreshold,
	        yThreshold = _props6.yThreshold;
	
	    var vp = (0, _viewport2.default)(_this4._child);
	    if (vp !== true && vp.left && vp.right) {
	      var fixed = !_this4._contextRect && _this4._attemptFix(vp);
	      if (!fixed) {
	        _this4.props.onClose(e);
	        _this4._ticking = false;
	      }
	
	      return;
	    } else if ((0, _isOutOfBounds2.default)(fixedTo, _this4._child, _this4._toggle, yThreshold, xThreshold)) {
	      _this4.props.onClose(e);
	      _this4._ticking = false;
	      return;
	    }
	
	    var x = void 0;
	    var y = void 0;
	    if (_this4._dialog) {
	      var scroll = (0, _getScroll2.default)(_this4._dialog);
	      x = scroll.x;
	      y = scroll.y;
	    } else if (fixedTo !== window && (fixedTo.x || fixedTo.y)) {
	      x = (0, _getScroll2.default)(fixedTo.x || window).x;
	      y = (0, _getScroll2.default)(fixedTo.y || window).y;
	    } else {
	      var _scroll3 = (0, _getScroll2.default)(fixedTo);
	      x = _scroll3.x;
	      y = _scroll3.y;
	    }
	
	    var winX = void 0;
	    var winY = void 0;
	    // When using the additional fixedTo stuff, need to also keep track of the entire
	    // window's scrolling..
	    if (fixedTo !== window && !fixedTo.x && !fixedTo.y) {
	      var _scroll4 = (0, _getScroll2.default)(window);
	      winX = _scroll4.x;
	      winY = _scroll4.y;
	    }
	
	    var styles = _this4.state.styles;
	    var left = styles.left,
	        top = styles.top;
	
	    if (_this4._initialX !== x) {
	      left = _this4._initialX - x + _this4._initialLeft;
	    }
	
	    if (winX && _this4._initialWinX !== winX) {
	      left = _this4._initialWinX - winX + _this4._initialX;
	    }
	
	    if (_this4._initialY !== y) {
	      top = _this4._initialY - y + _this4._initialTop;
	    }
	
	    if (winY && _this4._initialWinY !== winY) {
	      top = _this4._initialWinY - winY + _this4._initialTop + (_this4._initialY - y);
	    }
	
	    if (styles.top !== top || styles.left !== left) {
	      _this4.setState({ styles: _this4._mergeStyles({ left: left, top: top }) }, function () {
	        _this4._ticking = false;
	      });
	    } else {
	      _this4._ticking = false;
	    }
	  };
	
	  this._handleOutsideClick = function (e) {
	    if (_this4._contextRect && _this4._child && !_this4._child.contains(e.target) || _this4._container && !_this4._container.contains(e.target)) {
	      _this4.props.onClose(e);
	    }
	  };
	
	  this._handleWindowResize = function (e) {
	    var _props7 = _this4.props,
	        onClose = _props7.onClose,
	        repositionOnResize = _props7.repositionOnResize;
	
	    if (repositionOnResize) {
	      _this4._handleResize();
	    } else {
	      onClose(e);
	      _this4._manageWindowResizeListener(false);
	    }
	  };
	
	  this._attemptFix = function (vp) {
	    var _getAnchor3 = _this4._getAnchor(_this4.props),
	        x = _getAnchor3.x,
	        y = _getAnchor3.y;
	
	    var centered = x === _HorizontalAnchors2.default.CENTER && y === _VerticalAnchors2.default.CENTER && _this4.props.centered;
	    if (centered || _this4._lastYFix === 'top' && !vp.top || _this4._lastYFix === 'bottom' && !vp.bottom) {
	      return false;
	    }
	
	    var toggleTop = _this4._toggle.getBoundingClientRect().top;
	    var toggleHeight = _this4._toggle.offsetHeight;
	    var childHeight = _this4._child.offsetHeight;
	
	    // Can;t fix if the child can't fit on the page based on the toggle's position
	
	    if (toggleTop + toggleHeight + childHeight > window.innerHeight) {
	      return false;
	    }
	
	    var _child$getBoundingCli = _this4._child.getBoundingClientRect(),
	        top = _child$getBoundingCli.top;
	
	    var newTop = _this4._initialTop;
	    var addToTop = childHeight * (vp.top ? -1 : 1);
	    if (y === _VerticalAnchors2.default.OVERLAP) {
	      addToTop += (vp.top ? 1 : -1) * toggleHeight;
	    } else if (y === _VerticalAnchors2.default.TOP || y === _VerticalAnchors2.default.BOTTOM) {
	      addToTop += (_this4._lastYFix === 'top' ? -1 : 1) * toggleHeight;
	    }
	
	    if (addToTop !== 0) {
	      newTop = top + addToTop;
	      _this4._lastYFix = vp.top ? 'bottom' : 'top';
	    }
	
	    if (newTop !== _this4._initialTop) {
	      _this4._initialTop = newTop;
	      var fixedTo = _this4.props.fixedTo;
	
	      var scrollEl = fixedTo;
	      if (fixedTo !== window && (fixedTo.y || fixedTo.x)) {
	        scrollEl = fixedTo.y || window;
	      }
	
	      _this4._initialY = (0, _getScroll2.default)(scrollEl).y;
	
	      _this4.setState({ styles: _this4._mergeStyles({ top: _this4._initialTop }) }, function () {
	        _this4._ticking = false;
	      });
	      return true;
	    }
	
	    return false;
	  };
	
	  this._handleContextMenu = function (e) {
	    var anchor = _this4._getAnchor(_this4.props);
	    var _props8 = _this4.props,
	        onContextMenu = _props8.onContextMenu,
	        preventContextMenu = _props8.preventContextMenu,
	        fixedTo = _props8.fixedTo,
	        sameWidth = _props8.sameWidth,
	        centered = _props8.centered,
	        visible = _props8.visible;
	
	    if (!onContextMenu) {
	      return;
	    }
	
	    _this4._contextRect = (0, _getSelectedTextPosition2.default)(e);
	    if (preventContextMenu && (!_this4._child || !_this4._child.contains(e.target))) {
	      e.preventDefault();
	    }
	
	    onContextMenu(e);
	    if (visible) {
	      _this4._init(fixedTo, anchor, sameWidth, centered, _this4._contextRect);
	    }
	  };
	};
	
	exports.default = Layover;
	//# sourceMappingURL=Layover.js.map

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _themeColors = __webpack_require__(12);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _getCollapserStyles = __webpack_require__(114);
	
	var _getCollapserStyles2 = _interopRequireDefault(_getCollapserStyles);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _controlled = __webpack_require__(16);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _keyCodes = __webpack_require__(15);
	
	var _anchorShape = __webpack_require__(38);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(22);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _AccessibleFakeInkedButton = __webpack_require__(29);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	var _Collapse = __webpack_require__(46);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _FontIcon = __webpack_require__(13);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(21);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _TileAddon = __webpack_require__(172);
	
	var _TileAddon2 = _interopRequireDefault(_TileAddon);
	
	var _ListItemText = __webpack_require__(277);
	
	var _ListItemText2 = _interopRequireDefault(_ListItemText);
	
	var _List = __webpack_require__(81);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Menu = __webpack_require__(63);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `ListItem` component is used for rendering a `li` tag with text and optional
	 * icons/avatars.
	 */
	var ListItem = function (_PureComponent) {
	  _inherits(ListItem, _PureComponent);
	
	  function ListItem(props) {
	    _classCallCheck(this, ListItem);
	
	    var _this = _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = { active: false };
	
	    if (typeof props.isOpen === 'undefined' && typeof props.visible === 'undefined') {
	      var defined = function defined(v) {
	        return typeof v !== 'undefined';
	      };
	      var _this$props = _this.props,
	          initiallyOpen = _this$props.initiallyOpen,
	          defaultOpen = _this$props.defaultOpen,
	          defaultVisible = _this$props.defaultVisible;
	
	      var visible = defined(initiallyOpen) ? initiallyOpen : defaultVisible;
	      visible = defined(defaultOpen) ? defaultOpen : visible;
	      visible = !!visible;
	
	      _this.state.visible = visible;
	    }
	    return _this;
	  }
	
	  _createClass(ListItem, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.active) {
	        window.removeEventListener('click', this._handleOutsideClick);
	      }
	
	      if (this._touchTimeout) {
	        clearTimeout(this._touchTimeout);
	      }
	    }
	
	    /**
	     * A utility function to focus the `AccessibleFakeInkedButton` in the `ListItem` and also
	     * inject an ink to indicate focus.
	     */
	
	
	    /**
	     * A utility function to blur the `AccessibleFakeInkedButton` in the `ListItem`.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          tileStyle = _props.tileStyle,
	          tileClassName = _props.tileClassName,
	          contentStyle = _props.contentStyle,
	          contentClassName = _props.contentClassName,
	          leftNodeStyle = _props.leftNodeStyle,
	          leftNodeClassName = _props.leftNodeClassName,
	          rightNodeStyle = _props.rightNodeStyle,
	          rightNodeClassName = _props.rightNodeClassName,
	          primaryTextStyle = _props.primaryTextStyle,
	          primaryTextClassName = _props.primaryTextClassName,
	          secondaryTextStyle = _props.secondaryTextStyle,
	          secondaryTextClassName = _props.secondaryTextClassName,
	          nestedListStyle = _props.nestedListStyle,
	          nestedListClassName = _props.nestedListClassName,
	          nestedListHeightRestricted = _props.nestedListHeightRestricted,
	          disabled = _props.disabled,
	          leftIcon = _props.leftIcon,
	          leftAvatar = _props.leftAvatar,
	          inset = _props.inset,
	          rightIcon = _props.rightIcon,
	          rightAvatar = _props.rightAvatar,
	          primaryText = _props.primaryText,
	          secondaryText = _props.secondaryText,
	          threeLines = _props.threeLines,
	          children = _props.children,
	          nestedItems = _props.nestedItems,
	          prependNested = _props.prependNested,
	          active = _props.active,
	          activeClassName = _props.activeClassName,
	          activeBoxStyle = _props.activeBoxStyle,
	          activeBoxClassName = _props.activeBoxClassName,
	          animateNestedItems = _props.animateNestedItems,
	          expanderIcon = _props.expanderIcon,
	          expanderLeft = _props.expanderLeft,
	          component = _props.component,
	          ItemComponent = _props.itemComponent,
	          itemProps = _props.itemProps,
	          tileProps = _props.tileProps,
	          passPropsToItem = _props.passPropsToItem,
	          ariaSize = _props['aria-setsize'],
	          ariaPos = _props['aria-posinset'],
	          isOpen = _props.isOpen,
	          expanderIconChildren = _props.expanderIconChildren,
	          expanderIconClassName = _props.expanderIconClassName,
	          propVisible = _props.visible,
	          defaultVisible = _props.defaultVisible,
	          itemRef = _props.itemRef,
	          defaultOpen = _props.defaultOpen,
	          initiallyOpen = _props.initiallyOpen,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'tileStyle', 'tileClassName', 'contentStyle', 'contentClassName', 'leftNodeStyle', 'leftNodeClassName', 'rightNodeStyle', 'rightNodeClassName', 'primaryTextStyle', 'primaryTextClassName', 'secondaryTextStyle', 'secondaryTextClassName', 'nestedListStyle', 'nestedListClassName', 'nestedListHeightRestricted', 'disabled', 'leftIcon', 'leftAvatar', 'inset', 'rightIcon', 'rightAvatar', 'primaryText', 'secondaryText', 'threeLines', 'children', 'nestedItems', 'prependNested', 'active', 'activeClassName', 'activeBoxStyle', 'activeBoxClassName', 'animateNestedItems', 'expanderIcon', 'expanderLeft', 'component', 'itemComponent', 'itemProps', 'tileProps', 'passPropsToItem', 'aria-setsize', 'aria-posinset', 'isOpen', 'expanderIconChildren', 'expanderIconClassName', 'visible', 'defaultVisible', 'itemRef', 'defaultOpen', 'initiallyOpen']);
	
	      var _context = this.context,
	          cascadingId = _context.cascadingId,
	          cascadingMenu = _context.cascadingMenu,
	          cascadingAnchor = _context.cascadingAnchor,
	          cascadingFixedTo = _context.cascadingFixedTo;
	
	      var visible = (0, _getField2.default)(this.props, this.state, 'visible');
	      if (typeof isOpen !== 'undefined') {
	        visible = isOpen;
	      }
	
	      var leftNode = _react2.default.createElement(_TileAddon2.default, {
	        key: 'left-addon',
	        style: leftNodeStyle,
	        className: leftNodeClassName,
	        active: active,
	        activeClassName: activeClassName,
	        icon: leftIcon,
	        avatar: leftAvatar
	      });
	
	      var rightNode = _react2.default.createElement(_TileAddon2.default, {
	        key: 'right-addon',
	        style: rightNodeStyle,
	        className: rightNodeClassName,
	        active: active,
	        activeClassName: activeClassName,
	        icon: rightIcon,
	        avatar: rightAvatar
	      });
	
	      var nestedList = void 0;
	      if (nestedItems) {
	        if (!cascadingMenu) {
	          nestedList = _react2.default.createElement(
	            _Collapse2.default,
	            { collapsed: !visible, animate: animateNestedItems },
	            _react2.default.createElement(
	              _List2.default,
	              { style: nestedListStyle, className: nestedListClassName },
	              nestedItems
	            )
	          );
	        }
	
	        var icon = _react2.default.Children.only((0, _getDeprecatedIcon2.default)(expanderIconClassName, expanderIconChildren, expanderIcon));
	        var collapser = _react2.default.createElement(_TileAddon2.default, {
	          key: 'expander-addon',
	          icon: _react2.default.cloneElement(icon, {
	            className: (0, _getCollapserStyles2.default)({ flipped: visible }, icon.props.className)
	          }),
	          avatar: null
	        });
	
	        if (expanderLeft) {
	          if (!leftIcon && !leftAvatar) {
	            leftNode = collapser;
	          }
	        } else if (!rightIcon && !rightAvatar) {
	          rightNode = collapser;
	        }
	      }
	
	      var icond = !!leftIcon || !!rightIcon || !!nestedItems;
	      var avatard = !!leftAvatar || !!rightAvatar;
	
	      var tile = _react2.default.createElement(
	        _AccessibleFakeInkedButton2.default,
	        _extends({}, tileProps, passPropsToItem ? undefined : props, {
	          component: component,
	          __SUPER_SECRET_REF__: this._setTile,
	          key: 'tile',
	          onClick: this._handleClick,
	          onMouseOver: this._handleMouseOver,
	          onMouseLeave: this._handleMouseLeave,
	          onTouchStart: this._handleTouchStart,
	          onTouchEnd: this._handleTouchEnd,
	          onKeyDown: this._handleKeyDown,
	          onKeyUp: this._handleKeyUp,
	          disabled: disabled,
	          style: tileStyle,
	          className: (0, _classnames2.default)('md-list-tile', {
	            'md-list-tile--active': this.state.active && !this._touched,
	            'md-list-tile--icon': !secondaryText && icond && !avatard,
	            'md-list-tile--avatar': !secondaryText && avatard,
	            'md-list-tile--two-lines': secondaryText && !threeLines,
	            'md-list-tile--three-lines': secondaryText && threeLines,
	            'md-list-item--inset': inset && !leftIcon && !leftAvatar
	          }, (0, _themeColors2.default)({ disabled: disabled, text: true }), tileClassName),
	          'aria-expanded': nestedList && !cascadingMenu ? visible : null
	        }),
	        leftNode,
	        _react2.default.createElement(_ListItemText2.default, {
	          active: active,
	          activeClassName: activeClassName,
	          disabled: disabled,
	          primaryText: primaryText,
	          secondaryText: secondaryText,
	          threeLines: threeLines,
	          style: contentStyle,
	          className: (0, _classnames2.default)({
	            'md-tile-content--left-icon': leftIcon || expanderLeft && nestedItems,
	            'md-tile-content--left-avatar': leftAvatar,
	            'md-tile-content--right-padding': rightIcon || rightAvatar
	          }, contentClassName),
	          primaryTextStyle: primaryTextStyle,
	          primaryTextClassName: primaryTextClassName,
	          secondaryTextStyle: secondaryTextStyle,
	          secondaryTextClassName: secondaryTextClassName
	        }),
	        rightNode,
	        children
	      );
	
	      var sharedProps = _extends({}, itemProps, passPropsToItem ? props : undefined, {
	        style: Object.assign({}, style, active ? activeBoxStyle : null),
	        className: (0, _classnames2.default)('md-list-item', _defineProperty({
	          'md-list-item--nested-container': nestedItems
	        }, activeBoxClassName, active), className),
	        'aria-setsize': ariaSize,
	        'aria-posinset': ariaPos,
	        ref: this._setContainer
	      });
	      if (cascadingMenu && nestedItems) {
	        return _react2.default.createElement(
	          _Menu2.default,
	          _extends({
	            id: cascadingId,
	            visible: visible,
	            onClose: this._handleClick,
	            toggle: tile,
	            block: true,
	            simplified: false,
	            anchor: cascadingAnchor,
	            belowAnchor: null,
	            position: _Menu2.default.Positions.BELOW,
	            component: ItemComponent,
	            listStyle: nestedListStyle,
	            listClassName: nestedListClassName,
	            listHeightRestricted: nestedListHeightRestricted
	          }, sharedProps, {
	            fixedTo: cascadingFixedTo
	          }),
	          nestedItems
	        );
	      }
	
	      return _react2.default.createElement(
	        ItemComponent,
	        sharedProps,
	        prependNested ? nestedList : null,
	        tile,
	        prependNested ? null : nestedList
	      );
	    }
	  }]);
	
	  return ListItem;
	}(_react.PureComponent);
	
	ListItem.propTypes = {
	  /**
	   * An optional style to apply to the `li` tag.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `li` tag.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `.md-list-tile`.
	   *
	   * @see {@link #component}
	   */
	  tileStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `.md-list-tile`.
	   *
	   * @see {@link #component}
	   */
	  tileClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the div that surrounds the `primaryText` and `secondaryText`
	   * nodes.
	   */
	  contentStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the div that surrounds the `primaryText` and `secondaryText`
	   * nodes.
	   */
	  contentClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the element that is rendered before content node.
	   */
	  leftNodeStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the element that is rendered before content node.
	   */
	  leftNodeClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the element that is rendered after content node.
	   */
	  rightNodeStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the element that is rendered after content node.
	   */
	  rightNodeClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the div surrounding the `primaryText`.
	   */
	  primaryTextStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the div surrounding the `primaryText`.
	   */
	  primaryTextClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the div surrounding the `secondaryText`.
	   */
	  secondaryTextStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the div surrounding the `secondaryText`.
	   */
	  secondaryTextClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the nested `List` that gets created when using `nestedItems`.
	   */
	  nestedListStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the nested `List` that gets created when using `nestedItems`.
	   */
	  nestedListClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the nested `List` in a cascading menu should be restricted.
	   */
	  nestedListHeightRestricted: _propTypes2.default.bool,
	
	  /**
	   * Any additional children to display in the `.md-list-tile`. If you use this prop,
	   * you will most likely need to override the `height` for the `.md-list-tile--icon`,
	   * `.md-list-tile--avatar`, `.md-list-tile--two-lines`, and/or `.md-list-tile--three-lines`
	   * to get it to display correctly unless the children are positioned `absolute`.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the `ListItem` is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional tab index for the `.md-list-tile`. If omitted, it will default to the
	   * `AccessibleFakeButton`'s `tabIndex` default prop value.
	   */
	  tabIndex: _propTypes2.default.number,
	
	  /**
	   * The primary text to display. This will only be rendered as a single line. Any overflown
	   * text will be converted to ellipsis.
	   */
	  primaryText: _propTypes2.default.node.isRequired,
	
	  /**
	   * An optional secondary text to display below the `primaryText`. This can be an additional
	   * one or two lines. Like the `primaryText`, and overflown text will be converted to ellipsis.
	   *
	   * You must set the `threeLines` prop to `true` if you want this to be displayed as two lines.
	   */
	  secondaryText: _propTypes2.default.node,
	
	  /**
	   * An optional `FontIcon` to display to the left of the text.
	   */
	  leftIcon: _propTypes2.default.node,
	
	  /**
	   * An optional `Avatar` to display to the left of the text. If you have a mixed `List` of
	   * `FontIcon` and `Avatar`, it is recommended to set the `iconSized` prop on the `Avatar` to
	   * `true` so that the `Avatar` will be scaled down to the `FontIcon` size.
	   */
	  leftAvatar: _propTypes2.default.node,
	
	  /**
	   * An optional `FontIcon` to display to the right of the text.
	   */
	  rightIcon: _propTypes2.default.node,
	
	  /**
	   * An optional `Avatar` to display to the right of the text. If you have a mixed `List` of
	   * `FontIcon` and `Avatar`, it is recommended to set the `iconSized` prop on the `Avatar` to
	   * `true` so that the `Avatar` will be scaled down to the `FontIcon` size.
	   */
	  rightAvatar: _propTypes2.default.node,
	
	  /**
	   * Boolean if the list item should be inset as if there is a `leftIcon` or a `leftAvatar`.
	   * This is used for some lists where only a parent contains the icon.
	   */
	  inset: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `secondaryText` should span two lines instead of one. This will include
	   * three lines of text in total when including the `primaryText`.
	   */
	  threeLines: _propTypes2.default.bool,
	
	  /**
	   * The component to render the `.md-list-tile` as. This is mostly useful if you
	   * want to use the `ListItem` for navigation and working with the `react-router`'s `Link`
	   * component.
	   *
	   * This prop is **not** the top-most element of the `ListItem` component. To change the
	   * top-most element, see the `itemComponent` prop.
	   *
	   * @see {@link #itemComponent}
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * The component to render the top-most element of the `ListItem` component. This is the
	   * `.md-list-item` and defaults to the `<li>` element.
	   *
	   * @see {@link #component}
	   * @see {@link #itemProps}
	   */
	  itemComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * An optional ref callback to get reference to the top-most element of the `ListItem` component.
	   * Just like other refs, this will provide null when it unmounts.
	   */
	  itemRef: _propTypes2.default.func,
	
	  /**
	   * An optional list of `ListItem`, `ListItemControl`, `Divider`, or `Subheader` components
	   * to render in a nested list. This will inject an expander icon to the right of the text
	   * in the `.md-list-tile` that rotates 180 degrees when open.
	   *
	   * The nested items will be visible once the user clicks on the `ListItem`.
	   *
	   * @see {@link #visible}
	   */
	  nestedItems: _propTypes2.default.arrayOf(_propTypes2.default.node),
	
	  /**
	   * An optional parameter determining whether `nestedItems` should be placed before or after `ListItemText`
	   */
	  prependNested: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `nestedItems` are visible by default.
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `nestedItems` are visible. This will make the `nestedItems` controlled
	   * and require the `onClick` function to be defined.
	   *
	   * @see {@link #defaultVisible}
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onClick', 'defaultVisible'),
	
	  /**
	   * An icon to use for the expander icon when there are nested items.
	   */
	  expanderIcon: _propTypes2.default.element,
	
	  /**
	   * Boolean if the expander icon should appear as the left icon instead of the right.
	   */
	  expanderLeft: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when the `.md-list-tile` is clicked. This is required if the
	   * `visible` prop is defined.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `.md-list-tile` triggers the `mouseover` event.
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `.md-list-tile` triggers the `mouseleave` event.
	   */
	  onMouseLeave: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `.md-list-tile` triggers the `touchstart` event.
	   */
	  onTouchStart: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `.md-list-tile` triggers the `touchend` event.
	   */
	  onTouchEnd: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `.md-list-tile` triggers the `keydown` event.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `.md-list-tile` triggers the `keyup` event.
	   */
	  onKeyUp: _propTypes2.default.func,
	
	  /**
	   * Boolean if the `ListItem` is currently active. This will apply the `activeClassName` prop
	   * to the `leftIcon`, `rightIcon`, and the `primaryText`.
	   */
	  active: _propTypes2.default.bool,
	
	  /**
	   * The className to apply to the `leftIcon`, `rightIcon`, and `primaryText` when the `active`
	   * prop is `true`.
	   */
	  activeClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the top-most element of the `ListItem` component (`.md-list-item`)
	   * when the `active` prop is `true`.
	   */
	  activeBoxStyle: _propTypes2.default.object,
	
	  /**
	   * The className to apply to the top-most element of the `ListItem` component (`.md-list-item`)
	   * when the `active` prop is `true`.
	   */
	  activeBoxClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the nested items should animate when they appear or disappear.
	   */
	  animateNestedItems: _propTypes2.default.bool,
	
	  /**
	   * Defines the number of items in the list. This is only required when all items in the
	   * list are not present in the DOM.
	   *
	   * @see https://www.w3.org/TR/wai-aria/states_and_properties#aria-setsize
	   */
	  'aria-setsize': _propTypes2.default.number,
	
	  /**
	   * Defines the items position in the list. This is only required when all items in the list
	   * are not present in the DOM. The custom validation just requires this prop if the `aria-setsize`
	   * prop is defined as a helpful reminder.
	   *
	   * @see https://www.w3.org/TR/wai-aria/states_and_properties#aria-posinset
	   */
	  'aria-posinset': function ariaPosinset(props, propName) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    var validator = _propTypes2.default.number;
	    if (typeof props['aria-setsize'] !== 'undefined') {
	      validator = validator.isRequired;
	    }
	
	    return validator.apply(undefined, [props, propName].concat(args));
	  },
	
	  /**
	   * Any additional props you would like to supply to the surrounding `<li>` tag for the `ListItem`.
	   * By default, all props will be provided to the inner `AccessibleFakeButton`. If the `passPropsToItem`
	   * prop is enabled, the remaining props will be provided to the `<li>` tag instead and this prop
	   * is probably useless.
	   */
	  itemProps: _propTypes2.default.object,
	
	  /**
	   * Any additional props you would like to add to the inner `AccessibleFakeButton`. By default, all the
	   * remaining props will be provided to the `AccessibleFakeButton`, so this prop is probably useless.
	   * Enabling the `passPropsToItem` prop will change the default behavior so that the remaining props
	   * are provided to the surrounding `<li>` node instead and this prop becomes useful.
	   */
	  tileProps: _propTypes2.default.object,
	
	  /**
	   * All the remaining props should be passed to the surrounding `<li>` node instead of the `AccessibleFakeButton`.
	   *
	   * > NOTE: This will most likely become the default in the next *major* release. Migration warnings will be added
	   * if that is the case.
	   */
	  passPropsToItem: _propTypes2.default.bool,
	  expanderIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `expanderIcon` instead'),
	  expanderIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `expanderIcon` instead'),
	  initiallyOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
	  defaultOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
	  isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead')
	};
	ListItem.defaultProps = {
	  animateNestedItems: true,
	  activeClassName: 'md-text--theme-primary',
	  component: 'div',
	  itemComponent: 'li',
	  expanderIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'keyboard_arrow_down'
	  )
	};
	ListItem.contextTypes = {
	  cascadingId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  cascadingMenu: _propTypes2.default.bool,
	  cascadingAnchor: _anchorShape2.default,
	  cascadingFixedTo: _fixedToShape2.default
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.focus = function () {
	    if (_this2._tile) {
	      _this2._tile.focus();
	    }
	  };
	
	  this.blur = function () {
	    if (_this2._tile) {
	      _this2._tile.blur();
	    }
	  };
	
	  this._setTile = function (tile) {
	    if (tile) {
	      _this2._tile = tile;
	      _this2._tileNode = (0, _reactDom.findDOMNode)(tile);
	    }
	  };
	
	  this._setContainer = function (container) {
	    var itemRef = _this2.props.itemRef;
	
	    if (container) {
	      _this2._container = (0, _reactDom.findDOMNode)(container);
	    }
	    if (itemRef) {
	      itemRef(container ? _this2._container : null);
	    }
	  };
	
	  this._handleOutsideClick = function (e) {
	    if (_this2._container && !_this2._container.contains(e.target)) {
	      window.removeEventListener('click', _this2._handleOutsideClick);
	      _this2.setState({ active: false });
	    }
	  };
	
	  this._handleClick = function (e) {
	    if (_this2.props.onClick) {
	      _this2.props.onClick(e);
	    }
	
	    if (typeof _this2.state.visible !== 'undefined') {
	      _this2.setState({ visible: !_this2.state.visible });
	    }
	  };
	
	  this._handleMouseOver = function (e) {
	    if (_this2.props.onMouseOver) {
	      _this2.props.onMouseOver(e);
	    }
	
	    if (!_this2.props.disabled) {
	      _this2.setState({ active: true });
	    }
	  };
	
	  this._handleMouseLeave = function (e) {
	    if (_this2.props.onMouseLeave) {
	      _this2.props.onMouseLeave(e);
	    }
	
	    if (!_this2.props.disabled) {
	      _this2.setState({ active: false });
	    }
	  };
	
	  this._handleTouchStart = function (e) {
	    if (_this2.props.onTouchStart) {
	      _this2.props.onTouchStart(e);
	    }
	
	    _this2._touched = true;
	
	    _this2.setState({ active: true, touchedAt: Date.now() });
	  };
	
	  this._handleTouchEnd = function (e) {
	    if (_this2.props.onTouchEnd) {
	      _this2.props.onTouchEnd(e);
	    }
	
	    var time = Date.now() - _this2.state.touchedAt;
	    _this2._touchTimeout = setTimeout(function () {
	      _this2._touchTimeout = null;
	
	      _this2.setState({ active: false });
	    }, time > 450 ? 0 : 450 - time);
	  };
	
	  this._handleKeyUp = function (e) {
	    if (_this2.props.onKeyUp) {
	      _this2.props.onKeyUp(e);
	    }
	
	    if ((e.which || e.keyCode) === _keyCodes.TAB) {
	      window.addEventListener('click', _this2._handleOutsideClick);
	      _this2.setState({ active: true });
	    }
	  };
	
	  this._handleKeyDown = function (e) {
	    if (_this2.props.onKeyDown) {
	      _this2.props.onKeyDown(e);
	    }
	
	    if ((e.which || e.keyCode) === _keyCodes.TAB) {
	      window.removeEventListener('click', _this2._handleOutsideClick);
	      _this2.setState({ active: false });
	    }
	  };
	};
	
	exports.default = ListItem;
	//# sourceMappingURL=ListItem.js.map

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _getDisplayName = __webpack_require__(179);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _TooltipContainer = __webpack_require__(294);
	
	var _TooltipContainer2 = _interopRequireDefault(_TooltipContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Takes any component and injects a tooltip container as a prop. The tooltip container
	 * will add event listeners for touch, mouse, and keyboard events so that a tooltip will appear
	 * in the ComposedComponent.
	 *
	 * If the `tooltipLabel` prop is omitted, the tooltip and event listeners will not
	 * be included.
	 *
	 * ```js
	 * @param {function} ComposedComponent the component to compose with the tooltip functionality.
	 * @return {function} the ComposedComponent with a tooltip.
	 * ```
	 */
	exports.default = function (ComposedComponent) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_PureComponent) {
	    _inherits(TooltipedComponent, _PureComponent);
	
	    function TooltipedComponent() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, TooltipedComponent);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TooltipedComponent.__proto__ || Object.getPrototypeOf(TooltipedComponent)).call.apply(_ref, [this].concat(args))), _this), _this._composed = null, _this.getComposedComponent = function () {
	        return _this._composed;
	      }, _this._setComposedComponent = function (component) {
	        _this._composed = component;
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    /**
	     * Gets the composed component as a ref. This is useful if you need to access the ref of the
	     * composed component instead of the `injectTooltip` HOC to use some publicly accessible methods.
	     *
	     * ```js
	     * <SomeTooltippedComponent
	     *   ref={tooltipHOC => {
	     *     tooltipHOC.getComposedComponent().focus();
	     *   }}
	     * />
	     * ```
	     *
	     * > NOTE: This can be `null`, so make sure to do a null check before using.
	     */
	
	
	    _createClass(TooltipedComponent, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            tooltipLabel = _props.tooltipLabel,
	            tooltipDelay = _props.tooltipDelay,
	            tooltipPosition = _props.tooltipPosition,
	            tooltipStyle = _props.tooltipStyle,
	            tooltipClassName = _props.tooltipClassName,
	            tooltipContainerStyle = _props.tooltipContainerStyle,
	            tooltipContainerClassName = _props.tooltipContainerClassName,
	            tooltipTransitionEnterTimeout = _props.tooltipTransitionEnterTimeout,
	            tooltipTransitionLeaveTimeout = _props.tooltipTransitionLeaveTimeout,
	            props = _objectWithoutProperties(_props, ['tooltipLabel', 'tooltipDelay', 'tooltipPosition', 'tooltipStyle', 'tooltipClassName', 'tooltipContainerStyle', 'tooltipContainerClassName', 'tooltipTransitionEnterTimeout', 'tooltipTransitionLeaveTimeout']);
	
	        if (tooltipLabel) {
	          props.tooltip = _react2.default.createElement(_TooltipContainer2.default, {
	            key: 'tooltipContainer',
	            label: tooltipLabel,
	            delay: tooltipDelay,
	            position: tooltipPosition,
	            enterTimeout: tooltipTransitionEnterTimeout,
	            leaveTimeout: tooltipTransitionLeaveTimeout,
	            style: tooltipContainerStyle,
	            className: tooltipContainerClassName,
	            tooltipStyle: tooltipStyle,
	            tooltipClassName: tooltipClassName
	          });
	        }
	
	        props.ref = this._setComposedComponent;
	
	        return _react2.default.createElement(ComposedComponent, props);
	      }
	    }]);
	
	    return TooltipedComponent;
	  }(_react.PureComponent), _class.displayName = (0, _getDisplayName2.default)(ComposedComponent, 'Tooltip'), _class.propTypes = {
	    /**
	     * An optional style to apply to the tooltip container.
	     */
	    tooltipContainerStyle: _propTypes2.default.object,
	
	    /**
	     * An optional className to apply to the tooltip container.
	     */
	    tooltipContainerClassName: _propTypes2.default.string,
	
	    /**
	     * An optional style to apply to the tooltip itself.
	     */
	    tooltipStyle: _propTypes2.default.object,
	
	    /**
	     * An optional className to the tooltip itself.
	     */
	    tooltipClassName: _propTypes2.default.string,
	
	    /**
	     * The tooltip to display. If omitted, the `tooltip` prop will not be injected.
	     */
	    tooltipLabel: _propTypes2.default.node,
	
	    /**
	     * The amount of delay before the tooltip will appear on hover, touch, or keyboard focus.
	     */
	    tooltipDelay: _TooltipContainer2.default.propTypes.delay,
	
	    /**
	     * The position that the tooltip should appear related to the composed component.
	     */
	    tooltipPosition: _TooltipContainer2.default.propTypes.position,
	
	    /**
	     * The transition time for the tooltip appearing.
	     */
	    tooltipTransitionEnterTimeout: _TooltipContainer2.default.propTypes.enterTimeout,
	
	    /**
	     * The transition time for the tooltip disappearing.
	     */
	    tooltipTransitionLeaveTimeout: _TooltipContainer2.default.propTypes.leaveTimeout
	  }, _temp2;
	};
	//# sourceMappingURL=injectTooltip.js.map

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = handleWindowClickListeners;
	/** @module utils/EventUtils/handleWindowClickListeners */
	var mobileSafari = void 0;
	
	/**
	 * Since mobile safari doesn't delegate click events to the window (it only does touch events),
	 * this utility function will hack a fix to allow the delegation by updaging the body's cursor
	 * to be a pointer.
	 *
	 * Hopefully this can be removed one day....
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile
	 * @param {function} cb - the callback function to use for a window click event.
	 * @param {boolean} enabled - boolean if the click event is enabled.
	 */
	function handleWindowClickListeners(cb) {
	  var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if (typeof mobileSafari === 'undefined' && typeof window !== 'undefined') {
	    var ua = window.navigator.userAgent;
	    var iOS = ua.match(/iP(ad|hone)/i);
	    var webkit = ua.match(/WebKit/i);
	    mobileSafari = iOS && webkit && !ua.match(/CriOS/i);
	
	    if (mobileSafari) {
	      document.body.style.cursor = 'pointer';
	    }
	  }
	
	  var listener = window[(enabled ? 'add' : 'remove') + 'EventListener'];
	  listener('click', cb);
	}
	//# sourceMappingURL=handleWindowClickListeners.js.map

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = oneRequiredForA11y;
	/** @module utils/PropTypes/oneRequiredForA11y */
	
	/**
	 * This validator checks that either the current prop is defined and valid or that one of the
	 * other given prop names are defined. If it fails it returns an error for a11y.
	 *
	 * @param {function} validator - The React PropTypes validator to use for the given prop.
	 * @param {String[]} otherPropNames - Any other prop names to validate against.
	 * @return {Error} an error or null
	 */
	function oneRequiredForA11y(validator) {
	  for (var _len = arguments.length, otherPropNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    otherPropNames[_key - 1] = arguments[_key];
	  }
	
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	    var allPropNames = [propFullNameSafe].concat(otherPropNames);
	
	    for (var _len2 = arguments.length, args = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	      args[_key2 - 5] = arguments[_key2];
	    }
	
	    var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	    if (!err && !allPropNames.filter(function (pn) {
	      return typeof props[pn] !== 'undefined';
	    }).length) {
	      err = new Error('One of the following props are required to make ' + componentNameSafe + ' accessible ' + ('for users of assistive technologies such as screen readers. `' + allPropNames.join('`, `') + '`.'));
	    }
	
	    return err;
	  };
	}
	//# sourceMappingURL=oneRequiredForA11y.js.map

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getCollapserStyles;
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * A simple utility function to get the dynamic collapser styles.
	 */
	function getCollapserStyles(_ref) {
	  var _ref2;
	
	  var flipped = _ref.flipped,
	      suffix = _ref.suffix,
	      suffixFlipped = _ref.suffixFlipped;
	
	  for (var _len = arguments.length, classNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    classNames[_key - 1] = arguments[_key];
	  }
	
	  return _classnames2.default.apply(undefined, ['md-collapser', (_ref2 = {
	    'md-collapser--flipped': flipped && (!suffixFlipped || !suffix)
	  }, _defineProperty(_ref2, 'md-collapser--' + suffix, suffix), _defineProperty(_ref2, 'md-collapser--' + suffix + '-flipped', suffix && flipped && suffixFlipped), _ref2)].concat(classNames));
	}
	//# sourceMappingURL=getCollapserStyles.js.map

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValued;
	/** @module utils/isValied */
	
	/**
	 * A really simple utility function to check if an input's value is considered "valued".
	 *
	 * @param {string|number} v - the value to check
	 * @return {boolean} true if the value is a number or a non-empty string.
	 */
	function isValued(v) {
	  return v === 0 || !!v;
	}
	//# sourceMappingURL=isValued.js.map

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = omit;
	/** @module utils/omit */
	
	/**
	 * This should hopefully be very similar to lodash's omit function. It will
	 * take an object and return a new object without any of the given keys.
	 *
	 * @param {Object} obj - The object to omit keys from.
	 * @param {Array.<String>} keys - a list of keys to remove.
	 */
	function omit(obj, keys) {
	  if (!obj) {
	    return {};
	  } else if (!keys || !keys.length) {
	    return obj;
	  }
	
	  return Object.keys(obj).filter(function (key) {
	    return keys.indexOf(key) === -1;
	  }).reduce(function (newProps, key) {
	    newProps[key] = obj[key];
	
	    return newProps;
	  }, {});
	}
	//# sourceMappingURL=omit.js.map

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 118 */,
/* 119 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var alpha = exports.alpha = {
	  'en-US': /^[A-Z]+$/i,
	  'cs-CZ': /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
	  'da-DK': /^[A-ZÆØÅ]+$/i,
	  'de-DE': /^[A-ZÄÖÜß]+$/i,
	  'el-GR': /^[Α-ω]+$/i,
	  'es-ES': /^[A-ZÁÉÍÑÓÚÜ]+$/i,
	  'fr-FR': /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
	  'it-IT': /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
	  'nb-NO': /^[A-ZÆØÅ]+$/i,
	  'nl-NL': /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
	  'nn-NO': /^[A-ZÆØÅ]+$/i,
	  'hu-HU': /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
	  'pl-PL': /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
	  'pt-PT': /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
	  'ru-RU': /^[А-ЯЁ]+$/i,
	  'sr-RS@latin': /^[A-ZČĆŽŠĐ]+$/i,
	  'sr-RS': /^[А-ЯЂЈЉЊЋЏ]+$/i,
	  'sv-SE': /^[A-ZÅÄÖ]+$/i,
	  'tr-TR': /^[A-ZÇĞİıÖŞÜ]+$/i,
	  'uk-UA': /^[А-ЩЬЮЯЄIЇҐі]+$/i,
	  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
	};
	
	var alphanumeric = exports.alphanumeric = {
	  'en-US': /^[0-9A-Z]+$/i,
	  'cs-CZ': /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
	  'da-DK': /^[0-9A-ZÆØÅ]+$/i,
	  'de-DE': /^[0-9A-ZÄÖÜß]+$/i,
	  'el-GR': /^[0-9Α-ω]+$/i,
	  'es-ES': /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
	  'fr-FR': /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
	  'it-IT': /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
	  'hu-HU': /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
	  'nb-NO': /^[0-9A-ZÆØÅ]+$/i,
	  'nl-NL': /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
	  'nn-NO': /^[0-9A-ZÆØÅ]+$/i,
	  'pl-PL': /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
	  'pt-PT': /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
	  'ru-RU': /^[0-9А-ЯЁ]+$/i,
	  'sr-RS@latin': /^[0-9A-ZČĆŽŠĐ]+$/i,
	  'sr-RS': /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
	  'sv-SE': /^[0-9A-ZÅÄÖ]+$/i,
	  'tr-TR': /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
	  'uk-UA': /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
	  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
	};
	
	var decimal = exports.decimal = {
	  'en-US': '.',
	  ar: '٫'
	};
	
	var englishLocales = exports.englishLocales = ['AU', 'GB', 'HK', 'IN', 'NZ', 'ZA', 'ZM'];
	
	for (var locale, i = 0; i < englishLocales.length; i++) {
	  locale = 'en-' + englishLocales[i];
	  alpha[locale] = alpha['en-US'];
	  alphanumeric[locale] = alphanumeric['en-US'];
	  decimal[locale] = decimal['en-US'];
	}
	
	// Source: http://www.localeplanet.com/java/
	var arabicLocales = exports.arabicLocales = ['AE', 'BH', 'DZ', 'EG', 'IQ', 'JO', 'KW', 'LB', 'LY', 'MA', 'QM', 'QA', 'SA', 'SD', 'SY', 'TN', 'YE'];
	
	for (var _locale, _i = 0; _i < arabicLocales.length; _i++) {
	  _locale = 'ar-' + arabicLocales[_i];
	  alpha[_locale] = alpha.ar;
	  alphanumeric[_locale] = alphanumeric.ar;
	  decimal[_locale] = decimal.ar;
	}
	
	// Source: https://en.wikipedia.org/wiki/Decimal_mark
	var dotDecimal = exports.dotDecimal = [];
	var commaDecimal = exports.commaDecimal = ['cs-CZ', 'da-DK', 'de-DE', 'el-GR', 'es-ES', 'fr-FR', 'it-IT', 'hu-HU', 'nb-NO', 'nn-NO', 'nl-NL', 'pl-Pl', 'pt-PT', 'ru-RU', 'sr-RS@latin', 'sr-RS', 'sv-SE', 'tr-TR', 'uk-UA'];
	
	for (var _i2 = 0; _i2 < dotDecimal.length; _i2++) {
	  decimal[dotDecimal[_i2]] = decimal['en-US'];
	}
	
	for (var _i3 = 0; _i3 < commaDecimal.length; _i3++) {
	  decimal[commaDecimal[_i3]] = ',';
	}
	
	alpha['pt-BR'] = alpha['pt-PT'];
	alphanumeric['pt-BR'] = alphanumeric['pt-PT'];
	decimal['pt-BR'] = decimal['pt-PT'];

/***/ }),
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(140);
	var isArguments = __webpack_require__(139);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),
/* 139 */
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),
/* 140 */
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(100)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(188);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(138);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(164);
	
	var _HelmetConstants = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(7);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _contextTypes = __webpack_require__(106);
	
	var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _extends({}, _contextTypes2.default, { header: _propTypes2.default.bool });
	//# sourceMappingURL=headerContextTypes.js.map

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = withTableFixes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(9);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _fixedToShape = __webpack_require__(22);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _findTable = __webpack_require__(107);
	
	var _findTable2 = _interopRequireDefault(_findTable);
	
	var _findFixedTo = __webpack_require__(266);
	
	var _findFixedTo2 = _interopRequireDefault(_findFixedTo);
	
	var _getDisplayName = __webpack_require__(179);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This is a utility HOC to fix the components that use the `Menu` component behind the scenes. This will
	 * correctly add the `id` and `fixedTo` props if they are omitted from the child component's props.
	 *
	 * If the id prop is omitted, it will default to the `${rowId}-${cellIndex}-${suffix}` and when the
	 * `fixedTo` prop is omitted, it will automatically set it to the responsive table wrapper so that
	 * it will stay in viewport as expected.
	 *
	 * This component also attempts to find the `cellIndex` prop if it is not correctly cloned into the
	 * component.
	 *
	 * @param {function|Class} ComposedComponent - the component to compose with the tooltip functionality.
	 * @param {String} suffix - the id suffix to apply.
	 * @return {Class} the ComposedComponent with some fixes applied.
	 */
	function withTableFixes(ComposedComponent, suffix) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_PureComponent) {
	    _inherits(TableFixesComponent, _PureComponent);
	
	    function TableFixesComponent() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, TableFixesComponent);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableFixesComponent.__proto__ || Object.getPrototypeOf(TableFixesComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = { cellIndex: undefined }, _this._fixedTo = null, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TableFixesComponent, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var _props = this.props,
	            cellIndex = _props.cellIndex,
	            fixedTo = _props.fixedTo,
	            id = _props.id;
	
	        var isIndexed = !!id || cellIndex === 0 || !!cellIndex;
	        var isFixed = fixedTo === null || !!fixedTo;
	        if (isIndexed && isFixed) {
	          // all is good
	          return;
	        }
	
	        var column = (0, _reactDom.findDOMNode)(this);
	        var table = (0, _findTable2.default)(column);
	        this._fixedTo = (0, _findFixedTo2.default)(table);
	
	        // If a developer creates their own component to wrap the component that uses a menu, the cellIndex prop
	        // might not be defined if they don't pass ...props
	        if (!isIndexed) {
	          var columns = [].slice.call(column.parentNode.querySelectorAll('th,td'));
	          this.setState({ cellIndex: columns.indexOf(column) }); // eslint-disable-line react/no-did-mount-set-state
	        } else if (this._fixedTo) {
	          // need to apply the _fixedTo for the select field
	          this.forceUpdate();
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var rowId = this.context.rowId;
	
	        var _props2 = this.props,
	            propid = _props2.id,
	            propFixedTo = _props2.fixedTo,
	            propCellIndex = _props2.cellIndex,
	            props = _objectWithoutProperties(_props2, ['id', 'fixedTo', 'cellIndex']);
	
	        var id = this.props.id;
	
	        var fixedTo = this._fixedTo === null || propFixedTo ? propFixedTo : this._fixedTo;
	        var cellIndex = (0, _getField2.default)(this.props, this.state, 'cellIndex');
	        if (!id) {
	          id = rowId + '-' + cellIndex + '-' + suffix;
	        }
	
	        return _react2.default.createElement(ComposedComponent, _extends({}, props, { id: id, fixedTo: fixedTo }));
	      }
	    }]);
	
	    return TableFixesComponent;
	  }(_react.PureComponent), _class.Positions = ComposedComponent.Positions, _class.HorizontalAnchors = ComposedComponent.HorizontalAnchors, _class.VerticalAnchors = ComposedComponent.VerticalAnchors, _class.displayName = (0, _getDisplayName2.default)(ComposedComponent, 'TableFixes'), _class.propTypes = {
	    id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    cellIndex: _propTypes2.default.number,
	    fixedTo: _fixedToShape2.default
	  }, _class.contextTypes = {
	    rowId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	  }, _temp2;
	}
	//# sourceMappingURL=withTableFixes.js.map

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(17);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _oneRequiredForA11y = __webpack_require__(113);
	
	var _oneRequiredForA11y2 = _interopRequireDefault(_oneRequiredForA11y);
	
	var _FocusContainer = __webpack_require__(273);
	
	var _FocusContainer2 = _interopRequireDefault(_FocusContainer);
	
	var _ResizeObserver = __webpack_require__(32);
	
	var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);
	
	var _Paper = __webpack_require__(33);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _DialogTitle = __webpack_require__(576);
	
	var _DialogTitle2 = _interopRequireDefault(_DialogTitle);
	
	var _DialogFooter = __webpack_require__(108);
	
	var _DialogFooter2 = _interopRequireDefault(_DialogFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DIFF_KEYS = ['style', 'height', 'width', 'contentStyle'];
	
	/**
	 * The `Dialog` is just a static component for creating dialogs. Dialogs
	 * seemed like they could be used outside of the `DialogContainer` component,
	 * so it was exposed as well. In *most* cases, you will still want to use
	 * the `DialogContainer` component.
	 */
	
	var Dialog = function (_PureComponent) {
	  _inherits(Dialog, _PureComponent);
	
	  function Dialog(props) {
	    _classCallCheck(this, Dialog);
	
	    var _this = _possibleConstructorReturn(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).call(this));
	
	    _initialiseProps.call(_this);
	
	    var height = props.height,
	        width = props.width;
	
	    var styles = props.style;
	    if (height || width) {
	      styles = styles || {};
	      styles = _extends({ height: height, width: width }, styles);
	    }
	
	    _this.state = {
	      styles: styles,
	      contentStyles: props.contentStyle,
	      contentPadded: false
	    };
	    return _this;
	  }
	
	  _createClass(Dialog, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return { renderNode: this._renderNode };
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          pageX = _props.pageX,
	          pageY = _props.pageY;
	
	      if (!pageX || !pageY) {
	        return;
	      }
	
	      this.setState({ styles: this._getStyles(this.props) });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.onOpen) {
	        this.props.onOpen();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (DIFF_KEYS.some(function (key) {
	        return nextProps[key] !== _this2.props[key];
	      })) {
	        this.setState({
	          styles: this._getStyles(nextProps),
	          contentStyles: _extends({}, this.state.contentStyles, nextProps.contentStyle)
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.onLeave) {
	        this.props.onLeave();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          contentPadded = _state.contentPadded,
	          styles = _state.styles,
	          contentStyles = _state.contentStyles;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          className = _props2.className,
	          titleStyle = _props2.titleStyle,
	          titleClassName = _props2.titleClassName,
	          footerStyle = _props2.footerStyle,
	          footerClassName = _props2.footerClassName,
	          contentClassName = _props2.contentClassName,
	          title = _props2.title,
	          Content = _props2.contentComponent,
	          contentProps = _props2.contentProps,
	          actions = _props2.actions,
	          children = _props2.children,
	          fullPage = _props2.fullPage,
	          centered = _props2.centered,
	          autopadContent = _props2.autopadContent,
	          paddedContent = _props2.paddedContent,
	          autosizeContent = _props2.autosizeContent,
	          stackedActions = _props2.stackedActions,
	          style = _props2.style,
	          contentStyle = _props2.contentStyle,
	          pageX = _props2.pageX,
	          pageY = _props2.pageY,
	          containerX = _props2.containerX,
	          containerY = _props2.containerY,
	          onOpen = _props2.onOpen,
	          onLeave = _props2.onLeave,
	          height = _props2.height,
	          width = _props2.width,
	          props = _objectWithoutProperties(_props2, ['id', 'className', 'titleStyle', 'titleClassName', 'footerStyle', 'footerClassName', 'contentClassName', 'title', 'contentComponent', 'contentProps', 'actions', 'children', 'fullPage', 'centered', 'autopadContent', 'paddedContent', 'autosizeContent', 'stackedActions', 'style', 'contentStyle', 'pageX', 'pageY', 'containerX', 'containerY', 'onOpen', 'onLeave', 'height', 'width']);
	
	      var labelledBy = this.props['aria-labelledby'];
	
	      var titleId = id + '-title';
	      if (!labelledBy && title) {
	        labelledBy = titleId;
	      }
	
	      var padDefined = typeof paddedContent !== 'undefined';
	      var dialogChildren = fullPage ? children : [_react2.default.createElement(
	        _DialogTitle2.default,
	        {
	          key: 'title',
	          id: titleId,
	          style: titleStyle,
	          className: titleClassName
	        },
	        title
	      ), _react2.default.createElement(
	        Content,
	        _extends({
	          ref: !padDefined && autopadContent ? this._setContent : null,
	          key: 'content'
	        }, contentProps, {
	          style: contentStyles,
	          className: (0, _classnames2.default)('md-dialog-content', {
	            'md-dialog-content--padded': padDefined ? paddedContent : contentPadded
	          }, contentClassName)
	        }),
	        autosizeContent ? _react2.default.createElement(_ResizeObserver2.default, { watchHeight: true, watchWidth: true, onResize: this._handleContentResize }) : null,
	        children
	      ), _react2.default.createElement(_DialogFooter2.default, {
	        key: 'footer',
	        style: footerStyle,
	        className: footerClassName,
	        actions: actions,
	        stacked: stackedActions
	      })];
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        _extends({}, props, {
	          id: id,
	          component: _FocusContainer2.default,
	          ref: this._setRenderNode,
	          style: styles,
	          className: (0, _classnames2.default)('md-dialog', {
	            'md-dialog--full-page': fullPage,
	            'md-dialog--centered': centered
	          }, className),
	          role: 'dialog',
	          'aria-labelledby': labelledBy
	        }),
	        dialogChildren
	      );
	    }
	  }]);
	
	  return Dialog;
	}(_react.PureComponent);
	
	Dialog.propTypes = {
	  /**
	   * @see {@link Dialogs/DialogContainer#id}
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * @see {@link Dialogs/DialogContainer#aria-describedby}
	   */
	  'aria-describedby': (0, _oneRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]), 'title', 'aria-labelledby', 'aria-label'),
	
	  /**
	   * @see {@link Dialogs/DialogContainer#aria-labelledby}
	   */
	  'aria-labelledby': _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * @see {@link Dialogs/DialogContainer#aria-label}
	   */
	  'aria-label': _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the dialog.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the dialog.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional styke to apply to the title.
	   */
	  titleStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the title.
	   */
	  titleClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the footer. This is used when the `actions`
	   * prop is defined.
	   */
	  footerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the footer. This is used when the `actions`
	   * prop is defined.
	   */
	  footerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the dialog's content.
	   */
	  contentStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the dialog's content.
	   */
	  contentClassName: _propTypes2.default.string,
	
	  /**
	   * The component to render the content as. This is helpful if you would like to use
	   * the CSSTransitionGroup. This really just saves a tiny bit of markup.
	   *
	   * ```js
	   * <Dialog
	   *   contentComponent={CSSTransitionGroup}
	   *   contentProps={{
	   *     transitionName: 'md-cross-fade',
	   *     transitionLeave: false,
	   *     transitionEnterTimeout: 150,
	   *   }}
	   * >
	   *   {dynamicContent}
	   * </Dialog>
	   * ```
	   */
	  contentComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * Any additional props to pass to the content component.
	   */
	  contentProps: _propTypes2.default.object,
	
	  /**
	   * An optional title to display in the dialog.
	   */
	  title: _propTypes2.default.node,
	
	  /**
	   * Any children to display in the content of the dialog.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A single action or a list of actions to display in the dialog. This can either be a list
	   * of `FlatButton` props or `<Button flat {...props} />` elements.
	   */
	  actions: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.object, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.object]))]),
	
	  /**
	   * @see {@link Helpers/FocusContainer#additionalFocusKeys}
	   */
	  additionalFocusKeys: _FocusContainer2.default.propTypes.additionalFocusKeys,
	
	  /**
	   * @see {@link Helpers/FocusContainer#initialFocus}
	   */
	  initialFocus: _FocusContainer2.default.propTypes.initialFocus,
	
	  /**
	   * @see {@link Helpers/FocusContainer#focusOnMount}
	   */
	  focusOnMount: _FocusContainer2.default.propTypes.focusOnMount,
	
	  /**
	   * @see {@link Helpers/FocusContainer#containFocus}
	   */
	  containFocus: _FocusContainer2.default.propTypes.containFocus,
	
	  /**
	   * An optional x coordinate on the page that caused a full page dialog
	   * to be created. This is really just used for a `transformOrigin` style.
	   */
	  pageX: _propTypes2.default.number,
	
	  /**
	   * An optional y coordinate on the page that caused a full page dialog
	   * to be created. This is really just used for a `transformOrigin` style.
	   */
	  pageY: _propTypes2.default.number,
	
	  /**
	   * An optional x scroll position of the container holding the dialog. This
	   * is really just used for a `transformOrigin` style on full page dialogs.
	   */
	  containerX: _propTypes2.default.number,
	
	  /**
	   * An optional y scroll position of the container holding the dialog. This
	   * is really just used for a `transformOrigin` style on full page dialogs.
	   */
	  containerY: _propTypes2.default.number,
	
	  /**
	   * Boolean if the dialog should be rendered as a full page dialog.
	   */
	  fullPage: _propTypes2.default.bool,
	
	  /**
	   * The zDepth to use for the dialog.
	   */
	  zDepth: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional function to call when the dialog has been opened. This is
	   * really just used for the `DialogContainer`.
	   */
	  onOpen: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the dialog has been closed. This is
	   * really just used for the `DialogContainer`.
	   */
	  onLeave: _propTypes2.default.func,
	
	  /**
	   * Boolean if the dialog should be centered in the page.
	   */
	  centered: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the content should be padded. This will take precedence
	   * over the `autopadContent` prop. So if this is defined, that value
	   * will be used instead of any thing that was was calculated in this
	   * component.
	   *
	   * @see {@link #autopadContent}
	   */
	  paddedContent: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog should automatically try to determine if the content
	   * should be padded. It will be padded if the dialog does not contain a `List`.
	   */
	  autopadContent: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog content's size should automatically be resized to overflow
	   * correctly when there is a lot of content. This will calculate and apply some `maxHeight`
	   * to the `contentStyle`.
	   */
	  autosizeContent: _propTypes2.default.bool,
	
	  /**
	   * An optional height to apply to the dialog. This is used if it is easier to just apply height/width
	   * with for specific dialogs instead of in CSS.
	   *
	   * **This prop should not be used if the `fullPage` prop is enabled.**
	   *
	   * @see {@link #fullPage}
	   * @see {@link #width}
	   */
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional width to apply to the dialog. This is used if it is easier to just apply height/width
	   * with for specific dialogs instead of in CSS.
	   *
	   * **This prop should not be used if the `fullPage` prop is enabled.**
	   *
	   * @see {@link #fullPage}
	   * @see {@link #height}
	   */
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * Boolean if the actions should be stacked on top of each other. If this value is `undefined`, it will
	   * automatically attempt to guess if the items should be stacked.
	   */
	  stackedActions: _propTypes2.default.bool
	};
	Dialog.defaultProps = {
	  autopadContent: true,
	  autosizeContent: true,
	  contentComponent: 'section',
	  zDepth: 5
	};
	Dialog.childContextTypes = {
	  renderNode: _propTypes2.default.object
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this._getStyles = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3.props,
	        pageX = _ref.pageX,
	        containerX = _ref.containerX,
	        pageY = _ref.pageY,
	        containerY = _ref.containerY,
	        height = _ref.height,
	        width = _ref.width,
	        style = _ref.style;
	
	    return _extends({
	      height: typeof height !== 'undefined' ? height : null,
	      width: typeof width !== 'undefined' ? width : null,
	      transformOrigin: pageX || pageY ? pageX - containerX + 'px ' + (pageY - containerY) + 'px' : null
	    }, style);
	  };
	
	  this._setRenderNode = function (dialog) {
	    _this3._renderNode = (0, _reactDom.findDOMNode)(dialog);
	  };
	
	  this._setContent = function (content) {
	    if (content !== null) {
	      _this3._content = (0, _reactDom.findDOMNode)(content);
	      var contentPadded = _this3._content.querySelectorAll('.md-list').length === 0;
	
	      _this3.setState({ contentPadded: contentPadded });
	    }
	  };
	
	  this._handleContentResize = function (_ref2) {
	    var scrollHeight = _ref2.scrollHeight,
	        content = _ref2.el;
	
	    var maxHeight = content.style.maxHeight;
	    var dialog = content.parentNode;
	    content.style.maxHeight = 'none';
	    var title = _this3.props.title ? dialog.querySelector('.md-title--dialog') : null;
	    var footer = _this3.props.actions ? dialog.querySelector('.md-dialog-footer') : null;
	
	    var totalHeight = dialog.offsetHeight - (title ? title.offsetHeight : 0) - (footer ? footer.offsetHeight : 0);
	    content.style.maxHeight = maxHeight;
	    var equalHeight = totalHeight === scrollHeight;
	    if (equalHeight) {
	      var currentHeight = _this3.state.contentStyles && _this3.state.contentStyles.maxHeight || null;
	      if (currentHeight && currentHeight !== scrollHeight) {
	        _this3.setState({ contentStyles: _this3.props.contentStyle });
	      }
	    } else {
	      _this3.setState({ contentStyles: _extends({ maxHeight: totalHeight }, _this3.props.contentStyle) });
	    }
	  };
	};
	
	exports.default = Dialog;
	//# sourceMappingURL=Dialog.js.map

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _CSSTransitionGroup = __webpack_require__(49);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(17);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _keyCodes = __webpack_require__(15);
	
	var _CSSTransitionGroupTick = __webpack_require__(34);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _toggleScroll = __webpack_require__(690);
	
	var _toggleScroll2 = _interopRequireDefault(_toggleScroll);
	
	var _oneRequiredForA11y = __webpack_require__(113);
	
	var _oneRequiredForA11y2 = _interopRequireDefault(_oneRequiredForA11y);
	
	var _Dialog = __webpack_require__(167);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Portal = __webpack_require__(62);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `DialogContainer` component is used for dynamically creating the `Dialog` with
	 * transitions.
	 */
	var DialogContainer = function (_PureComponent) {
	  _inherits(DialogContainer, _PureComponent);
	
	  function DialogContainer(props) {
	    _classCallCheck(this, DialogContainer);
	
	    var _this = _possibleConstructorReturn(this, (DialogContainer.__proto__ || Object.getPrototypeOf(DialogContainer)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var visible = typeof props.isOpen !== 'undefined' ? props.isOpen : props.visible;
	    var dialogVisible = visible && !props.defaultVisibleTransitionable;
	
	    _this.state = {
	      active: visible && !props.fullPage,
	      overlay: visible && !props.fullPage,
	      portalVisible: visible,
	      dialogVisible: dialogVisible
	    };
	    return _this;
	  }
	  /* eslint-disable max-len */
	
	
	  _createClass(DialogContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.isOpen && !this.props.visible) {
	        return;
	      }
	
	      this._mountDialog(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var visible = typeof nextProps.isOpen !== 'undefined' ? nextProps.isOpen : nextProps.visible;
	      if (this.props.isOpen === visible || this.props.visible === visible) {
	        return;
	      }
	
	      var el = (0, _getField2.default)(this.props, this.context, 'renderNode') || window;
	      var pageX = el.scrollX,
	          pageY = el.scrollY;
	
	      if (typeof el.scrollTop !== 'undefined' && typeof el.scrollLeft !== 'undefined') {
	        pageX = el.scrollLeft;
	        pageY = el.scrollTop;
	      } else if (typeof el.scrollY !== 'undefined' && typeof el.scrollX !== 'undefined') {
	        pageX = el.scrollX;
	        pageY = el.scrollY;
	      }
	
	      this._pageX = pageX;
	      this._pageY = pageY;
	
	      if (this._inTimeout) {
	        clearTimeout(this._inTimeout);
	        this._inTimeout = null;
	      }
	
	      if (visible) {
	        this._activeElement = document.activeElement;
	        this._mountPortal(nextProps);
	      } else {
	        this.setState({ dialogVisible: false, active: false });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _props = this.props,
	          visible = _props.visible,
	          closeOnEsc = _props.closeOnEsc,
	          modal = _props.modal;
	
	      var escapable = !modal && closeOnEsc;
	      var prevEscapable = !prevProps.modal && prevProps.closeOnEsc;
	
	      // Only going to support visible here since it was not implemented before.
	      if (visible === prevProps.visible && escapable === prevEscapable) {
	        return;
	      }
	
	      var add = false;
	      var remove = false;
	
	      if (escapable !== prevEscapable) {
	        add = visible && escapable;
	        remove = !visible || prevEscapable && !escapable;
	      } else if (escapable) {
	        add = visible;
	        remove = !visible;
	      }
	
	      if (add) {
	        window.addEventListener('keydown', this._handleEscClose);
	      } else if (remove) {
	        window.removeEventListener('keydown', this._handleEscClose);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.isOpen || this.props.visible) {
	        (0, _toggleScroll2.default)(false);
	      }
	
	      if (this.props.visible && this.props.closeOnEsc && !this.props.modal) {
	        window.removeEventListener('keydown', this._handleEscClose);
	      }
	
	      if (this._inTimeout) {
	        clearTimeout(this._inTimeout);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          overlay = _state.overlay,
	          active = _state.active,
	          dialogVisible = _state.dialogVisible,
	          portalVisible = _state.portalVisible;
	
	      var _props2 = this.props,
	          style = _props2.style,
	          className = _props2.className,
	          dialogStyle = _props2.dialogStyle,
	          dialogClassName = _props2.dialogClassName,
	          modal = _props2.modal,
	          fullPage = _props2.fullPage,
	          component = _props2.component,
	          transitionEnterTimeout = _props2.transitionEnterTimeout,
	          transitionLeaveTimeout = _props2.transitionLeaveTimeout,
	          lastChild = _props2.lastChild,
	          portal = _props2.portal,
	          propVisible = _props2.visible,
	          propRenderNode = _props2.renderNode,
	          closeOnEsc = _props2.closeOnEsc,
	          onShow = _props2.onShow,
	          onHide = _props2.onHide,
	          disableScrollLocking = _props2.disableScrollLocking,
	          defaultVisibleTransitionable = _props2.defaultVisibleTransitionable,
	          close = _props2.close,
	          isOpen = _props2.isOpen,
	          actionLeft = _props2.actionLeft,
	          actionRight = _props2.actionRight,
	          transitionName = _props2.transitionName,
	          transitionEnter = _props2.transitionEnter,
	          transitionLeave = _props2.transitionLeave,
	          props = _objectWithoutProperties(_props2, ['style', 'className', 'dialogStyle', 'dialogClassName', 'modal', 'fullPage', 'component', 'transitionEnterTimeout', 'transitionLeaveTimeout', 'lastChild', 'portal', 'visible', 'renderNode', 'closeOnEsc', 'onShow', 'onHide', 'disableScrollLocking', 'defaultVisibleTransitionable', 'close', 'isOpen', 'actionLeft', 'actionRight', 'transitionName', 'transitionEnter', 'transitionLeave']);
	
	      var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');
	      var dialog = _react2.default.createElement(_Dialog2.default, _extends({
	        key: 'dialog',
	        style: dialogStyle,
	        className: (0, _classnames2.default)('md-background--card', dialogClassName),
	        ref: this._handleDialogMounting,
	        centered: !fullPage,
	        fullPage: fullPage
	      }, props, {
	        containerX: this._pageX,
	        containerY: this._pageY,
	        onLeave: this._unmountPortal
	      }));
	
	      var container = _react2.default.createElement(
	        _CSSTransitionGroup2.default,
	        {
	          component: component,
	          ref: this._setContainer,
	          style: style,
	          className: (0, _classnames2.default)('md-dialog-container', {
	            'md-overlay': !fullPage && overlay,
	            'md-pointer--hover': !fullPage && overlay && !modal,
	            'md-overlay--active': !fullPage && active && overlay
	          }, className),
	          transitionName: 'md-dialog--' + (fullPage ? 'full-page' : 'centered'),
	          transitionEnterTimeout: transitionEnterTimeout,
	          transitionLeaveTimeout: transitionLeaveTimeout,
	          tabIndex: -1,
	          onClick: this._handleClick
	        },
	        dialogVisible ? dialog : null
	      );
	
	      if (!portal) {
	        return portalVisible ? container : null;
	      }
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { visible: portalVisible, renderNode: renderNode, lastChild: lastChild },
	        container
	      );
	    }
	  }]);
	
	  return DialogContainer;
	}(_react.PureComponent);
	
	DialogContainer.propTypes = {
	  /**
	   * An id to use for the `Dialog` once it has been opened. This is used for the
	   * [dialog role](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_dialog_role).
	   * This is used to generate an `id` for the `title` prop when it has been defined.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	  /* eslint-enable max-len */
	
	  /**
	   * An optional accessibility prop to use when the `Dialog` is opened. This should be an id
	   * pointing to some text that describes the content of the dialog. For accessibility
	   * reasons, one of the following props must be defined:
	   * - `title`
	   * - `aria-describedby`
	   * - `aria-labelledby`
	   * - `aria-label`
	   *
	   * An example usage:
	   *
	   * ```js
	   * <Dialog id="accessible-example" visible aria-describedby="accessible-content">
	   *   <p id="accessible-content">This is some content that describes the dialog.</p>
	   * </Dialog>
	   * ```
	   */
	  'aria-describedby': (0, _oneRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]), 'title', 'aria-labelledby', 'aria-label'),
	
	  /**
	   * An optional accessibility prop to use when the `title` prop is not given. This should be
	   * an id pointing to a `h` tag that labels the dialog.
	   *
	   * An example usage:
	   *
	   * ```js
	   * <Dialog visible id="accessible-example" aria-labelledby="accessible-dialog-label">
	   *   <h2 id="accessible-dialog-label">Some Accessible Dialog</h2>
	   * </Dialog>
	   * ```
	   */
	  'aria-labelledby': _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional accessibility prop to use when the `title` and `aria-labelledby` props are
	   * not defined. This should be a string that describes what is in the `Dialog`.
	   *
	   * An example usage:
	   *
	   * ```js
	   * <Dialog visible id="accessible-example" aria-label="Some Accessible Dialog">
	   *   <p>Lorem Ipsum</p>
	   * </Dialog>
	   * ```
	   */
	  'aria-label': _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the dialog's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the dialog's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the dialog itself when the `visible` prop is `true`.
	   */
	  dialogStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the dialog itself when the `visible` prop is `true`.
	   */
	  dialogClassName: _propTypes2.default.string,
	
	  /**
	   * An optional styke to apply to the title.
	   */
	  titleStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the title.
	   */
	  titleClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the footer. This is used when the `actions`
	   * prop is defined.
	   */
	  footerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the footer. This is used when the `actions`
	   * prop is defined.
	   */
	  footerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the dialog's content.
	   */
	  contentStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the dialog's content.
	   */
	  contentClassName: _propTypes2.default.string,
	
	  /**
	   * The component to render the dialog's container in.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * The component to render the dialog's content in.
	   */
	  contentComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * The content to display in the dialog once open.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A single action or a list of actions to display in the dialog. This can either be a list
	   * of `FlatButton` props or `<Button flat {...props} />` elements.
	   */
	  actions: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.object, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.object]))]),
	
	  /**
	   * Boolean if the `Dialog` is current visible.
	   */
	  visible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * An optional function to call when the `visible` prop is changed from `false` to `true`.
	   */
	  onShow: _propTypes2.default.func,
	
	  /**
	   * A function to call that will close the dialog. This is required when the `modal` and `fullPage`
	   * props are not `true`.
	   */
	  onHide: function onHide(props, propName) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    var validator = _propTypes2.default.func;
	    if (!props.modal && !props.fullPage) {
	      validator = validator.isRequired;
	    }
	
	    return validator.apply(undefined, [props, propName].concat(args));
	  },
	
	  /**
	   * Boolean if the dialog should behave like a modal. This means that the dialog can only
	   * be closed by clicking on an action instead of also clicking on the overlay.
	   */
	  modal: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog should be displayed as a full page dialog.
	   */
	  fullPage: function fullPage(props, propName, componentName) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	      args[_key2 - 3] = arguments[_key2];
	    }
	
	    if (typeof props[propName] === 'undefined') {
	      return null;
	    }
	    var componentNameSafe = componentName || '<<anonymous>>';
	
	    var err = _propTypes2.default.bool.apply(_propTypes2.default, [props, propName, componentName].concat(args));
	
	    if (!err && typeof props.title !== 'undefined') {
	      err = new Error('You provided a `title` ' + location + ' to the `' + componentNameSafe + '` when `fullPage` ' + 'has been set to true. A title for a full page dialog should be rendered as a child instead.');
	    }
	
	    return err;
	  },
	
	  /**
	   * An optional pageX location to use when rendering a full page dialog. This is used to set the location
	   * the dialog should appear from.
	   */
	  pageX: _propTypes2.default.number,
	
	  /**
	   * An optional pageY location to use when rendering a full page dialog. This is used to set the location
	   * the dialog should appear from.
	   */
	  pageY: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/FocusContainer#additionalFocusKeys}
	   */
	  additionalFocusKeys: _Dialog2.default.propTypes.additionalFocusKeys,
	
	  /**
	   * @see {@link Helpers/FocusContainer#initialFocus}
	   */
	  initialFocus: _Dialog2.default.propTypes.initialFocus,
	
	  /**
	   * @see {@link Helpers/FocusContainer#focusOnMount}
	   */
	  focusOnMount: _Dialog2.default.propTypes.focusOnMount,
	
	  /**
	   * @see {@link Helpers/FocusContainer#containFocus}
	   */
	  containFocus: _Dialog2.default.propTypes.containFocus,
	
	  /**
	   * The transition enter timeout for the dialog.
	   */
	  transitionEnterTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * The transition leave timeout for the dialog.
	   */
	  transitionLeaveTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the dialog should be closable by pressing the escape key.
	   * This will always be considered `false` of the `modal` props is `true`.
	   */
	  closeOnEsc: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the Portal's functionality of rendering in a separate react tree should be applied
	   * to the dialog.
	   *
	   * @see {@link Helpers/Portal}
	   */
	  portal: _propTypes2.default.bool,
	
	  /**
	   * Since the `Dialog` uses the `Portal` component, you can pass an optional HTML Node to render
	   * the dialog in instead of the `document.body`.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the dialog should be rendered as the last child in the `renderNode` or `body` instead
	   * of as the first.
	   */
	  lastChild: _propTypes2.default.bool,
	
	  /**
	   * An optional title for the dialog.
	   */
	  title: _propTypes2.default.node,
	
	  /**
	   * Boolean if the dialog should animate into view if it is constructed with `visible` enabled.
	   *
	   * This basically means that if the `Dialog` has `visible` enabled on initial page load, does it animate?
	   * In some cases, it can also mean if the `Dialog` is added to the render tree with `visible` enabled,
	   * does it animate?
	   */
	  defaultVisibleTransitionable: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the Dialog should no longer try to prevent the parent container from scrolling while visible.
	   * In most cases, this will attempt to prevent the main window scrolling. If this dialog is nested in another
	   * dialog, it will attempt to prevent the parent dialog from scrolling.
	   */
	  disableScrollLocking: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog should automatically try to determine if the content
	   * should be padded. It will be padded if the dialog does not contain a `List`.
	   */
	  autopadContent: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog content's size should automatically be resized to overflow
	   * correctly when there is a lot of content. This will calculate and apply some `maxHeight`
	   * to the `contentStyle`.
	   */
	  autosizeContent: _propTypes2.default.bool,
	
	  /**
	   * An optional height to apply to the dialog. This is used if it is easier to just apply height/width
	   * with for specific dialogs instead of in CSS.
	   *
	   * **This prop should not be used if the `fullPage` prop is enabled.**
	   *
	   * @see {@link #fullPage}
	   * @see {@link #width}
	   */
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional width to apply to the dialog. This is used if it is easier to just apply height/width
	   * with for specific dialogs instead of in CSS.
	   *
	   * **This prop should not be used if the `fullPage` prop is enabled.**
	   *
	   * @see {@link #fullPage}
	   * @see {@link #height}
	   */
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * Boolean if the actions should be stacked on top of each other. If this value is `undefined`, it will
	   * automatically attempt to guess if the items should be stacked.
	   */
	  stackedActions: _propTypes2.default.bool,
	
	  isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead'),
	  transitionName: (0, _deprecated2.default)(_propTypes2.default.string, 'The transition name will be managed by the component'),
	  transitionEnter: (0, _deprecated2.default)(_propTypes2.default.bool, 'The transition will always be enforced'),
	  transitionLeave: (0, _deprecated2.default)(_propTypes2.default.bool, 'The transition will always be enforced'),
	  actionLeft: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `fullPage` prop instead'),
	  actionRight: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `fullPage` prop instead'),
	  close: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onHide` instead.')
	};
	DialogContainer.defaultProps = {
	  autopadContent: true,
	  autosizeContent: true,
	  component: 'span',
	  closeOnEsc: true,
	  contentComponent: 'section',
	  focusOnMount: true,
	  transitionEnterTimeout: 300,
	  transitionLeaveTimeout: 300,
	  defaultVisibleTransitionable: false
	};
	DialogContainer.contextTypes = {
	  renderNode: _propTypes2.default.object
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._setContainer = function (container) {
	    if (container !== null) {
	      _this2._container = (0, _reactDom.findDOMNode)(container);
	    }
	  };
	
	  this._handleEscClose = function (e) {
	    if ((e.which || e.keyCode) === _keyCodes.ESC) {
	      (_this2.props.onHide || _this2.props.close)(e);
	      window.removeEventListener('keydown', _this2._handleEscClose);
	    }
	  };
	
	  this._mountPortal = function (props) {
	    _this2._mountDialog(props);
	    _this2.setState({ portalVisible: true });
	  };
	
	  this._mountDialog = function (props) {
	    var fullPage = props.fullPage,
	        onShow = props.onShow;
	
	    _this2._inTimeout = setTimeout(function () {
	      _this2._inTimeout = fullPage ? null : setTimeout(function () {
	        _this2._inTimeout = null;
	        _this2.setState({ active: true });
	      }, _CSSTransitionGroupTick2.default);
	      _this2.setState({ dialogVisible: true, overlay: !fullPage }, onShow);
	    }, _CSSTransitionGroupTick2.default);
	  };
	
	  this._unmountPortal = function () {
	    _this2.setState({ portalVisible: false });
	  };
	
	  this._handleClick = function (e) {
	    var visible = typeof _this2.props.isOpen !== 'undefined' ? _this2.props.isOpen : _this2.props.visible;
	    if (_this2.props.modal || !visible || e.target !== _this2._container) {
	      return;
	    }
	
	    (_this2.props.onHide || _this2.props.close)(e);
	  };
	
	  this._handleDialogMounting = function (dialog) {
	    var disableScrollLocking = _this2.props.disableScrollLocking;
	
	    if (dialog === null) {
	      if (_this2._activeElement) {
	        _this2._activeElement.focus();
	      }
	
	      if (!disableScrollLocking) {
	        (0, _toggleScroll2.default)(false, _this2.scrollEl);
	      }
	
	      _this2._activeElement = null;
	      _this2.setState({ overlay: false });
	    } else {
	      var container = document.querySelector('#' + _this2.props.id);
	      if (!container || disableScrollLocking) {
	        return;
	      }
	
	      var el = (0, _getField2.default)(_this2.props, _this2.context, 'renderNode');
	      var node = container.parentNode;
	      while (node && node.classList && !el) {
	        if (node.classList.contains('md-dialog')) {
	          el = node;
	        }
	
	        node = node.parentNode;
	      }
	
	      _this2.scrollEl = el;
	      (0, _toggleScroll2.default)(true, el);
	    }
	  };
	};
	
	exports.default = DialogContainer;
	//# sourceMappingURL=DialogContainer.js.map

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The divider component will pass all other props such as style or
	 * event listeners on to the component.
	 */
	var Divider = function (_PureComponent) {
	  _inherits(Divider, _PureComponent);
	
	  function Divider() {
	    _classCallCheck(this, Divider);
	
	    return _possibleConstructorReturn(this, (Divider.__proto__ || Object.getPrototypeOf(Divider)).apply(this, arguments));
	  }
	
	  _createClass(Divider, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          inset = _props.inset,
	          vertical = _props.vertical,
	          props = _objectWithoutProperties(_props, ['className', 'inset', 'vertical']);
	
	      var Component = vertical ? 'div' : 'hr';
	
	      return _react2.default.createElement(Component, _extends({}, props, {
	        className: (0, _classnames2.default)('md-divider', {
	          'md-divider--vertical': vertical,
	          'md-divider--inset': inset
	        }, className)
	      }));
	    }
	  }]);
	
	  return Divider;
	}(_react.PureComponent);
	
	Divider.propTypes = {
	  /*
	   * An optional style to apply to the divider.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the divider.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if this divider should be inset relative to it's container
	   * component. This means that if it is in a `List` with `Avatar`, it
	   * will start the divider  to the left of the main text in the list.
	   */
	  inset: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the divider should be vertical instead of horizontal.
	   */
	  vertical: _propTypes2.default.bool
	};
	exports.default = Divider;
	//# sourceMappingURL=Divider.js.map

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _media = __webpack_require__(665);
	
	var _CSSTransitionGroupTick = __webpack_require__(34);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _mapToListParts = __webpack_require__(181);
	
	var _mapToListParts2 = _interopRequireDefault(_mapToListParts);
	
	var _controlled = __webpack_require__(16);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _Paper = __webpack_require__(33);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Portal = __webpack_require__(62);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _List = __webpack_require__(81);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Overlay = __webpack_require__(579);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _isType = __webpack_require__(268);
	
	var _DrawerTypes = __webpack_require__(267);
	
	var _DrawerTypes2 = _interopRequireDefault(_DrawerTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var oneOfDrawerTypes = _propTypes2.default.oneOf([_DrawerTypes2.default.FULL_HEIGHT, _DrawerTypes2.default.CLIPPED, _DrawerTypes2.default.FLOATING, _DrawerTypes2.default.PERSISTENT, _DrawerTypes2.default.PERSISTENT_MINI, _DrawerTypes2.default.TEMPORARY, _DrawerTypes2.default.TEMPORARY_MINI]);
	
	/**
	 * The `Drawer` component is used for having a sliding panel of content or navigation
	 * that appears from the side of a screen.
	 *
	 * If the `Drawer` uses any of the `_MINI` drawer types, you will need to also create another
	 * `Drawer` that is not `_MINI`. Transitioning the `width` on mobile devices is very sluggish,
	 * and it isn't much more work to create another drawer.
	 */
	
	var Drawer = function (_PureComponent) {
	  _inherits(Drawer, _PureComponent);
	
	  _createClass(Drawer, null, [{
	    key: 'getCurrentMedia',
	
	
	    /**
	     * Determines the current media and returns an object containing matches for `mobile`, `tablet`, `desktop`,
	     * and the current drawer type. This expects a `props` object of the drawer.
	     *
	     * If this is used server side, it will default to only matching mobile.
	     *
	     * @param {Object=} props - The current drawer's prop shape to extract the mobile, tablet,
	     *    and desktop type/min widths. This defaults to the drawer's default props.
	     * @return {Object} an object containing the media matches and the current type to use for the drawer.
	     */
	    value: function getCurrentMedia() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Drawer.defaultProps;
	      var mobileMinWidth = props.mobileMinWidth,
	          tabletMinWidth = props.tabletMinWidth,
	          desktopMinWidth = props.desktopMinWidth,
	          mobileType = props.mobileType,
	          tabletType = props.tabletType,
	          desktopType = props.desktopType,
	          constantType = props.constantType;
	
	      if (typeof window === 'undefined') {
	        var _type = constantType && props.type ? props.type : mobileType;
	        return { mobile: true, tablet: false, desktop: false, type: _type };
	      }
	
	      var mobile = Drawer.matchesMedia(mobileMinWidth, tabletMinWidth - 1);
	      var tablet = Drawer.matchesMedia(tabletMinWidth, desktopMinWidth);
	      var desktop = Drawer.matchesMedia(desktopMinWidth);
	
	      var type = void 0;
	      if (constantType && props.type && (0, _isType.isTemporary)(props.type)) {
	        type = props.type;
	      } else if (desktop) {
	        type = desktopType;
	      } else if (tablet) {
	        type = tabletType;
	      } else {
	        type = mobileType;
	      }
	
	      return { type: type, mobile: mobile, tablet: tablet, desktop: desktop };
	    }
	
	    /**
	     * Simply does a `window.matchMedia(query)` where the query gets defined as a min width
	     * and optional max width.
	     *
	     * @param {number} min - The min width for the media query.
	     * @param {number=} max - An optional max width to include for the media query.
	     * @return {boolean} true if the media matches.
	     */
	
	  }, {
	    key: 'matchesMedia',
	    value: function matchesMedia(min, max) {
	      var media = 'screen and (min-width: ' + min + 'px)';
	      if (max) {
	        media += ' and (max-width: ' + max + 'px)';
	      }
	
	      return window.matchMedia(media).matches;
	    }
	  }]);
	
	  function Drawer(props) {
	    _classCallCheck(this, Drawer);
	
	    var _this = _possibleConstructorReturn(this, (Drawer.__proto__ || Object.getPrototypeOf(Drawer)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var defaultVisible = props.defaultVisible,
	        defaultMedia = props.defaultMedia,
	        overlay = props.overlay;
	
	
	    _this.state = {
	      mobile: defaultMedia === 'mobile',
	      tablet: defaultMedia === 'tablet',
	      desktop: defaultMedia === 'desktop',
	      animating: false,
	      overlayActive: false,
	      drawerActive: false
	    };
	
	    if (typeof props.type === 'undefined') {
	      _this.state.type = props[defaultMedia + 'Type'];
	    }
	
	    var type = (0, _getField2.default)(props, _this.state, 'type');
	    _this._initialFix = true;
	
	    if (typeof props.visible === 'undefined') {
	      var _visible = (0, _isType.isPermanent)(type) || (0, _isType.isMini)(type);
	      if (!_visible && typeof defaultVisible !== 'undefined') {
	        _visible = defaultVisible;
	      }
	
	      _this.state.visible = _visible;
	    }
	
	    var visible = (0, _getField2.default)(props, _this.state, 'visible');
	
	    _this.state.overlayActive = (typeof overlay !== 'undefined' ? overlay : (0, _isType.isTemporary)(type) && !_this.state.desktop) && visible;
	    _this.state.drawerActive = visible;
	    return _this;
	  }
	
	  _createClass(Drawer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (typeof window !== 'undefined') {
	        this._updateType(this.props);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!(0, _isType.isMini)((0, _getField2.default)(this.props, this.state, 'type'))) {
	        window.addEventListener('resize', this._updateMedia);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          mobileMinWidth = _props.mobileMinWidth,
	          mobileType = _props.mobileType,
	          tabletMinWidth = _props.tabletMinWidth,
	          tabletType = _props.tabletType,
	          desktopMinWidth = _props.desktopMinWidth,
	          desktopType = _props.desktopType;
	
	
	      if (nextProps.mobileMinWidth !== mobileMinWidth || nextProps.mobileType !== mobileType || nextProps.tabletMinWidth !== tabletMinWidth || nextProps.tabletType !== tabletType || nextProps.desktopMinWidth !== desktopMinWidth || nextProps.desktopType !== desktopType) {
	        this._updateType(nextProps);
	      }
	
	      var visible = nextProps.visible,
	          transitionDuration = nextProps.transitionDuration,
	          overlay = nextProps.overlay;
	
	      if (this.props.visible === nextProps.visible) {
	        return;
	      }
	
	      var type = (0, _getField2.default)(nextProps, this.state, 'type');
	      this._animate(visible, type, transitionDuration, overlay, this.state.desktop);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	
	      if (this._closeTimeout) {
	        clearTimeout(this._closeTimeout);
	      }
	
	      window.removeEventListener('resize', this._updateMedia);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cn;
	
	      var _state = this.state,
	          overlayActive = _state.overlayActive,
	          drawerActive = _state.drawerActive,
	          animating = _state.animating;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          style = _props2.style,
	          className = _props2.className,
	          navStyle = _props2.navStyle,
	          navClassName = _props2.navClassName,
	          component = _props2.component,
	          navItems = _props2.navItems,
	          header = _props2.header,
	          children = _props2.children,
	          inline = _props2.inline,
	          position = _props2.position,
	          overlay = _props2.overlay,
	          clickableDesktopOverlay = _props2.clickableDesktopOverlay,
	          lastChild = _props2.lastChild,
	          portal = _props2.portal,
	          overlayStyle = _props2.overlayStyle,
	          overlayClassName = _props2.overlayClassName,
	          propType = _props2.type,
	          propVisible = _props2.visible,
	          propRenderNode = _props2.renderNode,
	          propNavItemsId = _props2.navItemsId,
	          propZDepth = _props2.zDepth,
	          constantType = _props2.constantType,
	          defaultVisible = _props2.defaultVisible,
	          defaultMedia = _props2.defaultMedia,
	          mobileType = _props2.mobileType,
	          mobileMinWidth = _props2.mobileMinWidth,
	          tabletType = _props2.tabletType,
	          tabletMinWidth = _props2.tabletMinWidth,
	          desktopType = _props2.desktopType,
	          desktopMinWidth = _props2.desktopMinWidth,
	          transitionDuration = _props2.transitionDuration,
	          onMediaTypeChange = _props2.onMediaTypeChange,
	          onVisibilityChange = _props2.onVisibilityChange,
	          autoclose = _props2.autoclose,
	          autocloseAfterInk = _props2.autocloseAfterInk,
	          onVisibilityToggle = _props2.onVisibilityToggle,
	          closeOnNavItemClick = _props2.closeOnNavItemClick,
	          props = _objectWithoutProperties(_props2, ['id', 'style', 'className', 'navStyle', 'navClassName', 'component', 'navItems', 'header', 'children', 'inline', 'position', 'overlay', 'clickableDesktopOverlay', 'lastChild', 'portal', 'overlayStyle', 'overlayClassName', 'type', 'visible', 'renderNode', 'navItemsId', 'zDepth', 'constantType', 'defaultVisible', 'defaultMedia', 'mobileType', 'mobileMinWidth', 'tabletType', 'tabletMinWidth', 'desktopType', 'desktopMinWidth', 'transitionDuration', 'onMediaTypeChange', 'onVisibilityChange', 'autoclose', 'autocloseAfterInk', 'onVisibilityToggle', 'closeOnNavItemClick']);
	
	      var _props3 = this.props,
	          navItemsId = _props3.navItemsId,
	          zDepth = _props3.zDepth;
	
	      if (!navItemsId && id) {
	        navItemsId = id + '-nav-items';
	      }
	
	      var desktop = this.state.desktop;
	
	      var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');
	      var type = (0, _getField2.default)(this.props, this.state, 'type');
	      var visible = (0, _getField2.default)(this.props, this.state, 'visible');
	      var mini = (0, _isType.isMini)(type);
	      var temporary = (0, _isType.isTemporary)(type);
	      var floating = _DrawerTypes2.default.FLOATING === type;
	      var permanent = (0, _isType.isPermanent)(type);
	
	      var Component = void 0;
	      if (component) {
	        Component = component;
	      } else if (navItems) {
	        Component = 'nav';
	      } else {
	        Component = 'aside';
	      }
	
	      var navigation = void 0;
	      if (navItems) {
	        navigation = _react2.default.createElement(
	          _List2.default,
	          {
	            ref: this._setNavigation,
	            key: 'navigation',
	            id: navItemsId,
	            style: navStyle,
	            className: (0, _classnames2.default)('md-list--drawer', {
	              'md-toolbar-relative': mini && !visible,
	              'md-background': floating
	            }, navClassName),
	            onClick: this._handleNavClick
	          },
	          navItems.map(_mapToListParts2.default)
	        );
	      }
	
	      if (typeof zDepth === 'undefined') {
	        zDepth = 1;
	        if (floating || inline) {
	          zDepth = 0;
	        } else if (!mini && temporary) {
	          zDepth = 5;
	        }
	      }
	
	      var overlayVisible = overlay;
	      if (typeof overlayVisible !== 'boolean') {
	        overlayVisible = temporary && !mini && (!desktop || clickableDesktopOverlay) && (animating || visible);
	      }
	
	      var drawer = _react2.default.createElement(
	        _Paper2.default,
	        _extends({}, props, {
	          id: id,
	          key: 'drawer',
	          component: Component,
	          zDepth: zDepth,
	          raiseOnHover: false,
	          style: style,
	          className: (0, _classnames2.default)('md-drawer', (_cn = {}, _defineProperty(_cn, 'md-drawer--' + position, !inline), _defineProperty(_cn, 'md-drawer--fixed', !inline), _defineProperty(_cn, 'md-drawer--inline', inline), _defineProperty(_cn, 'md-drawer--active', mini || drawerActive), _defineProperty(_cn, 'md-drawer--mini', mini), _defineProperty(_cn, 'md-transition--deceleration', !mini && !permanent && visible), _defineProperty(_cn, 'md-transition--acceleration', !mini && !permanent && !visible), _defineProperty(_cn, 'md-background', inline || floating), _defineProperty(_cn, 'md-background--card', !floating && !inline), _cn), className)
	        }),
	        header,
	        navigation,
	        children,
	        _react2.default.createElement(_Overlay2.default, {
	          style: overlayStyle,
	          className: overlayClassName,
	          active: overlayActive,
	          onClick: this._closeDrawer,
	          visible: overlayVisible,
	          renderNode: renderNode
	        })
	      );
	
	      if (inline || permanent) {
	        return drawer;
	      } else if (!portal) {
	        return mini || animating || visible ? drawer : null;
	      }
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { visible: animating || visible, renderNode: renderNode, lastChild: lastChild },
	        drawer
	      );
	    }
	  }]);
	
	  return Drawer;
	}(_react.PureComponent);
	
	Drawer.DrawerTypes = _DrawerTypes2.default;
	Drawer.propTypes = {
	  /**
	   * An optional id to provide to the drawer. This is generally a good idea to provide if
	   * there are any `navItems` defined.
	   *
	   * @see {@link #navItemsId}
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the navItems list. If this is omitted and the `id` prop is
	   * defined, it will be defaulted to `${id}-nav-items`.
	   */
	  navItemsId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `List` surrounding the `navItems`.
	   */
	  navStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `List` surrounding the `navItems`.
	   */
	  navClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the overlay.
	   */
	  overlayStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the overlay.
	   */
	  overlayClassName: _propTypes2.default.string,
	
	  /**
	   * An optional component to render the drawer in. When this prop is undefined, the drawer
	   * will be rendered as a `nav` if the `navItems` prop is defined, otherwise an `aside`.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	
	  /**
	   * An optional list of navigation items to display in the drawer. This list can either contain
	   * a valid child component for a `List` or an object used to create a `Divider`, `Subheader`,
	   * or `ListItem`.
	   *
	   * - To create a divider in the list, set a `divider` key to `true`. Any other keys will be
	   * passed to the `Divider` component.
	   * - To create a subheader in the list, set the `subheader` key to `true`. Any other keys will
	   * be passed to the `Subheader` component.
	   * - To create a list item, just create an object with any normal `ListItem` props.
	   */
	  navItems: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.shape({
	    divider: _propTypes2.default.bool,
	    subheader: _propTypes2.default.bool,
	    primaryText: _propTypes2.default.node
	  })])),
	
	  /**
	   * Boolean if a temporary drawer should close when a nav item is clicked.
	   */
	  autoclose: _propTypes2.default.bool,
	
	  /**
	   * An optional header to display. This _should_ normally be a toolbar.
	   */
	  header: _propTypes2.default.node,
	
	  /**
	   * Any additional children to display after the `header` and `navItems`.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The drawer type to use when the current device matches the mobile
	   * media query.
	   */
	  mobileType: _propTypes2.default.oneOf([Drawer.DrawerTypes.TEMPORARY, Drawer.DrawerTypes.TEMPORARY_MINI]).isRequired,
	
	  /**
	   * The min-width to use for the mobile media query.
	   */
	  mobileMinWidth: _propTypes2.default.number.isRequired,
	
	  /**
	   * The drawer type to use when the current device matches the tablet
	   * media query.
	   */
	  tabletType: oneOfDrawerTypes.isRequired,
	
	  /**
	   * The min-width to use for the tablet media query.
	   */
	  tabletMinWidth: _propTypes2.default.number.isRequired,
	
	  /**
	   * The drawer type to use when the current device matches the desktop media
	   * query.
	   */
	  desktopType: oneOfDrawerTypes.isRequired,
	
	  /**
	   * The min-width for a desktop screen.
	   */
	  desktopMinWidth: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional type to enforce across all media sizes. Since `mobile` devices are
	   * included, you are required to manually specify when the `type` should be `temporary`.
	   *
	   * When the `type` is not one of the `temporary` types, the `onMediaTypeChange` prop
	   * must be provided.
	   */
	  type: function type(props, propName, component) {
	    for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      others[_key - 3] = arguments[_key];
	    }
	
	    var type = props[propName];
	    if ((0, _isType.isTemporary)(type)) {
	      return oneOfDrawerTypes.apply(undefined, [props, propName, component].concat(others));
	    }
	
	    var err = oneOfDrawerTypes.apply(undefined, [props, propName, component].concat(others));
	    if (!err && typeof type !== 'undefined' && !(0, _isType.isMini)(type) && typeof props.onMediaTypeChange === 'undefined') {
	      err = new Error('You provided a `' + propName + '` prop to the ' + component + ' without the `onMediaTypeChange` ' + ('handler. The `onMediaTypeChange` prop must be specified when the `' + propName + '` is not ') + 'one of the `temporary` types.');
	    }
	
	    return err;
	  },
	
	  /**
	   * An optional function to call when the drawer's type changes when the screen resizes.
	   * The callback will include the new `type` that should be used for the screen size,
	   * and an object containing the media matches for `mobile`, `tablet`, and `desktop`.
	   *
	   * ```js
	   * this.props.onMediaTypeChange(Drawer.DrawerTypes.TEMPORARY, {
	   *   mobile: true,
	   *   tablet: false,
	   *   desktop: false,
	   * });
	   * ```
	   */
	  onMediaTypeChange: _propTypes2.default.func,
	
	  /**
	   * The default drawer type to display on initial render. The drawer will automatically
	   * adjust itself to the correct media once it has mounted. This prop is really only useful
	   * for server side rendering.
	   */
	  defaultMedia: _propTypes2.default.oneOf(['mobile', 'tablet', 'desktop']).isRequired,
	
	  /**
	   * Boolean if there should be a visible overlay when the drawer is visible. The default behavior
	   * is to only include a visible overlay when the `type` is `TEMPORARY` or `TEMPORARY_MINI` and
	   * the device is not a desktop.
	   *
	   * Definining this variable as `true` or `false` will override any default behavior. This means that
	   * if this is enabled for a full-height drawer, an overlay will still be created.
	   */
	  overlay: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the Portal's functionality of rendering in a separate react tree should be applied
	   * to the drawer. The overlay that appears for temporary type drawers will still appear in the
	   * separate subtree.
	   *
	   * @see {@link Helpers/Portal}
	   */
	  portal: _propTypes2.default.bool,
	
	  /**
	   * An optional DOM Node to render the drawer into. The default is to render as
	   * the first child in the `body`.
	   *
	   * > This prop will not be used when the drawer is of the permanent type or `inline` is specified
	   * since the `Portal` component will not be used.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the drawer should be rendered as the last child instead of the first child
	   * in the `renderNode` or `body`.
	   *
	   * > This prop will not be used when the drawer is of the permanent type or `inline` is specified
	   * since the `Portal` component will not be used.
	   */
	  lastChild: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the drawer is visible by default. If this is omitted, the drawer will be visible
	   * if the current drawer type is NOT `Drawer.DrawerTypes.TEMPORARY` or `Drawer.DrawerTypes.TEMPORARY_MINI`.
	   *
	   * This basically means that if you are using the default configuration, a mobile device's drawer
	   * will be hidden while tablets and desktops will be visible.
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the drawer is visible. This will force the component to define the `onVisibilityChange`
	   * prop as well as manually updating the drawer's visibility.
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityChange', 'defaultVisible'),
	
	  /**
	   * An optional function to call when the visibility of the drawer is changed. The function will
	   * be called with the new visibility state.
	   *
	   * ```js
	   * onVisibilityChange(!currentlyVisible);
	   * ```
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * The drawer's position on the page when it is not `inline`. When the drawer's position is `left`,
	   * the width will be `calc(100vw - 56px)` on mobile devices and `$md-drawer-desktop-width` on desktops.
	   *
	   * When the position is `right`, the width will be `100vw` for mobile devices and scaling to the drawer's
	   * children width on desktops.
	   */
	  position: _propTypes2.default.oneOf(['left', 'right']).isRequired,
	
	  /**
	   * Boolean if the drawer should be displayed inline instead of fixed to the page. When this prop
	   * is enabled, the `position` prop will not be used.
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * The `$md-drawer-transition-time` value from sass.
	   */
	  transitionDuration: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the temporary drawer's overlay should be created on desktop screens. This is really used so that
	   * the drawer will close when a user clicks anywhere on the page except in the drawer.
	   */
	  clickableDesktopOverlay: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `autoclose` feature should wait for the ink transition to finish before automatically
	   * closing the drawer. This will add a `300ms` delay. If this is `false`, there will only be a `17ms` delay.
	   *
	   * > The delay is required so that any event listeners will still be correctly invoked when an item is clicked.
	   */
	  autocloseAfterInk: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `type` prop should be constant across all media sizes. This is only valid if the `type` is
	   * one of the temporary types.
	   *
	   * This will basically mean that when attempting to do a media adjustment, it will use the `type` prop instead of
	   * `mobileType`, `tabletType`, and `desktopType` to determine the next drawer type.
	   */
	  constantType: _propTypes2.default.bool.isRequired,
	
	  /**
	   * An optional zDepth to apply to the drawer. If this is omitted, the value will be set as follows:
	   * - floating || inline = 1
	   * - temporary = 5
	   * - all others = 1
	   *
	   * @see {@link Papers/Paper#zDepth}
	   */
	  zDepth: _propTypes2.default.number,
	
	  closeOnNavItemClick: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `autoclose` instead'),
	  onVisibilityToggle: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onVisibilityChange` instead')
	};
	Drawer.defaultProps = {
	  defaultMedia: 'mobile',
	  mobileType: Drawer.DrawerTypes.TEMPORARY,
	  mobileMinWidth: _media.MOBILE_MIN_WIDTH,
	  tabletType: Drawer.DrawerTypes.PERSISTENT,
	  tabletMinWidth: _media.TABLET_MIN_WIDTH,
	  desktopType: Drawer.DrawerTypes.FULL_HEIGHT,
	  desktopMinWidth: _media.DESKTOP_MIN_WIDTH,
	  position: 'left',
	  transitionDuration: 300,
	  autoclose: true,
	  clickableDesktopOverlay: true,
	  constantType: true
	};
	Drawer.contextTypes = {
	  renderNode: _propTypes2.default.object
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._updateType = function (props) {
	    var onMediaTypeChange = props.onMediaTypeChange,
	        overlay = props.overlay,
	        transitionDuration = props.transitionDuration;
	
	
	    var onVisibilityChange = props.onVisibilityToggle || props.onVisibilityChange;
	
	    var state = Drawer.getCurrentMedia(props);
	    var diffType = (0, _getField2.default)(props, _this2.state, 'type') !== state.type;
	    var diffMedia = state.mobile !== _this2.state.mobile || state.tablet !== _this2.state.tablet || state.desktop !== _this2.state.desktop;
	
	    if (onMediaTypeChange && (diffType || diffMedia)) {
	      onMediaTypeChange(state.type, { mobile: state.mobile, tablet: state.tablet, desktop: state.desktop });
	    }
	
	    if (diffType) {
	      var visible = (0, _isType.isPermanent)(state.type);
	      if (_this2._initialFix) {
	        if (props.defaultVisible) {
	          visible = props.defaultVisible;
	        } else if (props.visible) {
	          visible = props.visible;
	        }
	      }
	
	      var prevVisible = (0, _getField2.default)(props, _this2.state, 'visible');
	      if (onVisibilityChange && visible !== prevVisible) {
	        onVisibilityChange(visible);
	      }
	
	      if (typeof props.visible === 'undefined') {
	        state.visible = visible;
	        _this2._animate(visible, state.type, transitionDuration, overlay, state.desktop);
	      }
	    } else if (_this2._initialFix && diffMedia) {
	      state.overlayActive = (typeof overlay !== 'undefined' ? overlay : (0, _isType.isTemporary)(state.type) && !state.desktop) && (0, _getField2.default)(props, _this2.state, 'visible');
	    }
	
	    if (typeof props.type !== 'undefined') {
	      var _state2 = state,
	          type = _state2.type,
	          realState = _objectWithoutProperties(_state2, ['type']); // eslint-disable-line no-unused-vars
	
	
	      state = realState;
	    }
	
	    _this2._initialFix = false;
	    _this2.setState(state);
	  };
	
	  this._updateMedia = function () {
	    _this2._updateType(_this2.props);
	  };
	
	  this._animate = function (visible, type, timeout, overlay, desktop) {
	    if (_this2._timeout) {
	      clearTimeout(_this2._timeout);
	    }
	
	    if (visible) {
	      _this2._timeout = setTimeout(function () {
	        _this2._timeout = null;
	
	        _this2.setState({
	          overlayActive: overlay || (0, _isType.isTemporary)(type) && !desktop,
	          drawerActive: true,
	          animating: true
	        });
	      }, _CSSTransitionGroupTick2.default);
	    } else {
	      _this2._timeout = setTimeout(function () {
	        _this2._timeout = null;
	
	        _this2.setState({ animating: false });
	      }, timeout);
	      _this2.setState({ animating: true, overlayActive: false, drawerActive: false });
	    }
	  };
	
	  this._setNavigation = function (navigation) {
	    _this2._navigation = (0, _reactDom.findDOMNode)(navigation);
	  };
	
	  this._handleNavClick = function (e) {
	    var _props4 = _this2.props,
	        closeOnNavItemClick = _props4.closeOnNavItemClick,
	        autoclose = _props4.autoclose,
	        autocloseAfterInk = _props4.autocloseAfterInk;
	
	    var enabled = typeof closeOnNavItemClick !== 'undefined' ? closeOnNavItemClick : autoclose;
	    if (!enabled || !(0, _isType.isTemporary)((0, _getField2.default)(_this2.props, _this2.state, 'type'))) {
	      return;
	    }
	
	    var target = e.target;
	
	    while (target && _this2._navigation.contains(target)) {
	      if (target.classList.contains('md-list-tile')) {
	        // Clicked a nav item that has a nested list
	        if (target.getAttribute('aria-expanded') !== null) {
	          return;
	        }
	
	        _this2._closeTimeout = setTimeout(function () {
	          _this2._closeTimeout = null;
	
	          _this2._closeDrawer(e);
	        }, autocloseAfterInk ? 300 : _CSSTransitionGroupTick2.default);
	        return;
	      }
	
	      target = target.parentNode;
	    }
	  };
	
	  this._closeDrawer = function () {
	    var _props5 = _this2.props,
	        onVisibilityChange = _props5.onVisibilityChange,
	        onVisibilityToggle = _props5.onVisibilityToggle,
	        transitionDuration = _props5.transitionDuration,
	        overlay = _props5.overlay;
	
	    var callback = onVisibilityToggle || onVisibilityChange;
	    if (callback) {
	      callback(false);
	    }
	
	    if (typeof _this2.props.visible === 'undefined') {
	      _this2.setState({ visible: false });
	      _this2._animate(false, (0, _getField2.default)(_this2.props, _this2.state, 'type'), transitionDuration, overlay, _this2.state.desktop);
	    }
	  };
	};
	
	exports.default = Drawer;
	//# sourceMappingURL=Drawer.js.map

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _getDisplayName = __webpack_require__(179);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _InkContainer = __webpack_require__(593);
	
	var _InkContainer2 = _interopRequireDefault(_InkContainer);
	
	var _inkContextTypes = __webpack_require__(595);
	
	var _inkContextTypes2 = _interopRequireDefault(_inkContextTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Takes any component and injects an ink container for having the Material Design Ink effect.
	 *
	 * The default triggers for an ink are:
	 * - mouse down event
	 * - touch start event
	 * - keyboard focus
	 * - form submit
	 *
	 * The form submit ink will only be triggered if the `ComposedComponent` has the attribute
	 * `type="submit"`, the `ComposedComponent` is in a form, and the user hits the `enter` key
	 * while not actively focusing the `ComposedComponent`.
	 *
	 * ```js
	 * @param {function} ComposedComponent - The React Component to inject an `ink` prop into.
	 * @return {function} a new React class rendering the `ComposedComponent` and adding an
	 *    `ink` pop.
	 * ```
	 */
	exports.default = function (ComposedComponent) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_PureComponent) {
	    _inherits(InkedComponent, _PureComponent);
	
	    function InkedComponent() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, InkedComponent);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InkedComponent.__proto__ || Object.getPrototypeOf(InkedComponent)).call.apply(_ref, [this].concat(args))), _this), _this.createInk = function (pageX, pageY) {
	        if (_this._inkContainer && !_this.props.disabled && !_this.props.inkDisabled) {
	          _this._inkContainer.createInk(pageX, pageY);
	        }
	      }, _this.focus = function () {
	        if (_this._inkContainer) {
	          _this._inkContainer.focus();
	        }
	      }, _this.getComposedComponent = function () {
	        return _this._composed;
	      }, _this._setInkRef = function (inkContainer) {
	        if (inkContainer) {
	          _this._inkContainer = inkContainer;
	        }
	      }, _this._setComposedComponent = function (component) {
	        _this._composed = component;
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(InkedComponent, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var ref = this.props.__SUPER_SECRET_REF__;
	        // Emulate the ref callback...
	
	        if (ref) {
	          ref(this);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        var ref = this.props.__SUPER_SECRET_REF__;
	        // Emulate the ref callback...
	
	        if (ref) {
	          ref(null);
	        }
	      }
	
	      /**
	       * A publicly accessible way to manually create an ink. This can be used with the `refs`.
	       * The ink can either be created by using the `pageX` and `pageY` from a click/touch event
	       * or it will be created in the center of the `ComposedComponent`.
	       *
	       * ```js
	       * <SomeInkedComponent ref={inkHOC => inkHOC.createInk()} />
	       * ```
	       *
	       * @param {number=} pageX - An optional pageX of the click or touch event.
	       * @param {number=} pageY - An optional pageY of the click or touch event.
	       */
	
	
	      /**
	       * This will attempt to focus the composed component. If the component is disabled, nothing
	       * will happen. If the `disabled` and `inkDisabled` props are not set to `true`, an ink will
	       * also be created.
	       *
	       * ```js
	       * <SomeInkedComponent ref={inkHOC => inkHOC.focus()} />
	       * ```
	       */
	
	
	      /**
	       * Gets the composed component as a ref. This is useful if you need to access the ref of the
	       * composed component instead of the `injectInk` HOC to use some publicly accessible methods.
	       *
	       * ```js
	       * <SomeInkedComponent
	       *   ref={inkHOC => {
	       *     inkHOC.getComposedComponent().focus();
	       *   }}
	       * />
	       * ```
	       */
	
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            transitionOverlap = _props.inkTransitionOverlap,
	            transitionEnterTimeout = _props.inkTransitionEnterTimeout,
	            transitionLeaveTimeout = _props.inkTransitionLeaveTimeout,
	            inkStyle = _props.inkStyle,
	            inkClassName = _props.inkClassName,
	            inkContainerStyle = _props.inkContainerStyle,
	            inkContainerClassName = _props.inkContainerClassName,
	            waitForInkTransition = _props.waitForInkTransition,
	            disabledInteractions = _props.disabledInteractions,
	            pulse = _props.pulse,
	            propInkDisabled = _props.inkDisabled,
	            __SUPER_SECRET_REF__ = _props.__SUPER_SECRET_REF__,
	            props = _objectWithoutProperties(_props, ['inkTransitionOverlap', 'inkTransitionEnterTimeout', 'inkTransitionLeaveTimeout', 'inkStyle', 'inkClassName', 'inkContainerStyle', 'inkContainerClassName', 'waitForInkTransition', 'disabledInteractions', 'pulse', 'inkDisabled', '__SUPER_SECRET_REF__']);
	
	        var inkDisabled = (0, _getField2.default)(this.props, this.context, 'inkDisabled');
	        var inkDisabledInteractions = typeof disabledInteractions !== 'undefined' ? disabledInteractions : this.context.inkDisabledInteractions;
	
	        if (!(props.disabled || inkDisabled)) {
	          props.ink = _react2.default.createElement(_InkContainer2.default, {
	            ref: this._setInkRef,
	            key: 'ink-container',
	            pulse: pulse,
	            style: inkContainerStyle,
	            className: inkContainerClassName,
	            inkStyle: inkStyle,
	            inkClassName: inkClassName,
	            disabledInteractions: inkDisabledInteractions,
	            transitionOverlap: transitionOverlap,
	            transitionEnterTimeout: transitionEnterTimeout,
	            transitionLeaveTimeout: transitionLeaveTimeout,
	            waitForInkTransition: waitForInkTransition
	          });
	        }
	
	        props.ref = this._setComposedComponent;
	
	        return _react2.default.createElement(ComposedComponent, props);
	      }
	    }]);
	
	    return InkedComponent;
	  }(_react.PureComponent), _class.displayName = (0, _getDisplayName2.default)(ComposedComponent, 'Ink'), _class.propTypes = {
	    /**
	     * An optional style to apply to each ink that gets generated.
	     */
	    inkStyle: _propTypes2.default.object,
	
	    /**
	     * An optional className to apply to each ink that gets generated.
	     */
	    inkClassName: _propTypes2.default.string,
	
	    /**
	     * An optional style to apply to the ink's container.
	     */
	    inkContainerStyle: _propTypes2.default.object,
	
	    /**
	     * An optional className to apply to the ink's container.
	     */
	    inkContainerClassName: _propTypes2.default.string,
	
	    /**
	     * Boolean if the composed component or the ink is disabled.
	     */
	    disabled: _propTypes2.default.bool,
	
	    /**
	     * Boolean if only the ink is disabled for the composed component.
	     */
	    inkDisabled: _propTypes2.default.bool,
	
	    /**
	     * The time (in ms) that the enter and leave transitions for the ink should overlap.
	     * This really just allows for a more _fluid_ looking ink when something is quickly
	     * touched or clicked by having it fade out while growing.
	     */
	    inkTransitionOverlap: _propTypes2.default.number.isRequired,
	
	    /**
	     * The transition time for the ink to be considered fully entered. This should really
	     * map up to whatever value you set for `$md-ink-enter-transition-time`.
	     */
	    inkTransitionEnterTimeout: _propTypes2.default.number.isRequired,
	
	    /**
	     * The transition time for the ink to be considered fully leaved (left?). This should really
	     * map up to whatever value you set for `$md-ink-leave-transition-time`.
	     */
	    inkTransitionLeaveTimeout: _propTypes2.default.number.isRequired,
	
	    /**
	     * Boolean if the `ComposedComponent`'s click event only after the ink has finished transitioning
	     * in and out. This is really only to get a more _fluid_ looking click event when clicking on
	     * the `ComposedComponent` ends up taking it out of the view. (ex: Closing a Dialog).
	     */
	    waitForInkTransition: _propTypes2.default.bool,
	
	    /**
	     * An optional array of interactions that can be disabled for the ink. This is a *very* limited
	     * use case where `Switches` needed the ink disabled only when using a mouse.
	     */
	    disabledInteractions: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['keyboard', 'mouse', 'touch'])),
	
	    /**
	     * Boolean if the ink should do a pulse animation while focused. This was enabled by default in
	     * previous versions.
	     */
	    pulse: _propTypes2.default.bool,
	
	    /**
	     * When using inked components in a `TransitionGroup`, the ref callback is not actually invoked.
	     * This is a little _hack_ to get it to work by not using `ref`, but this name.
	     */
	    __SUPER_SECRET_REF__: _propTypes2.default.func
	  }, _class.defaultProps = {
	    inkTransitionOverlap: 150,
	    inkTransitionEnterTimeout: 450,
	    inkTransitionLeaveTimeout: 300
	  }, _class.contextTypes = _inkContextTypes2.default, _temp2;
	};
	//# sourceMappingURL=injectInk.js.map

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TileAddon` component is used to render either a `FontIcon` or an `Avatar`
	 * next to the `ListTileText` for a `ListItem`.
	 */
	var TileAddon = function (_PureComponent) {
	  _inherits(TileAddon, _PureComponent);
	
	  function TileAddon() {
	    _classCallCheck(this, TileAddon);
	
	    return _possibleConstructorReturn(this, (TileAddon.__proto__ || Object.getPrototypeOf(TileAddon)).apply(this, arguments));
	  }
	
	  _createClass(TileAddon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          icon = _props.icon,
	          avatar = _props.avatar,
	          active = _props.active,
	          activeClassName = _props.activeClassName,
	          style = _props.style,
	          className = _props.className;
	
	      if (!icon && !avatar) {
	        return null;
	      }
	
	      var avatarIcon = false;
	      if (avatar) {
	        var avatarChild = _react2.default.Children.only(avatar);
	        if (avatarChild.props.iconSized) {
	          avatarIcon = true;
	        }
	      }
	      return _react2.default.createElement(
	        'div',
	        {
	          style: style,
	          className: (0, _classnames2.default)('md-tile-addon', _defineProperty({
	            'md-tile-addon--icon': icon || avatarIcon,
	            'md-tile-addon--avatar': avatar && !avatarIcon
	          }, activeClassName, active), className)
	        },
	        icon || avatar
	      );
	    }
	  }]);
	
	  return TileAddon;
	}(_react.PureComponent);
	
	TileAddon.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  active: _propTypes2.default.bool,
	  activeClassName: _propTypes2.default.string,
	  icon: _propTypes2.default.node,
	  avatar: _propTypes2.default.node
	};
	exports.default = TileAddon;
	//# sourceMappingURL=TileAddon.js.map

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _controlled = __webpack_require__(16);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _mapToListParts = __webpack_require__(181);
	
	var _mapToListParts2 = _interopRequireDefault(_mapToListParts);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _anchorShape = __webpack_require__(38);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(22);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(39);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _Menu = __webpack_require__(63);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `DropdownMenu` is just a simple wrapper to the `Menu` component. The main differences
	 * is that the `toggle` component will now be the children and the list of items to display
	 * will be the `menuItems` prop.
	 *
	 * The dropdown menu is mostly used to control the state of the menu and render a single element
	 * as the toggle.
	 */
	var DropdownMenu = function (_PureComponent) {
	  _inherits(DropdownMenu, _PureComponent);
	
	  function DropdownMenu(props) {
	    _classCallCheck(this, DropdownMenu);
	
	    var _this = _possibleConstructorReturn(this, (DropdownMenu.__proto__ || Object.getPrototypeOf(DropdownMenu)).call(this, props));
	
	    _this._handleClick = function (e) {
	      var _this$props = _this.props,
	          onVisibilityChange = _this$props.onVisibilityChange,
	          children = _this$props.children;
	
	      var visible = !(0, _getField2.default)(_this.props, _this.state, 'visible');
	      if (onVisibilityChange) {
	        onVisibilityChange(visible, e);
	      }
	
	      var toggle = _react2.default.Children.only(children);
	      if (toggle.props.onClick) {
	        toggle.props.onClick(e);
	      }
	
	      if (typeof _this.props.visible === 'undefined') {
	        _this.setState({ visible: visible });
	      }
	    };
	
	    _this._handleClose = function (e) {
	      var onVisibilityChange = _this.props.onVisibilityChange;
	
	      var visible = false;
	      if (onVisibilityChange) {
	        onVisibilityChange(visible, e);
	      }
	
	      if (typeof _this.props.visible === 'undefined') {
	        _this.setState({ visible: visible });
	      }
	    };
	
	    _this.state = {};
	    if (typeof props.visible === 'undefined') {
	      _this.state.visible = props.defaultVisible;
	    }
	    return _this;
	  }
	
	  _createClass(DropdownMenu, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          listId = _props.listId,
	          menuItems = _props.menuItems,
	          propChildren = _props.children,
	          simplifiedMenu = _props.simplifiedMenu,
	          propVisible = _props.visible,
	          onVisibilityChange = _props.onVisibilityChange,
	          defaultVisible = _props.defaultVisible,
	          props = _objectWithoutProperties(_props, ['id', 'listId', 'menuItems', 'children', 'simplifiedMenu', 'visible', 'onVisibilityChange', 'defaultVisible']);
	
	      var visible = (0, _getField2.default)(this.props, this.state, 'visible');
	
	      var children = _react2.default.Children.only(propChildren);
	      var toggle = _react2.default.cloneElement(children, {
	        id: children.props.id || id + '-toggle',
	        onClick: this._handleClick
	      });
	
	      var items = void 0;
	      if (!Array.isArray(menuItems)) {
	        items = (0, _mapToListParts2.default)(menuItems);
	      } else {
	        items = menuItems.map(_mapToListParts2.default);
	      }
	
	      return _react2.default.createElement(
	        _Menu2.default,
	        _extends({}, props, {
	          simplified: simplifiedMenu,
	          id: id,
	          listId: listId,
	          toggle: toggle,
	          visible: visible,
	          onClose: this._handleClose
	        }),
	        items
	      );
	    }
	  }]);
	
	  return DropdownMenu;
	}(_react.PureComponent);
	
	DropdownMenu.Positions = _Menu2.default.Positions;
	DropdownMenu.HorizontalAnchors = _Menu2.default.HorizontalAnchors;
	DropdownMenu.VerticalAnchors = _Menu2.default.VerticalAnchors;
	DropdownMenu.propTypes = {
	  /**
	   * An id to use for the menu. This is required for accessibility.
	   *
	   * @see {@link Menus/Menu#id}
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the menu's list.
	   *
	   * @see {@link Menus/Menu#listId}
	   */
	  listId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the menu.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the menu.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the list.
	   */
	  listStyle: _propTypes2.default.object,
	
	  /**
	   * An optional class name to apply to the list.
	   */
	  listClassName: _propTypes2.default.string,
	
	  /**
	   * Any additional props to provide to the list.
	   *
	   * @see {@link Menus/Menu#listProps}
	   */
	  listProps: _propTypes2.default.object,
	
	  /**
	   * The z-depth to use for the list.
	   *
	   * @see {@link Menus/Menu/listZDepth}
	   */
	  listZDepth: _propTypes2.default.number,
	
	  /**
	   * Boolean if the list should be displayed inline.
	   *
	   * @see {@link Lists/List#inline}
	   */
	  listInline: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the list's height should be restricted.
	   *
	   * @see {@link Menus/Menu#listHeightRestricted}
	   */
	  listHeightRestricted: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu's list is currently visible. If this is defined, it will
	   * require the `onVisibilityChange` function to be defined since it will become
	   * a controlled component.
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityChange', 'defaultVisible'),
	
	  /**
	   * Boolean if the menu's list should be visible by default.
	   */
	  defaultVisible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * An optional function to call when the button is clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the visibility changes for the menu. The callback will
	   * include the next visibility state and the event that triggered the change.
	   *
	   * ```js
	   * onVisibilityChange(visible, event);
	   * ```
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * This is a 0 to many relationship of `ListItem` to display in the menu's `List`. If the type
	   * of the item is a number or string, it will be passed to the `ListItem` as the `primaryText`.
	   * If it is an object, it should be the shape of the `ListItem` props. If it is a node, it will
	   * just be rendered in the `List`.
	   *
	   * @see {@link Lists/ListItem}
	   * @see {@link Menus/Menu#children}
	   */
	  menuItems: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.object, _propTypes2.default.node]))]),
	
	  /**
	   * @see {@link Menus/Menu#toggle}
	   */
	  children: _propTypes2.default.element.isRequired,
	
	  /**
	   * The anchor position of the menu's list.
	   *
	   * @see {@link Helpers/Layover#anchor}
	   */
	  anchor: _anchorShape2.default,
	
	  /**
	   * This is the anchor to use when the `position` is set to `Autocomplete.Positions.BELOW`.
	   *
	   * @see {@link Helpers/Layover#belowAnchor}
	   */
	  belowAnchor: _anchorShape2.default,
	
	  /**
	   * This is how the menu's list is fixed to the toggle.
	   *
	   * @see {@link Menus/Menu#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * This is the animation position for the menu's list.
	   *
	   * @see {@link Menus/Menu#position}
	   */
	  position: _positionShape2.default,
	
	  /**
	   * Boolean if the menu's list should gain the cascading styles.
	   *
	   * @see {@link Menus/Menu#cascading}
	   */
	  cascading: _propTypes2.default.bool,
	
	  /**
	   * The zDepth to use for the lists that appear in cascading menus.
	   *
	   * @see {@link Menus/Menu#cascadingZDepth}
	   */
	  cascadingZDepth: _propTypes2.default.number,
	
	  /**
	   * The anchor position for the cascading lists.
	   *
	   * @see {@link Menus/Menu#cascadingAnchor}
	   */
	  cascadingAnchor: _anchorShape2.default,
	
	  /**
	   * Boolean if the menu should display as a full width container. This will *not* update the button
	   * to be full width as well.
	   *
	   * @see {@link Menus/Menu#fullWidth}
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu's container should display as `block` instead of `inline-block`.
	   *
	   * @see {@link Menus/Menu#block}
	   */
	  block: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the list should appear centered related to the button.
	   *
	   * @see {@link Menus/Menu#centered}
	   */
	  centered: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu's list should be the same width as the button.
	   *
	   * @see {@link Menus/Menu#sameWidth}
	   */
	  sameWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Menus/Menu#xThreshold}
	   */
	  xThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Menus/Menu#yThreshold}
	   */
	  yThreshold: _propTypes2.default.number,
	
	  /**
	   * Boolean if the menu's list should be closed when an element outside of the menu has been clicked.
	   *
	   * @see {@link Menus/Menu#closeOnOutsideClick}
	   */
	  closeOnOutsideClick: _propTypes2.default.bool,
	
	  /**
	   * The transition name to use for the menu's list visibility changes.
	   *
	   * @see {@link Menus/Menu#transitionName}
	   */
	  transitionName: _propTypes2.default.string,
	
	  /**
	   * The transition name to use when the menu's list gains visibility.
	   *
	   * @see {@link Menus/Menu#transitionEnterTimeout}
	   */
	  transitionEnterTimeout: _propTypes2.default.number,
	
	  /**
	   * The transition timeout to use when the menu's list loses visibility.
	   *
	   * @see {@link Menus/Menu#transitionLeaveTimeout}
	   */
	  transitionLeaveTimeout: _propTypes2.default.number,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu logic should be simplified without any viewport logic and position
	   * based on the relative position of the menu. This will most like require some additional
	   * styles applied to the menu.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedMenu: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#minLeft}
	   */
	  minLeft: _Menu2.default.propTypes.minLeft,
	
	  /**
	   * @see {@link Helpers/Layover#minRight}
	   */
	  minRight: _Menu2.default.propTypes.minLeft,
	
	  /**
	   * @see {@link Helpers/Layover#minBottom}
	   */
	  minBottom: _Menu2.default.propTypes.minBottom,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportWidth}
	   */
	  fillViewportWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportHeight}
	   */
	  fillViewportHeight: _propTypes2.default.bool
	};
	DropdownMenu.defaultProps = {
	  defaultVisible: false,
	  repositionOnScroll: true,
	  repositionOnResize: false
	};
	exports.default = DropdownMenu;
	//# sourceMappingURL=DropdownMenu.js.map

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `PickerControl` component is the button that goes in the header
	 * of a `Picker` component. It is used to switch the view of the `Picker`
	 * from state to state.
	 *
	 * For example, this is the year and date views for the `DatePicker`.
	 */
	var PickerControl = function (_PureComponent) {
	  _inherits(PickerControl, _PureComponent);
	
	  function PickerControl() {
	    _classCallCheck(this, PickerControl);
	
	    return _possibleConstructorReturn(this, (PickerControl.__proto__ || Object.getPrototypeOf(PickerControl)).apply(this, arguments));
	  }
	
	  _createClass(PickerControl, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          active = _props.active,
	          props = _objectWithoutProperties(_props, ['className', 'active']);
	
	      return _react2.default.createElement('button', _extends({}, props, {
	        type: 'button',
	        className: (0, _classnames2.default)('md-btn md-pointer--hover md-picker-control md-picker-text', {
	          'md-picker-text--active': active
	        }, className)
	      }));
	    }
	  }]);
	
	  return PickerControl;
	}(_react.PureComponent);
	
	PickerControl.propTypes = {
	  className: _propTypes2.default.string,
	  active: _propTypes2.default.bool.isRequired,
	  onClick: _propTypes2.default.func.isRequired,
	  children: _propTypes2.default.node.isRequired
	};
	exports.default = PickerControl;
	//# sourceMappingURL=PickerControl.js.map

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(17);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _keyCodes = __webpack_require__(15);
	
	var _omit = __webpack_require__(116);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _isValued = __webpack_require__(115);
	
	var _isValued2 = _interopRequireDefault(_isValued);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _isBetween = __webpack_require__(300);
	
	var _isBetween2 = _interopRequireDefault(_isBetween);
	
	var _handleKeyboardAccessibility = __webpack_require__(83);
	
	var _handleKeyboardAccessibility2 = _interopRequireDefault(_handleKeyboardAccessibility);
	
	var _controlled = __webpack_require__(16);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _FontIcon = __webpack_require__(13);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _anchorShape = __webpack_require__(38);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(22);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(39);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _Menu = __webpack_require__(63);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _ListItem = __webpack_require__(110);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _SelectFieldToggle = __webpack_require__(627);
	
	var _SelectFieldToggle2 = _interopRequireDefault(_SelectFieldToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MOBILE_LIST_PADDING = 8;
	var ARIA_ACTIVE = 'aria-activedescendant';
	
	var SelectField = function (_PureComponent) {
	  _inherits(SelectField, _PureComponent);
	
	  function SelectField(props) {
	    _classCallCheck(this, SelectField);
	
	    var _this = _possibleConstructorReturn(this, (SelectField.__proto__ || Object.getPrototypeOf(SelectField)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = _extends({
	      error: false,
	      active: false
	    }, _this._getActive(props, { value: props.defaultValue }), {
	      listProps: _defineProperty({
	        role: 'listbox',
	        ref: _this._scrollActiveIntoView
	      }, ARIA_ACTIVE, null),
	      match: null,
	      lastSearch: null,
	      value: props.defaultValue,
	      visible: props.defaultVisible
	    });
	
	    _this._items = [];
	    _this._activeItem = null;
	    _this._deleteKeys = _this._getDeleteKeys(props);
	    return _this;
	  }
	
	  _createClass(SelectField, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._container = (0, _reactDom.findDOMNode)(this);
	      this._field = this._container.querySelector('.md-select-field');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          itemLabel = _props.itemLabel,
	          itemValue = _props.itemValue,
	          deleteKeys = _props.deleteKeys;
	
	      if (deleteKeys !== nextProps.deleteKeys || itemLabel !== nextProps.itemLabel || itemValue !== nextProps.itemValue) {
	        this._deleteKeys = this._getDeleteKeys(nextProps);
	      }
	
	      if (this.props.value !== nextProps.value || this.props.menuItems !== nextProps.menuItems) {
	        this.setState(this._getActive(nextProps, this.state));
	      }
	    }
	
	    /**
	     * Gets the current value from the select field. This is used when you have an uncontrolled
	     * text field and simply need the value from a ref callback.
	     *
	     * @return {String} the select field's value
	     */
	
	  }, {
	    key: '_getItemPart',
	    value: function _getItemPart(item, itemLabel, itemValue) {
	      var preferLabel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	      var type = typeof item === 'undefined' ? 'undefined' : _typeof(item);
	      if (type === 'number' || type === 'string') {
	        return item;
	      } else if (type === 'object') {
	        var key1 = preferLabel ? itemLabel : itemValue;
	        var key2 = preferLabel ? itemValue : itemLabel;
	        return typeof item[key1] !== 'undefined' ? item[key1] : item[key2];
	      }
	
	      return '';
	    }
	  }, {
	    key: '_getDeleteKeys',
	    value: function _getDeleteKeys(_ref) {
	      var itemLabel = _ref.itemLabel,
	          itemValue = _ref.itemValue,
	          itemProps = _ref.itemProps,
	          deleteKeys = _ref.deleteKeys;
	
	      var keys = [itemLabel, itemValue, itemProps];
	      if (deleteKeys) {
	        return keys.concat(Array.isArray(deleteKeys) ? deleteKeys : [deleteKeys]);
	      }
	
	      return keys;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          id = _props2.id,
	          style = _props2.style,
	          className = _props2.className,
	          listStyle = _props2.listStyle,
	          listClassName = _props2.listClassName,
	          toggleStyle = _props2.toggleStyle,
	          toggleClassName = _props2.toggleClassName,
	          menuItems = _props2.menuItems,
	          anchor = _props2.anchor,
	          belowAnchor = _props2.belowAnchor,
	          fixedTo = _props2.fixedTo,
	          position = _props2.position,
	          xThreshold = _props2.xThreshold,
	          yThreshold = _props2.yThreshold,
	          listZDepth = _props2.listZDepth,
	          listInline = _props2.listInline,
	          listHeightRestricted = _props2.listHeightRestricted,
	          block = _props2.block,
	          centered = _props2.centered,
	          sameWidth = _props2.sameWidth,
	          fullWidth = _props2.fullWidth,
	          repositionOnScroll = _props2.repositionOnScroll,
	          repositionOnResize = _props2.repositionOnResize,
	          simplifiedMenu = _props2.simplifiedMenu,
	          minLeft = _props2.minLeft,
	          minRight = _props2.minRight,
	          minBottom = _props2.minBottom,
	          fillViewportWidth = _props2.fillViewportWidth,
	          fillViewportHeight = _props2.fillViewportHeight,
	          menuTransitionName = _props2.menuTransitionName,
	          menuTransitionEnterTimeout = _props2.menuTransitionEnterTimeout,
	          menuTransitionLeaveTimeout = _props2.menuTransitionLeaveTimeout,
	          isOpen = _props2.isOpen,
	          propError = _props2.error,
	          propMenuId = _props2.menuId,
	          propVisible = _props2.visible,
	          itemLabel = _props2.itemLabel,
	          itemValue = _props2.itemValue,
	          itemProps = _props2.itemProps,
	          getItemProps = _props2.getItemProps,
	          defaultValue = _props2.defaultValue,
	          defaultVisible = _props2.defaultVisible,
	          onClick = _props2.onClick,
	          onKeyDown = _props2.onKeyDown,
	          onVisibilityChange = _props2.onVisibilityChange,
	          deleteKeys = _props2.deleteKeys,
	          stripActiveItem = _props2.stripActiveItem,
	          keyboardMatchingTimeout = _props2.keyboardMatchingTimeout,
	          defaultOpen = _props2.defaultOpen,
	          initiallyOpen = _props2.initiallyOpen,
	          onMenuToggle = _props2.onMenuToggle,
	          stretchList = _props2.stretchList,
	          menuStyle = _props2.menuStyle,
	          menuClassName = _props2.menuClassName,
	          floatingLabel = _props2.floatingLabel,
	          noAutoAdjust = _props2.noAutoAdjust,
	          adjustMinWidth = _props2.adjustMinWidth,
	          props = _objectWithoutProperties(_props2, ['id', 'style', 'className', 'listStyle', 'listClassName', 'toggleStyle', 'toggleClassName', 'menuItems', 'anchor', 'belowAnchor', 'fixedTo', 'position', 'xThreshold', 'yThreshold', 'listZDepth', 'listInline', 'listHeightRestricted', 'block', 'centered', 'sameWidth', 'fullWidth', 'repositionOnScroll', 'repositionOnResize', 'simplifiedMenu', 'minLeft', 'minRight', 'minBottom', 'fillViewportWidth', 'fillViewportHeight', 'menuTransitionName', 'menuTransitionEnterTimeout', 'menuTransitionLeaveTimeout', 'isOpen', 'error', 'menuId', 'visible', 'itemLabel', 'itemValue', 'itemProps', 'getItemProps', 'defaultValue', 'defaultVisible', 'onClick', 'onKeyDown', 'onVisibilityChange', 'deleteKeys', 'stripActiveItem', 'keyboardMatchingTimeout', 'defaultOpen', 'initiallyOpen', 'onMenuToggle', 'stretchList', 'menuStyle', 'menuClassName', 'floatingLabel', 'noAutoAdjust', 'adjustMinWidth']);
	
	      var _props3 = this.props,
	          menuId = _props3.menuId,
	          listId = _props3.listId,
	          error = _props3.error;
	
	      error = error || this.state.error;
	      if (!menuId) {
	        menuId = id + '-menu';
	      }
	
	      if (!listId) {
	        listId = menuId + '-options';
	      }
	
	      var _state = this.state,
	          listProps = _state.listProps,
	          active = _state.active,
	          activeLabel = _state.activeLabel;
	
	      var below = position === SelectField.Positions.BELOW;
	      var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	      var value = (0, _getField2.default)(this.props, this.state, 'value');
	      var useSameWidth = typeof sameWidth !== 'undefined' ? sameWidth : below;
	
	      var toggle = _react2.default.createElement(_SelectFieldToggle2.default, _extends({}, props, {
	        id: id,
	        style: toggleStyle,
	        className: toggleClassName,
	        visible: visible,
	        value: value,
	        below: below,
	        error: error,
	        active: active,
	        activeLabel: activeLabel,
	        onClick: this._toggle,
	        onFocus: this._handleFocus,
	        onBlur: this._handleBlur
	      }));
	
	      return _react2.default.createElement(
	        _Menu2.default,
	        {
	          id: menuId,
	          listId: listId,
	          style: style,
	          className: (0, _classnames2.default)('md-menu--select-field', className),
	          listProps: listProps,
	          listStyle: listStyle,
	          listClassName: listClassName,
	          toggle: toggle,
	          visible: visible,
	          onClose: this._close,
	          onKeyDown: this._handleKeyDown,
	          onClick: this._handleClick,
	          simplified: simplifiedMenu,
	          anchor: anchor,
	          belowAnchor: belowAnchor,
	          fixedTo: fixedTo,
	          position: position,
	          xThreshold: xThreshold,
	          yThreshold: yThreshold,
	          listZDepth: listZDepth,
	          listInline: listInline,
	          listHeightRestricted: listHeightRestricted,
	          sameWidth: useSameWidth,
	          block: block,
	          centered: centered,
	          fullWidth: fullWidth,
	          minLeft: minLeft,
	          minRight: minRight,
	          minBottom: minBottom,
	          fillViewportWidth: fillViewportWidth,
	          fillViewportHeight: fillViewportHeight,
	          repositionOnScroll: repositionOnScroll,
	          repositionOnResize: repositionOnResize,
	          transitionName: menuTransitionName,
	          transitionEnterTimeout: menuTransitionEnterTimeout,
	          transitionLeaveTimeout: menuTransitionLeaveTimeout
	        },
	        menuItems.reduce(this._reduceItems, [])
	      );
	    }
	  }, {
	    key: 'value',
	    get: function get() {
	      return (0, _getField2.default)(this.props, this.state, 'value');
	    }
	  }]);
	
	  return SelectField;
	}(_react.PureComponent);
	
	SelectField.HorizontalAnchors = _Menu2.default.HorizontalAnchors;
	SelectField.VerticalAnchors = _Menu2.default.VerticalAnchors;
	SelectField.Positions = _Menu2.default.Positions;
	SelectField.propTypes = {
	  /**
	   * An id to give the select field. This is required for accessibility.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * An optional name to give to the select field.
	   */
	  name: _propTypes2.default.string,
	
	  /**
	   * An optional id to provide to the select field's menu. If this is omitted,
	   * it will default to `${id}-menu`.
	   */
	  menuId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the select field's list.
	   *
	   * @see {@link #menuId}
	   * @see {@link Menus/Menu#menuId}
	   */
	  listId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the select field's container (the menu).
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the select field's container (the menu).
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the menu's list.
	   */
	  listStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the menu's list.
	   */
	  listClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the select field's toggle.
	   */
	  toggleStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the select field's toggle.
	   */
	  toggleClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `AccessibleFakeInkedButton` that is the trigger
	   * for the select field.
	   */
	  inputStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `AccessibleFakeInkedButton` that is the trigger
	   * for the select field.
	   */
	  inputClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the select field should be have the menu's list visible by default.
	   */
	  defaultVisible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * Boolean if the select field should have the menu's list visible. This will make
	   * the select field controlled and require the `onVisibilityChange` prop to be defined,
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityChange', 'defaultVisible'),
	
	  /**
	   * An optional function to call when the select field's menu has it's visibility changed. The callback
	   * will include the next visible state and the event that triggered it.
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * A list of `number`, `string`, or `object` that should be used to create `ListItem`
	   * in the menu's list. When it is an `object`, it will use the `itemLabel` prop as the
	   * `primaryText` and use the value of `itemValue`.
	   *
	   * @see {@link #itemLabel}
	   * @see {@link #itemValue}
	   */
	  menuItems: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.element])).isRequired,
	
	  /**
	   * The amount of time that a list of letters should be used when finding a menu item
	   * while typing. Since a user can select items by typing multiple letters in a row,
	   * this will be used as the timeout for clearing those letters.
	   *
	   * For example:
	   * - User types `g`
	   *
	   * Full match is now `'g'`.
	   *
	   * - User delays 200ms and types `u`
	   *
	   * Full match is now `'gu'`
	   *
	   * - User delays 1000ms and types `a`.
	   *
	   * Full match is now `'a'`
	   */
	  keyboardMatchingTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * The key to use for extracting a menu item's label if the menu item is an object.
	   *
	   * Example:
	   *
	   * ```js
	   * const item = { something: 'My Label', somethingElse: 'value' };
	   * const itemLabel = 'something';
	   * const itemValue = 'somethingElse';
	   * ```
	   */
	  itemLabel: _propTypes2.default.string.isRequired,
	
	  /**
	   * The key to use for extracting a menu item's value if the menu item is an object.
	   *
	   * Example:
	   *
	   * ```js
	   * const item = { something: 'My Label', somethingElse: 'value' };
	   * const itemLabel = 'something';
	   * const itemValue = 'somethingElse';
	   * ```
	   */
	  itemValue: _propTypes2.default.string.isRequired,
	
	  /**
	   * The key to use for extracting a menu item's function
	   * to get additional `ListItem` props if the menu item is an object.
	   *
	   * Example:
	   *
	   * ```js
	   * const item = { something: 'My Label', addProps: ({active}) => active ? {secondaryText: 'some text'} : null };
	   * const itemLabel = 'something';
	   * const itemProps = 'addProps';
	   * ```
	   *
	   * @see {@link #getItemProps}
	   */
	  itemProps: _propTypes2.default.string.isRequired,
	
	  /**
	   * An optional function to get additional `ListItem` props if the menu item is an object.
	   *
	   * An object with the following fields will be passed into the function:
	   * - `index` - item's index
	   * - `active` - whether item is active
	   * - `disabled` - whether item is disabled
	   * - `itemValue` - item's value
	   * - `value` - current list value
	   * - `props` - default `ListItem` props
	   * - `item` - source item's data
	   * - `field` - reference to the component instance
	   */
	  getItemProps: _propTypes2.default.func,
	
	  /**
	   * The default value to use for the select field. If this is set, it should either match
	   * one of the `number` or `string` in your `menuItems` list or be the empty string. If
	   * the `menuItems` is a list of `object`, this value should match one of the menu item's
	   * `itemValue` or be the empty string.
	   *
	   * ```js
	   * const menuItems = [{ label: 'Something': value: 0 }, { label: 'Something else', value: 1 }];
	   *
	   * // both valid
	   * defaultValue={0}
	   * defaultValue=""
	   * ```
	   */
	  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	
	  /**
	   * The value to use for the select field. If this is defined, it becomes a controlled component
	   * and requires the `onChange` prop to be defined. See the `defaultValue` for more behavior info.
	   *
	   * @see {@link #defaultValue}
	   */
	  value: (0, _controlled2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]), 'onChange', 'defaultValue'),
	
	  /**
	   * An optional function to call when the select field's value has been changed either when the user
	   * has click/touched/keyboard selected a value in the list, or the user has selected a value by typing
	   * in the select field while the menu's list is closed.
	   *
	   * The callback will include the next text field value, the selected item's index, the event that
	   * triggered the change, and the id, name, and value of the select field.
	   *
	   * ```js
	   * onChange(value, index, event, { id, name, value });
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional label to use with the select field. This will be a floating label as seen on the text field.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * An optional placeholder to use in the select field. This will only appear when no value has been selected.
	   */
	  placeholder: _propTypes2.default.string,
	
	  /**
	   * Boolean if the select field should be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the select field is required. This will update the label and placeholder to include a `*` suffix.
	   */
	  required: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the select field is considered to be in an `error` state.
	   *
	   * @see {@link TextFields/TextField#error}
	   */
	  error: _propTypes2.default.bool,
	
	  /**
	   * An optional text to display when the text select field is in an error state.
	   *
	   * @see {@link TextFields/TextField#errorText}
	   */
	  errorText: _propTypes2.default.node,
	
	  /**
	   * An optional text to display below the select field to provide input help to the user.
	   * This will only be displayed if the select field is not in an error state.
	   *
	   * @see {@link #helpOnFocus}
	   * @see {@link TextFields/TextField#errorText}
	   */
	  helpText: _propTypes2.default.node,
	
	  /**
	   * Boolean if the `helpText` should only appear on focus.
	   *
	   * @see {@link #helpText}
	   * @see {@link TextFields/TextField#helpOnFocus}
	   */
	  helpOnFocus: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when any element in the select field has been clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `keydown` event has been triggered anywhere in the
	   * select field.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the select field's toggle has gained focus.
	   */
	  onFocus: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the select field's toggle has been blurred. This
	   * will be triggered if the user hits the up or down arrow keys to traverse the list
	   * of items.
	   */
	  onBlur: _propTypes2.default.func,
	
	  /**
	   * The icon to use to display the dropdown arrow.
	   */
	  dropdownIcon: _propTypes2.default.element,
	
	  /**
	   * Boolean if the select field is in a toolbar. This should automatically be injected by the `Toolbar`
	   * component if being used as a `titleMenu` or one of the `actions`.
	   *
	   * @see {@link Toolbars/Toolbar#titleMenu}
	   * @see {@link Toolbars/Toolbar#actions}
	   */
	  toolbar: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the currently active item should be removed from the list of available `menuItems`.
	   * If this is `undefined`, it will strip out the active one only when the
	   * `position === SelectField.Positions.BELOW`.
	   */
	  stripActiveItem: _propTypes2.default.bool,
	
	  /**
	   * The transition name to use when a new value has been selected. By default, it will have the
	   * new item _drop_ into the select field's input location.
	   */
	  transitionName: _propTypes2.default.string.isRequired,
	
	  /**
	   * The transition time to use when a new value has been selected. If this value is `0`, there
	   * will be no transition.
	   */
	  transitionTime: _propTypes2.default.number.isRequired,
	
	  /**
	   * This is how the menu's `List` gets anchored to the select field.
	   *
	   * @see {@link Helpers/Layover#anchor}
	   */
	  anchor: _anchorShape2.default,
	
	  /**
	   * This is the anchor to use when the `position` is set to `Autocomplete.Positions.BELOW`.
	   *
	   * @see {@link Helpers/Layover#belowAnchor}
	   */
	  belowAnchor: _anchorShape2.default,
	
	  /**
	   * This is the animation position for the list that appears.
	   *
	   * @see {@link Helpers/Layover#animationPosition}
	   */
	  position: _positionShape2.default,
	
	  /**
	   * This is how the menu's list will be "fixed" to the `toggle` component.
	   *
	   * @see {@link Helpers/Layover#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * Boolean if the menu's list should appear horizontally instead of vertically.
	   */
	  listInline: _propTypes2.default.bool,
	
	  /**
	   * The list's z-depth for applying box shadow. This should be a number from 0 to 5.
	   */
	  listZDepth: _propTypes2.default.number,
	
	  /**
	   * Boolean if the list should have its height restricted to the `$md-menu-mobile-max-height`/
	   * `$md-menu-desktop-max-height` values.
	   *
	   * @see [md-menu-mobile-max-height](/components/menus?tab=1#variable-md-menu-mobile-max-height)
	   * @see [md-menu-desktop-max-height](/components/menus?tab=1#variable-md-menu-desktop-max-height)
	   */
	  listHeightRestricted: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#xThreshold}
	   */
	  xThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#yThreshold}
	   */
	  yThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#closeOnOutsideClick}
	   */
	  closeOnOutsideClick: _propTypes2.default.bool,
	
	  /**
	   * An optional transition name to use for the list appearing/disappearing.
	   *
	   * @see {@link Menus/Menu#transitionName}
	   */
	  menuTransitionName: _propTypes2.default.string,
	
	  /**
	   * @see {@link Helpers/Layover#transitionEnterTimeout}
	   */
	  menuTransitionEnterTimeout: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#transitionLeaveTimeout}
	   */
	  menuTransitionLeaveTimeout: _propTypes2.default.number,
	
	  /**
	   * @see {@link Menus/Menu#block}
	   */
	  block: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Menus/Menu#fullWidth}
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#centered}
	   */
	  centered: _Menu2.default.propTypes.centered,
	
	  /**
	   * @see {@link Helpers/Layover#sameWidth}
	   */
	  sameWidth: _Menu2.default.propTypes.sameWidth,
	
	  /**
	   * Since the `menuItems` get mapped into `ListItem`, this prop is used to remove
	   * any unnecessary props from the `ListItem` itself. This is where you
	   * would remove parts of your object such as `description` or `__metadata__`.
	   */
	  deleteKeys: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))]),
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu logic should be simplified without any viewport logic and position
	   * based on the relative position of the menu. This will most like require some additional
	   * styles applied to the menu.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedMenu: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#minLeft}
	   */
	  minLeft: _Menu2.default.propTypes.minLeft,
	
	  /**
	   * @see {@link Helpers/Layover#minRight}
	   */
	  minRight: _Menu2.default.propTypes.minLeft,
	
	  /**
	   * @see {@link Helpers/Layover#minBottom}
	   */
	  minBottom: _Menu2.default.propTypes.minBottom,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportWidth}
	   */
	  fillViewportWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportHeight}
	   */
	  fillViewportHeight: _propTypes2.default.bool,
	
	  /**
	   * The direction that the underline should appear from.
	   */
	  lineDirection: _propTypes2.default.oneOf(['left', 'center', 'right']).isRequired,
	
	  iconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `dropdownIcon` instead'),
	  iconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `dropdownIcon` instead'),
	  isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead'),
	  defaultOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
	  initiallyOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
	  onMenuToggle: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onVisibilityChange` instead'),
	  stretchList: (0, _deprecated2.default)(_propTypes2.default.bool, 'No longer valid after the changes to the `Menu` component. Possibly use `sameWidth` instead'),
	  menuStyle: (0, _deprecated2.default)(_propTypes2.default.object, 'Use `style` instead'),
	  menuClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `className` instead'),
	  floatingLabel: (0, _deprecated2.default)(_propTypes2.default.bool, 'A select field can only have floating labels now. Only provide the `label` prop'),
	  noAutoAdjust: (0, _deprecated2.default)(_propTypes2.default.bool, 'No longer valid to use since select fields are no longer text fields'),
	  adjustMinWidth: (0, _deprecated2.default)(_propTypes2.default.bool, 'No longer valid to use since select fields are no longer text fields')
	};
	SelectField.defaultProps = {
	  anchor: {
	    x: SelectField.HorizontalAnchors.INNER_LEFT,
	    y: SelectField.VerticalAnchors.OVERLAP
	  },
	  fixedTo: _Menu2.default.defaultProps.fixedTo,
	  position: SelectField.Positions.TOP_LEFT,
	  itemLabel: 'label',
	  itemValue: 'value',
	  itemProps: 'getProps',
	  dropdownIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'arrow_drop_down'
	  ),
	  lineDirection: 'left',
	  menuItems: [],
	  defaultValue: '',
	  defaultVisible: false,
	  keyboardMatchingTimeout: 1000,
	  transitionName: 'md-drop',
	  transitionTime: 300,
	  repositionOnScroll: true,
	  repositionOnResize: false
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._getActiveItemLabel = function (item, value, itemLabel, itemValue) {
	    var v = _this2._getItemPart(item, itemLabel, itemValue);
	    var label = _this2._getItemPart(item, itemLabel, itemValue, true);
	
	    return v === value || v === parseInt(value, 10) ? label : '';
	  };
	
	  this._getActive = function (props, state) {
	    var activeLabel = '';
	    var activeIndex = -1;
	    var value = (0, _getField2.default)(props, state, 'value');
	    if ((0, _isValued2.default)(value)) {
	      var menuItems = props.menuItems,
	          itemLabel = props.itemLabel,
	          itemValue = props.itemValue;
	
	
	      menuItems.some(function (item, index) {
	        activeLabel = _this2._getActiveItemLabel(item, value, itemLabel, itemValue);
	        var found = (0, _isValued2.default)(activeLabel);
	        if (found) {
	          activeIndex = index;
	        }
	
	        return found;
	      });
	    }
	
	    return { activeLabel: activeLabel, activeIndex: activeIndex };
	  };
	
	  this._attemptItemFocus = function (index) {
	    if (index === -1) {
	      return;
	    }
	
	    var item = _this2._items[index];
	    if (item) {
	      item.focus();
	    }
	  };
	
	  this._setListItem = function (item) {
	    if (!item) {
	      return;
	    }
	
	    if (item.props.active) {
	      _this2._activeItem = (0, _reactDom.findDOMNode)(item);
	      item.focus();
	
	      if (!_this2.state.listProps[ARIA_ACTIVE]) {
	        _this2.setState({ listProps: _extends({}, _this2.state.listProps, _defineProperty({}, ARIA_ACTIVE, _this2.props.id + '-options-active')) });
	      }
	    }
	
	    _this2._items.push(item);
	  };
	
	  this._scrollActiveIntoView = function (listRef) {
	    if (listRef === null) {
	      _this2._items = [];
	      return;
	    } else if (!_this2._activeItem) {
	      return;
	    }
	
	    var list = (0, _reactDom.findDOMNode)(listRef);
	    var offsetTop = _this2._activeItem.offsetTop;
	
	    list.scrollTop = offsetTop > MOBILE_LIST_PADDING ? offsetTop : 0;
	  };
	
	  this._toggle = function (e) {
	    var _props4 = _this2.props,
	        isOpen = _props4.isOpen,
	        onVisibilityChange = _props4.onVisibilityChange,
	        onMenuToggle = _props4.onMenuToggle;
	
	    var visible = !(typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(_this2.props, _this2.state, 'visible'));
	    if (onMenuToggle || onVisibilityChange) {
	      (onMenuToggle || onVisibilityChange)(visible, e);
	    }
	
	    var state = void 0;
	    if (typeof isOpen === 'undefined' && typeof _this2.props.visible === 'undefined') {
	      state = { visible: visible };
	    }
	
	    if (state) {
	      _this2.setState(state);
	    }
	  };
	
	  this._close = function (e) {
	    if (_this2.props.onVisibilityChange) {
	      _this2.props.onVisibilityChange(false, e);
	    }
	
	    if (e.type === 'keydown' && _this2._field) {
	      _this2._field.focus();
	    }
	
	    var state = void 0;
	    if (_this2.props.required && !(0, _getField2.default)(_this2.props, _this2.state, 'value')) {
	      state = { error: true };
	    }
	
	    if (typeof _this2.props.visible === 'undefined') {
	      state = state || {};
	      state.visible = false;
	    }
	
	    if (state) {
	      _this2.setState(state);
	    }
	  };
	
	  this._handleClick = function (e) {
	    if (_this2.props.onClick) {
	      _this2.props.onClick(e);
	    }
	
	    var isOpen = _this2.props.isOpen;
	
	    var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(_this2.props, _this2.state, 'visible');
	    if (visible && _this2._container) {
	      var node = e.target;
	      while (_this2._container.contains(node)) {
	        if (node.dataset && typeof node.dataset.id !== 'undefined') {
	          var _node$dataset = node.dataset,
	              id = _node$dataset.id,
	              value = _node$dataset.value;
	
	          _this2._selectItem(parseInt(id, 10), value, e);
	          return;
	        }
	
	        node = node.parentNode;
	      }
	    }
	  };
	
	  this._selectItem = function (dataIndex, dataValue, e) {
	    var _props5 = _this2.props,
	        required = _props5.required,
	        menuItems = _props5.menuItems,
	        itemLabel = _props5.itemLabel,
	        itemValue = _props5.itemValue,
	        onChange = _props5.onChange,
	        id = _props5.id,
	        name = _props5.name;
	
	    var value = _this2._getItemPart(menuItems[dataIndex], itemLabel, itemValue);
	    var prevValue = (0, _getField2.default)(_this2.props, _this2.state, 'value');
	    if (prevValue !== value && onChange) {
	      onChange(value, dataIndex, e, { id: id, name: name, value: value });
	    }
	
	    var state = _extends({}, _this2._getActive({ value: value, itemLabel: itemLabel, itemValue: itemValue, menuItems: menuItems }, {}), {
	      error: !!required && !value && value !== 0
	    });
	
	    if (typeof _this2.props.value === 'undefined') {
	      state.value = value;
	    }
	
	    _this2.setState(state);
	  };
	
	  this._handleFocus = function (e) {
	    if (_this2.props.onFocus) {
	      _this2.props.onFocus(e);
	    }
	
	    _this2.setState({ active: true });
	  };
	
	  this._handleBlur = function (e) {
	    if (_this2.props.onBlur) {
	      _this2.props.onBlur(e);
	    }
	
	    var error = _this2.state.error;
	    var _props6 = _this2.props,
	        isOpen = _props6.isOpen,
	        required = _props6.required;
	
	    var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(_this2.props, _this2.state, 'visible');
	    var value = (0, _getField2.default)(_this2.props, _this2.state, 'value');
	
	    if (required && !visible) {
	      error = !value;
	    }
	
	    _this2.setState({ active: false, error: error });
	  };
	
	  this._handleKeyDown = function (e) {
	    var _props7 = _this2.props,
	        isOpen = _props7.isOpen,
	        onKeyDown = _props7.onKeyDown;
	
	    if (onKeyDown) {
	      onKeyDown(e);
	    }
	
	    var key = e.which || e.keyCode;
	    var up = key === _keyCodes.UP;
	    var down = key === _keyCodes.DOWN;
	    var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(_this2.props, _this2.state, 'visible');
	
	    if (up || down) {
	      e.preventDefault();
	
	      if (!visible) {
	        _this2._toggle(e);
	        return;
	      }
	
	      _this2._advanceFocus(up);
	    } else if (!visible && (0, _handleKeyboardAccessibility2.default)(e, _this2._toggle, true, true)) {
	      return;
	    } else if (visible && (key === _keyCodes.ESC || key === _keyCodes.TAB)) {
	      if (_this2._field && key === _keyCodes.ESC) {
	        _this2._field.focus();
	      }
	
	      _this2._close(e);
	      return;
	    } else {
	      _this2._selectItemByLetter(key, e);
	    }
	  };
	
	  this._advanceFocus = function (decrement) {
	    var _props8 = _this2.props,
	        position = _props8.position,
	        stripActiveItem = _props8.stripActiveItem;
	    var activeIndex = _this2.state.activeIndex;
	
	
	    var below = position === SelectField.Positions.BELOW;
	    var value = (0, _getField2.default)(_this2.props, _this2.state, 'value');
	    var valued = (0, _isValued2.default)(value);
	    var itemStripped = (typeof stripActiveItem !== 'undefined' ? stripActiveItem : below) && valued;
	
	    // If the select field is positioned below and there is no value, need to increment the last index
	    // by one since this select field removes the active item. Need to account for that here when there
	    // is no value.
	    var lastIndex = _this2._items.length - (itemStripped ? 0 : 1);
	    if (decrement && activeIndex <= 0 || !decrement && activeIndex >= lastIndex) {
	      return;
	    }
	
	    var nextIndex = Math.max(-1, Math.min(lastIndex, activeIndex + (decrement ? -1 : 1)));
	    if (nextIndex === activeIndex) {
	      return;
	    }
	
	    _this2._attemptItemFocus(nextIndex - (itemStripped ? 1 : 0));
	    _this2.setState({ activeIndex: nextIndex });
	  };
	
	  this._selectItemByLetter = function (key, e) {
	    var charCode = String.fromCharCode(key);
	    var isLetter = charCode && charCode.match(/[A-Za-z0-9-_ ]/);
	    var isKeypad = (0, _isBetween2.default)(key, _keyCodes.KEYPAD_ZERO, _keyCodes.KEYPAD_NINE);
	    if (!(0, _isBetween2.default)(key, _keyCodes.ZERO, _keyCodes.NINE) && !isKeypad && !isLetter) {
	      return;
	    }
	
	    var letter = isLetter ? charCode : String(key - (isKeypad ? _keyCodes.KEYPAD_ZERO : _keyCodes.ZERO));
	
	    if (_this2._matchingTimeout) {
	      clearTimeout(_this2._matchingTimeout);
	    }
	
	    _this2._matchingTimeout = setTimeout(function () {
	      _this2._matchingTimeout = null;
	
	      _this2.setState({ match: null, lastSearch: null });
	    }, _this2.props.keyboardMatchingTimeout);
	
	    _this2._selectFirstMatch(letter, e);
	  };
	
	  this._selectFirstMatch = function (letter, e) {
	    var _props9 = _this2.props,
	        menuItems = _props9.menuItems,
	        itemLabel = _props9.itemLabel,
	        itemValue = _props9.itemValue,
	        isOpen = _props9.isOpen,
	        onChange = _props9.onChange,
	        id = _props9.id,
	        name = _props9.name;
	    var lastSearch = _this2.state.lastSearch;
	
	    var match = -1;
	    var search = ('' + (lastSearch || '') + letter).toUpperCase();
	    menuItems.some(function (item, index) {
	      if (item && (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item.disabled) {
	        return false;
	      }
	
	      var label = String(_this2._getItemPart(item, itemLabel, itemValue, true));
	      if (label && label.toUpperCase().replace(/\s/g, '').indexOf(search) === 0) {
	        match = index;
	      }
	
	      return match > -1;
	    });
	
	    var state = {
	      match: match,
	      lastSearch: search
	    };
	
	    if (match !== -1) {
	      var activeItem = menuItems[match];
	      state.activeLabel = _this2._getItemPart(activeItem, itemLabel, itemValue, true);
	      state.activeIndex = match;
	
	      var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(_this2.props, _this2.state, 'visible');
	      if (visible) {
	        if (state.match !== _this2.state.match) {
	          _this2._attemptItemFocus(state.activeIndex);
	        }
	      } else {
	        var value = _this2._getItemPart(activeItem, itemLabel, itemValue);
	        var prevValue = (0, _getField2.default)(_this2.props, _this2.state, 'value');
	
	        if (value !== prevValue && onChange) {
	          onChange(value, match, e, { id: id, name: name, value: value });
	        }
	
	        if (typeof _this2.props.value === 'undefined') {
	          state.value = value;
	        }
	      }
	    }
	
	    _this2.setState(state);
	  };
	
	  this._reduceItems = function (items, item, i) {
	    if (item === null) {
	      return items;
	    } else if (_react2.default.isValidElement(item)) {
	      items.push(item);
	      return items;
	    }
	
	    var _props10 = _this2.props,
	        getItemProps = _props10.getItemProps,
	        id = _props10.id,
	        itemLabel = _props10.itemLabel,
	        itemProps = _props10.itemProps,
	        itemValue = _props10.itemValue,
	        position = _props10.position,
	        stripActiveItem = _props10.stripActiveItem;
	
	    var below = position === SelectField.Positions.BELOW;
	    var value = (0, _getField2.default)(_this2.props, _this2.state, 'value');
	
	    var dataValue = _this2._getItemPart(item, itemLabel, itemValue);
	    var primaryText = _this2._getItemPart(item, itemLabel, itemValue, true);
	
	    var active = dataValue === value || dataValue === parseInt(value, 10);
	    var stripped = (typeof stripActiveItem !== 'undefined' ? stripActiveItem : below) && active;
	    if (!stripped) {
	      var objectType = (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object';
	      var props = objectType ? (0, _omit2.default)(item, _this2._deleteKeys) : {};
	      var disabled = props.disabled || false;
	      props.ref = disabled ? null : _this2._setListItem;
	      props.id = active ? id + '-options-active' : null;
	      props.active = active;
	      props.tabIndex = -1;
	      props.primaryText = primaryText;
	      props.key = item.key || dataValue;
	      props.role = 'option';
	      props['data-id'] = disabled ? null : i;
	      props['data-value'] = disabled ? null : dataValue;
	
	      var getProps = objectType && item[itemProps] || getItemProps;
	      if (typeof getProps === 'function') {
	        Object.assign(props, getProps({
	          index: i,
	          active: active,
	          disabled: disabled,
	          itemValue: itemValue,
	          value: value,
	          props: props,
	          item: item,
	          field: _this2
	        }));
	      }
	
	      items.push(_react2.default.createElement(_ListItem2.default, props));
	    }
	
	    return items;
	  };
	};
	
	exports.default = SelectField;
	//# sourceMappingURL=SelectField.js.map

/***/ }),
/* 176 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addDate;
	/** @module utils/DateUtils/addDate */
	
	/**
	 * Adds a given amount to a date.
	 *
	 * @param {date} sourceDate the date to add
	 * @param {number} amt the amount to add
	 * @param {string} part the date part to add to. ['D', 'M', 'Y']
	 * @return a new Date with the part added or the date if the part is not valid.
	 */
	function addDate(sourceDate, amt, part) {
	  var date = new Date(sourceDate);
	
	  switch (part) {
	    case 'D':
	      return new Date(date.setDate(date.getDate() + amt));
	    case 'M':
	      date.setDate(1);
	      return new Date(date.setMonth(date.getMonth() + amt));
	    case 'Y':
	      return new Date(date.setFullYear(date.getFullYear() + amt));
	    default:
	      return date;
	  }
	}
	//# sourceMappingURL=addDate.js.map

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValidClick;
	
	var _keyCodes = __webpack_require__(15);
	
	/**
	 * Checks if an event is a valid click event by ignoring
	 * any clisk that are not the left mouse button and not
	 * clicks that involve the shift key.
	 *
	 * @param {Object} e - the event to check
	 * @return {Boolean} true if the event is valid.
	 */
	function isValidClick(e) {
	  return e.button === _keyCodes.LEFT_MOUSE && !e.shiftKey;
	} /** @module utils/EventUtils/isValidClick */
	//# sourceMappingURL=isValidClick.js.map

/***/ }),
/* 178 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTextWidth;
	/** @module utils/Positioning/getTextWidth */
	
	var cachedCanvas = void 0;
	
	/**
	 * A utility function to measure the width (in px) of any text. It will require a canvas
	 * and an element to use to determine the current fonts to apply since different fonts will
	 * have different widths.
	 *
	 * This isn't fully accurate since some browsers handle the calculations a bit differently so
	 * they are off by a 0-3px
	 *
	 * @param {String} text - The text to measure the width
	 * @param {HTMLElement} el - The element to use to determine the current font for the text.
	 * @param {HTMLElement=} canvas - An optional canvas to use for doing the calculations. If this
	 *    is omitted, it will just use the locally created canvas to do the calculations.
	 * @return {number} this will either return null if there is a problem calculating the width or
	 *    the length (in px) of the text.
	 */
	function getTextWidth(text, el, canvas) {
	  if (!el) {
	    return null;
	  }
	
	  if (!canvas) {
	    if (!cachedCanvas) {
	      cachedCanvas = document.createElement('canvas');
	    }
	
	    canvas = cachedCanvas;
	  }
	
	  var context = canvas.getContext('2d');
	  if (!context) {
	    // context doesn't exist in testing without complicated mocks
	    return null;
	  }
	
	  var styles = window.getComputedStyle(el);
	  var font = styles.font;
	  // Some browsers do not actually supply the font style since they are on an older version of CSSProperties,
	  // so the font string needs to be made manually.
	  if (!font) {
	    // font-style font-variant font-weight font-size/line-height font-family
	    var sizing = styles.fontSize + ' / ' + styles.lineHeight + ' ' + styles.fontFamily;
	    font = styles.fontStyle + ' ' + styles.fontVariant + ' ' + styles.fontWeight + ' ' + sizing;
	  }
	
	  context.font = font;
	  return context.measureText(text).width;
	}
	//# sourceMappingURL=getTextWidth.js.map

/***/ }),
/* 179 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDisplayName;
	/** @module utils/StringUtils/getDisplayName */
	
	/**
	 * Gets the display name for a composed component.
	 *
	 * @param {function|Object} ComposedComponent - The composed component to use
	 * @param {String} hoc - The higher order component's name to use.
	 * @return {String} the new name of the component.
	 */
	function getDisplayName(ComposedComponent, hoc) {
	  var name = '' + (ComposedComponent.displayName || ComposedComponent.name || 'Component');
	
	  return 'with' + hoc + '(' + name + ')';
	}
	//# sourceMappingURL=getDisplayName.js.map

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /** @module utils/bem */
	
	
	exports.default = bem;
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A utility function to apply BEM class names to an element.
	 *
	 * ### Examples:
	 * ```js
	 * bem('class') === 'class'
	 * bem('block', 'element') === 'block__element'
	 * bem('block', 'element', 'sub-element') === 'block__element__sub-element'
	 * bem('block', { 'mod-1': true, 'mod-2': false }) === 'block block--mod-1'
	 * bem('block', 'element', { 'mod-1': false, 'mod-2': true }) === 'block__element block__element--mod-2'
	 * bem('block', 'element', {
	 *   'mod-1': false,
	 *   'mod-2': true,
	 * }, 'other', 'class-names') === 'block__element block__element--mod-2 other class-names'
	 * ```
	 *
	 * @param {...String} blocks - 1 to many blocks to use. These names will be joined
	 *    with underscores.
	 * @param {Object=} modifiers - Any conditional modifiers to apply to the blocks. Each
	 *    key in this object will be applied as a `--suffix` to the blocks ONLY when
	 *    their value is true-ish.
	 * @param {...String} others - Any additional class names to apply.
	 * @return {String} the bem-formatted className string.
	 */
	function bem() {
	  var base = [];
	  var modifiers = null;
	  var remaining = -1;
	
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  args.some(function (arg, i) {
	    if (arg) {
	      var type = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);
	      if (type === 'number' || type === 'string') {
	        base.push(arg);
	      } else if (type === 'object') {
	        modifiers = arg;
	        remaining = i + 1;
	      }
	    }
	    return modifiers;
	  });
	
	  var element = base.join('__');
	  if (modifiers) {
	    modifiers = Object.keys(modifiers).reduce(function (obj, key) {
	      obj[element + '--' + key] = modifiers[key];
	      return obj;
	    }, {});
	  }
	  var classes = remaining > -1 ? args.slice(remaining) : null;
	  return (0, _classnames2.default)(element, modifiers, classes).trim();
	}
	//# sourceMappingURL=bem.js.map

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = mapToListParts;
	
	var _react = __webpack_require__(1);
	
	var _Divider = __webpack_require__(169);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Subheader = __webpack_require__(286);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	var _ListItem = __webpack_require__(110);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /** @module utils/mapToListParts */
	
	/**
	 * A utility function to convert any "item" into a valid React element that is used
	 * within the `List` component.
	 *
	 * Use cases:
	 * - is a valid React element -> item returned unmodified
	 * - `number` or `string` -> `ListItem` with the item as the `primaryText`
	 * - an `object` with a key `divider: true` -> a `Divider` component with the remaining
	 *    keys applied as props.
	 * - an `object` with a key `subheader: true` -> a `Subheader` component with the remianing
	 *    keys applied as props. This one technically requires the `primaryText` key to be defined.
	 * - an `object` -> all keys passed into the `ListItem` component.
	 *
	 * Examples:
	 * ```js
	 * mapToListParts('Hello') == <ListItem primaryText="Hello" />
	 * mapToListParts(100)     == <ListItem primaryText={100} />
	 * mapToListParts({ primaryText: 'Item' }) == <ListItem primaryText="Item" />
	 * mapToListParts({ divider: true }) == <Divider />
	 * mapToListParts({ subheader: true, primaryText: 'Subheader' }) == <Subheader primaryText="Subheader" />
	 * ```
	 *
	 * @param {string|number|Object} item - the item to convert
	 * @param {number|string=} index - the current index in the array (if used in an array)
	 * @return {Object} a React element
	 */
	function mapToListParts(item, index) {
	  if (typeof item === 'string' || typeof item === 'number') {
	    return (0, _react.createElement)(_ListItem2.default, { key: item, primaryText: item });
	  } else if ((0, _react.isValidElement)(item)) {
	    return item;
	  }
	
	  var divider = item.divider,
	      subheader = item.subheader,
	      nestedItems = item.nestedItems,
	      remainingProps = _objectWithoutProperties(item, ['divider', 'subheader', 'nestedItems']);
	
	  var component = void 0;
	  if (divider) {
	    component = _Divider2.default;
	  } else if (subheader) {
	    component = _Subheader2.default;
	  } else {
	    component = _ListItem2.default;
	  }
	
	  var props = _extends({}, remainingProps, { key: item.key || index });
	  if (nestedItems) {
	    props.nestedItems = nestedItems.map(mapToListParts);
	  }
	
	  return (0, _react.createElement)(component, props);
	}
	//# sourceMappingURL=mapToListParts.js.map

/***/ }),
/* 182 */
/***/ (function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 183 */
/***/ (function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 184 */
/***/ (function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [0, 0];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ }),
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(141);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(191);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(9);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _trackHelper = __webpack_require__(314);
	
	var _objectAssign = __webpack_require__(7);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpers = {
	  initialize: function initialize(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    var currentSlide = props.rtl ? slideCount - 1 - props.initialSlide : props.initialSlide;
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      currentSlide: currentSlide,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	
	      this.autoPlay(); // once we're set up, trigger the initial autoplay.
	    });
	  },
	  update: function update(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	    // This method has mostly same code as initialize method.
	    // Refactor it
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    // pause slider if autoplay is set to false
	    if (!props.autoplay) {
	      this.pause();
	    } else {
	      this.autoPlay();
	    }
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	    });
	  },
	  getWidth: function getWidth(elem) {
	    return elem && (elem.getBoundingClientRect().width || elem.offsetWidth) || 0;
	  },
	  getHeight: function getHeight(elem) {
	    return elem && (elem.getBoundingClientRect().height || elem.offsetHeight) || 0;
	  },
	
	  adaptHeight: function adaptHeight() {
	    if (this.props.adaptiveHeight) {
	      var selector = '[data-index="' + this.state.currentSlide + '"]';
	      if (this.list) {
	        var slickList = _reactDom2.default.findDOMNode(this.list);
	        slickList.style.height = slickList.querySelector(selector).offsetHeight + 'px';
	      }
	    }
	  },
	  canGoNext: function canGoNext(opts) {
	    var canGo = true;
	    if (!opts.infinite) {
	      if (opts.centerMode) {
	        // check if current slide is last slide
	        if (opts.currentSlide >= opts.slideCount - 1) {
	          canGo = false;
	        }
	      } else {
	        // check if all slides are shown in slider
	        if (opts.slideCount <= opts.slidesToShow || opts.currentSlide >= opts.slideCount - opts.slidesToShow) {
	          canGo = false;
	        }
	      }
	    }
	    return canGo;
	  },
	  slideHandler: function slideHandler(index) {
	    var _this = this;
	
	    // Functionality of animateSlide and postSlide is merged into this function
	    // console.log('slideHandler', index);
	    var targetSlide, currentSlide;
	    var targetLeft, currentLeft;
	    var callback;
	
	    if (this.props.waitForAnimate && this.state.animating) {
	      return;
	    }
	
	    if (this.props.fade) {
	      currentSlide = this.state.currentSlide;
	
	      // Don't change slide if it's not infite and current slide is the first or last slide.
	      if (this.props.infinite === false && (index < 0 || index >= this.state.slideCount)) {
	        return;
	      }
	
	      //  Shifting targetSlide back into the range
	      if (index < 0) {
	        targetSlide = index + this.state.slideCount;
	      } else if (index >= this.state.slideCount) {
	        targetSlide = index - this.state.slideCount;
	      } else {
	        targetSlide = index;
	      }
	
	      if (this.props.lazyLoad && this.state.lazyLoadedList.indexOf(targetSlide) < 0) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(targetSlide)
	        });
	      }
	
	      callback = function callback() {
	        _this.setState({
	          animating: false
	        });
	        if (_this.props.afterChange) {
	          _this.props.afterChange(targetSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: targetSlide
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	
	      if (this.props.beforeChange) {
	        this.props.beforeChange(this.state.currentSlide, targetSlide);
	      }
	
	      this.autoPlay();
	      return;
	    }
	
	    targetSlide = index;
	    if (targetSlide < 0) {
	      if (this.props.infinite === false) {
	        currentSlide = 0;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = this.state.slideCount - this.state.slideCount % this.props.slidesToScroll;
	      } else {
	        currentSlide = this.state.slideCount + targetSlide;
	      }
	    } else if (targetSlide >= this.state.slideCount) {
	      if (this.props.infinite === false) {
	        currentSlide = this.state.slideCount - this.props.slidesToShow;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = 0;
	      } else {
	        currentSlide = targetSlide - this.state.slideCount;
	      }
	    } else {
	      currentSlide = targetSlide;
	    }
	
	    targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: targetSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    if (this.props.infinite === false) {
	      targetLeft = currentLeft;
	    }
	
	    if (this.props.beforeChange) {
	      this.props.beforeChange(this.state.currentSlide, currentSlide);
	    }
	
	    if (this.props.lazyLoad) {
	      var loaded = true;
	      var slidesToLoad = [];
	      for (var i = targetSlide; i < targetSlide + this.props.slidesToShow; i++) {
	        loaded = loaded && this.state.lazyLoadedList.indexOf(i) >= 0;
	        if (!loaded) {
	          slidesToLoad.push(i);
	        }
	      }
	      if (!loaded) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(slidesToLoad)
	        });
	      }
	    }
	
	    // Slide Transition happens here.
	    // animated transition happens to target Slide and
	    // non - animated transition happens to current Slide
	    // If CSS transitions are false, directly go the current slide.
	
	    if (this.props.useCSS === false) {
	
	      this.setState({
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      }, function () {
	        if (this.props.afterChange) {
	          this.props.afterChange(currentSlide);
	        }
	      });
	    } else {
	
	      var nextStateChanges = {
	        animating: false,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state)),
	        swipeLeft: null
	      };
	
	      callback = function callback() {
	        _this.setState(nextStateChanges);
	        if (_this.props.afterChange) {
	          _this.props.afterChange(currentSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: targetLeft }, this.props, this.state))
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	    }
	
	    this.autoPlay();
	  },
	  swipeDirection: function swipeDirection(touchObject) {
	    var xDist, yDist, r, swipeAngle;
	
	    xDist = touchObject.startX - touchObject.curX;
	    yDist = touchObject.startY - touchObject.curY;
	    r = Math.atan2(yDist, xDist);
	
	    swipeAngle = Math.round(r * 180 / Math.PI);
	    if (swipeAngle < 0) {
	      swipeAngle = 360 - Math.abs(swipeAngle);
	    }
	    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	      return this.props.rtl === false ? 'left' : 'right';
	    }
	    if (swipeAngle >= 135 && swipeAngle <= 225) {
	      return this.props.rtl === false ? 'right' : 'left';
	    }
	    if (this.props.verticalSwiping === true) {
	      if (swipeAngle >= 35 && swipeAngle <= 135) {
	        return 'down';
	      } else {
	        return 'up';
	      }
	    }
	
	    return 'vertical';
	  },
	  play: function play() {
	    var nextIndex;
	
	    if (!this.state.mounted) {
	      return false;
	    }
	
	    if (this.props.rtl) {
	      nextIndex = this.state.currentSlide - this.props.slidesToScroll;
	    } else {
	      if (this.canGoNext(_extends({}, this.props, this.state))) {
	        nextIndex = this.state.currentSlide + this.props.slidesToScroll;
	      } else {
	        return false;
	      }
	    }
	
	    this.slideHandler(nextIndex);
	  },
	  autoPlay: function autoPlay() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	    }
	    if (this.props.autoplay) {
	      this.setState({
	        autoPlayTimer: setTimeout(this.play, this.props.autoplaySpeed)
	      });
	    }
	  },
	  pause: function pause() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	      this.setState({
	        autoPlayTimer: null
	      });
	    }
	  }
	};
	
	exports.default = helpers;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(360);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(18);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(730);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFQDN;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _merge = __webpack_require__(68);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_fqdn_options = {
	  require_tld: true,
	  allow_underscores: false,
	  allow_trailing_dot: false
	};
	
	function isFQDN(str, options) {
	  (0, _assertString2.default)(str);
	  options = (0, _merge2.default)(options, default_fqdn_options);
	
	  /* Remove the optional trailing dot before checking validity */
	  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
	    str = str.substring(0, str.length - 1);
	  }
	  var parts = str.split('.');
	  if (options.require_tld) {
	    var tld = parts.pop();
	    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
	      return false;
	    }
	    // disallow spaces
	    if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
	      return false;
	    }
	  }
	  for (var part, i = 0; i < parts.length; i++) {
	    part = parts[i];
	    if (options.allow_underscores) {
	      part = part.replace(/_/g, '');
	    }
	    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
	      return false;
	    }
	    // disallow full-width chars
	    if (/[\uff01-\uff5e]/.test(part)) {
	      return false;
	    }
	    if (part[0] === '-' || part[part.length - 1] === '-') {
	      return false;
	    }
	  }
	  return true;
	}
	module.exports = exports['default'];

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toDate;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toDate(date) {
	  (0, _assertString2.default)(date);
	  date = Date.parse(date);
	  return !isNaN(date) ? new Date(date) : null;
	}
	module.exports = exports['default'];

/***/ }),
/* 194 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = toString;
	function toString(input) {
	  if ((typeof input === 'undefined' ? 'undefined' : _typeof(input)) === 'object' && input !== null) {
	    if (typeof input.toString === 'function') {
	      input = input.toString();
	    } else {
	      input = '[object Object]';
	    }
	  } else if (input === null || typeof input === 'undefined' || isNaN(input) && !input.length) {
	    input = '';
	  }
	  return String(input);
	}
	module.exports = exports['default'];

/***/ }),
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */
/***/ (function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ }),
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentDeprecated = __webpack_require__(47);
	
	var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);
	
	var _FontIcon = __webpack_require__(13);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _injectTooltip = __webpack_require__(111);
	
	var _injectTooltip2 = _interopRequireDefault(_injectTooltip);
	
	var _Button = __webpack_require__(19);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `IconButton` component automatically includes ink and a tooltip.
	 * The tooltip will only be included if the `tooltipLabel` prop is given.
	 *
	 * Any other props (such as style or event listeners) will also be
	 * applied.
	 */
	var IconButton = function (_PureComponent) {
	  _inherits(IconButton, _PureComponent);
	
	  function IconButton() {
	    _classCallCheck(this, IconButton);
	
	    return _possibleConstructorReturn(this, (IconButton.__proto__ || Object.getPrototypeOf(IconButton)).apply(this, arguments));
	  }
	
	  _createClass(IconButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          iconClassName = _props.iconClassName,
	          children = _props.children,
	          tooltip = _props.tooltip,
	          floating = _props.floating,
	          props = _objectWithoutProperties(_props, ['iconClassName', 'children', 'tooltip', 'floating']);
	
	      delete props.tooltipLabel;
	      delete props.tooltipPosition;
	
	      return _react2.default.createElement(
	        _Button2.default,
	        _extends({}, props, { icon: !floating, floating: floating }),
	        tooltip,
	        _react2.default.createElement(
	          _FontIcon2.default,
	          { iconClassName: iconClassName },
	          children
	        )
	      );
	    }
	  }]);
	
	  return IconButton;
	}(_react.PureComponent);
	
	IconButton.propTypes = {
	  /**
	   * The className to use for rendering the `FontIcon`.
	   */
	  iconClassName: _propTypes2.default.string,
	
	  /**
	   * Any children to use to render the `FontIcon`.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An optional className to apply to the button.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The button type.
	   */
	  type: _propTypes2.default.string,
	
	  /**
	   * Boolean if the button is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional href to convert the button into a link button.
	   */
	  href: _propTypes2.default.string,
	
	  /**
	   * An optional function to call when the button is clicked.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Boolean if the IconButton is floating
	  floating: PropTypes.bool,
	   /**
	   * An optional label to use if you would like a tooltip to display
	   * on hover or touch hold.
	   */
	  tooltipLabel: _propTypes2.default.node,
	
	  /**
	   * The position that the tooltip should be displayed relative to
	   * the button.
	   */
	  tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * An optional amount of delay before the tooltip appears.
	   */
	  tooltipDelay: _propTypes2.default.number,
	
	  // Inject from injectTooltip
	  tooltip: _propTypes2.default.node,
	  floating: _propTypes2.default.bool,
	
	  deprecated: (0, _componentDeprecated2.default)('The behavior of the `IconButton` can be achieved with the `Button` component ' + 'without the additional bundle size. Switch to the `Button` component and add a ' + 'prop `icon`.')
	};
	IconButton.defaultProps = {
	  type: 'button'
	};
	exports.default = (0, _injectTooltip2.default)(IconButton);
	//# sourceMappingURL=IconButton.js.map

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getBtnStyles;
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(12);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Since it can be helpful to apply button styles on other components, this is a utlity function
	 * to apply those styles based on props.
	 */
	function getBtnStyles(_ref) {
	  var _ref2;
	
	  var flat = _ref.flat,
	      raised = _ref.raised,
	      icon = _ref.icon,
	      floating = _ref.floating,
	      disabled = _ref.disabled,
	      primary = _ref.primary,
	      secondary = _ref.secondary,
	      hover = _ref.hover,
	      swapTheming = _ref.swapTheming,
	      pressed = _ref.pressed,
	      mini = _ref.mini,
	      fixed = _ref.fixed,
	      fixedPosition = _ref.fixedPosition;
	
	  var flatStyles = flat || icon;
	  var raisedStyles = raised || floating;
	  var textTheming = flatStyles && !swapTheming || raisedStyles && swapTheming;
	  var backgroundTheming = (!disabled && raisedStyles && !swapTheming || flatStyles && swapTheming) && (primary || secondary);
	
	  for (var _len = arguments.length, classNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    classNames[_key - 1] = arguments[_key];
	  }
	
	  return _classnames2.default.apply(undefined, ['md-btn', (_ref2 = {
	    'md-btn--flat': flat || disabled && raised,
	    'md-btn--raised': !disabled && raised,
	    'md-btn--icon': icon || floating,
	    'md-btn--floating': floating,
	    'md-btn--text': flat || raised,
	    'md-btn--hover': !disabled && hover,
	    'md-btn--raised-disabled': disabled && raised,
	    'md-btn--raised-pressed': !disabled && raisedStyles && pressed,
	    'md-btn--fixed': fixed
	  }, _defineProperty(_ref2, 'md-btn--fixed-' + fixedPosition, floating && fixed), _defineProperty(_ref2, 'md-btn--floating-mini', floating && mini), _defineProperty(_ref2, 'md-btn--color-primary-active', !disabled && primary && hover && textTheming), _defineProperty(_ref2, 'md-btn--color-secondary-active', !disabled && secondary && hover && textTheming), _defineProperty(_ref2, 'md-pointer--hover', !disabled), _defineProperty(_ref2, 'md-paper md-paper--2', !disabled && floating), _defineProperty(_ref2, 'md-paper--4', !disabled && floating && pressed), _ref2), (0, _themeColors2.default)({
	    text: !icon && !floating && !backgroundTheming,
	    themeText: !backgroundTheming,
	    disabled: disabled,
	    primary: primary,
	    secondary: secondary,
	    hover: true,
	    ink: true
	  })].concat(classNames));
	}
	//# sourceMappingURL=getBtnStyles.js.map

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _CardExpander = __webpack_require__(261);
	
	var _CardExpander2 = _interopRequireDefault(_CardExpander);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `CardActions` component is used for adding actions on your card.
	 * The actions should be `FlatButton`s or `IconButton`s.
	 *
	 * This component can act as a `CardExpander`.
	 */
	var CardActions = function (_Component) {
	  _inherits(CardActions, _Component);
	
	  function CardActions() {
	    _classCallCheck(this, CardActions);
	
	    return _possibleConstructorReturn(this, (CardActions.__proto__ || Object.getPrototypeOf(CardActions)).apply(this, arguments));
	  }
	
	  _createClass(CardActions, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          children = _props.children,
	          isExpander = _props.isExpander,
	          expander = _props.expander,
	          centered = _props.centered,
	          stacked = _props.stacked,
	          props = _objectWithoutProperties(_props, ['className', 'children', 'isExpander', 'expander', 'centered', 'stacked']);
	
	      return _react2.default.createElement(
	        'section',
	        _extends({}, props, {
	          className: (0, _classnames2.default)('md-dialog-footer--card', {
	            'md-dialog-footer--inline': !stacked,
	            'md-dialog-footer--stacked': stacked,
	            'md-dialog-footer--card-centered': centered
	          }, className)
	        }),
	        children,
	        isExpander || expander && _react2.default.createElement(_CardExpander2.default, null)
	      );
	    }
	  }]);
	
	  return CardActions;
	}(_react.Component);
	
	CardActions.propTypes = {
	  /**
	   * Boolean if this component should act as an expander and inject the
	   * `CardExpander`.
	   */
	  expander: _propTypes2.default.bool,
	
	  /**
	   * An optional className to apply to the actions container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An actions to display.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the actions should be centered.
	   */
	  centered: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the actions should be stacked.
	   */
	  stacked: _propTypes2.default.bool,
	
	  isExpander: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `expander` instead')
	};
	exports.default = CardActions;
	//# sourceMappingURL=CardActions.js.map

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _contextTypes = __webpack_require__(264);
	
	var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	var _Button = __webpack_require__(19);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _getCollapserStyles = __webpack_require__(114);
	
	var _getCollapserStyles2 = _interopRequireDefault(_getCollapserStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The CardExpander component is just a simple `IconButton` that
	 * gets generated through the `Card`'s `contextTypes`. Props are not used
	 * at all.
	 *
	 * Any component below a component that has this component inject into it
	 * and has the prop `expandable={true}` will be toggleable when this is clicked.
	 *
	 * You can manually inject the `CardExpander` component yourself if you want to
	 * use a component that is not a `CardActions` or a `CardTitle`.
	 */
	var CardExpander = function (_Component) {
	  _inherits(CardExpander, _Component);
	
	  function CardExpander() {
	    _classCallCheck(this, CardExpander);
	
	    return _possibleConstructorReturn(this, (CardExpander.__proto__ || Object.getPrototypeOf(CardExpander)).apply(this, arguments));
	  }
	
	  _createClass(CardExpander, [{
	    key: 'render',
	    value: function render() {
	      var _context = this.context,
	          expanded = _context.expanded,
	          onExpandClick = _context.onExpandClick,
	          icon = _context.icon,
	          tooltipPosition = _context.tooltipPosition,
	          tooltipLabel = _context.tooltipLabel,
	          tooltipDelay = _context.tooltipDelay;
	
	
	      return _react2.default.createElement(_Button2.default, {
	        icon: true,
	        className: (0, _getCollapserStyles2.default)({ flipped: expanded }, 'md-collapser--card'),
	        onClick: onExpandClick,
	        tooltipLabel: tooltipLabel,
	        tooltipDelay: tooltipDelay,
	        tooltipPosition: tooltipPosition,
	        iconEl: icon
	      });
	    }
	  }]);
	
	  return CardExpander;
	}(_react.Component);
	
	CardExpander.contextTypes = _contextTypes2.default;
	exports.default = CardExpander;
	//# sourceMappingURL=CardExpander.js.map

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _CardTitleBlock = __webpack_require__(263);
	
	var _CardTitleBlock2 = _interopRequireDefault(_CardTitleBlock);
	
	var _CardExpander = __webpack_require__(261);
	
	var _CardExpander2 = _interopRequireDefault(_CardExpander);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `CardTitle` component is used to render a title in a Card along
	 * with an optional subtitle or avatar.
	 */
	var CardTitle = function (_Component) {
	  _inherits(CardTitle, _Component);
	
	  function CardTitle() {
	    _classCallCheck(this, CardTitle);
	
	    return _possibleConstructorReturn(this, (CardTitle.__proto__ || Object.getPrototypeOf(CardTitle)).apply(this, arguments));
	  }
	
	  _createClass(CardTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          style = _props.style,
	          className = _props.className,
	          title = _props.title,
	          subtitle = _props.subtitle,
	          expander = _props.expander,
	          isExpander = _props.isExpander,
	          children = _props.children,
	          propAvatar = _props.avatar,
	          props = _objectWithoutProperties(_props, ['id', 'style', 'className', 'title', 'subtitle', 'expander', 'isExpander', 'children', 'avatar']);
	
	      var avatar = this.props.avatar;
	
	      if (avatar) {
	        var avatarClassName = _react.Children.only(avatar).props.className;
	
	        avatar = (0, _react.cloneElement)(avatar, {
	          className: (0, _classnames2.default)('md-avatar--card', avatarClassName)
	        });
	      }
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, {
	          style: style,
	          className: (0, _classnames2.default)('md-card-title', {
	            'md-card-title--primary': !avatar
	          }, className)
	        }),
	        avatar,
	        _react2.default.createElement(_CardTitleBlock2.default, { id: id, title: title, subtitle: subtitle, avatar: !!avatar }),
	        children,
	        isExpander || expander && _react2.default.createElement(_CardExpander2.default, null)
	      );
	    }
	  }]);
	
	  return CardTitle;
	}(_react.Component);
	
	CardTitle.propTypes = {
	  /**
	   * An optional id to add to the `title`.
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The title to display.
	   */
	  title: _propTypes2.default.node.isRequired,
	
	  /**
	   * An optional subtitle to display.
	   */
	  subtitle: _propTypes2.default.node,
	
	  /**
	   * Any additional children to display in the title block
	   * after the avatar, title, and subtitle.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An optional avatar to display before the title and subtitle.
	   */
	  avatar: _propTypes2.default.element,
	
	  /**
	   * Boolean if the `CardTitle` component should inject a button
	   * for expanding all children below it.
	   */
	  expander: _propTypes2.default.bool,
	
	  isExpander: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `expander` instead')
	};
	exports.default = CardTitle;
	//# sourceMappingURL=CardTitle.js.map

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(12);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CardTitleBlock = function (_PureComponent) {
	  _inherits(CardTitleBlock, _PureComponent);
	
	  function CardTitleBlock() {
	    _classCallCheck(this, CardTitleBlock);
	
	    return _possibleConstructorReturn(this, (CardTitleBlock.__proto__ || Object.getPrototypeOf(CardTitleBlock)).apply(this, arguments));
	  }
	
	  _createClass(CardTitleBlock, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          subtitle = _props.subtitle,
	          avatar = _props.avatar;
	      var title = this.props.title;
	
	      title = _react2.default.createElement(
	        'h2',
	        {
	          id: id,
	          className: (0, _classnames2.default)('md-card-title--title', {
	            'md-card-title--large': !avatar
	          }, (0, _themeColors2.default)({ text: true })),
	          tabIndex: id ? -1 : null
	        },
	        title
	      );
	
	      if (!subtitle) {
	        return title;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('md-card-title--title-block', {
	            'md-card-title--one-line': avatar
	          })
	        },
	        title,
	        _react2.default.createElement(
	          'h3',
	          { className: 'md-card-title--title ' + (0, _themeColors2.default)({ hint: true }) },
	          subtitle
	        )
	      );
	    }
	  }]);
	
	  return CardTitleBlock;
	}(_react.PureComponent);
	
	CardTitleBlock.propTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  title: _propTypes2.default.node.isRequired,
	  subtitle: _propTypes2.default.node,
	  avatar: _propTypes2.default.bool
	};
	exports.default = CardTitleBlock;
	//# sourceMappingURL=CardTitleBlock.js.map

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  onExpandClick: _propTypes2.default.func,
	  expanded: _propTypes2.default.bool,
	  icon: _propTypes2.default.element,
	  tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	  tooltipLabel: _propTypes2.default.node,
	  tooltipDelay: _propTypes2.default.number
	};
	//# sourceMappingURL=contextTypes.js.map

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This is just a simple <tfoot> component.
	 */
	var TableFooter = function (_PureComponent) {
	  _inherits(TableFooter, _PureComponent);
	
	  function TableFooter() {
	    _classCallCheck(this, TableFooter);
	
	    return _possibleConstructorReturn(this, (TableFooter.__proto__ || Object.getPrototypeOf(TableFooter)).apply(this, arguments));
	  }
	
	  _createClass(TableFooter, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return { footer: true };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['className', 'children']);
	
	      return _react2.default.createElement(
	        'tfoot',
	        _extends({ className: (0, _classnames2.default)('md-table-footer', className) }, props),
	        children
	      );
	    }
	  }]);
	
	  return TableFooter;
	}(_react.PureComponent);
	
	TableFooter.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The children to display. This should really be one or a list of `TableRow`
	   * components.
	   */
	  children: _propTypes2.default.node
	};
	TableFooter.childContextTypes = {
	  footer: _propTypes2.default.bool
	};
	exports.default = TableFooter;
	//# sourceMappingURL=TableFooter.js.map

/***/ }),
/* 266 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findFixedTo;
	function findFixedTo(table) {
	  if (table && table.firstChild.firstChild.classList.contains('md-data-table__scroll-wrapper')) {
	    return {
	      x: table,
	      y: table.firstChild.firstChild
	    };
	  }
	
	  return table;
	}
	//# sourceMappingURL=findFixedTo.js.map

/***/ }),
/* 267 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/** @module Drawers/DrawerTypes */
	
	/**
	 * An enum for all the different type of drawers.
	 *
	 * @readonly
	 * @enum {string}
	 */
	var DrawerTypes = {
	  // Permanent drawers
	  /**
	   * This is the default drawer type. It will always be on the screen and takes
	   * up the entire height. This is very helpful for main navigation on desktops
	   * when you do not need an expandable workspace.
	   */
	  FULL_HEIGHT: 'full-height',
	
	  /**
	   * This drawer type will always be on the screen, but it will appear under the
	   * main toolbar.
	   */
	  CLIPPED: 'clipped',
	
	  /**
	   * This drawer type will always be on the screen, but it will appear under the
	   * main toolbar and have a transparent background. This is useful if you want
	   * a persistent drawer on desktop screens, but do not want the main focus to be
	   * the drawer.
	   */
	  FLOATING: 'floating',
	
	  // Persistent drawers
	  /**
	   * A persistent drawer changes between being hidden and being fixed on the page like
	   * a permanent drawer. When it is visible, it will take up the same amount of room
	   * as a permanent drawer, and will not go away until closed.
	   *
	   * This drawer type is helpful when you need to have a dynamic workspace size.
	   */
	  PERSISTENT: 'persistent',
	
	  /**
	   * This is a modification of the persistent drawer. It will behave as the persistent drawer
	   * but it will always have a "mini" drawer visible. This is helpful when you want to have
	   * a dynamic workspace size and keep certain actions available at all times.
	   */
	  PERSISTENT_MINI: 'persistent-mini',
	
	  // Temporary
	  /**
	   * A temporary drawer will not be visible by default. When it is visible, it will overlay
	   * the page to get the main focus on the drawer. When the user touches the overlay or
	   * one of the navigation items, the drawer will be closed. The overlay can be disabled on
	   * desktop and tablets.
	   */
	  TEMPORARY: 'temporary',
	
	  /**
	   * This is a modification of the temporary drawer. It will behave like a temporary drawer,
	   * but it will always have a "mini" drawer visible. Just like the `PERSISTENT_MINI` drawer
	   * type, this is useful when certain actions should be available at all times but additional
	   * actions are available when the drawer is visible.
	   */
	  TEMPORARY_MINI: 'temporary-mini'
	};
	
	exports.default = DrawerTypes;
	//# sourceMappingURL=DrawerTypes.js.map

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isTemporary = isTemporary;
	exports.isPersistent = isPersistent;
	exports.isPermanent = isPermanent;
	exports.isMini = isMini;
	
	var _DrawerTypes = __webpack_require__(267);
	
	var _DrawerTypes2 = _interopRequireDefault(_DrawerTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FULL_HEIGHT = _DrawerTypes2.default.FULL_HEIGHT,
	    CLIPPED = _DrawerTypes2.default.CLIPPED,
	    FLOATING = _DrawerTypes2.default.FLOATING,
	    PERSISTENT = _DrawerTypes2.default.PERSISTENT,
	    PERSISTENT_MINI = _DrawerTypes2.default.PERSISTENT_MINI,
	    TEMPORARY = _DrawerTypes2.default.TEMPORARY,
	    TEMPORARY_MINI = _DrawerTypes2.default.TEMPORARY_MINI;
	function isTemporary(type) {
	  return [TEMPORARY, TEMPORARY_MINI].indexOf(type) !== -1;
	}
	
	function isPersistent(type) {
	  return [PERSISTENT, PERSISTENT_MINI].indexOf(type) !== -1;
	}
	
	function isPermanent(type) {
	  return [FULL_HEIGHT, CLIPPED, FLOATING].indexOf(type) !== -1;
	}
	
	function isMini(type) {
	  return [PERSISTENT_MINI, TEMPORARY_MINI].indexOf(type) !== -1;
	}
	//# sourceMappingURL=isType.js.map

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(17);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _keyCodes = __webpack_require__(15);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _captureNextEvent = __webpack_require__(82);
	
	var _captureNextEvent2 = _interopRequireDefault(_captureNextEvent);
	
	var _getBtnStyles = __webpack_require__(259);
	
	var _getBtnStyles2 = _interopRequireDefault(_getBtnStyles);
	
	var _FontIcon = __webpack_require__(13);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _IconSeparator = __webpack_require__(61);
	
	var _IconSeparator2 = _interopRequireDefault(_IconSeparator);
	
	var _AccessibleFakeInkedButton = __webpack_require__(29);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `FileInput` component is used as simple styling for the `<input type="file" />`.
	 * It will style the input as a raised button by default.
	 */
	var FileInput = function (_PureComponent) {
	  _inherits(FileInput, _PureComponent);
	
	  function FileInput() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FileInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FileInput.__proto__ || Object.getPrototypeOf(FileInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false, pressed: false, value: '' }, _this._handleChange = function (e) {
	      var _this$props = _this.props,
	          multiple = _this$props.multiple,
	          onChange = _this$props.onChange,
	          allowDuplicates = _this$props.allowDuplicates;
	      var _e$target = e.target,
	          files = _e$target.files,
	          value = _e$target.value;
	
	      if (onChange) {
	        if (!multiple) {
	          onChange(files[0] || null, e);
	        } else {
	          onChange(Array.prototype.slice.call(files), e);
	        }
	      }
	
	      if (!allowDuplicates) {
	        _this.setState({ value: value });
	      }
	    }, _this._blur = function () {
	      if (_this.props.disabled) {
	        return;
	      }
	
	      if (_this._timeout) {
	        _this._attemptedBlur = true;
	      } else {
	        _this.setState({ pressed: false });
	      }
	    }, _this._handleMouseUp = function (e) {
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(e);
	      }
	
	      _this._blur();
	    }, _this._handleMouseDown = function (e) {
	      if (_this.props.onMouseDown) {
	        _this.props.onMouseDown(e);
	      }
	
	      if (!_this.props.disabled) {
	        _this.setState({ pressed: true });
	      }
	    }, _this._handleTouchStart = function (e) {
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(e);
	      }
	
	      if (!_this.props.disabled) {
	        _this.setState({ pressed: true });
	      }
	    }, _this._handleTouchEnd = function (e) {
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(e);
	      }
	
	      _this._blur();
	      (0, _captureNextEvent2.default)('mouseover');
	    }, _this._handleKeyUp = function (e) {
	      if (_this.props.onKeyUp) {
	        _this.props.onKeyUp(e);
	      }
	
	      if ((e.which || e.keyCode) === _keyCodes.TAB) {
	        window.addEventListener('click', _this._blur);
	        _this.setState({ pressed: true });
	      }
	    }, _this._handleKeyDown = function (e) {
	      if (_this.props.onKeyDown) {
	        _this.props.onKeyDown(e);
	      }
	
	      var key = e.which || e.keyCode;
	
	      if (key === _keyCodes.TAB) {
	        window.removeEventListener('click', _this._blur);
	        _this.setState({ pressed: false });
	      } else if (key === _keyCodes.SPACE || key === _keyCodes.ENTER) {
	        e.preventDefault();
	        e.target.click();
	      }
	    }, _this._handleMouseOver = function (e) {
	      if (_this.props.onMouseOver) {
	        _this.props.onMouseOver(e);
	      }
	
	      if (!_this.props.disabled) {
	        _this.setState({ hover: true });
	      }
	    }, _this._handleMouseLeave = function (e) {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(e);
	      }
	
	      if (!_this.props.disabled) {
	        _this.setState({ hover: false });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FileInput, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.disabled && !nextProps.disabled && this.state.hover) {
	        this.setState({ hover: false });
	      }
	
	      if (nextProps.allowDuplicates && this.state.value) {
	        this.setState({ value: '' });
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      var _this2 = this;
	
	      // I honestly don't remember why this was implemented, but it was copied from the Button
	      // component
	      if (!this.state.pressed && nextState.pressed) {
	        this._timeout = setTimeout(function () {
	          _this2._timeout = null;
	          if (_this2._attemptedBlur) {
	            _this2._attemptedBlur = false;
	
	            _this2.setState({ pressed: false });
	          }
	        }, 450);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	
	      window.removeEventListener('click', this._blur);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          hover = _state.hover,
	          pressed = _state.pressed;
	
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          labelStyle = _props.labelStyle,
	          labelClassName = _props.labelClassName,
	          label = _props.label,
	          primary = _props.primary,
	          secondary = _props.secondary,
	          flat = _props.flat,
	          id = _props.id,
	          name = _props.name,
	          iconBefore = _props.iconBefore,
	          disabled = _props.disabled,
	          accept = _props.accept,
	          multiple = _props.multiple,
	          swapTheming = _props.swapTheming,
	          iconChildren = _props.iconChildren,
	          iconClassName = _props.iconClassName,
	          propIcon = _props.icon,
	          propValue = _props.value,
	          allowDuplicates = _props.allowDuplicates,
	          onChange = _props.onChange,
	          onKeyUp = _props.onKeyUp,
	          onKeyDown = _props.onKeyDown,
	          onMouseUp = _props.onMouseUp,
	          onMouseDown = _props.onMouseDown,
	          onMouseOver = _props.onMouseOver,
	          onMouseLeave = _props.onMouseLeave,
	          onTouchStart = _props.onTouchStart,
	          onTouchEnd = _props.onTouchEnd,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'labelStyle', 'labelClassName', 'label', 'primary', 'secondary', 'flat', 'id', 'name', 'iconBefore', 'disabled', 'accept', 'multiple', 'swapTheming', 'iconChildren', 'iconClassName', 'icon', 'value', 'allowDuplicates', 'onChange', 'onKeyUp', 'onKeyDown', 'onMouseUp', 'onMouseDown', 'onMouseOver', 'onMouseLeave', 'onTouchStart', 'onTouchEnd']);
	
	      var value = (0, _getField2.default)(this.props, this.state, 'value');
	      var icon = this.props.icon;
	
	      if (iconClassName || iconChildren) {
	        icon = _react2.default.createElement(
	          _FontIcon2.default,
	          { iconClassName: iconClassName },
	          iconChildren
	        );
	      }
	
	      var labelChildren = label;
	      if (icon) {
	        icon = _react2.default.cloneElement(icon, { inherit: true });
	        labelChildren = _react2.default.createElement(
	          _IconSeparator2.default,
	          { label: label, iconBefore: iconBefore },
	          icon
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, {
	          style: style,
	          className: (0, _classnames2.default)('md-inline-block md-file-input-container', className)
	        }),
	        _react2.default.createElement(
	          _AccessibleFakeInkedButton2.default,
	          {
	            component: 'label',
	            htmlFor: id,
	            disabled: disabled,
	            onTouchStart: this._handleTouchStart,
	            onTouchEnd: this._handleTouchEnd,
	            onMouseDown: this._handleMouseDown,
	            onMouseUp: this._handleMouseUp,
	            onKeyDown: this._handleKeyDown,
	            onKeyUp: this._handleKeyUp,
	            onMouseOver: this._handleMouseOver,
	            onMouseLeave: this._handleMouseLeave,
	            style: labelStyle,
	            className: (0, _getBtnStyles2.default)({
	              flat: flat,
	              raised: !flat,
	              disabled: disabled,
	              primary: primary,
	              secondary: secondary,
	              hover: hover,
	              swapTheming: swapTheming,
	              pressed: pressed
	            }, labelClassName)
	          },
	          labelChildren
	        ),
	        _react2.default.createElement('input', {
	          id: id,
	          name: name,
	          accept: accept,
	          type: 'file',
	          multiple: multiple,
	          disabled: disabled,
	          'aria-hidden': 'true',
	          className: 'md-file-input',
	          onChange: this._handleChange,
	          value: value,
	          tabIndex: -1
	        })
	      );
	    }
	  }]);
	
	  return FileInput;
	}(_react.PureComponent);
	
	FileInput.propTypes = {
	  /**
	   * The id for the text field. This is required for a11y and to get the `input type="file"` to
	   * open.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * An optional name to provide to the input.
	   */
	  name: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the label.
	   */
	  labelStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the label.
	   */
	  labelClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the `FileInput` should be styled with the primary color.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `FileInput` should be styled with the secondary color.
	   */
	  secondary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `FileInput` should be styled as a flat button instead of a
	   * raised button.
	   */
	  flat: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the theming should be swapped from text to background or vice-versa.
	   *
	   * @see {@link Buttons/Button#swapTheming}
	   */
	  swapTheming: _propTypes2.default.bool,
	
	  /**
	   * This should be a comma separated list of Media Types that the `FileInput` can
	   * accept. If this prop is left blank, any file will be accepted.
	   *
	   * The values can either be:
	   * - A file extension
	   * - audio/*
	   * - video/*
	   * - image/*
	   * - any valid [IANA Media Type](http://www.iana.org/assignments/media-types/media-types.xhtml)
	   *
	   * > NOTE: IE does not enforce this.
	   */
	  accept: _propTypes2.default.string,
	
	  /**
	   * Boolean if the same file is allowed to be uploaded multiple times. This will basically make the
	   * `value` of the file input always blank.
	   */
	  allowDuplicates: _propTypes2.default.bool,
	
	  /**
	   * Boolean if multiple files will be accepted.
	   */
	  multiple: _propTypes2.default.bool,
	
	  /**
	   * A label to display on the `FileInput`. This will be used with the `AccessibleFakeInkedButton` component to
	   * create a `<label>` for the `<input type="file">`.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * Boolean if the icons should appear before the label.
	   */
	  iconBefore: _propTypes2.default.bool,
	
	  /**
	   * An optional icon to display with the file download. This can be a `FontIcon` or an `SVGIcon`.
	   */
	  icon: _propTypes2.default.element,
	
	  /**
	   * A function to call when the value of the input changes. This will
	   * be triggered when the user selects a new file or cancels the new file selection.
	   *
	   * This function will be given the new [FileList](https://developer.mozilla.org/en-US/docs/Web/API/FileList)
	   * as an array and the change event. If this is not a multiple file input, only the
	   * newly selected File will be given instead of a list of one file. Since this is an
	   * `input` tag, the user will not be able to select the same file multiple times unless
	   * you manually clear the input's value.
	   *
	   * > NOTE: If the user hits cancel, null will be given for a single file input.
	   *
	   * ```js
	   * onChange(files, e);
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional value to apply to the `FileInput`. This is usually not needed and the
	   * `allowDuplicates` is what you are probably looking for instead.
	   *
	   * @see {@link #allowDuplicates}
	   */
	  value: _propTypes2.default.string,
	
	  /**
	   * Boolean if the `FileInput` is currently disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when they keyup event is triggered on the file input's label.
	   */
	  onKeyUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when they keydown event is triggered on the file input's label.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when they mouseup event is triggered on the file input's label.
	   */
	  onMouseUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when they mousedown event is triggered on the file input's label.
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when they mouseover event is triggered on the file input's label.
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when they mouseleave event is triggered on the file input's label.
	   */
	  onMouseLeave: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when they touchend event is triggered on the file input's label.
	   */
	  onTouchEnd: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when they touchstart event is triggered on the file input's label.
	   */
	  onTouchStart: _propTypes2.default.func,
	
	  iconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `icon` instead'),
	  iconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `icon` instead')
	};
	FileInput.defaultProps = {
	  label: 'Select a file',
	  icon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'file_upload'
	  ),
	  allowDuplicates: false
	};
	exports.default = FileInput;
	//# sourceMappingURL=FileInput.js.map

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FontIcon = undefined;
	
	var _FontIcon2 = __webpack_require__(13);
	
	var _FontIcon3 = _interopRequireDefault(_FontIcon2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FontIcon3.default;
	exports.FontIcon = _FontIcon3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bem2 = __webpack_require__(180);
	
	var _bem3 = _interopRequireDefault(_bem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DIFF_KEYS = ['className', 'align', 'position', 'size', 'offset', 'order', 'phoneSize', 'phoneOrder', 'phoneOffset', 'phoneHidden', 'tabletSize', 'tabletOrder', 'tabletOffset', 'tabletHidden', 'desktopSize', 'desktopOrder', 'desktopOffset', 'desktopHidden'];
	
	var Cell = function (_PureComponent) {
	  _inherits(Cell, _PureComponent);
	
	  _createClass(Cell, null, [{
	    key: 'getClassName',
	
	
	    /**
	     * A utility function to get the cell's className based on the Cell's props. This is
	     * used behind the scenes to merge and create the className for the cell.
	     *
	     * ### Example:
	     * ```js
	     * <div className={Cell.getClassName()}>A simple cell</div>
	     * <div className={Cell.getClassName({ size: 1 })}>A cell with size 1</div>
	     * ```
	     *
	     * @param {Object=} props - This should be an object of the `Cell`'s props. It
	     *    will extract the needed keys and generate the className.
	     * @return {String} the full className to use for the cell
	     */
	    value: function getClassName() {
	      var _bem;
	
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var className = props.className,
	          align = props.align,
	          position = props.position,
	          size = props.size,
	          order = props.order,
	          offset = props.offset,
	          phoneSize = props.phoneSize,
	          phoneOrder = props.phoneOrder,
	          phoneOffset = props.phoneOffset,
	          phoneHidden = props.phoneHidden,
	          tabletSize = props.tabletSize,
	          tabletOrder = props.tabletOrder,
	          tabletOffset = props.tabletOffset,
	          tabletHidden = props.tabletHidden,
	          desktopSize = props.desktopSize,
	          desktopOrder = props.desktopOrder,
	          desktopOffset = props.desktopOffset,
	          desktopHidden = props.desktopHidden;
	
	
	      return (0, _bem3.default)('md-cell', (_bem = {}, _defineProperty(_bem, align, align), _defineProperty(_bem, position, position), _defineProperty(_bem, size, size), _defineProperty(_bem, 'order-' + order, order), _defineProperty(_bem, offset + '-offset', offset), _defineProperty(_bem, phoneSize + '-phone', phoneSize), _defineProperty(_bem, 'order-' + phoneOrder + '-phone', phoneOrder), _defineProperty(_bem, phoneOffset + '-phone-offset', phoneOffset), _defineProperty(_bem, 'phone-hidden', phoneHidden), _defineProperty(_bem, tabletSize + '-tablet', tabletSize), _defineProperty(_bem, 'order-' + tabletOrder + '-tablet', tabletOrder), _defineProperty(_bem, tabletOffset + '-tablet-offset', tabletOffset), _defineProperty(_bem, 'tablet-hidden', tabletHidden), _defineProperty(_bem, desktopSize + '-desktop', desktopSize), _defineProperty(_bem, 'order-' + desktopOrder + '-desktop', desktopOrder), _defineProperty(_bem, desktopOffset + '-desktop-offset', desktopOffset), _defineProperty(_bem, 'desktop-hidden', desktopHidden), _bem), className);
	    }
	  }]);
	
	  function Cell(props) {
	    _classCallCheck(this, Cell);
	
	    var _this = _possibleConstructorReturn(this, (Cell.__proto__ || Object.getPrototypeOf(Cell)).call(this));
	
	    _this.state = { className: Cell.getClassName(props) };
	    return _this;
	  }
	
	  _createClass(Cell, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({ className: Cell.getClassName(this.props) });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (DIFF_KEYS.some(function (key) {
	        return _this2.props[key] !== nextProps[key];
	      })) {
	        this.setState({ className: Cell.getClassName(nextProps) });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var className = this.state.className;
	
	      var _props = this.props,
	          style = _props.style,
	          Component = _props.component,
	          children = _props.children,
	          propClassName = _props.className,
	          align = _props.align,
	          position = _props.position,
	          size = _props.size,
	          offset = _props.offset,
	          order = _props.order,
	          phoneSize = _props.phoneSize,
	          phoneOrder = _props.phoneOrder,
	          phoneOffset = _props.phoneOffset,
	          phoneHidden = _props.phoneHidden,
	          tabletSize = _props.tabletSize,
	          tabletOrder = _props.tabletOrder,
	          tabletOffset = _props.tabletOffset,
	          tabletHidden = _props.tabletHidden,
	          desktopSize = _props.desktopSize,
	          desktopOrder = _props.desktopOrder,
	          desktopOffset = _props.desktopOffset,
	          desktopHidden = _props.desktopHidden,
	          props = _objectWithoutProperties(_props, ['style', 'component', 'children', 'className', 'align', 'position', 'size', 'offset', 'order', 'phoneSize', 'phoneOrder', 'phoneOffset', 'phoneHidden', 'tabletSize', 'tabletOrder', 'tabletOffset', 'tabletHidden', 'desktopSize', 'desktopOrder', 'desktopOffset', 'desktopHidden']);
	
	      if (typeof children === 'function') {
	        return children({ style: style, className: className });
	      }
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, { style: style, className: className }),
	        children
	      );
	    }
	  }]);
	
	  return Cell;
	}(_react.PureComponent);
	
	Cell.propTypes = {
	  /**
	   * An optional style to apply to the Cell component. This will only be applied
	   * if the `children` prop is not a callback function.
	   *
	   * @see {@link #children}
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the Cell component. This will only be applied
	   * if the `children` prop is not a callback function.
	   *
	   * @see {@link #children}
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The component to render the Cell as. This should probably not be used as much
	   * as the `children` callback function.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	
	  /**
	   * The children can either be renderable React elements or a callback function
	   * that accepts the style and className props to apply so that the styles can
	   * be manually added to whichever component.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	
	  /**
	   * An optional cell alignment to apply. When the `Grid` is not `stacked`,
	   * this will apply to vertical alignment within each "row" of the grid.
	   *
	   * Alignments:
	   * - `top` - This will align to the top of the row
	   * - `middle` - This will align to the middle of the row
	   * - `bottom` - This will align to the bottom of the row
	   * - `stretch` - This will make the cell stretch to fill all the available space
	   *   in the row.
	   *
	   * @see {@link #position}
	   */
	  align: _propTypes2.default.oneOf(['top', 'middle', 'bottom', 'stretch']),
	
	  /**
	   * An optional cell position to apply. When the `Grid` is not `stacked`,
	   * this will apply to horizontal alignment within each "row" of the grid.
	   *
	   * Positions:
	   * - `center` - This will align the cell to be within the center of the row. This really
	   *    just applies `margin-left: auto; margin-right: auto`.
	   * - `right` - This will align the cell to the end of the row. This really just applies `margin-left: auto`.
	   *
	   * @see {@link #align}
	   */
	  position: _propTypes2.default.oneOf(['center', 'right']),
	
	  /**
	   * An optional size to apply to the cell. This sizing will be applied across all media sizes.
	   * If the size is greater than the number of columns allowed for the media size, it will just
	   * span the entire width.
	   */
	  size: _propTypes2.default.number,
	
	  /**
	   * An optional order to apply to the cell. This order will be applied across all media sizes.
	   */
	  order: _propTypes2.default.number,
	
	  /**
	   * An optional offset to apply to the cell. This will add spacing to the left of the cell.
	   */
	  offset: _propTypes2.default.number,
	
	  /**
	   * An optional size to apply to the cell only on phones.
	   */
	  phoneSize: _propTypes2.default.number,
	
	  /**
	   * An optional order to apply to the cell only on phones.
	   */
	  phoneOrder: _propTypes2.default.number,
	
	  /**
	   * An optional offset to apply to the cell only on phones.
	   */
	  phoneOffset: _propTypes2.default.number,
	
	  /**
	   * Boolean if the cell should be hidden on phones only.
	   */
	  phoneHidden: _propTypes2.default.bool,
	
	  /**
	   * An optional size to apply to the cell only on tablets.
	   */
	  tabletSize: _propTypes2.default.number,
	
	  /**
	   * An optional order to apply to the cell only on tablets.
	   */
	  tabletOrder: _propTypes2.default.number,
	
	  /**
	   * An optional offset to apply to the cell only on tablets.
	   */
	  tabletOffset: _propTypes2.default.number,
	
	  /**
	   * Boolean if the cell should be hidden on tablets only.
	   */
	  tabletHidden: _propTypes2.default.bool,
	
	  /**
	   * An optional size to apply to the cell only on desktops.
	   */
	  desktopSize: _propTypes2.default.number,
	
	  /**
	   * An optional order to apply to the cell only on desktops.
	   */
	  desktopOrder: _propTypes2.default.number,
	
	  /**
	   * An optional offset to apply to the cell only on desktops.
	   */
	  desktopOffset: _propTypes2.default.number,
	
	  /**
	   * Boolean if the cell should be hidden on desktops only.
	   */
	  desktopHidden: _propTypes2.default.bool
	};
	Cell.defaultProps = {
	  component: 'div',
	  phoneHidden: false,
	  tabletHidden: false,
	  desktopHidden: false
	};
	exports.default = Cell;
	//# sourceMappingURL=Cell.js.map

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bem2 = __webpack_require__(180);
	
	var _bem3 = _interopRequireDefault(_bem2);
	
	var _isValued = __webpack_require__(115);
	
	var _isValued2 = _interopRequireDefault(_isValued);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DIFF_KEYS = ['className', 'stacked', 'container', 'noSpacing', 'gutter', 'spacing'];
	
	var Grid = function (_PureComponent) {
	  _inherits(Grid, _PureComponent);
	
	  _createClass(Grid, null, [{
	    key: 'getClassName',
	
	
	    /**
	     * A utility function to get the grid's className based on the Grid's props. This is
	     * used behind the scenes to merge and create the className for the grid.
	     *
	     * ### Example:
	     * ```js
	     * <div className={Grid.getClassName()}>A base grid</div>
	     * <div className={Grid.getClassName({ stacked: true })}>A stacked Grid</div>
	     * ```
	     *
	     * @param {Object=} props - This should be an object of the `Grid`'s props. It
	     *    will extract the needed keys and generate the className.
	     * @return {String} the full className to use for the grid
	     */
	    value: function getClassName() {
	      var _bem;
	
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var className = props.className,
	          stacked = props.stacked,
	          noSpacing = props.noSpacing,
	          gutter = props.gutter,
	          spacing = props.spacing,
	          container = props.container;
	
	      return (0, _bem3.default)('md-grid', (_bem = {
	        'stacked': stacked,
	        'no-spacing': noSpacing
	      }, _defineProperty(_bem, gutter + '-' + spacing, (0, _isValued2.default)(gutter) && (0, _isValued2.default)(spacing)), _defineProperty(_bem, container, container), _bem), className);
	    }
	  }]);
	
	  function Grid(props) {
	    _classCallCheck(this, Grid);
	
	    var _this = _possibleConstructorReturn(this, (Grid.__proto__ || Object.getPrototypeOf(Grid)).call(this));
	
	    _this.state = { className: Grid.getClassName(props) };
	    return _this;
	  }
	
	  _createClass(Grid, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({ className: Grid.getClassName(this.props) });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (DIFF_KEYS.some(function (key) {
	        return _this2.props[key] !== nextProps[key];
	      })) {
	        this.setState({ className: Grid.getClassName(nextProps) });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var className = this.state.className;
	
	      var _props = this.props,
	          style = _props.style,
	          Component = _props.component,
	          children = _props.children,
	          propClassName = _props.className,
	          container = _props.container,
	          stacked = _props.stacked,
	          noSpacing = _props.noSpacing,
	          gutter = _props.gutter,
	          spacing = _props.spacing,
	          props = _objectWithoutProperties(_props, ['style', 'component', 'children', 'className', 'container', 'stacked', 'noSpacing', 'gutter', 'spacing']);
	
	      if (typeof children === 'function') {
	        return children({ style: style, className: className });
	      }
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, { style: style, className: className }),
	        children
	      );
	    }
	  }]);
	
	  return Grid;
	}(_react.PureComponent);
	
	Grid.propTypes = {
	  /**
	   * An optional style to apply to the Grid component. This will only be applied
	   * if the `children` prop is not a callback function.
	   *
	   * @see {@link #children}
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the Grid component. This will only be applied
	   * if the `children` prop is not a callback function.
	   *
	   * @see {@link #children}
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The component to render the Grid as. This should probably not be used as much
	   * as the `children` callback function.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	
	  /**
	   * The children can either be renderable React elements or a callback function
	   * that accepts the style and className props to apply so that the styles can
	   * be manually added to whichever component.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	
	  /**
	   * An optional container name to apply to the Grid. This should be the same name as provided
	   * to the [react-md-make-grid-container](/components/grids?tab=2#mixin-react-md-make-grid-container) mixin.
	   */
	  container: _propTypes2.default.string,
	
	  /**
	   * Boolean if the grid should be placed vertically instead of horizontally.
	   */
	  stacked: _propTypes2.default.bool,
	
	  /**
	   * Boolean if all the gutters and spacing should be removed from the grid.
	   */
	  noSpacing: _propTypes2.default.bool,
	
	  /**
	   * When the [react-md-make-custom-grid](/components/grids?tab=2#mixin-react-md-make-custom-grid) mixin
	   * is used, you can use the `gutter` and `spacing` props on the `Grid` to apply the correct className
	   */
	  gutter: _propTypes2.default.number,
	
	  /**
	   * When the [react-md-make-custom-grid](/components/grids?tab=2#mixin-react-md-make-custom-grid) mixin
	   * is used, you can use the `gutter` and `spacing` props on the `Grid` to apply the correct className
	   */
	  spacing: _propTypes2.default.number
	};
	Grid.defaultProps = {
	  component: 'div',
	  stacked: false,
	  noSpacing: false
	};
	exports.default = Grid;
	//# sourceMappingURL=Grid.js.map

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _isValidFocusKeypress = __webpack_require__(671);
	
	var _isValidFocusKeypress2 = _interopRequireDefault(_isValidFocusKeypress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hrefables = ['a', 'area'].map(function (tag) {
	  return tag + '[href],';
	}).join('');
	var disableables = ['button', 'input', 'textarea', 'select'].map(function (tag) {
	  return tag + ':not([disabled]),';
	}).join('');
	var FOCUSABLE_QUERY = '' + hrefables + disableables + '*[tabIndex]';
	
	/**
	 * This component is used for keeping the focus within some container. When the container
	 * is mounted and the `focusOnMount` prop is `true`, it will attempt to focus either:
	 * - an element that matches `document.getElementById(this.props.initialFocus)`
	 * - an element that matches `this._container.querySelector(this.props.initialFocus)`
	 * - the first focusable element in it's children (if `this.props.initialFocus` is omitted)
	 */
	
	var FocusContainer = function (_PureComponent) {
	  _inherits(FocusContainer, _PureComponent);
	
	  function FocusContainer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FocusContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FocusContainer.__proto__ || Object.getPrototypeOf(FocusContainer)).call.apply(_ref, [this].concat(args))), _this), _this._enableFocusTrap = function () {
	      window.addEventListener('keydown', _this._handleKeyDown, true);
	    }, _this._disableFocusTrap = function () {
	      window.removeEventListener('keydown', _this._handleKeyDown, true);
	    }, _this._attemptInitialFocus = function () {
	      if (!_this._container) {
	        return;
	      }
	
	      var initialFocus = _this.props.initialFocus;
	
	
	      var toFocus = initialFocus ? document.getElementById(initialFocus) || _this._container.querySelector(initialFocus) : _this._focusables[0];
	
	      var debugError = void 0;
	      if (!toFocus && initialFocus) {
	        debugError = ' The `initialFocus` did not match a document\'s `id` or was an invalid ';
	        debugError += '`querySelector` for the container. `initialFocus`: `' + initialFocus + '`. ';
	        debugError += 'If this was supposed to be an `id`, make sure to prefix with the `#` symbol.';
	      }
	
	      if (false) {
	        throw new Error('You specified that the `FocusContainer` should focus an element on mount, ' + 'but a focusable element was not found in the children. This could be because ' + 'the `initialFocus` prop is an invalid id or query selector, or the children ' + ('do not contain a valid focusable element.' + debugError));
	      }
	
	      if (toFocus) {
	        toFocus.focus();
	      }
	    }, _this._containFocus = function (containerRef) {
	      if (containerRef === null) {
	        _this._container = null;
	        _this._disableFocusTrap();
	        return;
	      }
	
	      var _this$props = _this.props,
	          focusOnMount = _this$props.focusOnMount,
	          containFocus = _this$props.containFocus;
	
	      _this._container = (0, _reactDom.findDOMNode)(containerRef);
	      _this._focusables = Array.prototype.slice.call(_this._container.querySelectorAll(FOCUSABLE_QUERY)).filter(function (el) {
	        return el.tabIndex !== -1;
	      });
	
	      if (focusOnMount) {
	        _this._attemptInitialFocus();
	      }
	
	      if (containFocus) {
	        _this._enableFocusTrap();
	      }
	    }, _this._handleKeyDown = function (e) {
	      _this._shifted = e.shiftKey;
	      if (!(0, _isValidFocusKeypress2.default)(e, _this.props.additionalFocusKeys)) {
	        return;
	      } else if (_this._focusables.length === 1) {
	        e.preventDefault();
	        return;
	      }
	
	      var target = e.target,
	          shiftKey = e.shiftKey;
	
	      var _this$_focusables = _toArray(_this._focusables),
	          first = _this$_focusables[0],
	          focusables = _this$_focusables.slice(1);
	
	      var last = focusables[focusables.length - 1];
	
	      if (shiftKey && target === first) {
	        e.preventDefault();
	        last.focus();
	      } else if (!shiftKey && target === last) {
	        e.preventDefault();
	        first.focus();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FocusContainer, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.containFocus === nextProps.containFocus) {
	        return;
	      }
	
	      if (nextProps.containFocus) {
	        this._enableFocusTrap();
	        this._attemptInitialFocus();
	      } else {
	        this._disableFocusTrap();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.containFocus && this._container) {
	        this._focusables = Array.prototype.slice.call(this._container.querySelectorAll(FOCUSABLE_QUERY)).filter(function (el) {
	          return el.tabIndex !== -1;
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.containFocus) {
	        this._disableFocusTrap();
	      }
	    }
	
	    /**
	     * Manages the event listeners to contain the focus within some container.  When the container
	     * ref is not null, the container has mounted and then attempts to focus an element inside
	     * if the `focusOnMount` prop is `true`.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.component,
	          initialFocus = _props.initialFocus,
	          focusOnMount = _props.focusOnMount,
	          containFocus = _props.containFocus,
	          additionalFocusKeys = _props.additionalFocusKeys,
	          props = _objectWithoutProperties(_props, ['component', 'initialFocus', 'focusOnMount', 'containFocus', 'additionalFocusKeys']);
	
	      return _react2.default.createElement(Component, _extends({}, props, { ref: this._containFocus }));
	    }
	  }]);
	
	  return FocusContainer;
	}(_react.PureComponent);
	
	FocusContainer.propTypes = {
	  /**
	   * The component to render as. This can be a React DOM element or
	   * a react Component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The children to display.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An optional id string or a query selector string to use for the initial focus.
	   * This will only be triggered if the `focusOnMount` prop is `true`. If this is
	   * omitted and the `focusOnMount` prop is `true`, the first focusable element in the
	   * container will be focused.
	   *
	   * Examples:
	   *
	   * ```js
	   * initialFocus="#someAmazingId"
	   * // or
	   * initialFocus=".md-btn,.md-list-tile"
	   * ```
	   */
	  initialFocus: _propTypes2.default.string,
	
	  /**
	   * Boolean if an element in the container should be focused when mounted.
	   */
	  focusOnMount: _propTypes2.default.bool,
	
	  /**
	   * An optional list of additional key codes to use for focus events.
	   */
	  additionalFocusKeys: _propTypes2.default.arrayOf(_propTypes2.default.number),
	
	  /**
	   * Boolean if the focus container should start or stop containing the focus within the container.
	   * This is useful for changing the focus requirements after mount.
	   */
	  containFocus: _propTypes2.default.bool
	};
	FocusContainer.defaultProps = {
	  component: 'div',
	  containFocus: true
	};
	exports.default = FocusContainer;
	//# sourceMappingURL=FocusContainer.js.map

/***/ }),
/* 274 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/** @module Helpers/HorizontalAnchors */
	
	/**
	 * An enum for all the different types of horizontal anchors on a layover.
	 *
	 * @readonly
	 * @enum {string}
	 */
	var HorizontalAnchors = {
	  /**
	   * Positions the layover to the outside left on the toggle component
	   * so that it does not overlap.
	   */
	  LEFT: 'left',
	
	  /**
	   * Positions the layover to the inner left of the toggle component so
	   * that it will overlap.
	   */
	  INNER_LEFT: 'inner left',
	
	  /**
	   * Positions the layover so that it overlaps the toggle component
	   * by positioning itself in the cetner of the toggle component's width.
	   */
	  CENTER: 'center',
	
	  /**
	   * Positions the layover to the outside right on the toggle component
	   * so that it does not overlap.
	   */
	  RIGHT: 'right',
	
	  /**
	   * Positions the layover to the outside right on the toggle component
	   * so that it will overlap.
	   */
	  INNER_RIGHT: 'inner right'
	};
	
	exports.default = HorizontalAnchors;
	//# sourceMappingURL=HorizontalAnchors.js.map

/***/ }),
/* 275 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/** @module Helpers/Positions */
	
	/**
	 * An enum for all the animation positions for a layover appearing.
	 *
	 * @readonly
	 * @enum {string}
	 */
	var Positions = {
	  /**
	   * The layover will appear by transitioning from the top left and expand
	   * down right.
	   */
	  TOP_LEFT: 'tl',
	
	  /**
	   * The layover will appear by transitioning from the top right and expand
	   * down left.
	   */
	  TOP_RIGHT: 'tr',
	
	  /**
	   * The layover will appear by transitioning from the bottom left and expand
	   * top right.
	   */
	  BOTTOM_LEFT: 'bl',
	
	  /**
	   * The layover will appear by transitioning from the bottom right and expand
	   * top left.
	   */
	  BOTTOM_RIGHT: 'br',
	
	  /**
	   * The layover will appear by just transitioning downwards from the bottom
	   * of the toggle component.
	   */
	  BELOW: 'below'
	};
	
	exports.default = Positions;
	//# sourceMappingURL=Positions.js.map

/***/ }),
/* 276 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/** @module Helpers/VerticalAnchors */
	
	/**
	 * An enum for all the different types of horizontal anchors on a layover.
	 *
	 * @readonly
	 * @enum {string}
	 */
	var VerticalAnchors = {
	  /**
	   * Positions the layover to be placed over the toggle component so that
	   * it will never overlay the toggle component.
	   */
	  TOP: 'top',
	
	  /**
	   * Positions the layover so that it will be centered over the toggle component
	   * based on the layover's height.
	   */
	  CENTER: 'center',
	
	  /**
	   * Positions the layover so that it will overlap the toggle component by
	   * fixing to the top of the toggle.
	   */
	  OVERLAP: 'overlap',
	
	  /**
	   * Positions the layover to be placed below the toggle component so that
	   * it will never overlay the toggle component.
	   */
	  BOTTOM: 'bottom'
	};
	
	exports.default = VerticalAnchors;
	//# sourceMappingURL=VerticalAnchors.js.map

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(12);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `ListItemText` component is used to render the `primaryText` and an optional
	 * `secondaryText` for a `ListItem`.
	 */
	var ListItemText = function (_PureComponent) {
	  _inherits(ListItemText, _PureComponent);
	
	  function ListItemText() {
	    _classCallCheck(this, ListItemText);
	
	    return _possibleConstructorReturn(this, (ListItemText.__proto__ || Object.getPrototypeOf(ListItemText)).apply(this, arguments));
	  }
	
	  _createClass(ListItemText, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          activeClassName = _props.activeClassName,
	          disabled = _props.disabled,
	          primaryText = _props.primaryText,
	          primaryTextStyle = _props.primaryTextStyle,
	          primaryTextClassName = _props.primaryTextClassName,
	          secondaryText = _props.secondaryText,
	          secondaryTextStyle = _props.secondaryTextStyle,
	          secondaryTextClassName = _props.secondaryTextClassName,
	          className = _props.className,
	          threeLines = _props.threeLines,
	          props = _objectWithoutProperties(_props, ['active', 'activeClassName', 'disabled', 'primaryText', 'primaryTextStyle', 'primaryTextClassName', 'secondaryText', 'secondaryTextStyle', 'secondaryTextClassName', 'className', 'threeLines']);
	
	      var secondaryTextNode = void 0;
	      if (secondaryText) {
	        secondaryTextNode = _react2.default.createElement(
	          'div',
	          {
	            style: secondaryTextStyle,
	            className: (0, _classnames2.default)('md-tile-text--secondary', {
	              'md-tile-text--three-lines': threeLines
	            }, (0, _themeColors2.default)({ disabled: disabled, hint: !disabled }), secondaryTextClassName)
	          },
	          secondaryText
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, { className: (0, _classnames2.default)('md-tile-content', className) }),
	        _react2.default.createElement(
	          'div',
	          {
	            style: primaryTextStyle,
	            className: (0, _classnames2.default)('md-tile-text--primary', _defineProperty({}, activeClassName, !disabled && active), (0, _themeColors2.default)({ disabled: disabled, text: !active }), primaryTextClassName)
	          },
	          primaryText
	        ),
	        secondaryTextNode
	      );
	    }
	  }]);
	
	  return ListItemText;
	}(_react.PureComponent);
	
	ListItemText.propTypes = {
	  active: _propTypes2.default.bool,
	  activeClassName: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  primaryText: _propTypes2.default.node.isRequired,
	  primaryTextStyle: _propTypes2.default.object,
	  primaryTextClassName: _propTypes2.default.string,
	  secondaryText: _propTypes2.default.node,
	  secondaryTextStyle: _propTypes2.default.object,
	  secondaryTextClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  threeLines: _propTypes2.default.bool
	};
	exports.default = ListItemText;
	//# sourceMappingURL=ListItemText.js.map

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function validateAspectRatio(props, propName, component) {
	  var _PropTypes$string;
	
	  var value = props[propName];
	
	  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    args[_key - 3] = arguments[_key];
	  }
	
	  var err = (_PropTypes$string = _propTypes2.default.string).isRequired.apply(_PropTypes$string, [props, propName, component].concat(args));
	  if (!err && value.split('-').length !== 2) {
	    err = new Error('Your provided an `' + propName + '` prop to the ' + component + ' that is not a valid ' + ('aspect ratio `' + value + '`. This should be in the form of \'{width}-{height}\'.'));
	  }
	
	  return err;
	}
	
	/**
	 * The `Media` component is used to display images, iframes, ...media. Who'da thunk?
	 */
	
	var Media = function (_PureComponent) {
	  _inherits(Media, _PureComponent);
	
	  function Media() {
	    _classCallCheck(this, Media);
	
	    return _possibleConstructorReturn(this, (Media.__proto__ || Object.getPrototypeOf(Media)).apply(this, arguments));
	  }
	
	  _createClass(Media, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.component,
	          className = _props.className,
	          children = _props.children,
	          forceAspect = _props.forceAspect,
	          aspectRatio = _props.aspectRatio,
	          expandable = _props.expandable,
	          props = _objectWithoutProperties(_props, ['component', 'className', 'children', 'forceAspect', 'aspectRatio', 'expandable']);
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, {
	          className: (0, _classnames2.default)('md-media', _defineProperty({}, 'md-media--' + aspectRatio, forceAspect), className)
	        }),
	        children
	      );
	    }
	  }]);
	
	  return Media;
	}(_react.PureComponent);
	
	Media.propTypes = {
	  /**
	   * An optional className to apply to the card media component.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Any media to display.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the aspect ratio should be forced.
	   */
	  forceAspect: _propTypes2.default.bool,
	
	  /**
	   * The aspect ratio to use.
	   */
	  aspectRatio: validateAspectRatio,
	
	  /**
	   * Boolean if this component should be expandable when there is a `CardExpander`
	   * above it in the `Card`.
	   */
	  expandable: _propTypes2.default.bool,
	
	  /**
	   * The component to render the card media as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Media.defaultProps = {
	  forceAspect: true,
	  aspectRatio: '16-9',
	  component: 'section'
	};
	exports.default = Media;
	//# sourceMappingURL=Media.js.map

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `MediaOverlay` component is just a very simple wrapper that adds the
	 * `.md-media-overlay` class name to a div. The overlay will be positioned
	 * at the bottom of the `Media` by default.
	 */
	var MediaOverlay = function (_PureComponent) {
	  _inherits(MediaOverlay, _PureComponent);
	
	  function MediaOverlay() {
	    _classCallCheck(this, MediaOverlay);
	
	    return _possibleConstructorReturn(this, (MediaOverlay.__proto__ || Object.getPrototypeOf(MediaOverlay)).apply(this, arguments));
	  }
	
	  _createClass(MediaOverlay, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          Component = _props.component,
	          props = _objectWithoutProperties(_props, ['className', 'component']);
	
	      return _react2.default.createElement(Component, _extends({ className: (0, _classnames2.default)('md-media-overlay', className) }, props));
	    }
	  }]);
	
	  return MediaOverlay;
	}(_react.PureComponent);
	
	MediaOverlay.propTypes = {
	  /**
	   * An optional style to apply to the overlay.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the overlay.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Any children to display in the overlay. This is _normally_ a `CardTitle` component
	   * or some buttons.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The component to be rendered as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	MediaOverlay.defaultProps = {
	  component: 'div'
	};
	exports.default = MediaOverlay;
	//# sourceMappingURL=MediaOverlay.js.map

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _controlled = __webpack_require__(16);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _anchorShape = __webpack_require__(38);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(22);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(39);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _Button = __webpack_require__(19);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _DropdownMenu = __webpack_require__(173);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `MenuButton` is a simple wrapper / combination of the `Button` and the `Menu`
	 * components that can be uncontrolled.
	 */
	var MenuButton = function (_PureComponent) {
	  _inherits(MenuButton, _PureComponent);
	
	  function MenuButton() {
	    _classCallCheck(this, MenuButton);
	
	    return _possibleConstructorReturn(this, (MenuButton.__proto__ || Object.getPrototypeOf(MenuButton)).apply(this, arguments));
	  }
	
	  _createClass(MenuButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          listId = _props.listId,
	          buttonId = _props.buttonId,
	          menuStyle = _props.menuStyle,
	          menuClassName = _props.menuClassName,
	          listStyle = _props.listStyle,
	          listClassName = _props.listClassName,
	          listProps = _props.listProps,
	          listZDepth = _props.listZDepth,
	          listInline = _props.listInline,
	          listHeightRestricted = _props.listHeightRestricted,
	          menuItems = _props.menuItems,
	          buttonChildren = _props.buttonChildren,
	          children = _props.children,
	          anchor = _props.anchor,
	          belowAnchor = _props.belowAnchor,
	          fixedTo = _props.fixedTo,
	          position = _props.position,
	          cascading = _props.cascading,
	          cascadingAnchor = _props.cascadingAnchor,
	          cascadingZDepth = _props.cascadingZDepth,
	          fullWidth = _props.fullWidth,
	          block = _props.block,
	          centered = _props.centered,
	          sameWidth = _props.sameWidth,
	          repositionOnScroll = _props.repositionOnScroll,
	          repositionOnResize = _props.repositionOnResize,
	          xThreshold = _props.xThreshold,
	          yThreshold = _props.yThreshold,
	          closeOnOutsideClick = _props.closeOnOutsideClick,
	          transitionName = _props.transitionName,
	          transitionEnterTimeout = _props.transitionEnterTimeout,
	          transitionLeaveTimeout = _props.transitionLeaveTimeout,
	          visible = _props.visible,
	          defaultVisible = _props.defaultVisible,
	          onVisibilityChange = _props.onVisibilityChange,
	          simplifiedMenu = _props.simplifiedMenu,
	          minLeft = _props.minLeft,
	          minRight = _props.minRight,
	          minBottom = _props.minBottom,
	          fillViewportWidth = _props.fillViewportWidth,
	          fillViewportHeight = _props.fillViewportHeight,
	          onMenuClick = _props.onMenuClick,
	          onMenuMouseDown = _props.onMenuMouseDown,
	          onMenuMouseUp = _props.onMenuMouseUp,
	          onMenuMouseEnter = _props.onMenuMouseEnter,
	          onMenuMouseMove = _props.onMenuMouseMove,
	          onMenuMouseLeave = _props.onMenuMouseLeave,
	          onMenuTouchStart = _props.onMenuTouchStart,
	          onMenuTouchMove = _props.onMenuTouchMove,
	          onMenuTouchCancel = _props.onMenuTouchCancel,
	          onMenuTouchEnd = _props.onMenuTouchEnd,
	          onMenuFocus = _props.onMenuFocus,
	          onMenuBlur = _props.onMenuBlur,
	          onMenuKeyDown = _props.onMenuKeyDown,
	          onMenuKeyUp = _props.onMenuKeyUp,
	          isOpen = _props.isOpen,
	          defaultOpen = _props.defaultOpen,
	          onMenuToggle = _props.onMenuToggle,
	          props = _objectWithoutProperties(_props, ['id', 'listId', 'buttonId', 'menuStyle', 'menuClassName', 'listStyle', 'listClassName', 'listProps', 'listZDepth', 'listInline', 'listHeightRestricted', 'menuItems', 'buttonChildren', 'children', 'anchor', 'belowAnchor', 'fixedTo', 'position', 'cascading', 'cascadingAnchor', 'cascadingZDepth', 'fullWidth', 'block', 'centered', 'sameWidth', 'repositionOnScroll', 'repositionOnResize', 'xThreshold', 'yThreshold', 'closeOnOutsideClick', 'transitionName', 'transitionEnterTimeout', 'transitionLeaveTimeout', 'visible', 'defaultVisible', 'onVisibilityChange', 'simplifiedMenu', 'minLeft', 'minRight', 'minBottom', 'fillViewportWidth', 'fillViewportHeight', 'onMenuClick', 'onMenuMouseDown', 'onMenuMouseUp', 'onMenuMouseEnter', 'onMenuMouseMove', 'onMenuMouseLeave', 'onMenuTouchStart', 'onMenuTouchMove', 'onMenuTouchCancel', 'onMenuTouchEnd', 'onMenuFocus', 'onMenuBlur', 'onMenuKeyDown', 'onMenuKeyUp', 'isOpen', 'defaultOpen', 'onMenuToggle']);
	
	      var items = children;
	      var toggleChildren = buttonChildren;
	      if (typeof menuItems !== 'undefined') {
	        toggleChildren = children;
	        items = menuItems;
	      }
	
	      return _react2.default.createElement(
	        _DropdownMenu2.default,
	        {
	          id: id,
	          listId: listId,
	          style: menuStyle,
	          className: menuClassName,
	          listStyle: listStyle,
	          listClassName: listClassName,
	          listProps: listProps,
	          listInline: listInline,
	          listZDepth: listZDepth,
	          listHeightRestricted: listHeightRestricted,
	          visible: typeof isOpen !== 'undefined' ? isOpen : visible,
	          defaultVisible: typeof defaultOpen !== 'undefined' ? defaultOpen : defaultVisible,
	          menuItems: items,
	          simplifiedMenu: simplifiedMenu,
	          anchor: anchor,
	          belowAnchor: belowAnchor,
	          fixedTo: fixedTo,
	          position: position,
	          cascading: cascading,
	          cascadingAnchor: cascadingAnchor,
	          cascadingZDepth: cascadingZDepth,
	          fullWidth: fullWidth,
	          block: block,
	          centered: centered,
	          sameWidth: sameWidth,
	          minLeft: minLeft,
	          minRight: minRight,
	          minBottom: minBottom,
	          fillViewportWidth: fillViewportWidth,
	          fillViewportHeight: fillViewportHeight,
	          repositionOnScroll: repositionOnScroll,
	          repositionOnResize: repositionOnResize,
	          xThreshold: xThreshold,
	          yThreshold: yThreshold,
	          closeOnOutsideClick: closeOnOutsideClick,
	          transitionName: transitionName,
	          transitionEnterTimeout: transitionEnterTimeout,
	          transitionLeaveTimeout: transitionLeaveTimeout,
	          onVisibilityChange: onMenuToggle || onVisibilityChange,
	          onClick: onMenuClick,
	          onMouseDown: onMenuMouseDown,
	          onMouseUp: onMenuMouseUp,
	          onMouseEnter: onMenuMouseEnter,
	          onMouseMove: onMenuMouseMove,
	          onMouseLeave: onMenuMouseLeave,
	          onTouchStart: onMenuTouchStart,
	          onTouchMove: onMenuTouchMove,
	          onTouchCancel: onMenuTouchCancel,
	          onTouchEnd: onMenuTouchEnd,
	          onFocus: onMenuFocus,
	          onBlur: onMenuBlur,
	          onKeyDown: onMenuKeyDown,
	          onKeyUp: onMenuKeyUp
	        },
	        _react2.default.createElement(
	          _Button2.default,
	          _extends({}, props, { id: buttonId }),
	          toggleChildren
	        )
	      );
	    }
	  }]);
	
	  return MenuButton;
	}(_react.PureComponent);
	
	MenuButton.Positions = _DropdownMenu2.default.Positions;
	MenuButton.HorizontalAnchors = _DropdownMenu2.default.HorizontalAnchors;
	MenuButton.VerticalAnchors = _DropdownMenu2.default.VerticalAnchors;
	MenuButton.propTypes = {
	  /**
	   * An id to use for the menu button. This is required for accessibility.
	   *
	   * @see {@link Menus/Menu#id}
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the menu's list.
	   *
	   * @see {@link Menus/Menu#listId}
	   */
	  listId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the button. If this is omitted, the button will automatically
	   * gain an id of `${id}-toggle`.
	   */
	  buttonId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the button.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the button.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the surrounding menu.
	   */
	  menuStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the surrounding menu.
	   */
	  menuClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the list.
	   */
	  listStyle: _propTypes2.default.object,
	
	  /**
	   * An optional class name to apply to the list.
	   */
	  listClassName: _propTypes2.default.string,
	
	  /**
	   * Any additional props to provide to the list.
	   *
	   * @see {@link Menus/Menu#listProps}
	   */
	  listProps: _propTypes2.default.object,
	
	  /**
	   * The z-depth to use for the list.
	   *
	   * @see {@link Menus/Menu/listZDepth}
	   */
	  listZDepth: _propTypes2.default.number,
	
	  /**
	   * Boolean if the list should be displayed inline.
	   *
	   * @see {@link Lists/List#inline}
	   */
	  listInline: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the list's height should be restricted.
	   *
	   * @see {@link Menus/Menu#listHeightRestricted}
	   */
	  listHeightRestricted: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu's list is currently visible. If this is defined, it will
	   * require the `onVisibilityChange` function to be defined since it will become
	   * a controlled component.
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityChange', 'defaultVisible'),
	
	  /**
	   * Boolean if the menu's list should be visible by default.
	   */
	  defaultVisible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * An optional function to call when the button is clicked.
	   *
	   * @see {@link #onMenuClick}
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mousedown` event is triggered by the button.
	   *
	   * @see {@link #onMenuMouseDown}
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseup` event is triggered by the button.
	   *
	   * @see {@link #onMenuMouseUp}
	   */
	  onMouseUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseenter` event is triggered by the button.
	   *
	   * @see {@link #onMenuMouseEnter}
	   */
	  onMouseEnter: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mousemove` event is triggered by the button.
	   *
	   * @see {@link #onMenuMouseMove}
	   */
	  onMouseMove: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseleave` event is triggered by the button.
	   *
	   * @see {@link #onMenuMouseLeave}
	   */
	  onMouseLeave: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `touchstart` event is triggered by the button.
	   *
	   * @see {@link #onMenuTouchStart}
	   */
	  onTouchStart: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `touchmove` event is triggered by the button.
	   *
	   * @see {@link #onMenuTouchMove}
	   */
	  onTouchMove: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `touchend` event is triggered by the button.
	   *
	   * @see {@link #onMenuTouchEnd}
	   */
	  onTouchEnd: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `touchcancel` event is triggered by the button.
	   *
	   * @see {@link #onMenuTouchCancel}
	   */
	  onTouchCancel: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `focus` event is triggered by the button.
	   *
	   * @see {@link #onMenuFocus}
	   */
	  onFocus: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `blur` event is triggered by the button.
	   *
	   * @see {@link #onMenuBlur}
	   */
	  onBlur: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `keydown` event is triggered by the button.
	   *
	   * @see {@link #onMenuKeyDown}
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `keyup` event is triggered by the button.
	   *
	   * @see {@link #onMenuKeyUp}
	   */
	  onKeyUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the entire `MenuButton` is clicked. This can be triggered
	   * by clicking the button or any list item that appears in the menu list.
	   *
	   * @see {@link #onClick}
	   */
	  onMenuClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `mousedown` event.
	   *
	   * @see {@link #onMouseDown}
	   */
	  onMenuMouseDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `mouseup` event.
	   *
	   * @see {@link #onMouseUp}
	   */
	  onMenuMouseUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `mouseenter` event.
	   *
	   * @see {@link #onMouseEnter}
	   */
	  onMenuMouseEnter: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `mousemove` event.
	   *
	   * @see {@link #onMouseMove}
	   */
	  onMenuMouseMove: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `mouseleave` event.
	   *
	   * @see {@link #onMouseLeave}
	   */
	  onMenuMouseLeave: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `touchstart` event.
	   *
	   * @see {@link @onTouchStart}
	   */
	  onMenuTouchStart: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `touchmove` event.
	   *
	   * @see {@link @onTouchMove}
	   */
	  onMenuTouchMove: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `touchend` event.
	   *
	   * @see {@link @onTouchEnd}
	   */
	  onMenuTouchEnd: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `touchcancel` event.
	   *
	   * @see {@link @onTouchCancel}
	   */
	  onMenuTouchCancel: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `focus` event.
	   *
	   * @see {@link #onFocus}
	   */
	  onMenuFocus: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `blur` event.
	   *
	   * @see {@link #onBlur}
	   */
	  onMenuBlur: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `keydown` event.
	   *
	   * @see {@link #onKeyDown}
	   */
	  onMenuKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `keyup` event.
	   *
	   * @see {@link #onKeyUp}
	   */
	  onMenuKeyUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the visibility changes for the menu. The callback will
	   * include the next visibility state and the event that triggered the change.
	   *
	   * ```js
	   * onVisibilityChange(visible, event);
	   * ```
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * This is a 0 to many relationship of `ListItem` to display in the menu's `List`. If the type
	   * of the item is a number or string, it will be passed to the `ListItem` as the `primaryText`.
	   * If it is an object, it should be the shape of the `ListItem` props. If it is a node, it will
	   * just be rendered in the `List`.
	   *
	   * @see {@link Lists/ListItem}
	   * @see {@link Menus/Menu#children}
	   */
	  menuItems: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.object, _propTypes2.default.node]))]),
	
	  /**
	   * This should be the children to use in the `Button` that gets created as the menu's toggle.
	   *
	   * @see {@link Buttons/Button}
	   * @see {@link Menus/Menu#toggle}
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The anchor position of the menu's list.
	   *
	   * @see {@link Helpers/Layover#anchor}
	   */
	  anchor: _anchorShape2.default,
	
	  /**
	   * This is the anchor to use when the `position` is set to `Autocomplete.Positions.BELOW`.
	   *
	   * @see {@link Helpers/Layover#belowAnchor}
	   */
	  belowAnchor: _anchorShape2.default,
	
	  /**
	   * This is how the menu's list is fixed to the toggle.
	   *
	   * @see {@link Menus/Menu#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * This is the animation position for the menu's list.
	   *
	   * @see {@link Menus/Menu#position}
	   */
	  position: _positionShape2.default,
	
	  /**
	   * Boolean if the menu's list should gain the cascading styles.
	   *
	   * @see {@link Menus/Menu#cascading}
	   */
	  cascading: _propTypes2.default.bool,
	
	  /**
	   * The zDepth to use for the lists that appear in cascading menus.
	   *
	   * @see {@link Menus/Menu#cascadingZDepth}
	   */
	  cascadingZDepth: _propTypes2.default.number,
	
	  /**
	   * The anchor position for the cascading lists.
	   *
	   * @see {@link Menus/Menu#cascadingAnchor}
	   */
	  cascadingAnchor: _anchorShape2.default,
	
	  /**
	   * Boolean if the menu should display as a full width container. This will *not* update the button
	   * to be full width as well.
	   *
	   * @see {@link Menus/Menu#fullWidth}
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu's container should display as `block` instead of `inline-block`.
	   *
	   * @see {@link Menus/Menu#block}
	   */
	  block: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the list should appear centered related to the button.
	   *
	   * @see {@link Menus/Menu#centered}
	   */
	  centered: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu's list should be the same width as the button.
	   *
	   * @see {@link Menus/Menu#sameWidth}
	   */
	  sameWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Menus/Menu#xThreshold}
	   */
	  xThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Menus/Menu#yThreshold}
	   */
	  yThreshold: _propTypes2.default.number,
	
	  /**
	   * Boolean if the menu's list should be closed when an element outside of the menu has been clicked.
	   *
	   * @see {@link Menus/Menu#closeOnOutsideClick}
	   */
	  closeOnOutsideClick: _propTypes2.default.bool,
	
	  /**
	   * The transition name to use for the menu's list visibility changes.
	   *
	   * @see {@link Menus/Menu#transitionName}
	   */
	  transitionName: _propTypes2.default.string,
	
	  /**
	   * The transition name to use when the menu's list gains visibility.
	   *
	   * @see {@link Menus/Menu#transitionEnterTimeout}
	   */
	  transitionEnterTimeout: _propTypes2.default.number,
	
	  /**
	   * The transition timeout to use when the menu's list loses visibility.
	   *
	   * @see {@link Menus/Menu#transitionLeaveTimeout}
	   */
	  transitionLeaveTimeout: _propTypes2.default.number,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu logic should be simplified without any viewport logic and position
	   * based on the relative position of the menu. This will most like require some additional
	   * styles applied to the menu.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedMenu: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#minLeft}
	   */
	  minLeft: _DropdownMenu2.default.propTypes.minLeft,
	
	  /**
	   * @see {@link Helpers/Layover#minRight}
	   */
	  minRight: _DropdownMenu2.default.propTypes.minLeft,
	
	  /**
	   * @see {@link Helpers/Layover#minBottom}
	   */
	  minBottom: _DropdownMenu2.default.propTypes.minBottom,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportWidth}
	   */
	  fillViewportWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportHeight}
	   */
	  fillViewportHeight: _propTypes2.default.bool,
	
	  buttonChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'To build a button, put any elements in the `children`. The `ListItem` have been moved to the `menuItems` prop'),
	  onMenuToggle: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `onVisibilityChange` instead'),
	  isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead'),
	  defaultOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead')
	};
	MenuButton.defaultProps = {
	  defaultVisible: false,
	  repositionOnScroll: true,
	  repositionOnResize: false
	};
	exports.default = MenuButton;
	//# sourceMappingURL=MenuButton.js.map

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(19);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A button used to close the persistent navigation drawer. The button will
	 * be generated based on the `NavigationDrawer`'s `contextTypes`.
	 *
	 * This component is really only used if you are using a `persistent` drawer and you
	 * manually created the `drawerHeader` for the `NavigationDrawer`.
	 */
	var CloseButton = function (_PureComponent) {
	  _inherits(CloseButton, _PureComponent);
	
	  function CloseButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CloseButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CloseButton.__proto__ || Object.getPrototypeOf(CloseButton)).call.apply(_ref, [this].concat(args))), _this), _this._handleClick = function (e) {
	      if (_this.props.onClick) {
	        _this.props.onClick(e);
	      }
	
	      if (_this.context.onCloseClick) {
	        _this.context.onCloseClick(e);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CloseButton, [{
	    key: 'render',
	    value: function render() {
	      var closeIcon = this.context.closeIcon;
	
	
	      return _react2.default.createElement(_Button2.default, _extends({}, this.props, {
	        icon: true,
	        key: 'close',
	        onClick: this._handleClick,
	        iconEl: closeIcon
	      }));
	    }
	  }]);
	
	  return CloseButton;
	}(_react.PureComponent);
	
	CloseButton.propTypes = {
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional additional function to call when the `click` event is triggered.
	   */
	  onClick: _propTypes2.default.func
	};
	CloseButton.contextTypes = {
	  closeIcon: _propTypes2.default.element,
	  onCloseClick: _propTypes2.default.func
	};
	exports.default = CloseButton;
	//# sourceMappingURL=CloseButton.js.map

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This is an accessibility only component that should be used in the `NavigationDrawer`
	 * component. It allows keyboard users to quickly jump to the main content.
	 *
	 * This component relies on the `contextTypes` of the `NavigationDrawer` to work. If this is going
	 * to be used outside of that component, you will need to specify an `id` and `label` contextType
	 * to pass to this component.
	 */
	var JumpToContentLink = function (_PureComponent) {
	  _inherits(JumpToContentLink, _PureComponent);
	
	  function JumpToContentLink() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, JumpToContentLink);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JumpToContentLink.__proto__ || Object.getPrototypeOf(JumpToContentLink)).call.apply(_ref, [this].concat(args))), _this), _this._handleClick = function (e) {
	      if (_this.props.onClick) {
	        _this.props.onClick(e);
	      }
	
	      document.getElementById(_this.context.id).focus();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(JumpToContentLink, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['className']);
	
	      var _context = this.context,
	          id = _context.id,
	          label = _context.label;
	
	      return _react2.default.createElement(
	        'a',
	        _extends({}, props, {
	          id: 'jump-to-' + id,
	          href: '#' + id,
	          onClick: this._handleClick,
	          className: (0, _classnames2.default)('md-content-jump', className)
	        }),
	        label
	      );
	    }
	  }]);
	
	  return JumpToContentLink;
	}(_react.PureComponent);
	
	JumpToContentLink.propTypes = {
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional function to call when the linked is clicked.
	   */
	  onClick: _propTypes2.default.func
	};
	JumpToContentLink.contextTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  label: _propTypes2.default.node.isRequired
	};
	exports.default = JumpToContentLink;
	//# sourceMappingURL=JumpToContentLink.js.map

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keyCodes = __webpack_require__(15);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _minMaxLoop = __webpack_require__(676);
	
	var _minMaxLoop2 = _interopRequireDefault(_minMaxLoop);
	
	var _controlled = __webpack_require__(16);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _SelectionControl = __webpack_require__(64);
	
	var _SelectionControl2 = _interopRequireDefault(_SelectionControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A custom PropTypes validator to make sure that each `control` in the `controls` prop
	 * contains the given `propName`, or the `SelectionControlGroup` has defined that prop.
	 */
	function requiredByAllControls(validator) {
	  return function validate(props, propName, component) {
	    for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      others[_key - 3] = arguments[_key];
	    }
	
	    var err = validator.apply(undefined, [props, propName, component].concat(others));
	
	    if (!err && typeof props[propName] === 'undefined') {
	      var invalids = props.controls.filter(function (c) {
	        return !c[propName];
	      }).map(function (_, i) {
	        return i;
	      });
	      if (invalids.length) {
	        var invalidPrefix = invalids.length === props.controls.length ? 'All `controls`' : 'The `controls` at indexes `' + invalids.join('`, `') + '`';
	        var invalidMsg = invalidPrefix + ' are missing the `' + propName + '` prop.';
	
	        err = new Error('The `' + propName + '` prop is required to make `' + component + '` accessible for users of ' + ('assistive technologies such as screen readers. Either add the `' + propName + '` to the `' + component + '` ') + ('or add the `' + propName + '` to each `control` in the `controls` prop. ' + invalidMsg));
	      }
	    }
	
	    return err;
	  };
	}
	
	/**
	 * The `SelectionControlGroup` component is used to simplify the generation of a list
	 * of `SelectionControl`. Any common props are extracted to this component and passed
	 * to the `SelectionControl`.
	 */
	
	var SelectionControlGroup = function (_PureComponent) {
	  _inherits(SelectionControlGroup, _PureComponent);
	
	  function SelectionControlGroup(props) {
	    _classCallCheck(this, SelectionControlGroup);
	
	    var _this = _possibleConstructorReturn(this, (SelectionControlGroup.__proto__ || Object.getPrototypeOf(SelectionControlGroup)).call(this, props));
	
	    _this._setGroup = function (group) {
	      _this._group = group;
	    };
	
	    _this._handleChange = function (e) {
	      var value = e.target.value;
	      if (_this.props.type === 'checkbox') {
	        var checked = e.target.checked;
	
	
	        var values = (0, _getField2.default)(_this.props, _this.state, 'value').split(',');
	        var index = values.indexOf(value);
	        if (checked) {
	          values.push(value);
	        } else {
	          values.splice(index, 1);
	        }
	
	        value = values.join(',');
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(value, e);
	      }
	
	      if (typeof _this.props.value === 'undefined') {
	        _this.setState({ value: value });
	      }
	    };
	
	    _this._handleKeyDown = function (e) {
	      if (_this.props.onKeyDown) {
	        _this.props.onKeyDown(e);
	      }
	
	      var key = e.which || e.keyCode;
	      var dec = key === _keyCodes.UP || key === _keyCodes.LEFT;
	      var inc = key === _keyCodes.DOWN || key === _keyCodes.RIGHT;
	      if (!_this._group || !dec && !inc) {
	        return;
	      }
	
	      e.preventDefault();
	      var radios = _this._group.querySelectorAll('*[role="radio"]');
	      _this._activeIndex = (0, _minMaxLoop2.default)(_this._activeIndex, 0, radios.length - 1, inc);
	      radios[_this._activeIndex].focus();
	      var value = _this.props.controls[_this._activeIndex].value;
	
	      if ((0, _getField2.default)(_this.props, _this.state, 'value') !== value) {
	        if (_this.props.onChange) {
	          _this.props.onChange(value, e);
	        }
	
	        if (typeof _this.props.value === 'undefined') {
	          _this.setState({ value: value });
	        }
	      }
	    };
	
	    var radio = props.type === 'radio';
	    _this.state = {};
	
	    if (typeof props.value === 'undefined') {
	      var value = props.defaultValue;
	
	      if (typeof value === 'undefined') {
	        value = radio ? props.controls[0].value : '';
	      }
	
	      _this.state.value = value;
	    }
	
	    var groupValue = (0, _getField2.default)(props, _this.state, 'value');
	    _this._activeIndex = -1;
	    props.controls.some(function (_ref, i) {
	      var value = _ref.value;
	
	      if (value === groupValue) {
	        _this._activeIndex = i;
	      }
	
	      return _this._activeIndex > -1;
	    });
	    return _this;
	  }
	
	  _createClass(SelectionControlGroup, [{
	    key: '_isChecked',
	    value: function _isChecked(value, controlValue, type) {
	      return type === 'radio' ? value === controlValue : value.split(',').indexOf(controlValue) !== -1;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          id = _props.id,
	          name = _props.name,
	          type = _props.type,
	          label = _props.label,
	          labelClassName = _props.labelClassName,
	          className = _props.className,
	          controlStyle = _props.controlStyle,
	          controlClassName = _props.controlClassName,
	          Component = _props.component,
	          LabelComponent = _props.labelComponent,
	          inline = _props.inline,
	          disabled = _props.disabled,
	          checkedRadioIcon = _props.checkedRadioIcon,
	          uncheckedRadioIcon = _props.uncheckedRadioIcon,
	          checkedCheckboxIcon = _props.checkedCheckboxIcon,
	          uncheckedCheckboxIcon = _props.uncheckedCheckboxIcon,
	          propValue = _props.value,
	          propControls = _props.controls,
	          defaultValue = _props.defaultValue,
	          props = _objectWithoutProperties(_props, ['id', 'name', 'type', 'label', 'labelClassName', 'className', 'controlStyle', 'controlClassName', 'component', 'labelComponent', 'inline', 'disabled', 'checkedRadioIcon', 'uncheckedRadioIcon', 'checkedCheckboxIcon', 'uncheckedCheckboxIcon', 'value', 'controls', 'defaultValue']);
	
	      var value = (0, _getField2.default)(this.props, this.state, 'value');
	      var radio = type === 'radio';
	
	      var controls = this.props.controls.map(function (control, i) {
	        var style = control.style;
	        if (controlStyle) {
	          style = style ? _extends({}, controlStyle, style) : controlStyle;
	        }
	
	        var checked = _this2._isChecked(value, control.value, type);
	        var controlProps = _extends({
	          id: '' + id + i,
	          key: 'control' + i,
	          name: '' + name + (type === 'checkbox' ? '[]' : ''),
	          type: type,
	          inline: inline,
	          disabled: disabled,
	          checked: checked,
	          tabIndex: !radio || checked || i === 0 && _this2._activeIndex === -1 ? undefined : -1,
	          checkedRadioIcon: checkedRadioIcon,
	          uncheckedRadioIcon: uncheckedRadioIcon,
	          checkedCheckboxIcon: checkedCheckboxIcon,
	          uncheckedCheckboxIcon: uncheckedCheckboxIcon
	        }, control, {
	          style: style,
	          className: (0, _classnames2.default)(controlClassName, control.className)
	        });
	
	        return _react2.default.createElement(_SelectionControl2.default, controlProps);
	      });
	
	      var ariaLabel = void 0;
	      if (label) {
	        ariaLabel = _react2.default.createElement(
	          LabelComponent,
	          { className: labelClassName },
	          label
	        );
	      }
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, {
	          ref: this._setGroup,
	          className: (0, _classnames2.default)('md-selection-control-group', className),
	          onChange: this._handleChange,
	          onKeyDown: radio ? this._handleKeyDown : null
	        }),
	        ariaLabel,
	        controls
	      );
	    }
	  }]);
	
	  return SelectionControlGroup;
	}(_react.PureComponent);
	
	SelectionControlGroup.propTypes = {
	  /**
	   * An optional style to apply to the container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to every `SelectionControl`. This will be merged with any `style`
	   * that a `control` might have.
	   */
	  controlStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to every `SelectionControl`. This will be merged with any
	   * `className` that a `control` might have.
	   */
	  controlClassName: _propTypes2.default.string,
	
	  /**
	   * An optional base id to apply to each `SelectionControl`. When this is included, the id for
	   * each control will start with this and end with their current index. If this is omitted,
	   * each `control` in the `controls` prop *must* have an `id` prop. This is required for
	   * accessibility.
	   */
	  id: requiredByAllControls(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * The type to apply to each `SelectionControl` in the group. Only `checkbox` and `radio` is
	   * valid for a grouping.
	   */
	  type: _propTypes2.default.oneOf(['checkbox', 'radio']).isRequired,
	
	  /**
	   * The component to render the `SelectionControlGroup` in. This can only be a valid dom element
	   * since it relies on the ref callback to add keyboard accessibility.
	   */
	  component: _propTypes2.default.string.isRequired,
	
	  /**
	   * An optional label to display above the group of `SelectionControl`s.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * An optional className to apply to the node surrounding the `label` prop.
	   */
	  labelClassName: _propTypes2.default.string,
	
	  /**
	   * The component to render the optional `label` in.
	   */
	  labelComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * An optional function to call when any `SelectionControl`'s `checked` state is changed
	   * in the group. If the `type` of the group is `radio`, the `value` of the `checked` radio
	   * will be given in the callback. If the `type` of the group is `checkbox`, a comma-delimited
	   * string of all `checked` checkboxes values will be given.
	   *
	   * ```js
	   * // checkbox
	   * onChange('Alpha,Omega', changeEvent);
	   *
	   * // radio
	   * onChange('Omega', changeEvent);
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * A name to use for each `SelectionControl` in the group. If the `type` of the group is
	   * `checkbox`, the name will be updated to be an array name so that using
	   * `document.querySelector('input[name="yourName[]"].value` will give the comma-delimited
	   * string of checked checkboxes.
	   *
	   * It is either required to have this prop set or every `control` in the `controls` prop to
	   * have the `name` prop.
	   */
	  name: requiredByAllControls(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * The default value for the `SelectionControlGroup`. This can either be a single value
	   * or a comma-delimited string of checkbox values. When the `type` of the group is `radio`
	   * and the group is uncontrolled, it is recommended to set this prop. Otherwise the first
	   * value of the `controls` prop will be used as the default value.
	   */
	  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional value to use for the `SelectionControlGroup`. This will make the component
	   * controlled and require the `onChange` prop to be defined. Like the `defaultValue`, this
	   * can either be a single value or a comma-delimited list of checkbox values.
	   */
	  value: (0, _controlled2.default)(_propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]), 'onChange'),
	
	  /**
	   * A list of objects to create the `SelectionControl` components. The shape of the object
	   * is the `propTypes` of the `SelectionControl` component, except that `value` prop is
	   * now required.
	   *
	   * The `SelectionControl` will inherit any inheritable props from the `SelectionControlGroup`.
	   */
	  controls: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    key: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    label: _propTypes2.default.node.isRequired,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]).isRequired
	  })).isRequired,
	
	  /**
	   * Boolean if the `SelectionControl` should be displayed inline.
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * Boolean if all the selection controls in the group are disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when the keydown event is triggered.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An icon to use for a checked `radio` control. This will be applied to each
	   * control that has a `type="radio"` in the `controls` list. This is just a simpler
	   * way of applying the custom icons for each radio in the list.
	   *
	   * This will default to the `checkedRadioIcon` on the `SelectionControl`.
	   *
	   * @see {@link #controls}
	   * @see {@link #uncheckedRadioIcon}
	   * @see {@link SelectionControls/SelectionControls#checkedRadioIcon}
	   * @see {@link SelectionControls/SelectionControls#uncheckedRadioIcon}
	   */
	  checkedRadioIcon: _propTypes2.default.node,
	
	  /**
	   * An icon to use for an unchecked `radio` control. This will be applied to each
	   * control that has a `type="radio"` in the `controls` list. This is just a simpler
	   * way of applying the custom icons for each radio in the list.
	   *
	   * This will default to the `uncheckedRadioIcon` on the `SelectionControl`.
	   *
	   * @see {@link #controls}
	   * @see {@link #checkedRadioIcon}
	   * @see {@link SelectionControls/SelectionControls#checkedRadioIcon}
	   * @see {@link SelectionControls/SelectionControls#uncheckedRadioIcon}
	   */
	  uncheckedRadioIcon: _propTypes2.default.node,
	
	  /**
	   * An icon to use for a checked `checkbox` control. This will be applied to each
	   * control that has a `type="checkbox"` in the `controls` list. This is just a simpler
	   * way of applying the custom icons for each checkbox in the list.
	   *
	   * This will default to the `checkedCheckboxIcon` on the `SelectionControl`.
	   *
	   * @see {@link #controls}
	   * @see {@link #uncheckedCheckboxIcon}
	   * @see {@link SelectionControls/SelectionControls#checkedCheckboxIcon}
	   * @see {@link SelectionControls/SelectionControls#uncheckedCheckboxIcon}
	   */
	  checkedCheckboxIcon: _propTypes2.default.node,
	
	  /**
	   * An icon to use for an unchecked `checkbox` control. This will be applied to each
	   * control that has a `type="checkbox"` in the `controls` list. This is just a simpler
	   * way of applying the custom icons for each checkbox in the list.
	   *
	   * This will default to the `uncheckedCheckboxIcon` on the `SelectionControl`.
	   *
	   * @see {@link #controls}
	   * @see {@link #checkedCheckboxIcon}
	   * @see {@link SelectionControls/SelectionControls#checkedCheckboxIcon}
	   * @see {@link SelectionControls/SelectionControls#uncheckedCheckboxIcon}
	   */
	  uncheckedCheckboxIcon: _propTypes2.default.node
	};
	SelectionControlGroup.defaultProps = {
	  component: 'fieldset',
	  labelComponent: 'legend',
	  labelClassName: 'md-subheading-1'
	};
	exports.default = SelectionControlGroup;
	//# sourceMappingURL=SelectionControlGroup.js.map

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(19);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _isInvalidAnimate = __webpack_require__(285);
	
	var _isInvalidAnimate2 = _interopRequireDefault(_isInvalidAnimate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Snackbar = function (_PureComponent) {
	  _inherits(Snackbar, _PureComponent);
	
	  function Snackbar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Snackbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Snackbar.__proto__ || Object.getPrototypeOf(Snackbar)).call.apply(_ref, [this].concat(args))), _this), _this._handleClick = function (e) {
	      var _this$props = _this.props,
	          onDismiss = _this$props.onDismiss,
	          action = _this$props.toast.action,
	          leaveTimeout = _this$props.leaveTimeout,
	          multiline = _this$props.multiline;
	
	      if (typeof action.onClick === 'function') {
	        action.onClick(e);
	      }
	
	      if (_this._fab) {
	        _this._fab._animateForSnackbar(multiline, leaveTimeout);
	      }
	
	      onDismiss();
	    }, _this._clearTimeout = function () {
	      if (_this._timeout) {
	        clearTimeout(_this._timeout);
	        _this._timeout = null;
	      }
	    }, _this._handleAutohide = function () {
	      var _this$props2 = _this.props,
	          autohide = _this$props2.autohide,
	          autohideTimeout = _this$props2.autohideTimeout,
	          onDismiss = _this$props2.onDismiss,
	          multiline = _this$props2.multiline,
	          leaveTimeout = _this$props2.leaveTimeout;
	
	      if (!autohide) {
	        return;
	      }
	
	      window.addEventListener('blur', _this._handleWindowBlur);
	      _this._eventType = 'blur';
	      _this._timeout = setTimeout(function () {
	        _this._timeout = null;
	        _this._eventType = null;
	
	        window.removeEventListener('blur', _this._handleWindowBlur);
	
	        if (_this._fab) {
	          _this._fab._animateForSnackbar(multiline, leaveTimeout);
	        }
	
	        onDismiss();
	      }, autohideTimeout || _this.state.toast);
	    }, _this._handleWindowBlur = function () {
	      _this._clearTimeout();
	      window.removeEventListener('blur', _this._handleWindowBlur);
	      window.addEventListener('focus', _this._handleWindowFocus);
	      _this._eventType = 'focus';
	    }, _this._handleWindowFocus = function () {
	      window.removeEventListener('focus', _this._handleWindowFocus);
	      _this._eventType = null;
	      _this._handleAutohide();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Snackbar, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          fab = _props.fab,
	          multiline = _props.multiline,
	          onAppear = _props.toast.onAppear;
	
	      if (onAppear) {
	        onAppear();
	      }
	
	      if (!fab || (0, _isInvalidAnimate2.default)(fab)) {
	        return;
	      }
	
	      this._fab = fab.getComposedComponent().getComposedComponent();
	      this._fab._animateForSnackbar(multiline);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._handleAutohide();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._clearTimeout();
	
	      if (this._eventType === 'focus') {
	        window.removeEventListener('focus', this._handleWindowFocus);
	      } else if (this._eventType === 'blur') {
	        window.removeEventListener('blur', this._handleWindowBlur);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          toast = _props2.toast,
	          multiline = _props2.multiline,
	          propId = _props2.id,
	          fab = _props2.fab,
	          autohide = _props2.autohide,
	          autohideTimeout = _props2.autohideTimeout,
	          leaveTimeout = _props2.leaveTimeout,
	          onDismiss = _props2.onDismiss,
	          props = _objectWithoutProperties(_props2, ['className', 'toast', 'multiline', 'id', 'fab', 'autohide', 'autohideTimeout', 'leaveTimeout', 'onDismiss']);
	
	      var text = toast.text,
	          action = toast.action;
	      var id = this.props.id;
	
	
	      var Component = 'p';
	      if (action) {
	        Component = 'section';
	        text = _react2.default.createElement(
	          'p',
	          { className: 'md-snackbar--toast md-snackbar--action' },
	          text
	        );
	
	        var btnProps = {
	          flat: true,
	          onClick: this._handleClick,
	          children: action,
	          secondary: true,
	          className: 'md-btn--snackbar'
	        };
	
	        if (typeof action !== 'string') {
	          btnProps = Object.assign(btnProps, action, {
	            className: (0, _classnames2.default)(btnProps.className, action.className),
	            onClick: this._handleClick
	          });
	        }
	
	        action = _react2.default.createElement(_Button2.default, btnProps);
	      }
	
	      if (!id) {
	        id = 'snackbar-alert' + (action ? '-dialog' : '');
	      }
	
	      var role = 'alert' + (action ? 'dialog' : '');
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, {
	          id: id,
	          role: role,
	          className: (0, _classnames2.default)('md-snackbar', {
	            'md-snackbar--multiline': multiline,
	            'md-snackbar--toast': !action
	          }, className)
	        }),
	        text,
	        action
	      );
	    }
	  }]);
	
	  return Snackbar;
	}(_react.PureComponent);
	
	Snackbar.propTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  onDismiss: _propTypes2.default.func.isRequired,
	  toast: _propTypes2.default.shape({
	    text: _propTypes2.default.node.isRequired,
	    action: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.shape({
	      label: _propTypes2.default.node,
	      children: _propTypes2.default.node,
	      onClick: _propTypes2.default.func
	    })]),
	    onAppear: _propTypes2.default.func
	  }).isRequired,
	  multiline: _propTypes2.default.bool,
	  autohide: _propTypes2.default.bool,
	  autohideTimeout: _propTypes2.default.number,
	  fab: _propTypes2.default.object,
	  leaveTimeout: _propTypes2.default.number.isRequired
	};
	exports.default = Snackbar;
	//# sourceMappingURL=Snackbar.js.map

/***/ }),
/* 285 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isInvalidAnimate;
	var gcc = 'getComposedComponent';
	
	/**
	 * Just checks if the fab is actually a ref to the FAB Button.
	 */
	function isInvalidAnimate(fab) {
	  return typeof fab[gcc] !== 'function' || typeof fab[gcc]()[gcc] !== 'function' || typeof fab[gcc]()[gcc]()._animateForSnackbar !== 'function';
	}
	//# sourceMappingURL=isInvalidAnimate.js.map

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(12);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Subheader` component is generally used inside of lists or menus.
	 */
	var Subheader = function (_PureComponent) {
	  _inherits(Subheader, _PureComponent);
	
	  function Subheader() {
	    _classCallCheck(this, Subheader);
	
	    return _possibleConstructorReturn(this, (Subheader.__proto__ || Object.getPrototypeOf(Subheader)).apply(this, arguments));
	  }
	
	  _createClass(Subheader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.component,
	          inset = _props.inset,
	          primary = _props.primary,
	          primaryText = _props.primaryText,
	          className = _props.className,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['component', 'inset', 'primary', 'primaryText', 'className', 'children']);
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, {
	          className: (0, _classnames2.default)('md-subheader', {
	            'md-list-item--inset': inset
	          }, (0, _themeColors2.default)({ primary: primary, hint: !primary }), className)
	        }),
	        primaryText,
	        children
	      );
	    }
	  }]);
	
	  return Subheader;
	}(_react.PureComponent);
	
	Subheader.propTypes = {
	  /**
	   * An optional style to apply to the subheader.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the subheader.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if the subheader should be styled with the primary color.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the subheader is inset in the list. This will add additional
	   * spacing to align the subheader.
	   */
	  inset: _propTypes2.default.bool,
	
	  /**
	   * The primary text to use in the subheader.
	   */
	  primaryText: _propTypes2.default.node.isRequired,
	
	  /**
	   * Any optional children to display after the `primaryText`. This prop is
	   * not recommended.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The component to render the Subheader as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired
	};
	Subheader.defaultProps = {
	  component: 'li'
	};
	exports.default = Subheader;
	//# sourceMappingURL=Subheader.js.map

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Subheader = undefined;
	
	var _Subheader2 = __webpack_require__(286);
	
	var _Subheader3 = _interopRequireDefault(_Subheader2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Subheader3.default;
	exports.Subheader = _Subheader3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(17);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _Menu = __webpack_require__(63);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _AccessibleFakeInkedButton = __webpack_require__(29);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	var _mapToListParts = __webpack_require__(181);
	
	var _mapToListParts2 = _interopRequireDefault(_mapToListParts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `MenuTab` component is used when there are too many desktop tabs
	 * to be displayed without any overflow. If the `Tabs` component is used,
	 * this will automatically be included when the `menuOverflow` prop is true.
	 */
	var MenuTab = function (_PureComponent) {
	  _inherits(MenuTab, _PureComponent);
	
	  function MenuTab() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MenuTab);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuTab.__proto__ || Object.getPrototypeOf(MenuTab)).call.apply(_ref, [this].concat(args))), _this), _this.state = { visible: false }, _this._toggleVisible = function (e) {
	      if (_this.props.onClick) {
	        _this.props.onClick(e);
	      }
	
	      _this.setState({ visible: !_this.state.visible });
	    }, _this._handleClose = function () {
	      _this.setState({ visible: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MenuTab, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          style = _props.style,
	          className = _props.className,
	          tabStyle = _props.tabStyle,
	          tabClassName = _props.tabClassName,
	          tabs = _props.tabs,
	          label = _props.label,
	          activeTabIndex = _props.activeTabIndex,
	          overflowAtIndex = _props.overflowAtIndex,
	          props = _objectWithoutProperties(_props, ['id', 'style', 'className', 'tabStyle', 'tabClassName', 'tabs', 'label', 'activeTabIndex', 'overflowAtIndex']);
	
	      var active = activeTabIndex >= overflowAtIndex;
	
	      var tab = _react2.default.createElement(
	        _AccessibleFakeInkedButton2.default,
	        _extends({}, props, {
	          onClick: this._toggleVisible,
	          style: tabStyle,
	          className: (0, _classnames2.default)('md-tab md-tab--menu', tabClassName)
	        }),
	        label
	      );
	
	      return _react2.default.createElement(
	        _Menu2.default,
	        {
	          id: id,
	          style: style,
	          className: (0, _classnames2.default)('md-menu--tab', {
	            'md-tab--active': active,
	            'md-tab--inactive': !active
	          }, className),
	          toggle: tab,
	          visible: this.state.visible,
	          onClose: this._handleClose
	        },
	        tabs.map(_mapToListParts2.default)
	      );
	    }
	  }]);
	
	  return MenuTab;
	}(_react.PureComponent);
	
	MenuTab.propTypes = {
	  /**
	   * An id to give the tab's menu.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * The current active tab index. This is used to determine which list item
	   * is active in the menu, and if the styles for an active tab should be applied
	   * to the menu.
	   */
	  activeTabIndex: _propTypes2.default.number.isRequired,
	
	  /**
	   * An tab index that caused the overflow to happen.
	   */
	  overflowAtIndex: _propTypes2.default.number.isRequired,
	
	  /**
	   * A list of tabs that should be rendered in the menu once opened. This can either
	   * be:
	   *
	   * - a `ListItem`, `Divider`, or `Subheader` component
	   * - a string to use as the `primaryText` for a list item
	   * - an object that defines props to generate a `ListItem`, `Divider`, or `Subheader` component
	   */
	  tabs: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.shape({
	    divider: _propTypes2.default.bool,
	    subheader: _propTypes2.default.bool,
	    primaryText: _propTypes2.default.node
	  })])).isRequired,
	
	  /**
	   * An optional style to apply to the menu.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the menu.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the tab in the menu.
	   */
	  tabStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the tab in the menu.
	   */
	  tabClassName: _propTypes2.default.string,
	
	  /**
	   * An optional function to call when the tab is clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * The label to display in the tab. This should normally be some text with
	   * a drop down arrow next to it.
	   */
	  label: _propTypes2.default.node.isRequired
	};
	exports.default = MenuTab;
	//# sourceMappingURL=MenuTab.js.map

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(17);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component is just a simple accessibility wrapper when using tabs. If you use the
	 * `TabsContainer` component, you *should* not manually use this as the `TabsContainer`
	 * generates this for you.
	 */
	var TabPanel = function (_PureComponent) {
	  _inherits(TabPanel, _PureComponent);
	
	  function TabPanel() {
	    _classCallCheck(this, TabPanel);
	
	    return _possibleConstructorReturn(this, (TabPanel.__proto__ || Object.getPrototypeOf(TabPanel)).apply(this, arguments));
	  }
	
	  _createClass(TabPanel, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.component,
	          id = _props.id,
	          active = _props.active,
	          className = _props.className,
	          controlledById = _props.controlledById,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['component', 'id', 'active', 'className', 'controlledById', 'children']);
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, {
	          id: id,
	          className: (0, _classnames2.default)('md-tab-panel', className),
	          role: 'tabpanel',
	          'aria-hidden': !active,
	          'aria-labelledby': controlledById
	        }),
	        children
	      );
	    }
	  }]);
	
	  return TabPanel;
	}(_react.PureComponent);
	
	TabPanel.propTypes = {
	  /**
	   * An id for the panel. This is used for a11y. This should equal the `controlsId`
	   * of whichever tab's children will be placed in here.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * An id for the tab that owns this panel. This should equal the `id` of whichever
	   * tab's children will be placed in here.
	   */
	  controlledById: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The component to render the panel as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * Boolean if the panel is currently active. This is used to generated the `aria-hidden`
	   * attribute.
	   */
	  active: _propTypes2.default.bool,
	
	  /**
	   * Any children to display.
	   */
	  children: _propTypes2.default.node
	};
	TabPanel.defaultProps = {
	  component: 'div'
	};
	exports.default = TabPanel;
	//# sourceMappingURL=TabPanel.js.map

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(12);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FloatingLabel = function (_PureComponent) {
	  _inherits(FloatingLabel, _PureComponent);
	
	  function FloatingLabel() {
	    _classCallCheck(this, FloatingLabel);
	
	    return _possibleConstructorReturn(this, (FloatingLabel.__proto__ || Object.getPrototypeOf(FloatingLabel)).apply(this, arguments));
	  }
	
	  _createClass(FloatingLabel, [{
	    key: 'render',
	    value: function render() {
	      var _cn;
	
	      var _props = this.props,
	          label = _props.label,
	          htmlFor = _props.htmlFor,
	          className = _props.className,
	          floating = _props.floating,
	          active = _props.active,
	          error = _props.error,
	          disabled = _props.disabled,
	          iconOffset = _props.iconOffset,
	          customSize = _props.customSize,
	          props = _objectWithoutProperties(_props, ['label', 'htmlFor', 'className', 'floating', 'active', 'error', 'disabled', 'iconOffset', 'customSize']);
	
	      if (!label) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'label',
	        _extends({}, props, {
	          htmlFor: htmlFor,
	          className: (0, _classnames2.default)('md-floating-label', (_cn = {
	            'md-floating-label--inactive': !floating,
	            'md-floating-label--inactive-sized': !floating && !customSize
	          }, _defineProperty(_cn, 'md-floating-label--' + customSize, customSize), _defineProperty(_cn, 'md-floating-label--inactive-' + customSize, customSize && !floating), _defineProperty(_cn, 'md-floating-label--floating', floating), _defineProperty(_cn, 'md-floating-label--icon-offset', iconOffset), _cn), (0, _themeColors2.default)({
	            disabled: disabled,
	            error: error,
	            hint: !active,
	            primary: active
	          }, className))
	        }),
	        label
	      );
	    }
	  }]);
	
	  return FloatingLabel;
	}(_react.PureComponent);
	
	FloatingLabel.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  label: _propTypes2.default.node,
	  floating: _propTypes2.default.bool,
	  error: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  iconOffset: _propTypes2.default.bool,
	  customSize: _propTypes2.default.string,
	  htmlFor: _propTypes2.default.string
	};
	exports.default = FloatingLabel;
	//# sourceMappingURL=FloatingLabel.js.map

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Divider = __webpack_require__(169);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextFieldDivider = function (_PureComponent) {
	  _inherits(TextFieldDivider, _PureComponent);
	
	  function TextFieldDivider() {
	    _classCallCheck(this, TextFieldDivider);
	
	    return _possibleConstructorReturn(this, (TextFieldDivider.__proto__ || Object.getPrototypeOf(TextFieldDivider)).apply(this, arguments));
	  }
	
	  _createClass(TextFieldDivider, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          error = _props.error,
	          lineDirection = _props.lineDirection,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['active', 'error', 'lineDirection', 'className']);
	
	      return _react2.default.createElement(_Divider2.default, _extends({}, props, {
	        className: (0, _classnames2.default)('md-divider--text-field md-divider--expand-from-' + lineDirection, {
	          'md-divider--text-field-expanded': active,
	          'md-divider--text-field-active': !error && active,
	          'md-divider--text-field-error': error
	        }, className)
	      }));
	    }
	  }]);
	
	  return TextFieldDivider;
	}(_react.PureComponent);
	
	TextFieldDivider.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  active: _propTypes2.default.bool,
	  error: _propTypes2.default.bool,
	  lineDirection: _propTypes2.default.oneOf(['left', 'center', 'right'])
	};
	exports.default = TextFieldDivider;
	//# sourceMappingURL=TextFieldDivider.js.map

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(12);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _Message = __webpack_require__(655);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextFieldMessage = function (_PureComponent) {
	  _inherits(TextFieldMessage, _PureComponent);
	
	  function TextFieldMessage(props) {
	    _classCallCheck(this, TextFieldMessage);
	
	    var _this = _possibleConstructorReturn(this, (TextFieldMessage.__proto__ || Object.getPrototypeOf(TextFieldMessage)).call(this, props));
	
	    _this.state = {
	      message: props.error && props.errorText || props.helpText || props.errorText,
	      isMessageVisible: _this._isMessageVisible(props)
	    };
	    return _this;
	  }
	
	  _createClass(TextFieldMessage, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var keys = ['active', 'error', 'helpOnFocus', 'helpText', 'errorText'];
	      if (this._anyChanges(keys, this.props, nextProps)) {
	        this.setState({
	          isMessageVisible: this._isMessageVisible(nextProps),
	          message: nextProps.error && nextProps.errorText || nextProps.helpText || nextProps.errorText
	        });
	      }
	    }
	  }, {
	    key: '_anyChanges',
	    value: function _anyChanges(keys, p1, p2) {
	      var changed = false;
	      keys.some(function (key) {
	        if (p1[key] !== p2[key]) {
	          changed = true;
	        }
	
	        return changed;
	      });
	
	      return changed;
	    }
	  }, {
	    key: '_isMessageVisible',
	    value: function _isMessageVisible(props) {
	      var error = props.error,
	          errorText = props.errorText,
	          helpText = props.helpText,
	          helpOnFocus = props.helpOnFocus,
	          active = props.active;
	
	      if (error && errorText) {
	        return true;
	      }
	
	      return !!(helpText && (!helpOnFocus || active));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          maxLength = _props.maxLength,
	          error = _props.error,
	          className = _props.className,
	          errorText = _props.errorText,
	          helpText = _props.helpText,
	          currentLength = _props.currentLength,
	          leftIcon = _props.leftIcon,
	          rightIcon = _props.rightIcon,
	          block = _props.block,
	          active = _props.active;
	      var _state = this.state,
	          isMessageVisible = _state.isMessageVisible,
	          message = _state.message;
	
	
	      if (currentLength === 'undefined' || !helpText && !errorText && !maxLength) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('md-text-field-message-container', {
	            'md-text-field-message-container--count-only': !message || !isMessageVisible,
	            'md-text-field-message-container--left-icon-offset': leftIcon,
	            'md-text-field-message-container--right-icon-offset': rightIcon,
	            'md-full-width': !block
	          }, (0, _themeColors2.default)({ error: error, disabled: !error }), className)
	        },
	        _react2.default.createElement(
	          _Message2.default,
	          { key: 'message', active: isMessageVisible },
	          message
	        ),
	        _react2.default.createElement(
	          _Message2.default,
	          { key: 'counter', className: 'md-text-field-message--counter', active: active },
	          maxLength ? currentLength + ' / ' + maxLength : null
	        )
	      );
	    }
	  }]);
	
	  return TextFieldMessage;
	}(_react.PureComponent);
	
	TextFieldMessage.propTypes = {
	  className: _propTypes2.default.string,
	  error: _propTypes2.default.bool,
	  helpText: _propTypes2.default.node,
	  errorText: _propTypes2.default.node,
	  active: _propTypes2.default.bool,
	  helpOnFocus: _propTypes2.default.bool,
	  maxLength: _propTypes2.default.number,
	  currentLength: _propTypes2.default.number,
	  leftIcon: _propTypes2.default.bool,
	  rightIcon: _propTypes2.default.bool,
	  block: _propTypes2.default.bool
	};
	exports.default = TextFieldMessage;
	//# sourceMappingURL=TextFieldMessage.js.map

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _invalidIf = __webpack_require__(48);
	
	var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	var _between = __webpack_require__(85);
	
	var _between2 = _interopRequireDefault(_between);
	
	var _Paper = __webpack_require__(33);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _ToolbarTitle = __webpack_require__(659);
	
	var _ToolbarTitle2 = _interopRequireDefault(_ToolbarTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Toolbar = function (_PureComponent) {
	  _inherits(Toolbar, _PureComponent);
	
	  function Toolbar() {
	    _classCallCheck(this, Toolbar);
	
	    return _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).apply(this, arguments));
	  }
	
	  _createClass(Toolbar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          component = _props.component,
	          titleStyle = _props.titleStyle,
	          titleClassName = _props.titleClassName,
	          prominentTitle = _props.prominentTitle,
	          themed = _props.themed,
	          singleColor = _props.singleColor,
	          actions = _props.actions,
	          fixed = _props.fixed,
	          children = _props.children,
	          inset = _props.inset,
	          titleId = _props.titleId,
	          propNav = _props.nav,
	          propTitle = _props.title,
	          propTitleMenu = _props.titleMenu,
	          propZDepth = _props.zDepth,
	          propColored = _props.colored,
	          propProminent = _props.prominent,
	          containerStyle = _props.containerStyle,
	          containerClassName = _props.containerClassName,
	          actionLeft = _props.actionLeft,
	          actionsRight = _props.actionsRight,
	          primary = _props.primary,
	          secondary = _props.secondary,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'component', 'titleStyle', 'titleClassName', 'prominentTitle', 'themed', 'singleColor', 'actions', 'fixed', 'children', 'inset', 'titleId', 'nav', 'title', 'titleMenu', 'zDepth', 'colored', 'prominent', 'containerStyle', 'containerClassName', 'actionLeft', 'actionsRight', 'primary', 'secondary']);
	
	      var _props2 = this.props,
	          colored = _props2.colored,
	          title = _props2.title,
	          titleMenu = _props2.titleMenu,
	          nav = _props2.nav,
	          prominent = _props2.prominent,
	          zDepth = _props2.zDepth;
	
	
	      colored = colored || primary || secondary;
	      prominent = prominent || prominentTitle;
	
	      title = _react2.default.createElement(_ToolbarTitle2.default, {
	        key: 'title',
	        style: titleStyle,
	        className: titleClassName,
	        prominent: prominentTitle,
	        offset: prominentTitle,
	        id: typeof titleId === 'undefined' && props.id ? props.id + '-title' : titleId,
	        title: title
	      });
	
	      if (nav || actionLeft) {
	        var navEl = _react.Children.only(nav || actionLeft);
	        nav = (0, _react.cloneElement)(nav, {
	          className: (0, _classnames2.default)('md-btn--toolbar md-toolbar--action-left', navEl.props.className)
	        });
	      }
	
	      var rightActions = void 0;
	      if (actions || actionsRight) {
	        rightActions = _react.Children.map(_react.Children.toArray(actions || actionsRight), function (action) {
	          return (0, _react.cloneElement)(action, {
	            className: (0, _classnames2.default)('md-btn--toolbar', action.props.className)
	          });
	        });
	
	        rightActions = _react2.default.createElement(
	          'div',
	          { key: 'actions', className: 'md-cell--right md-toolbar--action-right' },
	          rightActions
	        );
	      }
	
	      if (titleMenu) {
	        titleMenu = _react.Children.only(titleMenu);
	        titleMenu = (0, _react.cloneElement)(titleMenu, {
	          className: (0, _classnames2.default)('md-title md-title--toolbar md-select-field--toolbar', {
	            'md-title--toolbar-offset': prominentTitle,
	            'md-title--toolbar-prominent': prominentTitle
	          }, titleMenu.props.className),
	          position: titleMenu.props.position || 'tl',
	          toolbar: true
	        });
	      }
	
	      if (typeof zDepth !== 'number') {
	        zDepth = fixed ? 2 : 0;
	      }
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        _extends({}, props, {
	          component: component,
	          zDepth: zDepth,
	          style: style,
	          className: (0, _classnames2.default)('md-toolbar', {
	            'md-background--primary': colored,
	            'md-toolbar--themed': themed,
	            'md-toolbar--text-white': singleColor && colored,
	            'md-toolbar--prominent': prominent,
	            'md-toolbar--fixed': fixed,
	            'md-toolbar--inset': inset
	          }, className)
	        }),
	        nav,
	        title,
	        titleMenu,
	        children,
	        rightActions
	      );
	    }
	  }]);
	
	  return Toolbar;
	}(_react.PureComponent);
	
	Toolbar.propTypes = {
	  /**
	   * An optional id to provide to the toolbar. If this is specified and the `titleId` is not, the title
	   * will gain an id of `${id}-title`. This will not be applied to the `titleMenu`.
	   *
	   * @see {@link #titleId}
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the toolbar.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the toolbar,
	   */
	  className: _propTypes2.default.string,
	
	  /*
	   * An optional style to apply to the `h2` surrounding the `title` prop.
	   */
	  titleStyle: _propTypes2.default.object,
	
	  /*
	   * An optional className to apply to the `h2` surrounding the `title` prop.
	   */
	  titleClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the toolbar should more prominent. This will double the height of the toolbar.
	   */
	  prominent: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the toolbar's title should be more prominent. This will move the title to the
	   * second line of the toolbar. This only works when the `prominent` prop is true as well.
	   */
	  prominentTitle: _propTypes2.default.bool,
	
	  /**
	   * The current title of the page to show in the toolbar. It is invalid to specify both a
	   * `title` and a `titleMenu`. Only one should be given.
	   */
	  title: (0, _invalidIf2.default)(_propTypes2.default.node, 'titleMenu'),
	
	  /**
	   * An optional id to give the main title in the toolbar. This will not be applied to the
	   * `titleMenu`.
	   */
	  titleId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional title menu to display instead of the title. This should be a `SelectField` component.
	   * It is cloned with some additional props, so if the `SelectField` is separated into a separate
	   * component, the following props must be passed to get the correct styling: `className`, `block`,
	   * `paddedBlock`, `position`.
	   */
	  titleMenu: _propTypes2.default.element,
	
	  /**
	   * This prop is used for rendering an optional navigation button to the left of the `title`
	   * or the `titleMenu` component. This needs to be an icon `Button` because some additional props
	   * are cloned into it.
	   */
	  nav: _propTypes2.default.element,
	
	  /**
	   * Any additional actions to display to the right of the title. This should be a list or a single
	   * `Button` to display. The buttons get cloned with an additional className for toolbar styling.
	   */
	  actions: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]),
	
	  /**
	   * Any children to display in the toolbar. This will be displayed between the optional title and
	   * actions.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the toolbar should be fixed to the top of the page. This will add some additional box shadow.
	   */
	  fixed: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the nav, actions, and title should share the same color. For a `colored` or dark `themed`
	   * toolbar, they will all be colored white. For a transparent or light `themed` toolbar, the colors will
	   * be the `rgba(0, 0, 0, .87)`. Setting this to false will only style the title to the specific color
	   * stated above.
	   */
	  singleColor: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the toolbar should be colored based off the current theme. This will either style the background
	   * to be fairly white, or fairly black. You can not specify both `themed` and `colored`.
	   */
	  themed: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the toolbar should be colored with the `$md-primary-color`.
	   */
	  colored: (0, _invalidIf2.default)(_propTypes2.default.bool, 'themed'),
	
	  /**
	   * The component to render the toolbar as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * Boolean if the toolbar is inset in the page. This will just add some margin around
	   * it.
	   */
	  inset: _propTypes2.default.bool,
	
	  /**
	   * An optional zDepth to enforce for the toolbar. This should be a number between 0 and 5.
	   * If this is omitted, the toolbar will gain a zDepth of 2 when `fixed`.
	   */
	  zDepth: (0, _between2.default)(_propTypes2.default.number, 0, 5),
	  containerStyle: (0, _deprecated2.default)(_propTypes2.default.object, 'The `container` no longer exists in the `Toolbar`. Use the `style` prop instead'),
	  containerClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'The `container` no longer exists in the `Toolbar`. Use the `className` prop instead'),
	  primary: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use the `colored` prop instead'),
	  secondary: (0, _deprecated2.default)(_propTypes2.default.bool, 'Toolbars can no longer be themed to the secondary color. Use the `colored` prop instead'),
	  actionLeft: (0, _deprecated2.default)(_propTypes2.default.element, 'Use the `nav` prop instead'),
	  actionsRight: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `menu` prop and/or the `actions` prop instead')
	};
	Toolbar.defaultProps = {
	  singleColor: true,
	  component: 'header'
	};
	exports.default = Toolbar;
	//# sourceMappingURL=Toolbar.js.map

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(9);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(190);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keyCodes = __webpack_require__(15);
	
	var _captureNextEvent = __webpack_require__(82);
	
	var _captureNextEvent2 = _interopRequireDefault(_captureNextEvent);
	
	var _touches = __webpack_require__(84);
	
	var _Tooltip = __webpack_require__(661);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getContainer(tooltip) {
	  return tooltip.parentNode;
	}
	
	var TooltipContainer = function (_PureComponent) {
	  _inherits(TooltipContainer, _PureComponent);
	
	  function TooltipContainer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TooltipContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TooltipContainer.__proto__ || Object.getPrototypeOf(TooltipContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = { visible: false }, _this._delayedTimeout = null, _this._unlinkTarget = function () {
	      var target = _this._target;
	      if (target) {
	        (0, _touches.removeTouchEvent)(target, 'start', _this._showTooltip);
	        (0, _touches.removeTouchEvent)(target, 'end', _this._hideTooltip);
	        target.removeEventListener('mouseover', _this._showTooltip);
	        target.removeEventListener('mouseleave', _this._hideTooltip);
	        target.removeEventListener('keyup', _this._handleKeyUp);
	        target.removeEventListener('blur', _this._hideTooltip);
	      }
	    }, _this._setTarget = function () {
	      var container = _this._container;
	      var target = _this.props.target;
	
	
	      _this._unlinkTarget();
	
	      if (typeof target === 'function') {
	        target = target(container, _this);
	      }
	      target = target ? (0, _reactDom.findDOMNode)(target) : container;
	      _this._target = target || null;
	
	      if (target) {
	        (0, _touches.addTouchEvent)(target, 'start', _this._showTooltip);
	        (0, _touches.addTouchEvent)(target, 'end', _this._hideTooltip);
	        target.addEventListener('mouseover', _this._showTooltip);
	        target.addEventListener('mouseleave', _this._hideTooltip);
	        target.addEventListener('keyup', _this._handleKeyUp);
	        target.addEventListener('blur', _this._hideTooltip);
	      }
	    }, _this._setContainers = function (span) {
	      if (span) {
	        _this._container = _this.props.container(span.parentNode, _this);
	      }
	    }, _this._stopContextMenu = function (e) {
	      e.preventDefault();
	      window.removeEventListener('contextmenu', _this._stopContextMenu, true);
	      (0, _captureNextEvent2.default)('click');
	      _this.setState({ visible: true });
	    }, _this._showTooltip = function (e) {
	      if (e.type === 'mouseover' && _this._touched) {
	        return;
	      }
	
	      if (e.type === 'touchstart') {
	        _this._touched = true;
	
	        window.addEventListener('contextmenu', _this._stopContextMenu, true);
	        return;
	      }
	
	      var delay = _this.props.delay;
	
	      if (_this._delayedTimeout) {
	        clearTimeout(_this._delayedTimeout);
	      }
	
	      if (delay) {
	        _this._delayedTimeout = setTimeout(function () {
	          _this._delayedTimeout = null;
	
	          _this.setState({ visible: true });
	        }, delay);
	      } else {
	        _this.setState({ visible: true });
	      }
	    }, _this._hideTooltip = function (e) {
	      if (_this._delayedTimeout) {
	        clearTimeout(_this._delayedTimeout);
	      }
	
	      if (e.type === 'mouseover' && _this._touched) {
	        return;
	      }
	
	      _this.setState({ visible: false });
	    }, _this._handleKeyUp = function (e) {
	      if ((e.which || e.keyCode) === _keyCodes.TAB) {
	        _this._showTooltip(e);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TooltipContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._setTarget();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.target !== prevProps.target) {
	        this._setTarget();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._unlinkTarget();
	      this._target = null;
	
	      if (this._delayedTimeout) {
	        clearTimeout(this._delayedTimeout);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var visible = this.state.visible;
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          tooltipStyle = _props.tooltipStyle,
	          tooltipClassName = _props.tooltipClassName,
	          label = _props.label,
	          position = _props.position,
	          enterTimeout = _props.enterTimeout,
	          leaveTimeout = _props.leaveTimeout;
	
	
	      var tooltip = _react2.default.createElement(
	        _Tooltip2.default,
	        {
	          key: 'tooltip',
	          style: tooltipStyle,
	          className: tooltipClassName,
	          position: position,
	          enterTimeout: enterTimeout,
	          leaveTimeout: leaveTimeout
	        },
	        label
	      );
	
	      return _react2.default.createElement(
	        _TransitionGroup2.default,
	        {
	          style: style,
	          className: (0, _classnames2.default)('md-tooltip-container', className),
	          component: 'div'
	        },
	        _react2.default.createElement('span', { ref: this._setContainers, 'aria-hidden': true }),
	        visible ? tooltip : null
	      );
	    }
	  }]);
	
	  return TooltipContainer;
	}(_react.PureComponent);
	
	TooltipContainer.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  tooltipStyle: _propTypes2.default.object,
	  tooltipClassName: _propTypes2.default.string,
	  label: _propTypes2.default.node.isRequired,
	  position: _Tooltip2.default.propTypes.position,
	  delay: _propTypes2.default.number,
	  enterTimeout: _Tooltip2.default.propTypes.enterTimeout,
	  leaveTimeout: _Tooltip2.default.propTypes.leaveTimeout,
	  /**
	   * A function that returns a DOM element that will be used as the tooltip's container.
	   * A ref to the tooltip's DOM element will be passed into the function.
	   */
	  container: _propTypes2.default.func,
	  /**
	   * A component/element the tooltip should be linked to,
	   * or a function that returns such a component/element.
	   * A ref to the tooltip's container will be passed into the function.
	   *
	   * By default the tooltip's container will be used as the target.
	   */
	  target: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func])
	};
	TooltipContainer.defaultProps = {
	  container: getContainer,
	  delay: 0
	};
	exports.default = TooltipContainer;
	//# sourceMappingURL=TooltipContainer.js.map

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bem = exports.Version = exports.Tooltipped = exports.injectTooltip = exports.Toolbar = exports.TextField = exports.TabPanel = exports.MenuTab = exports.Tab = exports.Tabs = exports.TabsContainer = exports.Subheader = exports.SVGIcon = exports.Snackbar = exports.Sidebar = exports.Slider = exports.Switch = exports.Radio = exports.RadioGroup = exports.Checkbox = exports.SelectionControlGroup = exports.SelectionControl = exports.SelectField = exports.LinearProgress = exports.CircularProgress = exports.TimePicker = exports.DatePicker = exports.Paper = exports.JumpToContentLink = exports.CloseButton = exports.NavigationDrawer = exports.MenuButton = exports.DropdownMenu = exports.Menu = exports.MediaOverlay = exports.Media = exports.ListItemControl = exports.ListItem = exports.List = exports.injectInk = exports.ResizeObserver = exports.Portal = exports.Layover = exports.FocusContainer = exports.IconSeparator = exports.Collapse = exports.AccessibleFakeInkedButton = exports.AccessibleFakeButton = exports.GridList = exports.Cell = exports.Grid = exports.FontIcon = exports.FileUpload = exports.FileInput = exports.SpeedDial = exports.ExpansionPanel = exports.ExpansionList = exports.Drawer = exports.Divider = exports.Dialog = exports.DialogContainer = exports.DropdownMenuColumn = exports.MenuButtonColumn = exports.SelectFieldColumn = exports.TablePagination = exports.EditDialogColumn = exports.TableCardHeader = exports.TableColumn = exports.TableRow = exports.TableFooter = exports.TableBody = exports.TableHeader = exports.DataTable = exports.Chip = exports.CardActionOverlay = exports.CardText = exports.CardActions = exports.CardMedia = exports.CardTitle = exports.Card = exports.IconButton = exports.FloatingButton = exports.RaisedButton = exports.FlatButton = exports.Button = exports.Badge = exports.BottomNavigation = exports.Avatar = exports.Autocomplete = undefined;
	
	var _Autocompletes = __webpack_require__(543);
	
	var _Autocompletes2 = _interopRequireDefault(_Autocompletes);
	
	var _Avatars = __webpack_require__(545);
	
	var _Avatars2 = _interopRequireDefault(_Avatars);
	
	var _Badges = __webpack_require__(547);
	
	var _Badges2 = _interopRequireDefault(_Badges);
	
	var _BottomNavigations = __webpack_require__(550);
	
	var _BottomNavigations2 = _interopRequireDefault(_BottomNavigations);
	
	var _Buttons = __webpack_require__(554);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	var _Cards = __webpack_require__(559);
	
	var _Cards2 = _interopRequireDefault(_Cards);
	
	var _Chips = __webpack_require__(561);
	
	var _Chips2 = _interopRequireDefault(_Chips);
	
	var _DataTables = __webpack_require__(574);
	
	var _DataTables2 = _interopRequireDefault(_DataTables);
	
	var _Dialogs = __webpack_require__(577);
	
	var _Dialogs2 = _interopRequireDefault(_Dialogs);
	
	var _Dividers = __webpack_require__(578);
	
	var _Dividers2 = _interopRequireDefault(_Dividers);
	
	var _Drawers = __webpack_require__(580);
	
	var _Drawers2 = _interopRequireDefault(_Drawers);
	
	var _ExpansionPanels = __webpack_require__(584);
	
	var _FABTransitions = __webpack_require__(586);
	
	var _FileInputs = __webpack_require__(588);
	
	var _FileInputs2 = _interopRequireDefault(_FileInputs);
	
	var _FontIcons = __webpack_require__(270);
	
	var _FontIcons2 = _interopRequireDefault(_FontIcons);
	
	var _Grids = __webpack_require__(590);
	
	var _Helpers = __webpack_require__(591);
	
	var _Inks = __webpack_require__(594);
	
	var _Inks2 = _interopRequireDefault(_Inks);
	
	var _Lists = __webpack_require__(597);
	
	var _Media = __webpack_require__(598);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _Menus = __webpack_require__(599);
	
	var _Menus2 = _interopRequireDefault(_Menus);
	
	var _NavigationDrawers = __webpack_require__(602);
	
	var _NavigationDrawers2 = _interopRequireDefault(_NavigationDrawers);
	
	var _Papers = __webpack_require__(603);
	
	var _Papers2 = _interopRequireDefault(_Papers);
	
	var _Pickers = __webpack_require__(620);
	
	var _Progress = __webpack_require__(623);
	
	var _SelectionControls = __webpack_require__(635);
	
	var _SelectFields = __webpack_require__(628);
	
	var _SelectFields2 = _interopRequireDefault(_SelectFields);
	
	var _Sliders = __webpack_require__(645);
	
	var _Sliders2 = _interopRequireDefault(_Sliders);
	
	var _Sidebars = __webpack_require__(637);
	
	var _Sidebars2 = _interopRequireDefault(_Sidebars);
	
	var _Snackbars = __webpack_require__(647);
	
	var _Snackbars2 = _interopRequireDefault(_Snackbars);
	
	var _SVGIcons = __webpack_require__(625);
	
	var _SVGIcons2 = _interopRequireDefault(_SVGIcons);
	
	var _Subheaders = __webpack_require__(287);
	
	var _Subheaders2 = _interopRequireDefault(_Subheaders);
	
	var _Tabs = __webpack_require__(653);
	
	var _TextFields = __webpack_require__(658);
	
	var _TextFields2 = _interopRequireDefault(_TextFields);
	
	var _Toolbars = __webpack_require__(660);
	
	var _Toolbars2 = _interopRequireDefault(_Toolbars);
	
	var _Tooltips = __webpack_require__(663);
	
	var _Tooltips2 = _interopRequireDefault(_Tooltips);
	
	var _Version = __webpack_require__(664);
	
	var _Version2 = _interopRequireDefault(_Version);
	
	var _bem = __webpack_require__(180);
	
	var _bem2 = _interopRequireDefault(_bem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Exposes for UMD -> ReactMD.Autocomplete
	exports.Autocomplete = _Autocompletes2.default;
	exports.Avatar = _Avatars2.default;
	exports.BottomNavigation = _BottomNavigations2.default;
	exports.Badge = _Badges2.default;
	exports.Button = _Buttons2.default;
	exports.FlatButton = _Buttons.FlatButton;
	exports.RaisedButton = _Buttons.RaisedButton;
	exports.FloatingButton = _Buttons.FloatingButton;
	exports.IconButton = _Buttons.IconButton;
	exports.Card = _Cards2.default;
	exports.CardTitle = _Cards.CardTitle;
	exports.CardMedia = _Cards.CardMedia;
	exports.CardActions = _Cards.CardActions;
	exports.CardText = _Cards.CardText;
	exports.CardActionOverlay = _Cards.CardActionOverlay;
	exports.Chip = _Chips2.default;
	exports.DataTable = _DataTables2.default;
	exports.TableHeader = _DataTables.TableHeader;
	exports.TableBody = _DataTables.TableBody;
	exports.TableFooter = _DataTables.TableFooter;
	exports.TableRow = _DataTables.TableRow;
	exports.TableColumn = _DataTables.TableColumn;
	exports.TableCardHeader = _DataTables.TableCardHeader;
	exports.EditDialogColumn = _DataTables.EditDialogColumn;
	exports.TablePagination = _DataTables.TablePagination;
	exports.SelectFieldColumn = _DataTables.SelectFieldColumn;
	exports.MenuButtonColumn = _DataTables.MenuButtonColumn;
	exports.DropdownMenuColumn = _DataTables.DropdownMenuColumn;
	exports.DialogContainer = _Dialogs2.default;
	exports.Dialog = _Dialogs.Dialog;
	exports.Divider = _Dividers2.default;
	exports.Drawer = _Drawers2.default;
	exports.ExpansionList = _ExpansionPanels.ExpansionList;
	exports.ExpansionPanel = _ExpansionPanels.ExpansionPanel;
	exports.SpeedDial = _FABTransitions.SpeedDial;
	exports.FileInput = _FileInputs2.default;
	exports.FileUpload = _FileInputs.FileUpload;
	exports.FontIcon = _FontIcons2.default;
	exports.Grid = _Grids.Grid;
	exports.Cell = _Grids.Cell;
	exports.GridList = _Grids.GridList;
	exports.AccessibleFakeButton = _Helpers.AccessibleFakeButton;
	exports.AccessibleFakeInkedButton = _Helpers.AccessibleFakeInkedButton;
	exports.Collapse = _Helpers.Collapse;
	exports.IconSeparator = _Helpers.IconSeparator;
	exports.FocusContainer = _Helpers.FocusContainer;
	exports.Layover = _Helpers.Layover;
	exports.Portal = _Helpers.Portal;
	exports.ResizeObserver = _Helpers.ResizeObserver;
	exports.injectInk = _Inks2.default;
	exports.List = _Lists.List;
	exports.ListItem = _Lists.ListItem;
	exports.ListItemControl = _Lists.ListItemControl;
	exports.Media = _Media2.default;
	exports.MediaOverlay = _Media.MediaOverlay;
	exports.Menu = _Menus2.default;
	exports.DropdownMenu = _Menus.DropdownMenu;
	exports.MenuButton = _Menus.MenuButton;
	exports.NavigationDrawer = _NavigationDrawers2.default;
	exports.CloseButton = _NavigationDrawers.CloseButton;
	exports.JumpToContentLink = _NavigationDrawers.JumpToContentLink;
	exports.Paper = _Papers2.default;
	exports.DatePicker = _Pickers.DatePicker;
	exports.TimePicker = _Pickers.TimePicker;
	exports.CircularProgress = _Progress.CircularProgress;
	exports.LinearProgress = _Progress.LinearProgress;
	exports.SelectField = _SelectFields2.default;
	exports.SelectionControl = _SelectionControls.SelectionControl;
	exports.SelectionControlGroup = _SelectionControls.SelectionControlGroup;
	exports.Checkbox = _SelectionControls.Checkbox;
	exports.RadioGroup = _SelectionControls.RadioGroup;
	exports.Radio = _SelectionControls.Radio;
	exports.Switch = _SelectionControls.Switch;
	exports.Slider = _Sliders2.default;
	exports.Sidebar = _Sidebars2.default;
	exports.Snackbar = _Snackbars2.default;
	exports.SVGIcon = _SVGIcons2.default;
	exports.Subheader = _Subheaders2.default;
	exports.TabsContainer = _Tabs.TabsContainer;
	exports.Tabs = _Tabs.Tabs;
	exports.Tab = _Tabs.Tab;
	exports.MenuTab = _Tabs.MenuTab;
	exports.TabPanel = _Tabs.TabPanel;
	exports.TextField = _TextFields2.default;
	exports.Toolbar = _Toolbars2.default;
	exports.injectTooltip = _Tooltips2.default;
	exports.Tooltipped = _Tooltips.Tooltipped;
	exports.Version = _Version2.default;
	exports.bem = _bem2.default;
	
	// Exposes for ES6 modules
	
	exports.default = {
	  Autocomplete: _Autocompletes2.default,
	  Avatar: _Avatars2.default,
	  Badge: _Badges2.default,
	  BottomNavigation: _BottomNavigations2.default,
	
	  Button: _Buttons2.default,
	  FlatButton: _Buttons.FlatButton,
	  RaisedButton: _Buttons.RaisedButton,
	  FloatingButton: _Buttons.FloatingButton,
	  IconButton: _Buttons.IconButton,
	
	  Card: _Cards2.default,
	  CardTitle: _Cards.CardTitle,
	  CardMedia: _Cards.CardMedia,
	  CardActions: _Cards.CardActions,
	  CardText: _Cards.CardText,
	  CardActionOverlay: _Cards.CardActionOverlay,
	
	  Chip: _Chips2.default,
	
	  DataTable: _DataTables2.default,
	  TableHeader: _DataTables.TableHeader,
	  TableBody: _DataTables.TableBody,
	  TableFooter: _DataTables.TableFooter,
	  TableRow: _DataTables.TableRow,
	  TableColumn: _DataTables.TableColumn,
	  TableCardHeader: _DataTables.TableCardHeader,
	  EditDialogColumn: _DataTables.EditDialogColumn,
	  TablePagination: _DataTables.TablePagination,
	  SelectFieldColumn: _DataTables.SelectFieldColumn,
	  MenuButtonColumn: _DataTables.MenuButtonColumn,
	  DropdownMenuColumn: _DataTables.DropdownMenuColumn,
	
	  DialogContainer: _Dialogs2.default,
	  Dialog: _Dialogs.Dialog,
	  Divider: _Dividers2.default,
	  Drawer: _Drawers2.default,
	
	  ExpansionList: _ExpansionPanels.ExpansionList,
	  ExpansionPanel: _ExpansionPanels.ExpansionPanel,
	
	  SpeedDial: _FABTransitions.SpeedDial,
	
	  FileInput: _FileInputs2.default,
	  FileUpload: _FileInputs.FileUpload,
	
	  FontIcon: _FontIcons2.default,
	
	  Grid: _Grids.Grid,
	  Cell: _Grids.Cell,
	  GridList: _Grids.GridList,
	
	  AccessibleFakeButton: _Helpers.AccessibleFakeButton,
	  AccessibleFakeInkedButton: _Helpers.AccessibleFakeInkedButton,
	  Collapse: _Helpers.Collapse,
	  IconSeparator: _Helpers.IconSeparator,
	  Layover: _Helpers.Layover,
	  FocusContainer: _Helpers.FocusContainer,
	  Portal: _Helpers.Portal,
	  ResizeObserver: _Helpers.ResizeObserver,
	
	  injectInk: _Inks2.default,
	
	  List: _Lists.List,
	  ListItem: _Lists.ListItem,
	  ListItemControl: _Lists.ListItemControl,
	
	  Media: _Media2.default,
	  MediaOverlay: _Media.MediaOverlay,
	
	  Menu: _Menus2.default,
	  DropdownMenu: _Menus.DropdownMenu,
	  MenuButton: _Menus.MenuButton,
	
	  NavigationDrawer: _NavigationDrawers2.default,
	  CloseButton: _NavigationDrawers.CloseButton,
	  JumpToContentLink: _NavigationDrawers.JumpToContentLink,
	
	  Paper: _Papers2.default,
	
	  DatePicker: _Pickers.DatePicker,
	  TimePicker: _Pickers.TimePicker,
	
	  CircularProgress: _Progress.CircularProgress,
	  LinearProgress: _Progress.LinearProgress,
	
	  SelectField: _SelectFields2.default,
	
	  SelectionControl: _SelectionControls.SelectionControl,
	  SelectionControlGroup: _SelectionControls.SelectionControlGroup,
	  Checkbox: _SelectionControls.Checkbox,
	  RadioGroup: _SelectionControls.RadioGroup,
	  Radio: _SelectionControls.Radio,
	  Switch: _SelectionControls.Switch,
	
	  Slider: _Sliders2.default,
	  Sidebar: _Sidebars2.default,
	  Snackbar: _Snackbars2.default,
	
	  SVGIcon: _SVGIcons2.default,
	  Subheader: _Subheaders2.default,
	
	  TabsContainer: _Tabs.TabsContainer,
	  Tabs: _Tabs.Tabs,
	  Tab: _Tabs.Tab,
	  MenuTab: _Tabs.MenuTab,
	  TabPanel: _Tabs.TabPanel,
	
	  TextField: _TextFields2.default,
	  Toolbar: _Toolbars2.default,
	  injectTooltip: _Tooltips2.default,
	  Tooltipped: _Tooltips.Tooltipped,
	
	  Version: _Version2.default,
	
	  bem: _bem2.default
	};
	//# sourceMappingURL=index.js.map

/***/ }),
/* 296 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/** @module utils/DateUtils/DateTimeFormat */
	
	/**
	 * A _really_ terrible DateTimeFormat mock if it is not available in
	 * the browser or node version.
	 */
	var DateTimeFormat = function () {
	  if (typeof Intl !== 'undefined' && typeof Intl.DateTimeFormat !== 'undefined') {
	    return Intl.DateTimeFormat;
	  }
	
	  // Very bad 'mock' of Intl.DateTimeFormat
	  return function () {
	    // eslint-disable-line no-shadow
	    function DateTimeFormat(locales, formatOptions) {
	      _classCallCheck(this, DateTimeFormat);
	
	      this.locales = locales;
	      this.options = formatOptions;
	    }
	
	    _createClass(DateTimeFormat, [{
	      key: 'format',
	      value: function format(date) {
	        return date.toLocaleString();
	      }
	    }]);
	
	    return DateTimeFormat;
	  }();
	}();
	
	exports.default = DateTimeFormat;
	//# sourceMappingURL=DateTimeFormat.js.map

/***/ }),
/* 297 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatTime;
	/** @module utils/DateUtils/formatTime */
	
	/**
	 * Formats a date as a time string using the DateTimeFormat function and locales.
	 *
	 * @param {function} DateTimeFormat the DateTimeFormat function to use.
	 * @param {string|string[]} locales the locales to use.
	 * @param {Date} time the time to format into a string.
	 * @return a string of the formatted time.
	 */
	function formatTime(DateTimeFormat, locales, time) {
	  return new DateTimeFormat(locales, { hour: 'numeric', minute: '2-digit' }).format(time);
	}
	//# sourceMappingURL=formatTime.js.map

/***/ }),
/* 298 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDayOfWeek;
	/** @module utils/DateUtils/getDayOfWeek */
	
	/**
	 * Gets a day in the week. 0 = Sunday 6 = Saturday
	 *
	 * @param {date} sourceDate the date to find a relative day of week from
	 * @param {number} dow the day of the week to find
	 * @return a new Date as the given day of week
	 */
	function getDayOfWeek(sourceDate) {
	  var dow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  var date = new Date(sourceDate);
	  var day = date.getDay();
	
	  var diff = date.getDate() - day + dow;
	  return new Date(date.setDate(diff));
	}
	//# sourceMappingURL=getDayOfWeek.js.map

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stripTime;
	/** @module utils/DateUtils/stripTime */
	
	/**
	 * Removes all time from a date. Only keeps year, month, and date.
	 * @param {Date} date the date to strip
	 * @return a new Date with the time stripped.
	 */
	function stripTime(date) {
	  if (!date || !(date instanceof Date)) {
	    return null;
	  }
	
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
	}
	//# sourceMappingURL=stripTime.js.map

/***/ }),
/* 300 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBetween;
	/** @module utils/NumberUtils/isBetween */
	
	/**
	 * Checks if a number is between a min and maximum (inclusive)
	 *
	 * @param {Number} num the number to check
	 * @param {Number} min the minimum
	 * @param {Number} max the maximum
	 * @return {Boolean} true if the number is between the min and max (inclusive)
	 */
	function isBetween(num, min, max) {
	  return num >= min && num <= max;
	}
	//# sourceMappingURL=isBetween.js.map

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calcPageOffset;
	
	var _getPagePosition = __webpack_require__(302);
	
	var _getPagePosition2 = _interopRequireDefault(_getPagePosition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Calculates the page offset of an element. If the element
	 * is false-ish, an empty object will be returned.
	 *
	 * This is really only used for calculating an ink position.
	 *
	 * @param {Node} el - An html node to find a page offset for.
	 * @return {Object} an object with a left and top attribute for the page
	 *    offset.
	 */
	function calcPageOffset(el) {
	  if (!el) {
	    return { left: null, right: null };
	  }
	
	  var rect = el.getBoundingClientRect();
	  return {
	    left: rect.left + (0, _getPagePosition2.default)('x'),
	    top: rect.top + (0, _getPagePosition2.default)('y')
	  };
	} /** @module utils/Positioning/calcPageOffset */
	//# sourceMappingURL=calcPageOffset.js.map

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getPagePosition;
	/** @module utils/Positioning/getPagePosition */
	
	/**
	 * Gets the current page position.
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY
	 * @param {String} direction - The direction that should be retrieved. This
	 *    should be either 'x' or 'y'.
	 * @return {number} the position of the direction on the page.
	 */
	function getPagePosition(direction) {
	  var scroll = 'scroll' + (direction === 'x' ? 'Left' : 'Top');
	  if (typeof window.pageXOffset !== 'undefined') {
	    return window['page' + direction.toUpperCase() + 'Offset'];
	  } else if ((document.compatMode || '') === 'CSS1Compat') {
	    return document.documentElement[scroll];
	  } else {
	    return document.body[scroll];
	  }
	}
	//# sourceMappingURL=getPagePosition.js.map

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getScreenSize;
	/** @module utils/Positioning/getScreenSize */
	
	/**
	 * A utility function to get the height or width of the of the browser with
	 * a fallback for older browsers.
	 *
	 * @param {String} position - the position to get the screen size for
	 * @return {number} the screen size for the provided position.
	 */
	function getScreenSize(position) {
	  if (position !== 'Height' && position !== 'Width' && ("production") !== 'production') {
	    throw new Error('The \'getScreenSize\' function requires either a position of \'Height\' or \'Width\' ' + ('but received `' + position + '`'));
	  }
	
	  return window['inner' + position] || document.documentElement['client' + position];
	}
	//# sourceMappingURL=getScreenSize.js.map

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = viewport;
	
	var _getScreenSize = __webpack_require__(303);
	
	var _getScreenSize2 = _interopRequireDefault(_getScreenSize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Determines if an element is still in the viewport. If it is,
	 * it will return a `true` boolean. If it is not, it will return
	 * an object containing booleans for top, right, bottom, and left
	 * where a `false` value will mean it is out of the viewport for that
	 * position.
	 *
	 * @param {Object} el - The element to test.
	 * @return {boolean|Object} the results.
	 */
	function viewport(el) {
	  if (!el) {
	    return {};
	  }
	
	  var rect = el.getBoundingClientRect();
	  var top = rect.top >= 0;
	  var right = rect.right <= (0, _getScreenSize2.default)('Width');
	  var bottom = rect.bottom <= (0, _getScreenSize2.default)('Height');
	  var left = rect.left >= 0;
	
	  return top && right && bottom && left || { top: top, right: right, bottom: bottom, left: left };
	} /** @module utils/Positioning/viewport */
	//# sourceMappingURL=viewport.js.map

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = oneRequired;
	/** @module utils/PropTypes/oneRequired */
	
	/**
	 * A simple prop type validation that makes sure that at least this prop or one of the
	 * other defined prop names are defined for a component.
	 *
	 * @param {function} validator - The PropType validator for the current prop.
	 * @param {...String} otherPropNames - A single or list of prop names that could be defined
	 * @return {Error} a prop type validation error or null.
	 */
	function oneRequired(validator) {
	  for (var _len = arguments.length, otherPropNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    otherPropNames[_key - 1] = arguments[_key];
	  }
	
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	    var allPropNames = [propFullNameSafe].concat(otherPropNames);
	
	    for (var _len2 = arguments.length, args = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	      args[_key2 - 5] = arguments[_key2];
	    }
	
	    var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	    if (!err && !allPropNames.filter(function (pn) {
	      return typeof props[pn] !== 'undefined';
	    }).length) {
	      err = new Error('One of the following props are required for the ' + componentNameSafe + ' component. ' + ('`' + allPropNames.join('`, `') + '`.'));
	    }
	
	    return err;
	  };
	}
	//# sourceMappingURL=oneRequired.js.map

/***/ }),
/* 306 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addSuffix;
	/** @module utils/StringUtils/addSuffix */
	
	/**
	 * Optionally adds a suffix to a string if it does
	 * not already contain that string.
	 *
	 * @param {String} str - The string to modify
	 * @param {String} suffix - The suffix to add
	 *
	 * @return {String} the string with a suffix
	 */
	function addSuffix(str, suffix) {
	  if (!str || typeof str !== 'string') {
	    return str;
	  }
	
	  return str.indexOf(suffix) === -1 ? str.trim() + ' ' + suffix : str;
	}
	//# sourceMappingURL=addSuffix.js.map

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFormPartRole;
	/** @module utils/isFormPartRole */
	
	/**
	 * A simple utility function to determine if an element has a role that should
	 * be used as a form part. This is mostly used for changing the behavior of keyboard
	 * events.
	 *
	 * A form part role is one of the following:
	 * - checkbox
	 * - radio
	 * - listbox
	 * - input
	 *
	 * @param {HTMLElement} el - the element to check.
	 * @return {boolean} true if the element is considered an element part of a form.
	 */
	function isFormPartRole(el) {
	  if (!el) {
	    return false;
	  } else if (el.nodeName === 'INPUT') {
	    return true;
	  }
	
	  var role = el.getAttribute('role');
	  return role === 'checkbox' || role === 'radio' || role === 'listbox';
	}
	//# sourceMappingURL=isFormPartRole.js.map

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__(691);
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__(692);
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__(693);
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__(696);
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__(308);
	
	exports.presets = _interopRequire(_presets);
	
	var _stripStyle = __webpack_require__(117);
	
	exports.stripStyle = _interopRequire(_stripStyle);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__(695);
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	    className: '',
	    accessibility: true,
	    adaptiveHeight: false,
	    arrows: true,
	    autoplay: false,
	    autoplaySpeed: 3000,
	    centerMode: false,
	    centerPadding: '50px',
	    cssEase: 'ease',
	    customPaging: function customPaging(i) {
	        return _react2.default.createElement(
	            'button',
	            null,
	            i + 1
	        );
	    },
	    dots: false,
	    dotsClass: 'slick-dots',
	    draggable: true,
	    easing: 'linear',
	    edgeFriction: 0.35,
	    fade: false,
	    focusOnSelect: false,
	    infinite: true,
	    initialSlide: 0,
	    lazyLoad: false,
	    pauseOnHover: true,
	    responsive: null,
	    rtl: false,
	    slide: 'div',
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    speed: 500,
	    swipe: true,
	    swipeToSlide: false,
	    touchMove: true,
	    touchThreshold: 5,
	    useCSS: true,
	    variableWidth: false,
	    vertical: false,
	    waitForAnimate: true,
	    afterChange: null,
	    beforeChange: null,
	    edgeEvent: null,
	    init: null,
	    swipeEvent: null,
	    // nextArrow, prevArrow are react componets
	    nextArrow: null,
	    prevArrow: null
	};
	
	module.exports = defaultProps;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = undefined;
	
	var _reactDom = __webpack_require__(9);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _objectAssign = __webpack_require__(7);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error('Keys Missing', spec);
	};
	
	var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);
	
	  var trackWidth, trackHeight;
	
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	
	  if (!spec.vertical) {
	    if (spec.variableWidth) {
	      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	    } else if (spec.centerMode) {
	      trackWidth = (spec.slideCount + 2 * (spec.slidesToShow + 1)) * spec.slideWidth;
	    } else {
	      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	    }
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    WebkitTransform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transition: '',
	    WebkitTransition: '',
	    msTransform: !spec.vertical ? 'translateX(' + spec.left + 'px)' : 'translateY(' + spec.left + 'px)'
	  };
	
	  if (trackWidth) {
	    (0, _objectAssign2.default)(style, { width: trackWidth });
	  }
	
	  if (trackHeight) {
	    (0, _objectAssign2.default)(style, { height: trackHeight });
	  }
	
	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + 'px';
	    } else {
	      style.marginTop = spec.left + 'px';
	    }
	  }
	
	  return style;
	};
	
	var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);
	
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
	  style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
	  return style;
	};
	
	var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
	
	  checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth', 'slideHeight']);
	
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (spec.fade) {
	    return 0;
	  }
	
	  if (spec.infinite) {
	    if (spec.slideCount >= spec.slidesToShow) {
	      slideOffset = spec.slideWidth * spec.slidesToShow * -1;
	      verticalOffset = spec.slideHeight * spec.slidesToShow * -1;
	    }
	    if (spec.slideCount % spec.slidesToScroll !== 0) {
	      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
	        if (spec.slideIndex > spec.slideCount) {
	          slideOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideWidth * -1;
	          verticalOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideHeight * -1;
	        } else {
	          slideOffset = spec.slideCount % spec.slidesToScroll * spec.slideWidth * -1;
	          verticalOffset = spec.slideCount % spec.slidesToScroll * spec.slideHeight * -1;
	        }
	      }
	    }
	  } else {
	
	    if (spec.slideCount % spec.slidesToScroll !== 0) {
	      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
	        var slidesToOffset = spec.slidesToShow - spec.slideCount % spec.slidesToScroll;
	        slideOffset = slidesToOffset * spec.slideWidth;
	      }
	    }
	  }
	
	  if (spec.centerMode) {
	    if (spec.infinite) {
	      slideOffset += spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    } else {
	      slideOffset = spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    }
	  }
	
	  if (!spec.vertical) {
	    targetLeft = spec.slideIndex * spec.slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = spec.slideIndex * spec.slideHeight * -1 + verticalOffset;
	  }
	
	  if (spec.variableWidth === true) {
	    var targetSlideIndex;
	    if (spec.slideCount <= spec.slidesToShow || spec.infinite === false) {
	      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[spec.slideIndex];
	    } else {
	      targetSlideIndex = spec.slideIndex + spec.slidesToShow;
	      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[targetSlideIndex];
	    }
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (spec.centerMode === true) {
	      if (spec.infinite === false) {
	        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex];
	      } else {
	        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex + spec.slidesToShow + 1];
	      }
	
	      if (targetSlide) {
	        targetLeft = targetSlide.offsetLeft * -1 + (spec.listWidth - targetSlide.offsetWidth) / 2;
	      }
	    }
	  }
	
	  return targetLeft;
	};

/***/ }),
/* 315 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  RESISTANCE_COEF: 0.6,
	
	  // This value is closed to what browsers are using internally to
	  // trigger a native scroll.
	  UNCERTAINTY_THRESHOLD: 3 // px
	};

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.nameShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  leaveActive: _propTypes2.default.string,
	  appear: _propTypes2.default.string,
	  appearActive: _propTypes2.default.string
	})]);

/***/ }),
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = blacklist;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function blacklist(str, chars) {
	  (0, _assertString2.default)(str);
	  return str.replace(new RegExp('[' + chars + ']+', 'g'), '');
	}
	module.exports = exports['default'];

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isByteLength;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable prefer-rest-params */
	function isByteLength(str, options) {
	  (0, _assertString2.default)(str);
	  var min = void 0;
	  var max = void 0;
	  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	    min = options.min || 0;
	    max = options.max;
	  } else {
	    // backwards compatibility: isByteLength(str, min [, max])
	    min = arguments[1];
	    max = arguments[2];
	  }
	  var len = encodeURI(str).split(/%..|./).length - 1;
	  return len >= min && (typeof max === 'undefined' || len <= max);
	}
	module.exports = exports['default'];

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fullWidth = undefined;
	exports.default = isFullWidth;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fullWidth = exports.fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
	
	function isFullWidth(str) {
	  (0, _assertString2.default)(str);
	  return fullWidth.test(str);
	}

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.halfWidth = undefined;
	exports.default = isHalfWidth;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var halfWidth = exports.halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
	
	function isHalfWidth(str) {
	  (0, _assertString2.default)(str);
	  return halfWidth.test(str);
	}

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isHexadecimal;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hexadecimal = /^[0-9A-F]+$/i;
	
	function isHexadecimal(str) {
	  (0, _assertString2.default)(str);
	  return hexadecimal.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isIP;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ipv4Maybe = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
	var ipv6Block = /^[0-9A-F]{1,4}$/i;
	
	function isIP(str) {
	  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  (0, _assertString2.default)(str);
	  version = String(version);
	  if (!version) {
	    return isIP(str, 4) || isIP(str, 6);
	  } else if (version === '4') {
	    if (!ipv4Maybe.test(str)) {
	      return false;
	    }
	    var parts = str.split('.').sort(function (a, b) {
	      return a - b;
	    });
	    return parts[3] <= 255;
	  } else if (version === '6') {
	    var blocks = str.split(':');
	    var foundOmissionBlock = false; // marker to indicate ::
	
	    // At least some OS accept the last 32 bits of an IPv6 address
	    // (i.e. 2 of the blocks) in IPv4 notation, and RFC 3493 says
	    // that '::ffff:a.b.c.d' is valid for IPv4-mapped IPv6 addresses,
	    // and '::a.b.c.d' is deprecated, but also valid.
	    var foundIPv4TransitionBlock = isIP(blocks[blocks.length - 1], 4);
	    var expectedNumberOfBlocks = foundIPv4TransitionBlock ? 7 : 8;
	
	    if (blocks.length > expectedNumberOfBlocks) {
	      return false;
	    }
	    // initial or final ::
	    if (str === '::') {
	      return true;
	    } else if (str.substr(0, 2) === '::') {
	      blocks.shift();
	      blocks.shift();
	      foundOmissionBlock = true;
	    } else if (str.substr(str.length - 2) === '::') {
	      blocks.pop();
	      blocks.pop();
	      foundOmissionBlock = true;
	    }
	
	    for (var i = 0; i < blocks.length; ++i) {
	      // test for a :: which can not be at the string start/end
	      // since those cases have been handled above
	      if (blocks[i] === '' && i > 0 && i < blocks.length - 1) {
	        if (foundOmissionBlock) {
	          return false; // multiple :: in address
	        }
	        foundOmissionBlock = true;
	      } else if (foundIPv4TransitionBlock && i === blocks.length - 1) {
	        // it has been checked before that the last
	        // block is a valid IPv4 address
	      } else if (!ipv6Block.test(blocks[i])) {
	        return false;
	      }
	    }
	    if (foundOmissionBlock) {
	      return blocks.length >= 1;
	    }
	    return blocks.length === expectedNumberOfBlocks;
	  }
	  return false;
	}
	module.exports = exports['default'];

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isInt;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var int = /^(?:[-+]?(?:0|[1-9][0-9]*))$/;
	var intLeadingZeroes = /^[-+]?[0-9]+$/;
	
	function isInt(str, options) {
	  (0, _assertString2.default)(str);
	  options = options || {};
	
	  // Get the regex to use for testing, based on whether
	  // leading zeroes are allowed or not.
	  var regex = options.hasOwnProperty('allow_leading_zeroes') && !options.allow_leading_zeroes ? int : intLeadingZeroes;
	
	  // Check min/max/lt/gt
	  var minCheckPassed = !options.hasOwnProperty('min') || str >= options.min;
	  var maxCheckPassed = !options.hasOwnProperty('max') || str <= options.max;
	  var ltCheckPassed = !options.hasOwnProperty('lt') || str < options.lt;
	  var gtCheckPassed = !options.hasOwnProperty('gt') || str > options.gt;
	
	  return regex.test(str) && minCheckPassed && maxCheckPassed && ltCheckPassed && gtCheckPassed;
	}
	module.exports = exports['default'];

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ltrim;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ltrim(str, chars) {
	  (0, _assertString2.default)(str);
	  var pattern = chars ? new RegExp('^[' + chars + ']+', 'g') : /^\s+/g;
	  return str.replace(pattern, '');
	}
	module.exports = exports['default'];

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = rtrim;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rtrim(str, chars) {
	  (0, _assertString2.default)(str);
	  var pattern = chars ? new RegExp('[' + chars + ']') : /\s/;
	
	  var idx = str.length - 1;
	  while (idx >= 0 && pattern.test(str[idx])) {
	    idx--;
	  }
	
	  return idx < str.length ? str.substr(0, idx + 1) : str;
	}
	module.exports = exports['default'];

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toFloat;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toFloat(str) {
	  (0, _assertString2.default)(str);
	  return parseFloat(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About(_ref) {
	  var siteMetadata = _ref.siteMetadata;
	  return _react2.default.createElement(
	    'article',
	    null,
	    _react2.default.createElement(
	      'h2',
	      { className: 'md-text-center' },
	      'About'
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'md-text-center' },
	      siteMetadata.description
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'md-caption md-text-center' },
	      'We offer full cycle software development services, starting with a raw ideas analysis and resulting in end-to-end applications fully adjusted to business needs.'
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'md-caption md-text-center' },
	      'We build our development process on the Agile principles of transparency and collaboration with our clients. We strongly believe that our clients should have a heavy hand in the product development from the very outset to the fully-functioning piece of software.'
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'md-caption md-text-center' },
	      'We enhance our clients businesses by designing, developing, implementing and maintaining highly efficient and quality software solutions.'
	    )
	  );
	};
	
	About.propTypes = {
	  siteMetadata: _propTypes2.default.object
	};
	
	exports.default = About;
	module.exports = exports['default'];

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMd = __webpack_require__(295);
	
	var _validationUtils = __webpack_require__(348);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactForm = function (_Component) {
	  _inherits(ContactForm, _Component);
	
	  function ContactForm(props) {
	    _classCallCheck(this, ContactForm);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.getInitialFormState = function () {
	      return {
	        name: "",
	        email: "",
	        message: ""
	      };
	    };
	
	    _this.handleSubmit = function (e) {
	      var onSubmit = _this.props.onSubmit;
	      var form = _this.state.form;
	
	      var formErrors = (0, _validationUtils.validate)(form, _this.formConstraints);
	      _this.setState({ formErrors: formErrors });
	      if (!formErrors && onSubmit) {
	        onSubmit(form);
	      }
	      e.preventDefault();
	    };
	
	    _this.handleBlur = function (e) {
	      var _extends2;
	
	      var targetName = e.target.name;
	      var form = _this.state.form;
	
	      var formErrors = _this.state.formErrors || {};
	      var nextFormErrors = (0, _validationUtils.validate)(form, _this.formConstraints) || {};
	      _this.setState({ formErrors: _extends({}, formErrors, (_extends2 = {}, _extends2[targetName] = nextFormErrors[targetName], _extends2)) });
	    };
	
	    _this.reset = function () {
	      _this.setState({
	        form: _this.getInitialFormState(),
	        formErrors: null
	      });
	    };
	
	    _this.handleChange = function (value, e) {
	      var _extends3;
	
	      return _this.setState({ form: _extends({}, _this.state.form, (_extends3 = {}, _extends3[e.target.name] = value, _extends3)) });
	    };
	
	    _this.getNetlifyForm = function () {
	      return '\n    <form name="contact" netlify netlify-honeypot="bot-field" hidden>\n      <input type="text" name="name" />\n      <input type="email" name="email" />\n      <textarea name="message"></textarea>\n    </form>\n  ';
	    };
	
	    _this.state = {
	      form: _this.getInitialFormState()
	    };
	    _this.formConstraints = {
	      name: [_validationUtils.validationRules.required],
	      email: [_validationUtils.validationRules.required, _validationUtils.validationRules.email],
	      message: [_validationUtils.validationRules.required]
	    };
	    return _this;
	  }
	
	  ContactForm.prototype.render = function render() {
	    var form = this.state.form;
	
	    var formErrors = this.state.formErrors || {};
	    return _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(
	        'h2',
	        { className: 'md-text-center' },
	        'Contact'
	      ),
	      _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.getNetlifyForm() } }),
	      _react2.default.createElement(
	        'form',
	        { onSubmit: this.handleSubmit },
	        _react2.default.createElement(
	          _reactMd.Grid,
	          { className: 'grid-example' },
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 6, tabletSize: 4, phoneSize: 4 },
	            _react2.default.createElement(_reactMd.TextField, {
	              id: 'name',
	              name: 'name',
	              value: form.name,
	              label: 'Your Name',
	              onChange: this.handleChange,
	              onBlur: this.handleBlur,
	              error: !!formErrors.name,
	              errorText: formErrors.name
	            })
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 6, tabletSize: 4, phoneSize: 4 },
	            _react2.default.createElement(_reactMd.TextField, {
	              id: 'email',
	              name: 'email',
	              value: form.email,
	              label: 'Your Email',
	              onChange: this.handleChange,
	              onBlur: this.handleBlur,
	              error: !!formErrors.email,
	              errorText: formErrors.email
	            })
	          ),
	          _react2.default.createElement(
	            _reactMd.Cell,
	            { size: 12, tabletSize: 8, phoneSize: 4 },
	            _react2.default.createElement(_reactMd.TextField, {
	              id: 'message',
	              name: 'message',
	              value: form.message,
	              label: 'Message',
	              rows: 3,
	              onChange: this.handleChange,
	              onBlur: this.handleBlur,
	              error: !!formErrors.message,
	              errorText: formErrors.message
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'md-text-center' },
	          _react2.default.createElement(
	            _reactMd.Button,
	            { raised: true, secondary: true, type: 'submit', iconClassName: 'fa fa-envelope-o' },
	            'Send'
	          )
	        )
	      )
	    );
	  };
	
	  return ContactForm;
	}(_react.Component);
	
	;
	
	ContactForm.propTypes = {
	  onSubmit: _propTypes2.default.func
	};
	
	exports.default = ContactForm;
	module.exports = exports['default'];

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    'footer',
	    null,
	    _react2.default.createElement(
	      'span',
	      null,
	      'BOLDIT Ltd \u2022 Ko\u010De Racina 7 \u2022 40000 \u010Cakovec \u2022 Croatia'
	    ),
	    '\xA0|\xA0',
	    _react2.default.createElement(
	      'span',
	      null,
	      'Tel: +385 99 699 0856'
	    ),
	    '\xA0|\xA0',
	    _react2.default.createElement(
	      'span',
	      null,
	      'E-mail: info@boldit.hr'
	    ),
	    '\xA0|\xA0',
	    _react2.default.createElement(
	      'span',
	      null,
	      '\xA9 ',
	      new Date().getFullYear(),
	      ' BOLDIT Ltd'
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(230);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logo = __webpack_require__(749);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Logo = function Logo() {
	  return _react2.default.createElement('img', { src: _logo2.default, alt: 'Logo' });
	};
	
	exports.default = Logo;
	module.exports = exports['default'];

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSlick = __webpack_require__(716);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _gatsbyImage = __webpack_require__(448);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _firstViewDistrict = __webpack_require__(748);
	
	var _firstViewDistrict2 = _interopRequireDefault(_firstViewDistrict);
	
	var _firstBusConnect = __webpack_require__(747);
	
	var _firstBusConnect2 = _interopRequireDefault(_firstBusConnect);
	
	var _scanther = __webpack_require__(750);
	
	var _scanther2 = _interopRequireDefault(_scanther);
	
	var _smartHome = __webpack_require__(751);
	
	var _smartHome2 = _interopRequireDefault(_smartHome);
	
	var _referenceSliderModule = __webpack_require__(434);
	
	var _referenceSliderModule2 = _interopRequireDefault(_referenceSliderModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReferencesSlider = function ReferencesSlider(_ref) {
	  var images = _ref.images;
	
	  var settings = {
	    className: _referenceSliderModule2.default.slider,
	    dots: true,
	    infinite: true,
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    autoplay: true,
	    autoplaySpeed: 10000,
	    pauseOnHover: true,
	    lazyLoad: true
	  };
	
	  var titleClass = _referenceSliderModule2.default.sliderTitle + ' md-text-center';
	
	  return _react2.default.createElement(
	    'article',
	    { className: _referenceSliderModule2.default.container },
	    _react2.default.createElement(
	      'h2',
	      { className: 'md-text-center' },
	      'References'
	    ),
	    _react2.default.createElement(
	      _reactSlick2.default,
	      settings,
	      _react2.default.createElement(
	        'div',
	        { key: 'firstViewMobile' },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: images.firstViewParentImage.sizes, alt: 'FIRST VIEW TM PARENT' }),
	        _react2.default.createElement(
	          'h6',
	          { className: titleClass },
	          'FIRST VIEW',
	          _react2.default.createElement(
	            'sup',
	            null,
	            'TM'
	          ),
	          ' PARENT'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'md-caption md-text-center' },
	          'FirstView',
	          _react2.default.createElement(
	            'sup',
	            null,
	            'TM'
	          ),
	          ' Parent App is React Native mobile application for iOS and Android devices and it is also a React web application - resource for knowing the location of student\u2019s bus, estimated arrival times at student\u2019s stop and when student\u2019s bus arrives or departs their school.'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { key: 'firstViewDistrict' },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: images.firstViewDistrictImage.sizes, alt: 'FIRST VIEW TM DISTRICT' }),
	        _react2.default.createElement(
	          'h6',
	          { className: titleClass },
	          'FIRST VIEW',
	          _react2.default.createElement(
	            'sup',
	            null,
	            'TM'
	          ),
	          ' DISTRICT'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'md-caption md-text-center' },
	          'FirstView',
	          _react2.default.createElement(
	            'sup',
	            null,
	            'TM'
	          ),
	          ' District Dashboard centralizes critical transportation data for efficient decision making, performance improvement opportunities and increased customer service. Core features: Real Time Bus Tracking, Reporting Transparency, Custom Communications.'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { key: 'firstBusConnect' },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: images.firstBusConnectImage.sizes, alt: 'FIRST BUS CONNECT' }),
	        _react2.default.createElement(
	          'h6',
	          { className: titleClass },
	          'FIRST BUS CONNECT'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'md-caption md-text-center' },
	          ' Designed specifically for First Bus employees, First Bus Connect provides access to local information and updates, best practices, policies and company news. Employees stay connected with updates and notifications directly from their manager.'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { key: 'scanther' },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: images.scantherImage.sizes, alt: 'SCANTHER' }),
	        _react2.default.createElement(
	          'h6',
	          { className: titleClass },
	          'SCANTHER'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'md-caption md-text-center' },
	          'Scanther is a business software solution that creates and manages mobile sites and hybrid apps. System is built of several modules: customer frontend (real time app editing, push notifications, coupons), mobile site preview, native app generator, admin app.'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { key: 'smartHome' },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: images.smartHomeImage.sizes, alt: 'SMART HOME' }),
	        _react2.default.createElement(
	          'h6',
	          { className: titleClass },
	          'SMART HOME'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'md-caption md-text-center' },
	          'Web desktop, mobile application and hardware solution for automatic control and monitoring of systems for heating, cooling, solar hot water, watering, lighting and entrance control. Developed for the purpose of energy efficiency supervision of homes.'
	        )
	      )
	    )
	  );
	};
	
	ReferencesSlider.propTypes = {
	  images: _propTypes2.default.object
	};
	
	exports.default = ReferencesSlider;
	module.exports = exports['default'];

/***/ }),
/* 345 */,
/* 346 */,
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(230);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(163);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactMd = __webpack_require__(295);
	
	var _Logo = __webpack_require__(343);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _ContactForm = __webpack_require__(341);
	
	var _ContactForm2 = _interopRequireDefault(_ContactForm);
	
	var _ReferencesSlider = __webpack_require__(344);
	
	var _ReferencesSlider2 = _interopRequireDefault(_ReferencesSlider);
	
	var _About = __webpack_require__(340);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _Footer = __webpack_require__(342);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _indexModule = __webpack_require__(435);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_Component) {
	  _inherits(IndexPage, _Component);
	
	  function IndexPage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, IndexPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { toasts: [] }, _this.encode = function (data) {
	      return Object.keys(data).map(function (key) {
	        return encodeURIComponent(key) + "=" + encodeURIComponent(data[key]);
	      }).join("&");
	    }, _this.handleContactFormSubmit = function (data) {
	      fetch('/', {
	        method: 'POST',
	        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	        body: _this.encode(_extends({ 'form-name': 'contact' }, data))
	      }).then(function () {
	        _this.contactForm.reset();
	        _this.addToast('Thank you!');
	      }).catch(function (error) {
	        _this.addToast(error);
	      });
	    }, _this.addToast = function (text) {
	      _this.setState({ toasts: [].concat(_this.state.toasts, [{ text: text }]) });
	    }, _this.handleDismissToast = function () {
	      var _this$state$toasts = _this.state.toasts,
	          toasts = _this$state$toasts.slice(1);
	
	      _this.setState({ toasts: toasts });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  IndexPage.prototype.render = function render() {
	    var _this2 = this;
	
	    var data = this.props.data;
	    var toasts = this.state.toasts;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement('link', { rel: 'canonical', href: 'https://boldit.hr' })
	      ),
	      _react2.default.createElement(
	        'header',
	        { className: _indexModule2.default.header },
	        _react2.default.createElement(_Logo2.default, null),
	        _react2.default.createElement(
	          'h4',
	          { className: 'md-text-center' },
	          'We make outstanding web and mobile solutions'
	        )
	      ),
	      _react2.default.createElement(
	        'main',
	        { className: _indexModule2.default.main },
	        _react2.default.createElement(_ReferencesSlider2.default, { images: data }),
	        _react2.default.createElement(_About2.default, { siteMetadata: data.site.siteMetadata }),
	        _react2.default.createElement(_ContactForm2.default, { onSubmit: this.handleContactFormSubmit, ref: function ref(c) {
	            _this2.contactForm = c;
	          } })
	      ),
	      _react2.default.createElement(
	        'footer',
	        { className: _indexModule2.default.footer },
	        _react2.default.createElement(_Footer2.default, null)
	      ),
	      _react2.default.createElement(_reactMd.Snackbar, {
	        toasts: toasts,
	        onDismiss: this.handleDismissToast
	      })
	    );
	  };
	
	  return IndexPage;
	}(_react.Component);
	
	;
	
	IndexPage.propTypes = {
	  data: _propTypes2.default.object
	};
	
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.validationRules = exports.validate = undefined;
	
	var _lodash = __webpack_require__(472);
	
	var _validator = __webpack_require__(752);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fieldValidate = function fieldValidate(form, value, fieldConstrains) {
	  if ((0, _lodash.isFunction)(fieldConstrains)) {
	    var result = fieldConstrains(value, form);
	    if ((0, _lodash.isFunction)(result) || (0, _lodash.isArray)(result)) {
	      return fieldValidate(form, value, result);
	    }
	    return result;
	  } else if ((0, _lodash.isArray)(fieldConstrains)) {
	    var fieldErrors = [];
	    (0, _lodash.forEach)(fieldConstrains, function (fieldConstrain) {
	      var error = fieldConstrain(value, form);
	      if (error) {
	        fieldErrors.push(error);
	      }
	    });
	    if (!(0, _lodash.isEmpty)(fieldErrors)) {
	      return (0, _lodash.head)(fieldErrors);
	    }
	  }
	  return null;
	};
	
	var validate = exports.validate = function validate() {
	  var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var constrains = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var errors = {};
	  (0, _lodash.forIn)(form, function (value, key) {
	    var fieldConstrains = constrains[key];
	    var error = fieldValidate(form, value, fieldConstrains);
	    if (error) {
	      errors[key] = error;
	    }
	  });
	  return (0, _lodash.isEmpty)(errors) ? null : errors;
	};
	
	var validationRules = exports.validationRules = {
	  required: function required(value) {
	    if (!value) {
	      return 'Can\'t be blank.';
	    }
	    return null;
	  },
	  email: function email(value) {
	    if (value && !_validator2.default.isEmail(value.trim())) {
	      return 'Not a valid email.';
	    }
	    return null;
	  }
	};

/***/ }),
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */
/***/ (function(module, exports) {

	var canUseDOM = !!(
	  typeof window !== 'undefined' &&
	  window.document &&
	  window.document.createElement
	);
	
	module.exports = canUseDOM;

/***/ }),
/* 360 */
/***/ (function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ }),
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(220);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(432);
	var each = __webpack_require__(226).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(430);
	var Util = __webpack_require__(226);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ }),
/* 432 */
/***/ (function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(431);
	module.exports = new MediaQueryDispatch();


/***/ }),
/* 434 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components----referenceSlider-module---container---G9nw2","slider":"src-components----referenceSlider-module---slider---18VBG","sliderTitle":"src-components----referenceSlider-module---sliderTitle---1eSyj"};

/***/ }),
/* 435 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"src-pages----index-module---header---2Pp1r","main":"src-pages----index-module---main---2LmOO","footer":"src-pages----index-module---footer---1xH5N"};

/***/ }),
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(51);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(50);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(122);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(121);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  var _props$opacity = props.opacity,
	      opacity = _props$opacity === undefined ? "" : _props$opacity,
	      src = props.src,
	      srcSet = props.srcSet,
	      _props$sizes = props.sizes,
	      sizes = _props$sizes === undefined ? "" : _props$sizes,
	      _props$title = props.title,
	      title = _props$title === undefined ? "" : _props$title,
	      _props$alt = props.alt,
	      alt = _props$alt === undefined ? "" : _props$alt,
	      _props$width = props.width,
	      width = _props$width === undefined ? "" : _props$width,
	      _props$height = props.height,
	      height = _props$height === undefined ? "" : _props$height,
	      _props$transitionDela = props.transitionDelay,
	      transitionDelay = _props$transitionDela === undefined ? "" : _props$transitionDela;
	
	  return "<img width=" + width + " height=" + height + " src=\"" + src + "\" srcset=\"" + srcSet + "\" alt=\"" + alt + "\" title=\"" + title + "\" sizes=\"" + sizes + "\" style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;objectPosition:center\"/>";
	};
	
	var Img = function Img(props) {
	  var opacity = props.opacity,
	      onLoad = props.onLoad,
	      _props$transitionDela2 = props.transitionDelay,
	      transitionDelay = _props$transitionDela2 === undefined ? "" : _props$transitionDela2,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["opacity", "onLoad", "transitionDelay"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: {
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      transitionDelay: transitionDelay,
	      opacity: opacity,
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }
	  }));
	};
	
	Img.propTypes = {
	  opacity: _propTypes2.default.number,
	  transitionDelay: _propTypes2.default.string,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        "div",
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            zIndex: 0,
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden",
	              zIndex: 1
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement("div", {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          bgColor && _react2.default.createElement("div", {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        zIndex: 1,
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        "div",
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            zIndex: 0,
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.35s"
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          bgColor && _react2.default.createElement("div", {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: ""
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func
	};
	
	exports.default = Image;

/***/ }),
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(746);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.4';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
	      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `map.set` because it's not chainable in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    // Don't return `set.add` because it's not chainable in IE 11.
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (reLeadingDot.test(string)) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(args) {
	      args.push(undefined, customDefaultsAssignIn);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(808)(module)))

/***/ }),
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _CSSTransitionGroup = __webpack_require__(49);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _omit = __webpack_require__(116);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _findIgnoreCase = __webpack_require__(687);
	
	var _findIgnoreCase2 = _interopRequireDefault(_findIgnoreCase);
	
	var _fuzzyFilter = __webpack_require__(688);
	
	var _fuzzyFilter2 = _interopRequireDefault(_fuzzyFilter);
	
	var _caseInsensitiveFilter = __webpack_require__(685);
	
	var _caseInsensitiveFilter2 = _interopRequireDefault(_caseInsensitiveFilter);
	
	var _getTextWidth = __webpack_require__(178);
	
	var _getTextWidth2 = _interopRequireDefault(_getTextWidth);
	
	var _oneRequiredForA11y = __webpack_require__(113);
	
	var _oneRequiredForA11y2 = _interopRequireDefault(_oneRequiredForA11y);
	
	var _controlled = __webpack_require__(16);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _invalidIf = __webpack_require__(48);
	
	var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	var _keyCodes = __webpack_require__(15);
	
	var _anchorShape = __webpack_require__(38);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(22);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(39);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _ListItem = __webpack_require__(110);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Menu = __webpack_require__(63);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _TextField = __webpack_require__(65);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Autocomplete` component is useful for presenting real-time suggestions, completions,
	 * or filtering.
	 */
	var Autocomplete = function (_PureComponent) {
	  _inherits(Autocomplete, _PureComponent);
	
	  function Autocomplete(props) {
	    _classCallCheck(this, Autocomplete);
	
	    var _this = _possibleConstructorReturn(this, (Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var defaultValue = props.defaultValue,
	        data = props.data,
	        dataLabel = props.dataLabel,
	        filter = props.filter;
	
	
	    var matches = [];
	    if (defaultValue && filter) {
	      matches = filter(data, defaultValue, dataLabel);
	    } else if (!filter) {
	      matches = data;
	    }
	
	    _this.state = {
	      value: defaultValue,
	      matches: matches,
	      visible: false,
	      matchIndex: -1,
	      manualFocus: false,
	      suggestion: '',
	      suggestionIndex: -1
	    };
	    return _this;
	  }
	
	  _createClass(Autocomplete, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var nextValue = nextProps.value,
	          data = nextProps.data,
	          filter = nextProps.filter,
	          dataLabel = nextProps.dataLabel;
	
	      var dataDiff = data !== this.props.data;
	      if (nextValue !== this.props.value || dataDiff) {
	        var _state = this.state,
	            visible = _state.visible,
	            matches = _state.matches;
	
	        var value = (0, _getField2.default)(nextProps, this.state, 'value');
	
	        if (filter) {
	          matches = filter(data, value, dataLabel);
	        } else if (dataDiff) {
	          matches = data;
	        }
	
	        if (this.state.focus) {
	          visible = !!matches.length;
	        }
	
	        this.setState({ matches: matches, visible: visible });
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (this.state.visible !== nextState.visible) {
	        var menuFn = nextProps['onMenu' + (nextState.visible ? 'Open' : 'Close')];
	        if (menuFn) {
	          menuFn();
	        }
	      }
	    }
	
	    /**
	     * Gets the current value from the text field. This is used when you have an uncontrolled
	     * text field and simply need the value from a ref callback.
	     *
	     * @return {String} the text field's value
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          visible = _state2.visible,
	          matches = _state2.matches,
	          tabbed = _state2.tabbed,
	          focus = _state2.focus,
	          suggestionStyle = _state2.suggestionStyle;
	
	      var _props = this.props,
	          fullWidth = _props.fullWidth,
	          block = _props.block,
	          style = _props.style,
	          className = _props.className,
	          listStyle = _props.listStyle,
	          listClassName = _props.listClassName,
	          textFieldStyle = _props.textFieldStyle,
	          textFieldClassName = _props.textFieldClassName,
	          inlineSuggestionStyle = _props.inlineSuggestionStyle,
	          inlineSuggestionClassName = _props.inlineSuggestionClassName,
	          menuId = _props.menuId,
	          inline = _props.inline,
	          anchor = _props.anchor,
	          belowAnchor = _props.belowAnchor,
	          position = _props.position,
	          fixedTo = _props.fixedTo,
	          listId = _props.listId,
	          listInline = _props.listInline,
	          listZDepth = _props.listZDepth,
	          listHeightRestricted = _props.listHeightRestricted,
	          xThreshold = _props.xThreshold,
	          yThreshold = _props.yThreshold,
	          closeOnOutsideClick = _props.closeOnOutsideClick,
	          transitionName = _props.transitionName,
	          transitionEnterTimeout = _props.transitionEnterTimeout,
	          transitionLeaveTimeout = _props.transitionLeaveTimeout,
	          centered = _props.centered,
	          sameWidth = _props.sameWidth,
	          repositionOnScroll = _props.repositionOnScroll,
	          repositionOnResize = _props.repositionOnResize,
	          simplifiedMenu = _props.simplifiedMenu,
	          minLeft = _props.minLeft,
	          minRight = _props.minRight,
	          minBottom = _props.minBottom,
	          fillViewportWidth = _props.fillViewportWidth,
	          fillViewportHeight = _props.fillViewportHeight,
	          propValue = _props.value,
	          total = _props.total,
	          offset = _props.offset,
	          filter = _props.filter,
	          data = _props.data,
	          dataLabel = _props.dataLabel,
	          dataValue = _props.dataValue,
	          deleteKeys = _props.deleteKeys,
	          defaultValue = _props.defaultValue,
	          clearOnAutocomplete = _props.clearOnAutocomplete,
	          autocompleteWithLabel = _props.autocompleteWithLabel,
	          findInlineSuggestion = _props.findInlineSuggestion,
	          inlineSuggestionPadding = _props.inlineSuggestionPadding,
	          onAutocomplete = _props.onAutocomplete,
	          onMenuOpen = _props.onMenuOpen,
	          onMenuClose = _props.onMenuClose,
	          onBlur = _props.onBlur,
	          onFocus = _props.onFocus,
	          onKeyDown = _props.onKeyDown,
	          onMouseDown = _props.onMouseDown,
	          onChange = _props.onChange,
	          props = _objectWithoutProperties(_props, ['fullWidth', 'block', 'style', 'className', 'listStyle', 'listClassName', 'textFieldStyle', 'textFieldClassName', 'inlineSuggestionStyle', 'inlineSuggestionClassName', 'menuId', 'inline', 'anchor', 'belowAnchor', 'position', 'fixedTo', 'listId', 'listInline', 'listZDepth', 'listHeightRestricted', 'xThreshold', 'yThreshold', 'closeOnOutsideClick', 'transitionName', 'transitionEnterTimeout', 'transitionLeaveTimeout', 'centered', 'sameWidth', 'repositionOnScroll', 'repositionOnResize', 'simplifiedMenu', 'minLeft', 'minRight', 'minBottom', 'fillViewportWidth', 'fillViewportHeight', 'value', 'total', 'offset', 'filter', 'data', 'dataLabel', 'dataValue', 'deleteKeys', 'defaultValue', 'clearOnAutocomplete', 'autocompleteWithLabel', 'findInlineSuggestion', 'inlineSuggestionPadding', 'onAutocomplete', 'onMenuOpen', 'onMenuClose', 'onBlur', 'onFocus', 'onKeyDown', 'onMouseDown', 'onChange']);
	
	      delete props.focusInputOnAutocomplete;
	
	      var value = (0, _getField2.default)(this.props, this.state, 'value');
	
	      var autocomplete = _react2.default.createElement(_TextField2.default, _extends({}, props, {
	        'aria-autocomplete': inline ? 'inline' : 'list',
	        style: textFieldStyle,
	        className: (0, _classnames2.default)('md-autocomplete', textFieldClassName),
	        key: 'autocomplete',
	        ref: this._setField,
	        value: value,
	        onKeyDown: this._handleTextFieldKeyDown,
	        onMouseDown: this._toggleMenu,
	        onChange: this._handleChange,
	        onFocus: this._handleFocus,
	        onBlur: this._handleBlur,
	        fullWidth: fullWidth,
	        block: block
	      }));
	
	      if (inline) {
	        var suggestion = void 0;
	        if (focus && this.state.suggestion) {
	          suggestion = _react2.default.createElement(
	            'span',
	            {
	              key: 'suggestion',
	              style: _extends({}, suggestionStyle, inlineSuggestionStyle),
	              className: (0, _classnames2.default)('md-autocomplete-suggestion', {
	                'md-autocomplete-suggestion--floating': props.label,
	                'md-autocomplete-suggestion--block': block
	              }, inlineSuggestionClassName)
	            },
	            this.state.suggestion
	          );
	        }
	
	        return _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            style: style,
	            className: (0, _classnames2.default)('md-menu-container md-autocomplete-container', className, {
	              'md-full-width': fullWidth || block
	            }),
	            transitionName: 'opacity',
	            transitionEnterTimeout: 150,
	            transitionLeave: !tabbed,
	            transitionLeaveTimeout: 150,
	            onTouchStart: this._handleTouchStart
	          },
	          autocomplete,
	          suggestion
	        );
	      }
	
	      return _react2.default.createElement(
	        _Menu2.default,
	        {
	          id: menuId || props.id + '-menu',
	          listId: listId,
	          ref: this._setMenu,
	          toggle: autocomplete,
	          visible: visible,
	          onClick: this._handleClick,
	          onClose: this._close,
	          onKeyDown: this._handleMenuKeyDown,
	          simplified: simplifiedMenu,
	          sameWidth: sameWidth,
	          centered: centered,
	          anchor: anchor,
	          belowAnchor: belowAnchor,
	          position: position,
	          fixedTo: fixedTo,
	          listInline: listInline,
	          listZDepth: listZDepth,
	          listHeightRestricted: listHeightRestricted,
	          xThreshold: xThreshold,
	          yThreshold: yThreshold,
	          closeOnOutsideClick: closeOnOutsideClick,
	          transitionName: transitionName,
	          transitionEnterTimeout: transitionEnterTimeout,
	          transitionLeaveTimeout: transitionLeaveTimeout,
	          fullWidth: fullWidth || block,
	          style: style,
	          className: (0, _classnames2.default)('md-autocomplete-container', className),
	          listStyle: listStyle,
	          listClassName: (0, _classnames2.default)('md-autocomplete-list', listClassName),
	          repositionOnScroll: repositionOnScroll,
	          repositionOnResize: repositionOnResize,
	          minLeft: minLeft,
	          minRight: minRight,
	          minBottom: minBottom,
	          fillViewportWidth: fillViewportWidth,
	          fillViewportHeight: fillViewportHeight
	        },
	        matches.map(this._mapToListItem)
	      );
	    }
	  }, {
	    key: 'value',
	    get: function get() {
	      return (0, _getField2.default)(this.props, this.state, 'value');
	    }
	
	    /**
	     * Just check if the click target is in a list item.. if it is, autocomplete the text field
	     * with that item.
	     */
	
	
	    /**
	     * The `mousedown` event is used instead of `click` because of the order
	     * of the `mousedown`, `focus`, and `click` events.
	     */
	
	
	    /**
	     * Allows touch devices to autocomplete the inline view by tapping:
	     * - the suggestion text
	     * - the text field IF there is a suggestion visible
	     */
	
	  }]);
	
	  return Autocomplete;
	}(_react.PureComponent);
	
	Autocomplete.HorizontalAnchors = _Menu2.default.HorizontalAnchors;
	Autocomplete.VerticalAnchors = _Menu2.default.VerticalAnchors;
	Autocomplete.Positions = _Menu2.default.Positions;
	Autocomplete.fuzzyFilter = _fuzzyFilter2.default;
	Autocomplete.caseInsensitiveFilter = _caseInsensitiveFilter2.default;
	Autocomplete.findIgnoreCase = _findIgnoreCase2.default;
	Autocomplete.propTypes = {
	  /**
	   * An id to give the autocomplete. Either this or the `menuId` is required for accessibility.
	   *
	   * @see {@link #menuId}
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * The menu id to provide to the autocomplete. Either this prop or the `id` prop is required. If
	   * this props is omitted, the menuId will become: `${id}-menu`
	   */
	  menuId: (0, _oneRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]), 'id'),
	
	  /**
	   * An optional id to provide to the menu's list.
	   *
	   * @see {@link Menus/Menu#listId}
	   */
	  listId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the menu that contains the autocomplete.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the menu that contains the autocomplete.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the autocomplete's text field.
	   */
	  textFieldStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the autocomplete's text field.
	   */
	  textFieldClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the autocomplete's text field input itself.
	   */
	  inputStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the autocomplete's input field itself.
	   */
	  inputClassName: _propTypes2.default.string,
	
	  /**
	   * The optional style to apply to the opened menu List if the
	   * `Autocomplete` is not using `inline` suggestions.
	   */
	  listStyle: _propTypes2.default.object,
	
	  /**
	   * The optional className to apply to the opened menu List if the
	   * `Autocomplete` is not using `inline` suggestions.
	   */
	  listClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the inline suggestion when using `inline` mode.
	   */
	  inlineSuggestionStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the inline suggestion when using `inline` mode.
	   */
	  inlineSuggestionClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the autocomplete is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * A label to display with the autocomplete.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * An optional value to use for the text field. This will force this component
	   * to be controlled and require the `onChange` function.
	   */
	  value: (0, _controlled2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]), 'onChange'),
	
	  /**
	   * The default value for the autocomplete's text field.
	   */
	  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  /**
	   * An object key to use to extract the text to be compared for filtering.
	   * This will only be applied if the given `data` prop is an array of objects.
	   */
	  dataLabel: _propTypes2.default.string.isRequired,
	
	  /**
	   * An optional object key to use to extract the `value` of the given `data` prop.
	   * This is really only used with generating a unique react key. The unique react
	   * key with either be:
	   * - the datum if it is a string or number
	   * - the `key` attribute of the datum object
	   * - the `datum[dataValue]`
	   * - or the `datum[dataLabel]`
	   */
	  dataValue: _propTypes2.default.string,
	
	  /**
	   * A single key or an array of keys to delete from your data object before passing
	   * to the `ListItem` component.
	   */
	  deleteKeys: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
	
	  /**
	   * The data that will be used for autocomplete suggestions. This can either be
	   * an array of string, number, or object. If it is an array of objects, the key
	   * `dataLabel` is required.
	   *
	   * ```docgen
	   * PropTypes.arrayOf(PropTypes.oneOfType([
	   *   PropTypes.element,
	   *   PropTypes.string,
	   *   PropTypes.number,
	   *   PropTypes.shape({
	   *     [dataLabel]: PropTypes.oneOfType([
	   *       PropTypes.string,
	   *       PropTypes.number,
	   *       PropTypes.node,
	   *     ]).isRequired,
	   *   }),
	   * ])).isRequired
	   * ```
	   */
	  data: function data(props, propName, component) {
	    for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      others[_key - 3] = arguments[_key];
	    }
	
	    var _PropTypes$arrayOf;
	
	    var dataLabel = props.dataLabel;
	
	    return (_PropTypes$arrayOf = _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.shape(_defineProperty({}, dataLabel, _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.node]).isRequired))]))).isRequired.apply(_PropTypes$arrayOf, [props, propName, component].concat(others));
	  },
	
	  /**
	   * An optional number representing the total number of results in the `data` prop.
	   * This should really only be used when the data is paginated. When this is set,
	   * each item in the suggestion menu will be updated with the `aria-setsize` and
	   * `aria-posinset`.
	   *
	   * @see {@link #offset}
	   */
	  total: (0, _invalidIf2.default)(_propTypes2.default.number, 'inline'),
	
	  /**
	   * An optional number representing the data's offset if the results were paginated.
	   * This is used for accessibility with the `aria-posinset` attribute.
	   *
	   * @see {@link #total}
	   */
	  offset: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional function to use to filter the `data`. If you have a sexy backend
	   * using solr or some other search/indexer, it is recommended to set this prop to
	   * `null`.
	   */
	  filter: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `Autocomplete`'s text field has a `keydown` event.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `Autocomplete`'s text field has a `mousedown` event.
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `Autocomplete`'s text field value changes.
	   * The callback will be given the new value and the change event.
	   *
	   * `onChange(textFeldValue, event)`
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `Autocomplete`'s text field is focused.
	   */
	  onFocus: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the entire `Autocomplete` component is blurred.
	   * This will be triggered when the window is clicked or when a user tabs away from
	   * the autocomplete.
	   */
	  onBlur: _propTypes2.default.func,
	
	  /**
	   * Boolean if this text field should be styled as a full width text field.
	   * Floating labels and the text field indicator will be removed automatically.
	   */
	  block: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the autocomplete should span the entire width.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `Autocomplete` should display suggestions inline instead
	   * of in a `Menu`.
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * The amount of padding to use between the current text and the inline suggestion text.
	   */
	  inlineSuggestionPadding: _propTypes2.default.number.isRequired,
	
	  /**
	   * The function to call to find a suggestion for an inline autocomplete. This function
	   * expects to return a single result of a number or a string.
	   *
	   * ```js
	   * @param {Array<Object|String|Number>} data - The data prop to search.
	   * @param {String} value - The current value to use for searching.
	   * @param {String} dataLabel - The `dataLabel` prop to use if a datum is an object.
	   * @return {String|Number} the found suggestion or false-ish
	   * ```
	   */
	  findInlineSuggestion: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when an autocomplete suggestion is clicked either
	   * by using the mouse, the enter/space key, or touch. The match index and current
	   * `dataLabel` will be given back.
	   *
	   * `onAutocomplete(suggestion, suggestionIndex, matches);`
	   *
	   * @see {@link #autocompleteWithLabel}
	   */
	  onAutocomplete: _propTypes2.default.func,
	
	  /**
	   * Boolean if the `onAutocomplete` should attempt send the `suggestion[dataLabel]` instead
	   * of `suggestion[dataValue]` when the data is an object.
	   *
	   * @see {@link #onAutocomplete}
	   */
	  autocompleteWithLabel: _propTypes2.default.bool,
	
	  /**
	   * A boolean if the text field's value should be reset to the empty string when
	   * an item is auto-completed. This is useful if you do not want a fully controlled
	   * component and the values are stored outside of the `TextField`. (like `Chips`).
	   */
	  clearOnAutocomplete: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when the `Autocomplete` suggestion menu opens.
	   */
	  onMenuOpen: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `Autocomplete` suggestion menu closes.
	   */
	  onMenuClose: _propTypes2.default.func,
	
	  /**
	   * This prop is used for disabling the browser's default autocomplete suggestions
	   * of previously typed values in the text field. By default, this is disabled.
	   */
	  autoComplete: _propTypes2.default.oneOf(['on', 'off']),
	
	  /**
	   * Boolean if the `input` should be focused again after a suggestion was clicked.
	   *
	   * This is really only added for keyboard support and the fact that each of suggestions
	   * are focusable.
	   */
	  focusInputOnAutocomplete: _propTypes2.default.bool,
	
	  /**
	   * This is how the menu's `List` gets anchored to the `toggle` element.
	   *
	   * @see {@link Helpers/Layover#anchor}
	   */
	  anchor: _anchorShape2.default,
	
	  /**
	   * This is the anchor to use when the `position` is set to `Autocomplete.Positions.BELOW`.
	   *
	   * @see {@link Helpers/Layover#belowAnchor}
	   */
	  belowAnchor: _anchorShape2.default,
	
	  /**
	   * This is the animation position for the list that appears.
	   *
	   * @see {@link Helpers/Layover#animationPosition}
	   */
	  position: _positionShape2.default,
	
	  /**
	   * This is how the menu's list will be "fixed" to the `toggle` component.
	   *
	   * @see {@link Helpers/Layover#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * Boolean if the menu's list should appear horizontally instead of vertically.
	   */
	  listInline: _propTypes2.default.bool,
	
	  /**
	   * The list's z-depth for applying box shadow. This should be a number from 0 to 5.
	   */
	  listZDepth: _propTypes2.default.number,
	
	  /**
	   * Boolean if the list should have its height restricted to the `$md-menu-mobile-max-height`/
	   * `$md-menu-desktop-max-height` values.
	   *
	   * @see [md-menu-mobile-max-height](/components/menus?tab=2#variable-md-menu-mobile-max-height)
	   * @see [md-menu-desktop-max-height](/components/menus?tab=2#variable-md-menu-desktop-max-height)
	   */
	  listHeightRestricted: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#xThreshold}
	   */
	  xThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#yThreshold}
	   */
	  yThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#closeOnOutsideClick}
	   */
	  closeOnOutsideClick: _propTypes2.default.bool,
	
	  /**
	   * An optional transition name to use for the list appearing/disappearing.
	   *
	   * @see {@link Helpers/Layover#transitionName}
	   */
	  transitionName: _propTypes2.default.string,
	
	  /**
	   * @see {@link Helpers/Layover#transitionEnterTimeout}
	   */
	  transitionEnterTimeout: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#transitionLeaveTimeout}
	   */
	  transitionLeaveTimeout: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#centered}
	   */
	  centered: _Menu2.default.propTypes.centered,
	
	  /**
	   * @see {@link Helpers/Layover#sameWidth}
	   */
	  sameWidth: _Menu2.default.propTypes.sameWidth,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu logic should be simplified without any viewport logic and position
	   * based on the relative position of the menu. This will most like require some additional
	   * styles applied to the menu.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedMenu: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#minLeft}
	   */
	  minLeft: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#minRight}
	   */
	  minRight: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#minBottom}
	   */
	  minBottom: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportWidth}
	   */
	  fillViewportWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportHeight}
	   */
	  fillViewportHeight: _propTypes2.default.bool,
	
	  /**
	   * @see {@link TextFields#toolbar}
	   */
	  toolbar: _propTypes2.default.bool
	};
	Autocomplete.defaultProps = {
	  autocompleteWithLabel: false,
	  position: _Menu2.default.Positions.BELOW,
	  sameWidth: true,
	  offset: 0,
	  fullWidth: true,
	  defaultValue: '',
	  dataLabel: 'primaryText',
	  filter: Autocomplete.fuzzyFilter,
	  findInlineSuggestion: Autocomplete.findIgnoreCase,
	  autoComplete: 'off',
	  repositionOnScroll: true,
	  repositionOnResize: true,
	  inlineSuggestionPadding: 6
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._close = function (e) {
	    if (_this2.props.onBlur) {
	      _this2.props.onBlur(e);
	    }
	
	    _this2.setState({ visible: false });
	  };
	
	  this._handleChange = function (value, event) {
	    var _props2 = _this2.props,
	        onChange = _props2.onChange,
	        filter = _props2.filter,
	        findInlineSuggestion = _props2.findInlineSuggestion,
	        data = _props2.data,
	        dataLabel = _props2.dataLabel,
	        inline = _props2.inline;
	
	
	    if (onChange) {
	      onChange(value, event);
	    }
	
	    if (inline) {
	      // If findInlineSuggestion does not exist, assume that `onChange` will handle it.
	      return findInlineSuggestion ? _this2._findInlineSuggestions(value) : null;
	    }
	
	    var visible = _this2.state.visible;
	
	    var matches = value || !filter ? _this2.state.matches : [];
	    if (value && filter) {
	      matches = filter(data, value, dataLabel);
	    }
	
	    if (filter) {
	      visible = !!matches.length;
	    }
	
	    return _this2.setState({ matches: matches, visible: visible, value: value });
	  };
	
	  this._handleFocus = function (e) {
	    if (_this2.props.onFocus) {
	      _this2.props.onFocus(e);
	    }
	
	    var value = e.target.value;
	
	    if (_this2.props.inline && value) {
	      if (_this2.props.findInlineSuggestion) {
	        _this2._findInlineSuggestions(value);
	      }
	
	      return;
	    }
	
	    _this2.setState({
	      matchIndex: -1,
	      visible: !_this2.state.manualFocus && !!value && !!_this2.state.matches.length,
	      manualFocus: false,
	      focus: true
	    });
	  };
	
	  this._handleBlur = function (e) {
	    if (_this2.props.inline || !_this2.state.matches.length) {
	      if (_this2.props.onBlur) {
	        _this2.props.onBlur(e);
	      }
	    }
	
	    _this2.setState({ focus: false });
	  };
	
	  this._handleInlineAutocomplete = function () {
	    var _state3 = _this2.state,
	        suggestionIndex = _state3.suggestionIndex,
	        matches = _state3.matches;
	
	    if (suggestionIndex === -1) {
	      return;
	    }
	
	    var _props3 = _this2.props,
	        data = _props3.data,
	        dataLabel = _props3.dataLabel,
	        dataValue = _props3.dataValue,
	        label = _props3.autocompleteWithLabel,
	        onAutocomplete = _props3.onAutocomplete;
	
	
	    var value = data[suggestionIndex];
	    if (onAutocomplete) {
	      var v = value;
	      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	        if (!label) {
	          v = value[dataValue];
	        } else {
	          v = value[dataLabel];
	        }
	      }
	
	      onAutocomplete(v, suggestionIndex, matches);
	    }
	
	    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	      value = value[dataLabel];
	    }
	
	    _this2.setState({
	      value: value,
	      suggestion: '',
	      suggestionIndex: -1,
	      tabbed: true
	    });
	  };
	
	  this._handleTextFieldKeyDown = function (e) {
	    var _props4 = _this2.props,
	        inline = _props4.inline,
	        onKeyDown = _props4.onKeyDown;
	    var suggestionIndex = _this2.state.suggestionIndex;
	
	
	    var key = e.which || e.keyCode;
	    if (onKeyDown) {
	      onKeyDown(e);
	    }
	
	    if (inline && key === _keyCodes.TAB && suggestionIndex !== -1) {
	      // Autocomplete the text field
	      e.preventDefault();
	      _this2._handleInlineAutocomplete();
	    }
	  };
	
	  this._handleMenuKeyDown = function (e) {
	    var key = e.which || e.keyCode;
	    if (key === _keyCodes.TAB) {
	      if (_this2.props.onBlur) {
	        _this2.props.onBlur(e);
	      }
	
	      _this2.setState({ visible: false });
	    } else if (key === _keyCodes.UP || key === _keyCodes.DOWN) {
	      _this2._focusSuggestion(key === _keyCodes.UP, e);
	    }
	  };
	
	  this._handleClick = function (e) {
	    var target = e.target;
	    while (_this2._menu && _this2._menu.contains(target)) {
	      if (target.classList.contains('md-list-item')) {
	        var items = target.parentNode.querySelectorAll('.md-list-item');
	        items = Array.prototype.slice.call(items);
	
	        return _this2._handleItemClick(items.indexOf(target));
	      }
	
	      target = target.parentNode;
	    }
	
	    return null;
	  };
	
	  this._handleItemClick = function (index) {
	    if (index === -1) {
	      return;
	    }
	
	    var matches = _this2.state.matches;
	    var _props5 = _this2.props,
	        data = _props5.data,
	        dataLabel = _props5.dataLabel,
	        dataValue = _props5.dataValue,
	        filter = _props5.filter,
	        onAutocomplete = _props5.onAutocomplete,
	        clearOnAutocomplete = _props5.clearOnAutocomplete,
	        focusInputOnAutocomplete = _props5.focusInputOnAutocomplete,
	        label = _props5.autocompleteWithLabel;
	
	
	    var value = matches.filter(function (m) {
	      return !_react2.default.isValidElement(m);
	    })[index];
	    if (onAutocomplete) {
	      var v = value;
	      if ((typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object') {
	        if (!label) {
	          v = value[dataValue];
	        } else {
	          v = value[dataLabel];
	        }
	      }
	
	      onAutocomplete(v, index, matches);
	    }
	
	    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	      value = value[dataLabel];
	    }
	
	    value = clearOnAutocomplete ? '' : value;
	    var callback = void 0;
	    if (focusInputOnAutocomplete) {
	      callback = function callback() {
	        _this2._field.focus();
	      };
	    }
	
	    _this2.setState({
	      visible: false,
	      manualFocus: focusInputOnAutocomplete,
	      matches: filter ? filter(data, value, dataLabel) : matches,
	      value: value
	    }, callback);
	  };
	
	  this._focusSuggestion = function (negative, e) {
	    e.preventDefault();
	    var _state4 = _this2.state,
	        matchIndex = _state4.matchIndex,
	        matches = _state4.matches;
	
	    var l = matches.length;
	
	    var index = void 0;
	    if (negative && matchIndex === -1 || !negative && matchIndex >= l) {
	      return;
	    } else if (negative) {
	      index = matchIndex - 1;
	      if (index === -1) {
	        _this2._field.focus();
	      }
	    } else {
	      index = Math.min(l, matchIndex + 1);
	    }
	
	    if (index !== -1 && index !== matchIndex) {
	      var item = _this2._menu.querySelectorAll('.md-list-tile')[index];
	      if (item) {
	        item.focus();
	      }
	    }
	
	    _this2.setState({ matchIndex: index });
	  };
	
	  this._findInlineSuggestions = function (value) {
	    var _props6 = _this2.props,
	        data = _props6.data,
	        dataLabel = _props6.dataLabel,
	        findInlineSuggestion = _props6.findInlineSuggestion,
	        inlineSuggestionPadding = _props6.inlineSuggestionPadding;
	
	
	    var suggestion = findInlineSuggestion(data, value, dataLabel);
	    if ((typeof suggestion === 'undefined' ? 'undefined' : _typeof(suggestion)) === 'object') {
	      throw new Error('`findInlineSuggestion` should return a string or a number, but got an object.', suggestion);
	    }
	
	    var suggestionStyle = _this2.state.suggestionStyle;
	
	    var suggestionIndex = -1;
	    if (suggestion) {
	      // Find index of suggestion
	      data.some(function (datum, i) {
	        var d = (typeof dataum === 'undefined' ? 'undefined' : _typeof(dataum)) === 'object' ? datum[dataLabel] : datum;
	        if (d === suggestion) {
	          suggestionIndex = i;
	        }
	
	        return suggestionIndex !== -1;
	      });
	
	      // Strip already used letters
	      suggestion = suggestion.toString().substring(value.length, suggestion.length);
	
	      // Position the inline suggestion next to the text
	      var width = (0, _getTextWidth2.default)(value, _this2._field);
	      if (width !== null) {
	        width += inlineSuggestionPadding;
	      }
	
	      if (width !== null && (!suggestionStyle || suggestionStyle.left !== width)) {
	        suggestionStyle = { left: width };
	      }
	    }
	
	    _this2.setState({
	      value: value,
	      suggestion: suggestion,
	      suggestionIndex: suggestionIndex,
	      suggestionStyle: suggestionStyle,
	      tabbed: false,
	      focus: true
	    });
	  };
	
	  this._mapToListItem = function (match, i) {
	    if (_react2.default.isValidElement(match)) {
	      return match;
	    }
	
	    var _props7 = _this2.props,
	        dataLabel = _props7.dataLabel,
	        dataValue = _props7.dataValue,
	        deleteKeys = _props7.deleteKeys,
	        total = _props7.total,
	        offset = _props7.offset,
	        data = _props7.data;
	
	    var props = void 0;
	    switch (typeof match === 'undefined' ? 'undefined' : _typeof(match)) {
	      case 'string':
	      case 'number':
	        props = {
	          key: match,
	          primaryText: match
	        };
	        break;
	      default:
	        if (deleteKeys) {
	          props = (0, _omit2.default)(match, typeof deleteKeys === 'string' ? [deleteKeys] : deleteKeys);
	        } else {
	          props = match;
	        }
	
	        props = _extends({}, props, {
	          key: match.key || dataValue && match[dataValue] || match[dataLabel],
	          primaryText: match[dataLabel]
	        });
	    }
	
	    if (typeof total !== 'undefined' && data.length < total) {
	      props['aria-setsize'] = total;
	      props['aria-posinset'] = i + 1 + offset;
	    }
	
	    // Allows focus, but does not let tab focus. This is so up and down keys work.
	    return _react2.default.createElement(_ListItem2.default, _extends({ tabIndex: -1 }, props));
	  };
	
	  this._toggleMenu = function (e) {
	    if (_this2.props.onMouseDown) {
	      _this2.props.onMouseDown(e);
	    }
	
	    if (!_this2.props.inline && _this2.state.matches.length && (0, _getField2.default)(_this2.props, _this2.state, 'value')) {
	      _this2.setState({ visible: !_this2.state.visible });
	    }
	  };
	
	  this._handleTouchStart = function (e) {
	    var target = e.target;
	    var suggestion = _this2.state.suggestion;
	
	    if (target.classList.contains('md-autocomplete-suggestion') && suggestion) {
	      _this2._handleInlineAutocomplete();
	    }
	  };
	
	  this._setField = function (field) {
	    if (field) {
	      _this2._field = field.getField();
	    }
	  };
	
	  this._setMenu = function (menu) {
	    _this2._menu = (0, _reactDom.findDOMNode)(menu);
	  };
	};
	
	exports.default = Autocomplete;
	//# sourceMappingURL=Autocomplete.js.map

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Autocomplete = undefined;
	
	var _Autocomplete2 = __webpack_require__(542);
	
	var _Autocomplete3 = _interopRequireDefault(_Autocomplete2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Autocomplete3.default;
	exports.Autocomplete = _Autocomplete3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _oneRequiredForA11yIf = __webpack_require__(682);
	
	var _oneRequiredForA11yIf2 = _interopRequireDefault(_oneRequiredForA11yIf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The avatar component is used to convert a `FontIcon`, an image, or
	 * a letter into an avatar.
	 *
	 * Any other props given to the Avatar component such as event listeners
	 * or styles will also be applied.
	 */
	var Avatar = function (_PureComponent) {
	  _inherits(Avatar, _PureComponent);
	
	  function Avatar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Avatar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Avatar.__proto__ || Object.getPrototypeOf(Avatar)).call.apply(_ref, [this].concat(args))), _this), _this.state = { color: null }, _this._setRandomColor = function () {
	      var suffixes = _this.props.suffixes;
	
	
	      var i = Math.floor(Math.random() * (suffixes.length - 1)) + 1;
	      _this.setState({ color: suffixes[i] });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Avatar, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.random) {
	        this._setRandomColor();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.random && (this.props.src !== nextProps.src || this.props.icon !== nextProps.icon)) {
	        this._setRandomColor();
	      } else if (this.props.random && !nextProps.random) {
	        this.setState({ color: null });
	      }
	    }
	  }, {
	    key: '_getColor',
	    value: function _getColor(suffix, suffixes, color) {
	      if (suffix) {
	        return 'md-avatar--' + suffix;
	      } else if (!!suffixes && !color) {
	        return 'md-avatar--default';
	      }
	
	      return 'md-avatar--' + color;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          contentStyle = _props.contentStyle,
	          contentClassName = _props.contentClassName,
	          src = _props.src,
	          alt = _props.alt,
	          icon = _props.icon,
	          children = _props.children,
	          suffix = _props.suffix,
	          suffixes = _props.suffixes,
	          iconSized = _props.iconSized,
	          role = _props.role,
	          random = _props.random,
	          props = _objectWithoutProperties(_props, ['className', 'contentStyle', 'contentClassName', 'src', 'alt', 'icon', 'children', 'suffix', 'suffixes', 'iconSized', 'role', 'random']);
	
	      var content = void 0;
	      if (src) {
	        content = _react2.default.createElement('img', {
	          src: src,
	          alt: alt,
	          role: role,
	          style: contentStyle,
	          className: (0, _classnames2.default)('md-avatar-img', contentClassName)
	        });
	      } else {
	        content = _react2.default.createElement(
	          'div',
	          {
	            style: contentStyle,
	            className: (0, _classnames2.default)('md-avatar-content', contentClassName)
	          },
	          icon || children
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, {
	          className: (0, _classnames2.default)('md-inline-block md-avatar', this._getColor(suffix, suffixes, this.state.color), {
	            'md-avatar--icon-sized': iconSized
	          }, className)
	        }),
	        content
	      );
	    }
	  }]);
	
	  return Avatar;
	}(_react.PureComponent);
	
	Avatar.propTypes = {
	  /**
	   * An optional className to apply to the avatar.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to either the `<img>` or `<div>` surrounding the content. The `<img>` tag
	   * will be used with the `src` prop is defined.
	   */
	  contentStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to either the `<img>` or `<div>` surrounding the content. The `<img>` tag
	   * will be used with the `src` prop is defined.
	   */
	  contentClassName: _propTypes2.default.string,
	
	  /**
	   * An optional image source to use for the avatar.
	   */
	  src: (0, _oneRequiredForA11yIf2.default)(_propTypes2.default.string, 'role', 'alt'),
	
	  /**
	   * An optional image alt to use for the avatar if it is
	   * an image.
	   */
	  alt: _propTypes2.default.string,
	
	  /**
	   * An optional `FontIcon` to convert into an avatar.
	   */
	  icon: _propTypes2.default.node,
	
	  /**
	   * An optional letter to display in the avatar.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A boolean if a random color should be applied to the avatar.
	   * This will be one of the `suffixes`.
	   */
	  random: _propTypes2.default.bool,
	
	  /**
	   * A list of available suffixes to use when generating a random
	   * color for the avatar.
	   */
	  suffixes: _propTypes2.default.arrayOf(_propTypes2.default.string),
	
	  /**
	   * The suffix to use for a color. This can be any value but
	   * *should* be one of the available `suffixes`.
	   */
	  suffix: _propTypes2.default.string,
	
	  /**
	   * Boolean if the `Avatar` should be sized to a `FontIcon` size. This
	   * will just set the width and height to the `$md-font-icon-size`.
	   */
	  iconSized: _propTypes2.default.bool,
	
	  /**
	   * A role for the avatar's image. When the `src` prop is set, either a `role` of `presentation`
	   * or the `alt` prop must be defined for a11y.
	   */
	  role: _propTypes2.default.oneOf(['presentation'])
	};
	Avatar.defaultProps = {
	  suffixes: ['red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue', 'light-blue', 'cyan', 'teal', 'green', 'light-green', 'lime', 'yellow', 'amber', 'orange', 'deep-orange', 'brown', 'grey', 'blue-grey']
	};
	exports.default = Avatar;
	//# sourceMappingURL=Avatar.js.map

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Avatar = undefined;
	
	var _Avatar2 = __webpack_require__(544);
	
	var _Avatar3 = _interopRequireDefault(_Avatar2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Avatar3.default;
	exports.Avatar = _Avatar3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(17);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _themeColors = __webpack_require__(12);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The main use case of the `Badge` component is for notifications. It can
	 * however also place any content floating to whatever children are supplied.
	 */
	var Badge = function (_PureComponent) {
	  _inherits(Badge, _PureComponent);
	
	  function Badge(props) {
	    _classCallCheck(this, Badge);
	
	    var _this = _possibleConstructorReturn(this, (Badge.__proto__ || Object.getPrototypeOf(Badge)).call(this, props));
	
	    var single = _this._isSingleChild(props);
	    _this.state = {
	      single: single,
	      element: single && (0, _react.isValidElement)(props.children),
	      count: _this._normalizeCount(props)
	    };
	    return _this;
	  }
	
	  _createClass(Badge, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          badgeContent = _props.badgeContent,
	          max = _props.max,
	          children = _props.children;
	
	      var nextState = void 0;
	      if (badgeContent !== nextProps.badgeContent || max !== nextProps.max) {
	        nextState = { count: this._normalizeCount(nextProps) };
	      }
	
	      if (children !== nextProps.children) {
	        nextState = nextState || {};
	        nextState.single = this._isSingleChild(nextProps);
	        nextState.element = nextState.single && (0, _react.isValidElement)(nextProps.children);
	      }
	
	      if (nextState) {
	        this.setState(nextState);
	      }
	    }
	  }, {
	    key: '_isSingleChild',
	    value: function _isSingleChild(_ref) {
	      var children = _ref.children;
	
	      return _react.Children.count(children) === 1;
	    }
	  }, {
	    key: '_normalizeCount',
	    value: function _normalizeCount(_ref2) {
	      var badgeContent = _ref2.badgeContent,
	          max = _ref2.max;
	
	      var count = void 0;
	      if (max) {
	        var n = parseInt(badgeContent, 10);
	        if (!Number.isNaN(n) && n.toString() === badgeContent.toString()) {
	          count = n > max ? max + '+' : n;
	        }
	      }
	
	      return count;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          count = _state.count,
	          single = _state.single,
	          element = _state.element;
	
	      var _props2 = this.props,
	          className = _props2.className,
	          badgeStyle = _props2.badgeStyle,
	          badgeClassName = _props2.badgeClassName,
	          badgeContent = _props2.badgeContent,
	          Component = _props2.component,
	          children = _props2.children,
	          primary = _props2.primary,
	          secondary = _props2.secondary,
	          defaultTheme = _props2.default,
	          circular = _props2.circular,
	          badgeId = _props2.badgeId,
	          invisibleOnZero = _props2.invisibleOnZero,
	          max = _props2.max,
	          props = _objectWithoutProperties(_props2, ['className', 'badgeStyle', 'badgeClassName', 'badgeContent', 'component', 'children', 'primary', 'secondary', 'default', 'circular', 'badgeId', 'invisibleOnZero', 'max']);
	
	      var useCircular = typeof circular !== 'undefined' ? circular : typeof count !== 'undefined';
	      var content = children;
	      if (single && element) {
	        var c = _react.Children.only(content);
	        if (!c.props['aria-describedby']) {
	          content = (0, _react.cloneElement)(c, { 'aria-describedby': badgeId });
	        }
	      } else if (single && !element && !props['aria-describedby']) {
	        props['aria-describedby'] = badgeId;
	      }
	
	      var badge = _react2.default.createElement(
	        'span',
	        {
	          id: badgeId,
	          key: 'badge',
	          role: 'status',
	          style: badgeStyle,
	          className: (0, _classnames2.default)('md-badge', {
	            'md-badge--circular': useCircular,
	            'md-badge--default': defaultTheme
	          }, (0, _themeColors2.default)({
	            primary: primary,
	            secondary: secondary,
	            text: useCircular,
	            themeText: !primary && !secondary
	          }, badgeClassName))
	        },
	        count || badgeContent
	      );
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, {
	          className: (0, _classnames2.default)('md-badge-container md-inline-block', className)
	        }),
	        content,
	        invisibleOnZero && count === 0 ? null : badge
	      );
	    }
	  }]);
	
	  return Badge;
	}(_react.PureComponent);
	
	Badge.propTypes = {
	  /**
	   * An optional style to apply to the badge's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the badge's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the badge.
	   */
	  badgeStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the badge.
	   */
	  badgeClassName: _propTypes2.default.string,
	
	  /**
	   * The id to give the badge's content. This is required to help with the
	   * `aria-describedby` attribute that should be applied to one of the children.
	   *
	   * If there is only one child that is a valid React element, the `aria-describedby`
	   * will automatically be cloned into that child (so make sure your component passes
	   * that prop correctly).
	   *
	   * If there is only one child, but it is a string or number, the badge's container
	   * will be updated to include the `aria-describedby`.
	   *
	   * If there is more than child, you are required to add it to a child yourself.
	   */
	  badgeId: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * The content to display with the badge's content. The size of this
	   * element is determinate of the location of the content. You might have
	   * to update the positioning yourself.
	   */
	  children: _propTypes2.default.node.isRequired,
	
	  /**
	   * The component to render the badge as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * The content to display in the badge. If the content is a number or a number string,
	   * the number will be normalized if `normalizeContent` is enabled.
	   */
	  badgeContent: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.node]).isRequired,
	
	  /**
	   * This will basically update the display value of the content to only be 2 digits. If
	   * a number is greater than 99, 99+ will be displayed instead. This is really just to
	   * keep the count inside the circular bubble.
	   */
	  max: _propTypes2.default.number,
	
	  /**
	   * Boolean if the primary color background should get applied to the badge's content.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the secondary color background should get applied to the badge's content.
	   */
	  secondary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the default styles should be applied.
	   */
	  default: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the badge's content should appear in a circular container. If this is
	   * undefined, the content will be in a circular container if the badgeContent is a number.
	   */
	  circular: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the badge's notification should be invisible when the count is 0.
	   */
	  invisibleOnZero: _propTypes2.default.bool
	};
	Badge.defaultProps = {
	  max: 99,
	  component: 'div'
	};
	exports.default = Badge;
	//# sourceMappingURL=Badge.js.map

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Badge = undefined;
	
	var _Badge2 = __webpack_require__(546);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Badge3.default;
	exports.Badge = _Badge3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(12);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _AccessibleFakeInkedButton = __webpack_require__(29);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	var _Collapse = __webpack_require__(46);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _FontIcons = __webpack_require__(270);
	
	var _FontIcons2 = _interopRequireDefault(_FontIcons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `BottomNav` component is used for rendering the navigation tab/link in the `BottomNavigation`
	 * component.
	 */
	var BottomNav = function (_PureComponent) {
	  _inherits(BottomNav, _PureComponent);
	
	  function BottomNav() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BottomNav);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BottomNav.__proto__ || Object.getPrototypeOf(BottomNav)).call.apply(_ref, [this].concat(args))), _this), _this._handleClick = function (e) {
	      var _this$props = _this.props,
	          onClick = _this$props.onClick,
	          onNavChange = _this$props.onNavChange,
	          index = _this$props.index;
	
	      if (onClick) {
	        onClick(index, e);
	      }
	
	      if (onNavChange) {
	        onNavChange(index, e);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(BottomNav, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          fixed = _props.fixed,
	          className = _props.className,
	          colored = _props.colored,
	          animate = _props.animate,
	          iconClassName = _props.iconClassName,
	          iconChildren = _props.iconChildren,
	          index = _props.index,
	          propIcon = _props.icon,
	          propLabel = _props.label,
	          onClick = _props.onClick,
	          onNavChange = _props.onNavChange,
	          props = _objectWithoutProperties(_props, ['active', 'fixed', 'className', 'colored', 'animate', 'iconClassName', 'iconChildren', 'index', 'icon', 'label', 'onClick', 'onNavChange']);
	
	      var _props2 = this.props,
	          label = _props2.label,
	          icon = _props2.icon;
	
	      var labelClassName = (0, _classnames2.default)('md-bottom-nav-label', { 'md-bottom-nav-label--shifting-inactive': !active && !fixed });
	      if (_react.Children.count(label) === 1 && (0, _react.isValidElement)(label)) {
	        var labelEl = _react.Children.only(label);
	        label = (0, _react.cloneElement)(label, {
	          className: (0, _classnames2.default)(labelClassName, labelEl.props.className)
	        });
	      } else {
	        label = _react2.default.createElement(
	          'div',
	          { className: labelClassName },
	          label
	        );
	      }
	
	      if (!icon && (iconClassName || iconChildren)) {
	        // Deprecated
	        icon = _react2.default.createElement(
	          _FontIcons2.default,
	          { iconClassName: iconClassName, inherit: true },
	          iconChildren
	        );
	      } else if (icon) {
	        icon = _react2.default.cloneElement(icon, { inherit: true });
	      }
	
	      return _react2.default.createElement(
	        _AccessibleFakeInkedButton2.default,
	        _extends({}, props, {
	          onClick: this._handleClick,
	          className: (0, _classnames2.default)('md-bottom-nav', {
	            'md-bottom-nav--active': active,
	            'md-bottom-nav--fixed': fixed,
	            'md-bottom-nav--shifting': !fixed,
	            'md-bottom-nav--shifting-active': !fixed && active,
	            'md-bottom-nav--shifting-inactive': !fixed && !active
	          }, (0, _themeColors2.default)({ primary: !colored && active, text: !active && !colored }, className))
	        }),
	        icon,
	        _react2.default.createElement(
	          _Collapse2.default,
	          { collapsed: !fixed && !active, animate: animate },
	          label
	        )
	      );
	    }
	  }]);
	
	  return BottomNav;
	}(_react.PureComponent);
	
	BottomNav.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	  active: _propTypes2.default.bool,
	  fixed: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  index: _propTypes2.default.number.isRequired,
	  label: _propTypes2.default.node.isRequired,
	  colored: _propTypes2.default.bool,
	  iconChildren: _propTypes2.default.node,
	  iconClassName: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  onNavChange: _propTypes2.default.func,
	  role: _propTypes2.default.string,
	  animate: _propTypes2.default.bool,
	  icon: _propTypes2.default.element
	};
	BottomNav.defaultProps = {
	  component: 'a',
	  role: null
	};
	exports.default = BottomNav;
	//# sourceMappingURL=BottomNav.js.map

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _controlled = __webpack_require__(16);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _touches = __webpack_require__(84);
	
	var _Portal = __webpack_require__(62);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Paper = __webpack_require__(33);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _BottomNav = __webpack_require__(548);
	
	var _BottomNav2 = _interopRequireDefault(_BottomNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `BottomNavigation` component is an alternative to the `NavigationDrawer` for handling navigation
	 * only on mobile devices.
	 */
	var BottomNavigation = function (_PureComponent) {
	  _inherits(BottomNavigation, _PureComponent);
	
	  function BottomNavigation(props) {
	    _classCallCheck(this, BottomNavigation);
	
	    var _this = _possibleConstructorReturn(this, (BottomNavigation.__proto__ || Object.getPrototypeOf(BottomNavigation)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var visible = typeof props.initiallyVisible === 'boolean' ? props.initiallyVisible : props.defaultVisible;
	    _this.state = {
	      visible: visible,
	      portalVisible: visible
	    };
	
	    if (typeof props.activeIndex === 'undefined') {
	      _this.state.activeIndex = props.defaultActiveIndex;
	    }
	    return _this;
	  }
	
	  _createClass(BottomNavigation, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.dynamic) {
	        this._addTouchEvents();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var dynamic = nextProps.dynamic;
	
	      if (this.props.dynamic === dynamic) {
	        return;
	      }
	
	      if (dynamic) {
	        this._addTouchEvents();
	      } else {
	        this._removeTouchEvents();
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (this.state.visible !== nextState.visible && nextProps.onVisibilityChange) {
	        nextProps.onVisibilityChange(nextState.visible);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.dynamic) {
	        this._removeTouchEvents();
	      }
	
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          visible = _state.visible,
	          portalVisible = _state.portalVisible;
	
	      var _props = this.props,
	          className = _props.className,
	          actions = _props.actions,
	          colored = _props.colored,
	          dynamic = _props.dynamic,
	          lastChild = _props.lastChild,
	          animate = _props.animate,
	          portal = _props.portal,
	          propLinks = _props.links,
	          propActiveIndex = _props.activeIndex,
	          propRenderNode = _props.renderNode,
	          onNavChange = _props.onNavChange,
	          onVisibilityChange = _props.onVisibilityChange,
	          defaultVisible = _props.defaultVisible,
	          defaultActiveIndex = _props.defaultActiveIndex,
	          dynamicThreshold = _props.dynamicThreshold,
	          transitionDuration = _props.transitionDuration,
	          onChange = _props.onChange,
	          initiallyVisible = _props.initiallyVisible,
	          containerStyle = _props.containerStyle,
	          containerClassName = _props.containerClassName,
	          transitionName = _props.transitionName,
	          transitionEnterTimeout = _props.transitionEnterTimeout,
	          transitionLeaveTimeout = _props.transitionLeaveTimeout,
	          props = _objectWithoutProperties(_props, ['className', 'actions', 'colored', 'dynamic', 'lastChild', 'animate', 'portal', 'links', 'activeIndex', 'renderNode', 'onNavChange', 'onVisibilityChange', 'defaultVisible', 'defaultActiveIndex', 'dynamicThreshold', 'transitionDuration', 'onChange', 'initiallyVisible', 'containerStyle', 'containerClassName', 'transitionName', 'transitionEnterTimeout', 'transitionLeaveTimeout']);
	
	      var links = this.props.links;
	
	      if (actions) {
	        links = actions;
	      }
	
	      var fixed = links.length === 3;
	      var activeIndex = (0, _getField2.default)(this.props, this.state, 'activeIndex');
	      var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');
	      var navigation = _react2.default.createElement(
	        _Paper2.default,
	        _extends({}, props, {
	          key: 'navigation',
	          className: (0, _classnames2.default)('md-bottom-navigation', {
	            'md-background--card': !colored,
	            'md-background--primary': colored,
	            'md-bottom-navigation--dynamic': dynamic,
	            'md-bottom-navigation--dynamic-inactive': dynamic && !visible
	          }, className),
	          role: 'navigation'
	        }),
	        links.map(function (action, index) {
	          return _react2.default.createElement(_BottomNav2.default, _extends({}, action, {
	            animate: animate,
	            key: action.key || index,
	            index: index,
	            onNavChange: _this2._handleNavChange,
	            active: activeIndex === index,
	            colored: colored,
	            fixed: fixed
	          }));
	        })
	      );
	
	      if (!portal) {
	        return portalVisible ? navigation : null;
	      }
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { renderNode: renderNode, visible: portalVisible, lastChild: lastChild },
	        navigation
	      );
	    }
	  }]);
	
	  return BottomNavigation;
	}(_react.PureComponent);
	
	BottomNavigation.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * A list of objects to generate a bottom navigation link. There must be at least 3 and no more
	   * than 5 links. A link gets rendered as the `AccessibleFakeButton` component, so any additional
	   * props in the link's shape will be passed along.
	   *
	   * ```docgen
	   * PropTypes.arrayOf(PropTypes.shape({
	   *   label: PropTypes.node.isRequired,
	   *   icon: PropTypes.element,
	   *   component: PropTypes.oneOfType([
	   *      PropTypes.func,
	   *      PropTypes.string,
	   *   ]),
	   * }).isRequired
	   * ```
	   */
	  links: function links(props, propName, component) {
	    for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      args[_key - 3] = arguments[_key];
	    }
	
	    var _PropTypes$arrayOf;
	
	    var links = props[propName] || props.actions;
	    var len = links.length;
	
	    if (len < 3) {
	      return new Error('Only ' + len + ' `' + propName + '` were given to the ' + component + '. At least 3 are required.');
	    } else if (len > 5) {
	      return new Error(len + ' `' + propName + '` were given to the ' + component + '. No more than 5 may be given.');
	    }
	
	    return (_PropTypes$arrayOf = _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      label: _propTypes2.default.node.isRequired,
	      icon: _propTypes2.default.element,
	      iconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `icon` instead'),
	      iconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `icon` instead'),
	      component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string])
	    }))).isRequired.apply(_PropTypes$arrayOf, [props, propName, component].concat(args));
	  },
	
	  /**
	   * Boolean if the bottom navigation should be colored with the primary color or whatever color
	   * was a result of the `react-md-theme-bottom-navigations-colored` mixin.
	   */
	  colored: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the bottom navigation should dynamically appear based on scrolling. When the user
	   * scrolls the `dynamicThreshold` amount, this component will either disappear (scrolling down)
	   * or appear (scrolling up).
	   */
	  dynamic: _propTypes2.default.bool,
	
	  /**
	   * The distance a user must scroll before the bottom navigation appears or disappears when it is `dynamic`.
	   */
	  dynamicThreshold: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional function to call when a link has been clicked. The callback will
	   * include the new active index and the click event.
	   *
	   * ```js
	   * onNavChange(newActiveIndex, event);
	   * ```
	   */
	  onNavChange: _propTypes2.default.func,
	
	  /**
	   * An optional active index to use. This will make the component controlled and require the
	   * `onNavChange` prop to be defined.
	   */
	  activeIndex: (0, _controlled2.default)(_propTypes2.default.number, 'onNavChange', 'defaultActiveIndex'),
	
	  /**
	   * The index for the link that is active by default.
	   */
	  defaultActiveIndex: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the bottom navigation is visible by default. This *should* probably always
	   * be true.
	   */
	  defaultVisible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * The component to render the bottom navigation as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * Boolean if the Portal's functionality of rendering in a separate react tree should be applied
	   * to the bottom navigation.
	   *
	   * @see {@link Helpers/Portal}
	   */
	  portal: _propTypes2.default.bool,
	
	  /**
	   * Since the `BottomNavigation` component uses the `Portal` component, you can pass an optional
	   * HTML Node to render in.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the bottom navigation should render as the last child in the `renderNode` or `body`
	   * instead of as the first.
	   */
	  lastChild: _propTypes2.default.bool,
	
	  /**
	   * The transition duration for the dynamic bottom navigation to appear or disappear. This should
	   * match the `$md-bottom-navigation-transition-time` variable.
	   */
	  transitionDuration: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional function to call when the visibility of the bottom navigation changes. The callback
	   * will include the new visibility.
	   *
	   * ```js
	   * onVisibilityChange(!visible);
	   * ```
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * Boolean if the label on a shifting navigation should animate in and out.
	   */
	  animate: _propTypes2.default.bool,
	
	  onChange: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onNavChange` instead'),
	  initiallyVisible: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
	  initialActiveIndex: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `defaultActiveIndex` instead'),
	  containerStyle: (0, _deprecated2.default)(_propTypes2.default.object, 'Use `style` instead'),
	  containerClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `className` instead'),
	  transitionName: (0, _deprecated2.default)(_propTypes2.default.string, 'There is no CSSTransitionGroup used anymore'),
	  transitionEnterTimeout: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `transitionDuration` instead'),
	  transitionLeaveTimeout: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `transitionDuration` instead'),
	  actions: (0, _deprecated2.default)(_propTypes2.default.array, 'Use `links` instead')
	};
	BottomNavigation.defaultProps = {
	  animate: true,
	  defaultActiveIndex: 0,
	  component: 'footer',
	  defaultVisible: true,
	  transitionDuration: 300,
	  portal: false,
	  dynamicThreshold: 5
	};
	BottomNavigation.contextTypes = {
	  renderNode: _propTypes2.default.object
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this._addTouchEvents = function () {
	    (0, _touches.addTouchEvent)(window, 'start', _this3._handleTouchStart);
	    (0, _touches.addTouchEvent)(window, 'move', _this3._handleTouchMove);
	    (0, _touches.addTouchEvent)(window, 'end', _this3._handleTouchEnd);
	  };
	
	  this._removeTouchEvents = function () {
	    (0, _touches.removeTouchEvent)(window, 'start', _this3._handleTouchStart);
	    (0, _touches.removeTouchEvent)(window, 'move', _this3._handleTouchMove);
	    (0, _touches.removeTouchEvent)(window, 'end', _this3._handleTouchEnd);
	  };
	
	  this._animateIn = function () {
	    if (_this3._timeout) {
	      clearTimeout(_this3._timeout);
	    }
	
	    _this3._timeout = setTimeout(function () {
	      _this3._timeout = null;
	      _this3.setState({ visible: true });
	    }, 17);
	
	    _this3.setState({ portalVisible: true });
	  };
	
	  this._animateOut = function () {
	    if (_this3._timeout) {
	      clearTimeout(_this3._timeout);
	    }
	
	    _this3._timeout = setTimeout(function () {
	      _this3._timeout = null;
	      _this3.setState({ portalVisible: false });
	    }, _this3.props.transitionDuration);
	
	    _this3.setState({ visible: false });
	  };
	
	  this._handleTouchStart = function (e) {
	    var pageY = e.changedTouches[0].pageY;
	
	
	    _this3._pageY = pageY;
	    _this3._scrolling = true;
	  };
	
	  this._handleTouchMove = function (e) {
	    var visible = _this3.state.visible;
	
	    if (!_this3._scrolling) {
	      return;
	    }
	
	    var touchY = e.changedTouches[0].pageY;
	    var dynamicThreshold = _this3.props.dynamicThreshold;
	
	    var passedThreshold = Math.abs(_this3._pageY - touchY) >= dynamicThreshold;
	    if (_this3._pageY > touchY && visible && passedThreshold) {
	      _this3._pageY = touchY;
	      _this3._animateOut();
	    } else if (_this3._pageY < touchY && !visible && passedThreshold) {
	      _this3._pageY = touchY;
	      _this3._animateIn();
	    }
	  };
	
	  this._handleTouchEnd = function () {
	    _this3._scrolling = false;
	  };
	
	  this._handleNavChange = function (index, e) {
	    if (_this3.props.onNavChange || _this3.props.onChange) {
	      (_this3.props.onNavChange || _this3.props.onChange)(index, e);
	    }
	
	    if (typeof _this3.props.activeIndex === 'undefined') {
	      _this3.setState({ activeIndex: index });
	    }
	  };
	};
	
	exports.default = BottomNavigation;
	//# sourceMappingURL=BottomNavigation.js.map

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BottomNavigation = undefined;
	
	var _BottomNavigation2 = __webpack_require__(549);
	
	var _BottomNavigation3 = _interopRequireDefault(_BottomNavigation2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BottomNavigation3.default;
	exports.BottomNavigation = _BottomNavigation3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentDeprecated = __webpack_require__(47);
	
	var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);
	
	var _Button = __webpack_require__(19);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FlatButton = function (_PureComponent) {
	  _inherits(FlatButton, _PureComponent);
	
	  function FlatButton() {
	    _classCallCheck(this, FlatButton);
	
	    return _possibleConstructorReturn(this, (FlatButton.__proto__ || Object.getPrototypeOf(FlatButton)).apply(this, arguments));
	  }
	
	  _createClass(FlatButton, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_Button2.default, _extends({}, this.props, { flat: true }));
	    }
	  }]);
	
	  return FlatButton;
	}(_react.PureComponent);
	
	FlatButton.propTypes = {
	  /**
	   * The label to display in the button.
	   */
	  label: _propTypes2.default.node.isRequired,
	
	  /**
	   * An optional className to apply to the button.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if the icon should be displayed before the label.
	   */
	  iconBefore: _propTypes2.default.bool,
	
	  /**
	   * A `FontIcon` to display in the button. It can be placed before
	   * or after the label.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The button type.
	   */
	  type: _propTypes2.default.string,
	
	  /**
	   * Boolean if the button should be styled with the primary color.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the button should be styled with the secondary color.
	   */
	  secondary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the button is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional href to convert the button into a link button.
	   */
	  href: _propTypes2.default.string,
	
	  /**
	   * An optional function to call when the button is clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  deprecated: (0, _componentDeprecated2.default)('The behavior of the `FlatButton` can be achieved with the `Button` component ' + 'without the additional bundle size. Switch to the `Button` component and add a ' + 'prop `flat`.')
	};
	FlatButton.defaultProps = {
	  type: 'button',
	  iconBefore: true
	};
	exports.default = FlatButton;
	//# sourceMappingURL=FlatButton.js.map

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _componentDeprecated = __webpack_require__(47);
	
	var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);
	
	var _IconButton = __webpack_require__(258);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A `FloatingButton` is an extension of the `IconButton`.
	 * A tooltip can be displayed on hover or touch hold if the
	 * `tooltipLabel` prop is given.
	 *
	 * Another name for this button is a `FloatingActionButton` (FAB).
	 *
	 * Any other props (such as style or event listeners) will also be
	 * applied.
	 */
	var FloatingButton = function (_PureComponent) {
	  _inherits(FloatingButton, _PureComponent);
	
	  function FloatingButton() {
	    _classCallCheck(this, FloatingButton);
	
	    return _possibleConstructorReturn(this, (FloatingButton.__proto__ || Object.getPrototypeOf(FloatingButton)).apply(this, arguments));
	  }
	
	  _createClass(FloatingButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          fixed = _props.fixed,
	          mini = _props.mini,
	          children = _props.children,
	          iconClassName = _props.iconClassName,
	          props = _objectWithoutProperties(_props, ['className', 'fixed', 'mini', 'children', 'iconClassName']);
	
	      return _react2.default.createElement(
	        _IconButton2.default,
	        _extends({}, props, {
	          className: (0, _classnames2.default)({
	            'md-btn--floating-fixed': fixed,
	            'md-btn--floating-mini': mini
	          }, className),
	          iconClassName: iconClassName,
	          floating: true
	        }),
	        children
	      );
	    }
	  }]);
	
	  return FloatingButton;
	}(_react.PureComponent);
	
	FloatingButton.propTypes = {
	  /**
	   * The className to use for rendering the `FontIcon`.
	   */
	  iconClassName: _propTypes2.default.string,
	
	  /**
	   * Any children to use to render the `FontIcon`.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An optional className to apply to the button.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The button type.
	   */
	  type: _propTypes2.default.string,
	
	  /**
	   * Boolean if the button is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional href to convert the button into a link button.
	   */
	  href: _propTypes2.default.string,
	
	  /**
	   * An optional function to call when the button is clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional label to use if you would like a tooltip to display
	   * on hover or touch hold.
	   */
	  tooltipLabel: _propTypes2.default.node,
	
	  /**
	   * The position that the tooltip should be displayed relative to
	   * the button.
	   */
	  tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * An optional amount of delay before the tooltip appears.
	   */
	  tooltipDelay: _propTypes2.default.number,
	
	  /**
	   * Boolean if the floating button is fixed.
	   */
	  fixed: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the floating button should be displayed as the mini
	   * version.
	   */
	  mini: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the floating button should be styled with the primary color.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the floating button should be styled with the secondary color.
	   */
	  secondary: _propTypes2.default.bool,
	
	  deprecated: (0, _componentDeprecated2.default)('The behavior of the `FloatingButton` can be achieved with the `Button` component ' + 'without the additional bundle size. Switch to the `Button` component and add a ' + 'prop `floating`.')
	};
	exports.default = FloatingButton;
	//# sourceMappingURL=FloatingButton.js.map

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentDeprecated = __webpack_require__(47);
	
	var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);
	
	var _Button = __webpack_require__(19);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RaisedButton = function (_PureComponent) {
	  _inherits(RaisedButton, _PureComponent);
	
	  function RaisedButton() {
	    _classCallCheck(this, RaisedButton);
	
	    return _possibleConstructorReturn(this, (RaisedButton.__proto__ || Object.getPrototypeOf(RaisedButton)).apply(this, arguments));
	  }
	
	  _createClass(RaisedButton, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_Button2.default, _extends({}, this.props, { raised: true }));
	    }
	  }]);
	
	  return RaisedButton;
	}(_react.PureComponent);
	
	RaisedButton.propTypes = {
	  /**
	   * The label to display in the button.
	   */
	  label: _propTypes2.default.node.isRequired,
	
	  /**
	   * An optional className to apply to the button.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if the icon should be displayed before the label.
	   */
	  iconBefore: _propTypes2.default.bool,
	
	  /**
	   * A `FontIcon` to display in the button. It can be placed before
	   * or after the label.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The button type.
	   */
	  type: _propTypes2.default.string,
	
	  /**
	   * Boolean if the button should be styled with the primary color.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the button should be styled with the secondary color.
	   */
	  secondary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the button is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional href to convert the button into a link button.
	   */
	  href: _propTypes2.default.string,
	
	  /**
	   * An optional function to call when the button is clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  deprecated: (0, _componentDeprecated2.default)('The behavior of the `RaisedButton` can be achieved with the `Button` component ' + 'without the additional bundle size. Switch to the `Button` component and add a ' + 'prop `raised`.')
	};
	RaisedButton.defaultProps = {
	  type: 'button',
	  iconBefore: true
	};
	exports.default = RaisedButton;
	//# sourceMappingURL=RaisedButton.js.map

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconButton = exports.FloatingButton = exports.RaisedButton = exports.FlatButton = exports.Button = undefined;
	
	var _Button2 = __webpack_require__(19);
	
	var _Button3 = _interopRequireDefault(_Button2);
	
	var _FlatButton2 = __webpack_require__(551);
	
	var _FlatButton3 = _interopRequireDefault(_FlatButton2);
	
	var _RaisedButton2 = __webpack_require__(553);
	
	var _RaisedButton3 = _interopRequireDefault(_RaisedButton2);
	
	var _FloatingButton2 = __webpack_require__(552);
	
	var _FloatingButton3 = _interopRequireDefault(_FloatingButton2);
	
	var _IconButton2 = __webpack_require__(258);
	
	var _IconButton3 = _interopRequireDefault(_IconButton2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Button3.default;
	exports.Button = _Button3.default;
	exports.FlatButton = _FlatButton3.default;
	exports.RaisedButton = _RaisedButton3.default;
	exports.FloatingButton = _FloatingButton3.default;
	exports.IconButton = _IconButton3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _controlled = __webpack_require__(16);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _contextTypes = __webpack_require__(264);
	
	var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	var _getDeprecatedIcon = __webpack_require__(21);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _FontIcon = __webpack_require__(13);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Paper = __webpack_require__(33);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Collapse = __webpack_require__(46);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Card = function (_PureComponent) {
	  _inherits(Card, _PureComponent);
	
	  function Card(props) {
	    _classCallCheck(this, Card);
	
	    var _this = _possibleConstructorReturn(this, (Card.__proto__ || Object.getPrototypeOf(Card)).call(this, props));
	
	    _this._handleMouseOver = function (e) {
	      if (_this.props.onMouseOver) {
	        _this.props.onMouseOver(e);
	      }
	
	      if (_this.props.raise && !_this._touched) {
	        _this.setState({ zDepth: 4 });
	      }
	    };
	
	    _this._handleMouseLeave = function (e) {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(e);
	      }
	
	      _this._touched = false;
	      if (_this.props.raise && _this.state.zDepth !== 1) {
	        _this.setState({ zDepth: 1 });
	      }
	    };
	
	    _this._handleTouchStart = function (e) {
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(e);
	      }
	
	      _this._touched = true;
	    };
	
	    _this._handleExpandClick = function (e) {
	      var onExpanderClick = _this.props.onExpanderClick;
	
	      var expanded = !(0, _getField2.default)(_this.props, _this.state, 'expanded');
	      if (onExpanderClick) {
	        onExpanderClick(expanded, e);
	      }
	
	      if (typeof _this.props.expanded === 'undefined') {
	        _this.setState({ expanded: expanded });
	      }
	    };
	
	    _this.state = {
	      zDepth: 1,
	      expanded: typeof props.initiallyExpanded !== 'undefined' ? props.initiallyExpanded : !!props.defaultExpanded
	    };
	    return _this;
	  }
	
	  _createClass(Card, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _props = this.props,
	          expanderTooltipLabel = _props.expanderTooltipLabel,
	          expanderTooltipDelay = _props.expanderTooltipDelay,
	          expanderTooltipPosition = _props.expanderTooltipPosition,
	          expanderIcon = _props.expanderIcon,
	          iconClassName = _props.iconClassName,
	          iconChildren = _props.iconChildren,
	          expanderIconClassName = _props.expanderIconClassName,
	          expanderIconChildren = _props.expanderIconChildren;
	
	
	      var expanded = typeof this.props.isExpanded !== 'undefined' ? this.props.isExpanded : (0, _getField2.default)(this.props, this.state, 'expanded');
	
	      return {
	        expanded: expanded,
	        onExpandClick: this._handleExpandClick,
	        icon: (0, _getDeprecatedIcon2.default)(iconChildren || expanderIconChildren, iconClassName || expanderIconClassName, expanderIcon),
	        tooltipLabel: expanderTooltipLabel,
	        tooltipDelay: expanderTooltipDelay,
	        tooltipPosition: expanderTooltipPosition
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var zDepth = this.state.zDepth;
	
	      var _props2 = this.props,
	          className = _props2.className,
	          raise = _props2.raise,
	          tableCard = _props2.tableCard,
	          children = _props2.children,
	          animate = _props2.animate,
	          propExpanded = _props2.expanded,
	          onExpanderClick = _props2.onExpanderClick,
	          defaultExpanded = _props2.defaultExpanded,
	          expanderIcon = _props2.expanderIcon,
	          expanderIconChildren = _props2.expanderIconChildren,
	          expanderIconClassName = _props2.expanderIconClassName,
	          expanderTooltipLabel = _props2.expanderTooltipLabel,
	          expanderTooltipDelay = _props2.expanderTooltipDelay,
	          expanderTooltipPosition = _props2.expanderTooltipPosition,
	          iconChildren = _props2.iconChildren,
	          iconClassName = _props2.iconClassName,
	          isExpanded = _props2.isExpanded,
	          initiallyExpanded = _props2.initiallyExpanded,
	          props = _objectWithoutProperties(_props2, ['className', 'raise', 'tableCard', 'children', 'animate', 'expanded', 'onExpanderClick', 'defaultExpanded', 'expanderIcon', 'expanderIconChildren', 'expanderIconClassName', 'expanderTooltipLabel', 'expanderTooltipDelay', 'expanderTooltipPosition', 'iconChildren', 'iconClassName', 'isExpanded', 'initiallyExpanded']);
	
	      var expanded = typeof this.props.isExpanded !== 'undefined' ? this.props.isExpanded : (0, _getField2.default)(this.props, this.state, 'expanded');
	      var expanderIndex = -1;
	      var parts = _react.Children.map(_react.Children.toArray(children), function (child, i) {
	        if (!child || !child.props) {
	          return child;
	        } else if (expanderIndex < 0 && (child.props.isExpander || child.props.expander)) {
	          expanderIndex = i;
	        }
	
	        if (!child.props.expandable) {
	          return child;
	        }
	
	        var collapsed = expanderIndex === -1 || expanderIndex === i || !expanded;
	        return _react2.default.createElement(
	          _Collapse2.default,
	          { collapsed: collapsed, animate: animate },
	          child
	        );
	      });
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        _extends({}, props, {
	          zDepth: zDepth,
	          className: (0, _classnames2.default)('md-card', {
	            'md-card--raise': raise,
	            'md-card--table': tableCard
	          }, 'md-background--card', className),
	          onMouseOver: this._handleMouseOver,
	          onMouseLeave: this._handleMouseLeave,
	          onTouchStart: this._handleTouchStart
	        }),
	        parts
	      );
	    }
	  }]);
	
	  return Card;
	}(_react.PureComponent);
	
	Card.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the card.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Any Card parts that should be rendered.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the card is expanded by default when there is an expander
	   * component.
	   */
	  defaultExpanded: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the card should raise on hover when on a desktop display.
	   */
	  raise: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the card is currently expanded. This will require the `onExpanderClick` function
	   * to toggle the state. The card will become controlled if this is not `undefined`.
	   */
	  expanded: (0, _controlled2.default)(_propTypes2.default.bool, 'onExpanderClick', 'defaultExpanded'),
	
	  /**
	   * An optional function to call when the expander is clicked.
	   */
	  onExpanderClick: _propTypes2.default.func,
	
	  /**
	   * The icon to use for the expander button. It is recommended to use this prop over
	   * the `expaderIconChildren` and `expanderIconClassName` since it provides more control.
	   */
	  expanderIcon: _propTypes2.default.element,
	
	  /**
	   * The tooltip position for the expander icon.
	   */
	  expanderTooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The optional tooltip to display for the expander icon.
	   */
	  expanderTooltipLabel: _propTypes2.default.node,
	
	  /**
	   * An optional delay before the tooltip appears for the expander icon on hover.
	   */
	  expanderTooltipDelay: _propTypes2.default.number,
	
	  /**
	   * Boolean if the card contains a table. It will update the styling accordingly.
	   * When using the `DataTable` component, do not wrap it in a `CardText` component.
	   *
	   * ```js
	   * <Card tableCard={true}>
	   *   <CardTitle title="Example />
	   *   <DataTable>
	   *     ...
	   *   </DataTable>
	   * </Card>
	   * ```
	   */
	  tableCard: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when the mouseover event is triggered.
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the mouseleave event is triggered.
	   */
	  onMouseLeave: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the touchstart event is triggered.
	   */
	  onTouchStart: _propTypes2.default.func,
	
	  /**
	   * Boolean if the card expansion should be animated.
	   */
	  animate: _propTypes2.default.bool,
	
	  expanderIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `expanderIcon` instead'),
	  expanderIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `expanderIcon` instead'),
	  initiallyExpanded: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultExpanded` instead'),
	  isExpanded: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `expanded` instead'),
	  iconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `expanderIconChildren` prop instead'),
	  iconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `expanderIconClassName` prop instead')
	};
	Card.defaultProps = {
	  animate: true,
	  expanderIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'keyboard_arrow_down'
	  ),
	  expanderTooltipPosition: 'left'
	};
	Card.childContextTypes = _contextTypes2.default;
	exports.default = Card;
	//# sourceMappingURL=Card.js.map

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CardTitle = __webpack_require__(262);
	
	var _CardTitle2 = _interopRequireDefault(_CardTitle);
	
	var _CardActions = __webpack_require__(260);
	
	var _CardActions2 = _interopRequireDefault(_CardActions);
	
	var _Button = __webpack_require__(19);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _componentDeprecated = __webpack_require__(47);
	
	var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `CardActionOverlay` component is a simple wrapper for generating an overlay
	 * for the `CardMedia` component by having a `CardTitle` and an array of props
	 * for generating `FlatButton` for the `CardActions` component.
	 */
	var CardActionOverlay = function (_PureComponent) {
	  _inherits(CardActionOverlay, _PureComponent);
	
	  function CardActionOverlay() {
	    _classCallCheck(this, CardActionOverlay);
	
	    return _possibleConstructorReturn(this, (CardActionOverlay.__proto__ || Object.getPrototypeOf(CardActionOverlay)).apply(this, arguments));
	  }
	
	  _createClass(CardActionOverlay, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actions = _props.actions,
	          titleProps = _objectWithoutProperties(_props, ['actions']);
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(_CardTitle2.default, titleProps),
	        _react2.default.createElement(
	          _CardActions2.default,
	          null,
	          actions.map(function (actionProps, i) {
	            return _react2.default.createElement(_Button2.default, _extends({ flat: true, key: i }, actionProps));
	          })
	        )
	      );
	    }
	  }]);
	
	  return CardActionOverlay;
	}(_react.PureComponent);
	
	CardActionOverlay.propTypes = {
	  /**
	   * The title to use.
	   */
	  title: _propTypes2.default.node,
	
	  /**
	   * The optional subtitle to use.
	   */
	  subtitle: _propTypes2.default.node,
	
	  /**
	   * An array of flat button props.
	   */
	  actions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    label: _propTypes2.default.node.isRequired
	  })),
	
	  /**
	   * Any children to display in the `CardTitle` component.
	   */
	  children: _propTypes2.default.node,
	  deprecated: (0, _componentDeprecated2.default)('It is not a worthwhile component since the same thing can be accomplished with the `MediaOverlay` component.')
	};
	exports.default = CardActionOverlay;
	//# sourceMappingURL=CardActionOverlay.js.map

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _componentDeprecated = __webpack_require__(47);
	
	var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);
	
	var _Media = __webpack_require__(278);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _MediaOverlay = __webpack_require__(279);
	
	var _MediaOverlay2 = _interopRequireDefault(_MediaOverlay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `CardMedia` component is used to display images or some sort
	 * media.
	 */
	var CardMedia = function (_PureComponent) {
	  _inherits(CardMedia, _PureComponent);
	
	  function CardMedia() {
	    _classCallCheck(this, CardMedia);
	
	    return _possibleConstructorReturn(this, (CardMedia.__proto__ || Object.getPrototypeOf(CardMedia)).apply(this, arguments));
	  }
	
	  _createClass(CardMedia, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['className', 'children']);
	
	      delete props.overlay;
	
	      var overlay = this.props.overlay;
	
	      if (overlay) {
	        overlay = _react2.default.createElement(
	          _MediaOverlay2.default,
	          null,
	          overlay
	        );
	      }
	
	      return _react2.default.createElement(
	        _Media2.default,
	        _extends({ className: (0, _classnames2.default)('md-card-media', className) }, props),
	        children,
	        overlay
	      );
	    }
	  }]);
	
	  return CardMedia;
	}(_react.PureComponent);
	
	CardMedia.aspect = {
	  equal: '1-1',
	  wide: '16-9'
	};
	CardMedia.propTypes = {
	  /**
	   * An optional className to apply to the card media component.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional overlay component to be rendered over the media. This *should*
	   * be A `CardTitle`, `CardActions` or both.
	   */
	  overlay: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `MediaOverlay` component as a child instead'),
	
	  /**
	   * Any media to display.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the aspect ratio should be forced.
	   */
	  forceAspect: _propTypes2.default.bool,
	
	  /**
	   * The aspect ratio to use.
	   */
	  aspectRatio: _propTypes2.default.oneOf([CardMedia.aspect.equal, CardMedia.aspect.wide]).isRequired,
	
	  /**
	   * Boolean if this component should be expandable when there is a `CardExpander`
	   * above it in the `Card`.
	   */
	  expandable: _propTypes2.default.bool,
	
	  /**
	   * The component to render the card media as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  deprecated: (0, _componentDeprecated2.default)('There were no unique styles for media in cards so it is simpler to just use the ' + '`Media` component.')
	};
	CardMedia.defaultProps = {
	  forceAspect: true,
	  aspectRatio: CardMedia.aspect.wide,
	  component: 'section'
	};
	exports.default = CardMedia;
	//# sourceMappingURL=CardMedia.js.map

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `CardText` component is a simple wrapper for text or any content in a `Card`.
	 * It really just adds correct padding and font color.
	 */
	var CardText = function (_PureComponent) {
	  _inherits(CardText, _PureComponent);
	
	  function CardText() {
	    _classCallCheck(this, CardText);
	
	    return _possibleConstructorReturn(this, (CardText.__proto__ || Object.getPrototypeOf(CardText)).apply(this, arguments));
	  }
	
	  _createClass(CardText, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.component,
	          className = _props.className,
	          expandable = _props.expandable,
	          props = _objectWithoutProperties(_props, ['component', 'className', 'expandable']);
	
	      return _react2.default.createElement(Component, _extends({}, props, { className: (0, _classnames2.default)('md-card-text', className) }));
	    }
	  }]);
	
	  return CardText;
	}(_react.PureComponent);
	
	CardText.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The children to display.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The component to render as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * Boolean if this component should be expandable when there is a `CardExpander`
	   * above it in the `Card`.
	   */
	  expandable: _propTypes2.default.bool
	};
	CardText.defaultProps = {
	  component: 'section'
	};
	exports.default = CardText;
	//# sourceMappingURL=CardText.js.map

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardActionOverlay = exports.CardText = exports.CardActions = exports.CardMedia = exports.CardTitle = exports.Card = undefined;
	
	var _Card2 = __webpack_require__(555);
	
	var _Card3 = _interopRequireDefault(_Card2);
	
	var _CardTitle2 = __webpack_require__(262);
	
	var _CardTitle3 = _interopRequireDefault(_CardTitle2);
	
	var _CardMedia2 = __webpack_require__(557);
	
	var _CardMedia3 = _interopRequireDefault(_CardMedia2);
	
	var _CardActions2 = __webpack_require__(260);
	
	var _CardActions3 = _interopRequireDefault(_CardActions2);
	
	var _CardText2 = __webpack_require__(558);
	
	var _CardText3 = _interopRequireDefault(_CardText2);
	
	var _CardActionOverlay2 = __webpack_require__(556);
	
	var _CardActionOverlay3 = _interopRequireDefault(_CardActionOverlay2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Card3.default;
	exports.Card = _Card3.default;
	exports.CardTitle = _CardTitle3.default;
	exports.CardMedia = _CardMedia3.default;
	exports.CardActions = _CardActions3.default;
	exports.CardText = _CardText3.default;
	exports.CardActionOverlay = _CardActionOverlay3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _FontIcon = __webpack_require__(13);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Chip = function (_PureComponent) {
	  _inherits(Chip, _PureComponent);
	
	  function Chip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Chip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Chip.__proto__ || Object.getPrototypeOf(Chip)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this._handleMouseEnter = function (e) {
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(e);
	      }
	
	      _this.setState({ hover: true });
	    }, _this._handleMouseLeave = function (e) {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(e);
	      }
	
	      _this.setState({ hover: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Chip, [{
	    key: 'render',
	    value: function render() {
	      var hover = this.state.hover;
	
	      var _props = this.props,
	          label = _props.label,
	          className = _props.className,
	          labelStyle = _props.labelStyle,
	          labelClassName = _props.labelClassName,
	          avatar = _props.avatar,
	          children = _props.children,
	          removable = _props.removable,
	          remove = _props.remove,
	          onClick = _props.onClick,
	          rotateIcon = _props.rotateIcon,
	          iconClassName = _props.iconClassName,
	          removeIconChildren = _props.removeIconChildren,
	          removeIconClassName = _props.removeIconClassName,
	          props = _objectWithoutProperties(_props, ['label', 'className', 'labelStyle', 'labelClassName', 'avatar', 'children', 'removable', 'remove', 'onClick', 'rotateIcon', 'iconClassName', 'removeIconChildren', 'removeIconClassName']);
	
	      var icon = void 0;
	      if (removable || remove) {
	        var chipIconCN = (0, _classnames2.default)('md-chip-icon', {
	          'md-chip-icon--rotate': rotateIcon,
	          'md-chip-text--hover': hover
	        });
	
	        if (_react2.default.isValidElement(children)) {
	          icon = _react2.default.Children.only(children);
	          icon = _react2.default.cloneElement(icon, { className: (0, _classnames2.default)(chipIconCN, icon.props.className) });
	        } else {
	          icon = _react2.default.createElement(
	            _FontIcon2.default,
	            { className: chipIconCN, iconClassName: iconClassName },
	            children
	          );
	        }
	      }
	
	      return _react2.default.createElement(
	        'button',
	        _extends({
	          type: 'button'
	        }, props, {
	          className: (0, _classnames2.default)('md-chip', {
	            'md-chip--avatar': avatar,
	            'md-chip--remove': removable,
	            'md-chip--hover': hover
	          }, className),
	          onClick: remove || onClick,
	          onMouseEnter: this._handleMouseEnter,
	          onMouseLeave: this._handleMouseLeave
	        }),
	        avatar,
	        _react2.default.createElement(
	          'span',
	          {
	            style: labelStyle,
	            className: (0, _classnames2.default)('md-chip-text', {
	              'md-chip-text--hover': hover
	            }, labelClassName)
	          },
	          label
	        ),
	        icon
	      );
	    }
	  }]);
	
	  return Chip;
	}(_react.PureComponent);
	
	Chip.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the chip's label.
	   */
	  labelStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the chip's label.
	   */
	  labelClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the `.md-chip-icon--rotate` style should be applied to the remove icon.
	   * The `.md-chip-icon--rotate` just rotates the icon 45 degrees.
	   */
	  rotateIcon: _propTypes2.default.bool,
	
	  /**
	   * Any children used to display the remove icon when `removable`.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The label to display on the chip.
	   */
	  label: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the chip is removable.
	   */
	  removable: _propTypes2.default.bool,
	
	  /**
	   * An optional avatar to display on the chip.
	   */
	  avatar: _propTypes2.default.element,
	
	  /**
	   * An optional function to call when the `click` event is triggered.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseenter` event is triggered.
	   */
	  onMouseEnter: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseleave` event is triggered.
	   */
	  onMouseLeave: _propTypes2.default.func,
	
	  iconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `children` prop as a single FontIcon or SVGIcon instead'),
	  remove: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `removable` and `onClick` instead'),
	  removeIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `children` instead'),
	  removeIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `children` prop as a single FontIcon or SVGIcon instead')
	};
	Chip.defaultProps = {
	  rotateIcon: true,
	  children: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'add_circle'
	  )
	};
	exports.default = Chip;
	//# sourceMappingURL=Chip.js.map

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Chip = undefined;
	
	var _Chip2 = __webpack_require__(560);
	
	var _Chip3 = _interopRequireDefault(_Chip2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Chip3.default;
	exports.Chip = _Chip3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _requiredForA11yIfNot = __webpack_require__(683);
	
	var _requiredForA11yIfNot2 = _interopRequireDefault(_requiredForA11yIfNot);
	
	var _invalidIf = __webpack_require__(48);
	
	var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	var _FontIcon = __webpack_require__(13);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(21);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _contextTypes = __webpack_require__(106);
	
	var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `DataTable` component is used to manage the state of all rows.
	 * This can either be a __plain__ table or a __data__ table.
	 *
	 * A __data__ table will include checkboxes on each row while a __plain__ table
	 * will not.
	 */
	var DataTable = function (_PureComponent) {
	  _inherits(DataTable, _PureComponent);
	
	  function DataTable(props) {
	    _classCallCheck(this, DataTable);
	
	    var _this = _possibleConstructorReturn(this, (DataTable.__proto__ || Object.getPrototypeOf(DataTable)).call(this));
	
	    _initialiseProps.call(_this);
	
	    var rows = props.defaultSelectedRows;
	    _this.state = {
	      header: false,
	      indeterminate: props.indeterminate ? false : undefined,
	      allSelected: _this._allSelected(rows),
	      selectedRows: rows
	    };
	
	    _this._removed = 0;
	    _this._initial = true;
	    return _this;
	  }
	
	  _createClass(DataTable, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _props = this.props,
	          checkedIcon = _props.checkedIcon,
	          uncheckedIcon = _props.uncheckedIcon,
	          indeterminateIcon = _props.indeterminateIcon,
	          plain = _props.plain,
	          baseId = _props.baseId,
	          selectableRows = _props.selectableRows,
	          checkboxHeaderLabel = _props.checkboxHeaderLabel,
	          checkboxLabelTemplate = _props.checkboxLabelTemplate,
	          fixedHeader = _props.fixedHeader,
	          fixedFooter = _props.fixedFooter,
	          checkedIconChildren = _props.checkedIconChildren,
	          checkedIconClassName = _props.checkedIconClassName,
	          uncheckedIconChildren = _props.uncheckedIconChildren,
	          uncheckedIconClassName = _props.uncheckedIconClassName,
	          indeterminateIconChildren = _props.indeterminateIconChildren,
	          indeterminateIconClassName = _props.indeterminateIconClassName;
	
	
	      return {
	        checkedIcon: (0, _getDeprecatedIcon2.default)(checkedIconClassName, checkedIconChildren, checkedIcon),
	        uncheckedIcon: (0, _getDeprecatedIcon2.default)(uncheckedIconClassName, uncheckedIconChildren, uncheckedIcon),
	        indeterminateIcon: (0, _getDeprecatedIcon2.default)(indeterminateIconClassName, indeterminateIconChildren, indeterminateIcon),
	        indeterminate: this.state.indeterminate,
	        plain: plain,
	        allSelected: this.state.allSelected,
	        selectedRows: this.state.selectedRows,
	        toggleSelectedRow: this._toggleSelectedRow,
	        createCheckbox: this._createCheckbox,
	        removeCheckbox: this._removeCheckbox,
	        baseId: baseId,
	        baseName: baseId + '-control',
	        selectableRows: selectableRows,
	        checkboxHeaderLabel: checkboxHeaderLabel,
	        checkboxLabelTemplate: checkboxLabelTemplate,
	        fixedHeader: fixedHeader,
	        fixedFooter: fixedFooter
	      };
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._removed = 0;
	      this._initial = false;
	    }
	  }, {
	    key: '_allSelected',
	    value: function _allSelected(rows) {
	      var all = rows.length !== 0;
	      rows.some(function (checked) {
	        if (!checked) {
	          all = false;
	        }
	
	        return !all;
	      });
	
	      return all;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cn;
	
	      var _props2 = this.props,
	          style = _props2.style,
	          className = _props2.className,
	          tableStyle = _props2.tableStyle,
	          tableClassName = _props2.tableClassName,
	          fixedWrapperStyle = _props2.fixedWrapperStyle,
	          fixedWrapperClassName = _props2.fixedWrapperClassName,
	          fixedScrollWrapperStyle = _props2.fixedScrollWrapperStyle,
	          fixedScrollWrapperClassName = _props2.fixedScrollWrapperClassName,
	          children = _props2.children,
	          plain = _props2.plain,
	          responsive = _props2.responsive,
	          fixedHeader = _props2.fixedHeader,
	          fixedFooter = _props2.fixedFooter,
	          fixedDividers = _props2.fixedDividers,
	          fixedHeight = _props2.fixedHeight,
	          fixedWidth = _props2.fixedWidth,
	          headerHeight = _props2.headerHeight,
	          footerHeight = _props2.footerHeight,
	          fullWidth = _props2.fullWidth,
	          indeterminate = _props2.indeterminate,
	          indeterminateIcon = _props2.indeterminateIcon,
	          checkedIcon = _props2.checkedIcon,
	          uncheckedIcon = _props2.uncheckedIcon,
	          defaultSelectedRows = _props2.defaultSelectedRows,
	          baseId = _props2.baseId,
	          onRowToggle = _props2.onRowToggle,
	          selectableRows = _props2.selectableRows,
	          checkboxHeaderLabel = _props2.checkboxHeaderLabel,
	          checkboxLabelTemplate = _props2.checkboxLabelTemplate,
	          checkedIconChildren = _props2.checkedIconChildren,
	          checkedIconClassName = _props2.checkedIconClassName,
	          uncheckedIconChildren = _props2.uncheckedIconChildren,
	          uncheckedIconClassName = _props2.uncheckedIconClassName,
	          indeterminateIconChildren = _props2.indeterminateIconChildren,
	          indeterminateIconClassName = _props2.indeterminateIconClassName,
	          props = _objectWithoutProperties(_props2, ['style', 'className', 'tableStyle', 'tableClassName', 'fixedWrapperStyle', 'fixedWrapperClassName', 'fixedScrollWrapperStyle', 'fixedScrollWrapperClassName', 'children', 'plain', 'responsive', 'fixedHeader', 'fixedFooter', 'fixedDividers', 'fixedHeight', 'fixedWidth', 'headerHeight', 'footerHeight', 'fullWidth', 'indeterminate', 'indeterminateIcon', 'checkedIcon', 'uncheckedIcon', 'defaultSelectedRows', 'baseId', 'onRowToggle', 'selectableRows', 'checkboxHeaderLabel', 'checkboxLabelTemplate', 'checkedIconChildren', 'checkedIconClassName', 'uncheckedIconChildren', 'uncheckedIconClassName', 'indeterminateIconChildren', 'indeterminateIconClassName']);
	
	      var table = _react2.default.createElement(
	        'table',
	        _extends({}, props, {
	          ref: this._setTable,
	          style: responsive ? tableStyle : style,
	          className: (0, _classnames2.default)('md-data-table', (_cn = {
	            'md-data-table--plain': plain,
	            'md-data-table--full-width': fullWidth
	          }, _defineProperty(_cn, className, !responsive && className), _defineProperty(_cn, tableClassName, responsive && tableClassName), _cn))
	        }),
	        children
	      );
	
	      if (!responsive) {
	        return table;
	      }
	
	      var content = table;
	      if (fixedHeader || fixedFooter) {
	        var height = fixedHeight;
	        if (fixedHeight) {
	          if (fixedHeader) {
	            height -= headerHeight;
	          }
	
	          if (fixedFooter) {
	            height -= footerHeight;
	          }
	        }
	
	        var borderTop = fixedHeader;
	        var borderBot = fixedFooter;
	        if (typeof fixedDividers === 'boolean') {
	          borderTop = borderTop && fixedDividers;
	          borderBot = borderBot && fixedDividers;
	        } else {
	          borderTop = borderTop && (typeof fixedDividers.header === 'undefined' || fixedDividers.header);
	          borderBot = borderBot && (typeof fixedDividers.footer === 'undefined' || fixedDividers.footer);
	        }
	
	        content = _react2.default.createElement(
	          'div',
	          {
	            style: fixedWrapperStyle,
	            className: (0, _classnames2.default)('md-data-table__fixed-wrapper', {
	              'md-data-table__fixed-wrapper--header': fixedHeader,
	              'md-data-table__fixed-wrapper--footer': fixedFooter
	            }, fixedWrapperClassName)
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              style: _extends({ height: height }, fixedScrollWrapperStyle),
	              className: (0, _classnames2.default)('md-data-table__scroll-wrapper', {
	                'md-divider-border': fixedDividers,
	                'md-divider-border--top': borderTop,
	                'md-divider-border--bottom': borderBot
	              }, fixedScrollWrapperClassName)
	            },
	            table
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: _extends({ width: fixedWidth }, style),
	          className: (0, _classnames2.default)('md-data-table--responsive', {
	            'md-data-table--fixed': fixedHeader || fixedFooter
	          }, className)
	        },
	        content
	      );
	    }
	  }]);
	
	  return DataTable;
	}(_react.PureComponent);
	
	DataTable.propTypes = {
	  /**
	   * A base id to use for every checkbox or `EditDialogColumn` in the data table. This is
	   * required for a11y if the data table is not plain. It is recommended to always provide
	   * this prop if you are using any of the advanced table components to auto-generate unique
	   * ids for each element.
	   *
	   * @see {@link DataTables/EditDialogColumn}
	   * @see {@link DataTables/SelectFieldColumn}
	   * @see {@link DataTables/DropdownMenuColumn}
	   * @see {@link DataTables/MenuButtonColumn}
	   * @see {@link DataTables/TablePagination}
	   */
	  baseId: (0, _requiredForA11yIfNot2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]), 'plain'),
	
	  /**
	   * Optional style to apply to the table. If the table is `responsive`, this will be applied to the surrounding `div`
	   * instead of the table itself. Use the `tableStyle` in this case.
	   *
	   * @see {@link #tableStyle}
	   * @see {@link #responsive}
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the table. If the table is `responsive`, this will be applied to the
	   * surrounding `div` instead of the table itself. Use the `tableClassName` in this case.
	   *
	   * @see {@link #tableClassName}
	   * @see {@link #responsive}
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `table` itself when the `responsive` prop is enabled. If the table is not
	   * `responsive`, use the `style` prop.
	   *
	   * @see {@link #style}
	   * @see {@link #responsive}
	   */
	  tableStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `table` itself when the `responsive` prop is enabled. If the table is not
	   * `responsive`, use the `className` prop.
	   *
	   * @see {@link #className}
	   * @see {@link #responsive}
	   */
	  tableClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the fixed table wrapper that appears when there is a fixed
	   * header or a fixed footer.
	   *
	   * @see {@link #fixedHeader}
	   * @see {@link #fixedFooter}
	   * @see {@link #fixedWrapperClassName}
	   * @see {@link #fixedScrollWrapperStyle}
	   * @see {@link #fixedScrollWrapperClassName}
	   */
	  fixedWrapperStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the fixed table wrapper that appears when there is a fixed
	   * header or a fixed footer.
	   *
	   * @see {@link #fixedHeader}
	   * @see {@link #fixedFooter}
	   * @see {@link #fixedWrapperStyle}
	   * @see {@link #fixedScrollWrapperStyle}
	   * @see {@link #fixedScrollWrapperClassName}
	   */
	  fixedWrapperClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the fixed table wrapper's scroll container that appears when there is a fixed
	   * header or a fixed footer.
	   *
	   * @see {@link #fixedHeader}
	   * @see {@link #fixedFooter}
	   * @see {@link #fixedWrapperStyle}
	   * @see {@link #fixedWrapperClassName}
	   * @see {@link #fixedScrollWrapperStyle}
	   */
	  fixedScrollWrapperStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the fixed table wrapper's scroll container that appears when there is a fixed
	   * header or a fixed footer.
	   *
	   * @see {@link #fixedHeader}
	   * @see {@link #fixedFooter}
	   * @see {@link #fixedWrapperStyle}
	   * @see {@link #fixedWrapperClassName}
	   * @see {@link #fixedScrollWrapperStyle}
	   */
	  fixedScrollWrapperClassName: _propTypes2.default.string,
	
	  /**
	   * The table contents to display. This *should* be a list of `TableHeader` and `TableBody`
	   * components.
	   */
	  children: _propTypes2.default.node.isRequired,
	
	  /**
	   * An optional array of booleans denoting if a row is selected.
	   * This is an associative array so the index must match the row
	   * number in the `TableBody` component.
	   */
	  defaultSelectedRows: _propTypes2.default.arrayOf(_propTypes2.default.bool).isRequired,
	
	  /**
	   * Boolean if the table is responsive. This will wrap the table in a container
	   * that allows scrolling to the right if overflow exists.
	   */
	  responsive: _propTypes2.default.bool.isRequired,
	
	  /**
	   * Boolean if this table should not include the checkboxes on each row.
	   * This really means that the entire table is unselectable and you wish
	   * to display as a normal table.
	   */
	  plain: _propTypes2.default.bool,
	
	  /**
	   * The checked checkbox icon to display when a row is selected. This really defaults
	   * to the `checkedCheckboxIcon` prop from the `SelectionControl`.
	   *
	   * @see {@link SelectionControls/SelectionControl#checkedCheckboxIcon}
	   */
	  checkedIcon: _propTypes2.default.element,
	
	  /**
	   * The unchecked checkbox icon to display when a row is selected. This really defaults
	   * to the `uncheckedCheckboxIcon` prop from the `SelectionControl`.
	   *
	   * @see {@link SelectionControls/SelectionControl#uncheckedCheckboxIcon}
	   */
	  uncheckedIcon: _propTypes2.default.element,
	
	  /**
	   * An optional function to call when a non-plain data table has a row toggled. The callback
	   * will include:
	   * - the row id
	   * - boolean if the row is now checked
	   * - the total count of rows selected
	   * - the change event
	   *
	   * All rows will be toggled on or off when the row id is 0 and a `thead` exists in the table.
	   */
	  onRowToggle: (0, _invalidIf2.default)(_propTypes2.default.func, 'plain'),
	
	  /**
	   * Boolean if the `DataTable` should inject checkboxes at the start of each row.
	   */
	  selectableRows: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the checkboxes in the table should also include an _indeterminate_ state.
	   * It will use the `indeterminateIconChildren` and `indeterminateIconClassName` when at least
	   * 1 row has been checked, but not all rows.
	   */
	  indeterminate: _propTypes2.default.bool,
	
	  /**
	   * An optional icon to display when the selected state is indeterminate.
	   *
	   * @see {@link #indeterminate}
	   */
	  indeterminateIcon: _propTypes2.default.element,
	
	  /**
	   * This is the aria-label to apply to the checkbox in the table's header. This
	   * is just used for accessibility since the checkboxes have no visible label.
	   */
	  checkboxHeaderLabel: _propTypes2.default.string.isRequired,
	
	  /**
	   * This is the aria-label to apply to a checkbox in the table's body. This can either
	   * be a constant string that will replace `{{row}}` with the current row index, or
	   * a function that takes the row index and returns a string.
	   *
	   * ```js
	   * checkboxLabelTemplate={rowIndex => `Toggle row ${row}`}
	   * ```
	   */
	  checkboxLabelTemplate: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * Boolean if the table should include a fixed header. This will allow the `TableHeader` component
	   * to stay fixed to the top of the table while the `TableBody` scrolls horizontally.
	   *
	   * @see {@link #fixedFooter}
	   * @see [react-md-make-fixed-table](/components/data-tables?tab=2#mixin-react-md-make-fixed-table)
	   */
	  fixedHeader: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the table should include a fixed footer. This will allow the `TableFooter` component
	   * to stay fixed to the bottom of the table while the `TableBody` scrolls horizontally.
	   *
	   * @see {@link #fixedHeader}
	   * @see [react-md-make-fixed-table](/components/data-tables?tab=2#mixin-react-md-make-fixed-table)
	   */
	  fixedFooter: _propTypes2.default.bool,
	
	  /**
	   * Either a boolean or a shape of booleans for if a divider should appear at the top or bottom of the table
	   * when there is a fixed header/footer. By default, this will automatically create dividers.
	   *
	   * @see {@link #fixedHeader}
	   * @see {@link #fixedFooter}
	   */
	  fixedDividers: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
	    header: _propTypes2.default.bool,
	    footer: _propTypes2.default.bool
	  })]),
	
	  /**
	   * An optional height to set for a table with a fixed header and/or a fixed footer. It is recommended to use
	   * the related `react-md-make-fixed-table` mixin instead.
	   *
	   * @see {@link #headerHeight}
	   * @see {@link #footerHeight}
	   */
	  fixedHeight: _propTypes2.default.number,
	
	  /**
	   * An optional width to set for a table with a fixed header and/or a fixed footer. It is recommended to use
	   * the related `react-md-make-fixed-table` mixin instead.
	   */
	  fixedWidth: _propTypes2.default.number,
	
	  /**
	   * This is the height of the table's header columns. This should be equal to the `md-data-table-header-height`
	   * variable.
	   *
	   * @see [md-data-table-header-height](/components/data-tables?tab=2#variable-md-data-table-header-height)
	   * @see {@link #fixedHeight}
	   */
	  headerHeight: _propTypes2.default.number.isRequired,
	
	  /**
	   * This is the height of the table's header columns. This should be equal to the `md-data-table-header-height`
	   * variable.
	   *
	   * @see [md-data-table-column-height](/components/data-tables?tab=2#variable-md-data-table-column-height)
	   * @see {@link #fixedHeight}
	   */
	  footerHeight: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the `<table>` element should always span the entire width of its container.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  indeterminateIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `indeterminateIcon` prop instead'),
	  indeterminateIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `indeterminateIcon` prop instead'),
	  checkedIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `checkedIcon` prop instead'),
	  checkedIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `checkedIcon` prop instead'),
	  uncheckedIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `uncheckedIcon` prop instead'),
	  uncheckedIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `uncheckedIcon` prop instead')
	};
	DataTable.defaultProps = {
	  indeterminateIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'indeterminate_check_box'
	  ),
	  defaultSelectedRows: [],
	  responsive: true,
	  selectableRows: true,
	  checkboxHeaderLabel: 'Toggle All Rows',
	  checkboxLabelTemplate: 'Toggle row {{row}}',
	  fixedHeader: false,
	  fixedFooter: false,
	  fixedDividers: true,
	  headerHeight: 56,
	  footerHeight: 48,
	  fullWidth: true
	};
	DataTable.childContextTypes = _contextTypes2.default;
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._setTable = function (table) {
	    _this2._table = table;
	  };
	
	  this._createCheckbox = function (index) {
	    _this2.setState(function (state, props) {
	      var selectedRows = state.selectedRows.slice();
	      // Only use the default selected rows prop on first mount. If other changes occur after,
	      // default to false.
	      var selected = _this2._initial && props.defaultSelectedRows[index] || false;
	      selectedRows.splice(index, 0, selected);
	      return { selectedRows: selectedRows, allSelected: _this2._allSelected(selectedRows) };
	    });
	  };
	
	  this._removeCheckbox = function (index) {
	    _this2.setState(function (state) {
	      // When multiple checkboxes are removed in a render cycle, they are removed in list order.
	      // So to keep the index correct while removing, need to keep subtract the provided index by
	      // the current number of removed elements. This value gets reset to 0 after a finished cycle.
	      var selectedRows = state.selectedRows.slice();
	
	      // This is really ugly. React 16 doesn't need to track all this while React 15 does
	      if (_react2.default.version && _react2.default.version.match(/^16\./)) {
	        selectedRows.splice(index, 1);
	      } else {
	        selectedRows.splice(index - _this2._removed, 1);
	        _this2._removed += 1;
	      }
	      return { selectedRows: selectedRows, allSelected: _this2._allSelected(selectedRows) };
	    });
	  };
	
	  this._toggleSelectedRow = function (row, header, e) {
	    var selectedRows = void 0;
	    var allSelected = _this2.state.allSelected;
	    var selectedCount = 0;
	    var i = _this2._table && _this2._table.querySelector('.md-table-header') ? row - 1 : row;
	    var checked = e.target.checked;
	
	    if (header) {
	      selectedRows = _this2.state.selectedRows.map(function () {
	        return checked;
	      });
	      allSelected = checked;
	      selectedCount = !checked ? 0 : selectedRows.length;
	    } else {
	      selectedRows = _this2.state.selectedRows.slice();
	      selectedRows[i] = !selectedRows[i];
	      selectedCount = selectedRows.filter(function (b) {
	        return b;
	      }).length;
	      allSelected = selectedCount === selectedRows.length;
	    }
	
	    if (_this2.props.onRowToggle) {
	      _this2.props.onRowToggle(row, checked, selectedCount, e);
	    }
	
	    var indeterminate = _this2.props.indeterminate && !allSelected && selectedCount > 0;
	
	    _this2.setState({ selectedRows: selectedRows, allSelected: allSelected, indeterminate: indeterminate });
	  };
	};
	
	exports.default = DataTable;
	//# sourceMappingURL=DataTable.js.map

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _fixedToShape = __webpack_require__(22);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _withTableFixes = __webpack_require__(166);
	
	var _withTableFixes2 = _interopRequireDefault(_withTableFixes);
	
	var _DropdownMenu = __webpack_require__(173);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	var _TableColumn = __webpack_require__(60);
	
	var _TableColumn2 = _interopRequireDefault(_TableColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DropdownMenuColumn = function (_PureComponent) {
	  _inherits(DropdownMenuColumn, _PureComponent);
	
	  function DropdownMenuColumn() {
	    _classCallCheck(this, DropdownMenuColumn);
	
	    return _possibleConstructorReturn(this, (DropdownMenuColumn.__proto__ || Object.getPrototypeOf(DropdownMenuColumn)).apply(this, arguments));
	  }
	
	  _createClass(DropdownMenuColumn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          menuStyle = _props.menuStyle,
	          menuClassName = _props.menuClassName,
	          header = _props.header,
	          adjusted = _props.adjusted,
	          tooltipLabel = _props.tooltipLabel,
	          tooltipDelay = _props.tooltipDelay,
	          tooltipPosition = _props.tooltipPosition,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'menuStyle', 'menuClassName', 'header', 'adjusted', 'tooltipLabel', 'tooltipDelay', 'tooltipPosition']);
	
	      return _react2.default.createElement(
	        _TableColumn2.default,
	        {
	          style: style,
	          className: className,
	          header: header,
	          adjusted: adjusted,
	          tooltipLabel: tooltipLabel,
	          tooltipDelay: tooltipDelay,
	          tooltipPosition: tooltipPosition
	        },
	        _react2.default.createElement(_DropdownMenu2.default, _extends({}, props, { style: menuStyle, className: menuClassName }))
	      );
	    }
	  }]);
	
	  return DropdownMenuColumn;
	}(_react.PureComponent);
	
	DropdownMenuColumn.Positions = _DropdownMenu2.default.Positions;
	DropdownMenuColumn.HorizontalAnchors = _DropdownMenu2.default.HorizontalAnchors;
	DropdownMenuColumn.VerticalAnchors = _DropdownMenu2.default.VerticalAnchors;
	DropdownMenuColumn.propTypes = {
	  /**
	   * An optional id to use for the menu button in the column. If this is omitted, it's value will be
	   * `${rowId}-${cellIndex}-menu-button`
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * This is the optional style to apply to the `TableColumn`.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * This is the optional className to apply to the `TableColumn`.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The is the optional style to apply to the menu button's menu container.
	   *
	   * @see {@link Menus/DropdownMenu#style}
	   */
	  menuStyle: _propTypes2.default.object,
	
	  /**
	   * The is the optional class name to apply to the menu button's menu container.
	   *
	   * @see {@link Menus/DropdownMenu#className}
	   */
	  menuClassName: _propTypes2.default.string,
	
	  /**
	   * This is how the select field should be fixed within the table. When this is omitted,
	   * it will automatically use the responsive table as the fixture so that the select field
	   * will close/adjust itself to the scrolling of the table.
	   *
	   * @see {@link Helpers/Layover#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * The optional tooltip to render on hover.
	   *
	   * @see {@link DataTables/TableColumn#tooltipLabel}
	   */
	  tooltipLabel: _propTypes2.default.string,
	
	  /**
	   * An optional delay to apply to the tooltip before it appears.
	   *
	   * @see {@link DataTables/TableColumn#tooltipDelay}
	   */
	  tooltipDelay: _propTypes2.default.number,
	
	  /**
	   * The position of the tooltip.
	   *
	   * @see {@link DataTables/TableColumn#tooltipPosition}
	   */
	  tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu logic should be simplified without any viewport logic and position
	   * based on the relative position of the menu. This will most like require some additional
	   * styles applied to the menu.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedMenu: _propTypes2.default.bool,
	
	  /**
	   * This is injected by the `TableRow` component.
	   * @access private
	   */
	  header: _propTypes2.default.bool,
	
	  /**
	   * @access private
	   */
	  adjusted: _propTypes2.default.bool
	};
	DropdownMenuColumn.defaultProps = {
	  simplifiedMenu: false
	};
	exports.default = (0, _withTableFixes2.default)(DropdownMenuColumn, 'menu-button');
	//# sourceMappingURL=DropdownMenuColumn.js.map

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(12);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _AccessibleFakeButton = __webpack_require__(80);
	
	var _AccessibleFakeButton2 = _interopRequireDefault(_AccessibleFakeButton);
	
	var _Layover = __webpack_require__(109);
	
	var _Layover2 = _interopRequireDefault(_Layover);
	
	var _Dialog = __webpack_require__(167);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditDialog = function (_PureComponent) {
	  _inherits(EditDialog, _PureComponent);
	
	  function EditDialog() {
	    _classCallCheck(this, EditDialog);
	
	    return _possibleConstructorReturn(this, (EditDialog.__proto__ || Object.getPrototypeOf(EditDialog)).apply(this, arguments));
	  }
	
	  _createClass(EditDialog, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          dialogStyle = _props.dialogStyle,
	          dialogClassName = _props.dialogClassName,
	          dialogContentStyle = _props.dialogContentStyle,
	          dialogContentClassName = _props.dialogContentClassName,
	          textFieldId = _props.textFieldId,
	          visible = _props.visible,
	          header = _props.header,
	          onOpen = _props.onOpen,
	          children = _props.children,
	          label = _props.label,
	          title = _props.title,
	          large = _props.large,
	          actions = _props.actions,
	          placeholder = _props.placeholder,
	          dialogZDepth = _props.dialogZDepth,
	          props = _objectWithoutProperties(_props, ['id', 'dialogStyle', 'dialogClassName', 'dialogContentStyle', 'dialogContentClassName', 'textFieldId', 'visible', 'header', 'onOpen', 'children', 'label', 'title', 'large', 'actions', 'placeholder', 'dialogZDepth']);
	
	      var field = _react2.default.createElement(
	        _AccessibleFakeButton2.default,
	        {
	          className: (0, _classnames2.default)('md-edit-dialog__label', {
	            'md-edit-dialog__header': header
	          }, (0, _themeColors2.default)({ hint: placeholder || header })),
	          noFocusOutline: visible,
	          onClick: onOpen,
	          onFocus: onOpen
	        },
	        label
	      );
	
	      return _react2.default.createElement(
	        _Layover2.default,
	        _extends({}, props, {
	          id: id + '-layover',
	          toggle: field,
	          visible: visible,
	          block: true,
	          belowAnchor: null
	        }),
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            id: id,
	            'aria-labelledby': !large ? textFieldId : undefined,
	            style: dialogStyle,
	            className: (0, _classnames2.default)('md-edit-dialog', (0, _themeColors2.default)({ background: true, themeText: false }), dialogClassName),
	            contentStyle: dialogContentStyle,
	            contentClassName: (0, _classnames2.default)('md-edit-dialog__content', dialogContentClassName),
	            title: large ? title : null,
	            focusOnMount: true,
	            containFocus: !!large,
	            paddedContent: false,
	            actions: large ? actions : null,
	            zDepth: dialogZDepth
	          },
	          children
	        )
	      );
	    }
	  }]);
	
	  return EditDialog;
	}(_react.PureComponent);
	
	EditDialog.propTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  textFieldId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  dialogStyle: _propTypes2.default.object,
	  dialogClassName: _propTypes2.default.string,
	  dialogContentStyle: _propTypes2.default.object,
	  dialogContentClassName: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  onOpen: _propTypes2.default.func.isRequired,
	  onClose: _propTypes2.default.func.isRequired,
	  visible: _propTypes2.default.bool.isRequired,
	  label: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  placeholder: _propTypes2.default.bool,
	  title: _propTypes2.default.node,
	  large: _propTypes2.default.bool,
	  actions: _Dialog2.default.propTypes.actions,
	  dialogZDepth: _propTypes2.default.number,
	  header: _propTypes2.default.bool
	};
	exports.default = EditDialog;
	//# sourceMappingURL=EditDialog.js.map

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _keyCodes = __webpack_require__(15);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _themeColors = __webpack_require__(12);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _viewport = __webpack_require__(304);
	
	var _viewport2 = _interopRequireDefault(_viewport);
	
	var _controlled = __webpack_require__(16);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _anchorShape = __webpack_require__(38);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(22);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(39);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _Layover = __webpack_require__(109);
	
	var _Layover2 = _interopRequireDefault(_Layover);
	
	var _FontIcon = __webpack_require__(13);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(21);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _TextField = __webpack_require__(65);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _TableColumn = __webpack_require__(60);
	
	var _TableColumn2 = _interopRequireDefault(_TableColumn);
	
	var _EditDialog = __webpack_require__(564);
	
	var _EditDialog2 = _interopRequireDefault(_EditDialog);
	
	var _findTable = __webpack_require__(107);
	
	var _findTable2 = _interopRequireDefault(_findTable);
	
	var _findFixedTo = __webpack_require__(266);
	
	var _findFixedTo2 = _interopRequireDefault(_findFixedTo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `EditDialogColumn` is used when there should be used when a table column's value
	 * can be changed. It can either be displayed as a dialog or inline.
	 *
	 * All props that are not documented but provided will be passed on to the `TextField`
	 * component.
	 */
	var EditDialogColumn = function (_PureComponent) {
	  _inherits(EditDialogColumn, _PureComponent);
	
	  function EditDialogColumn(props) {
	    _classCallCheck(this, EditDialogColumn);
	
	    var _this = _possibleConstructorReturn(this, (EditDialogColumn.__proto__ || Object.getPrototypeOf(EditDialogColumn)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      visible: props.defaultVisible,
	      value: props.defaultValue,
	      cancelValue: props.defaultValue,
	      actions: _this._makeActions(props),
	      cellIndex: undefined
	    };
	    return _this;
	  }
	
	  _createClass(EditDialogColumn, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._column = (0, _reactDom.findDOMNode)(this);
	      this._table = (0, _findTable2.default)(this._column);
	      this._fixedTo = (0, _findFixedTo2.default)(this._table);
	
	      // If a developer creates their own component to wrap the EditDialogColumn, the cellIndex prop
	      // might not be defined if they don't pass ...props
	      var cellIndex = this.props.cellIndex;
	
	      if (!cellIndex && cellIndex !== 0) {
	        var columns = [].slice.call(this._column.parentNode.querySelectorAll('th,td'));
	        this.setState({ cellIndex: columns.indexOf(this._column) }); // eslint-disable-line react/no-did-mount-set-state
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          okLabel = _props.okLabel,
	          okPrimary = _props.okPrimary,
	          okSecondary = _props.okSecondary,
	          okProps = _props.okProps,
	          cancelLabel = _props.cancelLabel,
	          cancelPrimary = _props.cancelPrimary,
	          cancelSecondary = _props.cancelSecondary,
	          cancelProps = _props.cancelProps;
	
	
	      if (okLabel !== nextProps.okLabel || okPrimary !== nextProps.okPrimary || okSecondary !== nextProps.okSecondary || cancelLabel !== nextProps.cancelLabel || cancelPrimary !== nextProps.cancelPrimary || cancelSecondary !== nextProps.cancelSecondary || okProps !== nextProps.okProps || cancelProps !== nextProps.cancelProps) {
	        this.setState({ actions: this._makeActions(nextProps) });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var rowId = this.context.rowId;
	
	      var _props2 = this.props,
	          style = _props2.style,
	          className = _props2.className,
	          layoverStyle = _props2.layoverStyle,
	          layoverClassName = _props2.layoverClassName,
	          dialogStyle = _props2.dialogStyle,
	          dialogClassName = _props2.dialogClassName,
	          dialogContentStyle = _props2.dialogContentStyle,
	          dialogContentClassName = _props2.dialogContentClassName,
	          dialogZDepth = _props2.dialogZDepth,
	          textFieldStyle = _props2.textFieldStyle,
	          textFieldClassName = _props2.textFieldClassName,
	          inputClassName = _props2.inputClassName,
	          large = _props2.large,
	          title = _props2.title,
	          inline = _props2.inline,
	          inlineIcon = _props2.inlineIcon,
	          maxLength = _props2.maxLength,
	          label = _props2.label,
	          placeholder = _props2.placeholder,
	          header = _props2.header,
	          anchor = _props2.anchor,
	          belowAnchor = _props2.belowAnchor,
	          fixedTo = _props2.fixedTo,
	          animationPosition = _props2.animationPosition,
	          xThreshold = _props2.xThreshold,
	          yThreshold = _props2.yThreshold,
	          centered = _props2.centered,
	          sameWidth = _props2.sameWidth,
	          repositionOnScroll = _props2.repositionOnScroll,
	          repositionOnResize = _props2.repositionOnResize,
	          transitionName = _props2.transitionName,
	          transitionEnterTimeout = _props2.transitionEnterTimeout,
	          transitionLeaveTimeout = _props2.transitionLeaveTimeout,
	          tooltipLabel = _props2.tooltipLabel,
	          tooltipDelay = _props2.tooltipDelay,
	          tooltipPosition = _props2.tooltipPosition,
	          onClick = _props2.onClick,
	          onMouseDown = _props2.onMouseDown,
	          onMouseUp = _props2.onMouseUp,
	          onTouchStart = _props2.onTouchStart,
	          onTouchEnd = _props2.onTouchEnd,
	          onMouseEnter = _props2.onMouseEnter,
	          onMouseOver = _props2.onMouseOver,
	          onMouseLeave = _props2.onMouseLeave,
	          onTouchMove = _props2.onTouchMove,
	          simplifiedDialog = _props2.simplifiedDialog,
	          minLeft = _props2.minLeft,
	          minRight = _props2.minRight,
	          minBottom = _props2.minBottom,
	          noIcon = _props2.noIcon,
	          inlineIconChildren = _props2.inlineIconChildren,
	          inlineIconClassName = _props2.inlineIconClassName,
	          propId = _props2.id,
	          propDialogId = _props2.dialogId,
	          propCellIndex = _props2.cellIndex,
	          onOkClick = _props2.onOkClick,
	          okLabel = _props2.okLabel,
	          okPrimary = _props2.okPrimary,
	          okSecondary = _props2.okSecondary,
	          okProps = _props2.okProps,
	          onCancelClick = _props2.onCancelClick,
	          cancelLabel = _props2.cancelLabel,
	          cancelPrimary = _props2.cancelPrimary,
	          cancelSecondary = _props2.cancelSecondary,
	          cancelProps = _props2.cancelProps,
	          okOnOutsideClick = _props2.okOnOutsideClick,
	          defaultValue = _props2.defaultValue,
	          adjusted = _props2.adjusted,
	          scrollIntoView = _props2.scrollIntoView,
	          scrollIntoViewPadding = _props2.scrollIntoViewPadding,
	          defaultVisible = _props2.defaultVisible,
	          visibleOnFocus = _props2.visibleOnFocus,
	          scrollThreshold = _props2.scrollThreshold,
	          enforceMinWidth = _props2.enforceMinWidth,
	          transitionDuration = _props2.transitionDuration,
	          props = _objectWithoutProperties(_props2, ['style', 'className', 'layoverStyle', 'layoverClassName', 'dialogStyle', 'dialogClassName', 'dialogContentStyle', 'dialogContentClassName', 'dialogZDepth', 'textFieldStyle', 'textFieldClassName', 'inputClassName', 'large', 'title', 'inline', 'inlineIcon', 'maxLength', 'label', 'placeholder', 'header', 'anchor', 'belowAnchor', 'fixedTo', 'animationPosition', 'xThreshold', 'yThreshold', 'centered', 'sameWidth', 'repositionOnScroll', 'repositionOnResize', 'transitionName', 'transitionEnterTimeout', 'transitionLeaveTimeout', 'tooltipLabel', 'tooltipDelay', 'tooltipPosition', 'onClick', 'onMouseDown', 'onMouseUp', 'onTouchStart', 'onTouchEnd', 'onMouseEnter', 'onMouseOver', 'onMouseLeave', 'onTouchMove', 'simplifiedDialog', 'minLeft', 'minRight', 'minBottom', 'noIcon', 'inlineIconChildren', 'inlineIconClassName', 'id', 'dialogId', 'cellIndex', 'onOkClick', 'okLabel', 'okPrimary', 'okSecondary', 'okProps', 'onCancelClick', 'cancelLabel', 'cancelPrimary', 'cancelSecondary', 'cancelProps', 'okOnOutsideClick', 'defaultValue', 'adjusted', 'scrollIntoView', 'scrollIntoViewPadding', 'defaultVisible', 'visibleOnFocus', 'scrollThreshold', 'enforceMinWidth', 'transitionDuration']);
	
	      var _state = this.state,
	          visible = _state.visible,
	          actions = _state.actions;
	
	      var value = (0, _getField2.default)(this.props, this.state, 'value');
	      var cellIndex = (0, _getField2.default)(this.props, this.state, 'cellIndex');
	
	      var _props3 = this.props,
	          id = _props3.id,
	          dialogId = _props3.dialogId;
	
	      if (!dialogId) {
	        dialogId = (id || rowId + '-' + cellIndex) + '-edit-dialog';
	      }
	
	      if (!id) {
	        id = dialogId + '-field';
	      }
	
	      var inlineEditIcon = void 0;
	      if (inline && !noIcon) {
	        var icon = (0, _getDeprecatedIcon2.default)(inlineIconClassName, inlineIconChildren, inlineIcon);
	        if (icon) {
	          inlineEditIcon = _react2.default.cloneElement(icon, { key: 'edit-icon' });
	        }
	      }
	
	      var numeric = props.type === 'number';
	      var field = _react2.default.createElement(_TextField2.default, _extends({}, props, {
	        ref: this._setField,
	        style: textFieldStyle,
	        className: (0, _classnames2.default)({ 'md-edit-dialog__blocked-field': inline }, textFieldClassName),
	        inputClassName: (0, _classnames2.default)({
	          'md-edit-dialog__header': header && inline,
	          'md-text-right': numeric
	        }, (0, _themeColors2.default)({ hint: header && inline }), inputClassName),
	        id: id,
	        label: label,
	        placeholder: placeholder,
	        value: value,
	        onFocus: this._handleFocus,
	        onChange: this._handleChange,
	        onKeyDown: this._handleKeyDown,
	        block: inline,
	        maxLength: visible ? maxLength : null,
	        rightIcon: inlineEditIcon
	      }));
	
	      var children = void 0;
	      if (inline) {
	        children = field;
	      } else {
	        var dialogLabel = value || value === 0 ? value : placeholder || label;
	        children = _react2.default.createElement(
	          _EditDialog2.default,
	          {
	            style: layoverStyle,
	            className: layoverClassName,
	            dialogStyle: dialogStyle,
	            dialogClassName: dialogClassName,
	            dialogContentStyle: dialogContentStyle,
	            dialogContentClassName: dialogContentClassName,
	            id: dialogId,
	            textFieldId: id,
	            visible: visible,
	            onOpen: this._handleOpen,
	            onClose: this._handleClose,
	            label: dialogLabel,
	            actions: actions,
	            large: large,
	            title: title,
	            header: header,
	            placeholder: dialogLabel === placeholder || dialogLabel === label,
	            simplified: simplifiedDialog,
	            anchor: anchor,
	            belowAnchor: belowAnchor,
	            animationPosition: animationPosition,
	            xThreshold: xThreshold,
	            yThreshold: yThreshold,
	            centered: centered,
	            sameWidth: sameWidth,
	            minLeft: minLeft,
	            minRight: minRight,
	            minBottom: minBottom,
	            fixedTo: typeof fixedTo !== 'undefined' ? fixedTo : this._fixedTo,
	            dialogZDepth: dialogZDepth,
	            repositionOnScroll: repositionOnScroll,
	            repositionOnResize: repositionOnResize,
	            transitionName: transitionName,
	            transitionEnterTimeout: transitionEnterTimeout,
	            transitionLeaveTimeout: transitionLeaveTimeout
	          },
	          field
	        );
	      }
	
	      return _react2.default.createElement(
	        _TableColumn2.default,
	        {
	          style: style,
	          numeric: numeric,
	          className: (0, _classnames2.default)('md-edit-dialog-column', className),
	          header: header,
	          adjusted: false,
	          tooltipLabel: tooltipLabel,
	          tooltipDelay: tooltipDelay,
	          tooltipPosition: tooltipPosition,
	          onClick: onClick,
	          onMouseDown: onMouseDown,
	          onMouseUp: onMouseUp,
	          onTouchStart: onTouchStart,
	          onTouchMove: onTouchMove,
	          onMouseEnter: onMouseEnter,
	          onMouseOver: onMouseOver,
	          onMouseLeave: onMouseLeave,
	          onTouchEnd: onTouchEnd
	        },
	        children
	      );
	    }
	  }]);
	
	  return EditDialogColumn;
	}(_react.PureComponent);
	
	EditDialogColumn.VerticalAnchors = _Layover2.default.VerticalAnchors;
	EditDialogColumn.HorizontalAnchors = _Layover2.default.HorizontalAnchors;
	EditDialogColumn.Positions = _Layover2.default.Positions;
	EditDialogColumn.propTypes = {
	  /**
	   * An optional id to use for the text field in the column. If this is omitted,
	   * the id will be `${dialogId}-field`.
	   *
	   * @see {@link #dialogId}
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to use for the dialog that appears in the column. If this is omitted,
	   * the id will be `${rowId}-${cellIndex}-edit-dialog-field`.
	   */
	  dialogId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * The optional style to apply to the edit dialog's column.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * The optional className to apply to the edit dialog's column.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the dialog's surrounding `Layover` component.
	   */
	  layoverStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to the dialog's surrounding `Layover` component.
	   */
	  layoverClassName: _propTypes2.default.string,
	
	  /**
	   * The optional style to apply to the edit dialog.
	   */
	  dialogStyle: _propTypes2.default.object,
	
	  /**
	   * The optional className to apply to the edit dialog.
	   */
	  dialogClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the dialog's content area. This is the area
	   * that holds the text field.
	   */
	  dialogContentStyle: _propTypes2.default.object,
	
	  /**
	   * An optional class name to apply to the dialog's content area. This is the area
	   * that holds the text field.
	   */
	  dialogContentClassName: _propTypes2.default.string,
	
	  /**
	   * The zDepth to apply to the dialog when not inline.
	   *
	   * @see {@link Papers/Paper#zDepth}
	   */
	  dialogZDepth: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional style to apply to the text field.
	   */
	  textFieldStyle: _propTypes2.default.object,
	
	  /**
	   * An optional class name to apply to the text field.
	   */
	  textFieldClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the text field's input.
	   */
	  inputStyle: _propTypes2.default.object,
	
	  /**
	   * An optional class name to apply to the text field's input.
	   */
	  inputClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the edit dialog is currently disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the text field should be editable inline instead of in a dialog.
	   *
	   * @see {@link #inlineIcon}
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * An optional icon to set for the inline edit dialog column. Setting this prop to null
	   * will not render an icon.
	   */
	  inlineIcon: _propTypes2.default.element,
	
	  /**
	   * The default value to use for the text field.
	   */
	  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	
	  /**
	   * A value to use for the edit dialog text field. This will make the component controlled
	   * so you will need to provide an `onChange` function.
	   */
	  value: (0, _controlled2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]), 'onChange', 'defaultValue'),
	
	  /**
	   * An optional function to call when the text field's value has changed. This is required
	   * if the `value` prop has been defined.
	   *
	   * @see {@link TextFields/TextField#onChange}
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field gains focus.
	   */
	  onFocus: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the keydown event is triggered on the text field.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional label for the text field. When displaying an `inline` edit dialog column,
	   * the `placeholder` prop should be used instead. This is because the text field changes
	   * to the `block` type when `inline`.
	   *
	   * @see {@link #inline}
	   * @see {@link #placeholder}
	   * @see {@link TextFields/TextField#block}
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * An optional placeholder for the text field.
	   */
	  placeholder: _propTypes2.default.string,
	
	  /**
	   * Boolean if the edit dialog should become a large dialog. When the dialog is large,
	   * the `title` prop is required.
	   *
	   * A large dialog has a Title followed by the text field, and then a cancel and ok action
	   * buttons below.
	   */
	  large: _propTypes2.default.bool,
	
	  /**
	   * The title to use for the large edit dialog. This prop is required if the `large` prop
	   * is enabled.
	   */
	  title: _propTypes2.default.node,
	
	  /**
	   * An optional `maxLength` to apply to the text field.
	   *
	   * @see {@link TextFields/TextField#maxLength}
	   */
	  maxLength: _propTypes2.default.number,
	
	  /**
	   * An optional function to call when the "Ok" button has been clicked, the user presses enter
	   * on * the text field or when the `okOnOutsideClick` prop has been enabled and the user clicks
	   * somewhere on the page.
	   *
	   * The callback will include the current value and the click or keypress event.
	   * ```js
	   * onOkClick(value, event)
	   * ```
	   *
	   * @see {@link #large}
	   */
	  onOkClick: _propTypes2.default.func,
	
	  /**
	   * The label to use for the "Ok" button in large dialogs.
	   *
	   * @see {@link #large}
	   */
	  okLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the "Ok" button in large dialogs should be styled with the primary color.
	   * To get a `default` styled button, set both `okPrimary` and `okSecondary` (or omit `okSecondary`)
	   * to `false`.
	   *
	   * @see {@link #large}
	   * @see {@link #okSecondary}
	   */
	  okPrimary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the "Ok" button in large dialogs should be styled with the secondary color.
	   *
	   * @see {@link #large}
	   * @see {@link #okPrimary}
	   */
	  okSecondary: _propTypes2.default.bool,
	
	  /**
	   * Any additional props to apply to the "Ok" button. This will override any of the other
	   * button props.
	   *
	   * @see {@link #okLabel}
	   * @see {@link #okPrimary}
	   * @see {@link #okSecondary}
	   */
	  okProps: _propTypes2.default.object,
	
	  /**
	   * An optional function to call when the "Cancel" button has been clicked in large edit dialogs.
	   * The callback will include the text field's value before any edits occurred and the click event.
	   *
	   * ```js
	   * onCancelClick(previousValue, event)
	   * ```
	   *
	   * @see {@link #large}
	   */
	  onCancelClick: _propTypes2.default.func,
	
	  /**
	   * The label to give to the "Cancel" button in large edit dialogs.
	   *
	   * @see {@link #large}
	   */
	  cancelLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the "Cancel" button in large dialogs should be styled with the primary color.
	   * To get a `default` styled button, set both `cancelPrimary` and `cancelSecondary` (or
	   * omit `cancelSecondary`) to `false`.
	   *
	   * @see {@link #large}
	   * @see {@link #cancelSecondary}
	   */
	  cancelPrimary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the "Cancel" button in large dialogs should be styled with the secondary color.
	   *
	   * @see {@link #large}
	   * @see {@link #cancelPrimary}
	   */
	  cancelSecondary: _propTypes2.default.bool,
	
	  /**
	   * Any additional props to apply to the "Cancel" button. This will override any of the other
	   * button props.
	   *
	   * @see {@link #cancelLabel}
	   * @see {@link #cancelPrimary}
	   * @see {@link #cancelSecondary}
	   */
	  cancelProps: _propTypes2.default.object,
	
	  /**
	   * Boolean if the action for clicking somewhere on on the page while the dialog is open
	   * saves the changes or cancels to the previous value before opening the dialog.
	   *
	   * @see {@link #onOkClick}
	   * @see {@link #onCancelClick}
	   */
	  okOnOutsideClick: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when a user clicks out of the text field.
	   */
	  onOutsideClick: _propTypes2.default.func,
	
	  /**
	   * Boolean if the edit dialog should be closed if the user clicks somewhere else on the page
	   * while the dialog is open.
	   */
	  closeOnOutsideClick: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the Edit Dialog should be visible by default. This only applies when the `inline` prop
	   * is not enabled.
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the edit dialog should automatically open when the text field is focused for non-inline
	   * dialogs. This is enabled by default for backwards compatibility.
	   */
	  visibleOnFocus: _propTypes2.default.bool,
	
	  /**
	   * The type for the text field in the edit dialog.
	   *
	   * @see {@link TextFields/TextField#type}
	   */
	  type: _propTypes2.default.string,
	
	  /**
	   * This is how the dialog gets "anchored" to the table column.
	   *
	   * @see {@link Helpers/Layover#anchor}
	   */
	  anchor: _anchorShape2.default,
	
	  /**
	   * This is the anchor to use when the `position` is set to `Autocomplete.Positions.BELOW`.
	   *
	   * @see {@link Helpers/Layover#belowAnchor}
	   */
	  belowAnchor: _anchorShape2.default,
	
	  /**
	   * This is the animation position to use for the dialog.
	   *
	   * @see {@link Helpers/Layover#animationPosition}
	   */
	  animationPosition: _positionShape2.default,
	
	  /**
	   * This is how the dialog should be fixed within the table. When this is omitted, it will
	   * automatically use the responsive table as the fixture so that the dialog will close/adjust itself
	   * to the scrolling of the table.
	   *
	   * @see {@link Helpers/Layover#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * @see {@link Helpers/Layover#xThreshold}
	   */
	  xThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#yThreshold}
	   */
	  yThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#centered}
	   */
	  centered: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#sameWidth}
	   */
	  sameWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#transitionName}
	   */
	  transitionName: _propTypes2.default.string,
	
	  /**
	   * @see {@link Helpers/Layover#transitionEnterTimeout}
	   */
	  transitionEnterTimeout: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#transitionLeaveTimeout}
	   */
	  transitionLeaveTimeout: _propTypes2.default.number,
	
	  /**
	   * The optional tooltip to render on hover.
	   */
	  tooltipLabel: _propTypes2.default.node,
	
	  /**
	   * An optional delay to apply to the tooltip before it appears.
	   */
	  tooltipDelay: _propTypes2.default.number,
	
	  /**
	   * The position of the tooltip.
	   */
	  tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog logic should be simplified without any viewport logic and position
	   * based on the relative position of the menu. This will most like require some additional
	   * styles applied to the dialog.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedDialog: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#minLeft}
	   */
	  minLeft: _Layover2.default.propTypes.minLeft,
	
	  /**
	   * @see {@link Helpers/Layover#minRight}
	   */
	  minRight: _Layover2.default.propTypes.minLeft,
	
	  /**
	   * @see {@link Helpers/Layover#minBottom}
	   */
	  minBottom: _Layover2.default.propTypes.minBottom,
	
	  /**
	   * Boolean if the edit dialog should attempt to scroll into view if the full
	   * dialog can not be displayed in the viewport when it was toggled open.
	   *
	   * @see {@link #scrollIntoViewPadding}
	   */
	  scrollIntoView: _propTypes2.default.bool,
	
	  /**
	   * The amount of padding that should be applied when the cell is scrolled into view.
	   * This will be applied to the left of the cell.
	   */
	  scrollIntoViewPadding: _propTypes2.default.number,
	
	  /**
	   * An optional function to call when the `click` event is triggered in the column.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mousedown` event is triggered in the column.
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseup` event is triggered in the column.
	   */
	  onMouseUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `touchstart` event is triggered in the column.
	   */
	  onTouchStart: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `touchend` event is triggered in the column.
	   */
	  onTouchEnd: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseenter` event is triggered in the column.
	   */
	  onMouseEnter: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseover` event is triggered in the column.
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseleave` event is triggered in the column.
	   */
	  onMouseLeave: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `touchmove` event is triggered in the column.
	   */
	  onTouchMove: _propTypes2.default.func,
	
	  /**
	   * This is injected by the `TableRow` component.
	   * @access private
	   */
	  header: _propTypes2.default.bool,
	
	  /**
	   * This is injected by the `TableRow` component and used to help generate the unique id for the text
	   * field.
	   *
	   * @access private
	   */
	  cellIndex: _propTypes2.default.number,
	
	  /**
	   * @access private
	   */
	  adjusted: _propTypes2.default.bool,
	
	  inlineIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `inlineIcon` prop instead'),
	  inlineIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `inlineIcon` prop instead'),
	  noIcon: (0, _deprecated2.default)(_propTypes2.default.bool, 'Set the `inlineIcon` prop to `null` instead'),
	  enforceMinWidth: (0, _deprecated2.default)(_propTypes2.default.bool, 'The min width will always be enforced based on the `$md-edit-dialog-min-width` Sass variable.'),
	  scrollThreshold: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `xThreshold` and `yThreshold` instead'),
	  transitionDuration: (0, _deprecated2.default)(_propTypes2.default.number, 'use `transitionEnterTimeout` and `transitionLeaveTimeout` instead')
	};
	EditDialogColumn.defaultProps = {
	  type: 'text',
	  defaultValue: '',
	  okOnOutsideClick: true,
	  inlineIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'edit'
	  ),
	  okLabel: 'Save',
	  okPrimary: true,
	  cancelLabel: 'Cancel',
	  cancelPrimary: true,
	  animationPosition: EditDialogColumn.Positions.BELOW,
	  dialogZDepth: 1,
	  repositionOnScroll: true,
	  repositionOnResize: false,
	  scrollIntoView: true,
	  scrollIntoViewPadding: 16,
	  minLeft: 0,
	  minRight: 0,
	  minBottom: 0,
	  visibleOnFocus: true,
	  defaultVisible: false
	};
	EditDialogColumn.contextTypes = {
	  rowId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._setField = function (field) {
	    _this2._field = field;
	  };
	
	  this._makeActions = function (props) {
	    var okLabel = props.okLabel,
	        okPrimary = props.okPrimary,
	        okSecondary = props.okSecondary,
	        okProps = props.okProps,
	        cancelLabel = props.cancelLabel,
	        cancelPrimary = props.cancelPrimary,
	        cancelSecondary = props.cancelSecondary,
	        cancelProps = props.cancelProps;
	
	
	    return [_extends({
	      key: 'cancel',
	      children: cancelLabel,
	      primary: cancelPrimary && !cancelSecondary,
	      secondary: cancelSecondary
	    }, cancelProps, {
	      onClick: _this2._handleCancel
	    }), _extends({
	      key: 'ok',
	      children: okLabel,
	      primary: okPrimary && !okSecondary,
	      secondary: okSecondary
	    }, okProps, {
	      onClick: _this2._handleOk
	    })];
	  };
	
	  this._handleOpen = function (e) {
	    if (_this2._skipNextOpen) {
	      _this2._skipNextOpen = false;
	    } else if (_this2.props.visibleOnFocus || !e || e.type !== 'focus') {
	      var _props4 = _this2.props,
	          scrollIntoView = _props4.scrollIntoView,
	          scrollIntoViewPadding = _props4.scrollIntoViewPadding;
	
	      if (scrollIntoView) {
	        var vp = (0, _viewport2.default)(_this2._column);
	        if (vp !== true && _this2._table && _this2._column && !_this2.props.inline) {
	          _this2._table.scrollLeft = _this2._column.offsetLeft - scrollIntoViewPadding;
	        }
	      }
	
	      _this2.setState({ visible: true, cancelValue: (0, _getField2.default)(_this2.props, _this2.state, 'value') });
	    }
	  };
	
	  this._handleClose = function (e) {
	    var _props5 = _this2.props,
	        onOutsideClick = _props5.onOutsideClick,
	        okOnOutsideClick = _props5.okOnOutsideClick;
	
	    if (onOutsideClick) {
	      onOutsideClick(e);
	    }
	
	    if (okOnOutsideClick) {
	      _this2._handleOk(e);
	    } else {
	      _this2._handleCancel(e);
	    }
	  };
	
	  this._handleChange = function (value, e) {
	    if (_this2.props.onChange) {
	      _this2.props.onChange(value, e);
	    }
	
	    if (typeof _this2.props.value === 'undefined') {
	      _this2.setState({ value: value });
	    }
	  };
	
	  this._handleFocus = function (e) {
	    if (_this2.props.onFocus) {
	      _this2.props.onFocus(e);
	    }
	
	    if (_this2.props.inline) {
	      _this2.setState({ cancelValue: e.target.value });
	    }
	  };
	
	  this._handleKeyDown = function (e) {
	    var _props6 = _this2.props,
	        onKeyDown = _props6.onKeyDown,
	        okOnOutsideClick = _props6.okOnOutsideClick,
	        large = _props6.large;
	
	    if (onKeyDown) {
	      onKeyDown(e);
	    }
	
	    var key = e.which || e.keyCode;
	    if (key === _keyCodes.ENTER) {
	      _this2._handleOk(e);
	    } else if (key === _keyCodes.ESC) {
	      _this2._handleCancel(e);
	    } else if (key === _keyCodes.TAB && !large) {
	      // infinitely opens otherwise...
	      _this2._skipNextOpen = e.shiftKey;
	
	      if (okOnOutsideClick) {
	        _this2._handleOk(e);
	      } else {
	        _this2._handleCancel(e);
	      }
	    }
	  };
	
	  this._handleOk = function (e) {
	    if (_this2.props.onOkClick) {
	      _this2.props.onOkClick((0, _getField2.default)(_this2.props, _this2.state, 'value'), e);
	    }
	
	    _this2.setState({ visible: false });
	  };
	
	  this._handleCancel = function (e) {
	    var value = _this2.state.cancelValue;
	    if (_this2.props.onCancelClick) {
	      _this2.props.onCancelClick(value, e);
	    }
	
	    var state = { visible: false };
	    if (typeof _this2.props.value === 'undefined') {
	      state.value = value;
	    }
	
	    _this2.setState(state);
	  };
	};
	
	exports.default = EditDialogColumn;
	//# sourceMappingURL=EditDialogColumn.js.map

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _fixedToShape = __webpack_require__(22);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _withTableFixes = __webpack_require__(166);
	
	var _withTableFixes2 = _interopRequireDefault(_withTableFixes);
	
	var _MenuButton = __webpack_require__(280);
	
	var _MenuButton2 = _interopRequireDefault(_MenuButton);
	
	var _TableColumn = __webpack_require__(60);
	
	var _TableColumn2 = _interopRequireDefault(_TableColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MenuButtonColumn = function (_PureComponent) {
	  _inherits(MenuButtonColumn, _PureComponent);
	
	  function MenuButtonColumn() {
	    _classCallCheck(this, MenuButtonColumn);
	
	    return _possibleConstructorReturn(this, (MenuButtonColumn.__proto__ || Object.getPrototypeOf(MenuButtonColumn)).apply(this, arguments));
	  }
	
	  _createClass(MenuButtonColumn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          menuStyle = _props.menuStyle,
	          menuClassName = _props.menuClassName,
	          header = _props.header,
	          adjusted = _props.adjusted,
	          tooltipLabel = _props.tooltipLabel,
	          tooltipDelay = _props.tooltipDelay,
	          tooltipPosition = _props.tooltipPosition,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'menuStyle', 'menuClassName', 'header', 'adjusted', 'tooltipLabel', 'tooltipDelay', 'tooltipPosition']);
	
	      return _react2.default.createElement(
	        _TableColumn2.default,
	        {
	          style: style,
	          className: className,
	          header: header,
	          adjusted: adjusted,
	          tooltipLabel: tooltipLabel,
	          tooltipDelay: tooltipDelay,
	          tooltipPosition: tooltipPosition
	        },
	        _react2.default.createElement(_MenuButton2.default, _extends({}, props, { style: menuStyle, className: menuClassName }))
	      );
	    }
	  }]);
	
	  return MenuButtonColumn;
	}(_react.PureComponent);
	
	MenuButtonColumn.Positions = _MenuButton2.default.Positions;
	MenuButtonColumn.HorizontalAnchors = _MenuButton2.default.HorizontalAnchors;
	MenuButtonColumn.VerticalAnchors = _MenuButton2.default.VerticalAnchors;
	MenuButtonColumn.propTypes = {
	  /**
	   * An optional id to use for the menu button in the column. If this is omitted, it's value will be
	   * `${rowId}-${cellIndex}-menu-button`
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * This is the optional style to apply to the `TableColumn`.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * This is the optional className to apply to the `TableColumn`.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The is the optional style to apply to the menu button's menu container.
	   *
	   * @see {@link Menus/MenuButton#style}
	   */
	  menuStyle: _propTypes2.default.object,
	
	  /**
	   * The is the optional class name to apply to the menu button's menu container.
	   *
	   * @see {@link Menus/MenuButton#className}
	   */
	  menuClassName: _propTypes2.default.string,
	
	  /**
	   * This is how the select field should be fixed within the table. When this is omitted,
	   * it will automatically use the responsive table as the fixture so that the select field
	   * will close/adjust itself to the scrolling of the table.
	   *
	   * @see {@link Helpers/Layover#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * The optional tooltip to render on hover.
	   *
	   * @see {@link DataTables/TableColumn#tooltipLabel}
	   */
	  tooltipLabel: _propTypes2.default.string,
	
	  /**
	   * An optional delay to apply to the tooltip before it appears.
	   *
	   * @see {@link DataTables/TableColumn#tooltipDelay}
	   */
	  tooltipDelay: _propTypes2.default.number,
	
	  /**
	   * The position of the tooltip.
	   *
	   * @see {@link DataTables/TableColumn#tooltipPosition}
	   */
	  tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu logic should be simplified without any viewport logic and position
	   * based on the relative position of the menu. This will most like require some additional
	   * styles applied to the menu.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedMenu: _propTypes2.default.bool,
	
	  /**
	   * This is injected by the `TableRow` component.
	   * @access private
	   */
	  header: _propTypes2.default.bool,
	
	  /**
	   * @access private
	   */
	  adjusted: _propTypes2.default.bool
	};
	MenuButtonColumn.defaultProps = {
	  simplifiedMenu: false
	};
	exports.default = (0, _withTableFixes2.default)(MenuButtonColumn, 'menu-button');
	//# sourceMappingURL=MenuButtonColumn.js.map

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _fixedToShape = __webpack_require__(22);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(39);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _SelectField = __webpack_require__(175);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _withTableFixes = __webpack_require__(166);
	
	var _withTableFixes2 = _interopRequireDefault(_withTableFixes);
	
	var _TableColumn = __webpack_require__(60);
	
	var _TableColumn2 = _interopRequireDefault(_TableColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `SelectFieldColumn` component is just a simple wrapper between a `SelectField` and
	 * the `TableColumn` components.
	 *
	 * All props that are on the `SelectField` are also available here (except the naming of style or className).
	 * See the [SelectField](/components/select-fields?tab=1#select-field-proptypes) for remaining prop descriptions.
	 */
	var SelectFieldColumn = function (_PureComponent) {
	  _inherits(SelectFieldColumn, _PureComponent);
	
	  function SelectFieldColumn() {
	    _classCallCheck(this, SelectFieldColumn);
	
	    return _possibleConstructorReturn(this, (SelectFieldColumn.__proto__ || Object.getPrototypeOf(SelectFieldColumn)).apply(this, arguments));
	  }
	
	  _createClass(SelectFieldColumn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          menuStyle = _props.menuStyle,
	          menuClassName = _props.menuClassName,
	          header = _props.header,
	          tooltipLabel = _props.tooltipLabel,
	          tooltipDelay = _props.tooltipDelay,
	          tooltipPosition = _props.tooltipPosition,
	          adjusted = _props.adjusted,
	          wrapperStyle = _props.wrapperStyle,
	          wrapperClassName = _props.wrapperClassName,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'menuStyle', 'menuClassName', 'header', 'tooltipLabel', 'tooltipDelay', 'tooltipPosition', 'adjusted', 'wrapperStyle', 'wrapperClassName']);
	
	      return _react2.default.createElement(
	        _TableColumn2.default,
	        {
	          header: header,
	          style: style,
	          className: (0, _classnames2.default)('md-select-field-column', className),
	          adjusted: false,
	          tooltipLabel: tooltipLabel,
	          tooltipDelay: tooltipDelay,
	          tooltipPosition: tooltipPosition
	        },
	        _react2.default.createElement(_SelectField2.default, _extends({}, props, { style: menuStyle, className: menuClassName }))
	      );
	    }
	  }]);
	
	  return SelectFieldColumn;
	}(_react.PureComponent);
	
	SelectFieldColumn.VerticalAnchors = _SelectField2.default.VerticalAnchors;
	SelectFieldColumn.HorizontalAnchors = _SelectField2.default.HorizontalAnchors;
	SelectFieldColumn.Positions = _SelectField2.default.Positions;
	SelectFieldColumn.propTypes = {
	  /**
	   * An optional id to use for the select field in the column. If this is omitted, it's value will be
	   * `${rowId}-${cellIndex}-select-field`
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * This is the optional style to apply to the `TableColumn`.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * This is the optional className to apply to the `TableColumn`.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The is the optional style to apply to the select field's menu container.
	   *
	   * @see {@link SelectFields/SelectField#style}
	   */
	  menuStyle: _propTypes2.default.object,
	
	  /**
	   * The is the optional class name to apply to the select field's menu container.
	   *
	   * @see {@link SelectFields/SelectField#className}
	   */
	  menuClassName: _propTypes2.default.string,
	
	  /**
	   * This is how the select field should be fixed within the table. When this is omitted,
	   * it will automatically use the responsive table as the fixture so that the select field
	   * will close/adjust itself to the scrolling of the table.
	   *
	   * @see {@link Helpers/Layover#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * Boolean if the select field should span the entire width of the column.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * The position for the select field.
	   *
	   * @see {@link SelectFields/SelectField#position}
	   */
	  position: _positionShape2.default,
	
	  /**
	   * This is injected by the `TableRow` component.
	   * @access private
	   */
	  header: _propTypes2.default.bool,
	
	  /**
	   * @access private
	   */
	  adjusted: _propTypes2.default.bool,
	
	  /**
	   * The optional tooltip to render on hover.
	   *
	   * @see {@link DataTables/TableColumn#tooltipLabel}
	   */
	  tooltipLabel: _propTypes2.default.string,
	
	  /**
	   * An optional delay to apply to the tooltip before it appears.
	   *
	   * @see {@link DataTables/TableColumn#tooltipDelay}
	   */
	  tooltipDelay: _propTypes2.default.number,
	
	  /**
	   * The position of the tooltip.
	   *
	   * @see {@link DataTables/TableColumn#tooltipPosition}
	   */
	  tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu logic should be simplified without any viewport logic and position
	   * based on the relative position of the menu. This will most like require some additional
	   * styles applied to the menu.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedMenu: _propTypes2.default.bool,
	
	  wrapperStyle: (0, _deprecated2.default)(_propTypes2.default.object, 'There is no longer a wrapper'),
	  wrapperClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'There is no longer a wrapper')
	};
	SelectFieldColumn.defaultProps = {
	  position: SelectFieldColumn.Positions.BELOW,
	  fullWidth: true,
	  repositionOnScroll: true,
	  repositionOnResize: false,
	  simplifiedMenu: false
	};
	exports.default = (0, _withTableFixes2.default)(SelectFieldColumn, 'select-field');
	//# sourceMappingURL=SelectFieldColumn.js.map

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _contextTypes = __webpack_require__(106);
	
	var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TableBody` component is used for managing the state of all
	 * `TableRow` inside of it.
	 */
	var TableBody = function (_Component) {
	  _inherits(TableBody, _Component);
	
	  function TableBody() {
	    _classCallCheck(this, TableBody);
	
	    return _possibleConstructorReturn(this, (TableBody.__proto__ || Object.getPrototypeOf(TableBody)).apply(this, arguments));
	  }
	
	  _createClass(TableBody, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['children', 'className']);
	
	      var selectedRows = this.context.selectedRows;
	
	
	      var rows = children ? _react.Children.map(_react.Children.toArray(children), function (row, i) {
	        var uncontrolled = typeof row.props.selected === 'undefined';
	        return _react2.default.cloneElement(row, {
	          selected: uncontrolled ? selectedRows[i] : row.props.selected
	        });
	      }) : null;
	
	      return _react2.default.createElement(
	        'tbody',
	        _extends({}, props, { className: (0, _classnames2.default)('md-table-body', className) }),
	        rows
	      );
	    }
	  }]);
	
	  return TableBody;
	}(_react.Component);
	
	TableBody.propTypes = {
	  /**
	   * An optional style to apply to the tbody.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the tbody.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * A list or a single item of `TableRow` components to render.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)])
	};
	TableBody.contextTypes = _contextTypes2.default;
	exports.default = TableBody;
	//# sourceMappingURL=TableBody.js.map

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CSSTransitionGroup = __webpack_require__(49);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CSSTransitionGroupTick = __webpack_require__(34);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	var _oneRequired = __webpack_require__(305);
	
	var _oneRequired2 = _interopRequireDefault(_oneRequired);
	
	var _invalidIf = __webpack_require__(48);
	
	var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	var _CardTitleBlock = __webpack_require__(263);
	
	var _CardTitleBlock2 = _interopRequireDefault(_CardTitleBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TableCardHeader` is used when contextual actions should appear when
	 * a user selects a row.
	 */
	var TableCardHeader = function (_PureComponent) {
	  _inherits(TableCardHeader, _PureComponent);
	
	  function TableCardHeader(props) {
	    _classCallCheck(this, TableCardHeader);
	
	    var _this = _possibleConstructorReturn(this, (TableCardHeader.__proto__ || Object.getPrototypeOf(TableCardHeader)).call(this, props));
	
	    _this.state = { animating: false };
	    return _this;
	  }
	
	  _createClass(TableCardHeader, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var visible = this.props.visible;
	      var nVisible = nextProps.visible,
	          transitionEnterTimeout = nextProps.transitionEnterTimeout,
	          transitionLeaveTimeout = nextProps.transitionLeaveTimeout;
	
	      var timeout = !nVisible ? transitionLeaveTimeout : transitionEnterTimeout;
	      if (visible !== nVisible) {
	        if (this._timeout) {
	          clearTimeout(this._timeout);
	        }
	
	        this._timeout = setTimeout(function () {
	          _this2._timeout = setTimeout(function () {
	            _this2._timeout = null;
	            _this2.setState({ animating: false });
	          }, timeout);
	        }, _CSSTransitionGroupTick2.default);
	
	        if (!this.state.animating) {
	          this.setState({ animating: true });
	        }
	      }
	    }
	  }, {
	    key: '_cloneCellRight',
	    value: function _cloneCellRight(noAdjust, children) {
	      if (noAdjust || !children) {
	        return children;
	      }
	
	      return _react.Children.map(_react.Children.toArray(children), function (child, i) {
	        if (i === 0) {
	          return (0, _react.cloneElement)(child, { className: (0, _classnames2.default)('md-cell--right', child.props.className) });
	        }
	
	        return child;
	      });
	    }
	  }, {
	    key: '_cloneLeftChildren',
	    value: function _cloneLeftChildren(noClone, children) {
	      if (noClone || !children) {
	        return children;
	      }
	
	      return _react.Children.map(_react.Children.toArray(children), function (child) {
	        return (0, _react.cloneElement)(child, {
	          className: (0, _classnames2.default)('md-btn--dialog', child.props.className)
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var animating = this.state.animating;
	
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          title = _props.title,
	          titleId = _props.titleId,
	          actions = _props.actions,
	          contextualTitleId = _props.contextualTitleId,
	          contextualChildren = _props.contextualChildren,
	          noActionsAdjust = _props.noActionsAdjust,
	          noChildrenAdjust = _props.noChildrenAdjust,
	          noLeftChildrenClone = _props.noLeftChildrenClone,
	          visible = _props.visible,
	          propChildren = _props.children,
	          propLeftChildren = _props.leftChildren,
	          propContextualTitle = _props.contextualTitle,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'title', 'titleId', 'actions', 'contextualTitleId', 'contextualChildren', 'noActionsAdjust', 'noChildrenAdjust', 'noLeftChildrenClone', 'visible', 'children', 'leftChildren', 'contextualTitle']);
	
	      var _props2 = this.props,
	          children = _props2.children,
	          leftChildren = _props2.leftChildren,
	          contextualTitle = _props2.contextualTitle;
	
	      children = this._cloneCellRight(noChildrenAdjust, children);
	      leftChildren = this._cloneLeftChildren(noLeftChildrenClone, leftChildren);
	
	      if (title) {
	        children = _react2.default.createElement(
	          'div',
	          { className: 'md-card-title', key: 'main-title' },
	          _react2.default.createElement(_CardTitleBlock2.default, { id: titleId, title: title }),
	          children
	        );
	      } else if (leftChildren) {
	        leftChildren = _react.Children.toArray(leftChildren);
	
	        if (children) {
	          children = leftChildren.concat(_react.Children.toArray(children));
	        } else {
	          children = leftChildren;
	        }
	      }
	
	      if (contextualTitle) {
	        contextualTitle = _react2.default.createElement(
	          'h2',
	          {
	            id: contextualTitleId,
	            className: 'md-card-title--title md-card-title--title-contextual',
	            tabIndex: contextualTitleId ? -1 : null
	          },
	          contextualTitle
	        );
	      }
	
	      var contextualHeader = _react2.default.createElement(
	        'div',
	        { key: 'contextual-header', className: 'md-card-title md-card-title--contextual' },
	        contextualTitle,
	        contextualChildren,
	        this._cloneCellRight(noActionsAdjust, actions)
	      );
	
	      var mergedStyles = style;
	      if (animating) {
	        mergedStyles = Object.assign({}, style, { overflow: 'hidden' });
	      }
	
	      return _react2.default.createElement(
	        _CSSTransitionGroup2.default,
	        _extends({}, props, {
	          style: mergedStyles,
	          className: (0, _classnames2.default)('md-table-card-header', {
	            'md-table-card-header--no-title': !title
	          }, className)
	        }),
	        children,
	        visible ? contextualHeader : null
	      );
	    }
	  }]);
	
	  return TableCardHeader;
	}(_react.PureComponent);
	
	TableCardHeader.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The component to render as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * The transition name to use when the contextual header appears.
	   */
	  transitionName: _propTypes2.default.string.isRequired,
	
	  /**
	   * The transition time to use when the contextual header appears.
	   */
	  transitionEnterTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * The transition time to use when the contextual header disappears.
	   */
	  transitionLeaveTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional title to display. It is invalid to have both `title` and `leftChildren`
	   * defined as only one will be used.
	   */
	  title: (0, _oneRequired2.default)(_propTypes2.default.node, 'leftChildren', 'children'),
	
	  /**
	   * An optional id to provide to the title.
	   */
	  titleId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional title to display in the contextual header. This will get wrapped in an `h2`
	   * tag and additional styles applied.
	   */
	  contextualTitle: _propTypes2.default.node,
	
	  /**
	   * An optional id to provide to the contextual title.
	   */
	  contextualTitleId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * Any additional children to display in the contextual header. This will be displayed after
	   * the optional `contextualTile` and before the `actions`.
	   */
	  contextualChildren: _propTypes2.default.node,
	
	  /**
	   * An optional button or list of buttons to display instead of a title.
	   */
	  leftChildren: (0, _invalidIf2.default)(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]), 'title'),
	
	  /**
	   * An additional children to display after the `title` or `leftChildren` prop.
	   * This is _normally_ a list of icon button or menu button.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]),
	
	  /**
	   * An optional button/menu button or a list of button/menu button to display in the
	   * contextual header once the user has selected a row or multiple rows.
	   */
	  actions: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]),
	
	  /**
	   * Boolean if the `actions` prop should not have each element cloned with additional
	   * class names.
	   */
	  noActionsAdjust: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `children` prop should not have each element cloned with additional
	   * class names.
	   */
	  noChildrenAdjust: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `leftChildren` prop should not have each element cloned with additional
	   * class names.
	   */
	  noLeftChildrenClone: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the contextual header is currently visible.
	   */
	  visible: _propTypes2.default.bool.isRequired
	};
	TableCardHeader.defaultProps = {
	  component: 'header',
	  transitionName: 'md-drop-down',
	  transitionEnterTimeout: 150,
	  transitionLeaveTimeout: 150
	};
	exports.default = TableCardHeader;
	//# sourceMappingURL=TableCardHeader.js.map

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SelectionControl = __webpack_require__(64);
	
	var _SelectionControl2 = _interopRequireDefault(_SelectionControl);
	
	var _findTable = __webpack_require__(107);
	
	var _findTable2 = _interopRequireDefault(_findTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableCheckbox = function (_Component) {
	  _inherits(TableCheckbox, _Component);
	
	  function TableCheckbox() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TableCheckbox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableCheckbox.__proto__ || Object.getPrototypeOf(TableCheckbox)).call.apply(_ref, [this].concat(args))), _this), _this._td = null, _this._header = false, _this._handleMount = function (td) {
	      if (td) {
	        var header = (0, _findTable2.default)(td).querySelector('thead');
	        var index = td.parentNode.rowIndex - (header ? 1 : 0);
	
	        if (td.parentNode.parentNode.tagName === 'TBODY') {
	          _this.context.createCheckbox(index);
	        }
	        _this._td = td;
	        _this._header = header;
	      } else if (_this._td) {
	        var _index = _this._td.parentNode.rowIndex;
	        _this.context.removeCheckbox(_index - (_this._header ? 1 : 0));
	        _this._td = null;
	        _this._header = false;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TableCheckbox, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          checked = _props.checked,
	          index = _props.index,
	          props = _objectWithoutProperties(_props, ['checked', 'index']);
	
	      var _context = this.context,
	          checkedIcon = _context.checkedIcon,
	          uncheckedIcon = _context.uncheckedIcon,
	          indeterminateIcon = _context.indeterminateIcon,
	          indeterminate = _context.indeterminate,
	          header = _context.header,
	          footer = _context.footer,
	          rowId = _context.rowId,
	          baseName = _context.baseName,
	          checkboxHeaderLabel = _context.checkboxHeaderLabel,
	          checkboxLabelTemplate = _context.checkboxLabelTemplate;
	
	
	      var Cell = header ? 'th' : 'td';
	      var label = void 0;
	      if (header) {
	        label = checkboxHeaderLabel;
	      } else if (typeof checkboxLabelTemplate === 'function') {
	        label = checkboxLabelTemplate(index);
	      } else {
	        label = checkboxLabelTemplate.replace(/{{row}}/g, index);
	      }
	
	      var content = _react2.default.createElement(_SelectionControl2.default, _extends({}, props, {
	        id: rowId,
	        name: baseName + '-checkbox',
	        type: 'checkbox',
	        checked: checked,
	        checkedCheckboxIcon: checkedIcon,
	        uncheckedCheckboxIcon: header && indeterminate ? indeterminateIcon : uncheckedIcon,
	        'aria-label': label
	      }));
	      var fixedHeader = header && this.context.fixedHeader;
	      var fixedFooter = footer && this.context.fixedFooter;
	
	      if (fixedHeader) {
	        content = _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)('md-table-column__fixed', {
	              'md-table-column__fixed--header': fixedHeader,
	              'md-table-column__fixed--footer': fixedFooter
	            })
	          },
	          _react2.default.cloneElement(content, {
	            className: (0, _classnames2.default)({
	              'md-table-checkbox--header': header,
	              'md-table-checkbox--footer': footer
	            })
	          })
	        );
	      }
	
	      return _react2.default.createElement(
	        Cell,
	        {
	          className: (0, _classnames2.default)('md-table-checkbox', {
	            'md-table-column--fixed': fixedHeader
	          }),
	          scope: header ? 'col' : undefined,
	          ref: this._handleMount
	        },
	        content
	      );
	    }
	  }]);
	
	  return TableCheckbox;
	}(_react.Component);
	
	TableCheckbox.propTypes = {
	  index: _propTypes2.default.number,
	  checked: _propTypes2.default.bool
	};
	TableCheckbox.contextTypes = {
	  rowId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  baseName: _propTypes2.default.string.isRequired,
	  indeterminate: _propTypes2.default.bool,
	  checkedIcon: _propTypes2.default.element,
	  uncheckedIcon: _propTypes2.default.element,
	  indeterminateIcon: _propTypes2.default.element,
	  checkboxHeaderLabel: _propTypes2.default.string.isRequired,
	  checkboxLabelTemplate: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	  createCheckbox: _propTypes2.default.func.isRequired,
	  removeCheckbox: _propTypes2.default.func.isRequired,
	  header: _propTypes2.default.bool,
	  footer: _propTypes2.default.bool,
	  fixedHeader: _propTypes2.default.bool.isRequired,
	  fixedFooter: _propTypes2.default.bool.isRequired
	};
	exports.default = TableCheckbox;
	//# sourceMappingURL=TableCheckbox.js.map

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _contextTypes = __webpack_require__(106);
	
	var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	var _headerContextTypes = __webpack_require__(165);
	
	var _headerContextTypes2 = _interopRequireDefault(_headerContextTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A `thead` component to use in the `DataTable` component. This
	 * will automatically update the header row to check if it is selected
	 * and inject a function to toggle all rows selected if the row is
	 * uncontrolled. It will also automatically attempt to set the `TableColumn`
	 * components to be the header type.
	 */
	var TableHeader = function (_Component) {
	  _inherits(TableHeader, _Component);
	
	  function TableHeader() {
	    _classCallCheck(this, TableHeader);
	
	    return _possibleConstructorReturn(this, (TableHeader.__proto__ || Object.getPrototypeOf(TableHeader)).apply(this, arguments));
	  }
	
	  _createClass(TableHeader, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return _extends({}, this.context, {
	        header: true
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['className', 'children']);
	
	      var allSelected = this.context.allSelected;
	
	      var header = _react2.default.Children.only(children);
	      var selected = typeof header.props.selected === 'undefined' ? allSelected : header.props.selected;
	
	      var row = _react2.default.cloneElement(header, { selected: selected });
	
	      return _react2.default.createElement(
	        'thead',
	        _extends({}, props, { className: (0, _classnames2.default)('md-table-header', className) }),
	        row
	      );
	    }
	  }]);
	
	  return TableHeader;
	}(_react.Component);
	
	TableHeader.contextTypes = _contextTypes2.default;
	TableHeader.childContextTypes = _headerContextTypes2.default;
	TableHeader.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the table header
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * This should be a single `TableRow` component. The `custom` validation will
	   * warn you if there are more than one children given or none at all.
	   */
	  children: function children(props, propName, component) {
	    try {
	      _react2.default.Children.only(props.children);
	      return null;
	    } catch (e) {
	      var amt = props.children ? props.children.length : 0;
	      return new Error('There must only be one child in a \'' + component + '\', but ' + amt + ' were given.');
	    }
	  }
	};
	exports.default = TableHeader;
	//# sourceMappingURL=TableHeader.js.map

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _ResizeObserver = __webpack_require__(32);
	
	var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);
	
	var _SelectField = __webpack_require__(175);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _Button = __webpack_require__(19);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FontIcon = __webpack_require__(13);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(21);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _findTable = __webpack_require__(107);
	
	var _findTable2 = _interopRequireDefault(_findTable);
	
	var _TableFooter = __webpack_require__(265);
	
	var _TableFooter2 = _interopRequireDefault(_TableFooter);
	
	var _TableColumn = __webpack_require__(60);
	
	var _TableColumn2 = _interopRequireDefault(_TableColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TablePagination` component is used to generate the table footer that helps
	 * pagination through a large dataset by limiting the number of rows per page.
	 * The pagination will always be placed persistently at the bottom of the table
	 * so that when a user scrolls to the right, they will always be able to use the
	 * pagination.
	 */
	var TablePagination = function (_PureComponent) {
	  _inherits(TablePagination, _PureComponent);
	
	  function TablePagination(props, context) {
	    _classCallCheck(this, TablePagination);
	
	    var _this = _possibleConstructorReturn(this, (TablePagination.__proto__ || Object.getPrototypeOf(TablePagination)).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var controlledPage = typeof props.page !== 'undefined';
	    var controlledRowsPerPage = typeof props.rowsPerPage !== 'undefined';
	    var rowsPerPage = controlledRowsPerPage ? props.rowsPerPage : props.defaultRowsPerPage;
	    var page = controlledPage ? props.page : props.defaultPage;
	    _this.state = {
	      start: (page - 1) * rowsPerPage,
	      controlsMarginLeft: 0
	    };
	
	    if (!controlledPage) {
	      _this.state.page = page;
	    }
	
	    if (!controlledRowsPerPage) {
	      _this.state.rowsPerPage = props.defaultRowsPerPage;
	    }
	
	    _this._table = null;
	    _this._ticking = false;
	    return _this;
	  }
	
	  _createClass(TablePagination, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          rowsPerPage = _props.rowsPerPage,
	          page = _props.page;
	
	      if (page !== nextProps.page || rowsPerPage !== nextProps.rowsPerPage) {
	        var rpp = (0, _getField2.default)(nextProps, this.state, 'rowsPerPage');
	        var p = (0, _getField2.default)(nextProps, this.state, 'page');
	
	        this.setState({ start: (p - 1) * rpp });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          controlsMarginLeft = _state.controlsMarginLeft,
	          start = _state.start;
	
	      var _props2 = this.props,
	          className = _props2.className,
	          selectFieldStyle = _props2.selectFieldStyle,
	          selectFieldClassName = _props2.selectFieldClassName,
	          selectFieldInputStyle = _props2.selectFieldInputStyle,
	          selectFieldInputClassName = _props2.selectFieldInputClassName,
	          rows = _props2.rows,
	          rowsPerPageLabel = _props2.rowsPerPageLabel,
	          rowsPerPageItems = _props2.rowsPerPageItems,
	          incrementIcon = _props2.incrementIcon,
	          decrementIcon = _props2.decrementIcon,
	          simplifiedMenu = _props2.simplifiedMenu,
	          incrementIconChildren = _props2.incrementIconChildren,
	          incrementIconClassName = _props2.incrementIconClassName,
	          decrementIconChildren = _props2.decrementIconChildren,
	          decrementIconClassName = _props2.decrementIconClassName,
	          propId = _props2.id,
	          propIncrementId = _props2.incrementId,
	          propDecrementId = _props2.decrementId,
	          onPagination = _props2.onPagination,
	          propRowsPerPage = _props2.rowsPerPage,
	          propPage = _props2.page,
	          defaultPage = _props2.defaultPage,
	          defaultRowsPerPage = _props2.defaultRowsPerPage,
	          props = _objectWithoutProperties(_props2, ['className', 'selectFieldStyle', 'selectFieldClassName', 'selectFieldInputStyle', 'selectFieldInputClassName', 'rows', 'rowsPerPageLabel', 'rowsPerPageItems', 'incrementIcon', 'decrementIcon', 'simplifiedMenu', 'incrementIconChildren', 'incrementIconClassName', 'decrementIconChildren', 'decrementIconClassName', 'id', 'incrementId', 'decrementId', 'onPagination', 'rowsPerPage', 'page', 'defaultPage', 'defaultRowsPerPage']);
	
	      var baseId = this.context.baseId;
	
	      var rowsPerPage = (0, _getField2.default)(this.props, this.state, 'rowsPerPage');
	      var _props3 = this.props,
	          id = _props3.id,
	          incrementId = _props3.incrementId,
	          decrementId = _props3.decrementId;
	
	      if (!id) {
	        id = baseId + '-pagination';
	      }
	
	      if (!incrementId) {
	        incrementId = id + '-increment-btn';
	      }
	
	      if (!decrementId) {
	        decrementId = id + '-decrement-btn';
	      }
	
	      var pagination = start + 1 + '-' + Math.min(rows, start + rowsPerPage) + ' of ' + rows;
	      return _react2.default.createElement(
	        _TableFooter2.default,
	        _extends({}, props, { className: (0, _classnames2.default)('md-table-footer--pagination', className) }),
	        _react2.default.createElement(_ResizeObserver2.default, { watchWidth: true, component: 'tr', onResize: this._throttledPosition }),
	        _react2.default.createElement(_ResizeObserver2.default, { watchWidth: true, component: 'tr', target: this._table, onResize: this._throttledPosition }),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            _TableColumn2.default,
	            { colSpan: '100%' },
	            _react2.default.createElement(
	              'div',
	              {
	                ref: this._setControls,
	                className: 'md-table-pagination md-table-pagination--controls md-text',
	                style: { marginLeft: controlsMarginLeft }
	              },
	              _react2.default.createElement(
	                'span',
	                { className: 'md-table-pagination__label' },
	                rowsPerPageLabel
	              ),
	              _react2.default.createElement(_SelectField2.default, {
	                id: id,
	                menuItems: rowsPerPageItems,
	                position: _SelectField2.default.Positions.BELOW,
	                style: selectFieldStyle,
	                className: selectFieldClassName,
	                inputStyle: selectFieldInputStyle,
	                inputClassName: (0, _classnames2.default)('md-select-field--pagination', selectFieldInputClassName),
	                value: rowsPerPage,
	                onChange: this._setRowsPerPage,
	                simplifiedMenu: simplifiedMenu
	              }),
	              _react2.default.createElement(
	                'span',
	                { className: 'md-table-pagination--label' },
	                pagination
	              ),
	              _react2.default.createElement(_Button2.default, {
	                id: decrementId,
	                icon: true,
	                onClick: this._decrement,
	                disabled: start === 0,
	                iconEl: (0, _getDeprecatedIcon2.default)(decrementIconClassName, decrementIconChildren, decrementIcon)
	              }),
	              _react2.default.createElement(_Button2.default, {
	                id: incrementId,
	                icon: true,
	                onClick: this._increment,
	                disabled: start + rowsPerPage >= rows,
	                iconEl: (0, _getDeprecatedIcon2.default)(incrementIconClassName, incrementIconChildren, incrementIcon)
	              })
	            ),
	            _react2.default.createElement('div', { className: 'md-table-pagination' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return TablePagination;
	}(_react.PureComponent);
	
	TablePagination.propTypes = {
	  /**
	   * An optional id to provide to the select field. If this is omitted, it will be
	   * the `DataTable`'s `baseId` with '-pagination'.
	   *
	   * @see {@link DataTables/DataTable#baseId}
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the increment icon button. If this is omitted, it will be
	   * the `id` with '-increment-btn'.
	   *
	   * @see {@link #id}
	   */
	  incrementId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the decrement icon button. If this is omitted, it will be
	   * the `id` with '-decrement-btn'.
	   *
	   * @see {@link #id}
	   */
	  decrementId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the `tfoot` tag.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `tfoot` tag.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the select field.
	   *
	   * @see {@link SelectFields/SelectField#style}
	   */
	  selectFieldStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the select field.
	   *
	   * @see {@link SelectFields/SelectField#className}
	   */
	  selectFieldClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the select field's input.
	   *
	   * @see {@link SelectFields/SelectField#inputStyle}
	   */
	  selectFieldInputStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the select field's input.
	   *
	   * @see {@link SelectFields/SelectField#inputClassName}
	   */
	  selectFieldInputClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the select field should use the simplified menu logic.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedMenu: _propTypes2.default.bool,
	
	  /**
	   * A function to call when a user clicks the increment or decrement pagination
	   * icon button. This function will be given the new start index and the number
	   * or rows per page as well as the current page.
	   *
	   * ```js
	   * onPagination(newStart, rowsPerPage, currentPage);
	   * ```
	   */
	  onPagination: _propTypes2.default.func.isRequired,
	
	  /**
	   * The current value for the select field holding the number of rows per page.
	   */
	  rowsPerPage: _propTypes2.default.number,
	
	  /**
	   * The current page for the pagination. This will make the component controlled, so the only way to get pagination
	   * is making sure you are updating this prop after the `onPagination` callback is called.
	   *
	   * Pages start from 1 instead of 0.
	   */
	  page: _propTypes2.default.number,
	
	  /**
	   * The default page to start from for the pagination. Pages start from 1 instead of 0.
	   */
	  defaultPage: _propTypes2.default.number.isRequired,
	
	  /**
	   * The default number of rows per page to display. This will be the value for the
	   * `SelectField`.
	   */
	  defaultRowsPerPage: _propTypes2.default.number.isRequired,
	
	  /**
	   * The label to use for the rows per page `SelectField`.
	   */
	  rowsPerPageLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * A list of numbers for the amount of rows per page to display at a time.
	   * This will be rendered into the `SelectField`.
	   */
	  rowsPerPageItems: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
	
	  /**
	   * The total number of rows that can be displayed. This is the unfiltered/non-subset
	   * number of rows. This is used to help calculate the increment/decrement values to
	   * display and determine if the user can increment/decrement again.
	   */
	  rows: _propTypes2.default.number.isRequired,
	
	  /**
	   * The icon to use for the increment icon button.
	   */
	  incrementIcon: _propTypes2.default.element,
	
	  /**
	   * The icon to use for the decrement icon button.
	   */
	  decrementIcon: _propTypes2.default.element,
	
	  incrementIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `incrementIcon` prop instead'),
	  incrementIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `incrementIcon` prop instead'),
	  decrementIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `decrementIcon` prop instead'),
	  decrementIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `decrementIcon` prop instead')
	};
	TablePagination.contextTypes = {
	  baseId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  fixedFooter: _propTypes2.default.bool
	};
	TablePagination.defaultProps = {
	  defaultPage: 1,
	  defaultRowsPerPage: 10,
	  rowsPerPageLabel: 'Rows per page:',
	  rowsPerPageItems: [10, 20, 30, 40, 50, 100],
	  incrementIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'keyboard_arrow_right'
	  ),
	  decrementIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'keyboard_arrow_left'
	  ),
	  simplifiedMenu: false
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._setControls = function (controls) {
	    _this2._controls = controls;
	    _this2._table = (0, _findTable2.default)(controls);
	
	    if (_this2._table && _this2.context.fixedFooter) {
	      _this2._table.addEventListener('scroll', _this2._throttledPosition);
	    }
	  };
	
	  this._position = function () {
	    if (_this2._table) {
	      var fixedFooter = _this2.context.fixedFooter;
	      var _table = _this2._table,
	          offsetWidth = _table.offsetWidth,
	          scrollLeft = _table.scrollLeft;
	
	
	      var controlsMarginLeft = offsetWidth - _this2._controls.offsetWidth;
	      if (fixedFooter) {
	        controlsMarginLeft += scrollLeft;
	      }
	
	      _this2.setState({
	        controlsMarginLeft: Math.max(24, controlsMarginLeft)
	      });
	    }
	  };
	
	  this._throttledPosition = function () {
	    if (!_this2._ticking) {
	      requestAnimationFrame(function () {
	        _this2._ticking = false;
	        _this2._position();
	      });
	    }
	
	    _this2._ticking = true;
	  };
	
	  this._increment = function () {
	    var _props4 = _this2.props,
	        rows = _props4.rows,
	        onPagination = _props4.onPagination;
	    var start = _this2.state.start;
	
	    var rowsPerPage = (0, _getField2.default)(_this2.props, _this2.state, 'rowsPerPage');
	    var page = (0, _getField2.default)(_this2.props, _this2.state, 'page');
	
	    // Only correct multiple of rows per page
	    var max = rows - rows % rowsPerPage;
	
	    var newStart = Math.min(start + rowsPerPage, max);
	    var nextPage = page + 1;
	
	    onPagination(newStart, rowsPerPage, nextPage);
	    if (typeof _this2.props.page === 'undefined') {
	      _this2.setState({ start: newStart, page: nextPage });
	    }
	  };
	
	  this._decrement = function () {
	    var start = _this2.state.start;
	
	    var page = (0, _getField2.default)(_this2.props, _this2.state, 'page');
	    var rowsPerPage = (0, _getField2.default)(_this2.props, _this2.state, 'rowsPerPage');
	    var newStart = Math.max(0, start - rowsPerPage);
	    var nextPage = page - 1;
	
	    _this2.props.onPagination(newStart, rowsPerPage, nextPage);
	    if (typeof _this2.props.page === 'undefined') {
	      _this2.setState({ start: newStart, page: nextPage });
	    }
	  };
	
	  this._setRowsPerPage = function (rowsPerPage) {
	    var page = 1;
	    var newStart = 0;
	    _this2.props.onPagination(newStart, rowsPerPage, page);
	    var nextState = void 0;
	    if (typeof _this2.props.rowsPerPage === 'undefined') {
	      nextState = { rowsPerPage: rowsPerPage };
	    }
	
	    if (typeof _this2.props.page === 'undefined') {
	      nextState = nextState || {};
	      nextState.start = newStart;
	    }
	
	    if (nextState) {
	      _this2.setState(nextState);
	    }
	  };
	};
	
	exports.default = TablePagination;
	//# sourceMappingURL=TablePagination.js.map

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _headerContextTypes = __webpack_require__(165);
	
	var _headerContextTypes2 = _interopRequireDefault(_headerContextTypes);
	
	var _rowContextTypes = __webpack_require__(575);
	
	var _rowContextTypes2 = _interopRequireDefault(_rowContextTypes);
	
	var _TableCheckbox = __webpack_require__(570);
	
	var _TableCheckbox2 = _interopRequireDefault(_TableCheckbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A component for displaying a row in a `DataTable`. This will
	 * automatically add a `Checkbox` component to the row if it is not
	 * a `plain` table.
	 */
	var TableRow = function (_Component) {
	  _inherits(TableRow, _Component);
	
	  function TableRow(props, context) {
	    _classCallCheck(this, TableRow);
	
	    var _this = _possibleConstructorReturn(this, (TableRow.__proto__ || Object.getPrototypeOf(TableRow)).call(this, props, context));
	
	    _this._handleMouseOver = function (e) {
	      if (_this.props.onMouseOver) {
	        _this.props.onMouseOver(e);
	      }
	
	      if (_this.context.header) {
	        return;
	      }
	
	      var target = e.target;
	      while (target && target.parentNode) {
	        if (target.classList && _this._ignoreHoverState(target.classList)) {
	          _this.setState({ hover: false });
	          return;
	        }
	
	        target = target.parentNode;
	      }
	
	      _this.setState({ hover: true });
	    };
	
	    _this._handleMouseLeave = function (e) {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(e);
	      }
	
	      if (_this.context.header) {
	        return;
	      }
	
	      _this.setState({ hover: false });
	    };
	
	    _this._handleCheckboxClick = function (checked, e) {
	      var rowIndex = _this._row.rowIndex;
	
	      if (_this.props.onCheckboxClick) {
	        _this.props.onCheckboxClick(rowIndex, checked, e);
	      }
	
	      _this.context.toggleSelectedRow(rowIndex, _this.context.header, e);
	    };
	
	    _this._setRow = function (row) {
	      _this._row = row;
	    };
	
	    _this.state = { hover: false };
	    return _this;
	  }
	
	  _createClass(TableRow, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _context = this.context,
	          baseId = _context.baseId,
	          context = _objectWithoutProperties(_context, ['baseId']);
	
	      var id = baseId + '-' + (this._row ? this._row.rowIndex : null);
	      return _extends({}, context, {
	        rowId: context.header ? baseId + '-toggle-all' : id
	      });
	    }
	
	    /**
	     * Need to ignore adding the hover state if the mouse is over a menu/menu item
	     * or the edit dialog is open.
	     *
	     * @param {Function} classList - the classList to use for checking cn
	     * @return {Boolean} true if the hover state should be ignored for this classList
	     */
	
	  }, {
	    key: '_ignoreHoverState',
	    value: function _ignoreHoverState(classList) {
	      return classList.contains('md-list--menu') || classList.contains('md-edit-dialog');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          children = _props.children,
	          selected = _props.selected,
	          selectable = _props.selectable,
	          onCheckboxClick = _props.onCheckboxClick,
	          autoAdjust = _props.autoAdjust,
	          props = _objectWithoutProperties(_props, ['className', 'children', 'selected', 'selectable', 'onCheckboxClick', 'autoAdjust']);
	
	      var hover = this.state.hover;
	
	
	      var checkbox = void 0;
	      if (typeof selectable !== 'undefined' ? selectable : !this.context.plain && this.context.selectableRows) {
	        checkbox = _react2.default.createElement(_TableCheckbox2.default, {
	          key: 'checkbox',
	          checked: selected,
	          onChange: this._handleCheckboxClick,
	          index: this._row ? this._row.rowIndex : null
	        });
	      }
	
	      var length = _react.Children.count(children) - 1;
	      var columns = _react.Children.map(_react.Children.toArray(children), function (col, i) {
	        var adjusted = col.props.adjusted;
	        if (typeof adjusted === 'undefined') {
	          adjusted = i === length ? false : undefined;
	        }
	
	        return (0, _react.cloneElement)(col, {
	          cellIndex: i + (checkbox ? 1 : 0),
	          header: (0, _getField2.default)(col.props, _this2.context, 'header'),
	          adjusted: adjusted
	        });
	      });
	
	      return _react2.default.createElement(
	        'tr',
	        _extends({}, props, {
	          ref: this._setRow,
	          className: (0, _classnames2.default)('md-table-row', className, {
	            'md-table-row--hover': hover,
	            'md-table-row--active': !this.context.header && selected
	          }),
	          onMouseOver: this._handleMouseOver,
	          onMouseLeave: this._handleMouseLeave
	        }),
	        checkbox,
	        columns
	      );
	    }
	  }]);
	
	  return TableRow;
	}(_react.Component);
	
	TableRow.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the row.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * A single or list of `TableColumn` to display in the table.
	   *
	   * > The specs "require" at least 3 columns for a non-plain data table, but that isn't
	   * strictly enforced here.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]).isRequired,
	
	  /**
	   * An optional onClick function to call when a row is clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * A function to call when the checkbox is clicked. This
	   * function will will be called with `(rowIndex, checked, event)`.
	   * The `TableBody` and `TableHeader` components will automatically
	   * merge in a function to toggle the checkbox.
	   */
	  onCheckboxClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call onMouseOver.
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * An optional function to call onMouseLeave.
	   */
	  onMouseLeave: _propTypes2.default.func,
	
	  /**
	   * Boolean if the row is currently selected. If this value will be
	   * injected by the `TableHeader` or `TableBody` component.
	   */
	  selected: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the current row is selectable. This value will take precedence over anything inherited
	   * by the `DataTable`.
	   */
	  selectable: _propTypes2.default.bool,
	
	  autoAdjust: (0, _deprecated2.default)(_propTypes2.default.bool, 'Manually specify `grow` on one of the columns instead')
	};
	TableRow.contextTypes = _headerContextTypes2.default;
	TableRow.childContextTypes = _rowContextTypes2.default;
	exports.default = TableRow;
	//# sourceMappingURL=TableRow.js.map

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DropdownMenuColumn = exports.MenuButtonColumn = exports.SelectFieldColumn = exports.EditDialogColumn = exports.TableCardHeader = exports.TablePagination = exports.TableFooter = exports.TableColumn = exports.TableRow = exports.TableBody = exports.TableHeader = exports.DataTable = undefined;
	
	var _DataTable2 = __webpack_require__(562);
	
	var _DataTable3 = _interopRequireDefault(_DataTable2);
	
	var _TableHeader2 = __webpack_require__(571);
	
	var _TableHeader3 = _interopRequireDefault(_TableHeader2);
	
	var _TableBody2 = __webpack_require__(568);
	
	var _TableBody3 = _interopRequireDefault(_TableBody2);
	
	var _TableRow2 = __webpack_require__(573);
	
	var _TableRow3 = _interopRequireDefault(_TableRow2);
	
	var _TableColumn2 = __webpack_require__(60);
	
	var _TableColumn3 = _interopRequireDefault(_TableColumn2);
	
	var _TableFooter2 = __webpack_require__(265);
	
	var _TableFooter3 = _interopRequireDefault(_TableFooter2);
	
	var _TablePagination2 = __webpack_require__(572);
	
	var _TablePagination3 = _interopRequireDefault(_TablePagination2);
	
	var _TableCardHeader2 = __webpack_require__(569);
	
	var _TableCardHeader3 = _interopRequireDefault(_TableCardHeader2);
	
	var _EditDialogColumn2 = __webpack_require__(565);
	
	var _EditDialogColumn3 = _interopRequireDefault(_EditDialogColumn2);
	
	var _SelectFieldColumn2 = __webpack_require__(567);
	
	var _SelectFieldColumn3 = _interopRequireDefault(_SelectFieldColumn2);
	
	var _MenuButtonColumn2 = __webpack_require__(566);
	
	var _MenuButtonColumn3 = _interopRequireDefault(_MenuButtonColumn2);
	
	var _DropdownMenuColumn2 = __webpack_require__(563);
	
	var _DropdownMenuColumn3 = _interopRequireDefault(_DropdownMenuColumn2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DataTable3.default;
	exports.DataTable = _DataTable3.default;
	exports.TableHeader = _TableHeader3.default;
	exports.TableBody = _TableBody3.default;
	exports.TableRow = _TableRow3.default;
	exports.TableColumn = _TableColumn3.default;
	exports.TableFooter = _TableFooter3.default;
	exports.TablePagination = _TablePagination3.default;
	exports.TableCardHeader = _TableCardHeader3.default;
	exports.EditDialogColumn = _EditDialogColumn3.default;
	exports.SelectFieldColumn = _SelectFieldColumn3.default;
	exports.MenuButtonColumn = _MenuButtonColumn3.default;
	exports.DropdownMenuColumn = _DropdownMenuColumn3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _headerContextTypes = __webpack_require__(165);
	
	var _headerContextTypes2 = _interopRequireDefault(_headerContextTypes);
	
	var _omit = __webpack_require__(116);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rowContextTypes = (0, _omit2.default)(_extends({}, _headerContextTypes2.default, {
	  rowId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	}), ['baseId']);
	
	exports.default = rowContextTypes;
	//# sourceMappingURL=rowContextTypes.js.map

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DialogTitle = function (_PureComponent) {
	  _inherits(DialogTitle, _PureComponent);
	
	  function DialogTitle() {
	    _classCallCheck(this, DialogTitle);
	
	    return _possibleConstructorReturn(this, (DialogTitle.__proto__ || Object.getPrototypeOf(DialogTitle)).apply(this, arguments));
	  }
	
	  _createClass(DialogTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['children', 'className']);
	
	      if (!children) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'h2',
	        _extends({}, props, { className: (0, _classnames2.default)('md-title md-title--dialog', className) }),
	        children
	      );
	    }
	  }]);
	
	  return DialogTitle;
	}(_react.PureComponent);
	
	DialogTitle.propTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node
	};
	exports.default = DialogTitle;
	//# sourceMappingURL=DialogTitle.js.map

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Dialog = exports.DialogContainer = undefined;
	
	var _DialogContainer2 = __webpack_require__(168);
	
	var _DialogContainer3 = _interopRequireDefault(_DialogContainer2);
	
	var _Dialog2 = __webpack_require__(167);
	
	var _Dialog3 = _interopRequireDefault(_Dialog2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DialogContainer3.default;
	exports.DialogContainer = _DialogContainer3.default;
	exports.Dialog = _Dialog3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Divider = undefined;
	
	var _Divider2 = __webpack_require__(169);
	
	var _Divider3 = _interopRequireDefault(_Divider2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Divider3.default;
	exports.Divider = _Divider3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Portal = __webpack_require__(62);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Overlay = function (_PureComponent) {
	  _inherits(Overlay, _PureComponent);
	
	  function Overlay() {
	    _classCallCheck(this, Overlay);
	
	    return _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).apply(this, arguments));
	  }
	
	  _createClass(Overlay, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      // Always want the overlay to render in a separate subtree until 1.1.0
	      return { isInPortal: false };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          visible = _props.visible,
	          renderNode = _props.renderNode,
	          onClick = _props.onClick,
	          style = _props.style,
	          className = _props.className;
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { visible: visible, renderNode: renderNode },
	        _react2.default.createElement('div', {
	          style: style,
	          className: (0, _classnames2.default)('md-overlay md-overlay--drawer md-pointer--hover', {
	            'md-overlay--active': active
	          }, className),
	          onClick: onClick
	        })
	      );
	    }
	  }]);
	
	  return Overlay;
	}(_react.PureComponent);
	
	Overlay.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  active: _propTypes2.default.bool,
	  visible: _propTypes2.default.bool.isRequired,
	  renderNode: _propTypes2.default.object,
	  onClick: _propTypes2.default.func
	};
	Overlay.childContextTypes = {
	  isInPortal: _propTypes2.default.bool
	};
	exports.default = Overlay;
	//# sourceMappingURL=Overlay.js.map

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Drawer = undefined;
	
	var _Drawer2 = __webpack_require__(170);
	
	var _Drawer3 = _interopRequireDefault(_Drawer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Drawer3.default;
	exports.Drawer = _Drawer3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keyCodes = __webpack_require__(15);
	
	var _handleWindowClickListeners = __webpack_require__(112);
	
	var _handleWindowClickListeners2 = _interopRequireDefault(_handleWindowClickListeners);
	
	var _ResizeObserver = __webpack_require__(32);
	
	var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `ExpansionList` component is a wrapper for the `ExpansionPanel` that helps
	 * determine which `ExpansionPanel` currently has tab focus and adjusts the column
	 * sizes in the header of the `ExpansionPanel`.
	 *
	 * The `ExpansionList` and `ExpansionPanel` components should have probably been
	 * implemented as a `table` instead of a `ul || ol` since it is more column based,
	 * but it would complicate the API to have dynamic row generation for the expanded
	 * panels. The expanded panels _might_ not follow the same column widths as their labels
	 * so a singular row with a div for expanded content might not work correctly.
	 */
	var ExpansionList = function (_PureComponent) {
	  _inherits(ExpansionList, _PureComponent);
	
	  function ExpansionList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ExpansionList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ExpansionList.__proto__ || Object.getPrototypeOf(ExpansionList)).call.apply(_ref, [this].concat(args))), _this), _this.state = { columnWidths: [], focusedIndex: -1, overflown: false }, _this._setContainer = function (container) {
	      if (container !== null) {
	        _this._container = (0, _reactDom.findDOMNode)(container);
	        window.addEventListener('keyup', _this._determineTabFocus);
	
	        _this._width = _this._container.offsetWidth;
	        _this._calcColumnWidths();
	      }
	    }, _this._determineTabFocus = function (e) {
	      if ((e.which || e.keyCode) === _keyCodes.TAB) {
	        var panels = Array.prototype.slice.call((0, _reactDom.findDOMNode)(_this).querySelectorAll('.md-panel-header'));
	        _this.setState({ focusedIndex: panels.indexOf(e.target) });
	      }
	    }, _this._removeFocus = function () {
	      _this.setState({ focusedIndex: -1 });
	    }, _this._isOverflown = function (widths) {
	      if (!_this._container) {
	        return 0;
	      }
	
	      var panel = _this._container.querySelector('.md-panel-header');
	      if (!panel) {
	        return 0;
	      }
	
	      var collapser = _this._container.querySelector('.md-expansion-panel__collapser');
	      var collapserWidth = collapser ? collapser.offsetWidth : 0;
	      var styles = window.getComputedStyle(panel);
	      var maxWidth = panel.offsetWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight) - collapserWidth;
	
	      var totalWidth = widths.reduce(function (total, w) {
	        return total + w;
	      }, 0);
	      return totalWidth > maxWidth;
	    }, _this._getColumnWidths = function () {
	      if (!_this._container) {
	        return _this.state.columnWidths;
	      }
	
	      return [].slice.call(_this._container.querySelectorAll('.md-panel-header')).reduce(function (maxes, row) {
	        var columns = row.querySelectorAll('.md-panel-column');
	        for (var i = 0; i < columns.length; i++) {
	          var col = columns[i];
	          // Need to reset the widths if it has already been calculated to get a more accurate measurement.
	          var _col$style = col.style,
	              width = _col$style.width,
	              minWidth = _col$style.minWidth;
	
	          col.style.width = 'auto';
	          col.style.minWidth = 'auto';
	
	          // Only need to include the offsetWidth of the column because the child will really
	          // determine the width of the column. Since it has already been defined at this point,
	          // no additional work needs to be done.
	          maxes[i] = Math.max(col.offsetWidth, maxes[i] || 0);
	          col.style.width = width;
	          col.style.minWidth = minWidth;
	        }
	
	        return maxes;
	      }, [0]);
	    }, _this._calcColumnWidths = function () {
	      var columnWidths = _this.state.columnWidths;
	
	      var nextWidths = _this._getColumnWidths();
	      var overflown = _this._isOverflown(nextWidths);
	      if (_this.state.overflown !== overflown || columnWidths.length !== nextWidths.length || nextWidths.some(function (w, i) {
	        return w !== columnWidths[i];
	      })) {
	        _this.setState({ columnWidths: nextWidths, overflown: overflown });
	      }
	    }, _this._handleResize = function (_ref2) {
	      var width = _ref2.width;
	      var recalculateThreshold = _this.props.recalculateThreshold;
	
	      if (_this._width !== width && Math.abs(width - _this._width) >= recalculateThreshold) {
	        _this._width = width;
	        _this._calcColumnWidths();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ExpansionList, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var animateContent = this.props.animateContent;
	
	      return { animateContent: animateContent };
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.children !== nextProps.children) {
	        this._calcColumnWidths();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var focusedIndex = this.state.focusedIndex;
	
	      if (prevState.focusedIndex === focusedIndex || prevState.focusedIndex > -1 && focusedIndex > -1) {
	        return;
	      }
	
	      (0, _handleWindowClickListeners2.default)(this._removeFocus, this.state.focusedIndex !== -1);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.focusedIndex === -1) {
	        (0, _handleWindowClickListeners2.default)(this._removeFocus, false);
	      }
	
	      window.removeEventListener('keyup', this._determineTabFocus);
	    }
	
	    /**
	     * Since this should really be rendered as a table, need to calculate the max width for each _column_
	     * on the panel's header and apply that as a min width for the other panels.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          columnWidths = _state.columnWidths,
	          focusedIndex = _state.focusedIndex,
	          overflown = _state.overflown;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          Component = _props.component,
	          animateContent = _props.animateContent,
	          recalculateThreshold = _props.recalculateThreshold,
	          props = _objectWithoutProperties(_props, ['children', 'className', 'component', 'animateContent', 'recalculateThreshold']);
	
	      var panels = _react.Children.map(children, function (child, i) {
	        return (0, _react.cloneElement)(child, {
	          key: child.key || i,
	          overflown: overflown,
	          columnWidths: columnWidths,
	          focused: focusedIndex === i
	        });
	      });
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, {
	          ref: this._setContainer,
	          className: (0, _classnames2.default)('md-expansion-panel-list', className)
	        }),
	        _react2.default.createElement(_ResizeObserver2.default, { watchWidth: true, onResize: this._handleResize }),
	        panels
	      );
	    }
	  }]);
	
	  return ExpansionList;
	}(_react.PureComponent);
	
	ExpansionList.propTypes = {
	  /**
	   * An optional style object to apply to the list.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the list.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The children should be a list or singular `ExpansionPanel` component
	   * to render with some additional props injected.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The component to render the list as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * Boolean if all the expansion panels in the list should animate when their content's visibility
	   * changes. This is just a quicker way to disable all animations instead of having to toggle it off
	   * on each panel.
	   *
	   * > The default value is really `true` since it gets passed down to the `Collapse` component.
	   */
	  animateContent: _propTypes2.default.bool,
	
	  /**
	   * The threshold that should be used for when the list should recalculate the positioning of all
	   * the columns. This will only compare the difference between updates.
	   * So if the size changes from 80 -> 120 -> 160 -> 140. It will only update on the third resize (160)
	   */
	  recalculateThreshold: _propTypes2.default.number.isRequired
	};
	ExpansionList.defaultProps = {
	  component: 'ul',
	  recalculateThreshold: 80
	};
	ExpansionList.childContextTypes = {
	  animateContent: _propTypes2.default.bool
	};
	exports.default = ExpansionList;
	//# sourceMappingURL=ExpansionList.js.map

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _themeColors = __webpack_require__(12);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _getCollapserStyles = __webpack_require__(114);
	
	var _getCollapserStyles2 = _interopRequireDefault(_getCollapserStyles);
	
	var _controlled = __webpack_require__(16);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _Paper = __webpack_require__(33);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _AccessibleFakeButton = __webpack_require__(80);
	
	var _AccessibleFakeButton2 = _interopRequireDefault(_AccessibleFakeButton);
	
	var _Collapse = __webpack_require__(46);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _FontIcon = __webpack_require__(13);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(21);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _PanelContent = __webpack_require__(583);
	
	var _PanelContent2 = _interopRequireDefault(_PanelContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LABEL_FONT_SIZE = 15;
	var LINE_HEIGHT = 1.42857;
	var SINGLE_LINE_HEIGHT = LABEL_FONT_SIZE * LINE_HEIGHT;
	
	/**
	 * The `ExpansionPanel` component needs to be used with the `ExpansionList`
	 * component. The only reason is that the `ExpansionPanel` should really
	 * be rendered as a table, but it was a bit hard to have a single component
	 * dynamically rendering another row when expanded. It couldn't be in the
	 * same row since the expanded content might not have the same columns.
	 */
	
	var ExpansionPanel = function (_PureComponent) {
	  _inherits(ExpansionPanel, _PureComponent);
	
	  function ExpansionPanel(props, context) {
	    _classCallCheck(this, ExpansionPanel);
	
	    var _this = _possibleConstructorReturn(this, (ExpansionPanel.__proto__ || Object.getPrototypeOf(ExpansionPanel)).call(this, props, context));
	
	    _this._determineIfTwoLine = function () {
	      var twoLine = false;
	      Array.prototype.slice.call((0, _reactDom.findDOMNode)(_this).querySelectorAll('.md-panel-column')).some(function (el) {
	        return twoLine = el.offsetHeight > SINGLE_LINE_HEIGHT;
	      });
	
	      _this.setState({ twoLine: twoLine });
	    };
	
	    _this._handleClick = function () {
	      var expanded = !_this._isExpanded(_this.props, _this.state);
	      if (_this.props.onExpandToggle) {
	        _this.props.onExpandToggle(expanded);
	      }
	
	      if (typeof _this.props.expanded === 'undefined') {
	        _this.setState({ expanded: expanded });
	      }
	    };
	
	    _this._handleSave = function (e) {
	      var _this$props = _this.props,
	          onSave = _this$props.onSave,
	          onExpandToggle = _this$props.onExpandToggle,
	          closeOnSave = _this$props.closeOnSave;
	
	      if (onSave) {
	        onSave(e);
	      }
	
	      if (closeOnSave) {
	        if (onExpandToggle) {
	          onExpandToggle(false);
	        }
	
	        if (typeof _this.props.expanded === 'undefined') {
	          _this.setState({ expanded: false });
	        }
	      }
	    };
	
	    _this._handleCancel = function (e) {
	      var _this$props2 = _this.props,
	          onCancel = _this$props2.onCancel,
	          onExpandToggle = _this$props2.onExpandToggle,
	          closeOnCancel = _this$props2.closeOnCancel;
	
	      if (onCancel) {
	        onCancel(e);
	      }
	
	      if (closeOnCancel) {
	        if (onExpandToggle) {
	          onExpandToggle(false);
	        }
	
	        if (typeof _this.props.expanded === 'undefined') {
	          _this.setState({ expanded: false });
	        }
	      }
	    };
	
	    _this.state = {
	      received: false,
	      twoLine: false
	    };
	
	    if (typeof props.expanded === 'undefined') {
	      _this.state.expanded = props.defaultExpanded;
	    }
	    return _this;
	  }
	
	  _createClass(ExpansionPanel, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._determineIfTwoLine();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (false) {
	        if (nextProps.columnWidths.length === 0) {
	          // Hopefully a nice warning about fixing the missing props injected from ExpansionList
	          /* eslint-disable no-console */
	          console.error('The `ExpansionPanel` component expects the `columnWidths` prop to be injected from the ' + '`ExpansionList` component. It could be missing because:' + '\n - you have a wrapper component with extra functionality' + '\n - the `ExpansionPanel` is not a direct child of the `ExpansionList` component' + '\n\nYou can fix this by making sure to pass `this.props.focused` and `this.props.columnWidths` ' + 'within your wrapper component and making the `ExpansionPanel` a direct child of `ExpansionList`.');
	        }
	
	        this.setState({ received: true });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.label === prevProps.label && this.props.secondaryLabel === prevProps.secondaryLabel) {
	        return;
	      }
	
	      this._determineIfTwoLine();
	    }
	  }, {
	    key: '_isExpanded',
	    value: function _isExpanded(props, state) {
	      return typeof props.expanded === 'undefined' ? state.expanded : props.expanded;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          label = _props.label,
	          secondaryLabel = _props.secondaryLabel,
	          expandedSecondaryLabel = _props.expandedSecondaryLabel,
	          children = _props.children,
	          focused = _props.focused,
	          columnWidths = _props.columnWidths,
	          saveType = _props.saveType,
	          saveLabel = _props.saveLabel,
	          savePrimary = _props.savePrimary,
	          saveSecondary = _props.saveSecondary,
	          saveProps = _props.saveProps,
	          cancelType = _props.cancelType,
	          cancelLabel = _props.cancelLabel,
	          cancelPrimary = _props.cancelPrimary,
	          cancelSecondary = _props.cancelSecondary,
	          cancelProps = _props.cancelProps,
	          headerStyle = _props.headerStyle,
	          headerClassName = _props.headerClassName,
	          contentStyle = _props.contentStyle,
	          contentClassName = _props.contentClassName,
	          tabIndex = _props.tabIndex,
	          overflown = _props.overflown,
	          footer = _props.footer,
	          footerChildren = _props.footerChildren,
	          footerStyle = _props.footerStyle,
	          footerClassName = _props.footerClassName,
	          expandIconChildren = _props.expandIconChildren,
	          expandIconClassName = _props.expandIconClassName,
	          propAnimateContent = _props.animateContent,
	          propExpanded = _props.expanded,
	          propExpanderIcon = _props.expanderIcon,
	          defaultExpanded = _props.defaultExpanded,
	          closeOnSave = _props.closeOnSave,
	          closeOnCancel = _props.closeOnCancel,
	          onSave = _props.onSave,
	          onCancel = _props.onCancel,
	          onExpandToggle = _props.onExpandToggle,
	          props = _objectWithoutProperties(_props, ['className', 'label', 'secondaryLabel', 'expandedSecondaryLabel', 'children', 'focused', 'columnWidths', 'saveType', 'saveLabel', 'savePrimary', 'saveSecondary', 'saveProps', 'cancelType', 'cancelLabel', 'cancelPrimary', 'cancelSecondary', 'cancelProps', 'headerStyle', 'headerClassName', 'contentStyle', 'contentClassName', 'tabIndex', 'overflown', 'footer', 'footerChildren', 'footerStyle', 'footerClassName', 'expandIconChildren', 'expandIconClassName', 'animateContent', 'expanded', 'expanderIcon', 'defaultExpanded', 'closeOnSave', 'closeOnCancel', 'onSave', 'onCancel', 'onExpandToggle']);
	
	      var twoLine = this.state.twoLine;
	
	      var expanded = this._isExpanded(this.props, this.state);
	      var animateContent = (0, _getField2.default)(this.props, this.context, 'animateContent');
	
	      var columns = _react.Children.map(expanded && expandedSecondaryLabel || secondaryLabel, function (panelLabel, i) {
	        return _react2.default.createElement(
	          'div',
	          {
	            style: _defineProperty({}, '' + (overflown ? 'width' : 'minWidth'), columnWidths[i + 1]),
	            className: (0, _classnames2.default)('md-panel-column', {
	              'md-panel-column--overflown': overflown
	            }, (0, _themeColors2.default)({ text: true }))
	          },
	          panelLabel
	        );
	      });
	
	      if (!Array.isArray(columns)) {
	        columns = [columns];
	      }
	
	      columns.unshift(_react2.default.createElement(
	        'div',
	        {
	          key: 'main-label',
	          style: { minWidth: columnWidths[0] },
	          className: (0, _classnames2.default)('md-panel-column', (0, _themeColors2.default)({ text: true }))
	        },
	        label
	      ));
	
	      var expanderIcon = (0, _getDeprecatedIcon2.default)(expandIconClassName, expandIconChildren, this.props.expanderIcon);
	      expanderIcon = _react2.default.Children.only(expanderIcon);
	      expanderIcon = _react2.default.cloneElement(expanderIcon, {
	        className: (0, _getCollapserStyles2.default)({
	          flipped: expanded
	        }, 'md-expansion-panel__collapser md-cell--right', expanderIcon.props.className)
	      });
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        _extends({}, props, {
	          className: (0, _classnames2.default)('md-expansion-panel', {
	            'md-expansion-panel--expanded': expanded
	          }, className),
	          'aria-expanded': expanded
	        }),
	        _react2.default.createElement(
	          _AccessibleFakeButton2.default,
	          {
	            onClick: this._handleClick,
	            style: headerStyle,
	            className: (0, _classnames2.default)('md-panel-header', {
	              'md-panel-header--expanded': expanded || twoLine,
	              'md-panel-header--focused': focused
	            }, headerClassName),
	            tabIndex: tabIndex
	          },
	          columns,
	          expanderIcon
	        ),
	        _react2.default.createElement(
	          _Collapse2.default,
	          { collapsed: !expanded, animate: animateContent },
	          _react2.default.createElement(
	            _PanelContent2.default,
	            {
	              style: contentStyle,
	              className: contentClassName,
	              footerStyle: footerStyle,
	              footerClassName: footerClassName,
	              onSave: this._handleSave,
	              onCancel: this._handleCancel,
	              saveType: saveType,
	              saveLabel: saveLabel,
	              savePrimary: savePrimary,
	              saveSecondary: saveSecondary,
	              saveProps: saveProps,
	              cancelType: cancelType,
	              cancelLabel: cancelLabel,
	              cancelPrimary: cancelPrimary,
	              cancelSecondary: cancelSecondary,
	              cancelProps: cancelProps,
	              footer: footer,
	              footerChildren: footerChildren
	            },
	            children
	          )
	        )
	      );
	    }
	  }]);
	
	  return ExpansionPanel;
	}(_react.PureComponent);
	
	ExpansionPanel.propTypes = {
	  /**
	   * An optional style to apply to the panel.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the panel.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An options style to apply to the panel's header content. This is the
	   * section that toggles the children to be visible and label columns.
	   */
	  headerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the panel's header content. This is the
	   * section that toggles the children to be visible and label columns.
	   */
	  headerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the element surrounding the children when expanded.
	   */
	  contentStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the element surrounding the children when expanded.
	   */
	  contentClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the footer when the `footer` prop is `undefined`.
	   *
	   * @see {@link #footer}
	   */
	  footerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the footer when the `footer` prop is `undefined`.
	   *
	   * @see {@link #footer}
	   */
	  footerClassName: _propTypes2.default.string,
	
	  /**
	   * The main label to display in the unexpanded panel.
	   */
	  label: _propTypes2.default.node.isRequired,
	
	  /**
	   * Any additional columns to display after the main label. If this is a `list`
	   * instead of a singular item, they will each be formatted as a column.
	   */
	  secondaryLabel: _propTypes2.default.node,
	
	  /**
	   * Any additional columns to display after the main label when the panel is
	   * expanded. If this is omitted, the default `secondaryLabel` will be displayed
	   * instead.
	   */
	  expandedSecondaryLabel: _propTypes2.default.node,
	
	  /**
	   * The component to render the panel as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * The content to display once the panel is toggled open.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A boolean if the panel is currently expanded. This will force the component
	   * to be controlled and require's the `onExpandToggle` function to be defined.
	   */
	  expanded: (0, _controlled2.default)(_propTypes2.default.bool, 'onExpandToggle', 'defaultExpanded'),
	
	  /**
	   * Boolean if an uncontrolled panel should be expanded by default.
	   */
	  defaultExpanded: _propTypes2.default.bool.isRequired,
	
	  /**
	   * The icon to display for expanding the expansion panel.
	   */
	  expanderIcon: _propTypes2.default.element,
	
	  /**
	   * Boolean if the `ExpansionPanel` is currently tab focused. This is injected
	   * and managed by the `ExpansionList` component. Do not set yourself.
	   */
	  focused: _propTypes2.default.bool.isRequired,
	
	  /**
	   * A list of min-widths to apply to each column in the panel header. This is injected
	   * and managed by the `ExpansionList` component. Do not set yourself.
	   */
	  columnWidths: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
	
	  /**
	   * Boolean if the panel has too much content so that it overflowns. This is injected
	   * and managed by the `ExpansionList` component. Do not set yourself.
	   *
	   * When this is active, it will truncate all columns except for the main label and the
	   * toggle icon.
	   */
	  overflown: _propTypes2.default.bool,
	
	  /**
	   * A function to call when the expansion panel's expanded state is toggled.
	   * The callback for this function will include the new expanded state.
	   *
	   * `onExpandToggle(expanded)`
	   */
	  onExpandToggle: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the Save button is clicked on the expanded panel.
	   */
	  onSave: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the Cancel button is clicked on the expanded panel.
	   */
	  onCancel: _propTypes2.default.func,
	
	  /**
	   * Boolean if the panel should close when the Save button is clicked.
	   */
	  closeOnSave: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the panel should close when the Cancel button is clicked.
	   */
	  closeOnCancel: _propTypes2.default.bool,
	
	  /**
	   * An optional button type to apply to the Save button. This will get
	   * passed to the `FlatButton`.
	   */
	  saveType: _propTypes2.default.oneOf(['button', 'submit', 'reset']),
	
	  /**
	   * The label for the Save button.
	   */
	  saveLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the Save button should be styled with the primary color.
	   */
	  savePrimary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the Save button should be styled with the secondary color,
	   */
	  saveSecondary: _propTypes2.default.bool,
	
	  /**
	   * Any additional props to provide/override for the save button in the
	   * footer of the panel.
	   */
	  saveProps: _propTypes2.default.object,
	
	  /**
	   * An optional button type to apply to the Cancel button. This will get
	   * passed to the `FlatButton`.
	   */
	  cancelType: _propTypes2.default.oneOf(['button', 'submit', 'reset']),
	
	  /**
	   * The label for the Cancel button.
	   */
	  cancelLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the Cancel button should be styled with the primary color,
	   */
	  cancelPrimary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the Cancel button should be styled with the secondary color,
	   */
	  cancelSecondary: _propTypes2.default.bool,
	
	  /**
	   * Any additional props to provide/override for the cancel button in the
	   * footer of the panel.
	   */
	  cancelProps: _propTypes2.default.object,
	
	  /**
	   * The tab index for the panel's header. This allows keyboard navigation.
	   */
	  tabIndex: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the panel's content should animate when the content's visibility changes. This
	   * can also be toggled from the `ExpansionList` component if all `ExpansionPanel` in the list
	   * should not animate. This only affects the height transition.
	   *
	   * > The default value is really `true` since it gets passed down to the `Collapse` component.
	   */
	  animateContent: _propTypes2.default.bool,
	
	  /**
	   * This prop controls the footer for the expansion panel. If this prop is `undefined`, it will
	   * go with the default behavior of generating the save and cancel buttons with the save and cancel
	   * props.
	   *
	   * If this value is `null`, there will be no footer created.
	   *
	   * Finally, if this prop is defined as any renderable item, it will be displayed in place of the
	   * footer.
	   *
	   * @see {@link #footerChildren}
	   */
	  footer: _propTypes2.default.node,
	
	  /**
	   * Any additional children that should be displayed in the footer of the panel. These children
	   * will be placed after the action buttons.
	   */
	  footerChildren: _propTypes2.default.node,
	  expandIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `expanderIcon` instead'),
	  expandIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `expanderIcon` instead')
	};
	ExpansionPanel.defaultProps = {
	  defaultExpanded: false,
	  expanderIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'keyboard_arrow_down'
	  ),
	  component: 'li',
	  saveLabel: 'Save',
	  cancelLabel: 'Cancel',
	  savePrimary: true,
	  tabIndex: 0,
	  closeOnSave: true,
	  closeOnCancel: true,
	  focused: false,
	  columnWidths: []
	};
	ExpansionPanel.contextTypes = {
	  animateContent: _propTypes2.default.bool
	};
	exports.default = ExpansionPanel;
	//# sourceMappingURL=ExpansionPanel.js.map

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DialogFooter = __webpack_require__(108);
	
	var _DialogFooter2 = _interopRequireDefault(_DialogFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `PanelContent` component is for displaying the expanded content
	 * for an `ExpansionPanel`. It will display any children in a `md-panel-content`
	 * container followed by a `Divider` and the `PanelControls` .
	 */
	var PanelContent = function (_PureComponent) {
	  _inherits(PanelContent, _PureComponent);
	
	  function PanelContent() {
	    _classCallCheck(this, PanelContent);
	
	    return _possibleConstructorReturn(this, (PanelContent.__proto__ || Object.getPrototypeOf(PanelContent)).apply(this, arguments));
	  }
	
	  _createClass(PanelContent, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          footerStyle = _props.footerStyle,
	          footerClassName = _props.footerClassName,
	          contentStyle = _props.contentStyle,
	          className = _props.className,
	          children = _props.children,
	          onSave = _props.onSave,
	          onCancel = _props.onCancel,
	          saveProps = _props.saveProps,
	          saveType = _props.saveType,
	          saveLabel = _props.saveLabel,
	          savePrimary = _props.savePrimary,
	          saveSecondary = _props.saveSecondary,
	          cancelProps = _props.cancelProps,
	          cancelType = _props.cancelType,
	          cancelLabel = _props.cancelLabel,
	          cancelPrimary = _props.cancelPrimary,
	          cancelSecondary = _props.cancelSecondary,
	          footer = _props.footer,
	          footerChildren = _props.footerChildren;
	
	
	      var actions = [_extends({
	        type: cancelType,
	        label: cancelLabel,
	        primary: cancelPrimary,
	        secondary: cancelSecondary
	      }, cancelProps, {
	        onClick: onCancel
	      }), _extends({
	        type: saveType,
	        label: saveLabel,
	        primary: savePrimary,
	        secondary: saveSecondary
	      }, saveProps, {
	        onClick: onSave
	      })];
	
	      var actionFooter = null;
	      if (typeof footer === 'undefined') {
	        actionFooter = _react2.default.createElement(
	          _DialogFooter2.default,
	          {
	            actions: actions,
	            style: footerStyle,
	            className: (0, _classnames2.default)('md-divider-border md-divider-border--top', footerClassName)
	          },
	          footerChildren
	        );
	      } else if (footer !== null) {
	        actionFooter = footer;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: style },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('md-panel-content', className), style: contentStyle },
	          children
	        ),
	        actionFooter
	      );
	    }
	  }]);
	
	  return PanelContent;
	}(_react.PureComponent);
	
	PanelContent.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  footerStyle: _propTypes2.default.object,
	  footerClassName: _propTypes2.default.string,
	  contentStyle: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  onSave: _propTypes2.default.func.isRequired,
	  onCancel: _propTypes2.default.func.isRequired,
	  saveProps: _propTypes2.default.object,
	  saveType: _propTypes2.default.string,
	  saveLabel: _propTypes2.default.node.isRequired,
	  savePrimary: _propTypes2.default.bool,
	  saveSecondary: _propTypes2.default.bool,
	  cancelProps: _propTypes2.default.object,
	  cancelType: _propTypes2.default.string,
	  cancelLabel: _propTypes2.default.node.isRequired,
	  cancelPrimary: _propTypes2.default.bool,
	  cancelSecondary: _propTypes2.default.bool,
	  footer: _propTypes2.default.node,
	  footerChildren: _propTypes2.default.node
	};
	exports.default = PanelContent;
	//# sourceMappingURL=PanelContent.js.map

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ExpansionList = exports.ExpansionPanel = undefined;
	
	var _ExpansionPanel2 = __webpack_require__(582);
	
	var _ExpansionPanel3 = _interopRequireDefault(_ExpansionPanel2);
	
	var _ExpansionList2 = __webpack_require__(581);
	
	var _ExpansionList3 = _interopRequireDefault(_ExpansionList2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ExpansionPanel3.default;
	exports.ExpansionPanel = _ExpansionPanel3.default;
	exports.ExpansionList = _ExpansionList3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CSSTransitionGroup = __webpack_require__(49);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(19);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Any props such as style or event listeners will be applied to the
	 * main floating action button. If you want props applied to the `SpeedDial`
	 * itself, you will need to set them in the `containerProps` prop.
	 */
	var SpeedDial = function (_PureComponent) {
	  _inherits(SpeedDial, _PureComponent);
	
	  function SpeedDial(props) {
	    _classCallCheck(this, SpeedDial);
	
	    var _this = _possibleConstructorReturn(this, (SpeedDial.__proto__ || Object.getPrototypeOf(SpeedDial)).call(this, props));
	
	    _this.state = { isOpen: props.initiallyOpen };
	    _this._handleClick = _this._handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(SpeedDial, [{
	    key: '_isOpen',
	    value: function _isOpen(props, state) {
	      return typeof props.isOpen === 'undefined' ? state.isOpen : props.isOpen;
	    }
	  }, {
	    key: '_handleClick',
	    value: function _handleClick(e) {
	      var _props = this.props,
	          onClick = _props.onClick,
	          onPassiveClick = _props.onPassiveClick,
	          onActiveClick = _props.onActiveClick;
	
	      if (onClick) {
	        onClick(e);
	      }
	
	      var isOpen = this._isOpen(this.props, this.state);
	      if (isOpen && onActiveClick) {
	        onActiveClick(e);
	      } else if (!isOpen && onPassiveClick) {
	        onPassiveClick(e);
	      }
	
	      if (typeof this.props.isOpen === 'undefined') {
	        this.setState({ isOpen: !isOpen });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          fabs = _props2.fabs,
	          passiveIconChildren = _props2.passiveIconChildren,
	          passiveIconClassName = _props2.passiveIconClassName,
	          activeIconChildren = _props2.activeIconChildren,
	          activeIconClassName = _props2.activeIconClassName,
	          transitionName = _props2.transitionName,
	          transitionEnterTimeout = _props2.transitionEnterTimeout,
	          speedDialTransitionName = _props2.speedDialTransitionName,
	          speedDialTransitionEnterTimeout = _props2.speedDialTransitionEnterTimeout,
	          speedDialTransitionLeaveTimeout = _props2.speedDialTransitionLeaveTimeout,
	          containerProps = _props2.containerProps,
	          props = _objectWithoutProperties(_props2, ['fabs', 'passiveIconChildren', 'passiveIconClassName', 'activeIconChildren', 'activeIconClassName', 'transitionName', 'transitionEnterTimeout', 'speedDialTransitionName', 'speedDialTransitionEnterTimeout', 'speedDialTransitionLeaveTimeout', 'containerProps']);
	
	      delete props.isOpen;
	      delete props.initiallyOpen;
	
	      var isOpen = this._isOpen(this.props, this.state);
	
	      var speedDialFabs = void 0;
	      if (isOpen) {
	        speedDialFabs = fabs.map(function (fab, i) {
	          var fn = void 0;
	          var el = void 0;
	          var fabProps = void 0;
	          if (_react2.default.isValidElement(fab)) {
	            el = _react2.default.Children.only(fab);
	            fn = _react2.default.cloneElement;
	            fabProps = fab.props;
	          } else {
	            el = _Button2.default;
	            fn = _react2.default.createElement;
	            fabProps = fab;
	          }
	
	          var created = fn(el, _extends({
	            floating: true,
	            mini: true
	          }, fabProps));
	          return _react2.default.createElement(
	            'div',
	            { key: i, className: 'md-speed-dial-fab' },
	            created
	          );
	        });
	      }
	
	      props.iconClassName = isOpen ? activeIconClassName : passiveIconClassName;
	      props.children = isOpen ? activeIconChildren : passiveIconChildren;
	      return _react2.default.createElement(
	        _CSSTransitionGroup2.default,
	        _extends({}, containerProps, {
	          component: 'div',
	          className: (0, _classnames2.default)('md-speed-dial', !!containerProps && containerProps.className),
	          transitionName: transitionName + '-' + (isOpen ? 'right' : 'left'),
	          transitionEnterTimeout: transitionEnterTimeout,
	          transitionLeave: false,
	          ref: 'container'
	        }),
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          {
	            component: 'div',
	            key: 'speed-dial-fabs',
	            transitionName: speedDialTransitionName,
	            transitionEnterTimeout: speedDialTransitionEnterTimeout,
	            transitionLeaveTimeout: speedDialTransitionLeaveTimeout
	          },
	          speedDialFabs
	        ),
	        _react2.default.createElement(_Button2.default, _extends({}, props, {
	          floating: true,
	          key: (isOpen ? 'open' : 'closed') + '-fab',
	          onClick: this._handleClick
	        }))
	      );
	    }
	  }]);
	
	  return SpeedDial;
	}(_react.PureComponent);
	
	SpeedDial.propTypes = {
	  /**
	   * A boolean if the speed dial is currently open. This will make
	   * the speed dial into a controlled component.
	   */
	  isOpen: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the uncontrolled speed dial is initially open.
	   */
	  initiallyOpen: _propTypes2.default.bool,
	
	  /**
	   * An optional className to apply to the speed dial.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The speed dial's floating action button transition name when the button's
	   * open state changes. If the button is open, `-right` is appened, otherwise
	   * `-left`.
	   */
	  transitionName: _propTypes2.default.string.isRequired,
	
	  /**
	   * The timeout for the speed dial's floating action button transition.
	   */
	  transitionEnterTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * The name for the flinging animation of the speed dial.
	   */
	  speedDialTransitionName: _propTypes2.default.string.isRequired,
	
	  /**
	   * The timeout for the flinging animation of the speed dial when opening.
	   */
	  speedDialTransitionEnterTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * The timeout for the flinging animation when the speed dial is closing.
	   */
	  speedDialTransitionLeaveTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * The optional children to display for unopened speed dial floating action button.
	   */
	  passiveIconChildren: _propTypes2.default.node,
	
	  /**
	   * The optional icon className to display for unopened speed dial floating action button.
	   */
	  passiveIconClassName: _propTypes2.default.node,
	
	  /**
	   * The optional children to display for opened speed dial floating action button.
	   */
	  activeIconChildren: _propTypes2.default.node,
	
	  /**
	   * The optional icon className to display for opened speed dial floating action button.
	   */
	  activeIconClassName: _propTypes2.default.string,
	
	  /**
	   * A list of `FloatingButton` or props to generate the `FloatinButton` when the
	   * `SpeedDial` is open. The buttons will automatically be converted to the `mini`
	   * version.
	   */
	  fabs: function fabs(props, propName, component) {
	    for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      others[_key - 3] = arguments[_key];
	    }
	
	    var size = props.fabs.length;
	    if (size >= 3 && size <= 5) {
	      var _PropTypes$arrayOf;
	
	      return (_PropTypes$arrayOf = _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.shape({
	        onClick: _propTypes2.default.func,
	        iconClassName: _propTypes2.default.string,
	        children: _propTypes2.default.node
	      })]))).isRequired.apply(_PropTypes$arrayOf, [props, propName, component].concat(others));
	    }
	
	    var middle = size < 3 ? 'at least 3' : 'no more than 5';
	    return new Error('A speed dial requires ' + middle + ' floating action buttons to fling. ' + ('However, only ' + size + ' were given.'));
	  },
	
	  /**
	   * An optional function to call when the main floating action button is clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the main floating action button is clicked.
	   */
	  onPassiveClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the main floating action button is clicked.
	   */
	  onActiveClick: _propTypes2.default.func,
	
	  /**
	   * Any additional props to apply to the speed dial itself.
	   */
	  containerProps: _propTypes2.default.object
	};
	SpeedDial.defaultProps = {
	  initiallyOpen: false,
	  transitionName: 'md-fab-rotate',
	  transitionEnterTimeout: 150,
	  speedDialTransitionName: 'md-speed-dial',
	  speedDialTransitionEnterTimeout: 450,
	  speedDialTransitionLeaveTimeout: 150,
	  passiveIconClassName: 'material-icons',
	  activeIconClassName: 'material-icons'
	};
	exports.default = SpeedDial;
	//# sourceMappingURL=SpeedDial.js.map

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SpeedDial = undefined;
	
	var _SpeedDial2 = __webpack_require__(585);
	
	var _SpeedDial3 = _interopRequireDefault(_SpeedDial2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SpeedDial = _SpeedDial3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _FileInput = __webpack_require__(269);
	
	var _FileInput2 = _interopRequireDefault(_FileInput);
	
	var _omit = __webpack_require__(116);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `FileUpload` component is used to upload files locally This is a wrapper of the `FileInput` component
	 * with some additional functionality so any props that are undocumented on `FileUpload` but are present
	 * on `FileInput` are correctly provided. If you want to upload files to a server, use
	 * [FormData](https://developer.mozilla.org/en-US/docs/Web/API/FormData)
	 * by attaching the `File`.
	 *
	 * Quick example:
	 *
	 * ```js
	 * function upload(file) {
	 *   fetch('/api/images', {
	 *     method: 'POST',
	 *     body: new FormData().append('file', file),
	 *   });
	 * }
	 * ```
	 *
	 * An upload can be aborted by calling the `abort(file || fileName)` function. If
	 * the file or fileName are omitted, it will *attempt* to abort the current
	 * file that is uploading. Unreliable for multi-select.
	 *
	 * ```js
	 * <FileUpload ref="upload" />
	 * <Button raised onClick={() => this.refs.upload.abort()} label="Abort! Abort!" />
	 * ```
	 */
	var FileUpload = function (_PureComponent) {
	  _inherits(FileUpload, _PureComponent);
	
	  function FileUpload() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FileUpload);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FileUpload.__proto__ || Object.getPrototypeOf(FileUpload)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.abort = function (file) {
	      var fileName = file;
	      if (!file) {
	        // Attempt to remove first file added...
	        fileName = Object.keys(_this.state)[0];
	      } else if (typeof file.name === 'string') {
	        fileName = file.name;
	      }
	
	      var reader = _this.state[fileName];
	      if (reader) {
	        reader.abort();
	        (0, _reactDom.findDOMNode)(_this).querySelector('.md-file-input').value = '';
	
	        _this.setState((0, _omit2.default)(_this.state, [fileName]));
	      }
	    }, _this._uploadFile = function (file) {
	      var _this$props = _this.props,
	          onAbort = _this$props.onAbort,
	          onError = _this$props.onError,
	          onLoad = _this$props.onLoad,
	          onLoadStart = _this$props.onLoadStart,
	          onLoadEnd = _this$props.onLoadEnd,
	          onProgress = _this$props.onProgress,
	          readAs = _this$props.readAs;
	      var name = file.name,
	          type = file.type;
	
	
	      var fr = new FileReader();
	      if (onError) {
	        fr.onerror = function (e) {
	          onError(file, e.target.error, e);
	        };
	      }
	
	      if (onAbort) {
	        fr.onabort = function (e) {
	          onAbort(file, e);
	        };
	      }
	
	      if (onLoadStart) {
	        fr.onloadstart = function (e) {
	          onLoadStart(file, e);
	        };
	      }
	
	      if (onLoadEnd) {
	        fr.onloadend = function (e) {
	          onLoadEnd(file, e);
	        };
	      }
	
	      fr.onload = function (e) {
	        if (onLoad) {
	          onLoad(file, e.target.result, e);
	        }
	
	        _this.setState((0, _omit2.default)(_this.state, [name]));
	      };
	
	      if (onProgress) {
	        fr.onprogress = function (e) {
	          if (e.lengthComputable) {
	            onProgress(file, e.loaded / e.total * 100, e);
	          }
	        };
	      }
	
	      if (readAs) {
	        if (typeof readAs === 'function') {
	          readAs(type, file, fr);
	        } else {
	          fr['readAs' + readAs](file);
	        }
	      } else if (type.match(/image|video|audio|application\/pdf/) || name.match(/\.mkv$/)) {
	        fr.readAsDataURL(file);
	      } else if (type.match(/application\/json/)) {
	        fr.readAsText(file);
	      } else if (type.match(/application|model|multipart/) || name.match(/(w|e)ar$/)) {
	        fr.readAsArrayBuffer(file);
	      } else {
	        fr.readAsText(file);
	      }
	
	      return fr;
	    }, _this._handleUpload = function (fileList, e) {
	      if (_this.props.onChange) {
	        _this.props.onChange(fileList, e);
	      }
	
	      if (!fileList) {
	        return;
	      }
	      var _this$props2 = _this.props,
	          maxSize = _this$props2.maxSize,
	          onSizeError = _this$props2.onSizeError;
	
	      var files = Array.isArray(fileList) ? fileList : [fileList];
	
	      var errorFiles = [];
	      if (maxSize) {
	        errorFiles = files.filter(function (file) {
	          return file.size > maxSize;
	        });
	        files = files.filter(function (file) {
	          return file.size <= maxSize;
	        });
	      }
	
	      if (errorFiles.length) {
	        onSizeError(errorFiles);
	      }
	
	      if (!files.length) {
	        return;
	      }
	
	      var nextState = {};
	      files.forEach(function (file) {
	        var fileReader = _this._uploadFile(file);
	        nextState[file.name] = fileReader;
	      });
	
	      _this.setState(nextState);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Attempts to abort the upload of a file. This function takes an optional `file` or `fileName`
	   * as it's parameter. If the parameter is omitted, it attempts to abort the first file that was
	   * added. If the `onAbort` function was given, it will be called as well.
	   *
	   * @param {Object|string} file - The file or the file name to use to find the
	   *     correct `FileReader`.
	   */
	
	
	  _createClass(FileUpload, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          maxSize = _props.maxSize,
	          readAs = _props.readAs,
	          onLoad = _props.onLoad,
	          onLoadStart = _props.onLoadStart,
	          onLoadEnd = _props.onLoadEnd,
	          onProgress = _props.onProgress,
	          onAbort = _props.onAbort,
	          onError = _props.onError,
	          onSizeError = _props.onSizeError,
	          props = _objectWithoutProperties(_props, ['maxSize', 'readAs', 'onLoad', 'onLoadStart', 'onLoadEnd', 'onProgress', 'onAbort', 'onError', 'onSizeError']);
	
	      return _react2.default.createElement(_FileInput2.default, _extends({}, props, { onChange: this._handleUpload }));
	    }
	  }]);
	
	  return FileUpload;
	}(_react.PureComponent);
	
	FileUpload.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the label.
	   */
	  labelStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the label.
	   */
	  labelClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the `FileInput` should be styled with the primary color.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `FileInput` should be styled with the secondary color.
	   */
	  secondary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `FileInput` should be styled as a flat button instead of a
	   * raised button.
	   */
	  flat: _propTypes2.default.bool,
	
	  /**
	   * This should be a comma separated list of Media Types that the `FileInput` can
	   * accept. If this prop is left blank, any file will be accepted.
	   *
	   * The values can either be:
	   * - A file extension
	   * - audio/*
	   * - video/*
	   * - image/*
	   * - any valid [IANA Media Type](http://www.iana.org/assignments/media-types/media-types.xhtml)
	   */
	  accept: _propTypes2.default.string,
	
	  /**
	   * Boolean if multiple files will be accepted.
	   */
	  multiple: _propTypes2.default.bool,
	
	  /**
	   * A label to display on the `FileInput`.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * The icon children to use for the upload icon.
	   */
	  iconChildren: _propTypes2.default.node,
	
	  /**
	   * The icon className to use for the upload icon.
	   */
	  iconClassName: _propTypes2.default.string,
	
	  /**
	   * An optional max size for the file. If the file is greater than
	   * this limit, the file will not be uploaded.
	   */
	  maxSize: _propTypes2.default.number,
	
	  /**
	   * A required function to call when the `maxSize` prop is set. It will
	   * be given a list of files that were too big.
	   */
	  onSizeError: function onSizeError(props, propName, component) {
	    for (var _len2 = arguments.length, others = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	      others[_key2 - 3] = arguments[_key2];
	    }
	
	    if (typeof props.maxSize === 'number') {
	      var _PropTypes$func;
	
	      return (_PropTypes$func = _propTypes2.default.func).isRequired.apply(_PropTypes$func, [props, propName, component].concat(others));
	    }
	
	    return null;
	  },
	
	  /**
	   * You can force the `FileReader` to read the file as a specific type
	   * if you do not trust the *amazing* regex I have for choosing the correct
	   * one.
	   *
	   * ```js
	   * if(type.match(/image|video|audio/)) {
	   *   fr.readAsDataURL(file);
	   * } else if(type.match(/application|model|multipart/)) {
	   *   fr.readAsArrayBuffer(file);
	   * } else {
	   *   fr.readAsText(file);
	   * }
	   * ```
	   *
	   * > `.yml` and `.js` both are considered `application`, so it definitely fails there.
	   *
	   * If this prop is a function, you will be given the file's type, the file object, and
	   * the file reader. You will then need to call `fileReader.readAsYOUR_CORRECT_TYPE(file)`.
	   */
	  readAs: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['DataURL', 'ArrayBuffer', 'Text']), _propTypes2.default.func]),
	
	  /**
	   * An optional function to call when the `FileUpload` aborts. The current
	   * file and the abort event are given. This might not be the most useful
	   * function to use since you will need to manually call abort yourself anyways.
	   */
	  onAbort: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `FileUpload` errors. The current
	   * file, the error, and the error event are given.
	   *
	   * ```js
	   * onError(file, event.target.error, event);
	   * ```
	   */
	  onError: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `FileUpload` loads. The current
	   * file, the load result, and the load event are given.
	   *
	   * ```js
	   * onLoad(file, event.target.result, event);
	   * ```
	   *
	   * The load result will either be:
	   * - a data URL
	   * - a plain text string
	   * - an array buffer
	   *
	   * depending on what type the file is.
	   */
	  onLoad: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `FileUpload` starts loading. The current
	   * file and the load start event are given.
	   */
	  onLoadStart: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `FileUpload` finishes loading. The
	   * current file and the load end event are given.
	   */
	  onLoadEnd: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `FileUpload` progress. The current
	   * file, upload progress, and the progress event are given. The progress
	   * will be a number between 0 and 100 that has not been rounded.
	   *
	   * ```js
	   * onProgress(file, progress, event);
	   * ```
	   */
	  onProgress: _propTypes2.default.func,
	
	  /**
	   * Boolean if the same file is allowed to be uploaded multiple times. This will basically make the
	   * `value` of the file input always blank.
	   */
	  allowDuplicates: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when a file selects or unselects a file.
	   * This will be called before any local uploading occurs.
	   *
	   * ```js
	   * onChange(file(s) || null, event);
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional value to apply to the `FileInput`. This is usually not needed and the
	   * `allowDuplicates` is what you are probably looking for instead.
	   *
	   * @see {@link #allowDuplicates}
	   */
	  value: _propTypes2.default.string
	};
	exports.default = FileUpload;
	//# sourceMappingURL=FileUpload.js.map

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FileUpload = exports.FileInput = undefined;
	
	var _FileInput2 = __webpack_require__(269);
	
	var _FileInput3 = _interopRequireDefault(_FileInput2);
	
	var _FileUpload2 = __webpack_require__(587);
	
	var _FileUpload3 = _interopRequireDefault(_FileUpload2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FileInput3.default;
	exports.FileInput = _FileInput3.default;
	exports.FileUpload = _FileUpload3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Grid = __webpack_require__(272);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Cell = __webpack_require__(271);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DIFF_KEYS = ['className', 'cellClassName', 'stacked', 'container', 'noSpacing', 'gutter', 'spacing', 'align', 'position', 'size', 'offset', 'order', 'phoneSize', 'phoneOrder', 'phoneOffset', 'phoneHidden', 'tabletSize', 'tabletOrder', 'tabletOffset', 'tabletHidden', 'desktopSize', 'desktopOrder', 'desktopOffset', 'desktopHidden'];
	
	var GridList = function (_PureComponent) {
	  _inherits(GridList, _PureComponent);
	
	  _createClass(GridList, null, [{
	    key: 'getClassNames',
	
	
	    /**
	     * A utility function to get the grid's className based on the `Grid`'s and `Cell`'s
	     * props. This is * used behind the scenes to merge and create the className for the grid.
	     *
	     * ### Example:
	     * ```js
	     * const { className, cellClassName } = GridList.getClassNames();
	     * const { className, cellClassName } = GridList.getClassNames({ size: 1, container: 'custom' });
	     * ```
	     *
	     * @param {Object=} props - This should be an object of the `Grid`'s props. It
	     *    will extract the needed keys and generate the classNames.
	     * @return {Object} an object containing the `className` and `cellClassName` attributes.
	     */
	    value: function getClassNames() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var className = props.className,
	          cellClassName = props.cellClassName,
	          remaining = _objectWithoutProperties(props, ['className', 'cellClassName']);
	
	      return {
	        className: _Grid2.default.getClassName(_extends({ className: className }, remaining)),
	        cellClassName: _Cell2.default.getClassName(_extends({ className: cellClassName }, remaining))
	      };
	    }
	  }]);
	
	  function GridList(props) {
	    _classCallCheck(this, GridList);
	
	    var _this = _possibleConstructorReturn(this, (GridList.__proto__ || Object.getPrototypeOf(GridList)).call(this));
	
	    _this.state = GridList.getClassNames(props);
	    return _this;
	  }
	
	  _createClass(GridList, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState(GridList.getClassNames(this.props));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (DIFF_KEYS.some(function (key) {
	        return _this2.props[key] !== nextProps[key];
	      })) {
	        this.setState(GridList.getClassNames(nextProps));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          className = _state.className,
	          cellClassName = _state.cellClassName;
	
	      var _props = this.props,
	          style = _props.style,
	          cellStyle = _props.cellStyle,
	          Component = _props.component,
	          children = _props.children,
	          propClassName = _props.className,
	          propCellClassName = _props.cellClassName,
	          container = _props.container,
	          noSpacing = _props.noSpacing,
	          stacked = _props.stacked,
	          gutter = _props.gutter,
	          spacing = _props.spacing,
	          align = _props.align,
	          position = _props.position,
	          size = _props.size,
	          offset = _props.offset,
	          order = _props.order,
	          phoneSize = _props.phoneSize,
	          phoneOrder = _props.phoneOrder,
	          phoneOffset = _props.phoneOffset,
	          phoneHidden = _props.phoneHidden,
	          tabletSize = _props.tabletSize,
	          tabletOrder = _props.tabletOrder,
	          tabletOffset = _props.tabletOffset,
	          tabletHidden = _props.tabletHidden,
	          desktopSize = _props.desktopSize,
	          desktopOrder = _props.desktopOrder,
	          desktopOffset = _props.desktopOffset,
	          desktopHidden = _props.desktopHidden,
	          props = _objectWithoutProperties(_props, ['style', 'cellStyle', 'component', 'children', 'className', 'cellClassName', 'container', 'noSpacing', 'stacked', 'gutter', 'spacing', 'align', 'position', 'size', 'offset', 'order', 'phoneSize', 'phoneOrder', 'phoneOffset', 'phoneHidden', 'tabletSize', 'tabletOrder', 'tabletOffset', 'tabletHidden', 'desktopSize', 'desktopOrder', 'desktopOffset', 'desktopHidden']);
	
	      if (typeof children === 'function') {
	        return children({ style: style, className: className, cellStyle: cellStyle, cellClassName: cellClassName });
	      }
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, { style: style, className: className }),
	        _react2.default.Children.map(children, function (child) {
	          if (!child) {
	            return child;
	          }
	
	          var childStyle = child.props.style;
	          if (cellStyle) {
	            childStyle = childStyle ? _extends({}, cellStyle, childStyle) : cellStyle;
	          }
	
	          return _react2.default.cloneElement(child, {
	            style: childStyle,
	            className: (0, _classnames2.default)(child.props.className, cellClassName)
	          });
	        })
	      );
	    }
	  }]);
	
	  return GridList;
	}(_react.PureComponent);
	
	GridList.propTypes = {
	  /**
	   * An optional style to apply to the Grid component. This will only be applied
	   * if the `children` prop is not a callback function.
	   *
	   * @see {@link #children}
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the Grid component. This will only be applied
	   * if the `children` prop is not a callback function.
	   *
	   * @see {@link #children}
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to each child. This will only be applied
	   * if the `children` prop is not a callback function.
	   *
	   * @see {@link #children}
	   */
	  cellStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to each child. This will only be applied
	   * if the `children` prop is not a callback function.
	   *
	   * @see {@link #children}
	   */
	  cellClassName: _propTypes2.default.string,
	
	  /**
	   * The component to render the Cell as. This should probably not be used as much
	   * as the `children` callback function.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	
	  /**
	   * The children can either be renderable React elements or a callback function
	   * that accepts the style and className props to apply so that the styles can
	   * be manually added to whichever component.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	
	  /**
	   * An optional container name to apply to the Grid. This should be the same name as provided
	   * to the [react-md-make-grid-container](/components/grids?tab=2#mixin-react-md-make-grid-container) mixin.
	   */
	  container: _propTypes2.default.string,
	
	  /**
	   * Boolean if the grid should be placed vertically instead of horizontally.
	   */
	  stacked: _propTypes2.default.bool,
	
	  /**
	   * Boolean if all the gutters and spacing should be removed from the grid.
	   */
	  noSpacing: _propTypes2.default.bool,
	
	  /**
	   * When the [react-md-make-custom-grid](/components/grids?tab=2#mixin-react-md-make-custom-grid) mixin
	   * is used, you can use the `gutter` and `spacing` props on the `Grid` to apply the correct className
	   */
	  gutter: _propTypes2.default.number,
	
	  /**
	   * When the [react-md-make-custom-grid](/components/grids?tab=2#mixin-react-md-make-custom-grid) mixin
	   * is used, you can use the `gutter` and `spacing` props on the `Grid` to apply the correct className
	   */
	  spacing: _propTypes2.default.number,
	
	  /**
	   * An optional cell alignment to apply. When the `Grid` is not `stacked`,
	   * this will apply to vertical alignment within each "row" of the grid.
	   *
	   * Alignments:
	   * - `top` - This will align to the top of the row
	   * - `middle` - This will align to the middle of the row
	   * - `bottom` - This will align to the bottom of the row
	   * - `stretch` - This will make the cell stretch to fill all the available space
	   *   in the row.
	   *
	   * @see {@link #position}
	   */
	  align: _propTypes2.default.oneOf(['top', 'middle', 'bottom', 'stretch']),
	
	  /**
	   * An optional cell position to apply. When the `Grid` is not `stacked`,
	   * this will apply to horizontal alignment within each "row" of the grid.
	   *
	   * Positions:
	   * - `center` - This will align the cell to be within the center of the row. This really
	   *    just applies `margin-left: auto; margin-right: auto`.
	   * - `right` - This will align the cell to the end of the row. This really just applies `margin-left: auto`.
	   *
	   * @see {@link #align}
	   */
	  position: _propTypes2.default.oneOf(['center', 'right']),
	
	  /**
	   * An optional size to apply to the cell. This sizing will be applied across all media sizes.
	   * If the size is greater than the number of columns allowed for the media size, it will just
	   * span the entire width.
	   */
	  size: _propTypes2.default.number,
	
	  /**
	   * An optional order to apply to the cell. This order will be applied across all media sizes.
	   */
	  order: _propTypes2.default.number,
	
	  /**
	   * An optional offset to apply to the cell. This will add spacing to the left of the cell.
	   */
	  offset: _propTypes2.default.number,
	
	  /**
	   * An optional size to apply to the cell only on phones.
	   */
	  phoneSize: _propTypes2.default.number,
	
	  /**
	   * An optional order to apply to the cell only on phones.
	   */
	  phoneOrder: _propTypes2.default.number,
	
	  /**
	   * An optional offset to apply to the cell only on phones.
	   */
	  phoneOffset: _propTypes2.default.number,
	
	  /**
	   * Boolean if the cell should be hidden on phones only.
	   */
	  phoneHidden: _propTypes2.default.bool,
	
	  /**
	   * An optional size to apply to the cell only on tablets.
	   */
	  tabletSize: _propTypes2.default.number,
	
	  /**
	   * An optional order to apply to the cell only on tablets.
	   */
	  tabletOrder: _propTypes2.default.number,
	
	  /**
	   * An optional offset to apply to the cell only on tablets.
	   */
	  tabletOffset: _propTypes2.default.number,
	
	  /**
	   * Boolean if the cell should be hidden on tablets only.
	   */
	  tabletHidden: _propTypes2.default.bool,
	
	  /**
	   * An optional size to apply to the cell only on desktops.
	   */
	  desktopSize: _propTypes2.default.number,
	
	  /**
	   * An optional order to apply to the cell only on desktops.
	   */
	  desktopOrder: _propTypes2.default.number,
	
	  /**
	   * An optional offset to apply to the cell only on desktops.
	   */
	  desktopOffset: _propTypes2.default.number,
	
	  /**
	   * Boolean if the cell should be hidden on desktops only.
	   */
	  desktopHidden: _propTypes2.default.bool
	};
	GridList.defaultProps = {
	  component: 'div',
	  stacked: false,
	  noSpacing: false,
	  phoneHidden: false,
	  tabletHidden: false,
	  desktopHidden: false
	};
	exports.default = GridList;
	//# sourceMappingURL=GridList.js.map

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GridList = exports.Cell = exports.Grid = undefined;
	
	var _Grid2 = __webpack_require__(272);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _Cell2 = __webpack_require__(271);
	
	var _Cell3 = _interopRequireDefault(_Cell2);
	
	var _GridList2 = __webpack_require__(589);
	
	var _GridList3 = _interopRequireDefault(_GridList2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Grid3.default;
	exports.Grid = _Grid3.default;
	exports.Cell = _Cell3.default;
	exports.GridList = _GridList3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ResizeObserver = exports.Portal = exports.Layover = exports.IconSeparator = exports.FocusContainer = exports.Collapse = exports.AccessibleFakeInkedButton = exports.AccessibleFakeButton = undefined;
	
	var _AccessibleFakeButton2 = __webpack_require__(80);
	
	var _AccessibleFakeButton3 = _interopRequireDefault(_AccessibleFakeButton2);
	
	var _AccessibleFakeInkedButton2 = __webpack_require__(29);
	
	var _AccessibleFakeInkedButton3 = _interopRequireDefault(_AccessibleFakeInkedButton2);
	
	var _Collapse2 = __webpack_require__(46);
	
	var _Collapse3 = _interopRequireDefault(_Collapse2);
	
	var _FocusContainer2 = __webpack_require__(273);
	
	var _FocusContainer3 = _interopRequireDefault(_FocusContainer2);
	
	var _IconSeparator2 = __webpack_require__(61);
	
	var _IconSeparator3 = _interopRequireDefault(_IconSeparator2);
	
	var _Layover2 = __webpack_require__(109);
	
	var _Layover3 = _interopRequireDefault(_Layover2);
	
	var _Portal2 = __webpack_require__(62);
	
	var _Portal3 = _interopRequireDefault(_Portal2);
	
	var _ResizeObserver2 = __webpack_require__(32);
	
	var _ResizeObserver3 = _interopRequireDefault(_ResizeObserver2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AccessibleFakeButton = _AccessibleFakeButton3.default;
	exports.AccessibleFakeInkedButton = _AccessibleFakeInkedButton3.default;
	exports.Collapse = _Collapse3.default;
	exports.FocusContainer = _FocusContainer3.default;
	exports.IconSeparator = _IconSeparator3.default;
	exports.Layover = _Layover3.default;
	exports.Portal = _Portal3.default;
	exports.ResizeObserver = _ResizeObserver3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CSSTransitionGroupTick = __webpack_require__(34);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Ink = function (_PureComponent) {
	  _inherits(Ink, _PureComponent);
	
	  function Ink(props) {
	    _classCallCheck(this, Ink);
	
	    var _this = _possibleConstructorReturn(this, (Ink.__proto__ || Object.getPrototypeOf(Ink)).call(this, props));
	
	    _this.state = {
	      active: false,
	      expanded: false,
	      pulsing: false,
	      leaving: false
	    };
	    return _this;
	  }
	
	  _createClass(Ink, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.props.aborted && nextProps.aborted) {
	        if (this._timeout) {
	          clearTimeout(this._timeout);
	        }
	
	        if (this._abort) {
	          this._abort();
	        }
	
	        this.setState({ active: false, expanding: false, pulsing: false, leaving: false });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(cb) {
	      var _this2 = this;
	
	      if (this.props.aborted) {
	        cb();
	        return;
	      }
	
	      var _props = this.props,
	          transitionOverlap = _props.transitionOverlap,
	          transitionEnterTimeout = _props.transitionEnterTimeout;
	
	      this._abort = cb;
	
	      this._timeout = setTimeout(function () {
	        _this2._timeout = setTimeout(function () {
	          _this2._timeout = null;
	          _this2._abort = null;
	
	          cb();
	        }, transitionEnterTimeout - transitionOverlap);
	
	        _this2.setState({ expanded: true });
	      }, _CSSTransitionGroupTick2.default);
	
	      this.setState({ active: true });
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      var _this3 = this;
	
	      if (this.props.pulse) {
	        this._timeout = setTimeout(function () {
	          _this3._timeout = null;
	
	          _this3.setState({ pulsing: true });
	        }, this.props.transitionEnterTimeout);
	      }
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(cb) {
	      var _this4 = this;
	
	      if (this.props.aborted) {
	        cb();
	        return;
	      }
	
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	
	      this._abort = cb;
	      this._timeout = setTimeout(function () {
	        _this4._timeout = null;
	
	        cb();
	      }, this.props.transitionLeaveTimeout);
	
	      this.setState({ pulsing: false, leaving: true });
	    }
	  }, {
	    key: 'componentDidLeave',
	    value: function componentDidLeave() {
	      if (!this.props.aborted && this.props.onRemove) {
	        this.props.onRemove();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          style = _props2.style,
	          className = _props2.className,
	          left = _props2.left,
	          top = _props2.top,
	          size = _props2.size;
	      var _state = this.state,
	          active = _state.active,
	          expanded = _state.expanded,
	          pulsing = _state.pulsing,
	          leaving = _state.leaving;
	
	
	      return _react2.default.createElement('span', {
	        style: Object.assign({}, style, {
	          left: left,
	          top: top,
	          height: size,
	          width: size
	        }),
	        className: (0, _classnames2.default)('md-ink', {
	          'md-ink--active': active,
	          'md-ink--expanded': expanded,
	          'md-ink--pulsing': pulsing,
	          'md-ink--leaving': leaving
	        }, className)
	      });
	    }
	  }]);
	
	  return Ink;
	}(_react.PureComponent);
	
	Ink.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  aborted: _propTypes2.default.bool,
	  onRemove: _propTypes2.default.func,
	  left: _propTypes2.default.number.isRequired,
	  top: _propTypes2.default.number.isRequired,
	  size: _propTypes2.default.number.isRequired,
	  transitionOverlap: _propTypes2.default.number.isRequired,
	  transitionEnterTimeout: _propTypes2.default.number.isRequired,
	  transitionLeaveTimeout: _propTypes2.default.number.isRequired,
	  pulse: _propTypes2.default.bool
	};
	exports.default = Ink;
	//# sourceMappingURL=Ink.js.map

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(9);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(190);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keyCodes = __webpack_require__(15);
	
	var _isFormPartRole = __webpack_require__(307);
	
	var _isFormPartRole2 = _interopRequireDefault(_isFormPartRole);
	
	var _calcPageOffset = __webpack_require__(301);
	
	var _calcPageOffset2 = _interopRequireDefault(_calcPageOffset);
	
	var _isValidClick = __webpack_require__(177);
	
	var _isValidClick2 = _interopRequireDefault(_isValidClick);
	
	var _touches = __webpack_require__(84);
	
	var _captureNextEvent = __webpack_require__(82);
	
	var _captureNextEvent2 = _interopRequireDefault(_captureNextEvent);
	
	var _calculateHypotenuse = __webpack_require__(673);
	
	var _calculateHypotenuse2 = _interopRequireDefault(_calculateHypotenuse);
	
	var _Ink = __webpack_require__(592);
	
	var _Ink2 = _interopRequireDefault(_Ink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `InkContainer` is used for holding the list of inks that get created by touch,
	 * click, or keyboard focus.
	 *
	 * If the container element has the `type="submit"` attribute, the ink will also be
	 * triggered when the user presses enter anywhere in the form.
	 */
	var InkContainer = function (_PureComponent) {
	  _inherits(InkContainer, _PureComponent);
	
	  function InkContainer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InkContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InkContainer.__proto__ || Object.getPrototypeOf(InkContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = { inks: [] }, _this.createInk = function (pageX, pageY) {
	      _this._createInk(pageX, pageY);
	      _this._removeTimeout = setTimeout(function () {
	        _this._removeTimeout = null;
	        _this._removeInk();
	      }, _this.props.transitionOverlap);
	    }, _this.focus = function () {
	      _this._getKeyboardContainer().focus();
	    }, _this._createInk = function (pageX, pageY) {
	      var _this$_inkContainer = _this._inkContainer,
	          offsetWidth = _this$_inkContainer.offsetWidth,
	          offsetHeight = _this$_inkContainer.offsetHeight;
	
	
	      var x = void 0;
	      var y = void 0;
	      if (typeof pageX !== 'undefined' && typeof pageY !== 'undefined') {
	        var pageOffset = (0, _calcPageOffset2.default)(_this._inkContainer);
	
	        x = pageX - pageOffset.left;
	        y = pageY - pageOffset.top;
	      } else {
	        x = offsetWidth / 2;
	        y = offsetHeight / 2;
	      }
	
	      var r = Math.max((0, _calculateHypotenuse2.default)(x, y), (0, _calculateHypotenuse2.default)(offsetWidth - x, y), (0, _calculateHypotenuse2.default)(offsetWidth - x, offsetHeight - y), (0, _calculateHypotenuse2.default)(x, offsetHeight - y));
	
	      var ink = {
	        left: x - r,
	        top: y - r,
	        size: r * 2,
	        key: Date.now()
	      };
	
	      var inks = _this.state.inks.slice();
	      inks.push(ink);
	      _this.setState({ inks: inks });
	    }, _this._removeInk = function () {
	      var inks = _this.state.inks.slice();
	      inks.pop();
	
	      _this.setState({ inks: inks });
	    }, _this._getKeyboardContainer = function () {
	      if (_this._container.classList.contains('md-text-field-container')) {
	        return _this._container.querySelector('.md-text-field');
	      }
	
	      return _this._container;
	    }, _this._setContainers = function (group) {
	      if (group !== null) {
	        _this._inkContainer = (0, _reactDom.findDOMNode)(group);
	        _this._container = _this._inkContainer.parentElement;
	
	        if (_this._container) {
	          _this._initOrRemoveEvents(_this.props);
	        }
	      }
	    }, _this._initOrRemoveEvents = function (props) {
	      var keyboardDiff = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var mouseDiff = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	      var touchDiff = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	      var mouseDisabled = _this._isListenerDisabled('mouse', props.disabledInteractions);
	      var touchDisabled = _this._isListenerDisabled('touch', props.disabledInteractions);
	      var keyboardDisabled = _this._isListenerDisabled('keyboard', props.disabledInteractions);
	
	      if (keyboardDiff) {
	        var fn = (keyboardDisabled ? 'remove' : 'add') + 'EventListener';
	        _this._getKeyboardContainer()[fn]('focus', _this._handleFocus);
	        _this._getKeyboardContainer()[fn]('keydown', _this._handleKeyDown);
	
	        if (_this._container.getAttribute('type') === 'submit') {
	          window[fn]('submit', _this._handleSubmit);
	        }
	
	        if (mouseDiff) {
	          _this._container[(!mouseDisabled ? 'add' : 'remove') + 'EventListener']('mousedown', _this._stopPropagationToFocus);
	        }
	
	        if (touchDiff) {
	          (0, _touches.setTouchEvent)(!touchDisabled, _this._container, 'start', _this._stopPropagationToFocus);
	        }
	      }
	
	      if (mouseDiff) {
	        var _fn = (mouseDisabled ? 'remove' : 'add') + 'EventListener';
	        _this._container[_fn]('mousedown', _this._handleMouseDown);
	        _this._container[_fn]('mouseup', _this._handleMouseUp);
	      }
	
	      if (touchDiff) {
	        (0, _touches.setTouchEvent)(!touchDisabled, _this._container, 'start', _this._handleTouchStart);
	        (0, _touches.setTouchEvent)(!touchDisabled, _this._container, 'end', _this._handleTouchEnd);
	      }
	    }, _this._maybeDelayClick = function () {
	      if (!_this.props.waitForInkTransition) {
	        return;
	      }
	
	      (0, _captureNextEvent2.default)('click', _this._container);
	    }, _this._handleRemove = function () {
	      if (_this._clicked && _this.props.waitForInkTransition) {
	        // For some reason if the click event will make the ink unmount, it will no longer
	        // have a debug id in the TransitionGroup and it displays a warning. Adding a 1ms timeout
	        // fixes that issue... It only happens on an actual click instead of an enter click.
	        setTimeout(function () {
	          _this._container.click();
	        }, 1);
	      }
	
	      _this._clicked = false;
	    }, _this._handleKeyDown = function (e) {
	      var key = e.which || e.keyCode;
	      var enter = key === _keyCodes.ENTER;
	      var space = key === _keyCodes.SPACE;
	      // Don't trigger ink when enter key is pressed and the target has an input inside of it (SelectField)
	      if (space || enter && !(0, _isFormPartRole2.default)(e.target) && !e.target.querySelector('input')) {
	        _this._clicked = true;
	        _this.createInk();
	        _this._maybeDelayClick();
	      }
	    }, _this._handleFocus = function () {
	      if (_this._clicked) {
	        return;
	      }
	
	      _this._createInk();
	      _this._getKeyboardContainer().addEventListener('blur', _this._handleBlur);
	    }, _this._handleBlur = function () {
	      _this._getKeyboardContainer().removeEventListener('blur', _this._handleBlur);
	      _this._removeInk();
	    }, _this._handleMouseDown = function (e) {
	      _this._clicked = true;
	      if (!(0, _isValidClick2.default)(e) || _this._skipNextMouse) {
	        _this._skipNextMouse = false;
	        return;
	      }
	
	      _this._mouseLeave = false;
	      _this._container.addEventListener('mouseleave', _this._handleMouseLeave);
	      _this._createInk(e.pageX, e.pageY);
	    }, _this._handleMouseLeave = function () {
	      _this._container.removeEventListener('mouseleave', _this._handleMouseLeave);
	      _this._mouseLeave = true;
	      _this._removeInk();
	    }, _this._handleMouseUp = function () {
	      if (_this._mouseLeave) {
	        return;
	      }
	
	      _this._maybeDelayClick();
	      _this._container.removeEventListener('mouseleave', _this._handleMouseLeave);
	      _this._removeInk();
	    }, _this._handleTouchStart = function (e) {
	      _this._aborted = false;
	      _this._clicked = true;
	      _this._skipNextMouse = true;
	      (0, _touches.addTouchEvent)(window, 'move', _this._handleTouchMove);
	
	      var _e$changedTouches$ = e.changedTouches[0],
	          pageX = _e$changedTouches$.pageX,
	          pageY = _e$changedTouches$.pageY;
	
	      _this._createInk(pageX, pageY);
	    }, _this._handleTouchMove = function () {
	      (0, _touches.removeTouchEvent)(window, 'move', _this._handleTouchMove);
	      var lastInk = _this.state.inks[_this.state.inks.length - 1];
	      if (!lastInk || Date.now() > lastInk.key + 200) {
	        _this._aborted = false;
	        return;
	      }
	
	      var inks = _this.state.inks.slice();
	      var index = inks.length - 1;
	
	      var abortedInk = Object.assign({}, lastInk, { aborted: true });
	      inks.splice(index, 1, abortedInk);
	
	      _this._aborted = true;
	      _this.setState({ inks: inks }, _this._removeInk);
	    }, _this._handleTouchEnd = function () {
	      _this._skipNextMouse = true;
	
	      if (_this._aborted) {
	        return;
	      } else {
	        (0, _touches.removeTouchEvent)(window, 'move', _this._handleTouchMove);
	      }
	
	      _this._removeInk();
	    }, _this._handleSubmit = function (e) {
	      if (document.activeElement === _this._container || !e.target.contains(_this._container)) {
	        return;
	      }
	
	      _this._maybeDelayClick();
	      _this.createInk();
	    }, _this._stopPropagationToFocus = function (e) {
	      switch (e.type) {
	        case 'touchstart':
	          (0, _touches.addTouchEvent)(window, 'end', _this._stopPropagationToFocus, { capture: true });
	          break;
	        case 'touchend':
	          (0, _touches.removeTouchEvent)(window, 'end', _this._stopPropagationToFocus, { capture: true });
	          break;
	        case 'mousedown':
	          window.addEventListener('mouseup', _this._stopPropagationToFocus, true);
	          break;
	        case 'mouseup':
	          window.removeEventListener('mouseup', _this._stopPropagationToFocus, true);
	          break;
	        default:
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InkContainer, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var di = this.props.disabledInteractions;
	      var ndi = nextProps.disabledInteractions;
	
	      if (di === ndi || !this._container) {
	        return;
	      }
	
	      var mouseDisabledDiff = this._isListenerDisabledDiff('mouse', di, ndi);
	      var touchDisabledDiff = this._isListenerDisabledDiff('touch', di, ndi);
	      var keyboardDisabledDiff = this._isListenerDisabledDiff('keyboard', di, ndi);
	      this._initOrRemoveEvents(nextProps, keyboardDisabledDiff, mouseDisabledDiff, touchDisabledDiff);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._removeTimeout) {
	        clearTimeout(this._removeTimeout);
	      }
	
	      if (this._container) {
	        this._initOrRemoveEvents({ disabledInteractions: ['keyboard', 'mouse', 'touch'] });
	        this._getKeyboardContainer().removeEventListener('blur', this._handleBlur);
	      }
	    }
	
	    /**
	     * Creates an ink from pageX and pageY coordinates. These values should either come
	     * from the `changedTouches` or just the base event (if clicked). These coordinates
	     * are used to position the ink correctly in the container from touch/click point.
	     * If either value is undefined, an ink will be created from the center of the
	     * container.
	     *
	     * It will also automatically remove the ink.
	     *
	     * @param {number} pageX - The page x coordinate of the click or touch event.
	     * @param {number} pageY - The page y coordinate of the click or touch event.
	     */
	
	
	    /**
	     * Focuses the main element.
	     */
	
	  }, {
	    key: '_isListenerDisabledDiff',
	    value: function _isListenerDisabledDiff(interaction, disabledInteractions, nextDisabledInteractions) {
	      var i = disabledInteractions.indexOf(interaction);
	      var ni = nextDisabledInteractions.indexOf(interaction);
	
	      return i < 0 && ni >= 0 || i >= 0 && ni < 0;
	    }
	  }, {
	    key: '_isListenerDisabled',
	    value: function _isListenerDisabled(interaction, disabledInteractions) {
	      return disabledInteractions && disabledInteractions.indexOf(interaction) !== -1;
	    }
	
	    /**
	     * Creates an ink from pageX and pageY coordinates. These values should either come
	     * from the `changedTouches` or just the base event (if clicked). These coordinates
	     * are used to position the ink correctly in the container from touch/click point.
	     * If either value is undefined, an ink will be created from the center of the
	     * container.
	     *
	     * @param {number} pageX - The page x coordinate of the click or touch event.
	     * @param {number} pageY - The page y coordinate of the click or touch event.
	     */
	
	
	    /**
	     * Removes an ink from the container.
	     */
	
	
	    /**
	     * Gets the container for any keyboard events. This will almost always be the main element,
	     * but text fields will need to be the input itself.
	     */
	
	
	    /**
	     * Sets the ink container and the main container from the ref callback. When the component
	     * is mounting, the keyboard, mouse, and keyboard events will be initialized.
	     */
	
	
	    /**
	     * This function will either add or remove the event listeners for creating inks.
	     *
	     * @param {Object} props - The current props to use for figuring out if the events should
	     *    be added or removed.
	     * @param {bool=} keyboardDiff - Boolean if there was a difference between the current props and either
	     *    the previous or next props for the keyboard interactions being disabled.
	     * @param {bool=} mouseDiff - Boolean if there was a difference between the current props and either
	     *    the previous or next props for the mouse interactions being disabled.
	     * @param {bool=} touchDiff - Boolean if there was a difference between the current props and either
	     *    the previous or next props for the touch interactions being disabled.
	     */
	
	
	    /**
	     * If a form was submitted that contains the container of the ink and the current focus element
	     * is not the container, trigger an ink effect.
	     *
	     * The current focus check is added so that two inks are not created.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          inkStyle = _props.inkStyle,
	          inkClassName = _props.inkClassName,
	          transitionOverlap = _props.transitionOverlap,
	          transitionEnterTimeout = _props.transitionEnterTimeout,
	          transitionLeaveTimeout = _props.transitionLeaveTimeout,
	          pulse = _props.pulse;
	
	      var inks = this.state.inks.map(function (props) {
	        return _react2.default.createElement(_Ink2.default, _extends({}, props, {
	          pulse: pulse,
	          style: inkStyle,
	          className: inkClassName,
	          onRemove: _this2._handleRemove,
	          transitionOverlap: transitionOverlap,
	          transitionEnterTimeout: transitionEnterTimeout,
	          transitionLeaveTimeout: transitionLeaveTimeout
	        }));
	      });
	
	      return _react2.default.createElement(
	        _TransitionGroup2.default,
	        {
	          component: 'div',
	          style: style,
	          className: (0, _classnames2.default)('md-ink-container', className),
	          ref: this._setContainers
	        },
	        inks
	      );
	    }
	  }]);
	
	  return InkContainer;
	}(_react.PureComponent);
	
	InkContainer.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  inkStyle: _propTypes2.default.object,
	  inkClassName: _propTypes2.default.string,
	  waitForInkTransition: _propTypes2.default.bool,
	  disabledInteractions: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['keyboard', 'mouse', 'touch'])),
	  transitionOverlap: _propTypes2.default.number.isRequired,
	  transitionEnterTimeout: _propTypes2.default.number.isRequired,
	  transitionLeaveTimeout: _propTypes2.default.number.isRequired,
	  pulse: _propTypes2.default.bool
	};
	InkContainer.defaultProps = {
	  transitionOverlap: 150,
	  transitionEnterTimeout: 450,
	  transitionLeaveTimeout: 300
	};
	exports.default = InkContainer;
	//# sourceMappingURL=InkContainer.js.map

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.injectInk = undefined;
	
	var _injectInk2 = __webpack_require__(171);
	
	var _injectInk3 = _interopRequireDefault(_injectInk2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _injectInk3.default;
	exports.injectInk = _injectInk3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  inkDisabled: _propTypes2.default.bool,
	  inkDisabledInteractions: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['keyboard', 'mouse', 'touch']))
	};
	//# sourceMappingURL=inkContextTypes.js.map

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(12);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _ListItemText = __webpack_require__(277);
	
	var _ListItemText2 = _interopRequireDefault(_ListItemText);
	
	var _TileAddon = __webpack_require__(172);
	
	var _TileAddon2 = _interopRequireDefault(_TileAddon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListItemControl = function (_PureComponent) {
	  _inherits(ListItemControl, _PureComponent);
	
	  function ListItemControl() {
	    _classCallCheck(this, ListItemControl);
	
	    return _possibleConstructorReturn(this, (ListItemControl.__proto__ || Object.getPrototypeOf(ListItemControl)).apply(this, arguments));
	  }
	
	  _createClass(ListItemControl, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          tileStyle = _props.tileStyle,
	          tileClassName = _props.tileClassName,
	          primaryAction = _props.primaryAction,
	          secondaryAction = _props.secondaryAction,
	          primaryText = _props.primaryText,
	          secondaryText = _props.secondaryText,
	          threeLines = _props.threeLines,
	          leftIcon = _props.leftIcon,
	          leftAvatar = _props.leftAvatar,
	          rightIcon = _props.rightIcon,
	          rightAvatar = _props.rightAvatar,
	          props = _objectWithoutProperties(_props, ['className', 'tileStyle', 'tileClassName', 'primaryAction', 'secondaryAction', 'primaryText', 'secondaryText', 'threeLines', 'leftIcon', 'leftAvatar', 'rightIcon', 'rightAvatar']);
	
	      var control = _react.Children.only(primaryAction || secondaryAction);
	      var text = _react2.default.createElement(_ListItemText2.default, {
	        key: 'text',
	        primaryText: control.props.label || primaryText,
	        secondaryText: secondaryText,
	        className: (0, _classnames2.default)({
	          'md-tile-content--left-icon': leftIcon,
	          'md-tile-content--left-avatar': leftAvatar,
	          'md-tile-content--left-button': primaryAction,
	          'md-tile-content--right-padding': primaryAction
	        })
	      });
	      control = (0, _react.cloneElement)(control, {
	        className: (0, _classnames2.default)('md-list-control', {
	          'md-list-control--right': secondaryAction
	        }, control.props.className),
	        label: text
	      });
	
	      var leftNode = _react2.default.createElement(_TileAddon2.default, {
	        key: 'left-addon',
	        icon: leftIcon,
	        avatar: leftAvatar
	      });
	
	      var rightNode = _react2.default.createElement(_TileAddon2.default, {
	        key: 'right-addon',
	        icon: rightIcon,
	        avatar: rightAvatar
	      });
	
	      var icond = !!leftIcon || !!rightIcon;
	      var avatard = !!leftAvatar || !!rightAvatar;
	
	      return _react2.default.createElement(
	        'li',
	        _extends({}, props, { className: (0, _classnames2.default)('md-list-item', className) }),
	        _react2.default.createElement(
	          'div',
	          {
	            style: tileStyle,
	            className: (0, _classnames2.default)('md-list-tile', {
	              'md-list-tile--icon': !secondaryText && icond && !avatard,
	              'md-list-tile--avatar': !secondaryText && avatard,
	              'md-list-tile--two-lines': secondaryText && !threeLines,
	              'md-list-tile--three-lines': secondaryText && threeLines,
	              'md-list-tile--control-left': primaryAction,
	              'md-list-tile--control-right': secondaryAction
	            }, (0, _themeColors2.default)({ text: true }), tileClassName)
	          },
	          leftNode,
	          control,
	          rightNode
	        )
	      );
	    }
	  }]);
	
	  return ListItemControl;
	}(_react.PureComponent);
	
	ListItemControl.propTypes = {
	  /**
	   * An optional style to apply to the `.md-list-item`.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `.md-list-item`.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `.md-list-tile`.
	   */
	  tileStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `.md-list-tile`.
	   */
	  tileClassName: _propTypes2.default.string,
	
	  /**
	   * The primary text to display in the `ListItemControl`. The `primaryAction` or
	   * `secondaryAction` will end up getting the `label` prop injected into it with
	   * a combination of the `primaryText` and `secondaryText`. If the `primaryAction`
	   * or `secondaryAction` already have a label prop, the `label` prop will be used
	   * as the `primaryText`.
	   */
	  primaryText: _propTypes2.default.node,
	
	  /**
	   * An optional secondary text that can be displayed in the label of the `primaryAction`
	   * or `secondaryAction`.
	   */
	  secondaryText: _propTypes2.default.node,
	
	  /**
	   * Boolean if the primary and secondary text will span three lines.
	   */
	  threeLines: _propTypes2.default.bool,
	
	  /**
	   * The primary action of the `ListItemControl`. This _should_ normally
	   * be a type of `SelectionControl`
	   */
	  primaryAction: _propTypes2.default.element,
	
	  /**
	   * The secondary action of the `ListItemControl`. This _should_ normally
	   * be a type of `SelectionControl`. If it is a selection control,
	   * make sure to add the `labelBefore` prop to get correct positioning.
	   */
	  secondaryAction: _propTypes2.default.element,
	
	  /**
	   * An optional `FontIcon` to display to the left of the action.
	   */
	  leftIcon: _propTypes2.default.node,
	
	  /**
	   * An optional `Avatar` to display to the left of the action.
	   */
	  leftAvatar: _propTypes2.default.node,
	
	  /**
	   * An optional `FontIcon` to display to the right of the action.
	   */
	  rightIcon: _propTypes2.default.node,
	
	  /**
	   * An optional `FontIcon` to display to the right of the action.
	   */
	  rightAvatar: _propTypes2.default.node,
	
	  /**
	   * Defines the number of items in the list. This is only required when all items in the
	   * list are not present in the DOM.
	   *
	   * @see https://www.w3.org/TR/wai-aria/states_and_properties#aria-setsize
	   */
	  'aria-setsize': _propTypes2.default.number,
	
	  /**
	   * Defines the items position in the list. This is only required when all items in the list
	   * are not present in the DOM. The custom validation just requires this prop if the `aria-setsize`
	   * prop is defined as a helpful reminder.
	   *
	   * @see https://www.w3.org/TR/wai-aria/states_and_properties#aria-posinset
	   */
	  'aria-posinset': function ariaPosinset(props, propName) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    var validator = _propTypes2.default.number;
	    if (typeof props['aria-setsize'] !== 'undefined') {
	      validator = validator.isRequired;
	    }
	
	    return validator.apply(undefined, [props, propName].concat(args));
	  }
	};
	exports.default = ListItemControl;
	//# sourceMappingURL=ListItemControl.js.map

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ListItemControl = exports.ListItem = exports.List = undefined;
	
	var _List2 = __webpack_require__(81);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _ListItem2 = __webpack_require__(110);
	
	var _ListItem3 = _interopRequireDefault(_ListItem2);
	
	var _ListItemControl2 = __webpack_require__(596);
	
	var _ListItemControl3 = _interopRequireDefault(_ListItemControl2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _List3.default;
	exports.List = _List3.default;
	exports.ListItem = _ListItem3.default;
	exports.ListItemControl = _ListItemControl3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MediaOverlay = exports.Media = undefined;
	
	var _Media2 = __webpack_require__(278);
	
	var _Media3 = _interopRequireDefault(_Media2);
	
	var _MediaOverlay2 = __webpack_require__(279);
	
	var _MediaOverlay3 = _interopRequireDefault(_MediaOverlay2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Media3.default;
	exports.Media = _Media3.default;
	exports.MediaOverlay = _MediaOverlay3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MenuButton = exports.DropdownMenu = exports.Menu = undefined;
	
	var _Menu2 = __webpack_require__(63);
	
	var _Menu3 = _interopRequireDefault(_Menu2);
	
	var _DropdownMenu2 = __webpack_require__(173);
	
	var _DropdownMenu3 = _interopRequireDefault(_DropdownMenu2);
	
	var _MenuButton2 = __webpack_require__(280);
	
	var _MenuButton3 = _interopRequireDefault(_MenuButton2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Menu3.default;
	exports.Menu = _Menu3.default;
	exports.DropdownMenu = _DropdownMenu3.default;
	exports.MenuButton = _MenuButton3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AccessibleFakeInkedButton = __webpack_require__(29);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	var _TileAddon = __webpack_require__(172);
	
	var _TileAddon2 = _interopRequireDefault(_TileAddon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MiniListItem = function (_PureComponent) {
	  _inherits(MiniListItem, _PureComponent);
	
	  function MiniListItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MiniListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MiniListItem.__proto__ || Object.getPrototypeOf(MiniListItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this._handleMouseOver = function (e) {
	      if (_this.props.onMouseOver) {
	        _this.props.onMouseOver(e);
	      }
	
	      if (!_this.props.disabled) {
	        _this.setState({ active: true });
	      }
	    }, _this._handleMouseLeave = function (e) {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(e);
	      }
	
	      if (!_this.props.disabled) {
	        _this.setState({ active: false });
	      }
	    }, _this._handleTouchStart = function (e) {
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(e);
	      }
	
	      _this._touched = true;
	
	      _this.setState({ active: true, touchedAt: Date.now() });
	    }, _this._handleTouchEnd = function (e) {
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(e);
	      }
	
	      var time = Date.now() - _this.state.touchedAt;
	      _this._touchTimeout = setTimeout(function () {
	        _this._touchTimeout = null;
	
	        _this.setState({ active: false });
	      }, time > 450 ? 0 : 450 - time);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MiniListItem, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._touchTimeout) {
	        clearTimeout(this._touchTimeout);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          tileStyle = _props.tileStyle,
	          tileClassName = _props.tileClassName,
	          leftIcon = _props.leftIcon,
	          leftAvatar = _props.leftAvatar,
	          active = _props.active,
	          activeClassName = _props.activeClassName,
	          ItemComponent = _props.itemComponent,
	          primaryText = _props.primaryText,
	          secondaryText = _props.secondaryText,
	          rightIcon = _props.rightIcon,
	          rightAvatar = _props.rightAvatar,
	          threeLines = _props.threeLines,
	          children = _props.children,
	          defaultOpen = _props.defaultOpen,
	          isOpen = _props.isOpen,
	          inset = _props.inset,
	          nestedItems = _props.nestedItems,
	          animateNestedItems = _props.animateNestedItems,
	          expanderIcon = _props.expanderIcon,
	          expanderIconChildren = _props.expanderIconChildren,
	          expanderIconClassName = _props.expanderIconClassName,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'tileStyle', 'tileClassName', 'leftIcon', 'leftAvatar', 'active', 'activeClassName', 'itemComponent', 'primaryText', 'secondaryText', 'rightIcon', 'rightAvatar', 'threeLines', 'children', 'defaultOpen', 'isOpen', 'inset', 'nestedItems', 'animateNestedItems', 'expanderIcon', 'expanderIconChildren', 'expanderIconClassName']);
	
	      return _react2.default.createElement(
	        ItemComponent,
	        { style: style, className: className },
	        _react2.default.createElement(
	          _AccessibleFakeInkedButton2.default,
	          _extends({}, props, {
	            style: tileStyle,
	            className: (0, _classnames2.default)('md-list-tile md-list-tile--icon md-list-tile--mini', {
	              'md-list-tile--active': this.state.active && !this._touched
	            }, tileClassName),
	            onMouseOver: this._handleMouseOver,
	            onMouseLeave: this._handleMouseLeave,
	            onTouchStart: this._handleTouchStart,
	            onTouchEnd: this._handleTouchEnd
	          }),
	          _react2.default.createElement(_TileAddon2.default, {
	            active: active,
	            activeClassName: activeClassName,
	            icon: leftIcon,
	            avatar: leftAvatar
	          })
	        )
	      );
	    }
	  }]);
	
	  return MiniListItem;
	}(_react.PureComponent);
	
	MiniListItem.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  tileStyle: _propTypes2.default.object,
	  tileClassName: _propTypes2.default.string,
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	  active: _propTypes2.default.bool,
	  activeClassName: _propTypes2.default.string,
	  leftIcon: _propTypes2.default.node,
	  leftAvatar: _propTypes2.default.node,
	  disabled: _propTypes2.default.bool,
	  onTouchStart: _propTypes2.default.func,
	  onTouchEnd: _propTypes2.default.func,
	  onMouseOver: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  defaultOpen: _propTypes2.default.bool,
	  itemComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired
	};
	MiniListItem.defaultProps = {
	  activeClassName: 'md-text--theme-primary',
	  component: 'div',
	  itemComponent: 'li'
	};
	exports.default = MiniListItem;
	//# sourceMappingURL=MiniListItem.js.map

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CSSTransitionGroup = __webpack_require__(49);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(17);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _controlled = __webpack_require__(16);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _invalidIf = __webpack_require__(48);
	
	var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	var _Button = __webpack_require__(19);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Drawer = __webpack_require__(170);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _List = __webpack_require__(81);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Toolbar = __webpack_require__(293);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	var _FontIcon = __webpack_require__(13);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(21);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _isType = __webpack_require__(268);
	
	var _JumpToContentLink = __webpack_require__(282);
	
	var _JumpToContentLink2 = _interopRequireDefault(_JumpToContentLink);
	
	var _CloseButton = __webpack_require__(281);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	var _MiniListItem = __webpack_require__(600);
	
	var _MiniListItem2 = _interopRequireDefault(_MiniListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DrawerTypes = _Drawer2.default.DrawerTypes;
	
	
	function getNonMiniType(type) {
	  var pMini = DrawerTypes.PERSISTENT_MINI,
	      tMini = DrawerTypes.TEMPORARY_MINI;
	
	  if ([pMini, tMini].indexOf(type) === -1) {
	    return type;
	  }
	
	  return pMini === type ? DrawerTypes.PERSISTENT : DrawerTypes.TEMPORARY;
	}
	
	function toMiniListItem(item, index) {
	  if ((0, _react.isValidElement)(item)) {
	    return item;
	  }
	
	  var divider = item.divider,
	      subheader = item.subheader,
	      key = item.key,
	      itemProps = _objectWithoutProperties(item, ['divider', 'subheader', 'key']);
	
	  if (divider || subheader) {
	    return null;
	  }
	
	  return _react2.default.createElement(_MiniListItem2.default, _extends({ key: key || index }, itemProps));
	}
	
	/**
	 * The `NavigationDrawer` is used when you want a full layout configuration. It is a combination
	 * of the `Toolbar` component and the `Drawer` component. Any props that are not specifically
	 * listed below will be provided to the `Drawer` component. So if there are props on the `Drawer`
	 * that are not listed here, they will be passed along.
	 *
	 * The main benefit of using this component is that it will manage adding respective offset
	 * classes automatically for you to the content and the drawer. It will also manage using
	 * a mini drawer type for you.
	 */
	
	var NavigationDrawer = function (_PureComponent) {
	  _inherits(NavigationDrawer, _PureComponent);
	
	  _createClass(NavigationDrawer, null, [{
	    key: 'getCurrentMedia',
	
	
	    /**
	     * Determines the current media and returns an object containing matches for `mobile`, `tablet`, `desktop`,
	     * and the current drawer type. This expects a `props` object of the drawer.
	     *
	     * If this is used server side, it will default to only matching mobile.
	     *
	     * @param {Object=} props - The current drawer's prop shape to extract the mobile, tablet, and desktop type/min
	     *    widths. This defaults to the drawer's default props.
	     * @return {Object} an object containing the media matches and the current type to use for the drawer.
	     */
	    value: function getCurrentMedia() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NavigationDrawer.defaultProps;
	
	      var mobileType = props.mobileDrawerType,
	          tabletType = props.tabletDrawerType,
	          desktopType = props.desktopDrawerType,
	          constantType = props.constantDrawerType,
	          others = _objectWithoutProperties(props, ['mobileDrawerType', 'tabletDrawerType', 'desktopDrawerType', 'constantDrawerType']);
	
	      return _Drawer2.default.getCurrentMedia(_extends({ mobileType: mobileType, tabletType: tabletType, desktopType: desktopType, constantType: constantType }, others));
	    }
	  }]);
	
	  function NavigationDrawer(props) {
	    _classCallCheck(this, NavigationDrawer);
	
	    var _this = _possibleConstructorReturn(this, (NavigationDrawer.__proto__ || Object.getPrototypeOf(NavigationDrawer)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var defaultMedia = props.defaultMedia,
	        defaultVisible = props.defaultVisible,
	        initialDrawerType = props.initialDrawerType;
	
	
	    _this.state = {
	      mobile: initialDrawerType || defaultMedia === 'mobile',
	      tablet: initialDrawerType || defaultMedia === 'tablet',
	      desktop: initialDrawerType || defaultMedia === 'desktop'
	    };
	
	    if (typeof props.drawerType === 'undefined') {
	      _this.state.drawerType = props[(initialDrawerType || defaultMedia) + 'DrawerType'];
	    }
	
	    var type = (0, _getField2.default)(props, _this.state, 'drawerType');
	
	    if (typeof props.visible === 'undefined') {
	      // The logic for determining the visibility is handled by the created mini drawer
	      _this.state.visible = (0, _isType.isPermanent)(type);
	      if (!_this.state.visible && typeof defaultVisible !== 'undefined') {
	        _this.state.visible = defaultVisible;
	      }
	    }
	    return _this;
	  }
	
	  _createClass(NavigationDrawer, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _props = this.props,
	          persistentIcon = _props.persistentIcon,
	          id = _props.contentId,
	          label = _props.jumpLabel,
	          persistentIconChildren = _props.persistentIconChildren,
	          persistentIconClassName = _props.persistentIconClassName,
	          closeIconChildren = _props.closeIconChildren,
	          closeIconClassName = _props.closeIconClassName;
	
	
	      return {
	        id: id,
	        label: label,
	        closeIcon: (0, _getDeprecatedIcon2.default)(closeIconClassName || persistentIconClassName, closeIconChildren || persistentIconChildren, persistentIcon),
	        onCloseClick: this._toggleVisibility,
	        renderNode: this.context.renderNode
	      };
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var visible = (0, _getField2.default)(this.props, this.state, 'visible');
	      var nVisible = (0, _getField2.default)(nextProps, this.state, 'visible');
	      if (visible !== nVisible) {
	        this._animate(nextProps);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          id = _props2.id,
	          style = _props2.style,
	          className = _props2.className,
	          toolbarStyle = _props2.toolbarStyle,
	          toolbarClassName = _props2.toolbarClassName,
	          drawerStyle = _props2.drawerStyle,
	          drawerClassName = _props2.drawerClassName,
	          contentStyle = _props2.contentStyle,
	          contentClassName = _props2.contentClassName,
	          Content = _props2.contentComponent,
	          navItems = _props2.navItems,
	          children = _props2.children,
	          drawerId = _props2.drawerId,
	          drawerTitle = _props2.drawerTitle,
	          drawerZDepth = _props2.drawerZDepth,
	          drawerChildren = _props2.drawerChildren,
	          drawerHeaderChildren = _props2.drawerHeaderChildren,
	          drawerTransitionDuration = _props2.drawerTransitionDuration,
	          toolbarId = _props2.toolbarId,
	          toolbarTitle = _props2.toolbarTitle,
	          toolbarTitleMenu = _props2.toolbarTitleMenu,
	          toolbarTitleStyle = _props2.toolbarTitleStyle,
	          toolbarTitleClassName = _props2.toolbarTitleClassName,
	          toolbarActions = _props2.toolbarActions,
	          toolbarProminent = _props2.toolbarProminent,
	          toolbarProminentTitle = _props2.toolbarProminentTitle,
	          toolbarThemeType = _props2.toolbarThemeType,
	          toolbarSingleColor = _props2.toolbarSingleColor,
	          toolbarChildren = _props2.toolbarChildren,
	          toolbarZDepth = _props2.toolbarZDepth,
	          mobileType = _props2.mobileDrawerType,
	          tabletType = _props2.tabletDrawerType,
	          desktopType = _props2.desktopDrawerType,
	          transitionName = _props2.transitionName,
	          transitionEnterTimeout = _props2.transitionEnterTimeout,
	          transitionLeaveTimeout = _props2.transitionLeaveTimeout,
	          extractMini = _props2.extractMini,
	          miniDrawerHeader = _props2.miniDrawerHeader,
	          miniDrawerChildren = _props2.miniDrawerChildren,
	          footer = _props2.footer,
	          includeDrawerHeader = _props2.includeDrawerHeader,
	          contentId = _props2.contentId,
	          contentProps = _props2.contentProps,
	          constantDrawerType = _props2.constantDrawerType,
	          temporaryIcon = _props2.temporaryIcon,
	          temporaryIconChildren = _props2.temporaryIconChildren,
	          temporaryIconClassName = _props2.temporaryIconClassName,
	          menuIconChildren = _props2.menuIconChildren,
	          menuIconClassName = _props2.menuIconClassName,
	          propDrawerType = _props2.drawerType,
	          propDrawerHeader = _props2.drawerHeader,
	          propRenderNode = _props2.renderNode,
	          jumpLabel = _props2.jumpLabel,
	          persistentIcon = _props2.persistentIcon,
	          onDrawerChange = _props2.onDrawerChange,
	          closeIconChildren = _props2.closeIconChildren,
	          closeIconClassName = _props2.closeIconClassName,
	          persistentIconChildren = _props2.persistentIconChildren,
	          persistentIconClassName = _props2.persistentIconClassName,
	          props = _objectWithoutProperties(_props2, ['id', 'style', 'className', 'toolbarStyle', 'toolbarClassName', 'drawerStyle', 'drawerClassName', 'contentStyle', 'contentClassName', 'contentComponent', 'navItems', 'children', 'drawerId', 'drawerTitle', 'drawerZDepth', 'drawerChildren', 'drawerHeaderChildren', 'drawerTransitionDuration', 'toolbarId', 'toolbarTitle', 'toolbarTitleMenu', 'toolbarTitleStyle', 'toolbarTitleClassName', 'toolbarActions', 'toolbarProminent', 'toolbarProminentTitle', 'toolbarThemeType', 'toolbarSingleColor', 'toolbarChildren', 'toolbarZDepth', 'mobileDrawerType', 'tabletDrawerType', 'desktopDrawerType', 'transitionName', 'transitionEnterTimeout', 'transitionLeaveTimeout', 'extractMini', 'miniDrawerHeader', 'miniDrawerChildren', 'footer', 'includeDrawerHeader', 'contentId', 'contentProps', 'constantDrawerType', 'temporaryIcon', 'temporaryIconChildren', 'temporaryIconClassName', 'menuIconChildren', 'menuIconClassName', 'drawerType', 'drawerHeader', 'renderNode', 'jumpLabel', 'persistentIcon', 'onDrawerChange', 'closeIconChildren', 'closeIconClassName', 'persistentIconChildren', 'persistentIconClassName']);
	
	      var drawerHeader = this.props.drawerHeader;
	      var _state = this.state,
	          desktop = _state.desktop,
	          tablet = _state.tablet,
	          contentActive = _state.contentActive;
	
	
	      var drawerType = (0, _getField2.default)(this.props, this.state, 'drawerType');
	      var visible = (0, _getField2.default)(this.props, this.state, 'visible');
	      var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');
	      var mini = (0, _isType.isMini)(drawerType);
	      var temporary = (0, _isType.isTemporary)(drawerType);
	      var persistent = (0, _isType.isPersistent)(drawerType);
	      var clipped = drawerType === DrawerTypes.CLIPPED;
	      var floating = drawerType === DrawerTypes.FLOATING;
	
	      var offset = desktop || tablet ? !temporary && visible : visible;
	      var toolbarRelative = (0, _classnames2.default)({
	        'md-toolbar-relative': !toolbarProminent && !toolbarProminentTitle,
	        'md-toolbar-relative--prominent': toolbarProminent || toolbarProminentTitle
	      });
	
	      var nav = void 0;
	      if (temporary || persistent) {
	        nav = _react2.default.createElement(_Button2.default, {
	          key: 'nav',
	          onClick: this._toggleVisibility,
	          disabled: persistent && visible,
	          icon: true,
	          iconEl: (0, _getDeprecatedIcon2.default)(menuIconClassName || temporaryIconClassName, menuIconChildren || temporaryIconChildren, temporaryIcon)
	        });
	      }
	
	      var closeButton = void 0;
	      if (persistent) {
	        closeButton = _react2.default.createElement(_CloseButton2.default, null);
	      }
	
	      if (!drawerHeader && includeDrawerHeader) {
	        drawerHeader = _react2.default.createElement(
	          _Toolbar2.default,
	          {
	            key: 'drawer-header',
	            title: drawerTitle,
	            actions: visible && nav ? closeButton : null,
	            className: (0, _classnames2.default)('md-divider-border md-divider-border--bottom', _defineProperty({}, toolbarRelative, clipped || floating))
	          },
	          drawerHeaderChildren,
	          _react2.default.createElement(_JumpToContentLink2.default, null)
	        );
	      }
	      var miniDrawer = void 0;
	      if (mini) {
	        var miniList = void 0;
	        if (extractMini) {
	          miniList = navItems.map(toMiniListItem);
	          miniList = _react2.default.createElement(
	            _List2.default,
	            { key: 'mini-nav-items', className: toolbarRelative },
	            miniList
	          );
	        }
	
	        miniDrawer = _react2.default.createElement(
	          _Drawer2.default,
	          { key: 'mini-drawer', type: drawerType, renderNode: renderNode, 'aria-hidden': visible },
	          miniDrawerHeader,
	          miniList,
	          miniDrawerChildren
	        );
	      }
	
	      var desktopOffset = !clipped && !floating && offset;
	
	      return _react2.default.createElement(
	        'div',
	        { style: style, className: className, id: id },
	        _react2.default.createElement(
	          _Toolbar2.default,
	          {
	            id: toolbarId,
	            colored: toolbarThemeType === 'colored',
	            themed: toolbarThemeType === 'themed',
	            singleColor: toolbarSingleColor,
	            style: toolbarStyle,
	            className: (0, _classnames2.default)({
	              'md-toolbar--over-drawer': clipped || floating || mini && !visible
	            }, toolbarClassName),
	            title: toolbarTitle,
	            titleMenu: toolbarTitleMenu,
	            prominent: toolbarProminent,
	            prominentTitle: toolbarProminentTitle,
	            titleStyle: toolbarTitleStyle,
	            titleClassName: (0, _classnames2.default)({
	              'md-title--drawer-active': contentActive,
	              'md-transition--deceleration': offset && visible,
	              'md-transition--acceleration': offset && !visible,
	              'md-title--permanent-offset': desktopOffset && (0, _isType.isPermanent)(drawerType),
	              'md-title--persistent-offset': desktopOffset && persistent
	            }, toolbarTitleClassName),
	            nav: nav,
	            actions: toolbarActions,
	            fixed: true,
	            zDepth: toolbarZDepth
	          },
	          toolbarChildren
	        ),
	        miniDrawer,
	        _react2.default.createElement(
	          _Drawer2.default,
	          _extends({}, props, {
	            id: drawerId,
	            constantType: constantDrawerType,
	            transitionDuration: drawerTransitionDuration,
	            header: drawerHeader,
	            style: drawerStyle,
	            className: drawerClassName,
	            navItems: navItems,
	            renderNode: renderNode,
	            mobileType: mobileType,
	            tabletType: tabletType,
	            desktopType: desktopType,
	            type: getNonMiniType(drawerType),
	            visible: visible,
	            zDepth: drawerZDepth,
	            onVisibilityChange: this._handleVisibility,
	            onMediaTypeChange: this._handleTypeChange
	          }),
	          drawerChildren
	        ),
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          _extends({}, contentProps, {
	            id: contentId,
	            component: Content,
	            transitionName: transitionName,
	            transitionEnter: !!transitionEnterTimeout,
	            transitionEnterTimeout: transitionEnterTimeout,
	            transitionLeave: !!transitionLeaveTimeout,
	            transitionLeaveTimeout: transitionLeaveTimeout,
	            tabIndex: -1,
	            style: contentStyle,
	            className: (0, _classnames2.default)('md-navigation-drawer-content', {
	              'md-navigation-drawer-content--active': contentActive,
	              'md-navigation-drawer-content--inactive': !visible,
	              'md-navigation-drawer-content--prominent-offset': toolbarProminent || toolbarProminentTitle,
	              'md-transition--deceleration': visible,
	              'md-transition--acceleration': !visible,
	              'md-drawer-relative': offset,
	              'md-drawer-relative--mini': mini && (!visible || temporary)
	            }, toolbarRelative, contentClassName)
	          }),
	          children
	        ),
	        footer
	      );
	    }
	  }]);
	
	  return NavigationDrawer;
	}(_react.PureComponent);
	
	NavigationDrawer.DrawerType = { // deprecated
	  /* eslint-disable no-console */
	  _warned: false,
	  _msg: 'Invalid use of `NavigationDrawer.DrawerType.{{TYPE}}`. The `NavigationDrawer.DrawerType` ' + 'has been deprecated and will be removed in the next major release. Please use the ' + '`NavigationDrawer.DrawerTypes.{{TYPE}}` instead.',
	
	  get FULL_HEIGHT() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'FULL_HEIGHT'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.FULL_HEIGHT;
	  },
	
	  get CLIPPED() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'CLIPPED'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.CLIPPED;
	  },
	
	  get FLOATING() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'FLOATING'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.FLOATING;
	  },
	
	  get PERSISTENT() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'PERSISTENT'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.PERSISTENT;
	  },
	
	  get PERSISTENT_MINI() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'PERSISTENT_MINI'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.PERSISTENT_MINI;
	  },
	
	  get TEMPORARY() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'TEMPORARY'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.TEMPORARY;
	  },
	
	  get TEMPORARY_MINI() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'TEMPORARY_MINI'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.TEMPORARY_MINI;
	  }
	};
	NavigationDrawer.DrawerTypes = DrawerTypes;
	NavigationDrawer.propTypes = {
	  /**
	   * An optional id to provide to the entire div wrapper.
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the drawer. This is generally a good idea to provide if
	   * there are any `navItems` defined.
	   *
	   * @see {@link #navItemsId}
	   */
	  drawerId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the navItems list. If this is omitted and the `drawerId` prop is
	   * defined, it will be defaulted to `${drawerId}-nav-items`.
	   *
	   * @see {@link #drawerId}
	   * @see {@link Drawers#navItemsId}
	   */
	  navItemsId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the main toolbar.
	   */
	  toolbarId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An id to give the main content. A hidden link is created in the main drawer's header that links to the main
	   * content. This is used for keyboard only users to jump the navigation and jump straight to the content.
	   *
	   * If you provide your own `drawerHeader`, it is suggested to include the link yourself.
	   */
	  contentId: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * An optional style to apply to the surrounding container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the surrounding container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the main toolbar.
	   */
	  toolbarStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the toolbar.
	   */
	  toolbarClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the main toolbar's title.
	   */
	  toolbarTitleStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the main toolbar's title.
	   */
	  toolbarTitleClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the drawer.
	   */
	  drawerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the drawer.
	   */
	  drawerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `List` surrounding the `navItems`.
	   */
	  navStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `List` surrounding the `navItems`.
	   */
	  navClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the content. This is the container surrounding whatever
	   * `children` are passed in.
	   */
	  contentStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the content. This is the container surrounding whatever
	   * `children` are passed in.
	   */
	  contentClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the overlay.
	   */
	  overlayStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the overlay.
	   */
	  overlayClassName: _propTypes2.default.string,
	
	  /**
	   * The children to display in the main content.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the `drawerHeader` component should be built if the `drawerHeader` prop is not
	   * passed in.
	   */
	  includeDrawerHeader: _propTypes2.default.bool,
	
	  /**
	   * An optional header to display in the drawer. This will normally be the `Toolbar` component
	   * or any other type of header. You can either use this prop with the `CloseButton` component
	   * when displaying a persistent drawer, or use the `drawerTitle` and `drawerHeaderChildren` prop
	   * to build a toolbar.
	   */
	  drawerHeader: _propTypes2.default.node,
	
	  /**
	   * An optional title to use for the drawer's header toolbar. If the `drawerHeader` prop is defined,
	   * this is invalid.
	   */
	  drawerTitle: (0, _invalidIf2.default)(_propTypes2.default.node, 'drawerHeader'),
	
	  /**
	   * An optional zDepth to apply to the drawer. If this is omitted, the value will be set as follows:
	   * - floating || inline = 1
	   * - temporary = 5
	   * - all others = 1
	   *
	   * @see {@link Papers/Paper#zDepth}
	   */
	  drawerZDepth: _propTypes2.default.number,
	
	  /**
	   * Any additional children to display after the `drawerHeader` and `navItems` list in the drawer.
	   */
	  drawerChildren: _propTypes2.default.node,
	
	  /**
	   * Any additional children to display in the drawer's header `Toolbar`. If the `drawerHeader` prop is defined,
	   * this is invalid.
	   */
	  drawerHeaderChildren: (0, _invalidIf2.default)(_propTypes2.default.node, 'drawerHeader'),
	
	  /**
	   * The position for the drawer to be displayed.
	   */
	  position: _propTypes2.default.oneOf(['left', 'right']).isRequired,
	
	  /**
	   * An optional list of elements or props to use to build a navigational list in the drawer.
	   * When the item is an object of props, it will build a `ListItem` component unless a key of
	   * `divider` or `subheader` is set to true. It will then create the Divider or Subheader component
	   * with any other remaining keys.
	   */
	  navItems: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.shape({
	    divider: _propTypes2.default.bool,
	    subheader: _propTypes2.default.bool,
	    primaryText: _propTypes2.default.node
	  })])),
	
	  /**
	   * The drawer type to use for mobile devices.
	   */
	  mobileDrawerType: _propTypes2.default.oneOf([DrawerTypes.TEMPORARY, DrawerTypes.TEMPORARY_MINI]).isRequired,
	
	  /**
	   * The drawer type to use for tablets.
	   */
	  tabletDrawerType: _propTypes2.default.oneOf([DrawerTypes.FULL_HEIGHT, DrawerTypes.CLIPPED, DrawerTypes.FLOATING, DrawerTypes.PERSISTENT, DrawerTypes.PERSISTENT_MINI, DrawerTypes.TEMPORARY, DrawerTypes.TEMPORARY_MINI]).isRequired,
	
	  /**
	   * The drawer type to use for desktop displays.
	   */
	  desktopDrawerType: _propTypes2.default.oneOf([DrawerTypes.FULL_HEIGHT, DrawerTypes.CLIPPED, DrawerTypes.FLOATING, DrawerTypes.PERSISTENT, DrawerTypes.PERSISTENT_MINI, DrawerTypes.TEMPORARY, DrawerTypes.TEMPORARY_MINI]).isRequired,
	
	  /**
	   * An optional drawer type to enforce on all screen sizes. If the drawer type is not
	   * `temporary`, you are required to define the `onMediaTypeChange` prop to handle switching
	   * to temporary when the media matches a mobile device.
	   * ```
	   */
	  drawerType: _propTypes2.default.oneOf([DrawerTypes.FULL_HEIGHT, DrawerTypes.CLIPPED, DrawerTypes.FLOATING, DrawerTypes.PERSISTENT, DrawerTypes.PERSISTENT_MINI, DrawerTypes.TEMPORARY, DrawerTypes.TEMPORARY_MINI]),
	
	  /**
	   * The default media match for the drawer. This will be what is displayed on first render.
	   * The component will adjust itself to the current media after it has mounted, but this
	   * is mostly used for server side rendering.
	   */
	  defaultMedia: _propTypes2.default.oneOf(['mobile', 'tablet', 'desktop']),
	
	  /**
	   * The min width to use for a mobile media query. This prop should match the `md-mobile-min-width`
	   * variable.
	   *
	   * The media query for a mobile device will be:
	   *
	   * ```js
	   * window.matchMedia(
	   *   `screen and (min-width: ${mobileMinWidth}px) and (max-width: ${tabletMinWidth - 1}px`
	   * ).matches;
	   * ```
	   */
	  mobileMinWidth: _propTypes2.default.number.isRequired,
	
	  /**
	   * The min width to use for a tablet media query. This prop should match the `md-tablet-min-width`
	   * variable.
	   *
	   * The media query for a tablet device will be:
	   *
	   * ```js
	   * window.matchMedia(
	   *   `screen and (min-width: ${tabletMinWidth}px) and (max-width: ${desktopWidth - 1}px`
	   * ).matches;
	   * ```
	   */
	  tabletMinWidth: _propTypes2.default.number.isRequired,
	
	  /**
	   * The min width to use for a desktop media query. This prop should match the `md-desktop-min-width`
	   * variable.
	   *
	   * The media query for a tablet device will be:
	   *
	   * ```js
	   * window.matchMedia(`screen and (min-width: ${tabletMinWidth}px)`).matches;
	   * ```
	   */
	  desktopMinWidth: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional function to call when the type of the drawer changes because of the
	   * new media queries. The callback will include the newly selected drawer type
	   * and an object containing the media matches of `mobile`, `tablet`, and `desktop`.
	   *
	   * ```js
	   * this.props.onMediaTypeChange(NavigationDrawer.DrawerTypes.TEMPORARY, {
	   *   mobile: true,
	   *   tablet: false,
	   *   desktop: false,
	   * });
	   * ```
	   */
	  onMediaTypeChange: _propTypes2.default.func,
	
	  /**
	   * Boolean if the temporary or persistent drawers are visible by default.
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the temporary or persistent drawers are visible. If this is defined,
	   * it will make the component controlled and require the `onVisibilityChange` prop
	   * to be defined.
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityChange', 'defaultVisible'),
	
	  /**
	   * An optional function to call when the visibility of the drawer changes. The callback
	   * will include the new visibility.
	   *
	   * ```js
	   * onVisibilityChange(false);
	   * ```
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * A boolean if the mini drawer's list should be generated from the `navItems` prop. When building
	   * the list, it will extract the `leftIcon` or `leftAvatar` from the `navItem` and then create a
	   * mini `ListItem` containing only that icon or image. Any other event listeners will also be applied.
	   *
	   *
	   * @see {@link #miniDrawerHeader}
	   * @see {@link #miniDrawerChildren}
	   */
	  extractMini: _propTypes2.default.bool,
	
	  /**
	   * An optional header to display in the mini drawer. This will be displayed above the optional
	   * mini nav list that get generated if the `extractMini` prop is `true` and the `miniDrawerChildren`.
	   *
	   * @see {@link #extractMini}
	   */
	  miniDrawerHeader: _propTypes2.default.node,
	
	  /**
	   * Any additional children to display in the mini drawer. This will be displayed after the `miniDrawerHeader`
	   * and the optional mini nav list that gets generated if the `extractMini` prop is `true`.
	   *
	   * @see {@link #extractMini}
	   */
	  miniDrawerChildren: _propTypes2.default.node,
	
	  /**
	   * Boolean if the drawer should automatically close after a nav item has been clicked for `temporary` drawers.
	   */
	  autoclose: _propTypes2.default.bool,
	
	  /**
	   * An optional title to display in the main toolbar. Either the `toolbarTitle` or the `toolbarTitleMenu`
	   * may be defined, not both.
	   */
	  toolbarTitle: (0, _invalidIf2.default)(_propTypes2.default.node, 'toolbarTitleMenu'),
	
	  /**
	   * An optional select field menu to display in the main toolbar. Either the `toolbarTitle` or the `toolbarTitleMenu`
	   * may be defined, not both.
	   */
	  toolbarTitleMenu: _propTypes2.default.element,
	
	  /**
	   * The theme style for the main toolbar.
	   *
	   * @see {@link Toolbars/Toolbar}
	   */
	  toolbarThemeType: _propTypes2.default.oneOf(['default', 'colored', 'themed']).isRequired,
	
	  /**
	   * Boolean if the toolbar's nav, actions, and title should share the same color.
	   */
	  toolbarSingleColor: _propTypes2.default.bool,
	
	  /**
	   * A boolean if the toolbar should be prominent.
	   */
	  toolbarProminent: _propTypes2.default.bool,
	
	  /**
	   * A boolean if the toolbar's title should be prominent.
	   */
	  toolbarProminentTitle: _propTypes2.default.bool,
	
	  /**
	   * A list of elements or a single element to display to the right of the
	   * toolbar's nav, title, and children.
	   *
	   * @see {@link Toolbars/Toolbar#actions}
	   */
	  toolbarActions: _Toolbar2.default.propTypes.actions,
	
	  /**
	   * Any children to display in the toolbar. This will be displayed between the optional title and
	   * actions.
	   */
	  toolbarChildren: _Toolbar2.default.propTypes.children,
	
	  /**
	   * An optional zDepth to apply to the toolbar.
	   *
	   * @see {@link Toolbars/Toolbar#zDepth}
	   */
	  toolbarZDepth: _propTypes2.default.number,
	
	  /**
	   * The component to render the content in.
	   */
	  contentComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * An optional footer display after the main content.
	   */
	  footer: _propTypes2.default.node,
	
	  /**
	   * The icon to use to render the button that will toggle the visibility of the
	   * navigation drawer for `temporary` and `persistent` drawers. This is normally a
	   * hamburger menu.
	   */
	  temporaryIcon: _propTypes2.default.element,
	
	  /**
	   * The icon to use to render the button that appears on a persistent drawer's open
	   * header. This is used to create the `CloseButton` for drawers. When a persistent
	   * drawer is closed, the `temporaryIcon` will be used to create a button to open the drawer.
	   *
	   * If the `drawerHeader` prop is defined, you will have to either include the `CloseButton`
	   * in your header manually, or create your own controlled button to close the drawer.
	   */
	  persistentIcon: _propTypes2.default.element,
	
	  /**
	   * The transition name to use when the page's content changes. If you want to disable
	   * transitions, set both the `transitionEnterTimeout` and `transitionLeaveTimeout` props
	   * to a false-ish value. (`null`, `undefined`, or `0`).
	   */
	  transitionName: _propTypes2.default.string.isRequired,
	
	  /**
	   * The transition enter timeout when the page's content changes. If you want to disable
	   * the enter transition, set this to a false-ish value (`null`, `undefined`, or `0`).
	   */
	  transitionEnterTimeout: _propTypes2.default.number,
	
	  /**
	   * The transition leave timeout when the page's content changes. If you want to disable
	   * the leave transition, set this to a false-ish value (`null`, `undefined`, or `0`).
	   */
	  transitionLeaveTimeout: _propTypes2.default.number,
	
	  /**
	   * The transition duration for the drawer when sliding in and out of view.
	   */
	  drawerTransitionDuration: _propTypes2.default.number.isRequired,
	
	  /**
	   * Any additional props to provide to the main content. This will be applied before any of the generated props,
	   * so this should not include `style`, `className`, or `component`.
	   */
	  contentProps: _propTypes2.default.object,
	
	  /**
	   * The label to use for a keyboard accessibility link that jumps all the navigation and allows a user to focus
	   * the main content. This is created in the drawer's header.
	   */
	  jumpLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the Portal's functionality of rendering in a separate react tree should be applied
	   * to the drawer. The overlay that appears for temporary type drawers will still appear in the
	   * separate subtree.
	   *
	   * @see {@link Helpers/Portal}
	   */
	  portal: _propTypes2.default.bool,
	
	  /**
	   * An optional DOM Node to render the drawer into. The default is to render as
	   * the first child in the `body`.
	   *
	   * > This prop will not be used when the drawer is of the permanent type or `inline` is specified
	   * since the `Portal` component will not be used.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the drawer should be rendered as the last child instead of the first child
	   * in the `renderNode` or `body`.
	   *
	   * > This prop will not be used when the drawer is of the permanent type or `inline` is specified
	   * since the `Portal` component will not be used.
	   */
	  lastChild: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `drawerType` should remain constant across all media. This is really only valid
	   * if the `drawerType` is one of the temporary types.
	   */
	  constantDrawerType: _propTypes2.default.bool,
	
	  menuIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `temporaryIcon` instead'),
	  menuIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `temporaryIcon` instead'),
	  closeIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `persistentIcon` instead'),
	  closeIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `persistentIcon` instead'),
	  temporaryIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `temporaryIcon` instead'),
	  temporaryIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `temporaryIcon` instead.'),
	  persistentIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `persistentIcon` instead'),
	  persistentIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `persistentIcon` prop instead'),
	  onDrawerChange: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onVisibilityChange` or `onMediaTypeChange` instead'),
	  onVisibilityToggle: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onVisibilityChange` instead'),
	  contentTransitionName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `transitionName` instead'),
	  contentTransitionEnterTimeout: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `transtionEnterTimeout` instead'),
	  contentTransitionLeaveTimeout: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `transtionLeaveTimeout` instead'),
	  initialDrawerType: (0, _deprecated2.default)(_propTypes2.default.oneOf(['mobile', 'tablet', 'desktop']), 'Use `defaultMedia` instead')
	};
	NavigationDrawer.contextTypes = {
	  renderNode: _propTypes2.default.object
	};
	NavigationDrawer.childContextTypes = {
	  closeIcon: _propTypes2.default.element,
	  onCloseClick: _propTypes2.default.func,
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  label: _propTypes2.default.node.isRequired,
	  renderNode: _propTypes2.default.object
	};
	NavigationDrawer.defaultProps = {
	  autoclose: _Drawer2.default.defaultProps.autoclose,
	  contentId: 'main-content',
	  // Defaults to false since it keeps the state of the drawerType in sync and makes the Drawer
	  // controlled. On initial mount without any defaultMedia updates, it would always be considered
	  // temporary
	  constantDrawerType: false,
	  jumpLabel: 'Jump to content',
	  extractMini: true,
	  position: _Drawer2.default.defaultProps.position,
	  defaultMedia: _Drawer2.default.defaultProps.defaultMedia,
	  mobileDrawerType: _Drawer2.default.defaultProps.mobileType,
	  tabletDrawerType: _Drawer2.default.defaultProps.tabletType,
	  desktopDrawerType: _Drawer2.default.defaultProps.desktopType,
	  mobileMinWidth: _Drawer2.default.defaultProps.mobileMinWidth,
	  tabletMinWidth: _Drawer2.default.defaultProps.tabletMinWidth,
	  desktopMinWidth: _Drawer2.default.defaultProps.desktopMinWidth,
	  includeDrawerHeader: true,
	  contentComponent: 'main',
	  temporaryIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'menu'
	  ),
	  toolbarThemeType: 'colored',
	  persistentIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'arrow_back'
	  ),
	  transitionName: 'md-cross-fade',
	  transitionEnterTimeout: 300,
	  drawerTransitionDuration: _Drawer2.default.defaultProps.transitionDuration
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._animate = function () {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.props;
	    var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this2.state;
	
	    if ((0, _isType.isTemporary)((0, _getField2.default)(props, state, 'drawerType'))) {
	      return;
	    }
	
	    if (_this2._timeout) {
	      clearTimeout(_this2._timeout);
	    }
	
	    _this2._timeout = setTimeout(function () {
	      _this2.setState({ contentActive: false });
	    }, props.drawerTransitionDuration);
	
	    _this2.setState({ contentActive: true });
	  };
	
	  this._toggleVisibility = function (e) {
	    var _props3 = _this2.props,
	        onVisibilityToggle = _props3.onVisibilityToggle,
	        onVisibilityChange = _props3.onVisibilityChange,
	        onDrawerChange = _props3.onDrawerChange;
	
	    var visible = !(0, _getField2.default)(_this2.props, _this2.state, 'visible');
	    var callback = onVisibilityChange || onVisibilityToggle || onDrawerChange;
	    if (callback) {
	      callback(visible, e);
	    }
	
	    if (typeof _this2.props.visible === 'undefined') {
	      _this2.setState({ visible: visible });
	      _this2._animate(_this2.props);
	    }
	  };
	
	  this._handleVisibility = function (visible) {
	    var _props4 = _this2.props,
	        onVisibilityToggle = _props4.onVisibilityToggle,
	        onVisibilityChange = _props4.onVisibilityChange,
	        onDrawerChange = _props4.onDrawerChange;
	
	    var callback = onVisibilityChange || onVisibilityToggle || onDrawerChange;
	    if (callback) {
	      callback(visible);
	    }
	
	    if (typeof _this2.props.visible === 'undefined') {
	      _this2.setState({ visible: visible });
	      _this2._animate(_this2.props);
	    }
	  };
	
	  this._handleTypeChange = function (drawerType, mediaState) {
	    var onMediaTypeChange = _this2.props.onMediaTypeChange;
	
	    var state = mediaState;
	    if (onMediaTypeChange) {
	      onMediaTypeChange(drawerType, mediaState);
	    }
	
	    if (typeof _this2.props.drawerType === 'undefined') {
	      state = _extends({}, mediaState, { drawerType: drawerType });
	    }
	
	    _this2.setState(state);
	  };
	};
	
	exports.default = NavigationDrawer;
	//# sourceMappingURL=NavigationDrawer.js.map

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.JumpToContentLink = exports.CloseButton = exports.NavigationDrawer = undefined;
	
	var _NavigationDrawer2 = __webpack_require__(601);
	
	var _NavigationDrawer3 = _interopRequireDefault(_NavigationDrawer2);
	
	var _CloseButton2 = __webpack_require__(281);
	
	var _CloseButton3 = _interopRequireDefault(_CloseButton2);
	
	var _JumpToContentLink2 = __webpack_require__(282);
	
	var _JumpToContentLink3 = _interopRequireDefault(_JumpToContentLink2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _NavigationDrawer3.default;
	exports.NavigationDrawer = _NavigationDrawer3.default;
	exports.CloseButton = _CloseButton3.default;
	exports.JumpToContentLink = _JumpToContentLink3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Paper = undefined;
	
	var _Paper2 = __webpack_require__(33);
	
	var _Paper3 = _interopRequireDefault(_Paper2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Paper3.default;
	exports.Paper = _Paper3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(12);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component renders a selectable date in the `CalendarMonth` component.
	 */
	var CalendarDate = function (_PureComponent) {
	  _inherits(CalendarDate, _PureComponent);
	
	  function CalendarDate(props) {
	    _classCallCheck(this, CalendarDate);
	
	    var _this = _possibleConstructorReturn(this, (CalendarDate.__proto__ || Object.getPrototypeOf(CalendarDate)).call(this, props));
	
	    _this._setFocus = function (btn) {
	      if (btn && _this.props.active) {
	        btn.focus();
	      }
	    };
	
	    _this._handleClick = function (e) {
	      _this.props.onClick(new Date(_this.props.date), e);
	    };
	
	    _this._setActive = function () {
	      if (!_this.props.disabled) {
	        _this.setState({ desktopActive: true });
	      }
	    };
	
	    _this._setInactive = function () {
	      if (!_this.props.disabled) {
	        _this.setState({ desktopActive: false });
	      }
	    };
	
	    _this.state = _extends({}, _this._getFormattedDate(props), { desktopActive: false });
	    return _this;
	  }
	
	  _createClass(CalendarDate, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locales = _props.locales,
	          date = _props.date;
	
	      if (DateTimeFormat !== nextProps.DateTimeFormat || locales !== nextProps.locales || date !== nextProps.date) {
	        this.setState(this._getFormattedDate(nextProps));
	      }
	    }
	  }, {
	    key: '_getFormattedDate',
	    value: function _getFormattedDate(_ref) {
	      var DateTimeFormat = _ref.DateTimeFormat,
	          locales = _ref.locales,
	          date = _ref.date,
	          timeZone = _ref.timeZone;
	
	      return {
	        date: new DateTimeFormat(locales, { day: 'numeric', timeZone: timeZone }).format(date)
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          date = _state.date,
	          desktopActive = _state.desktopActive;
	      var _props2 = this.props,
	          disabled = _props2.disabled,
	          active = _props2.active,
	          today = _props2.today,
	          className = _props2.className;
	
	
	      var fullyActive = today && !active && !desktopActive;
	      return _react2.default.createElement(
	        'button',
	        {
	          type: 'button',
	          ref: this._setFocus,
	          onFocus: this._setActive,
	          onBlur: this._setInactive,
	          onMouseOver: this._setActive,
	          onMouseLeave: this._setInactive,
	          className: (0, _classnames2.default)('md-calendar-date md-calendar-date--btn', {
	            'md-calendar-date--btn-active': active || desktopActive,
	            'md-pointer--hover': !disabled
	          }, (0, _themeColors2.default)({ disabled: disabled, primary: fullyActive }), 'md-btn', className),
	          onClick: this._handleClick,
	          disabled: disabled
	        },
	        _react2.default.createElement(
	          'span',
	          {
	            className: (0, _classnames2.default)('md-calendar-date--date', {
	              'md-picker-text--active': active || desktopActive,
	              'md-font-bold': fullyActive
	            })
	          },
	          date
	        )
	      );
	    }
	  }]);
	
	  return CalendarDate;
	}(_react.PureComponent);
	
	CalendarDate.propTypes = {
	  className: _propTypes2.default.string,
	  date: _propTypes2.default.instanceOf(Date).isRequired,
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	  disabled: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func.isRequired,
	  active: _propTypes2.default.bool,
	  today: _propTypes2.default.bool,
	  timeZone: _propTypes2.default.string.isRequired
	};
	exports.default = CalendarDate;
	//# sourceMappingURL=CalendarDate.js.map

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(12);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _isMonthBefore = __webpack_require__(670);
	
	var _isMonthBefore2 = _interopRequireDefault(_isMonthBefore);
	
	var _getDayOfWeek = __webpack_require__(298);
	
	var _getDayOfWeek2 = _interopRequireDefault(_getDayOfWeek);
	
	var _addDate = __webpack_require__(176);
	
	var _addDate2 = _interopRequireDefault(_addDate);
	
	var _Button = __webpack_require__(19);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component renders the controls for a `DatePicker`'s Calendar.
	 * This will render a next and previous month button along with the
	 * current month/year. It also renders the abbreviiations for the days
	 * of the week.
	 */
	var CalendarHeader = function (_PureComponent) {
	  _inherits(CalendarHeader, _PureComponent);
	
	  function CalendarHeader(props) {
	    _classCallCheck(this, CalendarHeader);
	
	    var _this = _possibleConstructorReturn(this, (CalendarHeader.__proto__ || Object.getPrototypeOf(CalendarHeader)).call(this, props));
	
	    _this.state = _this._createState(props);
	    return _this;
	  }
	
	  _createClass(CalendarHeader, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locales = _props.locales,
	          date = _props.date;
	
	      if (DateTimeFormat !== nextProps.DateTimeFormat || locales !== nextProps.locales || date !== nextProps.date) {
	        this.setState(this._createState(nextProps));
	      }
	    }
	  }, {
	    key: '_createState',
	    value: function _createState() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props,
	          DateTimeFormat = _ref.DateTimeFormat,
	          locales = _ref.locales,
	          date = _ref.date,
	          firstDayOfWeek = _ref.firstDayOfWeek,
	          titleFormat = _ref.titleFormat,
	          weekdayClassName = _ref.weekdayClassName,
	          weekdayFormat = _ref.weekdayFormat,
	          timeZone = _ref.timeZone;
	
	      var firstDay = (0, _getDayOfWeek2.default)(date, firstDayOfWeek);
	      var formatter = new DateTimeFormat(locales, { weekday: weekdayFormat, timeZone: timeZone });
	      var dows = [];
	      for (var i = 0; i < 7; i++) {
	        var dow = formatter.format((0, _addDate2.default)(firstDay, i, 'D'));
	        dows.push(_react2.default.createElement(
	          'h4',
	          {
	            key: i,
	            className: (0, _classnames2.default)('md-calendar-date md-calendar-dow', (0, _themeColors2.default)({ disabled: true }), weekdayClassName)
	          },
	          dow
	        ));
	      }
	
	      return {
	        dows: dows,
	        title: new DateTimeFormat(locales, _extends({}, titleFormat, { timeZone: timeZone })).format(date)
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dows = _state.dows,
	          title = _state.title;
	      var _props2 = this.props,
	          date = _props2.date,
	          minDate = _props2.minDate,
	          maxDate = _props2.maxDate,
	          onPreviousClick = _props2.onPreviousClick,
	          previousIcon = _props2.previousIcon,
	          onNextClick = _props2.onNextClick,
	          nextIcon = _props2.nextIcon,
	          titleClassName = _props2.titleClassName;
	
	
	      var isPreviousDisabled = (0, _isMonthBefore2.default)(minDate, date);
	      var isNextDisabled = (0, _isMonthBefore2.default)(date, maxDate);
	      return _react2.default.createElement(
	        'header',
	        { className: 'md-calendar-header' },
	        _react2.default.createElement(
	          'div',
	          { className: 'md-calendar-controls' },
	          _react2.default.createElement(_Button2.default, {
	            icon: true,
	            onClick: onPreviousClick,
	            disabled: isPreviousDisabled,
	            className: 'md-calendar-control',
	            iconEl: previousIcon
	          }),
	          _react2.default.createElement(
	            'h4',
	            { className: (0, _classnames2.default)('md-title', titleClassName) },
	            title
	          ),
	          _react2.default.createElement(_Button2.default, {
	            icon: true,
	            onClick: onNextClick,
	            disabled: isNextDisabled,
	            className: 'md-calendar-control',
	            iconEl: nextIcon
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'md-calendar-dows' },
	          dows
	        )
	      );
	    }
	  }]);
	
	  return CalendarHeader;
	}(_react.PureComponent);
	
	CalendarHeader.propTypes = {
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  date: _propTypes2.default.instanceOf(Date).isRequired,
	  minDate: _propTypes2.default.instanceOf(Date),
	  maxDate: _propTypes2.default.instanceOf(Date),
	  previousIcon: _propTypes2.default.element,
	  onPreviousClick: _propTypes2.default.func.isRequired,
	  nextIcon: _propTypes2.default.node,
	  onNextClick: _propTypes2.default.func.isRequired,
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	  /**
	   * The first day of week: 0 for Sunday, 1 for Monday, 2 for Tuesday, and so on.
	   */
	  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
	  /**
	   * An optional className to apply to the title.
	   */
	  titleClassName: _propTypes2.default.string,
	  /**
	   * The DateTimeFormat options to apply to format the title.
	   */
	  titleFormat: _propTypes2.default.shape({
	    era: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	    year: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    month: _propTypes2.default.oneOf(['numeric', '2-digit', 'narrow', 'short', 'long'])
	  }),
	  /**
	   * An optional className to apply to a weekday.
	   */
	  weekdayClassName: _propTypes2.default.string,
	  /**
	   * The DateTimeFormat option to apply to format a weekday.
	   */
	  weekdayFormat: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	
	  /**
	   * The timeZone to be used in all formatting operations.
	   * For a full list of possible timeZone values check https://www.iana.org/time-zones.
	   */
	  timeZone: _propTypes2.default.string.isRequired
	};
	CalendarHeader.defaultProps = {
	  firstDayOfWeek: 0,
	  titleFormat: { month: 'long', year: 'numeric' },
	  weekdayFormat: 'narrow'
	};
	exports.default = CalendarHeader;
	//# sourceMappingURL=CalendarHeader.js.map

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _addDate = __webpack_require__(176);
	
	var _addDate2 = _interopRequireDefault(_addDate);
	
	var _stripTime = __webpack_require__(299);
	
	var _stripTime2 = _interopRequireDefault(_stripTime);
	
	var _getLastDay = __webpack_require__(668);
	
	var _getLastDay2 = _interopRequireDefault(_getLastDay);
	
	var _getDayOfWeek = __webpack_require__(298);
	
	var _getDayOfWeek2 = _interopRequireDefault(_getDayOfWeek);
	
	var _CalendarDate = __webpack_require__(604);
	
	var _CalendarDate2 = _interopRequireDefault(_CalendarDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component renders a month for the calendar view of the `DatePicker`.
	 */
	var CalendarMonth = function (_PureComponent) {
	  _inherits(CalendarMonth, _PureComponent);
	
	  function CalendarMonth() {
	    _classCallCheck(this, CalendarMonth);
	
	    return _possibleConstructorReturn(this, (CalendarMonth.__proto__ || Object.getPrototypeOf(CalendarMonth)).apply(this, arguments));
	  }
	
	  _createClass(CalendarMonth, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          calendarDate = _props.calendarDate,
	          calendarTempDate = _props.calendarTempDate,
	          onCalendarDateClick = _props.onCalendarDateClick,
	          minDate = _props.minDate,
	          maxDate = _props.maxDate,
	          DateTimeFormat = _props.DateTimeFormat,
	          locales = _props.locales,
	          className = _props.className,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          disableWeekEnds = _props.disableWeekEnds,
	          dateClassName = _props.dateClassName,
	          showAllDays = _props.showAllDays,
	          outerDateClassName = _props.outerDateClassName,
	          disableOuterDates = _props.disableOuterDates,
	          timeZone = _props.timeZone,
	          props = _objectWithoutProperties(_props, ['calendarDate', 'calendarTempDate', 'onCalendarDateClick', 'minDate', 'maxDate', 'DateTimeFormat', 'locales', 'className', 'firstDayOfWeek', 'disableWeekEnds', 'dateClassName', 'showAllDays', 'outerDateClassName', 'disableOuterDates', 'timeZone']);
	
	      var days = [];
	      var firstDay = new Date(calendarDate);
	      firstDay.setDate(1);
	      var lastDay = (0, _getLastDay2.default)(calendarDate);
	      var currentDate = (0, _stripTime2.default)((0, _getDayOfWeek2.default)(firstDay, 0));
	      var endDate = (0, _stripTime2.default)((0, _getDayOfWeek2.default)(lastDay, 6));
	      var activeDateTime = (0, _stripTime2.default)(new Date(calendarTempDate)).getTime();
	      var todayTime = (0, _stripTime2.default)(new Date()).getTime();
	
	      if (firstDayOfWeek) {
	        currentDate = (0, _addDate2.default)(currentDate, firstDayOfWeek > firstDay.getDay() ? firstDayOfWeek - 7 : firstDayOfWeek, 'D');
	        endDate = (0, _addDate2.default)(endDate, firstDayOfWeek > lastDay.getDay() ? firstDayOfWeek - 7 : firstDayOfWeek, 'D');
	      }
	      while (currentDate <= endDate) {
	        var key = currentDate.getMonth() + '-' + currentDate.getDate();
	        var currentMonth = currentDate.getMonth() === calendarDate.getMonth();
	
	        var date = void 0;
	        if (currentMonth || showAllDays) {
	          var time = currentDate.getTime();
	          var isMinDateDisabled = minDate && minDate.getTime() > time;
	          var isMaxDateDisabled = maxDate && maxDate.getTime() < time;
	          var isWeekendDisabled = disableWeekEnds && (currentDate.getDay() === 0 || currentDate.getDay() === 6);
	          var disabled = !currentMonth && disableOuterDates || isMinDateDisabled || isMaxDateDisabled || isWeekendDisabled;
	
	          date = _react2.default.createElement(_CalendarDate2.default, {
	            key: key,
	            className: (0, _classnames2.default)(dateClassName, _defineProperty({}, outerDateClassName, !currentMonth && outerDateClassName)),
	            today: time === todayTime,
	            active: time === activeDateTime,
	            disabled: disabled,
	            onClick: onCalendarDateClick,
	            date: currentDate,
	            DateTimeFormat: DateTimeFormat,
	            locales: locales,
	            timeZone: timeZone
	          });
	        } else {
	          date = _react2.default.createElement('div', { key: key, className: 'md-calendar-date' });
	        }
	
	        days.push(date);
	        // stripTime again to avoid problems when time is forwarded an hour for DST
	        currentDate = (0, _stripTime2.default)((0, _addDate2.default)(currentDate, 1, 'D'));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({ className: (0, _classnames2.default)('md-calendar-month', className) }, props),
	        days
	      );
	    }
	  }]);
	
	  return CalendarMonth;
	}(_react.PureComponent);
	
	CalendarMonth.propTypes = {
	  /**
	   * A className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The current selected date of the calendar. This is
	   * the date after hitting the Ok button or `value` || `defaultValue`.
	   */
	  calendarDate: _propTypes2.default.instanceOf(Date).isRequired,
	
	  /**
	   * The current selected date of the calendar before verifying
	   * the new date.
	   */
	  calendarTempDate: _propTypes2.default.instanceOf(Date).isRequired,
	
	  /**
	   * An optional min date for the calendar. This will disable any
	   * dates that come before this date in the month.
	   */
	  minDate: _propTypes2.default.instanceOf(Date),
	
	  /**
	   * An optional max date for the calendar. This will disable any
	   * dates that come after this date in the month.
	   */
	  maxDate: _propTypes2.default.instanceOf(Date),
	
	  /**
	   * A function to call that will select a new date.
	   */
	  onCalendarDateClick: _propTypes2.default.func.isRequired,
	
	  /**
	   * The first day of week: 0 for Sunday, 1 for Monday, 2 for Tuesday, and so on.
	   */
	  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
	
	  /**
	   * True if weekends are to be greyed out.
	   */
	  disableWeekEnds: _propTypes2.default.bool,
	
	  /**
	   * An optional className to apply to a date.
	   */
	  dateClassName: _propTypes2.default.string,
	
	  /**
	   * True if dates from adjacent months should be shown.
	   */
	  showAllDays: _propTypes2.default.bool,
	  disableOuterDates: _propTypes2.default.bool,
	
	  /**
	   * An optional className to apply to a date from an adjacent month.
	   */
	  outerDateClassName: _propTypes2.default.string,
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	
	  /**
	   * The timeZone to be used in all formatting operations.
	   * For a full list of possible timeZone values check https://www.iana.org/time-zones.
	   */
	  timeZone: _propTypes2.default.string.isRequired
	};
	CalendarMonth.defaultProps = {
	  firstDayOfWeek: 0
	};
	exports.default = CalendarMonth;
	//# sourceMappingURL=CalendarMonth.js.map

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isValidClick = __webpack_require__(177);
	
	var _isValidClick2 = _interopRequireDefault(_isValidClick);
	
	var _captureNextEvent = __webpack_require__(82);
	
	var _captureNextEvent2 = _interopRequireDefault(_captureNextEvent);
	
	var _touches = __webpack_require__(84);
	
	var _calcTimeFromPoint = __webpack_require__(672);
	
	var _calcTimeFromPoint2 = _interopRequireDefault(_calcTimeFromPoint);
	
	var _calcPageOffset = __webpack_require__(301);
	
	var _calcPageOffset2 = _interopRequireDefault(_calcPageOffset);
	
	var _ResizeObserver = __webpack_require__(32);
	
	var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);
	
	var _ClockTime = __webpack_require__(609);
	
	var _ClockTime2 = _interopRequireDefault(_ClockTime);
	
	var _ClockHand = __webpack_require__(608);
	
	var _ClockHand2 = _interopRequireDefault(_ClockHand);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `ClockFace` component is used for rendering all the clock's times
	 * and the clock hand.
	 */
	var ClockFace = function (_PureComponent) {
	  _inherits(ClockFace, _PureComponent);
	
	  function ClockFace(props) {
	    _classCallCheck(this, ClockFace);
	
	    var _this = _possibleConstructorReturn(this, (ClockFace.__proto__ || Object.getPrototypeOf(ClockFace)).call(this, props));
	
	    _this._setFace = function (face) {
	      _this._face = face;
	      _this._setPositioning();
	    };
	
	    _this._setPositioning = function () {
	      if (!_this._face) {
	        return;
	      }
	
	      var radius = _this._face.offsetWidth / 2;
	      var offset = (0, _calcPageOffset2.default)(_this._face);
	      _this._center = { x: offset.left + radius, y: offset.top + radius };
	      _this._left = offset.left;
	      _this._top = offset.top;
	
	      if (_this.state.radius !== radius) {
	        _this.setState({ radius: radius });
	      }
	    };
	
	    _this._handleMouseEnter = function () {
	      var hoverMode = _this.props.hoverMode;
	
	
	      if (hoverMode) {
	        _this._enableMouseMoving();
	      }
	    };
	
	    _this._handleMouseLeave = function () {
	      var hoverMode = _this.props.hoverMode;
	
	
	      if (hoverMode) {
	        _this._disableMouseMoving();
	      }
	    };
	
	    _this._handleMouseDown = function (e) {
	      if (!(0, _isValidClick2.default)(e)) {
	        return;
	      }
	
	      var hoverMode = _this.props.hoverMode;
	
	
	      if (!hoverMode) {
	        _this._enableMouseMoving();
	      }
	    };
	
	    _this._handleMouseMove = function (e) {
	      if (!_this.state.moving) {
	        return;
	      }
	
	      e.preventDefault();
	      _this._calcNewTime(e);
	    };
	
	    _this._handleMouseUp = function (e) {
	      if (!(0, _isValidClick2.default)(e)) {
	        return;
	      }
	
	      var _this$props = _this.props,
	          onTimeChosen = _this$props.onTimeChosen,
	          hoverMode = _this$props.hoverMode;
	
	
	      if (_this._face) {
	        if (_this._face.contains(e.target)) {
	          onTimeChosen();
	          _this._calcNewTime(e);
	        } else {
	          (0, _captureNextEvent2.default)('click');
	        }
	      }
	
	      if (!hoverMode) {
	        _this._disableMouseMoving();
	      }
	    };
	
	    _this._handleTouchStart = function () {
	      (0, _captureNextEvent2.default)('mousedown');
	
	      (0, _touches.addTouchEvent)(window, 'move', _this._handleTouchMove);
	      (0, _touches.addTouchEvent)(window, 'end', _this._handleTouchEnd);
	      _this.setState({ moving: true });
	    };
	
	    _this._handleTouchMove = function (e) {
	      if (!_this.state.moving) {
	        return;
	      }
	
	      _this._calcNewTime(e);
	    };
	
	    _this._handleTouchEnd = function (e) {
	      _this._calcNewTime(e);
	      if (_this._face && !_this._face.contains(e.target)) {
	        (0, _captureNextEvent2.default)('click');
	      }
	
	      (0, _touches.removeTouchEvent)(window, 'move', _this._handleTouchMove);
	      (0, _touches.removeTouchEvent)(window, 'end', _this._handleTouchEnd);
	
	      _this.setState({ moving: false });
	    };
	
	    _this._calcNewTime = function (e) {
	      var _ref = e.changedTouches ? e.changedTouches[0] : e,
	          x = _ref.pageX,
	          y = _ref.pageY;
	
	      var innerRadius = _this.state.radius - 48;
	      var _this$props2 = _this.props,
	          onChange = _this$props2.onChange,
	          minutes = _this$props2.minutes,
	          timePeriod = _this$props2.timePeriod;
	
	      onChange((0, _calcTimeFromPoint2.default)({ x: x, y: y }, _this._center, innerRadius, minutes, timePeriod));
	    };
	
	    _this._enableMouseMoving = function () {
	      window.addEventListener('mousemove', _this._handleMouseMove);
	      window.addEventListener('mouseup', _this._handleMouseUp);
	
	      _this.setState({ moving: true });
	    };
	
	    _this._disableMouseMoving = function () {
	      window.removeEventListener('mousemove', _this._handleMouseMove);
	      window.removeEventListener('mouseup', _this._handleMouseUp);
	
	      _this.setState({ moving: false });
	    };
	
	    _this.state = { radius: 136, moving: false };
	    _this._center = {};
	    return _this;
	  }
	
	  _createClass(ClockFace, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('mousemove', this._handleMouseMove);
	      window.removeEventListener('mouseup', this._handleMouseMove);
	
	      (0, _touches.removeTouchEvent)(window, 'move', this._handleTouchMove);
	      (0, _touches.removeTouchEvent)(window, 'end', this._handleTouchEnd);
	      clearInterval(this.interval);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          time = _props.time,
	          minutes = _props.minutes,
	          timePeriod = _props.timePeriod,
	          onChange = _props.onChange,
	          hoverMode = _props.hoverMode;
	      var radius = this.state.radius;
	
	      var size = !minutes && !timePeriod ? 24 : 12;
	      var times = Array.apply(null, new Array(size)).map(function (_, i) {
	        var clockTime = i + 1;
	        if (minutes) {
	          clockTime = clockTime * 5 % 60;
	        } else {
	          clockTime %= 24;
	        }
	
	        return _react2.default.createElement(_ClockTime2.default, {
	          key: 'time-' + i,
	          index: i + 1,
	          time: clockTime,
	          active: clockTime === time,
	          radius: radius,
	          onKeyboardFocus: onChange
	        });
	      });
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: this._setFace,
	          className: 'md-clock-face md-block-centered md-pointer--hover',
	          onMouseDown: this._handleMouseDown,
	          onMouseEnter: hoverMode ? this._handleMouseEnter : undefined,
	          onMouseLeave: hoverMode ? this._handleMouseLeave : undefined,
	          onTouchStart: this._handleTouchStart
	        },
	        _react2.default.createElement(_ResizeObserver2.default, { watchHeight: true, onResize: this._setPositioning }),
	        times,
	        _react2.default.createElement(_ClockHand2.default, { time: time, coords: radius, minutes: minutes })
	      );
	    }
	  }]);
	
	  return ClockFace;
	}(_react.PureComponent);
	
	ClockFace.propTypes = {
	  /**
	   * The current time for the clock.
	   */
	  time: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the clock is on the minutes view.
	   */
	  minutes: _propTypes2.default.bool.isRequired,
	
	  /**
	   * A function to call when a new time is selected. It gives the
	   * new time value. If it is 12 o'clock, 0 will be given.
	   */
	  onChange: _propTypes2.default.func.isRequired,
	
	  /**
	   * An optional time period string. This should be either AM or PM
	   * if the locale uses them.
	   */
	  timePeriod: _propTypes2.default.string,
	
	  /**
	   * If true the hover mode of the Time Picker is activated.
	   * In hover mode no clicks are required to start selecting an hour
	   * and the timemode switches automatically when a time was chosen.
	   * When a minute is selected the chosen time is applied automatically.
	   */
	  hoverMode: _propTypes2.default.bool,
	
	  onTimeChosen: _propTypes2.default.func.isRequired
	};
	exports.default = ClockFace;
	//# sourceMappingURL=ClockFace.js.map

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `ClockHand` component is just used to display the hand of the clock
	 * and a ball to surround the selected time.
	 */
	var ClockHand = function (_PureComponent) {
	  _inherits(ClockHand, _PureComponent);
	
	  function ClockHand(props) {
	    _classCallCheck(this, ClockHand);
	
	    var _this = _possibleConstructorReturn(this, (ClockHand.__proto__ || Object.getPrototypeOf(ClockHand)).call(this, props));
	
	    _this.state = { active: false };
	    return _this;
	  }
	
	  _createClass(ClockHand, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.props.minutes !== nextProps.minutes) {
	        if (this.state.timeout) {
	          clearTimeout(this.state.timeout);
	        }
	
	        this.setState({
	          active: true,
	          timeout: setTimeout(function () {
	            return _this2.setState({ active: false, timeout: null });
	          }, 150)
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.timeout) {
	        clearTimeout(this.state.timeout);
	      }
	    }
	  }, {
	    key: '_calcCurrentDegrees',
	    value: function _calcCurrentDegrees(_ref) {
	      var time = _ref.time,
	          minutes = _ref.minutes;
	
	      var timeAt0Deg = minutes ? 15 : 3;
	      var sectors = minutes ? 60 : 12;
	
	      return (time % sectors - timeAt0Deg) * (360 / sectors);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          coords = _props.coords,
	          time = _props.time,
	          minutes = _props.minutes;
	
	
	      var degrees = this._calcCurrentDegrees(this.props);
	      var invisibleMinute = false;
	      if (minutes) {
	        invisibleMinute = degrees % (360 / 12) !== 0;
	      }
	
	      var rotateTransform = 'rotate3d(0, 0, 1, ' + degrees + 'deg)';
	      return _react2.default.createElement('div', {
	        className: (0, _classnames2.default)('md-clock-hand md-background--primary', {
	          'md-clock-hand--active': this.state.active,
	          'md-clock-hand--minute-hover': invisibleMinute,
	          'md-clock-hand--inner': !minutes && (time > 12 || time === 0)
	        }),
	        style: {
	          left: coords,
	          top: coords,
	          WebkitTransform: rotateTransform,
	          MozTransform: rotateTransform,
	          msTransform: rotateTransform,
	          transform: rotateTransform
	        }
	      });
	    }
	  }]);
	
	  return ClockHand;
	}(_react.PureComponent);
	
	ClockHand.propTypes = {
	  /**
	   * This is the x and y coordinate to use for the center of the `ClockFace`.
	   * This should really be whatever the radius of the `ClockFace` is.
	   */
	  coords: _propTypes2.default.number,
	
	  /**
	   * The current time of the clock.
	   */
	  time: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the clock is displaying minutes instead of hours.
	   */
	  minutes: _propTypes2.default.bool.isRequired
	};
	exports.default = ClockHand;
	//# sourceMappingURL=ClockHand.js.map

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keyCodes = __webpack_require__(15);
	
	var _themeColors = __webpack_require__(12);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CLOCK_PADDING = 4;
	
	/**
	 * The `ClockTime` component is used for positioning hours or minutes
	 * in a clock. The time will be positioned based on it's given index
	 * and the radius of the clock.
	 */
	
	var ClockTime = function (_PureComponent) {
	  _inherits(ClockTime, _PureComponent);
	
	  function ClockTime(props) {
	    _classCallCheck(this, ClockTime);
	
	    var _this = _possibleConstructorReturn(this, (ClockTime.__proto__ || Object.getPrototypeOf(ClockTime)).call(this, props));
	
	    _this._handleKeyUp = function (e) {
	      if ((e.which || e.keyCode) === _keyCodes.TAB) {
	        _this.props.onKeyboardFocus(_this.props.time);
	      }
	    };
	
	    _this._setTime = function (time) {
	      _this._time = time;
	      if (time !== null) {
	        _this._setPosition(_this.props, time);
	
	        if (_this.props.active) {
	          time.focus();
	        }
	      }
	    };
	
	    _this._setPosition = function (_ref, time) {
	      var radius = _ref.radius,
	          index = _ref.index;
	
	      // 36 is default size for the time
	      var size = (time.offsetWidth || 36) / 2;
	      var timeRadians = Math.PI / 2 - index * (Math.PI / 6);
	      var innerCircle = index > 12;
	
	      var outerRadius = radius - size;
	      var innerRadius = outerRadius - CLOCK_PADDING - (innerCircle ? size * 2 : 0);
	
	      _this.setState({
	        style: {
	          top: outerRadius - innerRadius * Math.sin(timeRadians),
	          left: outerRadius + innerRadius * Math.cos(timeRadians)
	        }
	      });
	    };
	
	    _this.state = {
	      // default size in scss
	      size: 18
	    };
	    return _this;
	  }
	
	  _createClass(ClockTime, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.radius !== nextProps.radius || this.props.index !== nextProps.index) {
	        this._setPosition(nextProps, this._time);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          time = _props.time,
	          active = _props.active;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: this._setTime,
	          tabIndex: 0,
	          className: (0, _classnames2.default)('md-clock-time md-text-no-select md-pointer--none', {
	            'md-picker-text--active': active
	          }, (0, _themeColors2.default)({ text: !active })),
	          style: this.state.style,
	          onKeyUp: this._handleKeyUp
	        },
	        _react2.default.createElement(
	          'span',
	          { className: 'md-clock-time-value' },
	          time
	        )
	      );
	    }
	  }]);
	
	  return ClockTime;
	}(_react.PureComponent);
	
	ClockTime.propTypes = {
	  /**
	   * The index of the current time to be displayed. This
	   * should be a number between 1 and 24.
	   */
	  index: _propTypes2.default.number.isRequired,
	
	  /**
	   * The time number to display.
	   */
	  time: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if this time is currently selected.
	   */
	  active: _propTypes2.default.bool.isRequired,
	
	  /**
	   * The radius of the clock.
	   */
	  radius: _propTypes2.default.number.isRequired,
	
	  onKeyboardFocus: _propTypes2.default.func.isRequired
	};
	exports.default = ClockTime;
	//# sourceMappingURL=ClockTime.js.map

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DialogFooter = __webpack_require__(108);
	
	var _DialogFooter2 = _interopRequireDefault(_DialogFooter);
	
	var _DatePickerHeader = __webpack_require__(613);
	
	var _DatePickerHeader2 = _interopRequireDefault(_DatePickerHeader);
	
	var _DatePickerCalendar = __webpack_require__(611);
	
	var _DatePickerCalendar2 = _interopRequireDefault(_DatePickerCalendar);
	
	var _YearPicker = __webpack_require__(619);
	
	var _YearPicker2 = _interopRequireDefault(_YearPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DatePicker = function (_PureComponent) {
	  _inherits(DatePicker, _PureComponent);
	
	  function DatePicker() {
	    _classCallCheck(this, DatePicker);
	
	    return _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).apply(this, arguments));
	  }
	
	  _createClass(DatePicker, [{
	    key: 'render',
	    value: function render() {
	      var _cn;
	
	      var _props = this.props,
	          okLabel = _props.okLabel,
	          okPrimary = _props.okPrimary,
	          onOkClick = _props.onOkClick,
	          cancelLabel = _props.cancelLabel,
	          cancelPrimary = _props.cancelPrimary,
	          onCancelClick = _props.onCancelClick,
	          DateTimeFormat = _props.DateTimeFormat,
	          locales = _props.locales,
	          calendarTempDate = _props.calendarTempDate,
	          calendarMode = _props.calendarMode,
	          changeCalendarMode = _props.changeCalendarMode,
	          style = _props.style,
	          className = _props.className,
	          inline = _props.inline,
	          icon = _props.icon,
	          displayMode = _props.displayMode,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          disableWeekEnds = _props.disableWeekEnds,
	          showAllDays = _props.showAllDays,
	          disableOuterDates = _props.disableOuterDates,
	          headerClassName = _props.headerClassName,
	          contentClassName = _props.contentClassName,
	          footerClassName = _props.footerClassName,
	          calendarClassName = _props.calendarClassName,
	          yearPickerClassName = _props.yearPickerClassName,
	          calendarDateClassName = _props.calendarDateClassName,
	          calendarOuterDateClassName = _props.calendarOuterDateClassName,
	          calendarTitleClassName = _props.calendarTitleClassName,
	          calendarTitleFormat = _props.calendarTitleFormat,
	          calendarWeekdayClassName = _props.calendarWeekdayClassName,
	          calendarWeekdayFormat = _props.calendarWeekdayFormat,
	          timeZone = _props.timeZone,
	          props = _objectWithoutProperties(_props, ['okLabel', 'okPrimary', 'onOkClick', 'cancelLabel', 'cancelPrimary', 'onCancelClick', 'DateTimeFormat', 'locales', 'calendarTempDate', 'calendarMode', 'changeCalendarMode', 'style', 'className', 'inline', 'icon', 'displayMode', 'firstDayOfWeek', 'disableWeekEnds', 'showAllDays', 'disableOuterDates', 'headerClassName', 'contentClassName', 'footerClassName', 'calendarClassName', 'yearPickerClassName', 'calendarDateClassName', 'calendarOuterDateClassName', 'calendarTitleClassName', 'calendarTitleFormat', 'calendarWeekdayClassName', 'calendarWeekdayFormat', 'timeZone']);
	
	      var picker = void 0;
	      if (calendarMode === 'calendar') {
	        picker = _react2.default.createElement(_DatePickerCalendar2.default, _extends({}, props, {
	          key: 'calendar',
	          className: calendarClassName,
	          calendarTempDate: calendarTempDate,
	          DateTimeFormat: DateTimeFormat,
	          locales: locales,
	          firstDayOfWeek: firstDayOfWeek,
	          disableWeekEnds: disableWeekEnds,
	          showAllDays: showAllDays,
	          disableOuterDates: disableOuterDates,
	          dateClassName: calendarDateClassName,
	          outerDateClassName: calendarOuterDateClassName,
	          titleClassName: calendarTitleClassName,
	          titleFormat: calendarTitleFormat,
	          weekdayClassName: calendarWeekdayClassName,
	          weekdayFormat: calendarWeekdayFormat,
	          timeZone: timeZone
	        }));
	      } else {
	        picker = _react2.default.createElement(_YearPicker2.default, _extends({}, props, {
	          key: 'year',
	          className: yearPickerClassName,
	          calendarTempDate: calendarTempDate,
	          DateTimeFormat: DateTimeFormat,
	          locales: locales
	        }));
	      }
	
	      var actions = [{
	        key: 'cancel',
	        onClick: onCancelClick,
	        primary: cancelPrimary,
	        secondary: !cancelPrimary,
	        label: cancelLabel
	      }, {
	        key: 'ok',
	        onClick: onOkClick,
	        primary: okPrimary,
	        secondary: !okPrimary,
	        label: okLabel
	      }];
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: style,
	          className: (0, _classnames2.default)('md-picker md-picker--date', (_cn = {}, _defineProperty(_cn, 'md-picker--' + displayMode, displayMode), _defineProperty(_cn, 'md-picker--inline', inline), _defineProperty(_cn, 'md-picker--inline-icon', inline && icon), _cn), className)
	        },
	        _react2.default.createElement(_DatePickerHeader2.default, {
	          className: headerClassName,
	          DateTimeFormat: DateTimeFormat,
	          locales: locales,
	          calendarTempDate: calendarTempDate,
	          calendarMode: calendarMode,
	          changeCalendarMode: changeCalendarMode,
	          timeZone: timeZone
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('md-picker-content-container', contentClassName) },
	          picker,
	          _react2.default.createElement(_DialogFooter2.default, {
	            className: footerClassName,
	            actions: actions
	          })
	        )
	      );
	    }
	  }]);
	
	  return DatePicker;
	}(_react.PureComponent);
	
	DatePicker.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  okLabel: _propTypes2.default.node.isRequired,
	  okPrimary: _propTypes2.default.bool.isRequired,
	  onOkClick: _propTypes2.default.func.isRequired,
	  cancelLabel: _propTypes2.default.node.isRequired,
	  cancelPrimary: _propTypes2.default.bool.isRequired,
	  onCancelClick: _propTypes2.default.func.isRequired,
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	  calendarDate: _propTypes2.default.instanceOf(Date).isRequired,
	  calendarTempDate: _propTypes2.default.instanceOf(Date).isRequired,
	  calendarMode: _propTypes2.default.oneOf(['calendar', 'year']).isRequired,
	  changeCalendarMode: _propTypes2.default.func.isRequired,
	  icon: _propTypes2.default.bool,
	  inline: _propTypes2.default.bool,
	  displayMode: _propTypes2.default.oneOf(['landscape', 'portrait']),
	
	  /**
	   * The first day of week: 0 for Sunday, 1 for Monday, 2 for Tuesday, and so on.
	   */
	  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
	
	  /**
	   * True if weekends are to be greyed out.
	   */
	  disableWeekEnds: _propTypes2.default.bool,
	
	  /**
	   * True if dates from adjacent months should be shown in calendar.
	   */
	  showAllDays: _propTypes2.default.bool,
	  disableOuterDates: _propTypes2.default.bool,
	
	  /**
	   * An optional className to apply to the header of date picker.
	   */
	  headerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the content container of date picker.
	   */
	  contentClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the footer of date picker.
	   */
	  footerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the calendar container of date picker.
	   */
	  calendarClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the year picker of date picker.
	   */
	  yearPickerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to a date in calendar.
	   */
	  calendarDateClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to a date from an adjacent month in calendar.
	   */
	  calendarOuterDateClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the title in calendar header.
	   */
	  calendarTitleClassName: _propTypes2.default.string,
	
	  /**
	   * The DateTimeFormat options to apply to format the title in calendar header.
	   */
	  calendarTitleFormat: _propTypes2.default.shape({
	    era: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	    year: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    month: _propTypes2.default.oneOf(['numeric', '2-digit', 'narrow', 'short', 'long'])
	  }),
	
	  /**
	   * An optional className to apply to a weekday in calendar header.
	   */
	  calendarWeekdayClassName: _propTypes2.default.string,
	
	  /**
	   * The DateTimeFormat option to apply to format a weekday in calendar header.
	   */
	  calendarWeekdayFormat: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	
	  /**
	   * The timeZone to be used in all formatting operations.
	   * For a full list of possible timeZone values check https://www.iana.org/time-zones.
	   */
	  timeZone: _propTypes2.default.string.isRequired
	};
	exports.default = DatePicker;
	//# sourceMappingURL=DatePicker.js.map

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CalendarMonth = __webpack_require__(606);
	
	var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);
	
	var _CalendarHeader = __webpack_require__(605);
	
	var _CalendarHeader2 = _interopRequireDefault(_CalendarHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DatePickerCalendar = function (_PureComponent) {
	  _inherits(DatePickerCalendar, _PureComponent);
	
	  function DatePickerCalendar() {
	    _classCallCheck(this, DatePickerCalendar);
	
	    return _possibleConstructorReturn(this, (DatePickerCalendar.__proto__ || Object.getPrototypeOf(DatePickerCalendar)).apply(this, arguments));
	  }
	
	  _createClass(DatePickerCalendar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          previousIcon = _props.previousIcon,
	          onPreviousClick = _props.onPreviousClick,
	          nextIcon = _props.nextIcon,
	          onNextClick = _props.onNextClick,
	          calendarDate = _props.calendarDate,
	          calendarTempDate = _props.calendarTempDate,
	          onCalendarDateClick = _props.onCalendarDateClick,
	          DateTimeFormat = _props.DateTimeFormat,
	          locales = _props.locales,
	          minDate = _props.minDate,
	          maxDate = _props.maxDate,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          disableWeekEnds = _props.disableWeekEnds,
	          showAllDays = _props.showAllDays,
	          disableOuterDates = _props.disableOuterDates,
	          dateClassName = _props.dateClassName,
	          outerDateClassName = _props.outerDateClassName,
	          titleClassName = _props.titleClassName,
	          titleFormat = _props.titleFormat,
	          weekdayClassName = _props.weekdayClassName,
	          weekdayFormat = _props.weekdayFormat,
	          timeZone = _props.timeZone;
	
	
	      return _react2.default.createElement(
	        'section',
	        { className: (0, _classnames2.default)('md-picker-content md-picker-content--calendar', className) },
	        _react2.default.createElement(_CalendarHeader2.default, {
	          date: calendarDate,
	          minDate: minDate,
	          maxDate: maxDate,
	          DateTimeFormat: DateTimeFormat,
	          locales: locales,
	          onPreviousClick: onPreviousClick,
	          previousIcon: previousIcon,
	          onNextClick: onNextClick,
	          nextIcon: nextIcon,
	          firstDayOfWeek: firstDayOfWeek,
	          titleClassName: titleClassName,
	          titleFormat: titleFormat,
	          weekdayClassName: weekdayClassName,
	          weekdayFormat: weekdayFormat,
	          timeZone: timeZone
	        }),
	        _react2.default.createElement(_CalendarMonth2.default, {
	          key: new DateTimeFormat(locales).format(calendarDate),
	          calendarDate: calendarDate,
	          calendarTempDate: calendarTempDate,
	          onCalendarDateClick: onCalendarDateClick,
	          minDate: minDate,
	          maxDate: maxDate,
	          DateTimeFormat: DateTimeFormat,
	          locales: locales,
	          firstDayOfWeek: firstDayOfWeek,
	          disableWeekEnds: disableWeekEnds,
	          showAllDays: showAllDays,
	          disableOuterDates: disableOuterDates,
	          dateClassName: dateClassName,
	          outerDateClassName: outerDateClassName,
	          timeZone: timeZone
	        })
	      );
	    }
	  }]);
	
	  return DatePickerCalendar;
	}(_react.PureComponent);
	
	DatePickerCalendar.propTypes = {
	  className: _propTypes2.default.string,
	  previousIcon: _propTypes2.default.element,
	  onPreviousClick: _propTypes2.default.func.isRequired,
	  nextIcon: _propTypes2.default.element,
	  onNextClick: _propTypes2.default.func.isRequired,
	  onCalendarDateClick: _propTypes2.default.func.isRequired,
	  calendarDate: _propTypes2.default.instanceOf(Date).isRequired,
	  calendarTempDate: _propTypes2.default.instanceOf(Date).isRequired,
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	  minDate: _propTypes2.default.instanceOf(Date),
	  maxDate: _propTypes2.default.instanceOf(Date),
	
	  /**
	   * The first day of week: 0 for Sunday, 1 for Monday, 2 for Tuesday, and so on.
	   */
	  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
	
	  /**
	   * True if weekends are to be greyed out.
	   */
	  disableWeekEnds: _propTypes2.default.bool,
	
	  /**
	   * True if dates from adjacent months should be shown.
	   */
	  showAllDays: _propTypes2.default.bool,
	  disableOuterDates: _propTypes2.default.bool,
	
	  /**
	   * An optional className to apply to a date in calendar.
	   */
	  dateClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to a date from an adjacent month.
	   */
	  outerDateClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the title in calendar header.
	   */
	  titleClassName: _propTypes2.default.string,
	
	  /**
	   * The DateTimeFormat options to apply to format the title in calendar header.
	   */
	  titleFormat: _propTypes2.default.shape({
	    era: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	    year: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    month: _propTypes2.default.oneOf(['numeric', '2-digit', 'narrow', 'short', 'long'])
	  }),
	
	  /**
	   * An optional className to apply to a weekday in calendar header.
	   */
	  weekdayClassName: _propTypes2.default.string,
	
	  /**
	   * The DateTimeFormat option to apply to format a weekday in calendar header.
	   */
	  weekdayFormat: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	
	  /**
	   * The timeZone to be used in all formatting operations.
	   * For a full list of possible timeZone values check https://www.iana.org/time-zones.
	   */
	  timeZone: _propTypes2.default.string.isRequired
	};
	exports.default = DatePickerCalendar;
	//# sourceMappingURL=DatePickerCalendar.js.map

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(17);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _keyCodes = __webpack_require__(15);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _handleWindowClickListeners = __webpack_require__(112);
	
	var _handleWindowClickListeners2 = _interopRequireDefault(_handleWindowClickListeners);
	
	var _handleKeyboardAccessibility = __webpack_require__(83);
	
	var _handleKeyboardAccessibility2 = _interopRequireDefault(_handleKeyboardAccessibility);
	
	var _controlled = __webpack_require__(16);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _isDateEqual = __webpack_require__(669);
	
	var _isDateEqual2 = _interopRequireDefault(_isDateEqual);
	
	var _addDate = __webpack_require__(176);
	
	var _addDate2 = _interopRequireDefault(_addDate);
	
	var _DateTimeFormat = __webpack_require__(296);
	
	var _DateTimeFormat2 = _interopRequireDefault(_DateTimeFormat);
	
	var _Collapse = __webpack_require__(46);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _FontIcon = __webpack_require__(13);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(21);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _TextField = __webpack_require__(65);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _DialogContainer = __webpack_require__(168);
	
	var _DialogContainer2 = _interopRequireDefault(_DialogContainer);
	
	var _DatePicker = __webpack_require__(610);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable new-cap,no-shadow */
	
	
	/**
	 * The `DatePickerContainer` component is a wrapper for the main `DatePicker` component
	 * to manage the state and _logic_ for rendering the `DatePicker`. This component will
	 * either render inline or in a `Dialog` depending if the `inline` prop is set to `true`.
	 *
	 * NOTE: This component is actually exported as `DatePicker` when using the `import { member }` syntax.
	 * The following two lines are equivalent:
	 *
	 * ```js
	 * import { DatePicker } from 'react-md/lib/Pickers';
	 * import DatePicker from 'react-md/lib/Pickers/DatePickerContainer';
	 * ```
	 */
	var DatePickerContainer = function (_PureComponent) {
	  _inherits(DatePickerContainer, _PureComponent);
	
	  function DatePickerContainer(props) {
	    _classCallCheck(this, DatePickerContainer);
	
	    var _this = _possibleConstructorReturn(this, (DatePickerContainer.__proto__ || Object.getPrototypeOf(DatePickerContainer)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var date = void 0;
	    var value = void 0;
	    var defaultValue = props.defaultValue,
	        DateTimeFormat = props.DateTimeFormat,
	        locales = props.locales,
	        minDate = props.minDate,
	        maxDate = props.maxDate;
	
	
	    if (typeof props.value !== 'undefined') {
	      date = _this._getDate(props.value);
	    } else if (defaultValue) {
	      date = _this._getDate(defaultValue);
	      value = typeof defaultValue === 'string' ? defaultValue : DateTimeFormat(locales, _this._getFormatOptions()).format(defaultValue);
	    } else {
	      date = new Date();
	      value = '';
	    }
	
	    date = _this._validateDateRange(date, minDate, maxDate);
	
	    var defaultCalendarDate = typeof props.initialCalendarDate !== 'undefined' ? props.initialCalendarDate : props.defaultCalendarDate;
	    var calendarTempDate = date;
	    if (typeof defaultCalendarDate !== 'undefined' && !props.value && !props.defaultValue) {
	      calendarTempDate = _this._getDate(defaultCalendarDate);
	      date = calendarTempDate;
	    } else if (calendarTempDate === null) {
	      calendarTempDate = new Date();
	      date = new Date();
	    }
	
	    var visible = typeof props.initiallyOpen !== 'undefined' ? props.initiallyOpen : !!props.defaultVisible;
	
	    _this.state = {
	      value: value,
	      visible: visible,
	      calendarDate: date,
	      calendarTempDate: calendarTempDate,
	      calendarMode: props.initialCalendarMode || props.defaultCalendarMode
	    };
	    return _this;
	  }
	
	  _createClass(DatePickerContainer, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var value = nextProps.value,
	          minDate = nextProps.minDate,
	          maxDate = nextProps.maxDate;
	
	      var minEqual = (0, _isDateEqual2.default)(this.props.minDate, minDate);
	      var maxEqual = (0, _isDateEqual2.default)(this.props.maxDate, maxDate);
	      if (this.props.value !== value || !minEqual || !maxEqual) {
	        var calendarDate = this.state.calendarDate;
	
	        if (typeof value !== 'undefined') {
	          calendarDate = this._getDate(value);
	        }
	
	        calendarDate = this._validateDateRange(calendarDate, minDate, maxDate);
	
	        if (!(0, _isDateEqual2.default)(this.state.calendarDate, calendarDate)) {
	          this.setState({ calendarDate: calendarDate, calendarTempDate: calendarDate });
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _props = this.props,
	          inline = _props.inline,
	          isOpen = _props.isOpen;
	
	      var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	      var pVisible = typeof prevProps.isOpen !== 'undefined' ? prevProps.isOpen : (0, _getField2.default)(prevProps, prevState, 'visible');
	
	      if (visible === pVisible) {
	        return;
	      }
	
	      if (visible) {
	        if (inline) {
	          (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, true);
	          window.addEventListener('keydown', this._closeOnEsc);
	        }
	      } else if (inline) {
	        (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, false);
	        window.removeEventListener('keydown', this._closeOnEsc);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var visible = typeof this.props.isOpen !== 'undefined' ? this.props.isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	
	      if (visible && this.props.inline) {
	        (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, false);
	        window.removeEventListener('keydown', this._closeOnEsc);
	      }
	    }
	  }, {
	    key: '_getDate',
	    value: function _getDate(value) {
	      if (value === '' || value === null) {
	        return new Date();
	      } else if (typeof value === 'string') {
	        return new Date(value);
	      }
	
	      return value;
	    }
	  }, {
	    key: '_getFormatOptions',
	    value: function _getFormatOptions() {
	      var _props2 = this.props,
	          formatOptions = _props2.formatOptions,
	          timeZone = _props2.timeZone;
	
	      return _extends({}, formatOptions, { timeZone: timeZone });
	    }
	  }, {
	    key: '_getFormattedValue',
	
	
	    /**
	     * Gets the current value from the date picker as a formatted string.
	     *
	     * @param {Object} props? the props object to use.
	     * @param {Object} state? the state object to use.
	     * @return {String} a formatted date string or the empty string.
	     */
	    value: function _getFormattedValue(props, state) {
	      var DateTimeFormat = props.DateTimeFormat,
	          locales = props.locales;
	
	      var value = (0, _getField2.default)(props, state, 'value');
	      if (!value) {
	        return '';
	      } else if (value instanceof Date) {
	        return DateTimeFormat(locales, this._getFormatOptions()).format(new Date(value));
	      } else {
	        return value;
	      }
	    }
	
	    /**
	     * Attempts to validate the `calendarDate` in the state against the min and
	     * max dates.
	     *
	     * This will return null if the current calendarDate is still within the range.
	     *
	     * @param {Date} calendarDate - The current calendar date to compare to.
	     * @param {Date} minDate - An optional min date to compare to.
	     * @param {Date} maxDate - An optional max date to compare to.
	     * @return {Object} - The new state object with the updated calendarDate and
	     *    calendarTempDate keys or null.
	     */
	
	  }, {
	    key: '_validateDateRange',
	    value: function _validateDateRange(calendarDate, minDate, maxDate) {
	      var date = calendarDate;
	      if (minDate && minDate > calendarDate) {
	        date = new Date(minDate);
	      }
	
	      if (maxDate && maxDate < calendarDate) {
	        date = new Date(maxDate);
	      }
	
	      return date;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          style = _props3.style,
	          className = _props3.className,
	          pickerStyle = _props3.pickerStyle,
	          pickerClassName = _props3.pickerClassName,
	          pickerHeaderClassName = _props3.pickerHeaderClassName,
	          pickerContentClassName = _props3.pickerContentClassName,
	          pickerFooterClassName = _props3.pickerFooterClassName,
	          inputStyle = _props3.inputStyle,
	          inputClassName = _props3.inputClassName,
	          textFieldStyle = _props3.textFieldStyle,
	          textFieldClassName = _props3.textFieldClassName,
	          label = _props3.label,
	          placeholder = _props3.placeholder,
	          icon = _props3.icon,
	          inline = _props3.inline,
	          displayMode = _props3.displayMode,
	          fullWidth = _props3.fullWidth,
	          lineDirection = _props3.lineDirection,
	          id = _props3.id,
	          disabled = _props3.disabled,
	          closeOnEsc = _props3.closeOnEsc,
	          animateInline = _props3.animateInline,
	          portal = _props3.portal,
	          renderNode = _props3.renderNode,
	          lastChild = _props3.lastChild,
	          block = _props3.block,
	          paddedBlock = _props3.paddedBlock,
	          active = _props3.active,
	          error = _props3.error,
	          floating = _props3.floating,
	          required = _props3.required,
	          leftIconStateful = _props3.leftIconStateful,
	          rightIcon = _props3.rightIcon,
	          rightIconStateful = _props3.rightIconStateful,
	          customSize = _props3.customSize,
	          errorText = _props3.errorText,
	          helpText = _props3.helpText,
	          helpOnFocus = _props3.helpOnFocus,
	          inlineIndicator = _props3.inlineIndicator,
	          disableScrollLocking = _props3.disableScrollLocking,
	          ariaLabel = _props3['aria-label'],
	          propNextIcon = _props3.nextIcon,
	          propPreviousIcon = _props3.previousIcon,
	          isOpen = _props3.isOpen,
	          previousIconChildren = _props3.previousIconChildren,
	          previousIconClassName = _props3.previousIconClassName,
	          nextIconChildren = _props3.nextIconChildren,
	          nextIconClassName = _props3.nextIconClassName,
	          propValue = _props3.value,
	          propVisible = _props3.visible,
	          defaultValue = _props3.defaultValue,
	          defaultVisible = _props3.defaultVisible,
	          onChange = _props3.onChange,
	          readOnly = _props3.readOnly,
	          onVisibilityChange = _props3.onVisibilityChange,
	          defaultCalendarDate = _props3.defaultCalendarDate,
	          initialCalendarDate = _props3.initialCalendarDate,
	          initiallyOpen = _props3.initiallyOpen,
	          adjustMinWidth = _props3.adjustMinWidth,
	          props = _objectWithoutProperties(_props3, ['style', 'className', 'pickerStyle', 'pickerClassName', 'pickerHeaderClassName', 'pickerContentClassName', 'pickerFooterClassName', 'inputStyle', 'inputClassName', 'textFieldStyle', 'textFieldClassName', 'label', 'placeholder', 'icon', 'inline', 'displayMode', 'fullWidth', 'lineDirection', 'id', 'disabled', 'closeOnEsc', 'animateInline', 'portal', 'renderNode', 'lastChild', 'block', 'paddedBlock', 'active', 'error', 'floating', 'required', 'leftIconStateful', 'rightIcon', 'rightIconStateful', 'customSize', 'errorText', 'helpText', 'helpOnFocus', 'inlineIndicator', 'disableScrollLocking', 'aria-label', 'nextIcon', 'previousIcon', 'isOpen', 'previousIconChildren', 'previousIconClassName', 'nextIconChildren', 'nextIconClassName', 'value', 'visible', 'defaultValue', 'defaultVisible', 'onChange', 'readOnly', 'onVisibilityChange', 'defaultCalendarDate', 'initialCalendarDate', 'initiallyOpen', 'adjustMinWidth']);
	
	      var nextIcon = (0, _getDeprecatedIcon2.default)(nextIconClassName, nextIconChildren, propNextIcon);
	      var previousIcon = (0, _getDeprecatedIcon2.default)(previousIconClassName, previousIconChildren, propPreviousIcon);
	      var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	
	      var picker = _react2.default.createElement(_DatePicker2.default, _extends({}, this.state, props, {
	        nextIcon: nextIcon,
	        previousIcon: previousIcon,
	        icon: !!icon,
	        inline: inline,
	        style: pickerStyle,
	        className: pickerClassName,
	        headerClassName: pickerHeaderClassName,
	        contentClassName: pickerContentClassName,
	        footerClassName: pickerFooterClassName,
	        displayMode: displayMode,
	        onCancelClick: this._handleCancelClick,
	        onOkClick: this._handleOkClick,
	        changeCalendarMode: this._changeCalendarMode,
	        onPreviousClick: this._previousMonth,
	        onNextClick: this._nextMonth,
	        onCalendarDateClick: this._setCalendarTempDate,
	        onCalendarYearClick: this._setCalendarTempYear
	      }));
	
	      var content = void 0;
	      if (inline) {
	        content = _react2.default.createElement(
	          _Collapse2.default,
	          { collapsed: !visible, animate: animateInline },
	          picker
	        );
	      } else {
	        content = _react2.default.createElement(
	          _DialogContainer2.default,
	          {
	            id: id + '-dialog',
	            visible: visible,
	            onHide: this._handleCancelClick,
	            dialogClassName: 'md-dialog--picker',
	            contentClassName: 'md-dialog-content--picker',
	            'aria-label': ariaLabel,
	            closeOnEsc: closeOnEsc,
	            renderNode: renderNode,
	            portal: portal,
	            lastChild: lastChild,
	            focusOnMount: false,
	            disableScrollLocking: disableScrollLocking
	          },
	          picker
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: style, className: (0, _classnames2.default)('md-picker-container', className), ref: this._setContainer },
	        _react2.default.createElement(_TextField2.default, {
	          id: id,
	          style: textFieldStyle,
	          className: (0, _classnames2.default)({ 'md-pointer--hover': !disabled }, textFieldClassName),
	          inputStyle: inputStyle,
	          inputClassName: (0, _classnames2.default)({ 'md-pointer--hover': !disabled }, inputClassName),
	          active: active || visible,
	          error: error,
	          floating: floating || visible,
	          required: required,
	          disabled: disabled,
	          leftIcon: icon,
	          leftIconStateful: leftIconStateful,
	          rightIcon: rightIcon,
	          rightIconStateful: rightIconStateful,
	          inlineIndicator: inlineIndicator,
	          block: block,
	          paddedBlock: paddedBlock,
	          fullWidth: fullWidth,
	          lineDirection: lineDirection,
	          customSize: customSize,
	          helpText: helpText,
	          helpOnFocus: helpOnFocus,
	          errorText: errorText,
	          label: label,
	          placeholder: placeholder,
	          onClick: this._toggleOpen,
	          onKeyDown: this._handleKeyDown,
	          value: this._getFormattedValue(this.props, this.state),
	          readOnly: true
	        }),
	        content
	      );
	    }
	  }]);
	
	  return DatePickerContainer;
	}(_react.PureComponent);
	
	DatePickerContainer.propTypes = {
	  /**
	   * An id for the text field in the date picker. This is require for a11y.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * An aria label for the dialog. This is required for a11y.
	   */
	  'aria-label': (0, _isRequiredForA11y2.default)(_propTypes2.default.string),
	
	  /**
	   * An optional style to apply to the date picker's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the date picker's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the date picker.
	   */
	  pickerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the date picker.
	   */
	  pickerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the header of date picker.
	   */
	  pickerHeaderClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the content container of date picker.
	   */
	  pickerContentClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the footer of date picker.
	   */
	  pickerFooterClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the calendar container of date picker.
	   */
	  calendarClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the year picker of date picker.
	   */
	  yearPickerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the input tag.
	   */
	  inputStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the input tag.
	   */
	  inputClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the text field's container.
	   */
	  textFieldStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the text field's container.
	   */
	  textFieldClassName: _propTypes2.default.string,
	
	  /**
	   * An optional icon to display with the date picker.
	   *
	   * @see {@link TextFields/TextField#leftIcon}
	   */
	  icon: _propTypes2.default.node,
	
	  /**
	   * Boolean if the date picker is open by default.
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * An optional label to be displayed in the date picker's text
	   * field.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * An optional placeholder to be displayed in the date picker's text field.
	   */
	  placeholder: _propTypes2.default.string,
	
	  /**
	   * The value of the date picker. This will make the date picker
	   * be a controlled component. This value should either be a
	   * formatted date string or a date object.
	   */
	  value: (0, _controlled2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]), 'onChange', 'defaultValue'),
	
	  /**
	   * An optional default value to give for the date picker. This should
	   * either be a formatted date string or a date object.
	   */
	  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]),
	
	  /**
	   * An optional date to use when the calendar is opened for the first time.
	   * If this is omitted, it will either be the `defaultValue`, `value`, or
	   * today.
	   */
	  defaultCalendarDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]),
	
	  /**
	   * An optional function to call when the selected date is changed
	   * by hitting the OK button. The newly formatted date string,
	   * the new Date object, and the change event will be given.
	   *
	   * `onChange(dateString, dateObject, event)`.
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * A function to format the dates since it should be formatted to the user's
	   * locale. This _should_ be the `Intl.DateTimeFormat` function. You
	   * can also create your own if you really wanted. Inadvisable though.
	   *
	   * See [intl-polyfill](https://github.com/andyearnshaw/Intl.js/) for more info.
	   */
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	
	  /**
	   * The locales to use for formatting the date. This will default to using
	   * the user's language in the browser or `'en-US'` when server rendering.
	   */
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	
	  /**
	   * The label to use for the ok button on the date picker.
	   */
	  okLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the ok button should be styled with the primary color.
	   */
	  okPrimary: _propTypes2.default.bool,
	
	  /**
	   * The label to use for the cancel button on the date picker.
	   */
	  cancelLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the cancel button should be styled with the primary color.
	   */
	  cancelPrimary: _propTypes2.default.bool,
	
	  /**
	   * The initial mode to open the calendar in.
	   */
	  defaultCalendarMode: _propTypes2.default.oneOf(['calendar', 'year']),
	
	  /**
	   * The icon to use to display the previous month icon in the calendar.
	   */
	  previousIcon: _propTypes2.default.node,
	
	  /**
	   * The icon to use to display the next month icon in the calendar.
	   */
	  nextIcon: _propTypes2.default.node,
	
	  /**
	   * An optional min date to use for the date picker. This will prevent
	   * any dates before this time to be chosen.
	   */
	  minDate: _propTypes2.default.instanceOf(Date),
	
	  /**
	   * An optional max date to use for the date picker. This will prevent
	   * any dates after this time to be chosen.
	   */
	  maxDate: function maxDate(props, propName, component) {
	    for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      others[_key - 3] = arguments[_key];
	    }
	
	    var err = _propTypes2.default.instanceOf(Date).apply(undefined, [props, propName, component].concat(others));
	    if (err || !props.minDate || !props[propName]) {
	      return err;
	    }
	
	    var minDate = props.minDate,
	        maxDate = props.maxDate;
	
	    if (minDate > maxDate) {
	      return new Error('The min date: \'' + minDate + '\' is greater than the max date: \'' + maxDate + '\'');
	    }
	
	    return null;
	  },
	
	  /**
	   * Boolean if the date should automatically be selected when a user clicks
	   * on a new date instead of making them hit the ok button.
	   */
	  autoOk: _propTypes2.default.bool,
	
	  /**
	   * The number of years to display.
	   */
	  yearsDisplayed: _propTypes2.default.number,
	
	  /**
	   * Boolean if the date picker should be displayed inline instead of in a
	   * dialog.
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * An optional force of the display mode of the date picker.
	   * This _should_ not really be used since there are media queries
	   * to use the correct mode based on device orientation.
	   */
	  displayMode: _propTypes2.default.oneOf(['landscape', 'portrait']),
	
	  /**
	   * The DateTimeFormat options to apply to format the date.
	   */
	  formatOptions: _propTypes2.default.shape({
	    weekday: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	    era: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	    year: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    month: _propTypes2.default.oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
	    day: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    hour: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    minute: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    second: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    timeZoneName: _propTypes2.default.oneOf(['short', 'long'])
	  }),
	
	  /**
	   * The timeZone to be used in all formatting operations.
	   * For a full list of possible timeZone values check https://www.iana.org/time-zones.
	   */
	  timeZone: _propTypes2.default.string.isRequired,
	
	  /**
	   * Boolean if the text field for the Date Picker should be displayed as full width.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * The direction that the text field divider expands from when the text field
	   * in the date picker gains focus.
	   */
	  lineDirection: _propTypes2.default.oneOf(['left', 'center', 'right']),
	
	  /**
	   * An optional boolean if the time picker is current visible by dialog or inline.
	   * If this is set, the `onOpenToggle` function is required.
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityChange', 'defaultVisible'),
	
	  /**
	   * An optional function to call when the date picker is opened in either a dialog, or
	   * inline. The callback will include the next state.
	   *
	   * ```js
	   * onVisibilityChange(!visible, e);
	   * ```
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * Boolean if the time picker is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog should be able to close if a keyboard user presses the escape key.
	   */
	  closeOnEsc: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the inline time picker's visibility should be animated.
	   */
	  animateInline: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the time is required.
	   *
	   * @see {@link TextFields/TextField#required}
	   */
	  required: _propTypes2.default.bool,
	
	  /**
	   * @see {@link TextFields/TextField#block}
	   */
	  block: _TextField2.default.propTypes.block,
	
	  /**
	   * @see {@link TextFields/TextField#paddedBlock}
	   */
	  paddedBlock: _TextField2.default.propTypes.paddedBlock,
	
	  /**
	   * @see {@link TextFields/TextField#active}
	   */
	  active: _TextField2.default.propTypes.active,
	
	  /**
	   * @see {@link TextFields/TextField#error}
	   */
	  error: _TextField2.default.propTypes.error,
	
	  /**
	   * @see {@link TextFields/TextField#floating}
	   */
	  floating: _TextField2.default.propTypes.floating,
	
	  /**
	   * @see {@link TextFields/TextField#leftIconStateful}
	   */
	  leftIconStateful: _TextField2.default.propTypes.leftIconStateful,
	
	  /**
	   * @see {@link TextFields/TextField#rightIcon}
	   */
	  rightIcon: _TextField2.default.propTypes.rightIcon,
	
	  /**
	   * @see {@link TextFields/TextField#rightIconStateful}
	   */
	  rightIconStateful: _TextField2.default.propTypes.rightIconStateful,
	
	  /**
	   * @see {@link TextFields/TextField#customSize}
	   */
	  customSize: _TextField2.default.propTypes.customSize,
	
	  /**
	   * @see {@link TextFields/TextField#errorText}
	   */
	  errorText: _TextField2.default.propTypes.errorText,
	
	  /**
	   * @see {@link TextFields/TextField#helpText}
	   */
	  helpText: _TextField2.default.propTypes.helpText,
	
	  /**
	   * @see {@link TextFields/TextField#helpOnFocus}
	   */
	  helpOnFocus: _TextField2.default.propTypes.helpOnFocus,
	
	  /**
	   * @see {@link TextFields/TextField#inlineIndicator}
	   */
	  inlineIndicator: _TextField2.default.propTypes.inlineIndicator,
	
	  /**
	   * Boolean if the Portal's functionality of rendering in a separate react tree should be applied
	   * to the dialog.
	   *
	   * @see {@link Helpers/Portal}
	   */
	  portal: _propTypes2.default.bool,
	
	  /**
	   * An optional DOM Node to render the dialog into. The default is to render as the first child
	   * in the `body`.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the DatePicker should be read only. This will prevent the user from opening the picker
	   * and only display the current date in the text field.
	   */
	  readOnly: _propTypes2.default.bool,
	
	  /**
	   * The first day of week: 0 for Sunday, 1 for Monday, 2 for Tuesday, and so on.
	   */
	  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
	
	  /**
	   * True if weekends are to be greyed out.
	   */
	  disableWeekEnds: _propTypes2.default.bool,
	
	  /**
	   * True if dates from adjacent months should be shown in calendar.
	   */
	  showAllDays: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dates from adjacent months should be disabled. This will only
	   * do something if the `showAllDays` prop is enabled as well.
	   *
	   * This is really only helpful if youd like the other days to appear, but not be
	   * clickable until the user switches to that month.
	   *
	   * @see {@link #showAllDays}
	   */
	  disableOuterDates: _propTypes2.default.bool,
	
	  /**
	   * An optional className to apply to a date in calendar.
	   */
	  calendarDateClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to a date from an adjacent month in calendar. This will be applied
	   * along with the `calendarDateClassName`.
	   *
	   * @see {@link #showAllDays}
	   * @see {@link #calendarDateClassName}
	   */
	  calendarOuterDateClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the title in calendar header.
	   */
	  calendarTitleClassName: _propTypes2.default.string,
	
	  /**
	   * The DateTimeFormat options to apply to format the title in calendar header.
	   */
	  calendarTitleFormat: _propTypes2.default.shape({
	    era: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	    year: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    month: _propTypes2.default.oneOf(['numeric', '2-digit', 'narrow', 'short', 'long'])
	  }),
	
	  /**
	   * An optional className to apply to a weekday in calendar header.
	   */
	  calendarWeekdayClassName: _propTypes2.default.string,
	
	  /**
	   * The DateTimeFormat option to apply to format a weekday in calendar header.
	   */
	  calendarWeekdayFormat: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	
	  /**
	   * @see {@link Dialogs/DialogContainer#disableScrollLocking}
	   */
	  disableScrollLocking: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog should be rendered as the last child of the `renderNode` or `body` instead
	   * of the first.
	   */
	  lastChild: _propTypes2.default.bool,
	
	  previousIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `previousIcon` prop instead'),
	  previousIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `previousIcon` prop instead'),
	  nextIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'use the `nextIcon` prop instead'),
	  nextIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `nextIcon` prop instead'),
	  adjustMinWidth: (0, _deprecated2.default)(_propTypes2.default.bool, 'No longer valid for a text field'),
	  isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead'),
	  initiallyOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
	  initialCalendarDate: (0, _deprecated2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]), 'Use `defaultCalendarDate` instead'),
	  initialCalendarMode: (0, _deprecated2.default)(_propTypes2.default.oneOf(['calendar', 'year']), 'Use `defaultCalendarMode` instead'),
	  initialYearsDisplayed: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `yearsDisplayed` instead. I have not implemented infinite loading years')
	};
	DatePickerContainer.defaultProps = {
	  animateInline: true,
	  previousIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'chevron_left'
	  ),
	  nextIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'chevron_right'
	  ),
	  autoOk: false,
	  icon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'date_range'
	  ),
	  yearsDisplayed: 100,
	  defaultCalendarMode: 'calendar',
	  DateTimeFormat: _DateTimeFormat2.default, // eslint-disable-line object-shorthand
	  locales: typeof window !== 'undefined' ? window.navigator.userLanguage || window.navigator.language : 'en-US',
	  okLabel: 'Ok',
	  okPrimary: true,
	  cancelLabel: 'Cancel',
	  cancelPrimary: true,
	  closeOnEsc: true,
	  disableScrollLocking: false,
	  'aria-label': 'Pick a date',
	  timeZone: 'UTC'
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._setContainer = function (container) {
	    _this2._container = container;
	  };
	
	  this._closeOnEsc = function (e) {
	    if ((e.which || e.keyCode) === _keyCodes.ESC) {
	      _this2._handleCancelClick(e);
	    }
	  };
	
	  this._handleOutsideClick = function (e) {
	    if (_this2._container && !_this2._container.contains(e.target)) {
	      _this2._handleCancelClick(e);
	    }
	  };
	
	  this._toggleOpen = function (e) {
	    if (_this2.props.disabled || _this2.props.readOnly) {
	      return;
	    }
	
	    var visible = !(typeof _this2.props.isOpen !== 'undefined' ? _this2.props.isOpen : (0, _getField2.default)(_this2.props, _this2.state, 'visible'));
	
	    if (_this2.props.onVisibilityChange) {
	      _this2.props.onVisibilityChange(visible, e);
	    }
	
	    if (typeof _this2.props.isOpen === 'undefined' && typeof _this2.props.visible === 'undefined') {
	      _this2.setState({ visible: visible });
	    }
	  };
	
	  this._handleKeyDown = function (e) {
	    (0, _handleKeyboardAccessibility2.default)(e, _this2._toggleOpen, true, true);
	
	    if ((e.which || e.keyCode) === _keyCodes.TAB && _this2.state.active) {
	      _this2.setState({ active: false });
	    }
	  };
	
	  this._handleOkClick = function (e) {
	    var _props4 = _this2.props,
	        DateTimeFormat = _props4.DateTimeFormat,
	        locales = _props4.locales,
	        onChange = _props4.onChange,
	        onVisibilityChange = _props4.onVisibilityChange;
	
	    var value = DateTimeFormat(locales, _this2._getFormatOptions()).format(_this2.state.calendarTempDate);
	    if (onChange) {
	      onChange(value, new Date(_this2.state.calendarTempDate), e);
	    }
	
	    if (onVisibilityChange) {
	      onVisibilityChange(false, e);
	    }
	
	    var state = void 0;
	    if (typeof _this2.props.value === 'undefined') {
	      state = { value: value };
	    }
	
	    if (typeof _this2.props.visible === 'undefined' && typeof _this2.props.isOpen === 'undefined') {
	      state = state || {};
	      state.visible = false;
	    }
	
	    if (state) {
	      _this2.setState(state);
	    }
	  };
	
	  this._handleCancelClick = function (e) {
	    var state = { calendarTempDate: _this2.state.calendarDate };
	    if (typeof _this2.props.isOpen === 'undefined' && typeof _this2.props.isOpen === 'undefined') {
	      state.visible = false;
	    }
	
	    if (_this2.props.onVisibilityChange) {
	      _this2.props.onVisibilityChange(false, e);
	    }
	
	    _this2.setState(state);
	  };
	
	  this._changeCalendarMode = function (calendarMode) {
	    if (_this2.state.calendarMode === calendarMode) {
	      return;
	    }
	
	    _this2.setState({ calendarMode: calendarMode });
	  };
	
	  this._previousMonth = function () {
	    var calendarDate = (0, _addDate2.default)(_this2.state.calendarDate, -1, 'M');
	    _this2.setState({ calendarDate: calendarDate });
	  };
	
	  this._nextMonth = function () {
	    var calendarDate = (0, _addDate2.default)(_this2.state.calendarDate, 1, 'M');
	    _this2.setState({ calendarDate: calendarDate });
	  };
	
	  this._setCalendarTempDate = function (calendarTempDate) {
	    var _props5 = _this2.props,
	        autoOk = _props5.autoOk,
	        DateTimeFormat = _props5.DateTimeFormat,
	        locales = _props5.locales,
	        onChange = _props5.onChange;
	
	
	    var state = { calendarTempDate: calendarTempDate };
	    if (autoOk) {
	      var value = DateTimeFormat(locales, _this2._getFormatOptions()).format(calendarTempDate);
	      if (onChange) {
	        onChange(value, new Date(calendarTempDate));
	      }
	
	      if (typeof _this2.props.value === 'undefined') {
	        state.value = value;
	      }
	
	      _this2._timeout = setTimeout(function () {
	        _this2._timeout = null;
	
	        if (_this2.props.onVisibilityChange) {
	          _this2.props.onVisibilityChange(false);
	        }
	
	        if (typeof _this2.props.visible === 'undefined' && typeof _this2.props.isOpen === 'undefined') {
	          _this2.setState({ visible: false });
	        }
	      });
	    }
	    _this2.setState(state);
	  };
	
	  this._setCalendarTempYear = function (year) {
	    var _state = _this2.state,
	        calendarTempDate = _state.calendarTempDate,
	        calendarDate = _state.calendarDate;
	
	    if (calendarTempDate.getFullYear() === year) {
	      return;
	    }
	
	    var _props6 = _this2.props,
	        minDate = _props6.minDate,
	        maxDate = _props6.maxDate;
	
	    var nextDate = new Date(calendarDate.setFullYear(year));
	    var nextTemp = new Date(calendarTempDate.setFullYear(year));
	
	    if (minDate && nextTemp < minDate) {
	      nextDate = new Date(minDate);
	      nextTemp = new Date(minDate);
	    }
	
	    if (maxDate && nextTemp > maxDate) {
	      nextDate = new Date(maxDate);
	      nextTemp = new Date(maxDate);
	    }
	
	    _this2.setState({
	      calendarDate: nextDate,
	      calendarTempDate: nextTemp
	    });
	  };
	};
	
	exports.default = DatePickerContainer;
	//# sourceMappingURL=DatePickerContainer.js.map

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PickerControl = __webpack_require__(174);
	
	var _PickerControl2 = _interopRequireDefault(_PickerControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable new-cap */
	
	
	/**
	 * The `DatePickerHeader` component is the component that holds the
	 * current year and the current date. It allows the user to switch
	 * between calendar and year picker mode.
	 */
	var DatePickerHeader = function (_PureComponent) {
	  _inherits(DatePickerHeader, _PureComponent);
	
	  function DatePickerHeader(props) {
	    _classCallCheck(this, DatePickerHeader);
	
	    var _this = _possibleConstructorReturn(this, (DatePickerHeader.__proto__ || Object.getPrototypeOf(DatePickerHeader)).call(this, props));
	
	    _this._selectYear = function (e) {
	      _this.props.changeCalendarMode('year', e);
	    };
	
	    _this._selectCalendar = function (e) {
	      _this.props.changeCalendarMode('calendar', e);
	    };
	
	    _this.state = _this._getFormattedDate(props);
	    return _this;
	  }
	
	  _createClass(DatePickerHeader, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locales = _props.locales,
	          calendarTempDate = _props.calendarTempDate,
	          changeCalendarMode = _props.changeCalendarMode;
	
	      if (DateTimeFormat !== nextProps.DateTimeFormat || locales !== nextProps.locales || calendarTempDate !== nextProps.calendarTempDate || changeCalendarMode !== nextProps.changeCalendarMode) {
	        this.setState(this._getFormattedDate(nextProps));
	      }
	    }
	  }, {
	    key: '_getFormattedDate',
	    value: function _getFormattedDate(_ref) {
	      var DateTimeFormat = _ref.DateTimeFormat,
	          locales = _ref.locales,
	          calendarTempDate = _ref.calendarTempDate,
	          timeZone = _ref.timeZone;
	
	      return {
	        year: DateTimeFormat(locales, { year: 'numeric', timeZone: timeZone }).format(calendarTempDate),
	        weekday: DateTimeFormat(locales, { weekday: 'short', timeZone: timeZone }).format(calendarTempDate),
	        date: DateTimeFormat(locales, { month: 'short', day: '2-digit', timeZone: timeZone }).format(calendarTempDate)
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          year = _state.year,
	          weekday = _state.weekday,
	          date = _state.date;
	      var _props2 = this.props,
	          calendarMode = _props2.calendarMode,
	          className = _props2.className;
	
	      return _react2.default.createElement(
	        'header',
	        { className: (0, _classnames2.default)('md-picker-header', className) },
	        _react2.default.createElement(
	          _PickerControl2.default,
	          { onClick: this._selectYear, active: calendarMode === 'year' },
	          _react2.default.createElement(
	            'h6',
	            { className: 'md-subheading-1' },
	            year
	          )
	        ),
	        _react2.default.createElement(
	          _PickerControl2.default,
	          { onClick: this._selectCalendar, active: calendarMode === 'calendar' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'md-display-1' },
	            weekday + ',',
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'h4',
	            { className: 'md-display-1' },
	            date
	          )
	        )
	      );
	    }
	  }]);
	
	  return DatePickerHeader;
	}(_react.PureComponent);
	
	DatePickerHeader.propTypes = {
	  className: _propTypes2.default.string,
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	  calendarTempDate: _propTypes2.default.instanceOf(Date).isRequired,
	  calendarMode: _propTypes2.default.oneOf(['calendar', 'year']).isRequired,
	  changeCalendarMode: _propTypes2.default.func.isRequired,
	  timeZone: _propTypes2.default.string.isRequired
	};
	exports.default = DatePickerHeader;
	//# sourceMappingURL=DatePickerHeader.js.map

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _addHours = __webpack_require__(666);
	
	var _addHours2 = _interopRequireDefault(_addHours);
	
	var _PickerControl = __webpack_require__(174);
	
	var _PickerControl2 = _interopRequireDefault(_PickerControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component displays a section for switching between the AM
	 * and PM time periods.
	 */
	var TimePeriods = function (_PureComponent) {
	  _inherits(TimePeriods, _PureComponent);
	
	  function TimePeriods() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TimePeriods);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimePeriods.__proto__ || Object.getPrototypeOf(TimePeriods)).call.apply(_ref, [this].concat(args))), _this), _this._setAM = function () {
	      if (_this.props.timePeriod !== 'AM') {
	        _this.props.setTempTime((0, _addHours2.default)(_this.props.tempTime, -12));
	      }
	    }, _this._setPM = function () {
	      if (_this.props.timePeriod !== 'PM') {
	        _this.props.setTempTime((0, _addHours2.default)(_this.props.tempTime, 12));
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TimePeriods, [{
	    key: 'render',
	    value: function render() {
	      var timePeriod = this.props.timePeriod;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'md-time-periods' },
	        _react2.default.createElement(
	          _PickerControl2.default,
	          { onClick: this._setAM, active: timePeriod === 'AM' },
	          _react2.default.createElement(
	            'h6',
	            { className: 'md-time-period' },
	            'AM'
	          )
	        ),
	        _react2.default.createElement(
	          _PickerControl2.default,
	          { onClick: this._setPM, active: timePeriod === 'PM' },
	          _react2.default.createElement(
	            'h6',
	            { className: 'md-time-period' },
	            'PM'
	          )
	        )
	      );
	    }
	  }]);
	
	  return TimePeriods;
	}(_react.PureComponent);
	
	TimePeriods.propTypes = {
	  /**
	   * The current time for the time picker.
	   */
	  tempTime: _propTypes2.default.instanceOf(Date).isRequired,
	
	  /**
	   * A function to update the time for the time picker.
	   */
	  setTempTime: _propTypes2.default.func.isRequired,
	
	  /**
	   * The current time period.
	   */
	  timePeriod: _propTypes2.default.string.isRequired
	};
	exports.default = TimePeriods;
	//# sourceMappingURL=TimePeriods.js.map

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ClockFace = __webpack_require__(607);
	
	var _ClockFace2 = _interopRequireDefault(_ClockFace);
	
	var _DialogFooter = __webpack_require__(108);
	
	var _DialogFooter2 = _interopRequireDefault(_DialogFooter);
	
	var _TimePickerHeader = __webpack_require__(617);
	
	var _TimePickerHeader2 = _interopRequireDefault(_TimePickerHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TimePicker` component is used to display a time picker
	 * in the `TimePickerContainer` component.
	 */
	var TimePicker = function (_PureComponent) {
	  _inherits(TimePicker, _PureComponent);
	
	  function TimePicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TimePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimePicker.__proto__ || Object.getPrototypeOf(TimePicker)).call.apply(_ref, [this].concat(args))), _this), _this._updateTime = function (newTime) {
	      var timePart = newTime;
	      var _this$props = _this.props,
	          tempTime = _this$props.tempTime,
	          setTempTime = _this$props.setTempTime,
	          timeMode = _this$props.timeMode,
	          timePeriod = _this$props.timePeriod;
	
	      var time = new Date(tempTime);
	      if (timeMode === 'hour') {
	        var isAM = timePeriod === 'AM';
	        var is12 = timePart === 12;
	        if (timePeriod && isAM && is12) {
	          timePart = 0;
	        } else if (timePeriod && !isAM && !is12) {
	          timePart += 12;
	        }
	
	        time.setHours(timePart);
	      } else {
	        time.setMinutes(timePart);
	      }
	
	      setTempTime(time);
	    }, _this._handleTimeChosen = function () {
	      var _this$props2 = _this.props,
	          hoverMode = _this$props2.hoverMode,
	          setTimeMode = _this$props2.setTimeMode,
	          onOkClick = _this$props2.onOkClick,
	          timeMode = _this$props2.timeMode;
	
	
	      if (hoverMode) {
	        if (timeMode === 'hour') {
	          setTimeMode('minute');
	        } else {
	          onOkClick();
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Takes in the new time (number o'clock or minutes), updates the temp time
	   * with that new time, and then calls the setTempTime prop.
	   */
	
	
	  _createClass(TimePicker, [{
	    key: 'render',
	    value: function render() {
	      var _cn;
	
	      var _props = this.props,
	          okLabel = _props.okLabel,
	          okPrimary = _props.okPrimary,
	          onOkClick = _props.onOkClick,
	          cancelLabel = _props.cancelLabel,
	          cancelPrimary = _props.cancelPrimary,
	          onCancelClick = _props.onCancelClick,
	          style = _props.style,
	          className = _props.className,
	          setTimeMode = _props.setTimeMode,
	          setTempTime = _props.setTempTime,
	          timeMode = _props.timeMode,
	          tempTime = _props.tempTime,
	          hours = _props.hours,
	          minutes = _props.minutes,
	          timePeriod = _props.timePeriod,
	          displayMode = _props.displayMode,
	          inline = _props.inline,
	          icon = _props.icon,
	          hoverMode = _props.hoverMode;
	
	
	      var hoursInt = parseInt(hours, 10);
	      var minutesInt = parseInt(minutes.replace(/[^0-9]/g, ''), 10);
	      var actions = [{
	        key: 'cancel',
	        onClick: onCancelClick,
	        primary: cancelPrimary,
	        secondary: !cancelPrimary,
	        label: cancelLabel
	      }, {
	        key: 'ok',
	        onClick: onOkClick,
	        primary: okPrimary,
	        secondary: !okPrimary,
	        label: okLabel
	      }];
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: style,
	          className: (0, _classnames2.default)('md-picker md-picker--time', (_cn = {}, _defineProperty(_cn, 'md-picker--' + displayMode, displayMode), _defineProperty(_cn, 'md-picker--inline', inline), _defineProperty(_cn, 'md-picker--inline-icon', inline && icon), _cn), className)
	        },
	        _react2.default.createElement(_TimePickerHeader2.default, {
	          tempTime: tempTime,
	          timeMode: timeMode,
	          setTimeMode: setTimeMode,
	          setTempTime: setTempTime,
	          hours: hours,
	          minutes: minutes,
	          timePeriod: timePeriod
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'md-picker-content-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'md-picker-content md-picker-content--clock' },
	            _react2.default.createElement(_ClockFace2.default, {
	              time: timeMode === 'hour' ? hoursInt : minutesInt,
	              minutes: timeMode === 'minute',
	              onChange: this._updateTime,
	              timePeriod: timePeriod,
	              hoverMode: hoverMode,
	              onTimeChosen: this._handleTimeChosen
	            })
	          ),
	          _react2.default.createElement(_DialogFooter2.default, { actions: actions })
	        )
	      );
	    }
	  }]);
	
	  return TimePicker;
	}(_react.PureComponent);
	
	TimePicker.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  okLabel: _propTypes2.default.node.isRequired,
	  okPrimary: _propTypes2.default.bool.isRequired,
	  onOkClick: _propTypes2.default.func.isRequired,
	  cancelLabel: _propTypes2.default.node.isRequired,
	  cancelPrimary: _propTypes2.default.bool.isRequired,
	  onCancelClick: _propTypes2.default.func.isRequired,
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	  icon: _propTypes2.default.bool,
	  inline: _propTypes2.default.bool,
	  displayMode: _propTypes2.default.oneOf(['landscape', 'portrait']),
	
	  /**
	   * A function that will switch the state from hour to minute.
	   */
	  setTimeMode: _propTypes2.default.func.isRequired,
	
	  /**
	   * A function that will update the time for the TimePicker before
	   * the user selects ok. This function will be given a new Date object
	   * with a modified time.
	   */
	  setTempTime: _propTypes2.default.func.isRequired,
	
	  /**
	   * The current display mode of the time picker.
	   */
	  timeMode: _propTypes2.default.oneOf(['hour', 'minute']).isRequired,
	
	  /**
	   * The current time as a date object that is being displayed in the
	   * time picker.
	   */
	  tempTime: _propTypes2.default.instanceOf(Date).isRequired,
	
	  /**
	   * A string that is a representation of the hours in the user's locale.
	   */
	  hours: _propTypes2.default.string.isRequired,
	
	  /**
	   * A string that is a representation of the minutes in the user's locale.
	   * This will also include any separator the locale uses.
	   *
	   * Example: ':15' in '3:15 PM' for 'en-US'
	   */
	  minutes: _propTypes2.default.string.isRequired,
	
	  /**
	   * An optional time period if a user's locale uses it.
	   */
	  timePeriod: _propTypes2.default.string,
	
	  /**
	   * If true the hover mode of the Time Picker is activated.
	   * In hover mode no clicks are required to start selecting an hour
	   * and the timemode switches automatically when a time was chosen.
	   * When a minute is selected the chosen time is applied automatically.
	   */
	  hoverMode: _propTypes2.default.bool
	};
	exports.default = TimePicker;
	//# sourceMappingURL=TimePicker.js.map

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(17);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _keyCodes = __webpack_require__(15);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _handleWindowClickListeners = __webpack_require__(112);
	
	var _handleWindowClickListeners2 = _interopRequireDefault(_handleWindowClickListeners);
	
	var _handleKeyboardAccessibility = __webpack_require__(83);
	
	var _handleKeyboardAccessibility2 = _interopRequireDefault(_handleKeyboardAccessibility);
	
	var _controlled = __webpack_require__(16);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _DateTimeFormat = __webpack_require__(296);
	
	var _DateTimeFormat2 = _interopRequireDefault(_DateTimeFormat);
	
	var _formatTime = __webpack_require__(297);
	
	var _formatTime2 = _interopRequireDefault(_formatTime);
	
	var _extractTimeParts = __webpack_require__(667);
	
	var _extractTimeParts2 = _interopRequireDefault(_extractTimeParts);
	
	var _DialogContainer = __webpack_require__(168);
	
	var _DialogContainer2 = _interopRequireDefault(_DialogContainer);
	
	var _FontIcon = __webpack_require__(13);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _TextField = __webpack_require__(65);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _Collapse = __webpack_require__(46);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _TimePicker = __webpack_require__(615);
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-shadow */
	
	
	/**
	 * The `TimePickerContainer` component is a wrapper for the main `TimePicker` component
	 * to manage the state and _logic_ for rendering the `TimePicker`. This component will
	 * either render inline or in a `Dialog` depending if the `inline` prop is set
	 * to `true`.
	 *
	 * NOTE: This component is actually exported as `TimePicker` when using the `import { member }` syntax.
	 * The following two lines are equivalent:
	 *
	 * ```js
	 * import { TimePicker } from 'react-md/lib/Pickers';
	 * import TimePicker from 'react-md/lib/Pickers/TimePickerContainer';
	 * ```
	 */
	var TimePickerContainer = function (_PureComponent) {
	  _inherits(TimePickerContainer, _PureComponent);
	
	  function TimePickerContainer(props) {
	    _classCallCheck(this, TimePickerContainer);
	
	    var _this = _possibleConstructorReturn(this, (TimePickerContainer.__proto__ || Object.getPrototypeOf(TimePickerContainer)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var initialDate = void 0;
	    if (props.defaultValue) {
	      initialDate = new Date(props.defaultValue);
	    } else if (props.value) {
	      initialDate = new Date(props.value);
	    } else {
	      initialDate = new Date();
	    }
	
	    var visible = typeof props.initiallyOpen !== 'undefined' ? props.initiallyOpen : !!props.defaultVisible;
	
	    _this.state = _extends({
	      visible: visible
	    }, _this._getTimeParts(initialDate, props), {
	      value: props.defaultValue,
	      time: initialDate,
	      timeMode: props.initialTimeMode || props.defaultTimeMode,
	      tempTime: initialDate
	    });
	    return _this;
	  }
	
	  _createClass(TimePickerContainer, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var time = nextProps.value || new Date();
	        this.setState(_extends({ tempTime: time }, this._getTimeParts(time, nextProps)));
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _props = this.props,
	          inline = _props.inline,
	          isOpen = _props.isOpen;
	
	      var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	      var pVisible = typeof prevProps.isOpen !== 'undefined' ? prevProps.isOpen : (0, _getField2.default)(prevProps, prevState, 'visible');
	
	      if (visible === pVisible) {
	        return;
	      }
	
	      if (visible) {
	        if (inline) {
	          (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, true);
	          window.addEventListener('keydown', this._closeOnEsc);
	        }
	      } else if (inline) {
	        (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, false);
	        window.removeEventListener('keydown', this._closeOnEsc);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var visible = typeof this.props.isOpen !== 'undefined' ? this.props.isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	      if (visible && this.props.inline) {
	        (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, false);
	        window.removeEventListener('keydown', this._closeOnEsc);
	      }
	    }
	  }, {
	    key: '_getTimeParts',
	    value: function _getTimeParts(date, props) {
	      return (0, _extractTimeParts2.default)(props.DateTimeFormat, props.locales, date);
	    }
	  }, {
	    key: '_getTextFieldValue',
	    value: function _getTextFieldValue(props, state) {
	      var DateTimeFormat = props.DateTimeFormat,
	          locales = props.locales;
	
	      var value = (0, _getField2.default)(props, state, 'value');
	      if (!value) {
	        return '';
	      } else if (value instanceof Date) {
	        return (0, _formatTime2.default)(DateTimeFormat, locales, value);
	      } else {
	        // currently don't support value of string
	        return value;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          timeMode = _state.timeMode,
	          tempTime = _state.tempTime,
	          hours = _state.hours,
	          minutes = _state.minutes,
	          timePeriod = _state.timePeriod;
	
	      var _props2 = this.props,
	          style = _props2.style,
	          className = _props2.className,
	          pickerStyle = _props2.pickerStyle,
	          pickerClassName = _props2.pickerClassName,
	          inputStyle = _props2.inputStyle,
	          inputClassName = _props2.inputClassName,
	          textFieldStyle = _props2.textFieldStyle,
	          textFieldClassName = _props2.textFieldClassName,
	          id = _props2.id,
	          disabled = _props2.disabled,
	          label = _props2.label,
	          placeholder = _props2.placeholder,
	          icon = _props2.icon,
	          inline = _props2.inline,
	          displayMode = _props2.displayMode,
	          fullWidth = _props2.fullWidth,
	          lineDirection = _props2.lineDirection,
	          closeOnEsc = _props2.closeOnEsc,
	          hoverMode = _props2.hoverMode,
	          portal = _props2.portal,
	          renderNode = _props2.renderNode,
	          lastChild = _props2.lastChild,
	          animateInline = _props2.animateInline,
	          block = _props2.block,
	          paddedBlock = _props2.paddedBlock,
	          active = _props2.active,
	          error = _props2.error,
	          floating = _props2.floating,
	          required = _props2.required,
	          leftIconStateful = _props2.leftIconStateful,
	          rightIcon = _props2.rightIcon,
	          rightIconStateful = _props2.rightIconStateful,
	          customSize = _props2.customSize,
	          errorText = _props2.errorText,
	          helpText = _props2.helpText,
	          helpOnFocus = _props2.helpOnFocus,
	          inlineIndicator = _props2.inlineIndicator,
	          disableScrollLocking = _props2.disableScrollLocking,
	          ariaLabel = _props2['aria-label'],
	          propValue = _props2.value,
	          propVisible = _props2.visible,
	          readOnly = _props2.readOnly,
	          defaultValue = _props2.defaultValue,
	          defaultVisible = _props2.defaultVisible,
	          defaultTimeMode = _props2.defaultTimeMode,
	          onVisibilityChange = _props2.onVisibilityChange,
	          isOpen = _props2.isOpen,
	          initialTimeMode = _props2.initialTimeMode,
	          initiallyOpen = _props2.initiallyOpen,
	          props = _objectWithoutProperties(_props2, ['style', 'className', 'pickerStyle', 'pickerClassName', 'inputStyle', 'inputClassName', 'textFieldStyle', 'textFieldClassName', 'id', 'disabled', 'label', 'placeholder', 'icon', 'inline', 'displayMode', 'fullWidth', 'lineDirection', 'closeOnEsc', 'hoverMode', 'portal', 'renderNode', 'lastChild', 'animateInline', 'block', 'paddedBlock', 'active', 'error', 'floating', 'required', 'leftIconStateful', 'rightIcon', 'rightIconStateful', 'customSize', 'errorText', 'helpText', 'helpOnFocus', 'inlineIndicator', 'disableScrollLocking', 'aria-label', 'value', 'visible', 'readOnly', 'defaultValue', 'defaultVisible', 'defaultTimeMode', 'onVisibilityChange', 'isOpen', 'initialTimeMode', 'initiallyOpen']);
	
	      var visible = typeof this.props.isOpen !== 'undefined' ? this.props.isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	
	      var picker = _react2.default.createElement(_TimePicker2.default, _extends({}, props, {
	        inline: inline,
	        icon: !!icon,
	        tempTime: tempTime,
	        timeMode: timeMode,
	        hours: hours,
	        minutes: minutes,
	        timePeriod: timePeriod,
	        style: pickerStyle,
	        className: pickerClassName,
	        displayMode: displayMode,
	        onOkClick: this._handleOkClick,
	        onCancelClick: this._handleCancelClick,
	        setTimeMode: this._setTimeMode,
	        setTempTime: this._setTempTime,
	        hoverMode: hoverMode
	      }));
	
	      var content = void 0;
	      if (inline) {
	        content = _react2.default.createElement(
	          _Collapse2.default,
	          { collapsed: !visible, animate: animateInline },
	          picker
	        );
	      } else {
	        content = _react2.default.createElement(
	          _DialogContainer2.default,
	          {
	            id: id + '-dialog',
	            visible: visible,
	            onHide: this._handleCancelClick,
	            dialogClassName: 'md-dialog--picker',
	            contentClassName: 'md-dialog-content--picker',
	            'aria-label': ariaLabel,
	            closeOnEsc: closeOnEsc,
	            portal: portal,
	            lastChild: lastChild,
	            renderNode: renderNode,
	            focusOnMount: false,
	            disableScrollLocking: disableScrollLocking
	          },
	          picker
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: style, className: (0, _classnames2.default)('md-picker-container', className), ref: this._setContainer },
	        _react2.default.createElement(_TextField2.default, {
	          id: id,
	          style: textFieldStyle,
	          className: (0, _classnames2.default)({ 'md-pointer--hover': !disabled }, textFieldClassName),
	          inputStyle: inputStyle,
	          inputClassName: (0, _classnames2.default)({ 'md-pointer--hover': !disabled }, inputClassName),
	          active: active || visible,
	          error: error,
	          floating: floating || visible,
	          required: required,
	          disabled: disabled,
	          leftIcon: icon,
	          leftIconStateful: leftIconStateful,
	          rightIcon: rightIcon,
	          rightIconStateful: rightIconStateful,
	          inlineIndicator: inlineIndicator,
	          block: block,
	          paddedBlock: paddedBlock,
	          fullWidth: fullWidth,
	          lineDirection: lineDirection,
	          customSize: customSize,
	          helpText: helpText,
	          helpOnFocus: helpOnFocus,
	          errorText: errorText,
	          label: label,
	          placeholder: placeholder,
	          onClick: this._toggleOpen,
	          onKeyDown: this._handleKeyDown,
	          value: this._getTextFieldValue(this.props, this.state),
	          readOnly: true
	        }),
	        content
	      );
	    }
	  }]);
	
	  return TimePickerContainer;
	}(_react.PureComponent);
	
	TimePickerContainer.propTypes = {
	  /**
	   * An id for the text field in the time picker. This is require for a11y.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * An aria-label to apply to the dialog when it has been opened. This is required for
	   * a11y.
	   */
	  'aria-label': (0, _isRequiredForA11y2.default)(_propTypes2.default.string),
	
	  /**
	   * An optional style to apply to the time picker's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the time picker's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the time picker.
	   */
	  pickerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the time picker.
	   */
	  pickerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the input tag.
	   */
	  inputStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the input tag.
	   */
	  inputClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the text field's container.
	   */
	  textFieldStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the text field's container.
	   */
	  textFieldClassName: _propTypes2.default.string,
	
	  /**
	   * An optional icon to display with the time picker.
	   *
	   * @see {@link TextFields/TextField#leftIcon}
	   */
	  icon: _propTypes2.default.node,
	
	  /**
	   * Boolean if the time picker is open by default.
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * An optional label to be displayed in the time picker's text
	   * field.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * An optional placeholder to be displayed in the time picker's text field.
	   */
	  placeholder: _propTypes2.default.string,
	
	  /**
	   * The value of the time picker. This will make the time picker
	   * be a controlled component.
	   */
	  value: (0, _controlled2.default)(_propTypes2.default.instanceOf(Date), 'onChange', 'defaultValue'),
	
	  /**
	   * An optional function to call when the selected date is changed
	   * by hitting the OK button. The newly formatted time string,
	   * the new Date object, and the change event will be given.
	   *
	   * `onChange(timeString, dateObject, event)`.
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional default value to give for the year picker.
	   */
	  defaultValue: _propTypes2.default.instanceOf(Date),
	
	  /**
	   * A function to format the dates since it should be formatted to the user's
	   * locale. This _should_ be the `Intl.DateTimeFormat` function. You
	   * can also create your own if you really wanted. Inadvisable though.
	   *
	   * See [intl-polyfill](https://github.com/andyearnshaw/Intl.js/) for more info.
	   */
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	
	  /**
	   * The locales to use for formatting the date. This will default to using
	   * the user's language in the browser or `'en-US'` when server rendering.
	   */
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	
	  /**
	   * The label to use for the ok button on the year picker.
	   */
	  okLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the ok button should be styled with the primary color.
	   */
	  okPrimary: _propTypes2.default.bool,
	
	  /**
	   * The label to use for the cancel button on the year picker.
	   */
	  cancelLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the cancel button should be styled with the primary color.
	   */
	  cancelPrimary: _propTypes2.default.bool,
	
	  /**
	   * The default mode to open the time picker in.
	   */
	  defaultTimeMode: _propTypes2.default.oneOf(['hour', 'minute']),
	
	  /**
	   * Boolean if the date should automatically be selected when a user clicks
	   * on a new date instead of making them hit the ok button.
	   */
	  autoOk: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the date picker should be displayed inline instead of in a
	   * dialog.
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * An optional force of the display mode of the date picker.
	   * This _should_ not really be used since there are media queries
	   * to use the correct mode based on device orientation.
	   */
	  displayMode: _propTypes2.default.oneOf(['landscape', 'portrait']),
	
	  /**
	   * Boolean if the text field for the Time Picker should be displayed as full width.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * The direction that the text field divider expands from when the text field
	   * in the date picker gains focus.
	   */
	  lineDirection: _propTypes2.default.oneOf(['left', 'center', 'right']),
	
	  /**
	   * An optional boolean if the time picker is current visible by dialog or inline.
	   * If this is set, the `onVisibilityChange` function is required.
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityChange', 'defaultVisible'),
	
	  /**
	   * An optional function to call when the date picker is opened in either a dialog, or
	   * inline. The callback will include the next state.
	   *
	   * ```js
	   * onVisibilityChange(!visible, e);
	   * ```
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * Boolean if the time picker is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog should be able to close if a keyboard user presses the escape key.
	   */
	  closeOnEsc: _propTypes2.default.bool,
	
	  /**
	   * If true the hover mode of the Time Picker is activated.
	   * In hover mode no clicks are required to start selecting an hour
	   * and the time mode switches automatically when a time was chosen.
	   * When a minute is selected the chosen time is applied automatically.
	   */
	  hoverMode: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the inline time picker's visibility should be animated.
	   */
	  animateInline: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the time is required.
	   *
	   * @see {@link TextFields/TextField#required}
	   */
	  required: _propTypes2.default.bool,
	
	  /**
	   * @see {@link TextFields/TextField#block}
	   */
	  block: _TextField2.default.propTypes.block,
	
	  /**
	   * @see {@link TextFields/TextField#paddedBlock}
	   */
	  paddedBlock: _TextField2.default.propTypes.paddedBlock,
	
	  /**
	   * @see {@link TextFields/TextField#active}
	   */
	  active: _TextField2.default.propTypes.active,
	
	  /**
	   * @see {@link TextFields/TextField#error}
	   */
	  error: _TextField2.default.propTypes.error,
	
	  /**
	   * @see {@link TextFields/TextField#floating}
	   */
	  floating: _TextField2.default.propTypes.floating,
	
	  /**
	   * @see {@link TextFields/TextField#leftIconStateful}
	   */
	  leftIconStateful: _TextField2.default.propTypes.leftIconStateful,
	
	  /**
	   * @see {@link TextFields/TextField#rightIcon}
	   */
	  rightIcon: _TextField2.default.propTypes.rightIcon,
	
	  /**
	   * @see {@link TextFields/TextField#rightIconStateful}
	   */
	  rightIconStateful: _TextField2.default.propTypes.rightIconStateful,
	
	  /**
	   * @see {@link TextFields/TextField#customSize}
	   */
	  customSize: _TextField2.default.propTypes.customSize,
	
	  /**
	   * @see {@link TextFields/TextField#errorText}
	   */
	  errorText: _TextField2.default.propTypes.errorText,
	
	  /**
	   * @see {@link TextFields/TextField#helpText}
	   */
	  helpText: _TextField2.default.propTypes.helpText,
	
	  /**
	   * @see {@link TextFields/TextField#helpOnFocus}
	   */
	  helpOnFocus: _TextField2.default.propTypes.helpOnFocus,
	
	  /**
	   * @see {@link TextFields/TextField#inlineIndicator}
	   */
	  inlineIndicator: _TextField2.default.propTypes.inlineIndicator,
	
	  /**
	   * Boolean if the Portal's functionality of rendering in a separate react tree should be applied
	   * to the dialog.
	   *
	   * @see {@link Helpers/Portal}
	   */
	  portal: _propTypes2.default.bool,
	
	  /**
	   * An optional DOM Node to render the dialog into. The default is to render as the first child
	   * in the `body`.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the dialog should be rendered as the last child of the `renderNode` or `body` instead
	   * of the first.
	   */
	  lastChild: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Dialogs/DialogContainer#disableScrollLocking}
	   */
	  disableScrollLocking: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the TimePicker should be read only. This will prevent the user from opening the picker
	   * and only display the current date in the text field.
	   */
	  readOnly: _propTypes2.default.bool,
	
	  isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead'),
	  initiallyOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
	  initialTimeMode: (0, _deprecated2.default)(_propTypes2.default.oneOf(['hour', 'minute']), 'Use `defaultTimeMode` instead')
	};
	TimePickerContainer.defaultProps = {
	  animateInline: true,
	  defaultTimeMode: 'hour',
	  icon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'access_time'
	  ),
	  DateTimeFormat: _DateTimeFormat2.default, // eslint-disable-line object-shorthand
	  locales: typeof window !== 'undefined' ? window.navigator.userLanguage || window.navigator.language : 'en-US',
	  okLabel: 'Ok',
	  okPrimary: true,
	  cancelLabel: 'Cancel',
	  cancelPrimary: true,
	  closeOnEsc: true,
	  disableScrollLocking: false,
	  'aria-label': 'Select a time',
	  hoverMode: false
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._setContainer = function (container) {
	    _this2._container = container;
	  };
	
	  this._closeOnEsc = function (e) {
	    if ((e.which || e.keyCode) === _keyCodes.ESC) {
	      _this2._handleCancelClick(e);
	    }
	  };
	
	  this._handleOutsideClick = function (e) {
	    if (_this2._container && !_this2._container.contains(e.target)) {
	      _this2._handleCancelClick(e);
	    }
	  };
	
	  this._toggleOpen = function (e) {
	    if (_this2.props.disabled || _this2.props.readOnly) {
	      return;
	    }
	
	    var visible = !(typeof _this2.props.isOpen !== 'undefined' ? _this2.props.isOpen : (0, _getField2.default)(_this2.props, _this2.state, 'visible'));
	
	    if (_this2.props.onVisibilityChange) {
	      _this2.props.onVisibilityChange(visible, e);
	    }
	
	    if (typeof _this2.props.isOpen === 'undefined' && typeof _this2.props.visible === 'undefined') {
	      var hoverMode = _this2.props.hoverMode;
	
	
	      if (hoverMode) {
	        _this2._setTimeMode('hour');
	      }
	
	      _this2.setState({ visible: visible });
	    }
	  };
	
	  this._setTimeMode = function (timeMode) {
	    if (_this2.state.timeMode === timeMode) {
	      return;
	    }
	
	    _this2.setState({ timeMode: timeMode });
	  };
	
	  this._setTempTime = function (time) {
	    if (_this2.state.tempTime === time) {
	      return;
	    }
	
	    _this2.setState(_extends({ tempTime: time }, _this2._getTimeParts(time, _this2.props)));
	  };
	
	  this._handleKeyDown = function (e) {
	    (0, _handleKeyboardAccessibility2.default)(e, _this2._toggleOpen, true, true);
	
	    if ((e.which || e.keyCode) === _keyCodes.TAB && _this2.state.active) {
	      _this2.setState({ active: false });
	    }
	  };
	
	  this._handleOkClick = function (e) {
	    var _props3 = _this2.props,
	        onVisibilityChange = _props3.onVisibilityChange,
	        onChange = _props3.onChange,
	        DateTimeFormat = _props3.DateTimeFormat,
	        locales = _props3.locales;
	
	    var value = new Date(_this2.state.tempTime);
	    if (onChange) {
	      onChange((0, _formatTime2.default)(DateTimeFormat, locales, value), value, e);
	    }
	
	    if (onVisibilityChange) {
	      onVisibilityChange(false, e);
	    }
	
	    var state = _extends({ time: value }, _this2._getTimeParts(value, _this2.props));
	    if (typeof _this2.props.value === 'undefined') {
	      state.value = value;
	    }
	
	    if (typeof _this2.props.isOpen === 'undefined' && typeof _this2.props.visible === 'undefined') {
	      state.visible = false;
	    }
	
	    _this2.setState(state);
	  };
	
	  this._handleCancelClick = function (e) {
	    if (_this2.props.onVisibilityChange) {
	      _this2.props.onVisibilityChange(false, e);
	    }
	
	    var state = void 0;
	    if (typeof _this2.props.isOpen === 'undefined' && typeof _this2.props.visible === 'undefined') {
	      state = { visible: false };
	    }
	
	    var value = (0, _getField2.default)(_this2.props, _this2.state, 'value');
	    if (value) {
	      state = _extends({}, state, _this2._getTimeParts(value, _this2.props));
	      state.tempTime = _this2.state.time;
	    }
	
	    if (state) {
	      _this2.setState(state);
	    }
	  };
	};
	
	exports.default = TimePickerContainer;
	//# sourceMappingURL=TimePickerContainer.js.map

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TimePeriods = __webpack_require__(614);
	
	var _TimePeriods2 = _interopRequireDefault(_TimePeriods);
	
	var _PickerControl = __webpack_require__(174);
	
	var _PickerControl2 = _interopRequireDefault(_PickerControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TimePickerHeader` component is used for rendering the
	 * current time for the `TimePicker` as well as switching between
	 * the different views for the time picker.
	 */
	var TimePickerHeader = function (_PureComponent) {
	  _inherits(TimePickerHeader, _PureComponent);
	
	  function TimePickerHeader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TimePickerHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimePickerHeader.__proto__ || Object.getPrototypeOf(TimePickerHeader)).call.apply(_ref, [this].concat(args))), _this), _this._setHour = function () {
	      _this.props.setTimeMode('hour');
	    }, _this._setMinute = function () {
	      _this.props.setTimeMode('minute');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TimePickerHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          timeMode = _props.timeMode,
	          hours = _props.hours,
	          minutes = _props.minutes,
	          timePeriod = _props.timePeriod,
	          setTempTime = _props.setTempTime,
	          tempTime = _props.tempTime;
	
	      var timePeriods = void 0;
	      if (timePeriod) {
	        timePeriods = _react2.default.createElement(_TimePeriods2.default, { tempTime: tempTime, setTempTime: setTempTime, timePeriod: timePeriod });
	      }
	
	      return _react2.default.createElement(
	        'header',
	        { className: 'md-picker-header md-text-right' },
	        _react2.default.createElement(
	          _PickerControl2.default,
	          { onClick: this._setHour, active: timeMode === 'hour' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'md-display-3' },
	            hours
	          )
	        ),
	        _react2.default.createElement(
	          _PickerControl2.default,
	          { onClick: this._setMinute, active: timeMode === 'minute' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'md-display-3' },
	            minutes
	          )
	        ),
	        timePeriods
	      );
	    }
	  }]);
	
	  return TimePickerHeader;
	}(_react.PureComponent);
	
	TimePickerHeader.propTypes = {
	  /**
	   * The current time of the time picker.
	   */
	  tempTime: _propTypes2.default.instanceOf(Date).isRequired,
	
	  /**
	   * The current time type that is being changed.
	   */
	  timeMode: _propTypes2.default.oneOf(['hour', 'minute']).isRequired,
	
	  /**
	   * A function to update the time mode.
	   */
	  setTimeMode: _propTypes2.default.func.isRequired,
	
	  /**
	   * A function to update the time for the time picker.
	   */
	  setTempTime: _propTypes2.default.func.isRequired,
	
	  /**
	   * A formatted hours string for the user's locale. This
	   * would be '3' for en-US if the time was '3:15'
	   */
	  hours: _propTypes2.default.string.isRequired,
	
	  /**
	   * A formatted minutes string for the user's locale.
	   * This would be ':15' for en-US if the time was '3:15'.
	   */
	  minutes: _propTypes2.default.string.isRequired,
	
	  /**
	   * An optional time period to use for locales that use
	   * 12 hour clocks and AM/PM.
	   */
	  timePeriod: _propTypes2.default.string
	};
	exports.default = TimePickerHeader;
	//# sourceMappingURL=TimePickerHeader.js.map

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(12);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This is a component for rendering a year in the Date Picker's Year picker
	 * list.
	 */
	var Year = function (_PureComponent) {
	  _inherits(Year, _PureComponent);
	
	  function Year() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Year);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Year.__proto__ || Object.getPrototypeOf(Year)).call.apply(_ref, [this].concat(args))), _this), _this.state = { desktopActive: false }, _this._setActiveFocus = function (btn) {
	      if (btn && _this.props.active) {
	        btn.focus();
	      }
	    }, _this._setActive = function () {
	      _this.setState({ desktopActive: true });
	    }, _this._setInactive = function () {
	      _this.setState({ desktopActive: false });
	    }, _this._handleClick = function (e) {
	      _this.props.onClick(_this.props.year, e);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Year, [{
	    key: 'render',
	    value: function render() {
	      var desktopActive = this.state.desktopActive;
	      var _props = this.props,
	          active = _props.active,
	          className = _props.className,
	          year = _props.year;
	
	      return _react2.default.createElement(
	        'button',
	        {
	          type: 'button',
	          ref: this._setActiveFocus,
	          className: (0, _classnames2.default)('md-year', { 'md-year--active': active }, (0, _themeColors2.default)({
	            text: !active && !desktopActive,
	            primary: active || desktopActive
	          }), 'md-btn md-pointer--hover md-full-width', className),
	          onClick: this._handleClick
	        },
	        year
	      );
	    }
	  }]);
	
	  return Year;
	}(_react.PureComponent);
	
	Year.propTypes = {
	  className: _propTypes2.default.string,
	  active: _propTypes2.default.bool.isRequired,
	  onClick: _propTypes2.default.func.isRequired,
	  year: _propTypes2.default.number.isRequired
	};
	exports.default = Year;
	//# sourceMappingURL=Year.js.map

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Year = __webpack_require__(618);
	
	var _Year2 = _interopRequireDefault(_Year);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `YearPicker` component is the Year view in a `DatePicker`. This
	 * will display a list of years to select from within the given range.
	 */
	var YearPicker = function (_PureComponent) {
	  _inherits(YearPicker, _PureComponent);
	
	  function YearPicker(props) {
	    _classCallCheck(this, YearPicker);
	
	    var _this = _possibleConstructorReturn(this, (YearPicker.__proto__ || Object.getPrototypeOf(YearPicker)).call(this, props));
	
	    _this.state = _this._getYearRange(props);
	    return _this;
	  }
	
	  _createClass(YearPicker, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.yearsDisplayed !== nextProps.yearsDisplayed) {
	        this.setState(this._getFullYear(nextProps));
	      }
	    }
	
	    /**
	     * Gets the current start and end years for the year picker.
	     *
	     * @param {Object} props - The current props to extract the year range from.
	     * @return {Object} an object containign the start and end years
	     */
	
	  }, {
	    key: '_getYearRange',
	    value: function _getYearRange(_ref) {
	      var minDate = _ref.minDate,
	          maxDate = _ref.maxDate,
	          yearsDisplayed = _ref.yearsDisplayed,
	          calendarTempDate = _ref.calendarTempDate;
	
	      var year = calendarTempDate.getFullYear();
	      var range = !minDate && !maxDate ? parseInt(yearsDisplayed / 2, 10) : yearsDisplayed;
	
	      var startYear = void 0;
	      var endYear = void 0;
	      if (minDate && maxDate) {
	        startYear = minDate.getFullYear();
	        endYear = maxDate.getFullYear();
	      } else if (!minDate && !maxDate) {
	        startYear = year - range;
	        endYear = year + range;
	        if (yearsDisplayed % 2 === 0) {
	          endYear -= 1;
	        }
	      } else if (!maxDate) {
	        startYear = minDate.getFullYear();
	        endYear = startYear + yearsDisplayed - 1;
	      } else {
	        endYear = maxDate.getFullYear();
	        startYear = endYear - yearsDisplayed + 1;
	      }
	
	      return { startYear: startYear, endYear: endYear };
	    }
	  }, {
	    key: '_setContainer',
	    value: function _setContainer(container) {
	      if (container === null) {
	        return;
	      }
	
	      var offsetHeight = container.offsetHeight,
	          offsetWidth = container.offsetWidth;
	
	      var _container$querySelec = container.querySelector('.md-year--active'),
	          top = _container$querySelec.offsetTop,
	          height = _container$querySelec.offsetHeight;
	
	      // Portrait seems to be 3/4 of the way while landscape is about 1/2
	
	
	      if (offsetHeight > offsetWidth) {
	        container.scrollTop = top - offsetHeight * 3 / 4;
	      } else {
	        container.scrollTop = top - offsetHeight / 2 + height / 2;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          startYear = _state.startYear,
	          endYear = _state.endYear;
	
	
	      var currentYear = this.props.calendarTempDate.getFullYear();
	      var years = [];
	      for (var year = startYear; year <= endYear; year++) {
	        years.push(_react2.default.createElement(_Year2.default, {
	          key: year,
	          year: year,
	          active: year === currentYear,
	          onClick: this.props.onCalendarYearClick
	        }));
	      }
	
	      return _react2.default.createElement(
	        'section',
	        {
	          className: (0, _classnames2.default)('md-picker-content md-picker-content--year', this.props.className),
	          ref: this._setContainer
	        },
	        _react2.default.createElement(
	          'ol',
	          { className: 'md-years' },
	          years
	        )
	      );
	    }
	  }]);
	
	  return YearPicker;
	}(_react.PureComponent);
	
	YearPicker.propTypes = {
	  className: _propTypes2.default.string,
	  calendarTempDate: _propTypes2.default.instanceOf(Date).isRequired,
	  onCalendarYearClick: _propTypes2.default.func.isRequired,
	  yearsDisplayed: _propTypes2.default.number.isRequired,
	  minDate: _propTypes2.default.instanceOf(Date),
	  maxDate: _propTypes2.default.instanceOf(Date)
	};
	exports.default = YearPicker;
	//# sourceMappingURL=YearPicker.js.map

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TimePickerContainer = exports.TimePicker = exports.DatePickerContainer = exports.DatePicker = undefined;
	
	var _DatePickerContainer2 = __webpack_require__(612);
	
	var _DatePickerContainer3 = _interopRequireDefault(_DatePickerContainer2);
	
	var _TimePickerContainer2 = __webpack_require__(616);
	
	var _TimePickerContainer3 = _interopRequireDefault(_TimePickerContainer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DatePicker = _DatePickerContainer3.default;
	exports.DatePickerContainer = _DatePickerContainer3.default;
	exports.TimePicker = _TimePickerContainer3.default;
	exports.TimePickerContainer = _TimePickerContainer3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(17);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _between = __webpack_require__(85);
	
	var _between2 = _interopRequireDefault(_between);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ROATE_DISTANCE = 360 * 1.75;
	var BASE_SIZE = 24; // font-icon font size
	
	/**
	 * The `CircularProgress` component is used to give visual feedback while your app
	 * is loading.
	 *
	 * There are two different types of circular progress bars: `Determinate` and `Indeterminate`.
	 *
	 * A `Determinate` circular progress bar should be used when you want to keep track of the current
	 * progress. An example would be downloading a file.
	 *
	 * An `Indeterminate` circular progress bar should be used when you can not keep track of the progress
	 * yourself. An example would be waiting for some API call to complete.
	 */
	
	var CircularProgress = function (_PureComponent) {
	  _inherits(CircularProgress, _PureComponent);
	
	  function CircularProgress() {
	    _classCallCheck(this, CircularProgress);
	
	    return _possibleConstructorReturn(this, (CircularProgress.__proto__ || Object.getPrototypeOf(CircularProgress)).apply(this, arguments));
	  }
	
	  _createClass(CircularProgress, [{
	    key: 'render',
	
	    /* eslint-disable max-len */
	    value: function render() {
	      var _props = this.props,
	          scale = _props.scale,
	          style = _props.style,
	          className = _props.className,
	          value = _props.value,
	          determinateDashoffset = _props.determinateDashoffset,
	          centered = _props.centered,
	          props = _objectWithoutProperties(_props, ['scale', 'style', 'className', 'value', 'determinateDashoffset', 'centered']);
	
	      var isDeterminate = typeof value === 'number';
	      var circleStyle = void 0;
	      var svgStyle = style;
	      if (isDeterminate) {
	        var rotate = 'rotate3d(0, 0, 1, ' + ROATE_DISTANCE / 100 * value + 'deg)';
	        circleStyle = {
	          strokeDashoffset: determinateDashoffset - determinateDashoffset / 100 * value
	        };
	
	        svgStyle = Object.assign({}, style, {
	          WebkitTransform: (0, _classnames2.default)(style.WebkitTransform, rotate),
	          MozTransform: (0, _classnames2.default)(style.MozTransform, rotate),
	          transform: (0, _classnames2.default)(style.transform, rotate)
	        });
	      }
	
	      var accessibilityProps = {
	        role: 'progressbar',
	        'aria-valuemin': 0,
	        'aria-valuemax': 100
	      };
	
	      if (isDeterminate) {
	        accessibilityProps['aria-valuenow'] = value;
	      }
	
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, props, accessibilityProps, {
	          style: svgStyle,
	          className: (0, _classnames2.default)('md-progress md-progress--circular', {
	            'md-block-centered': centered,
	            'md-progress--circular-determinate': isDeterminate,
	            'md-progress--circular-indeterminate': !isDeterminate
	          }, className),
	          width: scale * BASE_SIZE,
	          height: scale * BASE_SIZE,
	          viewBox: '0 0 66 66'
	        }),
	        _react2.default.createElement('circle', {
	          className: (0, _classnames2.default)('md-circular-progress-path', {
	            'md-circular-progress-path--animated': !isDeterminate
	          }),
	          strokeWidth: '6',
	          strokeLinecap: 'round',
	          style: circleStyle,
	          cx: '33',
	          cy: '33',
	          r: '30'
	        })
	      );
	    }
	  }]);
	
	  return CircularProgress;
	}(_react.PureComponent);
	
	CircularProgress.propTypes = {
	  /**
	   * The `id` prop is required for accessibility concerns.
	   * [Progress Bar Role](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_progressbar_role)
	   *
	   * > If the progressbar is describing the loading progress of a particular region of a page, the author
	   * __SHOULD__ use aria-describedby to point to the status, and set the aria-busy attribute to true on the
	   * region until it is finished loading. It is not possible for the user to alter the value of a progressbar
	   * because it is always readonly.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /* eslint-enable max-len */
	
	  /**
	   * A style object to apply to the SVG. If this is a determinate `CircularProgress`,
	   * the `transform` (and vendor prefixes) styles will be merged with the current
	   * progress rotation.
	   */
	  style: _propTypes2.default.object.isRequired,
	
	  /**
	   * An optional className to apply to the SVG.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The current value of the progress. If this value is defined, it will
	   * be converted to a determinate circular progress. The progress will not
	   * advance unless this value changes.
	   *
	   * This value should also be a number between 0 and 100.
	   */
	  value: (0, _between2.default)(_propTypes2.default.number, 0, 100),
	
	  /**
	   * The scale for the circular progress.
	   */
	  scale: _propTypes2.default.number.isRequired,
	
	  /**
	   * You probably don't want to update this. I'm not good at SVG. This should
	   * match the SCSS variable `$md-circular-progress-stroke-dashoffset`.
	   */
	  determinateDashoffset: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the progress should be centered in it's container.
	   */
	  centered: _propTypes2.default.bool
	};
	CircularProgress.defaultProps = {
	  style: {},
	  scale: 1,
	  determinateDashoffset: 187,
	  centered: true
	};
	exports.default = CircularProgress;
	//# sourceMappingURL=CircularProgress.js.map

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(17);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _between = __webpack_require__(85);
	
	var _between2 = _interopRequireDefault(_between);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * There are 3 different types of linear progress bars: `Determinate`,
	 * `Indeterminate`, and `Query Indeterminate`.
	 *
	 * A `Determinate` linear progress bar should be used when you can keep track of the
	 * progress and have a percentage complete you can work with. An example would be
	 * uploading/downloading a file.
	 *
	 * An `Indeterminate` linear progress bar should be used when you can not keep track
	 * of the progress yourself. An example might be waiting for an API call to complete.
	 *
	 * A `Query Indeterminate` linear progress bar is used when you are combining
	 * `Indeterminate` and `Determinate`. A Linear Progress component can be displayed
	 * as a query indeterminate progress bar by adding the prop `query={true}` to the
	 * component. Until a progress value is given, it will display the query linear
	 * progress animation. Afterwards, it will start the determinate animation of where
	 * you manually keep updating the value of the progress.
	 */
	var LinearProgress = function (_PureComponent) {
	  _inherits(LinearProgress, _PureComponent);
	
	  function LinearProgress() {
	    _classCallCheck(this, LinearProgress);
	
	    return _possibleConstructorReturn(this, (LinearProgress.__proto__ || Object.getPrototypeOf(LinearProgress)).apply(this, arguments));
	  }
	
	  _createClass(LinearProgress, [{
	    key: 'render',
	
	    /* eslint-disable max-len */
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          progressClassName = _props.progressClassName,
	          progressStyle = _props.progressStyle,
	          value = _props.value,
	          query = _props.query,
	          centered = _props.centered,
	          props = _objectWithoutProperties(_props, ['className', 'progressClassName', 'progressStyle', 'value', 'query', 'centered']);
	
	      var isDeterminate = typeof value === 'number';
	
	      var accessibilityProps = {
	        role: 'progressbar',
	        'aria-valuemin': 0,
	        'aria-valuemax': 100
	      };
	
	      var style = void 0;
	      if (isDeterminate) {
	        style = { width: value + '%' };
	        accessibilityProps['aria-valuenow'] = value;
	      }
	      if (progressStyle) {
	        style = Object.assign(style || {}, typeof progressStyle === 'function' ? progressStyle(value, this) : progressStyle);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, {
	          className: (0, _classnames2.default)('md-progress md-progress--linear', { 'md-block-centered': centered }, className)
	        }),
	        _react2.default.createElement('div', _extends({}, accessibilityProps, {
	          style: style,
	          className: (0, _classnames2.default)('md-progress--linear-active', {
	            'md-progress--linear-query': query,
	            'md-progress--linear-determinate': isDeterminate,
	            'md-progress--linear-indeterminate': !isDeterminate
	          }, typeof progressClassName === 'function' ? progressClassName(value, this) : progressClassName)
	        }))
	      );
	    }
	  }]);
	
	  return LinearProgress;
	}(_react.PureComponent);
	
	LinearProgress.propTypes = {
	  /**
	   * The `id` prop is required for accessibility concerns.
	   * [Progress Bar Role](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_progressbar_role)
	   *
	   * > If the progressbar is describing the loading progress of a particular region of a page, the author
	   * __SHOULD__ use aria-describedby to point to the status, and set the aria-busy attribute to true on the
	   * region until it is finished loading. It is not possible for the user to alter the value of a progressbar
	   * because it is always readonly.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /* eslint-enable max-len */
	  /**
	   * An optional className to apply to the linear progress container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the progress bar element.
	   *
	   * If a function is specified it will be called to get necessary className.
	   * Current progress value and reference to the component will be passed into the function.
	   */
	  progressClassName: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the progress bar element.
	   *
	   * If a function is specified it will be called to get necessary style.
	   * Current progress value and reference to the component will be passed into the function.
	   */
	  progressStyle: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
	
	  /**
	   * The current value of the progress. If this value is defined, it will
	   * be converted to a determinate circular progress. The progress will not
	   * advance unless this value changes.
	   *
	   * This value should also be a number between 0 and 100.
	   */
	  value: (0, _between2.default)(_propTypes2.default.number, 0, 100),
	
	  /**
	   * Boolean if this should be a query indeterminate progress bar.
	   */
	  query: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the Linear Progress should be centered. This
	   * will only work if the `max-width` style is set.
	   */
	  centered: _propTypes2.default.bool
	};
	LinearProgress.defaultProps = {
	  query: false
	};
	exports.default = LinearProgress;
	//# sourceMappingURL=LinearProgress.js.map

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CircularProgress = exports.LinearProgress = undefined;
	
	var _LinearProgress2 = __webpack_require__(622);
	
	var _LinearProgress3 = _interopRequireDefault(_LinearProgress2);
	
	var _CircularProgress2 = __webpack_require__(621);
	
	var _CircularProgress3 = _interopRequireDefault(_CircularProgress2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.LinearProgress = _LinearProgress3.default;
	exports.CircularProgress = _CircularProgress3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _themeColors = __webpack_require__(12);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `SVGIcon` component is used for rendering inline SVG icons or sprite-mapped SVGs
	 * as an icon.
	 */
	var SVGIcon = function (_PureComponent) {
	  _inherits(SVGIcon, _PureComponent);
	
	  function SVGIcon(props) {
	    _classCallCheck(this, SVGIcon);
	
	    var _this = _possibleConstructorReturn(this, (SVGIcon.__proto__ || Object.getPrototypeOf(SVGIcon)).call(this));
	
	    _this._getIds = function (_ref) {
	      var use = _ref.use,
	          labels = _ref['aria-labelledby'],
	          title = _ref.title,
	          desc = _ref.desc;
	
	      var titleId = null;
	      var descId = null;
	      var labelledBy = null;
	      if (title || desc) {
	        if (use) {
	          var baseId = use.replace(/.*#/, '');
	          titleId = baseId + '-title';
	          descId = baseId + '-desc';
	
	          if (title) {
	            labelledBy = baseId + '-title';
	          }
	
	          if (desc) {
	            labelledBy = '' + (labelledBy ? labelledBy + ' ' : '') + descId;
	          }
	        } else if (labels) {
	          var _labels$split = labels.split(' ');
	
	          var _labels$split2 = _slicedToArray(_labels$split, 2);
	
	          titleId = _labels$split2[0];
	          descId = _labels$split2[1];
	        }
	      }
	
	      return { titleId: titleId, descId: descId, labelledBy: labelledBy };
	    };
	
	    _this._mergeStyles = function (_ref2) {
	      var style = _ref2.style,
	          size = _ref2.size;
	
	      if (style && size) {
	        return _extends({ height: size, width: size }, style);
	      } else if (style) {
	        return style;
	      } else if (size) {
	        return { height: size, width: size };
	      }
	
	      return undefined;
	    };
	
	    _this.state = _extends({
	      styles: _this._mergeStyles(props)
	    }, _this._getIds(props));
	    return _this;
	  }
	
	  _createClass(SVGIcon, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          style = _props.style,
	          size = _props.size,
	          use = _props.use,
	          title = _props.title,
	          desc = _props.desc,
	          labels = _props['aria-labelledby'];
	
	      var nextState = void 0;
	      if (style !== nextProps.style || size !== nextProps.size) {
	        nextState = { styles: this._mergeStyles(nextProps) };
	      }
	
	      if (title !== nextProps.title || desc !== nextProps.desc || (nextProps.title || nextProps.desc) && (use !== nextProps.use || labels !== nextProps['aria-labelledby'])) {
	        nextState = _extends({}, nextState, this._getIds(nextProps));
	      }
	
	      if (nextState) {
	        this.setState(nextState);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          styles = _state.styles,
	          titleId = _state.titleId,
	          descId = _state.descId,
	          labelledBy = _state.labelledBy;
	
	      var _props2 = this.props,
	          className = _props2.className,
	          disabled = _props2.disabled,
	          use = _props2.use,
	          primary = _props2.primary,
	          secondary = _props2.secondary,
	          error = _props2.error,
	          inherit = _props2.inherit,
	          titleAttr = _props2.titleAttr,
	          ariaLabelledBy = _props2['aria-labelledby'],
	          size = _props2.size,
	          propTitle = _props2.title,
	          propDesc = _props2.desc,
	          propStyle = _props2.style,
	          propChildren = _props2.children,
	          props = _objectWithoutProperties(_props2, ['className', 'disabled', 'use', 'primary', 'secondary', 'error', 'inherit', 'titleAttr', 'aria-labelledby', 'size', 'title', 'desc', 'style', 'children']);
	
	      var _props3 = this.props,
	          children = _props3.children,
	          title = _props3.title,
	          desc = _props3.desc;
	
	      if (!children && use) {
	        children = _react2.default.createElement('use', { xlinkHref: use });
	      }
	
	      if (title) {
	        title = _react2.default.createElement(
	          'title',
	          { id: titleId },
	          title
	        );
	      }
	
	      if (desc) {
	        desc = _react2.default.createElement(
	          'desc',
	          { id: descId },
	          desc
	        );
	      }
	
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, props, {
	          title: titleAttr,
	          'aria-labelledby': ariaLabelledBy || labelledBy,
	          style: styles,
	          className: (0, _classnames2.default)('md-icon', (0, _themeColors2.default)({
	            disabled: disabled,
	            error: error,
	            inherit: inherit,
	            primary: primary,
	            secondary: secondary
	          }, className))
	        }),
	        title,
	        desc,
	        children
	      );
	    }
	  }]);
	
	  return SVGIcon;
	}(_react.PureComponent);
	
	SVGIcon.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if the primary theme color should be applied.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the secondary theme color should be applied.
	   */
	  secondary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the icon is considered disabled and should inherit the
	   * disabled color.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the icon is considered errored and should inherit the error color.
	   */
	  error: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the color of the icon should be inherited by parent elements.
	   */
	  inherit: _propTypes2.default.bool,
	
	  /**
	   * The role to apply to the SVG. When using icons, it is generally recommended to leave it as the default
	   * `img` so that it is insured as a graphic.
	   */
	  role: _propTypes2.default.oneOf(['img', 'presentation']),
	
	  /**
	   * This prop is the title attribute to provide to the `<svg>` element itself. This should be used when you
	   * are using a spritesheet that has defined `<title>` with each SVG symbol.
	   */
	  titleAttr: _propTypes2.default.string,
	
	  /**
	   * An optional list of ids to use to label the SVG icon with. This is helpful to add when you use the `title`
	   * and `desc` props as this is used to create ids for those two props. This is super beneficial to screen readers.
	   *
	   * When this is defined, it is a space-delimited string of ids to provide to the title and desc (in order). If
	   * this is omitted and the `use` prop is defined, it will take everything after the `#` sign and append `-title` and
	   * `-desc` as a fallback. Check out the examples for more information about this.
	   *
	   * @see {@link #title}
	   * @see {@link #desc}
	   */
	  'aria-labelledby': _propTypes2.default.string,
	
	  /**
	   * An optional title to give to your SVG icon. This is generally recommended for accessibility when not using
	   * the `use` prop, or your spritemap does not contain `<title>` and `<desc>.
	   *
	   * @see {@link #aria-labelledby}
	   */
	  title: _propTypes2.default.string,
	
	  /**
	   * An optional description to give to your SVG icon. This is generally recommended for accessibility when not using
	   * the `use` prop, or your spritemap does not contain `<title>` and `<desc>.
	   *
	   * @see {@link #aria-labelledby}
	   */
	  desc: _propTypes2.default.string,
	
	  /**
	   * This should be a link to a part of an SVG spritemap. So normally one of the following:
	   * - `'#some-custom-svg'`
	   * - `'/images/spritemap.svg#some-custom-svg'`
	   *
	   * This prop **should not** be used with the `children` prop as only one will be rendered.
	   *
	   * > NOTE: IE **does not support** external SVGs. Please see the demo for more details.
	   */
	  use: _propTypes2.default.string,
	
	  /**
	   * Any `<svg>` children to render to create your icon. This can not be used with the `use` prop.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element), _propTypes2.default.node]),
	
	  /**
	   * Boolean if the SVG should gain the `focusable` attribute. This is disabled by default since IE11
	   * and Edge actually default this to true and keyboard's will tab focus all SVGs.
	   */
	  focusable: _propTypes2.default.string,
	
	  /**
	   * An optional size to apply to the SVG. This can be used to set both the
	   * `height` and `width` simultaneously. This will be provided as inline styles
	   * since the `height` and `width` are normally controlled by CSS, and CSS has
	   * higher precedence than the `height`/`width` attributes.
	   */
	  size: _propTypes2.default.number,
	
	  /**
	   * The `height` prop should not be used since the `height` and `width` are controlled by CSS and the CSS
	   * has a higher precedence than inline attributes. If you want to set the `height`, it should be done via
	   * CSS or the `size` prop.
	   *
	   * @see {@link #size}
	   */
	  height: (0, _deprecated2.default)(_propTypes2.default.number, 'Use the `size` prop instead.'),
	
	  /**
	   * The `width` prop should not be used since the `height` and `width` are controlled by CSS and the CSS
	   * has a higher precedence than inline attributes. If you want to set the `height`, it should be done via
	   * CSS or the `size` prop.
	   *
	   * @see {@link #size}
	   */
	  width: (0, _deprecated2.default)(_propTypes2.default.number, 'Use the `size` prop instead.'),
	
	  /**
	   * The viewBox attribute allows you to specify that a given set of graphics stretch to
	   * fit a particular container element.
	   *
	   * The value of the viewBox attribute is a list of four numbers min-x, min-y, width and
	   * height, separated by white space and/or a comma, which specify a rectangle in user
	   * space which should be mapped to the bounds of the viewport established by the given
	   * element, taking into account attribute preserveAspectRatio.
	   *
	   * Negative values for width or height are not permitted and a value of zero disables
	   * rendering of the element.An optional viewbox for the SVG.
	   *
	   * For example, if the SVG element is 250 (width) by 200 (height) and you provide
	   * `viewBox="0 0 25 20"`, the coordinates inside the SVG will go from the top left corner
	   * (0, 0) to the bottom right (25, 20) and each unit will be worth `10px`.
	   */
	  viewBox: _propTypes2.default.string,
	
	  /**
	   * An optional xmlns string to provide. The `use` prop will not work without this prop
	   * defined.
	   */
	  xmlns: _propTypes2.default.string
	};
	SVGIcon.defaultProps = {
	  role: 'img',
	  focusable: 'false',
	  xmlns: 'http://www.w3.org/2000/svg',
	  viewBox: '0 0 24 24'
	};
	exports.default = SVGIcon;
	//# sourceMappingURL=SVGIcon.js.map

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SVGIcon = undefined;
	
	var _SVGIcon2 = __webpack_require__(624);
	
	var _SVGIcon3 = _interopRequireDefault(_SVGIcon2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SVGIcon3.default;
	exports.SVGIcon = _SVGIcon3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CSSTransitionGroupTick = __webpack_require__(34);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	var _themeColors = __webpack_require__(12);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _FontIcon = __webpack_require__(13);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _AccessibleFakeInkedButton = __webpack_require__(29);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	var _IconSeparator = __webpack_require__(61);
	
	var _IconSeparator2 = _interopRequireDefault(_IconSeparator);
	
	var _Paper = __webpack_require__(33);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _TextFieldDivider = __webpack_require__(291);
	
	var _TextFieldDivider2 = _interopRequireDefault(_TextFieldDivider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectFieldInput = function (_PureComponent) {
	  _inherits(SelectFieldInput, _PureComponent);
	
	  function SelectFieldInput() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SelectFieldInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectFieldInput.__proto__ || Object.getPrototypeOf(SelectFieldInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = { transition: null }, _this._timeout = null, _this._transitionNewValue = function () {
	      var _this$props = _this.props,
	          transitionTime = _this$props.transitionTime,
	          transitionName = _this$props.transitionName;
	
	      if (_this._timeout) {
	        clearTimeout(_this._timeout);
	      }
	
	      _this._timeout = setTimeout(function () {
	        _this._timeout = setTimeout(function () {
	          _this._timeout = null;
	          _this.setState({ transition: null });
	        }, transitionTime);
	
	        _this.setState({ transition: _this.state.transition + ' ' + transitionName + '-enter-active' });
	      }, _CSSTransitionGroupTick2.default);
	
	      _this.setState({ transition: transitionName + '-enter' });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SelectFieldInput, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        this._transitionNewValue();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          className = _props.className,
	          name = _props.name,
	          value = _props.value,
	          label = _props.label,
	          placeholder = _props.placeholder,
	          active = _props.active,
	          activeLabel = _props.activeLabel,
	          error = _props.error,
	          disabled = _props.disabled,
	          required = _props.required,
	          toolbar = _props.toolbar,
	          below = _props.below,
	          lineDirection = _props.lineDirection,
	          dropdownIcon = _props.dropdownIcon,
	          iconChildren = _props.iconChildren,
	          iconClassName = _props.iconClassName,
	          transitionName = _props.transitionName,
	          transitionTime = _props.transitionTime,
	          props = _objectWithoutProperties(_props, ['id', 'className', 'name', 'value', 'label', 'placeholder', 'active', 'activeLabel', 'error', 'disabled', 'required', 'toolbar', 'below', 'lineDirection', 'dropdownIcon', 'iconChildren', 'iconClassName', 'transitionName', 'transitionTime']);
	
	      var transition = this.state.transition;
	
	
	      var divider = void 0;
	      if (!below && !toolbar) {
	        divider = _react2.default.createElement(_TextFieldDivider2.default, {
	          key: 'text-divider',
	          active: active,
	          error: error,
	          lineDirection: lineDirection,
	          className: 'md-divider--select-field'
	        });
	      }
	
	      var visibleLabel = activeLabel;
	      if (!activeLabel && activeLabel !== 0) {
	        visibleLabel = (!label || active) && placeholder || '';
	      }
	
	      var labelActive = !!activeLabel || activeLabel === 0;
	
	      var icon = dropdownIcon;
	      if (iconClassName || iconChildren) {
	        icon = _react2.default.createElement(
	          _FontIcon2.default,
	          { iconClassName: iconClassName },
	          iconChildren
	        );
	      }
	      icon = _react2.default.cloneElement(icon, { disabled: disabled });
	
	      return _react2.default.createElement(
	        _AccessibleFakeInkedButton2.default,
	        _extends({}, props, {
	          id: id + '-toggle',
	          role: 'listbox',
	          disabled: disabled,
	          component: _Paper2.default,
	          zDepth: below && active ? 1 : 0,
	          inkDisabled: !below,
	          className: (0, _classnames2.default)('md-select-field', (0, _themeColors2.default)({
	            disabled: disabled,
	            hint: !labelActive && placeholder,
	            text: labelActive
	          }), className)
	        }),
	        _react2.default.createElement(
	          _IconSeparator2.default,
	          {
	            label: visibleLabel,
	            labelClassName: transition,
	            className: (0, _classnames2.default)('md-text-field', {
	              'md-text-field--margin': !below && !label,
	              'md-text-field--floating-margin': label,
	              'md-text-field--toolbar': toolbar && !below,
	              'md-select-field--text-field': !below,
	              'md-select-field--btn': below
	            })
	          },
	          icon
	        ),
	        divider,
	        _react2.default.createElement('input', {
	          key: 'value',
	          type: 'hidden',
	          id: id,
	          name: name,
	          value: value,
	          required: required,
	          disabled: disabled
	        })
	      );
	    }
	  }]);
	
	  return SelectFieldInput;
	}(_react.PureComponent);
	
	SelectFieldInput.propTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  disabled: _propTypes2.default.bool,
	  required: _propTypes2.default.bool,
	  label: _propTypes2.default.node,
	  placeholder: _propTypes2.default.string,
	  active: _propTypes2.default.bool,
	  activeLabel: _propTypes2.default.node,
	  below: _propTypes2.default.bool,
	  error: _propTypes2.default.bool,
	  toolbar: _propTypes2.default.bool,
	  dropdownIcon: _propTypes2.default.element,
	  iconClassName: _propTypes2.default.string,
	  iconChildren: _propTypes2.default.node,
	  transitionName: _propTypes2.default.string.isRequired,
	  transitionTime: _propTypes2.default.number.isRequired,
	  lineDirection: _TextFieldDivider2.default.propTypes.lineDirection
	};
	SelectFieldInput.defaultProps = {
	  transitionName: 'md-drop',
	  transitionTime: 300
	};
	exports.default = SelectFieldInput;
	//# sourceMappingURL=SelectFieldInput.js.map

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _addSuffix = __webpack_require__(306);
	
	var _addSuffix2 = _interopRequireDefault(_addSuffix);
	
	var _isValued = __webpack_require__(115);
	
	var _isValued2 = _interopRequireDefault(_isValued);
	
	var _FloatingLabel = __webpack_require__(290);
	
	var _FloatingLabel2 = _interopRequireDefault(_FloatingLabel);
	
	var _TextFieldMessage = __webpack_require__(292);
	
	var _TextFieldMessage2 = _interopRequireDefault(_TextFieldMessage);
	
	var _SelectFieldInput = __webpack_require__(626);
	
	var _SelectFieldInput2 = _interopRequireDefault(_SelectFieldInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectFieldToggle = function (_PureComponent) {
	  _inherits(SelectFieldToggle, _PureComponent);
	
	  function SelectFieldToggle() {
	    _classCallCheck(this, SelectFieldToggle);
	
	    return _possibleConstructorReturn(this, (SelectFieldToggle.__proto__ || Object.getPrototypeOf(SelectFieldToggle)).apply(this, arguments));
	  }
	
	  _createClass(SelectFieldToggle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          style = _props.style,
	          className = _props.className,
	          inputStyle = _props.inputStyle,
	          inputClassName = _props.inputClassName,
	          required = _props.required,
	          disabled = _props.disabled,
	          active = _props.active,
	          error = _props.error,
	          errorText = _props.errorText,
	          helpText = _props.helpText,
	          helpOnFocus = _props.helpOnFocus,
	          visible = _props.visible,
	          activeLabel = _props.activeLabel,
	          propLabel = _props.label,
	          propPlaceholder = _props.placeholder,
	          props = _objectWithoutProperties(_props, ['id', 'style', 'className', 'inputStyle', 'inputClassName', 'required', 'disabled', 'active', 'error', 'errorText', 'helpText', 'helpOnFocus', 'visible', 'activeLabel', 'label', 'placeholder']);
	
	      var _props2 = this.props,
	          label = _props2.label,
	          placeholder = _props2.placeholder;
	
	      if (required) {
	        if (label) {
	          label = (0, _addSuffix2.default)(label, '*');
	        }
	
	        if (placeholder && !label) {
	          placeholder = (0, _addSuffix2.default)(placeholder, '*');
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: style, className: (0, _classnames2.default)('md-select-field__toggle', className) },
	        _react2.default.createElement(_FloatingLabel2.default, {
	          label: label,
	          htmlFor: id,
	          active: active || visible,
	          error: error,
	          floating: (0, _isValued2.default)(activeLabel) || active || visible,
	          disabled: disabled
	        }),
	        _react2.default.createElement(_SelectFieldInput2.default, _extends({}, props, {
	          id: id,
	          style: inputStyle,
	          className: inputClassName,
	          label: label,
	          placeholder: placeholder,
	          activeLabel: activeLabel,
	          active: active,
	          error: error,
	          disabled: disabled
	        })),
	        _react2.default.createElement(_TextFieldMessage2.default, {
	          active: active || visible,
	          error: error,
	          errorText: errorText,
	          helpText: helpText,
	          helpOnFocus: helpOnFocus,
	          leftIcon: false,
	          rightIcon: false
	        })
	      );
	    }
	  }]);
	
	  return SelectFieldToggle;
	}(_react.PureComponent);
	
	SelectFieldToggle.propTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  inputStyle: _propTypes2.default.object,
	  inputClassName: _propTypes2.default.string,
	  activeLabel: _propTypes2.default.node,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  required: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  label: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  active: _propTypes2.default.bool,
	  error: _propTypes2.default.bool,
	  errorText: _propTypes2.default.node,
	  helpText: _propTypes2.default.node,
	  helpOnFocus: _propTypes2.default.bool,
	  below: _propTypes2.default.bool,
	  visible: _propTypes2.default.bool
	};
	exports.default = SelectFieldToggle;
	//# sourceMappingURL=SelectFieldToggle.js.map

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectField = undefined;
	
	var _SelectField2 = __webpack_require__(175);
	
	var _SelectField3 = _interopRequireDefault(_SelectField2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SelectField3.default;
	exports.SelectField = _SelectField3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(17);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _controlled = __webpack_require__(16);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _getDeprecatedIcon = __webpack_require__(21);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _FontIcon = __webpack_require__(13);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _SelectionControl = __webpack_require__(64);
	
	var _SelectionControl2 = _interopRequireDefault(_SelectionControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Checkbox` component is used for the selection of multiple options from a set.
	 */
	var Checkbox = function (_PureComponent) {
	  _inherits(Checkbox, _PureComponent);
	
	  function Checkbox() {
	    _classCallCheck(this, Checkbox);
	
	    return _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
	  }
	
	  _createClass(Checkbox, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          checkedIcon = _props.checkedIcon,
	          uncheckedIcon = _props.uncheckedIcon,
	          checkedIconChildren = _props.checkedIconChildren,
	          checkedIconClassName = _props.checkedIconClassName,
	          uncheckedIconChildren = _props.uncheckedIconChildren,
	          uncheckedIconClassName = _props.uncheckedIconClassName,
	          props = _objectWithoutProperties(_props, ['checkedIcon', 'uncheckedIcon', 'checkedIconChildren', 'checkedIconClassName', 'uncheckedIconChildren', 'uncheckedIconClassName']);
	
	      var checked = (0, _getDeprecatedIcon2.default)(checkedIconClassName, checkedIconChildren, checkedIcon);
	      var unchecked = (0, _getDeprecatedIcon2.default)(uncheckedIconClassName, uncheckedIconChildren, uncheckedIcon);
	
	      return _react2.default.createElement(_SelectionControl2.default, _extends({
	        type: 'checkbox',
	        checkedCheckboxIcon: checked,
	        uncheckedCheckboxIcon: unchecked,
	        __superSecreteProp: true
	      }, props));
	    }
	  }]);
	
	  return Checkbox;
	}(_react.PureComponent);
	
	Checkbox.propTypes = {
	  /**
	   * An id to use with the checkbox. This is used for accessibility and so that the label
	   * triggers the checkbox toggle.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * An optional style to apply to the checkbox's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the checkbox's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * A label to display with the checkbox. This is required for accessibility and triggering
	   * the toggle.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * Boolean if the label should appear before the checkbox icon.
	   */
	  labelBefore: _propTypes2.default.bool,
	
	  /**
	   * A name to use for the `Checkbox`. This is required for accessibility. If the checkbox is
	   * part of a group, it is recommended to make this a string ending in `[]` so that the
	   * value can be found from `document.querySelector('input[name="someName[]"]').value`.
	   */
	  name: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * Boolean if the `Checkbox` is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when the `checked` state of the `Checkbox` changes.
	   * The callback will include the new checked state and the changeEvent.
	   *
	   * ```js
	   * onChange(changeEvent.target.checked, changeEvent);
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional value for the `Checkbox`. It is recommended to use a value though.
	   */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * Boolean if the `Checkbox` is checked by default.
	   */
	  defaultChecked: _propTypes2.default.bool,
	
	  /**
	   * A boolean if the `Checkbox` is currently checked. This will required the `onChange` prop
	   * to be defined.
	   */
	  checked: (0, _controlled2.default)(_propTypes2.default.bool, 'onChange', 'defaultChecked'),
	
	  /**
	   * Boolean if the `Checkbox` should be displayed inline.
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * The icon to display when the checkbox is checked.
	   */
	  checkedIcon: _propTypes2.default.node,
	
	  /**
	   * The icon to display when the checkbox is unchecked.
	   */
	  uncheckedIcon: _propTypes2.default.node,
	
	  checkedIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `checkedIcon` instead'),
	  checkedIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `checkedIcon` instead'),
	  uncheckedIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `uncheckedIcon` instead'),
	  uncheckedIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `uncheckedIcon` instead')
	};
	Checkbox.defaultProps = {
	  checkedIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'check_box'
	  ),
	  uncheckedIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'check_box_outline_blank'
	  )
	};
	exports.default = Checkbox;
	//# sourceMappingURL=Checkbox.js.map

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(17);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _getDeprecatedIcon = __webpack_require__(21);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _FontIcon = __webpack_require__(13);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _SelectionControl = __webpack_require__(64);
	
	var _SelectionControl2 = _interopRequireDefault(_SelectionControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Radio` component is used for the selection of a single option from a set. Unfortunately
	 * the `Radio` component must always be controlled because of the `FontIcon` toggles and how
	 * the `radio` input type works. It is recommended to use the `SelectionControlGroup` component
	 * to manage the `radio`.
	 */
	var Radio = function (_PureComponent) {
	  _inherits(Radio, _PureComponent);
	
	  function Radio() {
	    _classCallCheck(this, Radio);
	
	    return _possibleConstructorReturn(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).apply(this, arguments));
	  }
	
	  _createClass(Radio, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          checkedIcon = _props.checkedIcon,
	          uncheckedIcon = _props.uncheckedIcon,
	          checkedIconChildren = _props.checkedIconChildren,
	          checkedIconClassName = _props.checkedIconClassName,
	          uncheckedIconChildren = _props.uncheckedIconChildren,
	          uncheckedIconClassName = _props.uncheckedIconClassName,
	          props = _objectWithoutProperties(_props, ['checkedIcon', 'uncheckedIcon', 'checkedIconChildren', 'checkedIconClassName', 'uncheckedIconChildren', 'uncheckedIconClassName']);
	
	      var checked = (0, _getDeprecatedIcon2.default)(checkedIconClassName, checkedIconChildren, checkedIcon);
	      var unchecked = (0, _getDeprecatedIcon2.default)(uncheckedIconClassName, uncheckedIconChildren, uncheckedIcon);
	
	      return _react2.default.createElement(_SelectionControl2.default, _extends({
	        type: 'radio',
	        checkedCheckboxIcon: checked,
	        uncheckedCheckboxIcon: unchecked,
	        __superSecreteProp: true
	      }, props));
	    }
	  }]);
	
	  return Radio;
	}(_react.PureComponent);
	
	Radio.propTypes = {
	  /**
	   * An id to use with the radio. This is used for accessibility and so that the label
	   * triggers the radio toggle.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * An optional style to apply to the radio's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the radio's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * A label to display with the radio. This is required for accessibility and triggering
	   * the toggle.
	   */
	  label: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the label should appear before the radio icon.
	   */
	  labelBefore: _propTypes2.default.bool,
	
	  /**
	   * A name to use for the `Radio`. This is required for accessibility.
	   */
	  name: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * Boolean if the `Radio` is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * A function to call when the `Radio` triggers the `change` event. The `onChange` callback
	   * will include the current value of the checked `radio` and the change event.
	   *
	   * ```js
	   * onChange(changeEvent.target.value, changeEvent);
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * The value for the `Radio` component.
	   */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]).isRequired,
	
	  /**
	   * A boolean if the `Radio` is currently checked.
	   */
	  checked: _propTypes2.default.bool.isRequired,
	
	  /**
	   * Boolean if the `Radio` should be displayed inline.
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * The icon to display when the radio is checked/selected.
	   */
	  checkedIcon: _propTypes2.default.node.isRequired,
	
	  /**
	   * The icon to display when the radio is not checked/selected.
	   */
	  uncheckedIcon: _propTypes2.default.node.isRequired,
	  checkedIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `checkedIcon` instead'),
	  checkedIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `checkedIcon` instead'),
	  uncheckedIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `uncheckedIcon` instead'),
	  uncheckedIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `uncheckedIcon` instead')
	};
	Radio.defaultProps = {
	  checkedIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'radio_button_checked'
	  ),
	  uncheckedIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'radio_button_unchecked'
	  )
	};
	exports.default = Radio;
	//# sourceMappingURL=Radio.js.map

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _SelectionControlGroup = __webpack_require__(283);
	
	var _SelectionControlGroup2 = _interopRequireDefault(_SelectionControlGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars, no-shadow */
	
	
	// This will still work, but generate a lot of warnings
	
	/**
	 * The `RadioGroup` component is a state manager for the `Radio` component.
	 * It will automatically inject the name, an onChange function, and
	 * determine whether a radio is checked.
	 *
	 * This is just a simple wrapper to reduce some prop redundancy.
	 */
	var RadioGroup = function (_PureComponent) {
	  _inherits(RadioGroup, _PureComponent);
	
	  function RadioGroup() {
	    _classCallCheck(this, RadioGroup);
	
	    return _possibleConstructorReturn(this, (RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).apply(this, arguments));
	  }
	
	  _createClass(RadioGroup, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['children']);
	
	      delete props.id;
	      delete props.defaultValue;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          defaultValue = _props2.defaultValue;
	
	      if (!id) {
	        id = props.name + '-radios-unique-please';
	      }
	
	      if (typeof props.value === 'undefined') {
	        if (typeof defaultValue === 'undefined') {
	          defaultValue = _react.Children.map(children, function (_ref) {
	            var value = _ref.props.value;
	            return value;
	          })[0];
	        }
	      }
	
	      var controls = _react.Children.map(children, function (radio) {
	        var props = Object.assign({}, radio.props);
	        delete props.checkedIcon;
	        delete props.uncheckedIcon;
	        delete props.checkedIconChildren;
	        delete props.checkedIconClassName;
	        delete props.uncheckedIconChildren;
	        delete props.uncheckedIconClassName;
	        return _extends({}, props);
	      });
	      return _react2.default.createElement(_SelectionControlGroup2.default, _extends({}, props, { id: id, defaultValue: defaultValue, type: 'radio', controls: controls }));
	    }
	  }]);
	
	  return RadioGroup;
	}(_react.PureComponent);
	
	RadioGroup.propTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  defaultValue: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.arrayOf(_propTypes2.default.node).isRequired,
	  inline: _propTypes2.default.bool,
	  onChange: _propTypes2.default.func,
	  name: _propTypes2.default.string,
	  value: _propTypes2.default.string,
	
	  _deprecated: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use the `SelectionControlGroup` component instead')
	};
	exports.default = RadioGroup;
	//# sourceMappingURL=RadioGroup.js.map

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(17);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _controlled = __webpack_require__(16);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _SelectionControl = __webpack_require__(64);
	
	var _SelectionControl2 = _interopRequireDefault(_SelectionControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Switch = function (_PureComponent) {
	  _inherits(Switch, _PureComponent);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).apply(this, arguments));
	  }
	
	  _createClass(Switch, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          toggled = _props.toggled,
	          defaultToggled = _props.defaultToggled,
	          props = _objectWithoutProperties(_props, ['toggled', 'defaultToggled']);
	
	      if (typeof toggled !== 'undefined' && typeof props.checked === 'undefined') {
	        props.checked = toggled;
	      }
	
	      if (typeof defaultToggled !== 'undefined' && typeof props.defaultChecked === 'undefined') {
	        props.defaultChecked = defaultToggled;
	      }
	
	      return _react2.default.createElement(_SelectionControl2.default, _extends({ type: 'switch' }, props, { __superSecreteProp: true }));
	    }
	  }]);
	
	  return Switch;
	}(_react.PureComponent);
	
	Switch.propTypes = {
	  /**
	   * An id to use with the switch. This is used for accessibility and so that the label
	   * triggers the switch toggle.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * An optional style to apply to the switch's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the switch's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * A label to display with the switch. This is required for accessibility and triggering
	   * the toggle.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * Boolean if the label should appear before the switch.
	   */
	  labelBefore: _propTypes2.default.bool,
	
	  /**
	   * A name to use for the `Switch`. This is required for accessibility since behind the scenes
	   * the `Switch` is renders as an `<input type="checkbox" />`.
	   */
	  name: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * Boolean if the `Switch` is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when the `checked` state of the `Switch` changes.
	   * The callback will include the new checked state and the changeEvent.
	   *
	   * ```js
	   * onChange(changeEvent.target.checked, changeEvent);
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional value for the `Switch`. It is recommended to use a value though.
	   */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * Boolean if the `Switch` is checked by default.
	   */
	  defaultChecked: _propTypes2.default.bool,
	
	  /**
	   * A boolean if the `Switch` is currently checked. This will required the `onChange` prop
	   * to be defined.
	   */
	  checked: (0, _controlled2.default)(_propTypes2.default.bool, 'onChange', 'defaultChecked'),
	
	  defaultToggled: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use the `defaultChecked` prop instead'),
	  toggled: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use the `checked` prop instead')
	};
	exports.default = Switch;
	//# sourceMappingURL=Switch.js.map

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AccessibleFakeInkedButton = __webpack_require__(29);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DISABLED_INTERACTIONS = ['mouse'];
	
	/**
	 * This is the `Thumb` for the switch. The `ink` in the Thumb is only active on touch and keyboard
	 * interactions, so the `AccessibleFakeInkButton` does not work for this case.
	 *
	 * This component really just is used for custom inkage.
	 */
	
	var SwitchThumb = function (_PureComponent) {
	  _inherits(SwitchThumb, _PureComponent);
	
	  function SwitchThumb() {
	    _classCallCheck(this, SwitchThumb);
	
	    return _possibleConstructorReturn(this, (SwitchThumb.__proto__ || Object.getPrototypeOf(SwitchThumb)).apply(this, arguments));
	  }
	
	  _createClass(SwitchThumb, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          disabled = _props.disabled,
	          checked = _props.checked,
	          className = _props.className,
	          disabledInteractions = _props.disabledInteractions,
	          props = _objectWithoutProperties(_props, ['disabled', 'checked', 'className', 'disabledInteractions']);
	
	      return _react2.default.createElement(_AccessibleFakeInkedButton2.default, _extends({}, props, {
	        disabled: disabled,
	        disabledInteractions: disabledInteractions || DISABLED_INTERACTIONS,
	        inkContainerClassName: 'md-ink-container--2x',
	        className: (0, _classnames2.default)('md-switch-thumb', {
	          'md-switch-thumb--disabled': disabled,
	          'md-switch-thumb--on': checked,
	          'md-switch-thumb--off': !checked
	        }, className)
	      }));
	    }
	  }]);
	
	  return SwitchThumb;
	}(_react.PureComponent);
	
	SwitchThumb.propTypes = {
	  className: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  checked: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  disabledInteractions: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['keyboard', 'touch', 'mouse']))
	};
	exports.default = SwitchThumb;
	//# sourceMappingURL=SwitchThumb.js.map

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SwitchThumb = __webpack_require__(633);
	
	var _SwitchThumb2 = _interopRequireDefault(_SwitchThumb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SwitchTrack = function (_PureComponent) {
	  _inherits(SwitchTrack, _PureComponent);
	
	  function SwitchTrack() {
	    _classCallCheck(this, SwitchTrack);
	
	    return _possibleConstructorReturn(this, (SwitchTrack.__proto__ || Object.getPrototypeOf(SwitchTrack)).apply(this, arguments));
	  }
	
	  _createClass(SwitchTrack, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          disabled = _props.disabled,
	          checked = _props.checked,
	          className = _props.className,
	          inkDisabled = _props.inkDisabled,
	          disabledInteractions = _props.disabledInteractions,
	          props = _objectWithoutProperties(_props, ['disabled', 'checked', 'className', 'inkDisabled', 'disabledInteractions']);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, {
	          className: (0, _classnames2.default)('md-switch-track', {
	            'md-pointer--hover': !disabled,
	            'md-switch-track--disabled': disabled,
	            'md-switch-track--on': checked,
	            'md-switch-track--off': !checked
	          }, className)
	        }),
	        _react2.default.createElement(_SwitchThumb2.default, {
	          disabled: disabled,
	          checked: checked,
	          onClick: props.onClick,
	          inkDisabled: inkDisabled,
	          disabledInteractions: disabledInteractions
	        })
	      );
	    }
	  }]);
	
	  return SwitchTrack;
	}(_react.PureComponent);
	
	SwitchTrack.propTypes = {
	  className: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  checked: _propTypes2.default.bool,
	  inkDisabled: _propTypes2.default.bool,
	  disabledInteractions: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['keyboard', 'touch', 'mouse']))
	};
	exports.default = SwitchTrack;
	//# sourceMappingURL=SwitchTrack.js.map

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Switch = exports.RadioGroup = exports.Radio = exports.Checkbox = exports.SelectionControlGroup = exports.SelectionControl = undefined;
	
	var _SelectionControl2 = __webpack_require__(64);
	
	var _SelectionControl3 = _interopRequireDefault(_SelectionControl2);
	
	var _SelectionControlGroup2 = __webpack_require__(283);
	
	var _SelectionControlGroup3 = _interopRequireDefault(_SelectionControlGroup2);
	
	var _Checkbox2 = __webpack_require__(629);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Radio2 = __webpack_require__(630);
	
	var _Radio3 = _interopRequireDefault(_Radio2);
	
	var _RadioGroup2 = __webpack_require__(631);
	
	var _RadioGroup3 = _interopRequireDefault(_RadioGroup2);
	
	var _Switch2 = __webpack_require__(632);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SelectionControl3.default;
	exports.SelectionControl = _SelectionControl3.default;
	exports.SelectionControlGroup = _SelectionControlGroup3.default;
	exports.Checkbox = _Checkbox3.default;
	exports.Radio = _Radio3.default;
	exports.RadioGroup = _RadioGroup3.default;
	exports.Switch = _Switch3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Drawer = __webpack_require__(170);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _componentDeprecated = __webpack_require__(47);
	
	var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Sidebar = function (_PureComponent) {
	  _inherits(Sidebar, _PureComponent);
	
	  function Sidebar() {
	    _classCallCheck(this, Sidebar);
	
	    return _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).apply(this, arguments));
	  }
	
	  _createClass(Sidebar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isOpen = _props.isOpen,
	          header = _props.header,
	          overlay = _props.overlay,
	          children = _props.children,
	          onOverlayClick = _props.onOverlayClick,
	          align = _props.align,
	          items = _props.items,
	          fixed = _props.fixed,
	          props = _objectWithoutProperties(_props, ['isOpen', 'header', 'overlay', 'children', 'onOverlayClick', 'align', 'items', 'fixed']);
	
	      delete props.responsive;
	
	      return _react2.default.createElement(
	        _Drawer2.default,
	        _extends({}, props, {
	          visible: isOpen,
	          onVisibilityChange: onOverlayClick,
	          navItems: items,
	          position: align,
	          overflay: overlay,
	          header: header,
	          inline: !fixed
	        }),
	        children
	      );
	    }
	  }]);
	
	  return Sidebar;
	}(_react.PureComponent);
	
	Sidebar.propTypes = {
	  deprecated: (0, _componentDeprecated2.default)('All the functionality and responsiveness of a `Sidebar` can be handled by the `Drawer` instead.' + ' Switch to the `Drawer` component instead.'),
	
	  /**
	   * Boolean if the overlay should appear when opened.
	   */
	  overlay: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the sidebar is visible and open.
	   */
	  isOpen: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the sidebar is fixed to the side of the page.
	   */
	  fixed: _propTypes2.default.bool,
	
	  /**
	   * Boolean if sidebar should be responsive.
	   */
	  responsive: _propTypes2.default.bool,
	
	  /**
	   * An optional header to display above the children or list items.
	   */
	  header: _propTypes2.default.node,
	
	  /**
	   * Any children to display after the generated list of items.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The transition name to use for the overlay.
	   */
	  transitionName: _propTypes2.default.string,
	
	  /**
	   * The enter timeout for the overlay transition.
	   */
	  transitionEnterTimeout: _propTypes2.default.number,
	
	  /**
	   * The leave timeout for the overlay transition.
	   */
	  transitionLeaveTimeout: _propTypes2.default.number,
	
	  /**
	   * An optional function to call when the overlay is clicked.
	   * This should normally close the sidebar.
	   */
	  onOverlayClick: _propTypes2.default.func,
	
	  /**
	   * The position to align the sidebar of the screen to.
	   */
	  align: _propTypes2.default.oneOf(['left', 'right']),
	
	  /**
	   * A list of item props to convert into `ListItem`, `Divider`, or
	   * `Subheader` components.
	   *
	   * ##### Item Descriptions
	   */
	  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    /**
	     * Boolean if this item is a divider.
	     */
	    divider: _propTypes2.default.bool,
	
	    /**
	     * Boolean if this item is a subheader.
	     */
	    subheader: _propTypes2.default.bool,
	
	    /**
	     * The primary text to display in a `ListItem` or a `Subheader`.
	     */
	    primaryText: _propTypes2.default.node
	  }))
	};
	Sidebar.defaultProps = {
	  align: 'left'
	};
	exports.default = Sidebar;
	//# sourceMappingURL=Sidebar.js.map

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Sidebar = __webpack_require__(636);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Sidebar2.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DiscreteValue = function (_PureComponent) {
	  _inherits(DiscreteValue, _PureComponent);
	
	  function DiscreteValue() {
	    _classCallCheck(this, DiscreteValue);
	
	    return _possibleConstructorReturn(this, (DiscreteValue.__proto__ || Object.getPrototypeOf(DiscreteValue)).apply(this, arguments));
	  }
	
	  _createClass(DiscreteValue, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          discrete = _props.discrete,
	          dragging = _props.dragging,
	          thumbLeft = _props.thumbLeft,
	          active = _props.active,
	          value = _props.value,
	          valuePrecision = _props.valuePrecision,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'discrete', 'dragging', 'thumbLeft', 'active', 'value', 'valuePrecision']);
	
	      if (!discrete || !active) {
	        return null;
	      }
	
	      var valueStr = value.toFixed(valuePrecision);
	      if (valuePrecision > 0) {
	        var _valueStr$split = valueStr.split('.'),
	            _valueStr$split2 = _slicedToArray(_valueStr$split, 2),
	            w = _valueStr$split2[0],
	            d = _valueStr$split2[1];
	
	        if (parseInt(d, 10) === 0) {
	          valueStr = w;
	        }
	      }
	      return _react2.default.createElement(
	        'span',
	        _extends({}, props, {
	          style: Object.assign({}, style, { left: thumbLeft }),
	          className: (0, _classnames2.default)('md-slider-discrete-value', className, {
	            'md-slider-discrete-value--dragging': dragging
	          })
	        }),
	        valueStr
	      );
	    }
	  }]);
	
	  return DiscreteValue;
	}(_react.PureComponent);
	
	DiscreteValue.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  discrete: _propTypes2.default.bool,
	  dragging: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	  value: _propTypes2.default.number.isRequired,
	  thumbLeft: _propTypes2.default.string.isRequired,
	  valuePrecision: _propTypes2.default.number.isRequired
	};
	exports.default = DiscreteValue;
	//# sourceMappingURL=DiscreteValue.js.map

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(17);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _keyCodes = __webpack_require__(15);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _isValidClick = __webpack_require__(177);
	
	var _isValidClick2 = _interopRequireDefault(_isValidClick);
	
	var _touches = __webpack_require__(84);
	
	var _calculateValueDistance = __webpack_require__(674);
	
	var _calculateValueDistance2 = _interopRequireDefault(_calculateValueDistance);
	
	var _isWithinStep = __webpack_require__(675);
	
	var _isWithinStep2 = _interopRequireDefault(_isWithinStep);
	
	var _controlled = __webpack_require__(16);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _SliderLabel = __webpack_require__(640);
	
	var _SliderLabel2 = _interopRequireDefault(_SliderLabel);
	
	var _Track = __webpack_require__(643);
	
	var _Track2 = _interopRequireDefault(_Track);
	
	var _TextField = __webpack_require__(65);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Slider` component is used to let users select a value from a continuous
	 * or discrete range of values by moving the slider thumb.
	 *
	 * When the user has finished dragging the Slider or increments the value by using
	 * the edit field/keyboard arrows, the value will be rounded to the nearest `step`.
	 */
	var Slider = function (_PureComponent) {
	  _inherits(Slider, _PureComponent);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var min = props.min,
	        max = props.max,
	        step = props.step;
	
	    var scale = Math.abs(max - min) / step;
	
	    var value = typeof props.value !== 'undefined' ? props.value : props.defaultValue;
	
	    if (typeof value === 'undefined') {
	      value = min;
	    }
	
	    var distance = _this._calcDistance(value, min, max);
	    var thumbLeft = _this._calcLeft(distance);
	    var trackFillWidth = distance + '%';
	
	    if (typeof props.value !== 'undefined') {
	      value = undefined;
	    }
	
	    var trackWidth = void 0;
	    if (props.label && !props.editable && !props.leftIcon && !props.rightIcon) {
	      trackWidth = '100%';
	    }
	
	    _this.state = {
	      value: value,
	      scale: scale,
	      distance: distance,
	      thumbLeft: thumbLeft,
	      trackWidth: trackWidth,
	      trackFillWidth: trackFillWidth,
	      active: false,
	      dragging: false,
	      maskInked: false
	    };
	    _this._dragAdded = false;
	    return _this;
	  }
	
	  _createClass(Slider, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          leftIcon = _props.leftIcon,
	          rightIcon = _props.rightIcon,
	          label = _props.label,
	          min = _props.min,
	          max = _props.max,
	          step = _props.step,
	          value = _props.value;
	
	      if (value !== nextProps.value) {
	        var distance = this._calcDistance(nextProps.value, nextProps.min, nextProps.max);
	        this.setState({ distance: distance, trackFillWidth: distance + '%', thumbLeft: this._calcLeft(distance) });
	      }
	
	      if (leftIcon !== nextProps.leftIcon || rightIcon !== nextProps.rightIcon || label !== nextProps.label) {
	        this._calcTrackWidth(nextProps);
	      }
	
	      if (min !== nextProps.min || max !== nextProps.max || step !== nextProps.step) {
	        this.setState({ scale: Math.abs(nextProps.max - nextProps.min) / nextProps.step });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _state = this.state,
	          active = _state.active,
	          manualIncrement = _state.manualIncrement;
	
	      var fn = window[(active ? 'add' : 'remove') + 'EventListener'];
	      if (active !== prevState.active) {
	        fn('click', this._blurOnOutsideClick);
	
	        if (active) {
	          this._focusThumb();
	        }
	      }
	
	      var addDrag = active && !manualIncrement;
	      fn = window[(addDrag ? 'add' : 'remove') + 'EventListener'];
	      if (this._dragAdded !== addDrag) {
	        fn('mousemove', this._handleDragMove);
	        fn('mouseup', this._handleDragEnd);
	        (0, _touches.setTouchEvent)(addDrag, window, 'move', this._handleDragMove);
	        (0, _touches.setTouchEvent)(addDrag, window, 'end', this._handleDragEnd);
	
	        this._dragAdded = addDrag;
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var rm = window.removeEventListener;
	      rm('click', this._blurOnOutsideClick);
	      rm('mousemove', this._handleMouseMove);
	      rm('mouseup', this._handleMouseUp);
	      (0, _touches.removeTouchEvent)(window, 'move', this._handleDragMove);
	      (0, _touches.removeTouchEvent)(window, 'end', this._handleDragEnd);
	
	      if (this._inkTimeout) {
	        clearTimeout(this._inkTimeout);
	      }
	
	      if (this._focusTimeout) {
	        clearTimeout(this._focusTimeout);
	      }
	    }
	
	    /**
	     * Gets the `left` position for the thumb based on the value given.
	     *
	     * @param {number} value - The current value.
	     * @return {string} the `calc` string.
	     */
	
	  }, {
	    key: '_calcLeft',
	    value: function _calcLeft(value) {
	      return 'calc(' + value + '% - 6px)';
	    }
	  }, {
	    key: '_calcDistance',
	    value: function _calcDistance(value, min, max) {
	      return Math.max(0, Math.min(100, (value - min) / (max - min) * 100));
	    }
	
	    /**
	     * Checks if a classList does not contain all the *bad* class names.
	     *
	     * @param {function} classList - The classList to check.
	     * @return {Boolean} true if the classList does not contain any of the *bad* class names.
	     */
	
	  }, {
	    key: '_isValidClassList',
	    value: function _isValidClassList(classList) {
	      var invalid = false;
	      ['md-slider-label', 'md-slider-ind', 'md-icon'].some(function (cl) {
	        invalid = classList.contains(cl);
	        return invalid;
	      });
	
	      return !invalid;
	    }
	  }, {
	    key: '_isInTextField',
	    value: function _isInTextField(e) {
	      var className = e.target.className;
	
	      // SVG's className is an object instead of a string
	
	      return typeof className.match === 'function' && className.match(/text-field/);
	    }
	
	    /**
	     * Checks if the target is within the text field container.
	     *
	     * @param {Object} target - The event target.
	     * @return {Boolean} true if the target is in the text field.
	     */
	
	
	    /**
	     * Updates the slider's thumb position and the slider's track fill width based
	     * on the thumb's current x position on the screen.
	     *
	     * The slider distance will be *normalized* when:
	     *  - The user does a quick jump
	     *  - The user stops dragging with the mouse
	     *  - The user drops dragging with touch
	     *
	     * If the position is not *normalized*, the `onDragChange` prop will be called
	     * with the new distance percentage, the value, and the move event.
	     *
	     * The `onChange` function will always be called.
	     *
	     * @param {Object} e - The current event to extract an x location from
	     * @param {bool} normalize - Boolean if the distance should be normalized
	     *    to the current scale of the slider.
	     */
	
	
	    /**
	     * This will either allow a user to start dragging the slider or quickly
	     * jump to a new value on the slider if the slider is not disabled.
	     *
	     * This will handle the `touchstart` and `mousedown` events.
	     *
	     * @param {Object} e - The touchstart or mousedown event.
	     */
	
	
	    /**
	     * This will set the active state of the slider to false if the user
	     * clicks outside of the slider's container.
	     *
	     * @param {Object} e - The window's click event.
	     */
	
	
	    /**
	     * Updates the slider with the `step` prop and calls the `onChange`
	     * function with the new value.
	     *
	     * @param {number} incrementedValue - The newly incremented value of the slider.
	     * @param {Object} e - Either the text field's change event, mouse down event, or
	     *    touch start event.
	     * @param {bool} disableTransition - Boolean if the jump's transition should be disabled.
	     */
	
	
	    /**
	     * This will increment the Slider's value by the `step` prop. If the left or
	     * right key arrow is pressed.
	     *
	     * @param {Object} e - the keydown event.
	     */
	
	
	    /**
	     * This function will animate the discrete Slider's ink if it gains focus
	     * by a tab event.
	     *
	     * @param {Object} e - the key up event.
	     */
	
	
	    /**
	     * For some reason the width of the track gets set to 0 if the `Slider` has a label and
	     * does not include the `leftIcon`, `rightIcon`, and is not `editable` OR it is
	     * `editable` and does not include the `leftIcon`. All other cases the width works
	     * correctly.
	     *
	     * This function just checks these things, and sets the width accordingly.
	     */
	
	
	    /**
	     * The ink for a Discrete slider is only visible for a short time on initial
	     * focus. This function will handle the in/out transitions.
	     */
	
	
	    /**
	     * This is a helper function for focusing the Slider's thumb component. There
	     * is a short delay because the body sometimes gets focused immediately after
	     * if there is no timeout..
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          dragging = _state2.dragging,
	          active = _state2.active,
	          thumbLeft = _state2.thumbLeft,
	          trackFillWidth = _state2.trackFillWidth,
	          maskInked = _state2.maskInked,
	          trackWidth = _state2.trackWidth,
	          scale = _state2.scale,
	          distance = _state2.distance;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          min = _props2.min,
	          max = _props2.max,
	          disabled = _props2.disabled,
	          className = _props2.className,
	          trackStyle = _props2.trackStyle,
	          trackClassName = _props2.trackClassName,
	          thumbStyle = _props2.thumbStyle,
	          thumbClassName = _props2.thumbClassName,
	          discreteValueStyle = _props2.discreteValueStyle,
	          discreteValueClassName = _props2.discreteValueClassName,
	          label = _props2.label,
	          editable = _props2.editable,
	          step = _props2.step,
	          inputWidth = _props2.inputWidth,
	          leftIcon = _props2.leftIcon,
	          rightIcon = _props2.rightIcon,
	          discrete = _props2.discrete,
	          discreteTicks = _props2.discreteTicks,
	          tickWidth = _props2.tickWidth,
	          valuePrecision = _props2.valuePrecision,
	          propValue = _props2.value,
	          onChange = _props2.onChange,
	          onDragChange = _props2.onDragChange,
	          discreteInkTransitionTime = _props2.discreteInkTransitionTime,
	          stepPrecision = _props2.stepPrecision,
	          props = _objectWithoutProperties(_props2, ['id', 'min', 'max', 'disabled', 'className', 'trackStyle', 'trackClassName', 'thumbStyle', 'thumbClassName', 'discreteValueStyle', 'discreteValueClassName', 'label', 'editable', 'step', 'inputWidth', 'leftIcon', 'rightIcon', 'discrete', 'discreteTicks', 'tickWidth', 'valuePrecision', 'value', 'onChange', 'onDragChange', 'discreteInkTransitionTime', 'stepPrecision']);
	
	      var value = (0, _getField2.default)(this.props, this.state);
	      var rightChildren = rightIcon;
	      if (editable) {
	        rightChildren = _react2.default.createElement(_TextField2.default, {
	          id: id + '-editor',
	          ref: this._setField,
	          type: 'number',
	          value: value,
	          inputClassName: 'md-slider-editor',
	          style: { width: inputWidth },
	          onChange: this._handleTextFieldChange,
	          step: step
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, {
	          ref: this._setNode,
	          className: (0, _classnames2.default)('md-slider-container', className, {
	            'md-pointer--hover': !disabled
	          }),
	          onMouseDown: this._handleDragStart,
	          onTouchStart: this._handleDragStart
	        }),
	        _react2.default.createElement(
	          _SliderLabel2.default,
	          { htmlFor: id },
	          label
	        ),
	        _react2.default.createElement('input', {
	          id: id,
	          type: 'range',
	          className: 'md-slider-input',
	          readOnly: true,
	          min: min,
	          max: max,
	          value: value,
	          disabled: disabled
	        }),
	        leftIcon,
	        _react2.default.createElement(_Track2.default, {
	          ref: this._setTrack,
	          style: Object.assign({}, trackStyle, { width: trackWidth }),
	          className: (0, _classnames2.default)(trackClassName, {
	            'md-slider-track--ind-left': leftIcon,
	            'md-slider-track--ind-right': rightIcon
	          }),
	          thumbStyle: thumbStyle,
	          thumbClassName: thumbClassName,
	          discreteValueStyle: discreteValueStyle,
	          discreteValueClassName: discreteValueClassName,
	          active: active,
	          dragging: dragging,
	          disabled: disabled,
	          thumbLeft: thumbLeft,
	          trackFillWidth: trackFillWidth,
	          on: !disabled && distance > 0,
	          off: distance === 0,
	          maskInked: maskInked,
	          onThumbKeyUp: this._handleKeyUp,
	          onThumbKeyDown: this._handleKeyDown,
	          onThumbFocus: this._handleFocus,
	          discrete: discrete,
	          tickWidth: tickWidth,
	          discreteTicks: discreteTicks,
	          valuePrecision: valuePrecision,
	          step: step,
	          scale: scale,
	          value: value
	        }),
	        rightChildren
	      );
	    }
	  }]);
	
	  return Slider;
	}(_react.PureComponent);
	
	Slider.propTypes = {
	  /**
	   * An id to use for the `Slider`. This is required if the `label` prop
	   * is defined.
	   */
	  id: function id(props, propName, component) {
	    for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      others[_key - 3] = arguments[_key];
	    }
	
	    if (typeof props.label === 'undefined') {
	      return _propTypes2.default.string.apply(_propTypes2.default, [props, propName, component].concat(others));
	    }
	
	    return (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])).apply(undefined, [props, propName, component].concat(others));
	  },
	
	  /**
	   * An optional style to apply to the slider's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the slider's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the slider's thumb.
	   */
	  thumbStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the slider's thumb.
	   */
	  thumbClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the slider's track.
	   */
	  trackStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the slider's track.
	   */
	  trackClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the slider's track fill.
	   */
	  trackFillStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the slider's track fill.
	   */
	  trackFillClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to a discrete slider's value.
	   */
	  discreteValueStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to a discrete slider's value.
	   */
	  discreteValueClassName: _propTypes2.default.string,
	
	  /**
	   * The default value for the slider. This number must be between the min and max values if
	   * defined. If this is undefined, it's value will be set to the min value.
	   */
	  defaultValue: _propTypes2.default.number,
	
	  /**
	   * The min value for the slider. This value **must** be less than the `max` value.
	   */
	  min: function min(props, propName, component) {
	    for (var _len2 = arguments.length, others = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	      others[_key2 - 3] = arguments[_key2];
	    }
	
	    var _PropTypes$number;
	
	    var err = (_PropTypes$number = _propTypes2.default.number).isRequired.apply(_PropTypes$number, [props, propName, component].concat(others));
	    if (!err) {
	      var min = props[propName];
	      var name = void 0;
	      if (min > props.value) {
	        name = 'value';
	      } else if (typeof props.defaultValue !== 'undefined' && min > props.defaultValue) {
	        name = 'defaultValue';
	      }
	
	      if (name) {
	        err = new Error('The \'' + propName + '\' prop must be less than or equal to the \'' + name + '\' prop for the \'' + component + '\' but ' + ('received: \'min: ' + min + '\' and \'' + name + ': ' + props[name] + '\''));
	      }
	    }
	
	    return err;
	  },
	
	  /**
	   * The max value for the slider. This value **must** be greater than the `min` value.
	   */
	  max: function max(props, propName, component) {
	    for (var _len3 = arguments.length, others = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
	      others[_key3 - 3] = arguments[_key3];
	    }
	
	    var _PropTypes$number2;
	
	    var err = (_PropTypes$number2 = _propTypes2.default.number).isRequired.apply(_PropTypes$number2, [props, propName, component].concat(others));
	    if (!err) {
	      var max = props[propName];
	      var name = void 0;
	      if (max < props.value) {
	        name = 'value';
	      } else if (max < props.defaultValue) {
	        name = 'defaultValue';
	      }
	
	      if (name) {
	        err = new Error('The \'' + propName + '\' prop must be greater than or equal to the \'' + name + '\' prop for the \'' + component + '\' but ' + ('received: \'' + propName + ': ' + max + '\' and \'' + name + ': ' + props[name] + '\''));
	      }
	    }
	
	    return err;
	  },
	
	  /**
	   * Boolean if the slider is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional value for the slider. This will make the component controlled
	   * and require the `onChange` function.
	   */
	  value: (0, _controlled2.default)(_propTypes2.default.number, 'onChange'),
	
	  /**
	   * This is called when the slider's value gets updated. The value can be updated
	   * by one of the following:
	   *
	   * - Clicking a section of the slider
	   * - Dragging the slider with the mouse
	   * - Touching a section of the slider.
	   * - Dragging the slider with touch
	   * - Using the text field to update the value either by typing or incrementing
	   * - Using the left or right arrow keys to increment/decrement the value.
	   *
	   * The callback for this function is as follows:
	   *
	   * ```js
	   * onChange(value, event);
	   * ```
	   *
	   * where the event can either be:
	   * - a touch start event
	   * - a touch move event
	   * - a touch end event
	   * - a mouse down event
	   * - a mouse move event
	   * - a mouse up event
	   * - a key up event
	   * - a key down event
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * This is only called when the user is dragging the slider with either
	   * the mouse or touch. Probably not really useful. It just includes the
	   * new drag percentage while the `onChange` does not.
	   *
	   * The callback for this function is defined as:
	   *
	   * ```js
	   * onDragChange(dragPercentage, value, (touchMove || mouseMove) event);
	   * ```
	   */
	  onDragChange: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the slider's container has
	   * the mousedown event.
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the slider's container has
	   * the touchstart event.
	   */
	  onTouchStart: _propTypes2.default.func,
	
	  /**
	   * An optional icon or letter to place to the left of the slider.
	   * if you want to use a non-font icon or a letter, use the `md-slider-ind`
	   * className on your element.
	   */
	  leftIcon: _propTypes2.default.element,
	
	  /**
	   * An optional icon or letter to place to the right of the slider.
	   * if you want to use a non-font icon or a letter, use the `md-slider-ind`
	   * className on your element.
	   *
	   * > NOTE: This can not be used if the `editable` prop is true.
	   */
	  rightIcon: _propTypes2.default.element,
	
	  /**
	   * An optional label to display above the slider. If this prop
	   * is set, then an `id` must also be given.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * The incremental amount when the user hits left or right with the
	   * keyboard arrows, or the user hits the up or down buttons in the
	   * editable number text field. This number must be a number between
	   * 0 and 1 or a whole number above 1.
	   */
	  step: function step(props, propName, component) {
	    for (var _len4 = arguments.length, others = Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
	      others[_key4 - 3] = arguments[_key4];
	    }
	
	    var _PropTypes$number3;
	
	    var err = (_PropTypes$number3 = _propTypes2.default.number).isRequired.apply(_PropTypes$number3, [props, propName, component].concat(others));
	    if (!err) {
	      var step = props[propName];
	      if (step <= 0) {
	        err = new Error('The \'' + propName + '\' for the \'' + component + '\' must be a number greater than 0. The ' + ('current value is \'' + step + '\'.'));
	      } else {
	        var valueDefined = typeof props.value !== 'undefined';
	        var defaultDefined = typeof props.defaultValue !== 'undefined';
	        var value = props.value;
	        if (!valueDefined) {
	          value = defaultDefined ? props.defaultValue : props.min;
	        }
	
	        var name = void 0;
	        if (!(0, _isWithinStep2.default)(value, step)) {
	          if (valueDefined) {
	            name = 'value';
	          } else if (defaultDefined) {
	            name = 'defaultValue';
	          } else {
	            name = 'min';
	          }
	        }
	
	        if (name) {
	          err = new Error('The \'' + name + '\' prop on \'' + component + '\' should be a number divisible by the ' + ('\'' + propName + '\' prop. The current value is \'' + props[name] + '\' and the \'' + propName + '\' ') + ('is \'' + step + '\'.'));
	        }
	      }
	    }
	
	    return err;
	  },
	
	  /**
	   * Boolean if the Slider should be editable. This will place a number text field
	   * to the right of the slider. If this prop is set to `true`, the `rightIcon`
	   * prop can not be set.
	   */
	  editable: function editable(props, propName, component) {
	    for (var _len5 = arguments.length, others = Array(_len5 > 3 ? _len5 - 3 : 0), _key5 = 3; _key5 < _len5; _key5++) {
	      others[_key5 - 3] = arguments[_key5];
	    }
	
	    var _PropTypes$bool;
	
	    if (typeof props[propName] === 'undefined') {
	      return null;
	    }
	
	    var err = (_PropTypes$bool = _propTypes2.default.bool).isRequired.apply(_PropTypes$bool, [props, propName, component].concat(others));
	    if (!err && typeof props.rightIcon !== 'undefined') {
	      err = new Error('The \'' + component + '\' is unable to be \'editable\' and include a \'rightIcon\'.');
	    }
	
	    return err;
	  },
	
	  /**
	   * The width for the number text field when the Slider is editable.
	   */
	  inputWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	
	  /**
	   * Boolean if the slider should be discrete. This will update the slider to include a
	   * _balloon_ with the current value inside. It will also not allow the `Slider` to be
	   * editable.
	   */
	  discrete: function discrete(props, propName, component) {
	    for (var _len6 = arguments.length, others = Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++) {
	      others[_key6 - 3] = arguments[_key6];
	    }
	
	    if (typeof props[propName] === 'undefined') {
	      return null;
	    }
	
	    var err = _propTypes2.default.bool.apply(_propTypes2.default, [props, propName, component].concat(others));
	    if (!err && typeof props.editable !== 'undefined') {
	      err = new Error('The \'' + component + '\' cannot be \'discrete\' and \'editable\'. Please choose one.');
	    }
	
	    return err;
	  },
	
	  /**
	   * The width of each tick for a discrete slider with ticks. This can either be a number
	   * which gets converted to `px`, or a valid CSS unit.
	   */
	  tickWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	
	  /**
	   * This is number divisible by the total number of values included in the Slider. Every
	   * value that is divisible by this number will include a tick mark. It is common recommended
	   * to have this equal to the `step` prop.
	   *
	   * This prop is completely optional.
	   */
	  discreteTicks: function discreteTicks(props, propName, component) {
	    for (var _len7 = arguments.length, others = Array(_len7 > 3 ? _len7 - 3 : 0), _key7 = 3; _key7 < _len7; _key7++) {
	      others[_key7 - 3] = arguments[_key7];
	    }
	
	    if (typeof props[propName] === 'undefined') {
	      return null;
	    }
	
	    var err = _propTypes2.default.number.apply(_propTypes2.default, [props, propName, component].concat(others));
	    if (!err) {
	      var min = props.min,
	          max = props.max,
	          step = props.step;
	
	      var range = Math.abs(max - min);
	
	      if (range / props[propName] % 1 !== 0) {
	        err = new Error('The \'' + propName + '\' must be a number divisible by the range set by the \'min\' and ' + ('\'max\' props. The current range is \'' + range + '\' by including the min: \'' + min + '\' and ') + ('max: \'' + max + '\' values. The current value of \'' + propName + '\' is \'' + props[propName] + '\'.'));
	      } else if (props[propName] % step !== 0) {
	        err = new Error('The \'step\' prop must be a number divisible by the \'' + propName + '\'. It is common to have ' + ('them as the same value. The current \'step\' is \'' + step + '\' and the \'' + propName + '\' is \'' + props[propName] + '\'.'));
	      }
	    }
	
	    return err;
	  },
	
	  /**
	   * The transition time for a discrete Slider's keyboard focus ink. This should match the
	   * `md-slider-discrete-ink-transition-time` value in your SCSS. This is used because
	   * the ink is only visible temporarily for a discrete slider when keyboard focusing.
	   */
	  discreteInkTransitionTime: _propTypes2.default.number.isRequired,
	
	  /**
	   * The precision that the value should be rounded to when the Slider is updated. This
	   * needs to be a whole number greater than or equal to 0.
	   */
	  valuePrecision: function valuePrecision(props, propName, component) {
	    for (var _len8 = arguments.length, others = Array(_len8 > 3 ? _len8 - 3 : 0), _key8 = 3; _key8 < _len8; _key8++) {
	      others[_key8 - 3] = arguments[_key8];
	    }
	
	    var _PropTypes$number4;
	
	    var err = (_PropTypes$number4 = _propTypes2.default.number).isRequired.apply(_PropTypes$number4, [props, propName, component].concat(others));
	    if (!err) {
	      var precision = props[propName];
	
	      if (precision % 1 !== 0 || precision < 0) {
	        err = new Error('The \'' + propName + '\' must be a positive whole number or 0 on the \'' + component + '\'. ' + ('The current \'' + propName + '\' is \'' + precision + '\''));
	      }
	    }
	
	    return err;
	  },
	
	  stepPrecision: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `step` and `valuePrecision` instead')
	};
	Slider.defaultProps = {
	  min: 0,
	  max: 100,
	  step: 1,
	  inputWidth: 40,
	  tickWidth: 6,
	  discreteInkTransitionTime: 300,
	  valuePrecision: 0
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._isTextField = function (target) {
	    return _this2._field && _this2._field.contains(target);
	  };
	
	  this._updatePosition = function (e, normalize) {
	    var x = (e.changedTouches ? e.changedTouches[0] : e).clientX;
	    var scale = _this2.state.scale;
	    var _props3 = _this2.props,
	        onChange = _props3.onChange,
	        onDragChange = _props3.onDragChange,
	        min = _props3.min,
	        max = _props3.max,
	        step = _props3.step;
	
	    var _calculateValueDistan = (0, _calculateValueDistance2.default)(x, _this2._track.offsetWidth, _this2._track.getBoundingClientRect().left, scale, step, min, max, normalize),
	        value = _calculateValueDistan.value,
	        distance = _calculateValueDistan.distance;
	
	    var isNewValue = (0, _getField2.default)(_this2.props, _this2.state, 'value') !== value;
	    if (onChange && isNewValue) {
	      onChange(value, e);
	    }
	
	    if (!normalize && onDragChange && (isNewValue || _this2.state.distance !== distance)) {
	      onDragChange(distance, value, e);
	    }
	
	    var state = {
	      active: true,
	      distance: distance,
	      manualIncrement: false,
	      dragging: !normalize,
	      thumbLeft: _this2._calcLeft(distance),
	      trackFillWidth: distance + '%'
	    };
	
	    if (e.type === 'touchend' || e.type === 'mousedown') {
	      state.maskInked = false;
	    }
	
	    if (typeof _this2.props.value === 'undefined') {
	      state.value = value;
	    }
	
	    _this2.setState(state);
	  };
	
	  this._handleDragStart = function (e) {
	    if (e.type === 'mousedown' && _this2.props.onMouseDown) {
	      _this2.props.onMouseDown(e);
	    } else if (e.type === 'touchstart' && _this2.props.onTouchStart) {
	      _this2.props.onTouchStart(e);
	    }
	
	    if (_this2.props.disabled || e.type === 'mousedown' && !(0, _isValidClick2.default)(e, 'mousedown') || _this2._isInTextField(e)) {
	      return;
	    }
	
	    var classList = e.target.classList;
	
	    var isDiscreteValue = classList.contains('md-slider-discrete-value');
	    if (classList.contains('md-slider-thumb') || isDiscreteValue) {
	      // Prevents text highlighting while dragging.
	      if (e.type.match(/mouse/)) {
	        e.preventDefault();
	      }
	      _this2.setState({ dragging: true, active: true, manualIncrement: false, maskInked: false });
	    } else if (!_this2._isTextField(e.target) && _this2._isValidClassList(classList)) {
	      _this2._updatePosition(e, true);
	    }
	  };
	
	  this._setNode = function (node) {
	    _this2._node = (0, _reactDom.findDOMNode)(node);
	  };
	
	  this._setTrack = function (track) {
	    _this2._track = (0, _reactDom.findDOMNode)(track);
	  };
	
	  this._setField = function (field) {
	    _this2._field = (0, _reactDom.findDOMNode)(field);
	    _this2._calcTrackWidth(_this2.props);
	  };
	
	  this._handleDragMove = function (e) {
	    if (_this2.props.disabled || !_this2.state.dragging) {
	      return;
	    }
	
	    // Stops the text highlighting while dragging
	    if (e.type.match(/mouse/)) {
	      e.preventDefault();
	    }
	
	    _this2._updatePosition(e, false);
	  };
	
	  this._handleDragEnd = function (e) {
	    if (!_this2.state.dragging || _this2.props.disabled || e.type === 'mouseup' && !(0, _isValidClick2.default)(e)) {
	      return;
	    }
	
	    _this2._updatePosition(e, true);
	  };
	
	  this._blurOnOutsideClick = function (e) {
	    if (_this2.state.dragging && !_this2.state.manualIncrement || _this2.props.disabled) {
	      return;
	    }
	
	    if (!_this2._node.contains(e.target)) {
	      _this2.setState({ active: false, maskInked: false });
	    }
	  };
	
	  this._handleIncrement = function (incrementedValue, e, disableTransition) {
	    var _props4 = _this2.props,
	        onChange = _props4.onChange,
	        min = _props4.min,
	        max = _props4.max,
	        discrete = _props4.discrete;
	
	
	    var value = Math.max(min, Math.min(max, incrementedValue));
	    var distance = _this2._calcDistance(value, min, max);
	
	    if (onChange) {
	      onChange(value, e);
	    }
	
	    var state = {
	      distance: distance,
	      manualIncrement: true,
	      thumbLeft: _this2._calcLeft(distance),
	      trackFillWidth: distance + '%',
	      dragging: Math.abs(_this2.state.distance - distance) < 2 && disableTransition
	    };
	
	    if (typeof _this2.props.value === 'undefined') {
	      state.value = value;
	    }
	
	    if (e.type === 'keydown' && !discrete) {
	      state.maskInked = true;
	    }
	
	    _this2.setState(state);
	  };
	
	  this._handleTextFieldChange = function (newValue, e) {
	    _this2._handleIncrement(newValue, e, false);
	  };
	
	  this._handleKeyDown = function (e) {
	    var key = e.which || e.keyCode;
	    var _props5 = _this2.props,
	        min = _props5.min,
	        max = _props5.max,
	        step = _props5.step,
	        disabled = _props5.disabled;
	
	    if (disabled) {
	      return;
	    }
	
	    if (key === _keyCodes.TAB) {
	      _this2.setState({ active: false, maskInked: false });
	      return;
	    } else if (key !== _keyCodes.LEFT && key !== _keyCodes.RIGHT) {
	      return;
	    }
	
	    var nextValue = (0, _getField2.default)(_this2.props, _this2.state, 'value');
	    nextValue = Math.max(min, Math.min((key === _keyCodes.LEFT ? -step : step) + nextValue, max));
	
	    _this2._handleIncrement(nextValue, e, true);
	  };
	
	  this._handleKeyUp = function (e) {
	    if ((e.which || e.keyCode) !== _keyCodes.TAB) {
	      return;
	    }
	
	    if (_this2.props.discrete) {
	      _this2._animateDiscreteInk();
	    }
	
	    _this2.setState({ maskInked: true });
	  };
	
	  this._handleFocus = function () {
	    _this2.setState({ active: true });
	  };
	
	  this._calcTrackWidth = function (props) {
	    var editable = props.editable,
	        leftIcon = props.leftIcon,
	        rightIcon = props.rightIcon,
	        inputWidth = props.inputWidth,
	        label = props.label;
	
	
	    if (!label) {
	      _this2.setState({ trackWidth: null });
	      return;
	    }
	
	    var trackWidth = null;
	    if (!leftIcon && !rightIcon && !editable) {
	      trackWidth = '100%';
	    } else if (editable && !leftIcon) {
	      var cs = window.getComputedStyle(_this2._field);
	      var pl = parseInt(cs.getPropertyValue('padding-left'), 10);
	      var ml = parseInt(cs.getPropertyValue('margin-left'), 10);
	
	      trackWidth = pl + ml + inputWidth;
	    }
	
	    if (trackWidth) {
	      _this2.setState({ trackWidth: trackWidth });
	    }
	  };
	
	  this._animateDiscreteInk = function () {
	    var wait = _this2.props.discreteInkTransitionTime;
	    if (_this2._inkTimeout) {
	      clearTimeout(_this2._inkTimeout);
	    }
	
	    _this2._inkTimeout = setTimeout(function () {
	      _this2.setState({ leaving: true, maskInked: false });
	
	      _this2._inkTimeout = setTimeout(function () {
	        _this2._inkTimeout = null;
	        _this2.setState({ leaving: false });
	      }, wait);
	    }, wait);
	  };
	
	  this._focusThumb = function () {
	    if (_this2._focusTimeout) {
	      clearTimeout(_this2._focusTimeout);
	    }
	
	    _this2._focusTimeout = setTimeout(function () {
	      _this2._focusTimeout = null;
	      if (!_this2._thumb) {
	        _this2._thumb = _this2._node.querySelector('.md-slider-thumb');
	      }
	
	      _this2._thumb.focus();
	    }, 100);
	  };
	};
	
	exports.default = Slider;
	//# sourceMappingURL=Slider.js.map

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(12);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This is just the label component for the slider. It will
	 * return null if there are no children to display.
	 */
	var SliderLabel = function (_PureComponent) {
	  _inherits(SliderLabel, _PureComponent);
	
	  function SliderLabel() {
	    _classCallCheck(this, SliderLabel);
	
	    return _possibleConstructorReturn(this, (SliderLabel.__proto__ || Object.getPrototypeOf(SliderLabel)).apply(this, arguments));
	  }
	
	  _createClass(SliderLabel, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          htmlFor = _props.htmlFor,
	          props = _objectWithoutProperties(_props, ['children', 'className', 'htmlFor']);
	
	      if (!children) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'label',
	        _extends({}, props, {
	          htmlFor: htmlFor,
	          className: (0, _classnames2.default)('md-slider-label', (0, _themeColors2.default)({ text: true }), className)
	        }),
	        children
	      );
	    }
	  }]);
	
	  return SliderLabel;
	}(_react.PureComponent);
	
	SliderLabel.propTypes = {
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  htmlFor: function htmlFor(props, propName, component) {
	    for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      others[_key - 3] = arguments[_key];
	    }
	
	    var _PropTypes$string;
	
	    if (typeof props.children === 'undefined') {
	      return null;
	    }
	
	    return (_PropTypes$string = _propTypes2.default.string).isRequired.apply(_PropTypes$string, [props, propName, component].concat(others));
	  }
	};
	exports.default = SliderLabel;
	//# sourceMappingURL=SliderLabel.js.map

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AccessibleFakeButton = __webpack_require__(80);
	
	var _AccessibleFakeButton2 = _interopRequireDefault(_AccessibleFakeButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Thumb` component is the little ball for the slider.
	 */
	var Thumb = function (_PureComponent) {
	  _inherits(Thumb, _PureComponent);
	
	  function Thumb() {
	    _classCallCheck(this, Thumb);
	
	    return _possibleConstructorReturn(this, (Thumb.__proto__ || Object.getPrototypeOf(Thumb)).apply(this, arguments));
	  }
	
	  _createClass(Thumb, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          on = _props.on,
	          off = _props.off,
	          active = _props.active,
	          disabled = _props.disabled,
	          dragging = _props.dragging,
	          thumbLeft = _props.thumbLeft,
	          discrete = _props.discrete,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'on', 'off', 'active', 'disabled', 'dragging', 'thumbLeft', 'discrete']);
	
	      return _react2.default.createElement(_AccessibleFakeButton2.default, _extends({
	        disabled: disabled
	      }, props, {
	        style: Object.assign({}, style, { left: thumbLeft }),
	        className: (0, _classnames2.default)('md-slider-thumb', className, {
	          'md-slider-thumb--active': active,
	          'md-slider-thumb--dragging': dragging,
	          'md-slider-thumb--disabled': disabled,
	          'md-slider-thumb--on': on,
	          'md-slider-thumb--continuous-off': !discrete && off,
	          'md-slider-thumb--discrete': discrete,
	          'md-slider-thumb--discrete-on': discrete && active && on,
	          'md-slider-thumb--discrete-off': discrete && !disabled && off,
	          'md-slider-thumb--discrete-active': discrete && active,
	          'md-slider-thumb--discrete-active-off': discrete && active && off
	        })
	      }));
	    }
	  }]);
	
	  return Thumb;
	}(_react.PureComponent);
	
	Thumb.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  thumbLeft: _propTypes2.default.string.isRequired,
	  on: _propTypes2.default.bool,
	  off: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  dragging: _propTypes2.default.bool,
	  discrete: _propTypes2.default.bool
	};
	exports.default = Thumb;
	//# sourceMappingURL=Thumb.js.map

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `ThumbMask` component is used for either:
	 *
	 *  - rendering the ink behind the `Thumb` component when the `Thumb`
	 *  has keyboard focus or touch focus
	 *  - rendering a underlay to make the `Track` look broken for disabled
	 *  Sliders.
	 */
	var ThumbMask = function (_PureComponent) {
	  _inherits(ThumbMask, _PureComponent);
	
	  function ThumbMask() {
	    _classCallCheck(this, ThumbMask);
	
	    return _possibleConstructorReturn(this, (ThumbMask.__proto__ || Object.getPrototypeOf(ThumbMask)).apply(this, arguments));
	  }
	
	  _createClass(ThumbMask, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          thumbLeft = _props.thumbLeft,
	          disabled = _props.disabled,
	          dragging = _props.dragging,
	          maskInked = _props.maskInked,
	          discrete = _props.discrete,
	          leaving = _props.leaving,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'thumbLeft', 'disabled', 'dragging', 'maskInked', 'discrete', 'leaving']);
	
	      return _react2.default.createElement('span', _extends({}, props, {
	        style: Object.assign({}, style, { left: thumbLeft }),
	        className: (0, _classnames2.default)('md-slider-thumb md-slider-thumb--mask', className, {
	          'md-slider-thumb--dragging': dragging,
	          'md-slider-thumb--mask-inked': maskInked,
	          'md-slider-thumb--mask-disabled': disabled,
	          'md-slider-thumb--discrete-mask-inked': maskInked && discrete,
	          'md-slider-thumb--discrete-mask-leaving': discrete && leaving
	        })
	      }));
	    }
	  }]);
	
	  return ThumbMask;
	}(_react.PureComponent);
	
	ThumbMask.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  thumbLeft: _propTypes2.default.string.isRequired,
	  maskInked: _propTypes2.default.bool,
	  dragging: _propTypes2.default.bool,
	  discrete: _propTypes2.default.bool,
	  leaving: _propTypes2.default.bool
	};
	exports.default = ThumbMask;
	//# sourceMappingURL=ThumbMask.js.map

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _updateUnit = __webpack_require__(677);
	
	var _updateUnit2 = _interopRequireDefault(_updateUnit);
	
	var _TrackFill = __webpack_require__(644);
	
	var _TrackFill2 = _interopRequireDefault(_TrackFill);
	
	var _Thumb = __webpack_require__(641);
	
	var _Thumb2 = _interopRequireDefault(_Thumb);
	
	var _ThumbMask = __webpack_require__(642);
	
	var _ThumbMask2 = _interopRequireDefault(_ThumbMask);
	
	var _DiscreteValue = __webpack_require__(638);
	
	var _DiscreteValue2 = _interopRequireDefault(_DiscreteValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var half = function half(w) {
	  return w / 2;
	};
	
	/**
	 * The `Track` component is used for showing the current state of the slider.
	 * It will render the `TrackFill`, `Thumb`, and `ThumbMask` components.
	 */
	
	var Track = function (_PureComponent) {
	  _inherits(Track, _PureComponent);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, (Track.__proto__ || Object.getPrototypeOf(Track)).apply(this, arguments));
	  }
	
	  _createClass(Track, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          on = _props.on,
	          off = _props.off,
	          active = _props.active,
	          disabled = _props.disabled,
	          dragging = _props.dragging,
	          className = _props.className,
	          thumbLeft = _props.thumbLeft,
	          trackFillWidth = _props.trackFillWidth,
	          trackFillStyle = _props.trackFillStyle,
	          trackFillClassName = _props.trackFillClassName,
	          discreteValueStyle = _props.discreteValueStyle,
	          discreteValueClassName = _props.discreteValueClassName,
	          maskInked = _props.maskInked,
	          maskLeaving = _props.maskLeaving,
	          thumbStyle = _props.thumbStyle,
	          thumbClassName = _props.thumbClassName,
	          discrete = _props.discrete,
	          onThumbFocus = _props.onThumbFocus,
	          onThumbKeyUp = _props.onThumbKeyUp,
	          onThumbKeyDown = _props.onThumbKeyDown,
	          value = _props.value,
	          tickWidth = _props.tickWidth,
	          discreteTicks = _props.discreteTicks,
	          scale = _props.scale,
	          step = _props.step,
	          valuePrecision = _props.valuePrecision,
	          props = _objectWithoutProperties(_props, ['on', 'off', 'active', 'disabled', 'dragging', 'className', 'thumbLeft', 'trackFillWidth', 'trackFillStyle', 'trackFillClassName', 'discreteValueStyle', 'discreteValueClassName', 'maskInked', 'maskLeaving', 'thumbStyle', 'thumbClassName', 'discrete', 'onThumbFocus', 'onThumbKeyUp', 'onThumbKeyDown', 'value', 'tickWidth', 'discreteTicks', 'scale', 'step', 'valuePrecision']);
	
	      var ticks = [];
	      if (typeof discreteTicks !== 'undefined' && !disabled && discrete) {
	        var amt = scale / (discreteTicks / step);
	        var offset = (0, _updateUnit2.default)(tickWidth, half, 'px');
	        var inc = 100 / amt;
	
	        for (var i = 0; i <= amt; i++) {
	          var left = i * inc + '%';
	          var width = tickWidth;
	          if (i === 0 || i === amt) {
	            width = (0, _updateUnit2.default)(tickWidth, half);
	          } else {
	            left = 'calc(' + left + ' - ' + offset + ')';
	          }
	
	          ticks.push(_react2.default.createElement('span', {
	            key: 'tick-' + i,
	            className: 'md-slider-discrete-tick',
	            style: { left: left, width: width }
	          }));
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, { className: (0, _classnames2.default)('md-slider-track', className) }),
	        ticks,
	        _react2.default.createElement(_TrackFill2.default, {
	          style: trackFillStyle,
	          className: trackFillClassName,
	          disabled: disabled,
	          dragging: dragging,
	          trackFillWidth: trackFillWidth
	        }),
	        _react2.default.createElement(_Thumb2.default, {
	          style: thumbStyle,
	          className: thumbClassName,
	          on: on,
	          off: off,
	          disabled: disabled,
	          dragging: dragging,
	          active: active,
	          thumbLeft: thumbLeft,
	          onFocus: onThumbFocus,
	          onKeyUp: onThumbKeyUp,
	          onKeyDown: onThumbKeyDown,
	          discrete: discrete
	        }),
	        _react2.default.createElement(_DiscreteValue2.default, {
	          style: discreteValueStyle,
	          className: discreteValueClassName,
	          discrete: discrete,
	          dragging: dragging,
	          active: active,
	          value: value,
	          thumbLeft: thumbLeft,
	          valuePrecision: valuePrecision
	        }),
	        _react2.default.createElement(_ThumbMask2.default, {
	          dragging: dragging,
	          disabled: disabled,
	          thumbLeft: thumbLeft,
	          maskInked: maskInked,
	          discrete: discrete,
	          leaving: maskLeaving
	        })
	      );
	    }
	  }]);
	
	  return Track;
	}(_react.PureComponent);
	
	Track.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  thumbStyle: _propTypes2.default.object,
	  thumbClassName: _propTypes2.default.string,
	  trackFillStyle: _propTypes2.default.object,
	  trackFillClassName: _propTypes2.default.string,
	  discreteValueStyle: _propTypes2.default.object,
	  discreteValueClassName: _propTypes2.default.string,
	  on: _propTypes2.default.bool,
	  off: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	  dragging: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  thumbLeft: _propTypes2.default.string.isRequired,
	  trackFillWidth: _propTypes2.default.string.isRequired,
	  value: _propTypes2.default.number.isRequired,
	  discrete: _propTypes2.default.bool,
	  maskInked: _propTypes2.default.bool,
	  maskLeaving: _propTypes2.default.bool,
	  onThumbKeyUp: _propTypes2.default.func.isRequired,
	  onThumbKeyDown: _propTypes2.default.func.isRequired,
	  onThumbFocus: _propTypes2.default.func.isRequired,
	  scale: _propTypes2.default.number,
	  step: _propTypes2.default.number,
	  discreteTicks: _propTypes2.default.number,
	  tickWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  valuePrecision: _propTypes2.default.number.isRequired
	};
	exports.default = Track;
	//# sourceMappingURL=Track.js.map

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TrackFill` component is used for showing a colored bar
	 * within the `Track` component to show the `Slider`'s position.
	 *
	 * If the `Slider` is disabled, this will just return null.
	 */
	var TrackFill = function (_PureComponent) {
	  _inherits(TrackFill, _PureComponent);
	
	  function TrackFill() {
	    _classCallCheck(this, TrackFill);
	
	    return _possibleConstructorReturn(this, (TrackFill.__proto__ || Object.getPrototypeOf(TrackFill)).apply(this, arguments));
	  }
	
	  _createClass(TrackFill, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          trackFillWidth = _props.trackFillWidth,
	          dragging = _props.dragging,
	          disabled = _props.disabled,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'trackFillWidth', 'dragging', 'disabled']);
	
	      if (disabled) {
	        return null;
	      }
	
	      return _react2.default.createElement('hr', _extends({}, props, {
	        style: Object.assign({}, style, { width: trackFillWidth }),
	        className: (0, _classnames2.default)('md-slider-track-fill', className, {
	          'md-slider-track-fill--dragging': dragging
	        })
	      }));
	    }
	  }]);
	
	  return TrackFill;
	}(_react.PureComponent);
	
	TrackFill.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  dragging: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  trackFillWidth: _propTypes2.default.string.isRequired
	};
	exports.default = TrackFill;
	//# sourceMappingURL=TrackFill.js.map

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Slider = undefined;
	
	var _Slider2 = __webpack_require__(639);
	
	var _Slider3 = _interopRequireDefault(_Slider2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Slider3.default;
	exports.Slider = _Slider3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _CSSTransitionGroup = __webpack_require__(49);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _CSSTransitionGroupTick = __webpack_require__(34);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	var _isInvalidAnimate = __webpack_require__(285);
	
	var _isInvalidAnimate2 = _interopRequireDefault(_isInvalidAnimate);
	
	var _Portal = __webpack_require__(62);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Snackbar = __webpack_require__(284);
	
	var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CHAINED_TOAST_DELAY = 50;
	
	/**
	 * The `Snackbar` component is used for displaying a concise and small message to the user about
	 * an operation performed.
	 *
	 * > The main component for the `Snackbar` is actually named the `SnackbarContainer`, so you need
	 * to make sure the import is `react-md/lib/Snackbars` or `react-md/lib/Snackbars/SnackbarContainer`.
	 * The first import is preferable.
	 */
	
	var SnackbarContainer = function (_PureComponent) {
	  _inherits(SnackbarContainer, _PureComponent);
	
	  function SnackbarContainer(props) {
	    _classCallCheck(this, SnackbarContainer);
	
	    var _this = _possibleConstructorReturn(this, (SnackbarContainer.__proto__ || Object.getPrototypeOf(SnackbarContainer)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var visible = !!props.toasts.length;
	    _this.state = {
	      visible: visible,
	      toast: null
	    };
	    return _this;
	  }
	
	  _createClass(SnackbarContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var toasts = this.props.toasts;
	
	      if (toasts.length) {
	        this._initAndToast(toasts[0]);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _nextProps$toasts = _slicedToArray(nextProps.toasts, 1),
	          toast = _nextProps$toasts[0];
	
	      var _props$toasts = _slicedToArray(this.props.toasts, 1),
	          prevToast = _props$toasts[0];
	
	      if (toast === prevToast || toast === this.state.toast) {
	        return;
	      }
	
	      if (!toast) {
	        this._createLeaveTimer();
	      } else if (!this.state.visible) {
	        this._initAndToast(toast);
	      } else {
	        this._createSwapTimer(toast);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._initTimeout) {
	        clearTimeout(this._initTimeout);
	      }
	
	      if (this._leaveTimeout) {
	        clearTimeout(this._leaveTimeout);
	      }
	
	      if (this._swapTimeout) {
	        clearTimeout(this._swapTimeout);
	      }
	
	      if (this._dismissTimeout) {
	        clearTimeout(this._dismissTimeout);
	      }
	    }
	
	    /**
	     * This function takes in a new toast object and checks if the message will span
	     * multiple lines of text by creating the new snackbar before the `Snackbar` component
	     * gets made, checking the height of the message, and then removing the temporary
	     * snackbar.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          visible = _state.visible,
	          toast = _state.toast,
	          multiline = _state.multiline;
	
	      var _props = this.props,
	          transitionName = _props.transitionName,
	          transitionEnterTimeout = _props.transitionEnterTimeout,
	          transitionLeaveTimeout = _props.transitionLeaveTimeout,
	          dismiss = _props.dismiss,
	          onDismiss = _props.onDismiss,
	          lastChild = _props.lastChild,
	          portal = _props.portal,
	          propRenderNode = _props.renderNode,
	          toasts = _props.toasts,
	          props = _objectWithoutProperties(_props, ['transitionName', 'transitionEnterTimeout', 'transitionLeaveTimeout', 'dismiss', 'onDismiss', 'lastChild', 'portal', 'renderNode', 'toasts']);
	
	      var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');
	
	      var snackbar = void 0;
	      if (toast) {
	        snackbar = _react2.default.createElement(_Snackbar2.default, _extends({}, props, {
	          key: 'snackbar',
	          leaveTimeout: transitionLeaveTimeout,
	          toast: toast,
	          multiline: multiline,
	          onDismiss: onDismiss || dismiss
	        }));
	      }
	
	      var container = _react2.default.createElement(
	        _CSSTransitionGroup2.default,
	        {
	          ref: this._setContainer,
	          key: 'container',
	          className: 'md-snackbar-container',
	          transitionName: transitionName,
	          transitionEnterTimeout: transitionEnterTimeout,
	          transitionLeaveTimeout: transitionLeaveTimeout
	        },
	        snackbar
	      );
	
	      if (!portal) {
	        return visible ? container : null;
	      }
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { visible: visible, renderNode: renderNode, lastChild: lastChild },
	        container
	      );
	    }
	  }]);
	
	  return SnackbarContainer;
	}(_react.PureComponent);
	
	SnackbarContainer.propTypes = {
	  /**
	   * An id for the Snackbar once a toast has been added and is visible. This is a recommended
	   * prop for accessibility concerns. If it is omitted, the id will become `'snackbar-alert'`
	   * when there is no action on the toast, or `'snackbar-alert-dialog'` when there is an action
	   * on the toast.
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the snackbar once it appears.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the snackbar once it appears.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An immutable controlled queue of toasts that should appear in the snackbar.
	   * The snackbar will always display the first toast in this list. When the user has
	   * either clicked the action of the toast, or the `autohideTimeout` has been reached,
	   * the `onDismiss` function will be called. The `onDismiss` function should remove the
	   * first toast and return a new list of remaining toasts.
	   *
	   * ```js
	   * let toasts = [];
	   * const onDismiss = () => {
	   *   const [, ...remainingToasts] = toasts;
	   *   toasts = remainingToasts;
	   * };
	   * ```
	   */
	  toasts: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    /**
	     * The text to display in the toast.
	     */
	    text: _propTypes2.default.node.isRequired,
	
	    /**
	     * An optional action to take. If this value is a string, the `label` for the
	     * button will be this value, Otherwise, all the keys in the action object will
	     * be applied to the `Button`.
	     */
	    action: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.shape({
	      onClick: _propTypes2.default.func,
	      children: _propTypes2.default.node,
	      // Deprecated
	      label: _propTypes2.default.node
	    })])
	  })).isRequired,
	
	  /**
	   * A function to call that will dismiss a toast. This will automatically be bound to
	   * any toast that has an `action` and it will also be called when the `autohideTimeout`
	   * has been reached.
	   */
	  onDismiss: _propTypes2.default.func.isRequired,
	
	  /**
	   * Boolean if the snackbar's toasts should automatically be dismissed after the
	   * `autohideTimeout` has been reached.
	   */
	  autohide: _propTypes2.default.bool,
	
	  /**
	   * The amount of time before the snackbar should be dequeued and the next toast
	   * should be displayed.
	   */
	  autohideTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * The transition name to use for the snackbar appearing and disappearing.
	   */
	  transitionName: _propTypes2.default.string.isRequired,
	
	  /**
	   * The transition time for the snackbar to enter. This should match the `$md-snackbar-transition-time`
	   * sass variable.
	   */
	  transitionEnterTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * The transition time for the snackbar to leave. This should match the `$md-snackbar-transition-time`
	   * sass variable.
	   */
	  transitionLeaveTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * When the app contains a floating action button that is fixed to the bottom of the screen,
	   * you should set this to be a ref of the floating action button. When a snackbar appears,
	   * the FAB will be moved to not overlay the snackbar.
	   */
	  fab: function fab(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	    if (!propValue) {
	      return null;
	    }
	
	    if (propType !== 'object' || typeof propValue.render !== 'function' || (0, _isInvalidAnimate2.default)(propValue)) {
	      var componentNameSafe = componentName || '<<anonymous>>';
	      var propFullNameSafe = propFullName || propName;
	      return new Error('Invalid ' + location + ' `' + propFullNameSafe + '` supplied to `' + componentNameSafe + '`, expected a ' + 'ref to a floating `Button` component. This should not be a DOMElement from `findDOMNode` but instead ' + 'the React ref object.');
	    }
	
	    return null;
	  },
	
	  /**
	   * Boolean if the Portal's functionality of rendering in a separate react tree should be applied
	   * to the snackbar.
	   *
	   * @see {@link Helpers/Portal}
	   */
	  portal: _propTypes2.default.bool,
	
	  /**
	   * An optional DOM node to render the Snackbar in. If this is omitted, it will render as the first
	   * child in the `body`.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the snackbar should render as the last child in the `renderNode` or `body` instead of
	   * as the first.
	   */
	  lastChild: _propTypes2.default.bool,
	  dismiss: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onDismiss` instead')
	};
	SnackbarContainer.defaultProps = {
	  autohide: true,
	  toasts: [],
	  autohideTimeout: 3000,
	  transitionName: 'md-snackbar',
	  transitionEnterTimeout: 300,
	  transitionLeaveTimeout: 300
	};
	SnackbarContainer.contextTypes = {
	  renderNode: _propTypes2.default.object
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._setContainer = function (container) {
	    _this2._container = (0, _reactDom.findDOMNode)(container);
	  };
	
	  this._isMultiline = function (toast) {
	    var container = _this2._container;
	    if (container === null) {
	      return false;
	    }
	
	    var message = document.createElement('p');
	    message.classList.add('md-snackbar--toast');
	    message.innerHTML = toast.text;
	
	    var snackbar = void 0;
	    if (toast.action) {
	      message.classList.add('md-snackbar--action');
	
	      snackbar = document.createElement('section');
	      snackbar.className = 'md-snackbar';
	      snackbar.appendChild(message);
	
	      var action = document.createElement('button');
	      action.innerHTML = typeof toast.action === 'string' ? toast.action : toast.action.label;
	      action.className = 'md-btn md-btn--flat md-btn--text md-btn--snackbar';
	      snackbar.appendChild(action);
	    } else {
	      snackbar = message;
	    }
	
	    // Only style we really want from the .md-snackbar
	    snackbar.style.maxWidth = '568px';
	
	    container.appendChild(snackbar);
	    var multiline = message.offsetHeight > 20;
	    container.removeChild(snackbar);
	
	    return multiline;
	  };
	
	  this._initAndToast = function (toast) {
	    _this2._initTimeout = setTimeout(function () {
	      _this2._initTimeout = null;
	
	      _this2.setState({ toast: toast, multiline: _this2._isMultiline(toast) });
	    }, _CSSTransitionGroupTick2.default);
	
	    _this2.setState({ visible: true });
	  };
	
	  this._createLeaveTimer = function () {
	    var time = _this2.props.transitionLeaveTimeout;
	
	    _this2._leaveTimeout = setTimeout(function () {
	      _this2._leaveTimeout = null;
	
	      _this2.setState({ visible: false });
	    }, time + _CSSTransitionGroupTick2.default);
	
	    _this2.setState({ toast: null });
	  };
	
	  this._createSwapTimer = function (toast) {
	    _this2._swapTimeout = setTimeout(function () {
	      _this2._swapTimeout = null;
	
	      _this2.setState({ toast: toast, multiline: _this2._isMultiline(toast) });
	    }, _this2.props.transitionLeaveTimeout + CHAINED_TOAST_DELAY);
	
	    _this2.setState({ toast: null });
	  };
	};
	
	exports.default = SnackbarContainer;
	//# sourceMappingURL=SnackbarContainer.js.map

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Snackbar = undefined;
	
	var _SnackbarContainer = __webpack_require__(646);
	
	var _SnackbarContainer2 = _interopRequireDefault(_SnackbarContainer);
	
	var _Snackbar2 = __webpack_require__(284);
	
	var _Snackbar3 = _interopRequireDefault(_Snackbar2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SnackbarContainer2.default;
	exports.Snackbar = _Snackbar3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _oneRequired = __webpack_require__(305);
	
	var _oneRequired2 = _interopRequireDefault(_oneRequired);
	
	var _AccessibleFakeInkedButton = __webpack_require__(29);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Tab` component is used for rendering a single tab in the `Tabs` component.
	 * It can optionally have either a `label`, an `icon` or both.
	 */
	var Tab = function (_PureComponent) {
	  _inherits(Tab, _PureComponent);
	
	  function Tab() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Tab);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tab.__proto__ || Object.getPrototypeOf(Tab)).call.apply(_ref, [this].concat(args))), _this), _this._handleClick = function (e) {
	      if (_this.props.onClick) {
	        _this.props.onClick(_this.props.index, _this.props.id, _this.props.controlsId, _this.props.children, e);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Tab, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          controlsId = _props.controlsId,
	          className = _props.className,
	          active = _props.active,
	          propIcon = _props.icon,
	          propLabel = _props.label,
	          index = _props.index,
	          props = _objectWithoutProperties(_props, ['id', 'controlsId', 'className', 'active', 'icon', 'label', 'index']);
	
	      var _props2 = this.props,
	          icon = _props2.icon,
	          label = _props2.label;
	
	      if (icon) {
	        var iconEl = _react.Children.only(icon);
	        icon = (0, _react.cloneElement)(icon, {
	          className: (0, _classnames2.default)('md-icon--tab', iconEl.props.className)
	        });
	      }
	
	      if ((0, _react.isValidElement)(label)) {
	        var labelEl = _react.Children.only(label);
	        label = (0, _react.cloneElement)(label, {
	          className: (0, _classnames2.default)('md-tab-label', labelEl.props.className)
	        });
	      } else {
	        label = _react2.default.createElement(
	          'div',
	          { className: 'md-tab-label' },
	          label
	        );
	      }
	      return _react2.default.createElement(
	        _AccessibleFakeInkedButton2.default,
	        _extends({}, props, {
	          id: id,
	          role: 'tab',
	          onClick: this._handleClick,
	          className: (0, _classnames2.default)('md-tab', {
	            'md-tab--active': active,
	            'md-tab--inactive': !active,
	            'md-tab--icon': label && icon
	          }, className),
	          'aria-controls': controlsId,
	          'aria-selected': active
	        }),
	        icon,
	        label
	      );
	    }
	  }]);
	
	  return Tab;
	}(_react.PureComponent);
	
	Tab.propTypes = {
	  /**
	   * An id for the tab. This is required for a11y. If you use the `Tabs` component, this
	   * will automatically be generated for you and injected into this component.
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An id for a `TabPanel` that holds the children from this tab. This is required for a11y.
	   * If you use the `Tabs` component, this will automatically be generated for you and injected
	   * into this component.
	   */
	  controlsId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The component to render as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * Any children to display once the tab has been selected.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An optional icon to display in the tab. This can either be used alone, or it
	   * will be placed above the `label` if both are given.
	   */
	  icon: _propTypes2.default.element,
	
	  /**
	   * An optional label to display in the tab. This can either be used alone, or it
	   * will be placed below the `icon` if both are given.
	   */
	  label: (0, _oneRequired2.default)(_propTypes2.default.node, 'icon'),
	
	  /**
	   * An optional function to call when the tab is clicked. The callback includes this tab's index,
	   * id, controlsId, children, and finally click event. All the additional parameters are included
	   * if you are not using the `TabsContainer` component. The `id` and `controlsId` are mainly passed
	   * for accessibility.
	   *
	   * ```js
	   * onClick(index, id, controlsId, children, event);
	   * ```
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * Boolean if the tab is currently active. If you use the `Tabs` component, this is automatically
	   * injected.
	   */
	  active: _propTypes2.default.bool,
	
	  /**
	   * Tab's index. If you use the `Tabs` component, this is automatically injected.
	   */
	  index: _propTypes2.default.number
	};
	Tab.defaultProps = {
	  component: 'li'
	};
	exports.default = Tab;
	//# sourceMappingURL=Tab.js.map

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMotion = __webpack_require__(309);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabIndicator = function (_PureComponent) {
	  _inherits(TabIndicator, _PureComponent);
	
	  function TabIndicator() {
	    _classCallCheck(this, TabIndicator);
	
	    return _possibleConstructorReturn(this, (TabIndicator.__proto__ || Object.getPrototypeOf(TabIndicator)).apply(this, arguments));
	  }
	
	  _createClass(TabIndicator, [{
	    key: 'render',
	    value: function render() {
	      var visible = this.props.visible;
	
	      return _react2.default.createElement(
	        _reactMotion.Motion,
	        {
	          style: {
	            x: (0, _reactMotion.spring)(this.props.offset),
	            width: (0, _reactMotion.spring)(this.props.width),
	            height: (0, _reactMotion.spring)(visible ? 2 : 0)
	          }
	        },
	        function (_ref) {
	          var x = _ref.x,
	              height = _ref.height,
	              width = _ref.width;
	
	          var transform = 'translate3d(' + x + 'px, 0, 0)';
	          return _react2.default.createElement('span', {
	            style: {
	              height: height,
	              width: width,
	              WebkitTransform: transform,
	              MozTransform: transform,
	              msTransform: transform,
	              transform: transform
	            },
	            className: 'md-tab-indicator'
	          });
	        }
	      );
	    }
	  }]);
	
	  return TabIndicator;
	}(_react.PureComponent);
	
	TabIndicator.propTypes = {
	  offset: _propTypes2.default.number.isRequired,
	  width: _propTypes2.default.number.isRequired,
	  visible: _propTypes2.default.bool
	};
	exports.default = TabIndicator;
	//# sourceMappingURL=TabIndicator.js.map

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(19);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabOverflowButton = function (_PureComponent) {
	  _inherits(TabOverflowButton, _PureComponent);
	
	  function TabOverflowButton() {
	    _classCallCheck(this, TabOverflowButton);
	
	    return _possibleConstructorReturn(this, (TabOverflowButton.__proto__ || Object.getPrototypeOf(TabOverflowButton)).apply(this, arguments));
	  }
	
	  _createClass(TabOverflowButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          left = _props.left,
	          icon = _props.icon,
	          props = _objectWithoutProperties(_props, ['left', 'icon']);
	
	      return _react2.default.createElement(_Button2.default, _extends({}, props, {
	        icon: true,
	        className: (0, _classnames2.default)('md-icon--inherit md-btn--tab-overflow', {
	          'md-btn--tab-overflow-left': left,
	          'md-btn--tab-overflow-right': !left,
	          'md-btn--tab-overflow-icon': icon
	        })
	      }));
	    }
	  }]);
	
	  return TabOverflowButton;
	}(_react.PureComponent);
	
	TabOverflowButton.propTypes = {
	  left: _propTypes2.default.bool,
	  icon: _propTypes2.default.bool
	};
	exports.default = TabOverflowButton;
	//# sourceMappingURL=TabOverflowButton.js.map

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(6);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(17);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _controlled = __webpack_require__(16);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _TabIndicator = __webpack_require__(649);
	
	var _TabIndicator2 = _interopRequireDefault(_TabIndicator);
	
	var _IconSeparator = __webpack_require__(61);
	
	var _IconSeparator2 = _interopRequireDefault(_IconSeparator);
	
	var _ResizeObserver = __webpack_require__(32);
	
	var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);
	
	var _FontIcon = __webpack_require__(13);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(21);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _MenuTab = __webpack_require__(288);
	
	var _MenuTab2 = _interopRequireDefault(_MenuTab);
	
	var _TabOverflowButton = __webpack_require__(650);
	
	var _TabOverflowButton2 = _interopRequireDefault(_TabOverflowButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MOBILE_PADDING = 72;
	var DESKTOP_PADDING = 80;
	var MOBILE_TAB_MIN_WIDTH = 72;
	var DESKTOP_TAB_MIN_WIDTH = 160;
	
	/**
	 * The `Tabs` component is used to manage the state of which tab is currently active.
	 */
	
	var Tabs = function (_PureComponent) {
	  _inherits(Tabs, _PureComponent);
	
	  function Tabs(props) {
	    _classCallCheck(this, Tabs);
	
	    var _this = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));
	
	    _this._setContainer = function (container) {
	      _this._container = container;
	      _this._positionElements(_this._container !== null);
	    };
	
	    _this._positionElements = function (initialRender) {
	      initialRender = typeof initialRender === 'boolean' && initialRender;
	      if (!_this._container) {
	        return;
	      }
	
	      var _this$props = _this.props,
	          centered = _this$props.centered,
	          overflowMenu = _this$props.overflowMenu;
	      var mobile = _this.props.mobile;
	
	
	      var paddingLeft = void 0;
	      if (!centered && _this._shouldAlign(_this.props)) {
	        paddingLeft = _this._calcPaddingLeft(_this._container, mobile);
	      }
	
	      var overflowAtIndex = void 0;
	      if (!mobile) {
	        overflowAtIndex = _this._calcOverflowIndex(_this._container, paddingLeft, overflowMenu);
	      }
	
	      var indicatorPosition = _this._calcIndicatorPosition(_this._container, initialRender ? paddingLeft : 0);
	
	      _this.setState(_extends({ mobile: mobile, paddingLeft: paddingLeft, overflowAtIndex: overflowAtIndex }, indicatorPosition), _this._scrollActiveIntoView);
	    };
	
	    _this._scrollActiveIntoView = function () {
	      if (!_this._container || !_this.state.mobile) {
	        return;
	      }
	
	      var active = _this._container.querySelector('.md-tab--active');
	      if (!active) {
	        return;
	      }
	
	      var allTabs = Array.prototype.slice.call(_this._container.querySelectorAll('.md-tab'));
	      if (allTabs[0] === active) {
	        _this._container.scrollLeft = 0;
	        return;
	      }
	
	      var _this$_container = _this._container,
	          containerWidth = _this$_container.offsetWidth,
	          scrollLeft = _this$_container.scrollLeft;
	      var activeWidth = active.offsetWidth,
	          activeOffset = active.offsetLeft;
	
	      var inFullViewLeft = activeOffset - scrollLeft >= 0;
	      var inFullViewRight = activeOffset + activeWidth - (containerWidth + scrollLeft) <= 0;
	      if (inFullViewLeft && inFullViewRight) {
	        return;
	      }
	
	      var offset = 0;
	      allTabs.some(function (tab, i) {
	        if (i < _this.props.activeTabIndex) {
	          offset += tab.offsetWidth;
	        }
	
	        return i < _this.state.activeTabIndex;
	      });
	
	      _this._container.scrollLeft = offset;
	    };
	
	    _this._handleTabChange = function (index, tabId, tabControlsId, tabChildren, event) {
	      if (_this.props.onTabChange) {
	        _this.props.onTabChange(index, tabId, tabControlsId, tabChildren, event);
	      }
	
	      if (typeof _this.props.activeTabIndex === 'undefined') {
	        _this.setState(_extends({
	          activeTabIndex: index
	        }, _this._calcIndicatorPosition(_this._container, 0, index, _this.state.overflowAtIndex)));
	      }
	    };
	
	    _this._mapToOverflowTabProps = function (tab, i) {
	      var index = i + _this.state.overflowAtIndex;
	      var active = (0, _getField2.default)(_this.props, _this.state, 'activeTabIndex') === index;
	      var tabEl = _react.Children.only(tab);
	      var handleTabChange = _this._handleTabChange;
	
	      return {
	        active: active,
	        primaryText: tabEl.props.label,
	        onClick: function handleClick(event) {
	          var _tabEl$props = tabEl.props,
	              onClick = _tabEl$props.onClick,
	              id = _tabEl$props.id,
	              controlsId = _tabEl$props.controlsId,
	              children = _tabEl$props.children;
	
	          if (onClick) {
	            onClick(index, event);
	          }
	
	          handleTabChange(index, id, controlsId, children, event);
	        }
	      };
	    };
	
	    _this._nextIndexes = function (increment) {
	      var _this$state = _this.state,
	          overflowIndex = _this$state.overflowIndex,
	          overflowAtIndex = _this$state.overflowAtIndex;
	
	      var visibleAmt = (overflowAtIndex - overflowIndex) * (increment ? 1 : -1);
	
	      _this.setState({
	        overflowIndex: overflowIndex + visibleAmt,
	        overflowAtIndex: overflowAtIndex + visibleAmt
	      });
	    };
	
	    _this._showNextTabs = function () {
	      _this._nextIndexes(true);
	    };
	
	    _this._showPreviousTabs = function () {
	      _this._nextIndexes(false);
	    };
	
	    var defaultTabIndex = typeof props.activeTabIndex === 'undefined' ? props.defaultTabIndex : props.activeTabIndex;
	    var indicatorWidth = props.mobile ? MOBILE_TAB_MIN_WIDTH : DESKTOP_TAB_MIN_WIDTH;
	    _this.state = {
	      indicatorWidth: indicatorWidth,
	      indicatorOffset: indicatorWidth * defaultTabIndex,
	      indicatorVisible: true,
	      overflowIndex: 0
	    };
	
	    if (typeof props.activeTabIndex === 'undefined') {
	      _this.state.activeTabIndex = defaultTabIndex;
	    }
	    return _this;
	  }
	
	  _createClass(Tabs, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.activeTabIndex !== nextProps.activeTabIndex) {
	        this.setState(_extends({}, this._calcIndicatorPosition(this._container, 0, nextProps.activeTabIndex, this.state.overflowAtIndex)), this._scrollActiveIntoView);
	      } else if (!this._shouldAlign(nextProps) && this._shouldAlign(this.props)) {
	        this.setState({ paddingLeft: null });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this._shouldAlign(this.props) && this.state.overflowAtIndex !== prevState.overflowAtIndex) {
	        var paddingLeft = this._calcPaddingLeft(this._container, this.state.mobile);
	        // Have to wait for the overflow menus to appear, then wop
	        /* eslint-disable react/no-did-update-set-state */
	        this.setState({ paddingLeft: paddingLeft });
	      } else {
	        var labels = _react.Children.map(_react.Children.toArray(this.props.children), function (_ref) {
	          var label = _ref.props.label;
	          return label;
	        });
	        var prevLabels = _react.Children.map(_react.Children.toArray(prevProps.children), function (_ref2) {
	          var label = _ref2.props.label;
	          return label;
	        });
	        if (labels.length !== prevLabels.length || labels.filter(function (_, i) {
	          return labels[i] !== prevLabels[i];
	        }).length) {
	          this.setState(_extends({}, this._calcIndicatorPosition(this._container, 0, this.props.activeTabIndex, this.state.overflowAtIndex)), this._scrollActiveIntoView);
	        }
	      }
	    }
	  }, {
	    key: '_shouldAlign',
	    value: function _shouldAlign(props) {
	      return typeof props.alignToKeyline === 'boolean' ? props.alignToKeyline : _react.Children.toArray(props.children).filter(function (child) {
	        return !!child;
	      }).length > 3;
	    }
	  }, {
	    key: '_calcPaddingLeft',
	    value: function _calcPaddingLeft(container, mobile) {
	      var mediaPadding = mobile ? MOBILE_PADDING : DESKTOP_PADDING;
	      var tab = container.querySelector('.md-tab');
	
	      var _tab$querySelector = tab.querySelector('.md-tab-label'),
	          labelOffset = _tab$querySelector.offsetLeft;
	
	      return mediaPadding - labelOffset;
	    }
	  }, {
	    key: '_calcOverflowIndex',
	    value: function _calcOverflowIndex(container) {
	      var paddingLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	      var menu = arguments[2];
	
	      var containerWidth = container.offsetWidth;
	      var overflowIndex = 0;
	      if (containerWidth < container.scrollWidth) {
	        var tabs = Array.prototype.slice.call(container.querySelectorAll('.md-tab'));
	        var totalWidth = 0;
	        tabs.some(function (tab, i) {
	          overflowIndex = i;
	          totalWidth += tab.offsetWidth;
	
	          return totalWidth > containerWidth;
	        });
	      }
	
	      return Math.max(0, overflowIndex - (menu ? 1 : 0));
	    }
	  }, {
	    key: '_calcIndicatorPosition',
	    value: function _calcIndicatorPosition(container) {
	      var paddingLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	      var activeTabIndex = arguments[2];
	      var overflowAtIndex = arguments[3];
	
	      var activeItem = void 0;
	      if (typeof activeTabIndex === 'number') {
	        if (overflowAtIndex > 0 && activeTabIndex >= overflowAtIndex) {
	          activeItem = container.querySelector('.md-menu--tab');
	        } else {
	          activeItem = container.querySelectorAll('.md-tab')[activeTabIndex];
	        }
	      } else {
	        activeItem = container.querySelector('.md-tab--active');
	      }
	
	      if (!activeItem) {
	        return { indicatorVisible: false };
	      }
	
	      var _activeItem = activeItem,
	          indicatorWidth = _activeItem.offsetWidth,
	          indicatorOffset = _activeItem.offsetLeft;
	
	      return {
	        indicatorWidth: indicatorWidth,
	        indicatorOffset: indicatorOffset + paddingLeft,
	        indicatorVisible: !overflowAtIndex || overflowAtIndex > activeTabIndex
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          indicatorOffset = _state.indicatorOffset,
	          indicatorWidth = _state.indicatorWidth,
	          indicatorVisible = _state.indicatorVisible,
	          overflowIndex = _state.overflowIndex,
	          overflowAtIndex = _state.overflowAtIndex,
	          paddingLeft = _state.paddingLeft;
	
	      var _props = this.props,
	          Component = _props.component,
	          style = _props.style,
	          className = _props.className,
	          colored = _props.colored,
	          centered = _props.centered,
	          tabId = _props.tabId,
	          overflowMenu = _props.overflowMenu,
	          overflowMenuLabel = _props.overflowMenuLabel,
	          nextIcon = _props.nextIcon,
	          previousIcon = _props.previousIcon,
	          overflowMenuIcon = _props.overflowMenuIcon,
	          overflowMenuIconChildren = _props.overflowMenuIconChildren,
	          overflowMenuIconClassName = _props.overflowMenuIconClassName,
	          nextIconChildren = _props.nextIconChildren,
	          nextIconClassName = _props.nextIconClassName,
	          previousIconChildren = _props.previousIconChildren,
	          previousIconClassName = _props.previousIconClassName,
	          propActiveIndex = _props.activeTabIndex,
	          defaultTabIndex = _props.defaultTabIndex,
	          onTabChange = _props.onTabChange,
	          alignToKeyline = _props.alignToKeyline,
	          mobile = _props.mobile,
	          defaultMedia = _props.defaultMedia,
	          desktopMinWidth = _props.desktopMinWidth,
	          props = _objectWithoutProperties(_props, ['component', 'style', 'className', 'colored', 'centered', 'tabId', 'overflowMenu', 'overflowMenuLabel', 'nextIcon', 'previousIcon', 'overflowMenuIcon', 'overflowMenuIconChildren', 'overflowMenuIconClassName', 'nextIconChildren', 'nextIconClassName', 'previousIconChildren', 'previousIconClassName', 'activeTabIndex', 'defaultTabIndex', 'onTabChange', 'alignToKeyline', 'mobile', 'defaultMedia', 'desktopMinWidth']);
	
	      var activeTabIndex = (0, _getField2.default)(this.props, this.state, 'activeTabIndex');
	
	      var icon = false;
	      var children = _react.Children.map(_react.Children.toArray(this.props.children), function (tab, index) {
	        var handleOnClick = function handleOnClick(tabIndex, id, tabControlsId, tabChildren, event) {
	          if (tab.props.onClick) {
	            tab.props.onClick(tabId, id, tabControlsId, tabChildren, event);
	          }
	
	          _this2._handleTabChange(tabIndex, id, tabControlsId, tabChildren, event);
	        };
	
	        if (tab.props.icon) {
	          icon = true;
	        }
	
	        return (0, _react.cloneElement)(tab, {
	          index: index,
	          id: tab.props.id || tabId + '-' + index,
	          controlsId: tab.props.controlsId || tabId + '-panel-' + index,
	          active: index === activeTabIndex,
	          onClick: handleOnClick
	        });
	      });
	
	      var overflow = void 0;
	      var nextControl = void 0;
	      var previousControl = void 0;
	      if (overflowAtIndex) {
	        var length = children.length;
	        if (overflowMenu) {
	          overflow = _react2.default.createElement(_MenuTab2.default, {
	            id: tabId + '-overflow-menu',
	            activeTabIndex: activeTabIndex,
	            overflowAtIndex: overflowAtIndex,
	            label: _react2.default.createElement(
	              _IconSeparator2.default,
	              { label: overflowMenuLabel },
	              (0, _getDeprecatedIcon2.default)(overflowMenuIconClassName, overflowMenuIconChildren, overflowMenuIcon)
	            ),
	            tabs: children.slice(overflowAtIndex, children.length).map(this._mapToOverflowTabProps)
	          });
	        }
	
	        children = children.slice(overflowIndex, overflowAtIndex);
	
	        if (!overflowMenu && overflowIndex > 0) {
	          previousControl = _react2.default.createElement(_TabOverflowButton2.default, {
	            left: true,
	            icon: icon,
	            iconEl: (0, _getDeprecatedIcon2.default)(previousIconClassName, previousIconChildren, previousIcon),
	            onClick: this._showPreviousTabs
	          });
	        }
	
	        if (!overflowMenu && length > 3 && overflowAtIndex + overflowIndex <= length) {
	          nextControl = _react2.default.createElement(_TabOverflowButton2.default, {
	            icon: icon,
	            onClick: this._showNextTabs,
	            iconEl: (0, _getDeprecatedIcon2.default)(nextIconClassName, nextIconChildren, nextIcon)
	          });
	        }
	      }
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, {
	          style: _extends({}, style, { paddingLeft: paddingLeft }),
	          className: (0, _classnames2.default)('md-tabs', {
	            'md-tabs--pagination': overflowAtIndex && !overflowMenu,
	            'md-tabs--centered': centered,
	            'md-background--primary': colored
	          }, className),
	          role: 'tablist'
	        }),
	        _react2.default.createElement(_ResizeObserver2.default, { watchWidth: true, watchHeight: true, onResize: this._positionElements, elRef: this._setContainer }),
	        previousControl,
	        children,
	        nextControl,
	        overflow,
	        _react2.default.createElement(_TabIndicator2.default, { offset: indicatorOffset, width: indicatorWidth, visible: indicatorVisible })
	      );
	    }
	  }]);
	
	  return Tabs;
	}(_react.PureComponent);
	
	Tabs.propTypes = {
	  /**
	   * A base id to use for each `Tab`. When the child tabs are created, they are cloned
	   * with some additional accessibility props. Each tab will get a prop with this and the
	   * current index of the tab.
	   */
	  tabId: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The component to render the tabs in.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * This should either be a single `Tab` component or a list of `Tab` components. Unfortunately,
	   * the child *must* be exactly a `Tab` component because this is unable to extract the correct
	   * `label` and `children` from a custom `Tab` component.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]).isRequired,
	
	  /**
	   * Boolean if the tabs should be centered instead of aligned to the keyline. The tabs will
	   * only be aligned to the keyline when there are more than 3 tabs and the `alignToKeyline`
	   * prop is `false`.
	   */
	  centered: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the tabs should align to a toolbar's title keyline. If this is undefined,
	   * the tabs will try to align to the keyline when there are more than 3 tabs.
	   */
	  alignToKeyline: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the tabs should be colored with the primary color. If this is false or undefined,
	   * the tabs will be colored for the light or dark theme.
	   */
	  colored: _propTypes2.default.bool,
	
	  /**
	   * A boolean if the overflow tabs on desktop displays should appear in a menu. If this is false,
	   * the additional tabs will be available by using pagination buttons.
	   */
	  overflowMenu: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when the active tab is changed. The callback will include
	   * the new active tab index and a click event.
	   *
	   * ```js
	   * onTabChange(newTabIndex, event);
	   * ```
	   */
	  onTabChange: _propTypes2.default.func,
	
	  /**
	   * An optional active tab index to use. If this is defined, it will make the component controlled
	   * and require the `onTabChange` prop to be defined.
	   */
	  activeTabIndex: (0, _controlled2.default)(_propTypes2.default.number, 'onTabChange', 'defaultTabIndex'),
	
	  /**
	   * The default tab index to use when the component is uncontrolled.
	   */
	  defaultTabIndex: _propTypes2.default.number.isRequired,
	
	  /**
	   * When the `overflowMenu` prop is false, this will be used to render the "next slice of tabs"
	   * when there are too many tabs to display at once on desktop screens.
	   */
	  nextIcon: _propTypes2.default.element,
	
	  /**
	   * When the `overflowMenu` prop is false, this will be used to render the "previous slice of tabs"
	   * when there are too many tabs to display at once on desktop screens.
	   */
	  previousIcon: _propTypes2.default.element,
	
	  /**
	   * When the `overflowMenu` prop is true, this will be used to render the `MenuTab` overflow menu.
	   * This will be to render the icon to the right of the label.
	   */
	  overflowMenuIcon: _propTypes2.default.element,
	
	  /**
	   * When the `overflowMenu` prop is true, this will be used to render the `MenuTab` overflow menu.
	   * This will be the text that displays as a tab.
	   */
	  overflowMenuLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the tabs are currently rendered on a mobile or tablet device. This is used to calculate
	   * overflow/padding on the tabs.
	   */
	  mobile: _propTypes2.default.bool,
	  defaultMedia: (0, _deprecated2.default)(_propTypes2.default.oneOf(['mobile', 'tablet', 'desktop']), 'Use `mobile` instead'),
	  desktopMinWidth: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `mobile` instead.'),
	  nextIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `nextIcon` prop instead'),
	  nextIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `nextIcon` prop instead'),
	  previousIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `previousIcon` prop instead'),
	  previousIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `previousIcon` prop instead'),
	  overflowMenuIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `overflowMenuIcon` prop instead'),
	  overflowMenuIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `overflowMenuIcon` prop instead')
	};
	Tabs.defaultProps = {
	  component: 'ul',
	  defaultTabIndex: 0,
	  nextIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'keyboard_arrow_right'
	  ),
	  previousIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'keyboard_arrow_left'
	  ),
	  overflowMenuLabel: 'More',
	  overflowMenuIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'arrow_drop_down'
	  )
	};
	exports.default = Tabs;
	//# sourceMappingURL=Tabs.js.map

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSwipeableViews = __webpack_require__(728);
	
	var _reactSwipeableViews2 = _interopRequireDefault(_reactSwipeableViews);
	
	var _getField = __webpack_require__(11);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _controlled = __webpack_require__(16);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _between = __webpack_require__(85);
	
	var _between2 = _interopRequireDefault(_between);
	
	var _ResizeObserver = __webpack_require__(32);
	
	var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);
	
	var _Paper = __webpack_require__(33);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _TabPanel = __webpack_require__(289);
	
	var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TabsContainer` component is used when you want to have your `Tabs` connected with
	 * the `SwipeableViews`. This component will traverse the children subtree and extract out
	 * the `children` from each tab, and render them in a swipeable container. However,
	 * since this is using the `React.Children` traversal, You will have to keep the `Tabs`
	 * and `Tab` component as a direct descendent. You are unable to make a separate component
	 * that encompasses the `Tab` component.
	 *
	 * ```js
	 * // valid
	 * <TabsContainer>
	 *   <Tabs>
	 *     <Tab />
	 *   </Tabs>
	 * </TabsContainer>
	 *
	 * // invalid
	 * <TabsContainer>
	 *   <Tabs>
	 *     <MyCustomTab />
	 *   </Tabs>
	 * </TabsContainer>
	 * ```
	 *
	 * This is because it seems you are unable to access the `MyCustomTab`'s child Tab props correctly.
	 * You can however have the tab's children as a separate component if you wish.
	 */
	var TabsContainer = function (_PureComponent) {
	  _inherits(TabsContainer, _PureComponent);
	
	  function TabsContainer(props) {
	    _classCallCheck(this, TabsContainer);
	
	    var _this = _possibleConstructorReturn(this, (TabsContainer.__proto__ || Object.getPrototypeOf(TabsContainer)).call(this, props));
	
	    _this._handleTabChange = function (index, tabId, tabControlsId, tabChildren, event) {
	      if (_this.props.onTabChange) {
	        _this.props.onTabChange(index, tabId, tabControlsId, tabChildren, event);
	      }
	
	      if (typeof _this.props.activeTabIndex === 'undefined') {
	        _this.setState({ activeTabIndex: index });
	      }
	    };
	
	    _this._handleSwipeChange = function (activeTabIndex) {
	      _this._handleTabChange(activeTabIndex);
	    };
	
	    _this._setContainer = function (container) {
	      _this._container = (0, _reactDom.findDOMNode)(container);
	    };
	
	    _this._resizePanel = function () {
	      if (!_this._container) {
	        return;
	      }
	
	      var activePanel = _this._container.querySelector('.md-tab-panel[aria-hidden=false]');
	      if (activePanel && _this.state.panelHeight !== activePanel.offsetHeight) {
	        _this.setState({ panelHeight: activePanel.offsetHeight });
	      }
	    };
	
	    _this.state = {};
	    if (typeof props.activeTabIndex === 'undefined') {
	      _this.state.activeTabIndex = props.defaultTabIndex;
	    }
	    return _this;
	  }
	
	  _createClass(TabsContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._resizePanel();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var prevIndex = (0, _getField2.default)(prevProps, prevState, 'activeTabIndex');
	      var currIndex = (0, _getField2.default)(this.props, this.state, 'activeTabIndex');
	
	      if (prevIndex !== currIndex) {
	        this._resizePanel();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var panelHeight = this.state.panelHeight;
	
	      var _props = this.props,
	          Component = _props.component,
	          style = _props.style,
	          className = _props.className,
	          panelStyle = _props.panelStyle,
	          panelClassName = _props.panelClassName,
	          panelComponent = _props.panelComponent,
	          headerStyle = _props.headerStyle,
	          headerClassName = _props.headerClassName,
	          slideStyle = _props.slideStyle,
	          slideHeightProp = _props.slideHeightProp,
	          swipeableViewsStyle = _props.swipeableViewsStyle,
	          swipeableViewsClassName = _props.swipeableViewsClassName,
	          headerComponent = _props.headerComponent,
	          headerZDepth = _props.headerZDepth,
	          children = _props.children,
	          colored = _props.colored,
	          fixed = _props.fixed,
	          labelAndIcon = _props.labelAndIcon,
	          swipeableViewsProps = _props.swipeableViewsProps,
	          themed = _props.themed,
	          propToolbar = _props.toolbar,
	          propActiveTabeIndex = _props.activeTabIndex,
	          onTabChange = _props.onTabChange,
	          defaultTabIndex = _props.defaultTabIndex,
	          props = _objectWithoutProperties(_props, ['component', 'style', 'className', 'panelStyle', 'panelClassName', 'panelComponent', 'headerStyle', 'headerClassName', 'slideStyle', 'slideHeightProp', 'swipeableViewsStyle', 'swipeableViewsClassName', 'headerComponent', 'headerZDepth', 'children', 'colored', 'fixed', 'labelAndIcon', 'swipeableViewsProps', 'themed', 'toolbar', 'activeTabIndex', 'onTabChange', 'defaultTabIndex']);
	
	      var toolbar = this.props.toolbar;
	
	
	      var activeTabIndex = (0, _getField2.default)(this.props, this.state, 'activeTabIndex');
	
	      var tabsEl = _react.Children.only(children);
	      var tabId = tabsEl.props.tabId;
	      var content = _react.Children.map(tabsEl.props.children, function (tab, index) {
	        if (!tab) {
	          return tab;
	        }
	
	        return _react2.default.createElement(
	          _TabPanel2.default,
	          {
	            id: tab.props.controlsId || tabId + '-panel-' + index,
	            active: activeTabIndex === index,
	            style: panelStyle,
	            className: panelClassName,
	            component: panelComponent,
	            controlledById: tab.props.id || tabId + '-' + index
	          },
	          _react2.default.createElement(_ResizeObserver2.default, { watchHeight: true, onResize: _this2._resizePanel }),
	          tab.props.children
	        );
	      });
	
	      var childrenProps = _react.Children.only(children).props;
	      var tabs = (0, _react.cloneElement)(children, {
	        colored: typeof childrenProps.colored !== 'undefined' ? childrenProps.colored : colored,
	        onTabChange: this._handleTabChange,
	        activeTabIndex: activeTabIndex
	      });
	
	      var prominentToolbar = false;
	      if (toolbar) {
	        var toolbarProps = _react.Children.only(toolbar).props;
	        toolbar = (0, _react.cloneElement)(toolbar, {
	          component: toolbarProps.component || 'div',
	          colored: typeof toolbarProps.colored !== 'undefined' ? childrenProps.colored : colored
	        });
	
	        prominentToolbar = toolbarProps.prominent || toolbarProps.prominentTitle;
	      }
	
	      var header = void 0;
	      if (fixed) {
	        header = _react2.default.createElement(
	          _Paper2.default,
	          {
	            style: headerStyle,
	            className: (0, _classnames2.default)('md-tabs-fixed-container', {
	              'md-toolbar--themed': themed
	            }, headerClassName),
	            zDepth: headerZDepth,
	            component: headerComponent
	          },
	          toolbar,
	          tabs
	        );
	      }
	
	      var baseSlideStyle = _defineProperty({}, slideHeightProp, panelHeight);
	
	      return _react2.default.createElement(
	        Component,
	        _extends({
	          style: style,
	          className: (0, _classnames2.default)('md-tabs-container', className)
	        }, props, {
	          ref: this._setContainer
	        }),
	        header,
	        header ? null : toolbar,
	        header ? null : tabs,
	        _react2.default.createElement(
	          _reactSwipeableViews2.default,
	          _extends({}, swipeableViewsProps, {
	            style: swipeableViewsStyle,
	            className: (0, _classnames2.default)('md-tabs-content', {
	              'md-tabs-content--offset': !toolbar && !labelAndIcon && fixed,
	              'md-tabs-content--offset-icon': !toolbar && fixed && labelAndIcon,
	              'md-tabs-content--offset-toolbar': toolbar && fixed && !prominentToolbar && !labelAndIcon,
	              'md-tabs-content--offset-toolbar-prominent': toolbar && fixed && prominentToolbar && !labelAndIcon,
	              'md-tabs-content--offset-toolbar-icon': fixed && toolbar && labelAndIcon && !prominentToolbar,
	              'md-tabs-content--offset-toolbar-prominent-icon': fixed && toolbar && labelAndIcon && prominentToolbar
	            }, swipeableViewsClassName),
	            slideStyle: _extends({}, baseSlideStyle, typeof slideStyle === 'function' ? slideStyle(baseSlideStyle, panelHeight) : slideStyle),
	            index: activeTabIndex,
	            onChangeIndex: this._handleSwipeChange
	          }),
	          content
	        )
	      );
	    }
	  }]);
	
	  return TabsContainer;
	}(_react.PureComponent);
	
	TabsContainer.propTypes = {
	  /**
	   * An optional style to apply to the container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to each `TabPanel` that gets generated. Each tab's children
	   * will get wrapped in a `TabPanel` component.
	   */
	  panelStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to each each `TabPanel` that gets generated. Each tab's
	   * children will get wrapped in a `TabPanel` component.
	   */
	  panelClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the header component when the tabs are fixed to the top of the page.
	   * The optional toolbar and tabs get wrapped in a `Paper` component.
	   */
	  headerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the header component when the tabs are fixed to the top of the page.
	   * The optional toolbar and tabs get wrapped in a `Paper` component.
	   */
	  headerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `SwipeableViews`.
	   *
	   * @see https://github.com/oliviertassinari/react-swipeable-views#user-content-swipeableviews-
	   */
	  swipeableViewsStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `SwipeableViews` container.
	   */
	  swipeableViewsClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to each slide component or a function that returns such style.
	   *
	   * Default style and height of slide component will be passed in the function.
	   * The function should return a style that will be merged with default style, or `null`.
	   *
	   * @see https://github.com/oliviertassinari/react-swipeable-views#user-content-swipeableviews-
	   */
	  slideStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
	
	  /**
	   * The property that should be used to set height of a slide component.
	   */
	  slideHeightProp: _propTypes2.default.oneOf(['height', 'minHeight', 'maxHeight']),
	
	  /**
	   * This should be a `Tabs` component with children of `Tab`. This is used to figure out which
	   * tab's content is currently visible.
	   */
	  children: _propTypes2.default.element.isRequired,
	
	  /**
	   * The component to render the container as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * The component to render each `TabPanel` as.
	   */
	  panelComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	
	  /**
	   * An optional toolbar to render above the tabs.
	   */
	  toolbar: _propTypes2.default.element,
	
	  /**
	   * An optional active tab index to use. If this is defined, the component will be controlled
	   * and require the `onTabChange` prop to be defined.
	   */
	  activeTabIndex: (0, _controlled2.default)(_propTypes2.default.number, 'onTabChange', 'defaultTabIndex'),
	
	  /**
	   * An optional function to call when a new tab is selected by swiping or clicking a tab. When
	   * a new tab has been clicked, the callback will include the active tab index, the tab's `id`,
	   * the tab's `controlsId`, the tab's `children`, and the click event.
	   *
	   * If the tab was changed by swiping, it will only contain the new active tab index.
	   *
	   * ```js
	   * onTabChange(newActiveTabIndex, tabId, tabControlsId, tabChildren, event);
	   * ```
	   */
	  onTabChange: _propTypes2.default.func,
	
	  /**
	   * The default tab index to use when the component is uncontrolled.
	   */
	  defaultTabIndex: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the `toolbar` and `Tabs` should be cloned with `colored: true`.
	   */
	  colored: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `toolbar` should be applied with the theme color. This _really_ only
	   * applies when you create a `fixed` tabs container.
	   */
	  themed: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the tabs and the optional toolbar should be fixed to the top of the page.
	   */
	  fixed: _propTypes2.default.bool,
	
	  /**
	   * A boolean if a `fixed` `TabsContainer` has tabs with a label and an icon.
	   */
	  labelAndIcon: _propTypes2.default.bool,
	
	  /**
	   * An optional component to render the fixed tabs header as.
	   */
	  headerComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	
	  /**
	   * The zDepth for the fixed tabs header.
	   */
	  headerZDepth: (0, _between2.default)(_propTypes2.default.number, 0, 5),
	
	  /**
	   * Any additional props to apply to the SwipeableViews component. View the
	   * [SwipeableViews API](https://github.com/oliviertassinari/react-swipeable-views#api)
	   * for valid attributes.
	   *
	   * You will not be able to set the `style`, `className`, `slideStyle`, `index`,
	   * or `onChangeIndex` props for the SwipeableViews.
	   *
	   * The styling and classnames can be updated with the other TabsContainer props.
	   */
	  swipeableViewsProps: _propTypes2.default.object
	};
	TabsContainer.defaultProps = {
	  component: 'section',
	  defaultTabIndex: 0,
	  headerZDepth: 1,
	  slideHeightProp: 'height'
	};
	exports.default = TabsContainer;
	//# sourceMappingURL=TabsContainer.js.map

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabPanel = exports.MenuTab = exports.Tab = exports.Tabs = exports.TabsContainer = undefined;
	
	var _TabsContainer2 = __webpack_require__(652);
	
	var _TabsContainer3 = _interopRequireDefault(_TabsContainer2);
	
	var _Tabs2 = __webpack_require__(651);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Tab2 = __webpack_require__(648);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _MenuTab2 = __webpack_require__(288);
	
	var _MenuTab3 = _interopRequireDefault(_MenuTab2);
	
	var _TabPanel2 = __webpack_require__(289);
	
	var _TabPanel3 = _interopRequireDefault(_TabPanel2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TabsContainer3.default;
	exports.TabsContainer = _TabsContainer3.default;
	exports.Tabs = _Tabs3.default;
	exports.Tab = _Tab3.default;
	exports.MenuTab = _MenuTab3.default;
	exports.TabPanel = _TabPanel3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(12);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _TextArea = __webpack_require__(657);
	
	var _TextArea2 = _interopRequireDefault(_TextArea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component either renders a base `input` tag or the `TextArea` component.
	 */
	var InputField = function (_PureComponent) {
	  _inherits(InputField, _PureComponent);
	
	  function InputField() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InputField);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputField.__proto__ || Object.getPrototypeOf(InputField)).call.apply(_ref, [this].concat(args))), _this), _this.getField = function () {
	      // eslint-disable-line arrow-body-style
	      return typeof _this.props.rows === 'undefined' ? _this._field : _this._field.getField();
	    }, _this.getValue = function () {
	      if (typeof _this.props.rows === 'undefined') {
	        return _this._field.value;
	      }
	
	      return _this._field.getValue();
	    }, _this.focus = function () {
	      _this._field.focus();
	    }, _this.blur = function () {
	      _this._field.blur();
	    }, _this._setField = function (field) {
	      _this._field = field;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InputField, [{
	    key: 'render',
	    value: function render() {
	      var _cn;
	
	      var _props = this.props,
	          className = _props.className,
	          rows = _props.rows,
	          label = _props.label,
	          customSize = _props.customSize,
	          fullWidth = _props.fullWidth,
	          type = _props.type,
	          passwordVisible = _props.passwordVisible,
	          block = _props.block,
	          inlineIndicator = _props.inlineIndicator,
	          maxRows = _props.maxRows,
	          props = _objectWithoutProperties(_props, ['className', 'rows', 'label', 'customSize', 'fullWidth', 'type', 'passwordVisible', 'block', 'inlineIndicator', 'maxRows']);
	
	      var multiline = typeof rows !== 'undefined';
	      var Component = multiline ? _TextArea2.default : 'input';
	      if (!multiline) {
	        props.type = passwordVisible ? 'text' : type;
	      } else {
	        props.label = label;
	        props.block = block;
	        props.maxRows = maxRows;
	      }
	
	      return (0, _react.createElement)(Component, _extends({}, props, {
	        rows: rows,
	        ref: this._setField,
	        className: (0, _classnames2.default)('md-text-field', (_cn = {
	          'md-text-field--inline-indicator': inlineIndicator || !multiline && type === 'password',
	          'md-text-field--multiline': multiline,
	          'md-text-field--margin': !block && !multiline && !label,
	          'md-text-field--floating-margin': !block && !multiline && label
	        }, _defineProperty(_cn, 'md-text-field--' + customSize, customSize), _defineProperty(_cn, 'md-full-width', fullWidth), _cn), (0, _themeColors2.default)({ disabled: props.disabled, text: !props.disabled }, className))
	      }));
	    }
	  }]);
	
	  return InputField;
	}(_react.PureComponent);
	
	InputField.propTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  type: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  block: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  rows: _propTypes2.default.number,
	  maxRows: _propTypes2.default.number,
	  label: _propTypes2.default.node,
	  fullWidth: _propTypes2.default.bool,
	  customSize: _propTypes2.default.string,
	  passwordVisible: _propTypes2.default.bool,
	  inlineIndicator: _propTypes2.default.bool
	};
	exports.default = InputField;
	//# sourceMappingURL=InputField.js.map

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Message = function (_PureComponent) {
	  _inherits(Message, _PureComponent);
	
	  function Message() {
	    _classCallCheck(this, Message);
	
	    return _possibleConstructorReturn(this, (Message.__proto__ || Object.getPrototypeOf(Message)).apply(this, arguments));
	  }
	
	  _createClass(Message, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          className = _props.className;
	
	
	      if (!children) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          'aria-hidden': !active,
	          className: (0, _classnames2.default)('md-text-field-message', 'md-text-field-message--' + (active ? '' : 'in') + 'active', className)
	        },
	        children
	      );
	    }
	  }]);
	
	  return Message;
	}(_react.PureComponent);
	
	Message.propTypes = {
	  active: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node
	};
	exports.default = Message;
	//# sourceMappingURL=Message.js.map

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keyCodes = __webpack_require__(15);
	
	var _themeColors = __webpack_require__(12);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PasswordButton = function (_PureComponent) {
	  _inherits(PasswordButton, _PureComponent);
	
	  function PasswordButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PasswordButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PasswordButton.__proto__ || Object.getPrototypeOf(PasswordButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = { keyboardFocus: false }, _this._handleOutsideClick = function (e) {
	      if (_this._button && !_this._button.contains(e.target)) {
	        window.removeEventListener('click', _this._handleOutsideClick);
	        _this.setState({ keyboardFocus: false });
	      }
	    }, _this._handleBlur = function () {
	      if (_this.state.keyboardFocus) {
	        _this.setState({ keyboardFocus: false });
	      }
	    }, _this._handleKeyUp = function (e) {
	      var key = e.which || e.keyCode;
	      if (key === _keyCodes.TAB) {
	        _this.setState({ keyboardFocus: true });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PasswordButton, [{
	    key: 'render',
	    value: function render() {
	      var keyboardFocus = this.state.keyboardFocus;
	
	      var _props = this.props,
	          active = _props.active,
	          passwordVisible = _props.passwordVisible,
	          block = _props.block,
	          floating = _props.floating,
	          icon = _props.icon,
	          props = _objectWithoutProperties(_props, ['active', 'passwordVisible', 'block', 'floating', 'icon']);
	
	      return _react2.default.createElement(
	        'button',
	        _extends({}, props, {
	          onBlur: this._handleBlur,
	          onKeyUp: this._handleKeyUp,
	          type: 'button',
	          className: (0, _classnames2.default)('md-text-field-inline-indicator md-password-btn md-pointer--hover', {
	            'md-password-btn--focus': keyboardFocus,
	            'md-password-btn--invisible': active && !passwordVisible,
	            'md-text-field-inline-indicator--floating': floating,
	            'md-text-field-inline-indicator--block': block
	          }, (0, _themeColors2.default)({ disabled: !active, hint: active }))
	        }),
	        icon
	      );
	    }
	  }]);
	
	  return PasswordButton;
	}(_react.PureComponent);
	
	PasswordButton.propTypes = {
	  active: _propTypes2.default.bool,
	  passwordVisible: _propTypes2.default.bool,
	  icon: _propTypes2.default.element,
	  block: _propTypes2.default.bool,
	  floating: _propTypes2.default.bool
	};
	exports.default = PasswordButton;
	//# sourceMappingURL=PasswordButton.js.map

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ResizeObserver = __webpack_require__(32);
	
	var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TextArea` component is used to allow a dynamic height for the
	 * `textarea`. The height will keep on changing until the maxRows prop
	 * is met or infinitely if it does not exist, or is 0.
	 */
	var TextArea = function (_PureComponent) {
	  _inherits(TextArea, _PureComponent);
	
	  function TextArea() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TextArea);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextArea.__proto__ || Object.getPrototypeOf(TextArea)).call.apply(_ref, [this].concat(args))), _this), _this.state = { height: null }, _this.getField = function () {
	      return _this._field;
	    }, _this.getValue = function () {
	      return _this._field.value;
	    }, _this.focus = function () {
	      _this._field.focus();
	    }, _this.blur = function () {
	      _this._field.blur();
	    }, _this._calcRowHeight = function () {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props,
	          rows = _ref2.rows;
	
	      if (!_this._field) {
	        return 19;
	      }
	
	      var height = _this._field.style.height;
	      _this._field.style.height = 'auto';
	      var rowHeight = _this._field.offsetHeight / rows;
	      _this._field.style.height = height;
	      return rowHeight;
	    }, _this._setMask = function (mask) {
	      _this._mask = mask;
	    }, _this._setField = function (field) {
	      _this._field = field;
	    }, _this._handleResize = function () {
	      _this._rowHeight = _this._calcRowHeight();
	      _this._syncHeightWithMask();
	    }, _this._syncHeightWithMask = function (value) {
	      // The mask is always null in snapshot teseting
	      if (!_this._mask) {
	        return;
	      }
	
	      if (value !== undefined) {
	        _this._mask.value = value;
	      }
	
	      var height = _this._mask.scrollHeight;
	      if (height === undefined) {
	        return;
	      }
	
	      var _this$props = _this.props,
	          rows = _this$props.rows,
	          maxRows = _this$props.maxRows;
	
	      if (maxRows && maxRows > 0) {
	        height = Math.min(height, _this._rowHeight * maxRows);
	      }
	
	      height = Math.max(_this._rowHeight * rows, height);
	      _this.setState({ height: height });
	    }, _this._handleChange = function (e) {
	      _this._syncHeightWithMask(e.target.value, e);
	
	      if (_this.props.onChange) {
	        _this.props.onChange(e);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TextArea, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._rowHeight = this._calcRowHeight();
	      this._syncHeightWithMask();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.rows !== nextProps.rows) {
	        this._rowHeight = this._calcRowHeight(nextProps);
	      }
	
	      if (this.props.value !== nextProps.value || this.props.maxRows !== nextProps.maxRows) {
	        this._syncHeightWithMask(nextProps.value);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var height = this.state.height;
	
	      var _props = this.props,
	          style = _props.style,
	          defaultValue = _props.defaultValue,
	          value = _props.value,
	          className = _props.className,
	          label = _props.label,
	          block = _props.block,
	          maxRows = _props.maxRows,
	          onChange = _props.onChange,
	          props = _objectWithoutProperties(_props, ['style', 'defaultValue', 'value', 'className', 'label', 'block', 'maxRows', 'onChange']);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: { height: height && height + 5 },
	          className: (0, _classnames2.default)('md-text-field-multiline-container', {
	            'md-text-field--margin': !label && !block,
	            'md-text-field--floating-margin': label && !block
	          })
	        },
	        _react2.default.createElement(_ResizeObserver2.default, { watchWidth: true, onResize: this._handleResize }),
	        _react2.default.createElement('textarea', {
	          ref: this._setMask,
	          className: (0, _classnames2.default)(className, 'md-text-field--multiline-mask'),
	          readOnly: true,
	          rows: props.rows,
	          tabIndex: -1,
	          style: style,
	          defaultValue: defaultValue,
	          'aria-hidden': true,
	          value: value
	        }),
	        _react2.default.createElement('textarea', _extends({}, props, {
	          ref: this._setField,
	          style: Object.assign({}, style, { height: height }),
	          className: className,
	          defaultValue: defaultValue,
	          value: value,
	          onChange: this._handleChange
	        }))
	      );
	    }
	  }]);
	
	  return TextArea;
	}(_react.PureComponent);
	
	TextArea.propTypes = {
	  id: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  rows: _propTypes2.default.number.isRequired,
	  maxRows: _propTypes2.default.number,
	  onChange: _propTypes2.default.func,
	  defaultValue: _propTypes2.default.string,
	  floatingLabel: _propTypes2.default.bool,
	  value: _propTypes2.default.string,
	  block: _propTypes2.default.bool,
	  label: _propTypes2.default.node
	};
	exports.default = TextArea;
	//# sourceMappingURL=TextArea.js.map

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextField = undefined;
	
	var _TextField2 = __webpack_require__(65);
	
	var _TextField3 = _interopRequireDefault(_TextField2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TextField3.default;
	exports.TextField = _TextField3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ToolbarTitle = function (_PureComponent) {
	  _inherits(ToolbarTitle, _PureComponent);
	
	  function ToolbarTitle() {
	    _classCallCheck(this, ToolbarTitle);
	
	    return _possibleConstructorReturn(this, (ToolbarTitle.__proto__ || Object.getPrototypeOf(ToolbarTitle)).apply(this, arguments));
	  }
	
	  _createClass(ToolbarTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          className = _props.className,
	          prominent = _props.prominent,
	          offset = _props.offset,
	          props = _objectWithoutProperties(_props, ['title', 'className', 'prominent', 'offset']);
	
	      if (!title) {
	        return null;
	      }
	
	      var fullClassName = (0, _classnames2.default)('md-title md-title--toolbar', {
	        'md-title--toolbar-prominent': prominent,
	        'md-title--toolbar-offset': offset
	      }, className);
	
	      if ((0, _react.isValidElement)(title)) {
	        var titleEl = _react.Children.only(title);
	        return (0, _react.cloneElement)(title, _extends({}, props, {
	          id: titleEl.props.id || props.id,
	          className: (0, _classnames2.default)(fullClassName, titleEl.props.className)
	        }));
	      }
	
	      return _react2.default.createElement(
	        'h2',
	        _extends({}, props, {
	          className: fullClassName
	        }),
	        title
	      );
	    }
	  }]);
	
	  return ToolbarTitle;
	}(_react.PureComponent);
	
	ToolbarTitle.propTypes = {
	  className: _propTypes2.default.string,
	  prominent: _propTypes2.default.bool,
	  offset: _propTypes2.default.bool,
	  title: _propTypes2.default.node
	};
	exports.default = ToolbarTitle;
	//# sourceMappingURL=ToolbarTitle.js.map

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Toolbar = undefined;
	
	var _Toolbar2 = __webpack_require__(293);
	
	var _Toolbar3 = _interopRequireDefault(_Toolbar2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Toolbar3.default;
	exports.Toolbar = _Toolbar3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CSSTransitionGroupTick = __webpack_require__(34);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tooltip = function (_PureComponent) {
	  _inherits(Tooltip, _PureComponent);
	
	  function Tooltip(props) {
	    _classCallCheck(this, Tooltip);
	
	    var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));
	
	    _this.state = {
	      entering: false,
	      leaving: false,
	      active: false,
	      visible: false
	    };
	
	    _this._timeout = null;
	    return _this;
	  }
	
	  _createClass(Tooltip, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(cb) {
	      var _this2 = this;
	
	      this._timeout = setTimeout(function () {
	        _this2._timeout = setTimeout(function () {
	          _this2._timeout = null;
	
	          cb();
	        }, _this2.props.enterTimeout);
	        _this2.setState({ active: true });
	      }, _CSSTransitionGroupTick2.default);
	
	      this.setState({ entering: true });
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.setState({ entering: false, active: false, visible: true });
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(cb) {
	      var _this3 = this;
	
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	
	      this._timeout = setTimeout(function () {
	        _this3._timeout = setTimeout(function () {
	          _this3._timeout = null;
	
	          cb();
	        }, _this3.props.leaveTimeout);
	
	        _this3.setState({ active: true, visible: false });
	      }, _CSSTransitionGroupTick2.default);
	
	      this.setState({ leaving: true });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          active = _state.active,
	          entering = _state.entering,
	          leaving = _state.leaving,
	          visible = _state.visible;
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          children = _props.children,
	          position = _props.position;
	
	
	      var direction = position === 'top' || position === 'bottom' ? 'horizontal' : 'vertical';
	      return _react2.default.createElement(
	        'span',
	        {
	          style: style,
	          className: (0, _classnames2.default)('md-tooltip md-tooltip--' + position + ' md-tooltip--' + direction, _defineProperty({
	            'md-tooltip--active': active,
	            'md-tooltip--enter': entering,
	            'md-tooltip--enter-active': entering && active,
	            'md-tooltip--leave': leaving,
	            'md-tooltip--leave-active': leaving && active
	          }, 'md-tooltip--' + position + '-active', visible || entering && active), className)
	        },
	        children
	      );
	    }
	  }]);
	
	  return Tooltip;
	}(_react.PureComponent);
	
	Tooltip.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  position: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	  children: _propTypes2.default.node.isRequired,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};
	Tooltip.defaultProps = {
	  position: 'bottom',
	  enterTimeout: 150,
	  leaveTimeout: 150
	};
	exports.default = Tooltip;
	//# sourceMappingURL=Tooltip.js.map

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Tooltipped;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TooltipContainer = __webpack_require__(294);
	
	var _TooltipContainer2 = _interopRequireDefault(_TooltipContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Adds a tooltip for a component/element given as the only child.
	 *
	 * The component should render its children, or the tooltip will not be shown.
	 * Also the component should be positioned by `className` or `style`
	 * (CSS property `position` should have value `relative`, `absolute` or `fixed`),
	 * or the tooltip can appear incorrectly.
	 * Use `setPosition={true}` to automatically add `position: 'relative'` to the `style` of the wrapped component.
	 *
	 * Besides of `children` and `setPosition` all props set for `Tooltipped` component are passed through
	 * to `TooltipContainer` that is added as a child of the wrapped component and controls the tooltip.
	 *
	 * ```js
	 * <Tooltipped
	 *   label="Tooltip for text"
	 *   position="left"
	 *   delay={1000}
	 * >
	 *   <span style={{position: 'absolute', top: '10px', left: '70%'}}>
	 *     Some text
	 *     <div>Another line of text</div>
	 *   </span>
	 * </Tooltipped>
	 * ```
	 *
	 * ```js
	 * <Tooltipped
	 *   setPosition={true}
	 *   label="Avatar's tooltip"
	 *   position="top"
	 * >
	 *   <span style={{marginLeft: '30px'}}>
	 *       <Avatar random>T</Avatar>
	 *   </span>
	 * </Tooltipped>
	 * ```
	 */
	function Tooltipped(_ref) {
	  var children = _ref.children,
	      setPosition = _ref.setPosition,
	      props = _objectWithoutProperties(_ref, ['children', 'setPosition']);
	
	  var target = _react2.default.Children.only(children);
	  var targetProps = target.props;
	
	  if (props.label) {
	    var clonedProps = targetProps;
	    if (setPosition) {
	      clonedProps = _extends({}, clonedProps, {
	        style: _extends({}, clonedProps.style, { position: 'relative' })
	      });
	    }
	
	    target = _react2.default.cloneElement(target, clonedProps, [targetProps.children, _react2.default.createElement(_TooltipContainer2.default, _extends({ key: 'tooltipContainer' }, props))]);
	  }
	
	  return target;
	}
	
	Tooltipped.displayName = 'Tooltipped';
	
	Tooltipped.propTypes = {
	  /**
	   * A component/element the tooltip should be linked to.
	   */
	  children: _propTypes2.default.element.isRequired,
	  /**
	   * Tooltip's content.
	   */
	  label: _propTypes2.default.node,
	  /**
	   * Whether `position: relative` should be added to the `style` property of the wrapped component.
	   */
	  setPosition: _propTypes2.default.bool
	};
	//# sourceMappingURL=Tooltipped.js.map

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Tooltipped = exports.injectTooltip = undefined;
	
	var _injectTooltip2 = __webpack_require__(111);
	
	var _injectTooltip3 = _interopRequireDefault(_injectTooltip2);
	
	var _Tooltipped2 = __webpack_require__(662);
	
	var _Tooltipped3 = _interopRequireDefault(_Tooltipped2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _injectTooltip3.default;
	exports.injectTooltip = _injectTooltip3.default;
	exports.Tooltipped = _Tooltipped3.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 664 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = '1.2.9';
	//# sourceMappingURL=Version.js.map

/***/ }),
/* 665 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MOBILE_MIN_WIDTH = exports.MOBILE_MIN_WIDTH = 320;
	var TABLET_MIN_WIDTH = exports.TABLET_MIN_WIDTH = 768;
	var DESKTOP_MIN_WIDTH = exports.DESKTOP_MIN_WIDTH = 1025;
	//# sourceMappingURL=media.js.map

/***/ }),
/* 666 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addHours;
	/** @module utils/DateUtils/addHours */
	
	/**
	 * Adds hours to a date.
	 *
	 * @param {Date} time the time to increment
	 * @param {number} hours the number of hours to increment by.
	 * @return a new Date with the new hours set.
	 */
	function addHours(time, hours) {
	  var t = new Date(time.getTime());
	  t.setHours(t.getHours() + hours);
	  return t;
	}
	//# sourceMappingURL=addHours.js.map

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @module utils/DateUtils/extractTimeParts */
	
	
	exports.default = extractTimeParts;
	
	var _formatTime = __webpack_require__(297);
	
	var _formatTime2 = _interopRequireDefault(_formatTime);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	/**
	 * Extracts the hours, minutes, and optional time period from
	 * a date time.
	 *
	 * @param {function} DateTimeFormat the DateTimeFormat function to use.
	 * @param {string|string[]} locales the locales to use.
	 * @param {Date} time the time to extract from.
	 * @return {Object} an object of { hours, minutes, timePeriod }
	 */
	function extractTimeParts(DateTimeFormat, locales, time) {
	  var formatted = (0, _formatTime2.default)(DateTimeFormat, locales, time);
	
	  // IE does not like lookaheads or splitting on [^0-9]
	  // it will include the non-printable characters..
	
	  var _formatted$match = formatted.match(/[0-9]+/g),
	      _formatted$match2 = _slicedToArray(_formatted$match, 2),
	      hours = _formatted$match2[0],
	      minutes = _formatted$match2[1];
	
	  var _formatted$match3 = formatted.match(/[ ,.:A-z]+/g),
	      _formatted$match4 = _toArray(_formatted$match3),
	      separator = _formatted$match4[0],
	      remaining = _formatted$match4.slice(1);
	
	  var timePeriod = void 0;
	  if (remaining && remaining.length) {
	    timePeriod = remaining.join('').trim();
	  }
	
	  return {
	    hours: hours,
	    minutes: separator + minutes,
	    timePeriod: timePeriod
	  };
	}
	//# sourceMappingURL=extractTimeParts.js.map

/***/ }),
/* 668 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getLastDay;
	/** @module utils/DateUtils/getLastDay */
	
	/**
	 * Gets the last day in a month
	 *
	 * @param {Date} sourceDate the date to get the last day from.
	 * @return a new Date as the last day of the month.
	 */
	function getLastDay(sourceDate) {
	  return new Date(sourceDate.getFullYear(), sourceDate.getMonth() + 1, 0);
	}
	//# sourceMappingURL=getLastDay.js.map

/***/ }),
/* 669 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDateEqual;
	/** @module utils/DateUtils/isDateEqual */
	
	/**
	 * Checks if two dates are equal by comparing the exact time.
	 * This allows null or undefined.
	 *
	 * @param {Date} d1 - The first date to compare.
	 * @param {Date} d2 - The second date to compare.
	 * @return {bool} - true if the dates are equal.
	 */
	function isDateEqual(d1, d2) {
	  if (!d1 && !d2) {
	    return true;
	  } else if (!d1 && d2 || d1 && !d2) {
	    return false;
	  }
	
	  return d1.getTime() === d2.getTime();
	}
	//# sourceMappingURL=isDateEqual.js.map

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMonthBefore;
	
	var _stripTime = __webpack_require__(299);
	
	var _stripTime2 = _interopRequireDefault(_stripTime);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Checks if a date is the month before another date without time
	 *
	 * @param {Date} date the date to check if it is before the other
	 * @param {Date} toCompare the date to compare to
	 * @return true if the date is before the other date's first day of month.
	 */
	function isMonthBefore(date, toCompare) {
	  if (!date || !toCompare) {
	    return false;
	  }
	
	  var d1 = (0, _stripTime2.default)(new Date(date.getFullYear(), date.getMonth(), 1));
	  var d2 = (0, _stripTime2.default)(new Date(toCompare.getFullYear(), toCompare.getMonth() - 1, 1));
	  return d1 > d2;
	} /** @module utils/DateUtils/isMonthBefore */
	//# sourceMappingURL=isMonthBefore.js.map

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValidFocusKeypress;
	
	var _keyCodes = __webpack_require__(15);
	
	/**
	 * Checks if a keydown or keyup event's key was the TAB key or any additional valid
	 * keys that were passed in.
	 *
	 * @param {Object} event - The event to check.
	 * @param {Array.<number>=} additionalKeys - An optional array of additional key codes
	 *    that are considered valid for a focus event.
	 */
	function isValidFocusKeypress(event, additionalKeys) {
	  var key = event.which || event.keyCode;
	  return key === _keyCodes.TAB || additionalKeys && additionalKeys.indexOf(key) !== -1;
	} /** @module utils/EventUtils/isValidFocusKeypress */
	//# sourceMappingURL=isValidFocusKeypress.js.map

/***/ }),
/* 672 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calcTimeFromPoint;
	/** @module utils/NumberUtils/calcTimeFromPoint */
	
	function isPointInCircle(cx, cy, r, x, y) {
	  var distance = Math.pow(cx - x, 2) + Math.pow(cy - y, 2);
	  return distance <= Math.pow(r, 2);
	}
	
	function toDegrees(radians) {
	  return radians * (180 / Math.PI);
	}
	
	/**
	 * Takes a point from a mouse or touch event and a center point of a circle to determine
	 * what the new time should be.
	 *
	 * If the point.y < center.y, the point is in the top half of the circle.
	 * If the point.x < center.x, the point is in the left half of the circle.
	 *
	 * @param {Object} point - The mouse or touch event's point that contains an x and y coordinate.
	 * @param {Object} center - The center point for the circle that contains an x and y coordinate.
	 * @param {Number} innerRadius - An inner radius for clocks that have 24 hour times. This is
	 *    a circle that contains hours 12-23.
	 * @param {Boolean} minutes - Boolena if the current time to be calculated is minutes instead of
	 *    hours.
	 * @param {Boolean} hour12 - Boolean if the clock is a 12 hour clock.
	 * @return {Number} the new time.
	 */
	function calcTimeFromPoint(point, center, innerRadius, minutes, hour12) {
	  var x = point.x - center.x;
	  var y = point.y - center.y;
	  var degrees = toDegrees(Math.atan2(y, x));
	  var sectors = minutes ? 60 : 12;
	  var sectorSize = 360 / sectors;
	  var time = Math.round(degrees / sectorSize);
	
	  // Since the css transform has 0π at π/2 place, we need to offset the
	  // time to that location.
	  time += minutes ? 15 : 3;
	
	  // If time is still negative, it is in the top half of the circle
	  if (time < 0) {
	    time += sectors;
	  }
	
	  // Finally, if it is a 24 hour clock, need to check if the point is actually
	  // selecting hours 13 - 24 (0).
	  if (!minutes && !hour12) {
	    var isInCircle = isPointInCircle(0, 0, innerRadius, x, y);
	
	    if (time === 0 && !isInCircle || time !== 0 && isInCircle) {
	      time += 12;
	    }
	  }
	
	  return time;
	}
	//# sourceMappingURL=calcTimeFromPoint.js.map

/***/ }),
/* 673 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculateHypotenuse;
	/** @module utils/NumberUtils/calculateHypotenuse */
	
	/**
	 * Calculates the hypotenuse using the x and y coordinates given.
	 *
	 * @param {number} a the x coordinate
	 * @param {number} b the y coordinate
	 * @return {number} the hypotenuse length for the given x and y coordinates.
	 */
	function calculateHypotenuse(a, b) {
	  return Math.sqrt(a * a + b * b);
	}
	//# sourceMappingURL=calculateHypotenuse.js.map

/***/ }),
/* 674 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculateValueDistance;
	/** @module utils/NumberUtils/calculateValueDistance */
	
	/**
	 * This calculates the distance from a screen x location to a position in some element
	 * by comparing the width of the element and the element's page position to the screen
	 * x position.
	 *
	 * If the distance is not _normalized_ the distance will be updated to be a percentage
	 * of the element's total width.
	 *
	 * @param {Number} x - the screen x location.
	 * @param {Number} width - the element's width
	 * @param {Number} left - the element's page x position.
	 * @param {Boolean} normalize - boolean if the distance should be a percentage.
	 *
	 * @return {Number} the distance from the element's left position to the page x
	 *    location.
	 */
	function calculateDistance(x, width, left, normalize) {
	  var distance = Math.min(width, Math.max(0, x - left));
	
	  return normalize ? distance : distance / width * 100;
	}
	
	/**
	 * This calculates the new value and distance for a slider. It will compare the page x
	 * location of a touch or mouse event to the slider's track page x position. If the
	 * final value and distance should be _normalized_, they will be updated to be rounded
	 * with the scale and steps in mind.
	 *
	 * The distance will always be contained within a percentage of 0 - 100 while the
	 * value will be contained within the min and max values.
	 *
	 * @param {Number} x - the page x location of the touch or mouse event.
	 * @param {Number} width - the slider's width
	 * @param {Number} left - the slider's left position in the page.
	 * @param {Number} scale - the total number values included in the slider.
	 * @param {Number} step - the amount to increment by.
	 * @param {Number} min - the min value for the slider.
	 * @param {Number} max - the max value for the slider.
	 * @param {Boolean} normalize - boolean if the vaue and distance should be _normalized_.
	 *
	 * @return {Object} an object with the value and distance.
	 */
	function calculateValueDistance(x, width, left, scale, step, min, max, normalize) {
	  var value = void 0;
	  var distance = calculateDistance(x, width, left, normalize);
	  if (normalize) {
	    value = Math.round(distance / (width / scale));
	    if (step < 1) {
	      var decimals = String(step).split('.')[1];
	      var corrector = typeof decimals !== 'undefined' && decimals.length > 0 ? Math.pow(10, decimals.length) : 1;
	
	      var modded = value * corrector % (step * corrector);
	      if (modded !== 0 && modded >= step / 2) {
	        value += step - modded;
	      } else if (modded !== 0) {
	        value -= modded;
	      }
	    }
	
	    distance = value / scale * 100;
	    value = value * step + min;
	  } else {
	    value = min + step * Math.round(distance / 100 * scale);
	  }
	
	  return {
	    distance: Math.max(0, Math.min(100, distance)),
	    value: Math.max(min, Math.min(max, value))
	  };
	}
	//# sourceMappingURL=calculateValueDistance.js.map

/***/ }),
/* 675 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWithinStep;
	/** @module utils/NumberUtils/isWithinStep */
	
	/**
	 * Checks if a provided value is within the current step. I don't remember the main
	 * usage for this, but it is for the Slider component.
	 *
	 * @param {number} value - the current value
	 * @param {number} step - the step value
	 * @return {Boolean} true if the vlaue is within the step
	 */
	function isWithinStep(value, step) {
	  var decimals = String(step).split('.')[1];
	  var corrector = typeof decimals !== 'undefined' && decimals.length > 0 ? Math.pow(10, decimals.length) : 1;
	
	  return value * corrector % (step * corrector) === 0;
	}
	//# sourceMappingURL=isWithinStep.js.map

/***/ }),
/* 676 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = minMaxLoop;
	/** @module utils/NumberUtils/minMaxLoop */
	
	/**
	 * Keeps a number within the min and max values. When the number becomes less
	 * than the min, it will loop around and be the max value. When the number is
	 * greater than the max, it will loop around and be the min value.
	 *
	 * @param {Number} current - the current number
	 * @param {Number} min - the minimum number allowed
	 * @param {Number} max - the maximum number allowed
	 * @param {Boolean} increment - boolean if the value should be incremented or decremented by
	 *    1.
	 * @return {Number} the next number
	 */
	function minMaxLoop(current, min, max) {
	  var increment = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	  var next = current + (increment ? 1 : -1);
	  if (max < next) {
	    next = min;
	  } else if (next < min) {
	    next = max;
	  }
	
	  return next;
	}
	//# sourceMappingURL=minMaxLoop.js.map

/***/ }),
/* 677 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = updateUnit;
	/** @module utils/NumberUtils/updateUnit */
	
	/**
	 * Takes in a css unit (px, rem, em, etc) or a number and applies a function to the
	 * number part of the unit.
	 *
	 * If the unit was a number to start with and a `toUnit` is given, the number will
	 * be given the `toUnit`. Otherwise the number will be returned.
	 *
	 * If the unit was a string, the original units will be applied back to the updated
	 * unit's value.
	 *
	 * @param {number|String} unit - the unit to apply a function to.
	 * @param {function} fn - the function to apply to the number.
	 * @param {String=} toUnit - an optional unit to cast the updated unit to.
	 *
	 * @return {String|number} the updated unit.
	 */
	function updateUnit(unit, fn, toUnit) {
	  var updated = fn(parseInt(unit, 10));
	
	  if (typeof unit === 'number') {
	    return toUnit ? '' + updated + toUnit : updated;
	  }
	
	  return '' + updated + unit.replace(/[0-9]/g, '');
	}
	//# sourceMappingURL=updateUnit.js.map

/***/ }),
/* 678 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getScroll;
	/** @module utils/Positioning/getScroll */
	
	/**
	 * A utility function to just get an element's scroll x and y
	 * values. This is really just needed because `window` uses
	 * different attributes.
	 *
	 * @param {Object} el - The element to get a scroll value from.
	 * @return {Object} an object containing the scrollX and scrollY of the element.
	 */
	function getScroll(el) {
	  if (typeof el.scrollX !== 'undefined' && typeof el.scrollY !== 'undefined') {
	    return { x: el.scrollX, y: el.scrollY };
	  } else if (typeof el.scrollLeft !== 'undefined' && typeof el.scrollTop !== 'undefined') {
	    return { x: el.scrollLeft, y: el.scrollTop };
	  }
	
	  return { x: 0, y: 0 };
	}
	//# sourceMappingURL=getScroll.js.map

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getSelectedTextPosition;
	
	var _getSelectedText = __webpack_require__(689);
	
	var _getSelectedText2 = _interopRequireDefault(_getSelectedText);
	
	var _getTextWidth = __webpack_require__(178);
	
	var _getTextWidth2 = _interopRequireDefault(_getTextWidth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** @module utils/Positoning/getSelectedTextPosition */
	var ZERO_WIDTH_CHARACTER = '\u200B';
	
	/**
	 * A utility function to attempt to get the current highlighted text position.
	 *
	 * When a context menu is opened, this function attempts to find the bounding client rect
	 * for the highlighted text. However, if the text is in the text field, some weird stuff
	 * happens and it is unable to get it correctly.
	 */
	function getSelectedTextPosition(e) {
	  var height = void 0;
	  var target = e.target,
	      clientX = e.clientX,
	      clientY = e.clientY;
	
	  var text = (0, _getSelectedText2.default)();
	  var width = Math.round((0, _getTextWidth2.default)(text, target) || 0);
	  if (!text || target.classList.contains('md-text-field')) {
	    height = parseInt(window.getComputedStyle(target).fontSize, 10);
	    return {
	      width: width,
	      height: height,
	      left: clientX - width,
	      top: clientY
	    };
	  }
	
	  // All browsers I am supporting have window.getSelection, but better safe than sorry
	  if (window.getSelection) {
	    var selection = window.getSelection();
	    if (selection.rangeCount) {
	      var range = selection.getRangeAt(0).cloneRange();
	      var rect = null;
	      if (range.getClientRects) {
	        var rects = range.getClientRects();
	        if (rects.length > 0) {
	          rect = rects[0];
	        }
	      }
	
	      if (!rect) {
	        var span = document.createElement('span');
	        span.appendChild(document.createTextNode(ZERO_WIDTH_CHARACTER));
	        range.insertNode(span);
	        rect = span.getBoundingClientRect();
	
	        var spanParent = span.parentNode;
	        spanParent.removeChild(span);
	        spanParent.normalize();
	      }
	
	      return rect;
	    }
	  }
	
	  return null;
	}
	//# sourceMappingURL=getSelectedTextPosition.js.map

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isOutOfBounds;
	
	var _getScreenSize = __webpack_require__(303);
	
	var _getScreenSize2 = _interopRequireDefault(_getScreenSize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isOutHorizontally(fixedTo, child, threshold) {
	  var _fixedTo$getBoundingC = fixedTo.getBoundingClientRect(),
	      fixedLeft = _fixedTo$getBoundingC.left,
	      fixedRight = _fixedTo$getBoundingC.right;
	
	  var _child$getBoundingCli = child.getBoundingClientRect(),
	      childLeft = _child$getBoundingCli.left,
	      childRight = _child$getBoundingCli.right;
	
	  var offset = child.offsetWidth * threshold;
	
	  var left = childLeft + offset;
	  var right = childRight - offset;
	
	  var screenEdge = childLeft === 0 || (0, _getScreenSize2.default)('Width') === childRight;
	  return fixedLeft > left || fixedRight < right || screenEdge;
	} /** @module utils/Positioning/isOutOfBounds */
	
	function isOutVertically(fixedTo, child, toggle, threshold) {
	  var _fixedTo$getBoundingC2 = fixedTo.getBoundingClientRect(),
	      fixedTop = _fixedTo$getBoundingC2.top,
	      fixedBottom = _fixedTo$getBoundingC2.bottom;
	
	  var _child$getBoundingCli2 = child.getBoundingClientRect(),
	      childTop = _child$getBoundingCli2.top,
	      childBottom = _child$getBoundingCli2.bottom;
	
	  var offset = toggle.offsetHeight * threshold;
	
	  var screenEdge = childTop === 0 || (0, _getScreenSize2.default)('Height') === childBottom;
	  return fixedTop > childTop + offset || fixedBottom < childTop - offset || screenEdge;
	}
	
	/**
	 * Checks if the fixedTo object for the Layover component is considered
	 * out of bounds relative to the container.
	 *
	 * @param {Object} fixedTo - The Layover's `fixedTo` prop.
	 * @param {Object} child - The Layover's `children` prop as a DOM element.
	 * @param {Object} toggle - The Layover's `toggle` prop as a DOM element.
	 * @param {number} verticalThreshold - The vertical threshold multiplier to apply.
	 * @param {number} horizontalThreshold - The horizontal threshold multiplier to apply.
	 * @return {boolean} true if the Layover's `fixedTo` prop is considered out of bounds.
	 */
	function isOutOfBounds(fixedTo, child, toggle, verticalThreshold, horizontalThreshold) {
	  if (fixedTo === window) {
	    return false;
	  } else if (fixedTo.x || fixedTo.y) {
	    var x = fixedTo.x,
	        y = fixedTo.y;
	
	    return !!y && isOutVertically(y, child, toggle, verticalThreshold) || !!x && isOutHorizontally(x, child, horizontalThreshold);
	  }
	
	  return isOutVertically(fixedTo, child, toggle, verticalThreshold) || isOutHorizontally(fixedTo, child, horizontalThreshold);
	}
	//# sourceMappingURL=isOutOfBounds.js.map

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = minNumber;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Validates the a prop's value is greater than or equal to the minimum value.
	 *
	 * @param {Number} min - the minimum value for the prop.
	 * @param {Boolean} required - Boolean if the prop is required.
	 * @return {Error} an error or null.
	 */
	function minNumber(min, required) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    var validator = _propTypes2.default.number;
	    if (required) {
	      validator = validator.isRequired;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	    if (!required && !err && props[propName] < min) {
	      err = new Error('The ' + location + ' `' + propFullNameSafe + '` must be greater than or equal to the min value ' + ('`' + min + '` but received `' + props[propName] + '` for the `' + componentNameSafe + '` component.'));
	    }
	
	    return err;
	  };
	} /** @module utils/PropTypes/minNumber */
	//# sourceMappingURL=minNumber.js.map

/***/ }),
/* 682 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = oneRequiredForA11yIf;
	/** @module utils/PropTypes/oneRequiredForA11yIf */
	
	/**
	 * A PropType validator to make sure that any of the other prop names have been defined
	 * if the current prop is also defined.
	 *
	 * This is mostly useful for when adding a prop requires additional accessibility props defined
	 * as well.
	 *
	 * @param {function} validator - The current prop's validator.
	 */
	function oneRequiredForA11yIf(validator) {
	  for (var _len = arguments.length, otherPropNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    otherPropNames[_key - 1] = arguments[_key];
	  }
	
	  return function validate(props, propName, componentName, location, propFullName) {
	    var filterUndefined = function filterUndefined(pn) {
	      return typeof props[pn] !== 'undefined';
	    };
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	    var defined = typeof props[propName] !== 'undefined';
	    var allPropNames = [propFullNameSafe].concat(otherPropNames);
	
	    for (var _len2 = arguments.length, args = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	      args[_key2 - 5] = arguments[_key2];
	    }
	
	    var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	    if (!err && defined && !allPropNames.filter(filterUndefined).length) {
	      err = new Error('One of the following props are required to make `' + componentNameSafe + '` accessible ' + ('for users of assistive technologies such as screen readers when using the `' + propFullNameSafe + '` ') + ('prop. `' + allPropNames.join('`, `') + '`.'));
	    }
	
	    return err;
	  };
	}
	//# sourceMappingURL=oneRequiredForA11yIf.js.map

/***/ }),
/* 683 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = requiredForA11yIfNot;
	/** @module utils/PropTypes/requiredForA11yIfNot */
	
	/**
	 * This validator checks that the current prop is valid and defined ONLY if
	 * any of the `otherPropNames` are not true or defined.
	 *
	 * @param {function} validator - The React PropTypes validator to use for the given prop.
	 * @param {String[]} otherPropNames - Any other prop names to validate against.
	 * @return {Error} an error or null
	 */
	function requiredForA11yIfNot(validator) {
	  for (var _len = arguments.length, otherPropNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    otherPropNames[_key - 1] = arguments[_key];
	  }
	
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	    var defined = typeof props[propName] !== 'undefined';
	
	    for (var _len2 = arguments.length, args = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	      args[_key2 - 5] = arguments[_key2];
	    }
	
	    var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	    if (!err && !defined && !otherPropNames.filter(function (pn) {
	      return !!props[pn];
	    }).length) {
	      err = new Error('The `' + propFullNameSafe + '` ' + location + ' is required to make `' + componentNameSafe + '` accessible ' + 'for users of assistive technologies such as screen readers.');
	    }
	
	    return err;
	  };
	}
	//# sourceMappingURL=requiredForA11yIfNot.js.map

/***/ }),
/* 684 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = capitalizeFirst;
	/** @module utils/StringUtils/capitlizeFirst */
	
	/**
	 * Capitalizes the first letter of a string. If the string is falsish, it will be
	 * returned as is. If the string is only one letter long, it will be capitalized;
	 *
	 * @param {String} str - The string to capitalize.
	 * @return {String} the updated string or false-ish self.
	 */
	function capitalizeFirst(str) {
	  if (!str) {
	    return str;
	  } else if (str.length === 1) {
	    return str.toUpperCase();
	  }
	
	  return "" + str.charAt(0).toUpperCase() + str.substring(1, str.length);
	}
	//# sourceMappingURL=capitalizeFirst.js.map

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /** @module utils/caseInsensitiveFilter */
	
	
	exports.default = caseInsensitiveFilter;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This function does a simple ignore case search of some `filterText` for every
	 * item in a `haystack`. It will only include items that are:
	 *  - not null or undefined
	 *  - valid React Components
	 *  - a number or string that contains each letter/number in exact order ignoring case
	 *  - an object's `dataLabel` value that contains each letter/number in exact order ignoring case.
	 *
	 * Example:
	 *
	 * ```js
	 * const haystack = ['Apple', 'Banana', 'Orange'];
	 * caseInsensitiveFilter(haystack, 'An') // ['Banana', 'Orange'];
	 * caseInsensitiveFilter(haystack, 'ae') // []
	 * ```
	 *
	 * @param {Array.<string|number|Object|function>} haystack - the haystack to search
	 * @param {string} filterText - the filter text to use.
	 * @param {string=} dataLabel - the data label to use if the element is an object.
	 *
	 * @return {Array.<string|number|Object|function>} a filtered list.
	 */
	function caseInsensitiveFilter(haystack, filterText, dataLabel) {
	  var needle = filterText.toLowerCase();
	
	  return haystack.filter(function (hay) {
	    if (hay === null || typeof hay === 'undefined') {
	      return false;
	    } else if (_react2.default.isValidElement(hay)) {
	      return true;
	    }
	
	    var value = void 0;
	    switch (typeof hay === 'undefined' ? 'undefined' : _typeof(hay)) {
	      case 'string':
	      case 'number':
	        value = hay.toString();
	        break;
	      default:
	        value = hay[dataLabel];
	    }
	
	    return value && value.toLowerCase().indexOf(needle) !== -1;
	  });
	}
	//# sourceMappingURL=caseInsensitiveFilter.js.map

/***/ }),
/* 686 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = closest;
	/** @module utils/closest */
	
	/**
	 * A _very_ primitive polyfill for the Element.closest function. If this is a browser that doesn't
	 * support it (IE, Edge, etc), it will just keep searching the parent elements until the nodeName
	 * matches the provided type.
	 *
	 * @param {Element} el - the html element to find a closest node type for
	 * @param {String} type - the html element type to find.
	 * @return {Element} the found element or null.
	 */
	function closest(el, type) {
	  if (typeof el.closest === 'function') {
	    return el.closest(type);
	  }
	
	  var nodeType = type.toUpperCase();
	  var node = el.parentElement;
	  while (node && node.parentElement) {
	    if (node.nodeName === nodeType) {
	      return node;
	    }
	
	    node = node.parentElement;
	  }
	
	  return null;
	}
	//# sourceMappingURL=closest.js.map

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /** @module utils/findIgnoreCase */
	
	
	exports.default = findIgnoreCase;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This function finds the first item in a `haystack` that starts with every
	 * letter of the `value` in order. It will ignore:
	 *  - null or undefined
	 *  - valid React components
	 *
	 * @param {Array.<string|number|Object|function>} haystack - the haystack to search.
	 * @param {string} value - the current value to use.
	 * @param {string=} dataLabel - the object key to use to extract the comparing value.
	 *
	 * @return {string} the found element or the empty string.
	 */
	function findIgnoreCase(haystack, value, dataLabel) {
	  var needle = value ? value.toLowerCase() : '';
	
	  if (!needle) {
	    return needle;
	  }
	
	  var suggestion = '';
	  haystack.some(function (hay) {
	    if (hay === null || typeof hay === 'undefined' || _react2.default.isValidElement(hay)) {
	      return false;
	    }
	
	    var hayStr = (typeof hay === 'undefined' ? 'undefined' : _typeof(hay)) === 'object' ? hay[dataLabel] : hay.toString();
	
	    if (hayStr.toLowerCase().indexOf(needle) === 0) {
	      suggestion = hayStr;
	    }
	
	    return suggestion;
	  });
	
	  return suggestion;
	}
	//# sourceMappingURL=findIgnoreCase.js.map

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /** @module utils/fuzzyFilter */
	
	
	exports.default = fuzzyFilter;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This function does a simple fuzzy search of some `needle` for every
	 * item in a `haystack`. It will only include items that are:
	 *  - not null or undefined
	 *  - valid React Components
	 *  - a number or string that contains each letter/number in order ignoring case
	 *  - an object's `dataLabel` value that contains each letter/number in order ignoring case.
	 *
	 * Example:
	 * ```js
	 * const haystack = ['Apple', 'Banana', 'Orange'];
	 * fuzzyFilter(haystack, 'An') // ['Banana', 'Orange'];
	 * fuzzyFilter(haystack, 'ae') // ['Apple']
	 * ```
	 *
	 * @param {Array.<string|number|Object|function>} haystack - the haystack to search
	 * @param {string} needle - the filter text to use.
	 * @param {string=} dataLabel - the data label to use if the element is an object.
	 *
	 * @return {Array.<string|number|Object|function>} a filtered list.
	 */
	function fuzzyFilter(haystack, needle, dataLabel) {
	  // Create an amazing regex that matches the letters in order
	  // and escapes any strings that could be part of a regex.
	  var reg = new RegExp(('' + needle).split('').join('\\w*').replace(/(\(|\||\)|\\(?!w\*)|\[|\|-|\.|\^|\+|\$|\?|^(?!w)\*)/g, '\\$1')
	  // Couldn't get the matching of two '*' working, so replace them here..
	  .replace(/\*\*/g, '*\\*'), 'i');
	
	  return haystack.filter(function (hay) {
	    if (hay === null || typeof hay === 'undefined') {
	      return false;
	    } else if (_react2.default.isValidElement(hay)) {
	      return true;
	    }
	
	    var value = void 0;
	    switch (typeof hay === 'undefined' ? 'undefined' : _typeof(hay)) {
	      case 'string':
	      case 'number':
	        value = hay.toString();
	        break;
	      default:
	        value = hay[dataLabel];
	    }
	
	    return value && value.match(reg);
	  });
	}
	//# sourceMappingURL=fuzzyFilter.js.map

/***/ }),
/* 689 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getSelectedText;
	/** @module utils/getSelectedText */
	
	/**
	 * A utility function that gets the current selected text in the document. I think
	 * that all the browsers I support have `window.getSelection`, but it falls back to
	 * support others.
	 *
	 * @return {String} the current selection on the page
	 */
	function getSelectedText() {
	  if (typeof window.getSelection !== 'undefined') {
	    return window.getSelection().toString();
	  } else if (typeof document.selection !== 'undefined' && document.selection.type === 'Text') {
	    return document.selection.createRange().text;
	  }
	
	  return '';
	}
	//# sourceMappingURL=getSelectedText.js.map

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toggleScroll;
	
	var _getPagePosition = __webpack_require__(302);
	
	var _getPagePosition2 = _interopRequireDefault(_getPagePosition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A utility function for toggling the overflow visibility on an element. This will either target
	 * the given `selector`, or the `body` tag to set a `className`.
	 *
	 * If the `visible` param is `undefined`, the className will be toggled.
	 * If the `visible` param is `true`, the className will be added.
	 * If the `visible` param is `false`, the className will be removed.
	 *
	 *
	 * > This depends on the `classList` attribute on elements.
	 *
	 * @param {bool=} visible - An optional boolean to determine how the `className` will be applied.
	 * @param {string|Object=} selector - An optional query selector string to use to select an element.
	 * @param {string=} className - The className to apply. Defaults to 'md-overflow-hidden'
	 */
	function toggleScroll(scrollable, selector) {
	  var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'md-no-scroll';
	
	  var queryable = !selector || typeof selector === 'string';
	  var el = void 0;
	  if (queryable) {
	    el = selector ? document.querySelector(selector) : document.querySelector('html');
	  } else {
	    el = selector;
	  }
	
	  if (!el) {
	    return;
	  }
	
	  if (typeof scrollable === 'undefined') {
	    scrollable = !el.classList.contains(className);
	  }
	
	  if (scrollable && !el.classList.contains(className)) {
	    el.style.top = '-' + (queryable ? (0, _getPagePosition2.default)('y') : el.scrollTop) + 'px';
	    el.classList.add(className);
	  } else if (!scrollable && el.classList.contains(className)) {
	    var scrollTop = Math.abs(parseInt(el.style.top, 10));
	    el.classList.remove(className);
	    el.style.top = null;
	
	    if (!selector) {
	      window.scrollTo(0, scrollTop);
	    } else {
	      el.scrollTop = scrollTop;
	    }
	  }
	} /** @module utils/toggleScroll */
	//# sourceMappingURL=toggleScroll.js.map

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(182);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(117);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(184);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(100);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(146);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(183);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = (function (_React$Component) {
	  _inherits(Motion, _React$Component);
	
	  _createClass(Motion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      onRest: _propTypes2['default'].func
	    },
	    enumerable: true
	  }]);
	
	  function Motion(props) {
	    var _this = this;
	
	    _classCallCheck(this, Motion);
	
	    _React$Component.call(this, props);
	    this.wasAnimating = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyle = null;
	
	    this.clearUnreadPropStyle = function (destStyle) {
	      var dirty = false;
	      var _state = _this.state;
	      var currentStyle = _state.currentStyle;
	      var currentVelocity = _state.currentVelocity;
	      var lastIdealStyle = _state.lastIdealStyle;
	      var lastIdealVelocity = _state.lastIdealVelocity;
	
	      for (var key in destStyle) {
	        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	          continue;
	        }
	
	        var styleValue = destStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyle = _extends({}, currentStyle);
	            currentVelocity = _extends({}, currentVelocity);
	            lastIdealStyle = _extends({}, lastIdealStyle);
	            lastIdealVelocity = _extends({}, lastIdealVelocity);
	          }
	
	          currentStyle[key] = styleValue;
	          currentVelocity[key] = 0;
	          lastIdealStyle[key] = styleValue;
	          lastIdealVelocity[key] = 0;
	        }
	      }
	
	      if (dirty) {
	        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // check if we need to animate in the first place
	        var propsStyle = _this.props.style;
	        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	          if (_this.wasAnimating && _this.props.onRest) {
	            _this.props.onRest();
	          }
	
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.wasAnimating = false;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        _this.wasAnimating = true;
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	
	        for (var key in propsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = propsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	            for (var i = 0; i < framesToCatchUp; i++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyle: newCurrentStyle,
	          currentVelocity: newCurrentVelocity,
	          lastIdealStyle: newLastIdealStyle,
	          lastIdealVelocity: newLastIdealVelocity
	        });
	
	        _this.unreadPropStyle = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  Motion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  };
	
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	
	  Motion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  Motion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return Motion;
	})(_react2['default'].Component);
	
	exports['default'] = Motion;
	module.exports = exports['default'];
	
	// after checking for unreadPropStyle != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(182);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(117);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(184);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(100);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(146);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(183);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = (function (_React$Component) {
	  _inherits(StaggeredMotion, _React$Component);
	
	  _createClass(StaggeredMotion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	      styles: _propTypes2['default'].func.isRequired,
	      children: _propTypes2['default'].func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function StaggeredMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, StaggeredMotion);
	
	    _React$Component.call(this, props);
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _state = _this.state;
	      var currentStyles = _state.currentStyles;
	      var currentVelocities = _state.currentVelocities;
	      var lastIdealStyles = _state.lastIdealStyles;
	      var lastIdealVelocities = _state.lastIdealVelocities;
	
	      var someDirty = false;
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i];
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              someDirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	          }
	        }
	      }
	
	      if (someDirty) {
	        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyles = [];
	        var newLastIdealVelocities = [];
	        var newCurrentStyles = [];
	        var newCurrentVelocities = [];
	
	        for (var i = 0; i < destStyles.length; i++) {
	          var destStyle = destStyles[i];
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in destStyle) {
	            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	              continue;
	            }
	
	            var styleValue = destStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  StaggeredMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  };
	
	  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  StaggeredMotion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return StaggeredMotion;
	})(_react2['default'].Component);
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400
	
	// after checking for unreadPropStyles != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(182);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(117);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(184);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__(694);
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__(100);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(146);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(183);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = (function (_React$Component) {
	  _inherits(TransitionMotion, _React$Component);
	
	  _createClass(TransitionMotion, null, [{
	    key: 'propTypes',
	    value: {
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	      })),
	      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	      }))]).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      willEnter: _propTypes2['default'].func,
	      willLeave: _propTypes2['default'].func,
	      didLeave: _propTypes2['default'].func
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    },
	    enumerable: true
	  }]);
	
	  function TransitionMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, TransitionMotion);
	
	    _React$Component.call(this, props);
	    this.unmounting = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var mergedPropsStyles = _mergeAndSync[0];
	      var currentStyles = _mergeAndSync[1];
	      var currentVelocities = _mergeAndSync[2];
	      var lastIdealStyles = _mergeAndSync[3];
	      var lastIdealVelocities = _mergeAndSync[4];
	
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i].style;
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	              mergedPropsStyles[i] = {
	                key: mergedPropsStyles[i].key,
	                data: mergedPropsStyles[i].data,
	                style: _extends({}, mergedPropsStyles[i].style)
	              };
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	            mergedPropsStyles[i].style[key] = styleValue;
	          }
	        }
	      }
	
	      // unlike the other 2 components, we can't detect staleness and optionally
	      // opt out of setState here. each style object's data might contain new
	      // stuff we're not/cannot compare
	      _this.setState({
	        currentStyles: currentStyles,
	        currentVelocities: currentVelocities,
	        mergedPropsStyles: mergedPropsStyles,
	        lastIdealStyles: lastIdealStyles,
	        lastIdealVelocities: lastIdealVelocities
	      });
	    };
	
	    this.startAnimationIfNecessary = function () {
	      if (_this.unmounting) {
	        return;
	      }
	
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // https://github.com/chenglou/react-motion/pull/420
	        // > if execution passes the conditional if (this.unmounting), then
	        // executes async defaultRaf and after that component unmounts and after
	        // that the callback of defaultRaf is called, then setState will be called
	        // on unmounted component.
	        if (_this.unmounting) {
	          return;
	        }
	
	        var propStyles = _this.props.styles;
	        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	        var newMergedPropsStyles = _mergeAndSync2[0];
	        var newCurrentStyles = _mergeAndSync2[1];
	        var newCurrentVelocities = _mergeAndSync2[2];
	        var newLastIdealStyles = _mergeAndSync2[3];
	        var newLastIdealVelocities = _mergeAndSync2[4];
	
	        for (var i = 0; i < newMergedPropsStyles.length; i++) {
	          var newMergedPropsStyle = newMergedPropsStyles[i].style;
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in newMergedPropsStyle) {
	            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	              continue;
	            }
	
	            var styleValue = newMergedPropsStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = newLastIdealStyles[i][key];
	              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities,
	          mergedPropsStyles: newMergedPropsStyles
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  TransitionMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync3 = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync3[0];
	    var currentStyles = _mergeAndSync3[1];
	    var currentVelocities = _mergeAndSync3[2];
	    var lastIdealStyles = _mergeAndSync3[3];
	    var lastIdealVelocities = _mergeAndSync3[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  };
	
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	
	  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  TransitionMotion.prototype.render = function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return TransitionMotion;
	})(_react2['default'].Component);
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400

/***/ }),
/* 694 */
/***/ (function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__(308);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ }),
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.NextArrow = exports.PrevArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _helpers = __webpack_require__(189);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrevArrow = exports.PrevArrow = function (_React$Component) {
	  _inherits(PrevArrow, _React$Component);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  PrevArrow.prototype.render = function render() {
	    var prevClasses = { 'slick-arrow': true, 'slick-prev': true };
	    var prevHandler = this.clickHandler.bind(this, { message: 'previous' });
	
	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses['slick-disabled'] = true;
	      prevHandler = null;
	    }
	
	    var prevArrowProps = {
	      key: '0',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(prevClasses),
	      style: { display: 'block' },
	      onClick: prevHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var prevArrow = void 0;
	
	    if (this.props.prevArrow) {
	      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
	    } else {
	      prevArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '0', type: 'button' }, prevArrowProps),
	        ' Previous'
	      );
	    }
	
	    return prevArrow;
	  };
	
	  return PrevArrow;
	}(_react2.default.Component);
	
	var NextArrow = exports.NextArrow = function (_React$Component2) {
	  _inherits(NextArrow, _React$Component2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  NextArrow.prototype.render = function render() {
	    var nextClasses = { 'slick-arrow': true, 'slick-next': true };
	    var nextHandler = this.clickHandler.bind(this, { message: 'next' });
	
	    if (!_helpers2.default.canGoNext(this.props)) {
	      nextClasses['slick-disabled'] = true;
	      nextHandler = null;
	    }
	
	    var nextArrowProps = {
	      key: '1',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(nextClasses),
	      style: { display: 'block' },
	      onClick: nextHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var nextArrow = void 0;
	
	    if (this.props.nextArrow) {
	      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
	    } else {
	      nextArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '1', type: 'button' }, nextArrowProps),
	        ' Next'
	      );
	    }
	
	    return nextArrow;
	  };
	
	  return NextArrow;
	}(_react2.default.Component);

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Dots = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	  dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  return dots;
	};
	
	var Dots = exports.Dots = function (_React$Component) {
	  _inherits(Dots, _React$Component);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Dots.prototype.clickHandler = function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  };
	
	  Dots.prototype.render = function render() {
	    var _this2 = this;
	
	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll
	    });
	
	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {
	
	      var leftBound = i * _this2.props.slidesToScroll;
	      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
	      var className = (0, _classnames2.default)({
	        'slick-active': _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
	      });
	
	      var dotOptions = {
	        message: 'dots',
	        index: i,
	        slidesToScroll: _this2.props.slidesToScroll,
	        currentSlide: _this2.props.currentSlide
	      };
	
	      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
	
	      return _react2.default.createElement(
	        'li',
	        { key: i, className: className },
	        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
	      );
	    });
	
	    return _react2.default.createElement(
	      'ul',
	      { className: this.props.dotsClass, style: { display: 'block' } },
	      dots
	    );
	  };
	
	  return Dots;
	}(_react2.default.Component);

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(720);

/***/ }),
/* 717 */
/***/ (function(module, exports) {

	"use strict";
	
	var initialState = {
	    animating: false,
	    dragging: false,
	    autoPlayTimer: null,
	    currentDirection: 0,
	    currentLeft: null,
	    currentSlide: 0,
	    direction: 1,
	    listWidth: null,
	    listHeight: null,
	    scrolling: false,
	    // loadIndex: 0,
	    slideCount: null,
	    slideWidth: null,
	    slideHeight: null,
	    swiping: false,
	    // sliding: false,
	    // slideOffset: 0,
	    swipeLeft: null,
	    touchObject: {
	        startX: 0,
	        startY: 0,
	        curX: 0,
	        curY: 0
	    },
	
	    lazyLoadedList: [],
	
	    // added for react
	    initialized: false,
	    edgeDragged: false,
	    swiped: false, // used by swipeEvent. differentites between touch and swipe.
	    trackStyle: {},
	    trackWidth: 0
	
	    // Removed
	    // transformsEnabled: false,
	    // $nextArrow: null,
	    // $prevArrow: null,
	    // $dots: null,
	    // $list: null,
	    // $slideTrack: null,
	    // $slides: null,
	};
	
	module.exports = initialState;

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.InnerSlider = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventHandlers = __webpack_require__(719);
	
	var _eventHandlers2 = _interopRequireDefault(_eventHandlers);
	
	var _helpers = __webpack_require__(189);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _initialState = __webpack_require__(717);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _defaultProps = __webpack_require__(313);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _createReactClass = __webpack_require__(423);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _objectAssign = __webpack_require__(7);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _track = __webpack_require__(721);
	
	var _dots = __webpack_require__(715);
	
	var _arrows = __webpack_require__(714);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InnerSlider = exports.InnerSlider = (0, _createReactClass2.default)({
	  displayName: 'InnerSlider',
	
	  mixins: [_helpers2.default, _eventHandlers2.default],
	  list: null,
	  track: null,
	  listRefHandler: function listRefHandler(ref) {
	    this.list = ref;
	  },
	  trackRefHandler: function trackRefHandler(ref) {
	    this.track = ref;
	  },
	  getInitialState: function getInitialState() {
	    return _extends({}, _initialState2.default, {
	      currentSlide: this.props.initialSlide
	    });
	  },
	  getDefaultProps: function getDefaultProps() {
	    return _defaultProps2.default;
	  },
	  componentWillMount: function componentWillMount() {
	    if (this.props.init) {
	      this.props.init();
	    }
	    this.setState({
	      mounted: true
	    });
	    var lazyLoadedList = [];
	    for (var i = 0; i < _react2.default.Children.count(this.props.children); i++) {
	      if (i >= this.state.currentSlide && i < this.state.currentSlide + this.props.slidesToShow) {
	        lazyLoadedList.push(i);
	      }
	    }
	
	    if (this.props.lazyLoad && this.state.lazyLoadedList.length === 0) {
	      this.setState({
	        lazyLoadedList: lazyLoadedList
	      });
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    // Hack for autoplay -- Inspect Later
	    this.initialize(this.props);
	    this.adaptHeight();
	
	    // To support server-side rendering
	    if (!window) {
	      return;
	    }
	    if (window.addEventListener) {
	      window.addEventListener('resize', this.onWindowResized);
	    } else {
	      window.attachEvent('onresize', this.onWindowResized);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationEndCallback) {
	      clearTimeout(this.animationEndCallback);
	    }
	    if (window.addEventListener) {
	      window.removeEventListener('resize', this.onWindowResized);
	    } else {
	      window.detachEvent('onresize', this.onWindowResized);
	    }
	    if (this.state.autoPlayTimer) {
	      clearInterval(this.state.autoPlayTimer);
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.slickGoTo != nextProps.slickGoTo) {
	      if (false) {
	        console.warn('react-slick deprecation warning: slickGoTo prop is deprecated and it will be removed in next release. Use slickGoTo method instead');
	      }
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.slickGoTo,
	        currentSlide: this.state.currentSlide
	      });
	    } else if (this.state.currentSlide >= nextProps.children.length) {
	      this.update(nextProps);
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.children.length - nextProps.slidesToShow,
	        currentSlide: this.state.currentSlide
	      });
	    } else {
	      this.update(nextProps);
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.adaptHeight();
	  },
	  onWindowResized: function onWindowResized() {
	    this.update(this.props);
	    // animating state should be cleared while resizing, otherwise autoplay stops working
	    this.setState({
	      animating: false
	    });
	    clearTimeout(this.animationEndCallback);
	    delete this.animationEndCallback;
	  },
	  slickPrev: function slickPrev() {
	    this.changeSlide({ message: 'previous' });
	  },
	  slickNext: function slickNext() {
	    this.changeSlide({ message: 'next' });
	  },
	  slickGoTo: function slickGoTo(slide) {
	    slide = Number(slide);
	    !isNaN(slide) && this.changeSlide({
	      message: 'index',
	      index: slide,
	      currentSlide: this.state.currentSlide
	    });
	  },
	  render: function render() {
	    var className = (0, _classnames2.default)('slick-initialized', 'slick-slider', this.props.className, {
	      'slick-vertical': this.props.vertical
	    });
	
	    var trackProps = {
	      fade: this.props.fade,
	      cssEase: this.props.cssEase,
	      speed: this.props.speed,
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      focusOnSelect: this.props.focusOnSelect ? this.selectHandler : null,
	      currentSlide: this.state.currentSlide,
	      lazyLoad: this.props.lazyLoad,
	      lazyLoadedList: this.state.lazyLoadedList,
	      rtl: this.props.rtl,
	      slideWidth: this.state.slideWidth,
	      slidesToShow: this.props.slidesToShow,
	      slidesToScroll: this.props.slidesToScroll,
	      slideCount: this.state.slideCount,
	      trackStyle: this.state.trackStyle,
	      variableWidth: this.props.variableWidth
	    };
	
	    var dots;
	
	    if (this.props.dots === true && this.state.slideCount >= this.props.slidesToShow) {
	      var dotProps = {
	        dotsClass: this.props.dotsClass,
	        slideCount: this.state.slideCount,
	        slidesToShow: this.props.slidesToShow,
	        currentSlide: this.state.currentSlide,
	        slidesToScroll: this.props.slidesToScroll,
	        clickHandler: this.changeSlide,
	        children: this.props.children,
	        customPaging: this.props.customPaging
	      };
	
	      dots = _react2.default.createElement(_dots.Dots, dotProps);
	    }
	
	    var prevArrow, nextArrow;
	
	    var arrowProps = {
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      currentSlide: this.state.currentSlide,
	      slideCount: this.state.slideCount,
	      slidesToShow: this.props.slidesToShow,
	      prevArrow: this.props.prevArrow,
	      nextArrow: this.props.nextArrow,
	      clickHandler: this.changeSlide
	    };
	
	    if (this.props.arrows) {
	      prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
	      nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
	    }
	
	    var verticalHeightStyle = null;
	
	    if (this.props.vertical) {
	      verticalHeightStyle = {
	        height: this.state.listHeight
	      };
	    }
	
	    var centerPaddingStyle = null;
	
	    if (this.props.vertical === false) {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: '0px ' + this.props.centerPadding
	        };
	      }
	    } else {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: this.props.centerPadding + ' 0px'
	        };
	      }
	    }
	
	    var listStyle = (0, _objectAssign2.default)({}, verticalHeightStyle, centerPaddingStyle);
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: this.onInnerSliderEnter,
	        onMouseLeave: this.onInnerSliderLeave,
	        onMouseOver: this.onInnerSliderOver
	      },
	      prevArrow,
	      _react2.default.createElement(
	        'div',
	        {
	          ref: this.listRefHandler,
	          className: 'slick-list',
	          style: listStyle,
	          onMouseDown: this.swipeStart,
	          onMouseMove: this.state.dragging ? this.swipeMove : null,
	          onMouseUp: this.swipeEnd,
	          onMouseLeave: this.state.dragging ? this.swipeEnd : null,
	          onTouchStart: this.swipeStart,
	          onTouchMove: this.state.dragging ? this.swipeMove : null,
	          onTouchEnd: this.swipeEnd,
	          onTouchCancel: this.state.dragging ? this.swipeEnd : null,
	          onKeyDown: this.props.accessibility ? this.keyHandler : null },
	        _react2.default.createElement(
	          _track.Track,
	          _extends({ ref: this.trackRefHandler }, trackProps),
	          this.props.children
	        )
	      ),
	      nextArrow,
	      dots
	    );
	  }
	});

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _trackHelper = __webpack_require__(314);
	
	var _helpers = __webpack_require__(189);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _objectAssign = __webpack_require__(7);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _reactDom = __webpack_require__(9);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventHandlers = {
	  // Event handler for previous and next
	  changeSlide: function changeSlide(options) {
	    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	    var _props = this.props,
	        slidesToScroll = _props.slidesToScroll,
	        slidesToShow = _props.slidesToShow;
	    var _state = this.state,
	        slideCount = _state.slideCount,
	        currentSlide = _state.currentSlide;
	
	    unevenOffset = slideCount % slidesToScroll !== 0;
	    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	    if (options.message === 'previous') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	      targetSlide = currentSlide - slideOffset;
	      if (this.props.lazyLoad) {
	        previousInt = currentSlide - slideOffset;
	        targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	      }
	    } else if (options.message === 'next') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	      targetSlide = currentSlide + slideOffset;
	      if (this.props.lazyLoad) {
	        targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	      }
	    } else if (options.message === 'dots' || options.message === 'children') {
	      // Click on dots
	      targetSlide = options.index * options.slidesToScroll;
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    } else if (options.message === 'index') {
	      targetSlide = Number(options.index);
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    }
	
	    this.slideHandler(targetSlide);
	  },
	
	  // Accessiblity handler for previous and next
	  keyHandler: function keyHandler(e) {
	    //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	    if (!e.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	      if (e.keyCode === 37 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'next' : 'previous'
	        });
	      } else if (e.keyCode === 39 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'previous' : 'next'
	        });
	      }
	    }
	  },
	  // Focus on selecting a slide (click handler on track)
	  selectHandler: function selectHandler(options) {
	    this.changeSlide(options);
	  },
	  swipeStart: function swipeStart(e) {
	    var touches, posX, posY;
	
	    if (this.props.swipe === false || 'ontouchend' in document && this.props.swipe === false) {
	      return;
	    } else if (this.props.draggable === false && e.type.indexOf('mouse') !== -1) {
	      return;
	    }
	    posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
	    posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;
	    this.setState({
	      dragging: true,
	      touchObject: {
	        startX: posX,
	        startY: posY,
	        curX: posX,
	        curY: posY
	      }
	    });
	  },
	  swipeMove: function swipeMove(e) {
	    if (!this.state.dragging) {
	      e.preventDefault();
	      return;
	    }
	    if (this.state.scrolling) {
	      return;
	    }
	    if (this.state.animating) {
	      e.preventDefault();
	      return;
	    }
	    if (this.props.vertical && this.props.swipeToSlide && this.props.verticalSwiping) {
	      e.preventDefault();
	    }
	    var swipeLeft;
	    var curLeft, positionOffset;
	    var touchObject = this.state.touchObject;
	
	    curLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: this.state.currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	
	    if (!this.props.verticalSwiping && !this.state.swiping && verticalSwipeLength > 4) {
	      this.setState({
	        scrolling: true
	      });
	      return;
	    }
	
	    if (this.props.verticalSwiping) {
	      touchObject.swipeLength = verticalSwipeLength;
	    }
	
	    positionOffset = (this.props.rtl === false ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	
	    if (this.props.verticalSwiping) {
	      positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	    }
	
	    var currentSlide = this.state.currentSlide;
	    var dotCount = Math.ceil(this.state.slideCount / this.props.slidesToScroll);
	    var swipeDirection = this.swipeDirection(this.state.touchObject);
	    var touchSwipeLength = touchObject.swipeLength;
	
	    if (this.props.infinite === false) {
	      if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left') {
	        touchSwipeLength = touchObject.swipeLength * this.props.edgeFriction;
	
	        if (this.state.edgeDragged === false && this.props.edgeEvent) {
	          this.props.edgeEvent(swipeDirection);
	          this.setState({ edgeDragged: true });
	        }
	      }
	    }
	
	    if (this.state.swiped === false && this.props.swipeEvent) {
	      this.props.swipeEvent(swipeDirection);
	      this.setState({ swiped: true });
	    }
	
	    if (!this.props.vertical) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft + touchSwipeLength * (this.state.listHeight / this.state.listWidth) * positionOffset;
	    }
	
	    if (this.props.verticalSwiping) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    }
	
	    this.setState({
	      touchObject: touchObject,
	      swipeLeft: swipeLeft,
	      trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: swipeLeft }, this.props, this.state))
	    });
	
	    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	      return;
	    }
	    if (touchObject.swipeLength > 4) {
	      this.setState({
	        swiping: true
	      });
	      e.preventDefault();
	    }
	  },
	  getNavigableIndexes: function getNavigableIndexes() {
	    var max = void 0;
	    var breakPoint = 0;
	    var counter = 0;
	    var indexes = [];
	
	    if (!this.props.infinite) {
	      max = this.state.slideCount;
	    } else {
	      breakPoint = this.props.slidesToShow * -1;
	      counter = this.props.slidesToShow * -1;
	      max = this.state.slideCount * 2;
	    }
	
	    while (breakPoint < max) {
	      indexes.push(breakPoint);
	      breakPoint = counter + this.props.slidesToScroll;
	
	      counter += this.props.slidesToScroll <= this.props.slidesToShow ? this.props.slidesToScroll : this.props.slidesToShow;
	    }
	
	    return indexes;
	  },
	  checkNavigable: function checkNavigable(index) {
	    var navigables = this.getNavigableIndexes();
	    var prevNavigable = 0;
	
	    if (index > navigables[navigables.length - 1]) {
	      index = navigables[navigables.length - 1];
	    } else {
	      for (var n in navigables) {
	        if (index < navigables[n]) {
	          index = prevNavigable;
	          break;
	        }
	
	        prevNavigable = navigables[n];
	      }
	    }
	
	    return index;
	  },
	  getSlideCount: function getSlideCount() {
	    var _this = this;
	
	    var centerOffset = this.props.centerMode ? this.state.slideWidth * Math.floor(this.props.slidesToShow / 2) : 0;
	
	    if (this.props.swipeToSlide) {
	      var swipedSlide = void 0;
	
	      var slickList = _reactDom2.default.findDOMNode(this.list);
	
	      var slides = slickList.querySelectorAll('.slick-slide');
	
	      Array.from(slides).every(function (slide) {
	        if (!_this.props.vertical) {
	          if (slide.offsetLeft - centerOffset + _this.getWidth(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        } else {
	          if (slide.offsetTop + _this.getHeight(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        }
	
	        return true;
	      });
	
	      var slidesTraversed = Math.abs(swipedSlide.dataset.index - this.state.currentSlide) || 1;
	
	      return slidesTraversed;
	    } else {
	      return this.props.slidesToScroll;
	    }
	  },
	
	  swipeEnd: function swipeEnd(e) {
	    if (!this.state.dragging) {
	      if (this.props.swipe) {
	        e.preventDefault();
	      }
	      return;
	    }
	    var touchObject = this.state.touchObject;
	    var minSwipe = this.state.listWidth / this.props.touchThreshold;
	    var swipeDirection = this.swipeDirection(touchObject);
	
	    if (this.props.verticalSwiping) {
	      minSwipe = this.state.listHeight / this.props.touchThreshold;
	    }
	
	    var wasScrolling = this.state.scrolling;
	    // reset the state of touch related state variables.
	    this.setState({
	      dragging: false,
	      edgeDragged: false,
	      scrolling: false,
	      swiping: false,
	      swiped: false,
	      swipeLeft: null,
	      touchObject: {}
	    });
	    if (wasScrolling) {
	      return;
	    }
	
	    // Fix for #13
	    if (!touchObject.swipeLength) {
	      return;
	    }
	    if (touchObject.swipeLength > minSwipe) {
	      e.preventDefault();
	
	      var slideCount = void 0,
	          newSlide = void 0;
	
	      switch (swipeDirection) {
	
	        case 'left':
	        case 'down':
	          newSlide = this.state.currentSlide + this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 0;
	          break;
	
	        case 'right':
	        case 'up':
	          newSlide = this.state.currentSlide - this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 1;
	          break;
	
	        default:
	          slideCount = this.state.currentSlide;
	
	      }
	
	      this.slideHandler(slideCount);
	    } else {
	      // Adjust the track back to it's original position.
	      var currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, this.props, this.state));
	
	      this.setState({
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      });
	    }
	  },
	  onInnerSliderEnter: function onInnerSliderEnter(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderOver: function onInnerSliderOver(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderLeave: function onInnerSliderLeave(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.autoPlay();
	    }
	  }
	};
	
	exports.default = EventHandlers;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _innerSlider = __webpack_require__(718);
	
	var _objectAssign = __webpack_require__(7);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _json2mq = __webpack_require__(471);
	
	var _json2mq2 = _interopRequireDefault(_json2mq);
	
	var _defaultProps = __webpack_require__(313);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _canUseDom = __webpack_require__(359);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var enquire = _canUseDom2.default && __webpack_require__(433);
	
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    _this.innerSliderRefHandler = _this.innerSliderRefHandler.bind(_this);
	    return _this;
	  }
	
	  Slider.prototype.innerSliderRefHandler = function innerSliderRefHandler(ref) {
	    this.innerSlider = ref;
	  };
	
	  Slider.prototype.media = function media(query, handler) {
	    enquire.register(query, handler);
	    this._responsiveMediaHandlers.push({ query: query, handler: handler });
	  };
	
	  Slider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });
	
	      breakpoints.forEach(function (breakpoint, index) {
	        var bQuery;
	        if (index === 0) {
	          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2.default)({ minWidth: breakpoints[index - 1], maxWidth: breakpoint });
	        }
	        _canUseDom2.default && _this2.media(bQuery, function () {
	          _this2.setState({ breakpoint: breakpoint });
	        });
	      });
	
	      // Register media query for full screen. Need to support resize from small to large
	      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });
	
	      _canUseDom2.default && this.media(query, function () {
	        _this2.setState({ breakpoint: null });
	      });
	    }
	  };
	
	  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._responsiveMediaHandlers.forEach(function (obj) {
	      enquire.unregister(obj.query, obj.handler);
	    });
	  };
	
	  Slider.prototype.slickPrev = function slickPrev() {
	    this.innerSlider.slickPrev();
	  };
	
	  Slider.prototype.slickNext = function slickNext() {
	    this.innerSlider.slickNext();
	  };
	
	  Slider.prototype.slickGoTo = function slickGoTo(slide) {
	    this.innerSlider.slickGoTo(slide);
	  };
	
	  Slider.prototype.render = function render() {
	    var _this3 = this;
	
	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this3.state.breakpoint;
	      });
	      settings = newProps[0].settings === 'unslick' ? 'unslick' : (0, _objectAssign2.default)({}, this.props, newProps[0].settings);
	    } else {
	      settings = (0, _objectAssign2.default)({}, _defaultProps2.default, this.props);
	    }
	
	    var children = this.props.children;
	    if (!Array.isArray(children)) {
	      children = [children];
	    }
	
	    // Children may contain false or null, so we should filter them
	    children = children.filter(function (child) {
	      return !!child;
	    });
	
	    if (settings === 'unslick') {
	      // if 'unslick' responsive breakpoint setting used, just return the <Slider> tag nested HTML
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.className + ' unslicked' },
	        children
	      );
	    } else {
	      return _react2.default.createElement(
	        _innerSlider.InnerSlider,
	        _extends({ ref: this.innerSliderRefHandler }, settings),
	        children
	      );
	    }
	  };
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Track = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(7);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  return (0, _classnames2.default)({
	    'slick-slide': true,
	    'slick-active': slickActive,
	    'slick-center': slickCenter,
	    'slick-cloned': slickCloned
	  });
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = 'relative';
	    style.left = -spec.index * spec.slideWidth;
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	    style.WebkitTransition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  // key could be a zero
	  return child.key === null || child.key === undefined ? fallbackKey : child.key;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var count = _react2.default.Children.count(spec.children);
	
	  _react2.default.Children.forEach(spec.children, function (elem, index) {
	    var child = void 0;
	    var childOnClickOptions = {
	      message: 'children',
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };
	
	    if (!spec.lazyLoad | (spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0)) {
	      child = elem;
	    } else {
	      child = _react2.default.createElement('div', null);
	    }
	    var childStyle = getSlideStyle((0, _objectAssign2.default)({}, spec, { index: index }));
	    var slideClass = child.props.className || '';
	
	    var onClick = function onClick(e) {
	      child.props && child.props.onClick && child.props.onClick(e);
	      if (spec.focusOnSelect) {
	        spec.focusOnSelect(childOnClickOptions);
	      }
	    };
	
	    slides.push(_react2.default.cloneElement(child, {
	      key: 'original' + getKey(child, index),
	      'data-index': index,
	      className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: index }, spec)), slideClass),
	      tabIndex: '-1',
	      style: (0, _objectAssign2.default)({ outline: 'none' }, child.props.style || {}, childStyle),
	      onClick: onClick
	    }));
	
	    // variableWidth doesn't wrap properly.
	    if (spec.infinite && spec.fade === false) {
	      var infiniteCount = spec.variableWidth ? spec.slidesToShow + 1 : spec.slidesToShow;
	
	      if (index >= count - infiniteCount) {
	        key = -(count - index);
	        preCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'precloned' + getKey(child, key),
	          'data-index': key,
	          className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: key }, spec)), slideClass),
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	
	      if (index < infiniteCount) {
	        key = count + index;
	        postCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'postcloned' + getKey(child, key),
	          'data-index': key,
	          className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: key }, spec)), slideClass),
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = exports.Track = function (_React$Component) {
	  _inherits(Track, _React$Component);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Track.prototype.render = function render() {
	    var slides = renderSlides.call(this, this.props);
	    return _react2.default.createElement(
	      'div',
	      { className: 'slick-track', style: this.props.trackStyle },
	      slides
	    );
	  };
	
	  return Track;
	}(_react2.default.Component);

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _warning = __webpack_require__(18);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkIndexBounds = function checkIndexBounds(props) {
	  var index = props.index,
	      children = props.children;
	
	
	  var childrenCount = _react.Children.count(children);
	
	   false ? (0, _warning2.default)(index >= 0 && index <= childrenCount, 'react-swipeable-view: the new index: ' + index + ' is out of bounds: [0-' + childrenCount + '].') : void 0;
	};
	
	exports.default = checkIndexBounds;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = computeIndex;
	
	var _react = __webpack_require__(1);
	
	var _constant = __webpack_require__(315);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function computeIndex(params) {
	  var children = params.children,
	      startIndex = params.startIndex,
	      startX = params.startX,
	      pageX = params.pageX,
	      viewLength = params.viewLength,
	      resistance = params.resistance;
	
	
	  var indexMax = _react.Children.count(children) - 1;
	  var index = startIndex + (startX - pageX) / viewLength;
	  var newStartX = void 0;
	
	  if (!resistance) {
	    // Reset the starting point
	    if (index < 0) {
	      index = 0;
	      newStartX = (index - startIndex) * viewLength + pageX;
	    } else if (index > indexMax) {
	      index = indexMax;
	      newStartX = (index - startIndex) * viewLength + pageX;
	    }
	  } else if (index < 0) {
	    index = Math.exp(index * _constant2.default.RESISTANCE_COEF) - 1;
	  } else if (index > indexMax) {
	    index = indexMax + 1 - Math.exp((indexMax - index) * _constant2.default.RESISTANCE_COEF);
	  }
	
	  return {
	    index: index,
	    startX: newStartX
	  };
	}

/***/ }),
/* 724 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getDisplaySameSlide = function getDisplaySameSlide(props, nextProps) {
	  var displaySameSlide = false;
	
	  if (props.children.length && nextProps.children.length) {
	    var oldChildren = props.children[props.index];
	    var oldKey = oldChildren ? oldChildren.key : 'empty';
	
	    if (oldKey !== null) {
	      var newChildren = nextProps.children[nextProps.index];
	      var newKey = newChildren ? newChildren.key : 'empty';
	
	      if (oldKey === newKey) {
	        displaySameSlide = true;
	      }
	    }
	  }
	
	  return displaySameSlide;
	};
	
	exports.default = getDisplaySameSlide;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _checkIndexBounds = __webpack_require__(722);
	
	Object.defineProperty(exports, 'checkIndexBounds', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_checkIndexBounds).default;
	  }
	});
	
	var _computeIndex = __webpack_require__(723);
	
	Object.defineProperty(exports, 'computeIndex', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_computeIndex).default;
	  }
	});
	
	var _constant = __webpack_require__(315);
	
	Object.defineProperty(exports, 'constant', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_constant).default;
	  }
	});
	
	var _getDisplaySameSlide = __webpack_require__(724);
	
	Object.defineProperty(exports, 'getDisplaySameSlide', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getDisplaySameSlide).default;
	  }
	});
	
	var _mod = __webpack_require__(726);
	
	Object.defineProperty(exports, 'mod', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_mod).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 726 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Extended version of % with negative integer support.
	function mod(n, m) {
	  var q = n % m;
	  return q < 0 ? q + m : q;
	}
	
	exports.default = mod;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(121);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(122);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(353);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(358);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(51);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(50);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.getDomTreeShapes = getDomTreeShapes;
	exports.findNativeHandler = findNativeHandler;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(18);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _properties = __webpack_require__(224);
	
	var _properties2 = _interopRequireDefault(_properties);
	
	var _on = __webpack_require__(222);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(221);
	
	var _off2 = _interopRequireDefault(_off);
	
	var _reactSwipeableViewsCore = __webpack_require__(725);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addEventListenerEnhanced(node, event, handler, options) {
	  (0, _on2.default)(node, event, handler, options);
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, options);
	    }
	  };
	}
	
	var styleInjected = false;
	
	// Support old version of iOS and IE 10.
	// To be deleted in 2019.
	function injectStyle() {
	  // Inject once for all the instances
	  if (!styleInjected) {
	    var style = document.createElement('style');
	    style.innerHTML = '\n      .react-swipeable-view-container {\n        display: -webkit-box;\n        display: -ms-flexbox;\n      }\n      .react-swipeable-view-container > div {\n        -ms-flex-negative: 0;\n      }\n    ';
	
	    if (document.body) {
	      document.body.appendChild(style);
	    }
	    styleInjected = true;
	  }
	}
	
	var styles = {
	  container: {
	    direction: 'ltr',
	    display: 'flex',
	    willChange: 'transform'
	  },
	  slide: {
	    width: '100%',
	    WebkitFlexShrink: 0,
	    flexShrink: 0,
	    overflow: 'auto'
	  }
	};
	
	var axisProperties = {
	  root: {
	    x: {
	      overflowX: 'hidden'
	    },
	    'x-reverse': {
	      overflowX: 'hidden'
	    },
	    y: {
	      overflowY: 'hidden'
	    },
	    'y-reverse': {
	      overflowY: 'hidden'
	    }
	  },
	  flexDirection: {
	    x: 'row',
	    'x-reverse': 'row-reverse',
	    y: 'column',
	    'y-reverse': 'column-reverse'
	  },
	  transform: {
	    x: function x(translate) {
	      return 'translate(' + -translate + '%, 0)';
	    },
	    'x-reverse': function xReverse(translate) {
	      return 'translate(' + translate + '%, 0)';
	    },
	    y: function y(translate) {
	      return 'translate(0, ' + -translate + '%)';
	    },
	    'y-reverse': function yReverse(translate) {
	      return 'translate(0, ' + translate + '%)';
	    }
	  },
	  length: {
	    x: 'width',
	    'x-reverse': 'width',
	    y: 'height',
	    'y-reverse': 'height'
	  },
	  rotationMatrix: {
	    x: {
	      x: [1, 0],
	      y: [0, 1]
	    },
	    'x-reverse': {
	      x: [-1, 0],
	      y: [0, 1]
	    },
	    y: {
	      x: [0, 1],
	      y: [1, 0]
	    },
	    'y-reverse': {
	      x: [0, -1],
	      y: [1, 0]
	    }
	  },
	  scrollPosition: {
	    x: 'scrollLeft',
	    'x-reverse': 'scrollLeft',
	    y: 'scrollTop',
	    'y-reverse': 'scrollTop'
	  },
	  scrollLength: {
	    x: 'scrollWidth',
	    'x-reverse': 'scrollWidth',
	    y: 'scrollHeight',
	    'y-reverse': 'scrollHeight'
	  },
	  clientLength: {
	    x: 'clientWidth',
	    'x-reverse': 'clientWidth',
	    y: 'clientHeight',
	    'y-reverse': 'clientHeight'
	  }
	};
	
	function createTransition(property, options) {
	  var duration = options.duration,
	      easeFunction = options.easeFunction,
	      delay = options.delay;
	
	
	  return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
	}
	
	// We are using a 2x2 rotation matrix.
	function applyRotationMatrix(touch, axis) {
	  var rotationMatrix = axisProperties.rotationMatrix[axis];
	
	  return {
	    pageX: rotationMatrix.x[0] * touch.pageX + rotationMatrix.x[1] * touch.pageY,
	    pageY: rotationMatrix.y[0] * touch.pageX + rotationMatrix.y[1] * touch.pageY
	  };
	}
	
	function adaptMouse(event) {
	  event.touches = [{ pageX: event.pageX, pageY: event.pageY }];
	  return event;
	}
	
	function getDomTreeShapes(element, rootNode) {
	  var domTreeShapes = [];
	
	  while (element && element !== rootNode) {
	    // We reach a Swipeable View, no need to look higher in the dom tree.
	    if (element.hasAttribute('data-swipeable')) {
	      break;
	    }
	
	    var style = window.getComputedStyle(element);
	
	    if (
	    // Ignore the scroll children if the element is absolute positioned.
	    style.getPropertyValue('position') === 'absolute' ||
	    // Ignore the scroll children if the element has an overflowX hidden
	    style.getPropertyValue('overflow-x') === 'hidden') {
	      domTreeShapes = [];
	    } else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) {
	      // Ignore the nodes that have no width.
	      // Keep elements with a scroll
	      domTreeShapes.push({
	        element: element,
	        scrollWidth: element.scrollWidth,
	        scrollHeight: element.scrollHeight,
	        clientWidth: element.clientWidth,
	        clientHeight: element.clientHeight,
	        scrollLeft: element.scrollLeft,
	        scrollTop: element.scrollTop
	      });
	    }
	
	    element = element.parentNode;
	  }
	
	  return domTreeShapes;
	}
	
	// We can only have one node at the time claiming ownership for handling the swipe.
	// Otherwise, the UX would be confusing.
	// That's why we use a singleton here.
	var nodeHowClaimedTheScroll = null;
	
	function findNativeHandler(params) {
	  var domTreeShapes = params.domTreeShapes,
	      pageX = params.pageX,
	      startX = params.startX,
	      axis = params.axis;
	
	
	  return domTreeShapes.some(function (shape) {
	    // Determine if we are going backward or forward.
	    var goingForward = pageX >= startX;
	    if (axis === 'x' || axis === 'y') {
	      goingForward = !goingForward;
	    }
	
	    var scrollPosition = shape[axisProperties.scrollPosition[axis]];
	
	    var areNotAtStart = scrollPosition > 0;
	    var areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];
	
	    if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) {
	      nodeHowClaimedTheScroll = shape.element;
	      return true;
	    }
	
	    return false;
	  });
	}
	
	var SwipeableViews = function (_Component) {
	  (0, _inherits3.default)(SwipeableViews, _Component);
	
	  function SwipeableViews() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SwipeableViews);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SwipeableViews.__proto__ || (0, _getPrototypeOf2.default)(SwipeableViews)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      indexLatest: null,
	      // Set to true as soon as the component is swiping.
	      // It's the state counter part of this.isSwiping.
	      isDragging: false,
	      // Help with SSR logic and lazy loading logic.
	      isFirstRender: true,
	      heightLatest: 0,
	      // Let the render method that we are going to display the same slide than previously.
	      displaySameSlide: true
	    }, _this.rootNode = null, _this.containerNode = null, _this.ignoreNextScrollEvents = false, _this.viewLength = 0, _this.startX = 0, _this.lastX = 0, _this.vx = 0, _this.startY = 0, _this.isSwiping = undefined, _this.started = false, _this.startIndex = 0, _this.transitionListener = null, _this.touchMoveListener = null, _this.activeSlide = null, _this.indexCurrent = null, _this.handleSwipeStart = function (event) {
	      var axis = _this.props.axis;
	
	      // Latency and rapid rerenders on some devices can leave
	      // a period where rootNode briefly equals null.
	
	      if (_this.rootNode === null) {
	        return;
	      }
	
	      var touch = applyRotationMatrix(event.touches[0], axis);
	
	      _this.viewLength = _this.rootNode.getBoundingClientRect()[axisProperties.length[axis]];
	      _this.startX = touch.pageX;
	      _this.lastX = touch.pageX;
	      _this.vx = 0;
	      _this.startY = touch.pageY;
	      _this.isSwiping = undefined;
	      _this.started = true;
	
	      var computedStyle = window.getComputedStyle(_this.containerNode);
	      var transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
	
	      if (transform && transform !== 'none') {
	        var transformValues = transform.split('(')[1].split(')')[0].split(',');
	        var rootStyle = window.getComputedStyle(_this.rootNode);
	
	        var tranformNormalized = applyRotationMatrix({
	          pageX: parseInt(transformValues[4], 10),
	          pageY: parseInt(transformValues[5], 10)
	        }, axis);
	
	        _this.startIndex = -tranformNormalized.pageX / (_this.viewLength - parseInt(rootStyle.paddingLeft, 10) - parseInt(rootStyle.paddingRight, 10));
	      }
	    }, _this.handleSwipeMove = function (event) {
	      // The touch start event can be cancel.
	      // Makes sure we set a starting point.
	      if (!_this.started) {
	        _this.handleTouchStart(event);
	        return;
	      }
	
	      // Latency and rapid rerenders on some devices
	      // can leave a period where rootNode briefly equals null.
	      if (_this.rootNode === null) {
	        return;
	      }
	
	      // We are not supposed to hanlde this touch move.
	      if (nodeHowClaimedTheScroll !== null && nodeHowClaimedTheScroll !== _this.rootNode) {
	        return;
	      }
	
	      var _this$props = _this.props,
	          axis = _this$props.axis,
	          children = _this$props.children,
	          ignoreNativeScroll = _this$props.ignoreNativeScroll,
	          onSwitching = _this$props.onSwitching,
	          resistance = _this$props.resistance;
	
	
	      var touch = applyRotationMatrix(event.touches[0], axis);
	
	      // We don't know yet.
	      if (_this.isSwiping === undefined) {
	        var dx = Math.abs(_this.startX - touch.pageX);
	        var dy = Math.abs(_this.startY - touch.pageY);
	
	        var isSwiping = dx > dy && dx > _reactSwipeableViewsCore.constant.UNCERTAINTY_THRESHOLD;
	
	        // We let the parent handle the scroll.
	        if (!resistance && (axis === 'y' || axis === 'y-reverse') && (_this.indexCurrent === 0 && _this.startX < touch.pageX || _this.indexCurrent === _react.Children.count(_this.props.children) - 1 && _this.startX > touch.pageX)) {
	          _this.isSwiping = false;
	          return;
	        }
	
	        // We are likely to be swiping, let's prevent the scroll event.
	        if (dx > dy) {
	          event.preventDefault();
	        }
	
	        if (isSwiping === true || dy > _reactSwipeableViewsCore.constant.UNCERTAINTY_THRESHOLD) {
	          _this.isSwiping = isSwiping;
	          _this.startX = touch.pageX; // Shift the starting point.
	
	          return; // Let's wait the next touch event to move something.
	        }
	      }
	
	      if (_this.isSwiping !== true) {
	        return;
	      }
	
	      // We are swiping, let's prevent the scroll event.
	      event.preventDefault();
	
	      // Low Pass filter.
	      _this.vx = _this.vx * 0.5 + (touch.pageX - _this.lastX) * 0.5;
	      _this.lastX = touch.pageX;
	
	      var _computeIndex = (0, _reactSwipeableViewsCore.computeIndex)({
	        children: children,
	        resistance: resistance,
	        pageX: touch.pageX,
	        startIndex: _this.startIndex,
	        startX: _this.startX,
	        viewLength: _this.viewLength
	      }),
	          index = _computeIndex.index,
	          startX = _computeIndex.startX;
	
	      // Add support for native scroll elements.
	
	
	      if (nodeHowClaimedTheScroll === null && !ignoreNativeScroll) {
	        var domTreeShapes = getDomTreeShapes(event.target, _this.rootNode);
	        var hasFoundNativeHandler = findNativeHandler({
	          domTreeShapes: domTreeShapes,
	          startX: _this.startX,
	          pageX: touch.pageX,
	          axis: axis
	        });
	
	        // We abort the touch move handler.
	        if (hasFoundNativeHandler) {
	          return;
	        }
	      }
	
	      // We are moving toward the edges.
	      if (startX) {
	        _this.startX = startX;
	      } else if (nodeHowClaimedTheScroll === null) {
	        nodeHowClaimedTheScroll = _this.rootNode;
	      }
	
	      _this.setIndexCurrent(index);
	
	      var callback = function callback() {
	        if (onSwitching) {
	          onSwitching(index, 'move');
	        }
	      };
	
	      if (_this.state.displaySameSlide || !_this.state.isDragging) {
	        _this.setState({
	          displaySameSlide: false,
	          isDragging: true
	        }, callback);
	      }
	
	      callback();
	    }, _this.handleSwipeEnd = function () {
	      nodeHowClaimedTheScroll = null;
	
	      // The touch start event can be cancel.
	      // Makes sure that a starting point is set.
	      if (!_this.started) {
	        return;
	      }
	
	      _this.started = false;
	
	      if (_this.isSwiping !== true) {
	        return;
	      }
	
	      var indexLatest = _this.state.indexLatest;
	      var indexCurrent = _this.indexCurrent;
	      var delta = indexLatest - indexCurrent;
	
	      var indexNew = void 0;
	
	      // Quick movement
	      if (Math.abs(_this.vx) > _this.props.threshold) {
	        if (_this.vx > 0) {
	          indexNew = Math.floor(indexCurrent);
	        } else {
	          indexNew = Math.ceil(indexCurrent);
	        }
	      } else if (Math.abs(delta) > _this.props.hysteresis) {
	        // Some hysteresis with indexLatest.
	        indexNew = delta > 0 ? Math.floor(indexCurrent) : Math.ceil(indexCurrent);
	      } else {
	        indexNew = indexLatest;
	      }
	
	      var indexMax = _react.Children.count(_this.props.children) - 1;
	
	      if (indexNew < 0) {
	        indexNew = 0;
	      } else if (indexNew > indexMax) {
	        indexNew = indexMax;
	      }
	
	      _this.setIndexCurrent(indexNew);
	      _this.setState({
	        indexLatest: indexNew,
	        isDragging: false
	      }, function () {
	        if (_this.props.onSwitching) {
	          _this.props.onSwitching(indexNew, 'end');
	        }
	
	        if (_this.props.onChangeIndex && indexNew !== indexLatest) {
	          _this.props.onChangeIndex(indexNew, indexLatest, {
	            reason: 'swipe'
	          });
	        }
	
	        // Manually calling handleTransitionEnd in that case as isn't otherwise.
	        if (indexCurrent === indexLatest) {
	          _this.handleTransitionEnd();
	        }
	      });
	    }, _this.handleTouchStart = function (event) {
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	      _this.handleSwipeStart(event);
	    }, _this.handleTouchEnd = function (event) {
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(event);
	      }
	      _this.handleSwipeEnd(event);
	    }, _this.handleMouseDown = function (event) {
	      if (_this.props.onMouseDown) {
	        _this.props.onMouseDown(event);
	      }
	      event.persist();
	      _this.handleSwipeStart(adaptMouse(event));
	    }, _this.handleMouseUp = function (event) {
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(event);
	      }
	      _this.handleSwipeEnd(adaptMouse(event));
	    }, _this.handleMouseLeave = function (event) {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	
	      // Filter out events
	      if (_this.started) {
	        _this.handleSwipeEnd(adaptMouse(event));
	      }
	    }, _this.handleMouseMove = function (event) {
	      if (_this.props.onMouseMove) {
	        _this.props.onMouseMove(event);
	      }
	
	      // Filter out events
	      if (_this.started) {
	        _this.handleSwipeMove(adaptMouse(event));
	      }
	    }, _this.handleScroll = function (event) {
	      if (_this.props.onScroll) {
	        _this.props.onScroll(event);
	      }
	
	      // Ignore events bubbling up.
	      if (event.target !== _this.rootNode) {
	        return;
	      }
	
	      if (_this.ignoreNextScrollEvents) {
	        _this.ignoreNextScrollEvents = false;
	        return;
	      }
	
	      var indexLatest = _this.state.indexLatest;
	      var indexNew = Math.ceil(event.target.scrollLeft / event.target.clientWidth) + indexLatest;
	
	      _this.ignoreNextScrollEvents = true;
	      // Reset the scroll position.
	      event.target.scrollLeft = 0;
	
	      if (_this.props.onChangeIndex && indexNew !== indexLatest) {
	        _this.props.onChangeIndex(indexNew, indexLatest, {
	          reason: 'focus'
	        });
	      }
	    }, _this.updateHeight = function () {
	      if (_this.activeSlide !== null) {
	        var child = _this.activeSlide.children[0];
	        if (child !== undefined && child.offsetHeight !== undefined && _this.state.heightLatest !== child.offsetHeight) {
	          _this.setState({
	            heightLatest: child.offsetHeight
	          });
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SwipeableViews, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _this2 = this;
	
	      return {
	        swipeableViews: {
	          slideUpdateHeight: function slideUpdateHeight() {
	            _this2.updateHeight();
	          }
	        }
	      };
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (false) {
	        (0, _reactSwipeableViewsCore.checkIndexBounds)(this.props);
	      }
	
	      this.setIndexCurrent(this.props.index);
	      this.setState({
	        indexLatest: this.props.index
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      // Subscribe to transition end events.
	      this.transitionListener = addEventListenerEnhanced(this.containerNode, _properties2.default.end, function (event) {
	        if (event.target !== _this3.containerNode) {
	          return;
	        }
	
	        _this3.handleTransitionEnd();
	      });
	
	      // Block the thread to handle that event.
	      this.touchMoveListener = addEventListenerEnhanced(this.rootNode, 'touchmove', function (event) {
	        // Handling touch events is disabled.
	        if (_this3.props.disabled) {
	          return;
	        }
	        _this3.handleSwipeMove(event);
	      }, {
	        passive: false
	      });
	
	      // eslint-disable-next-line react/no-did-mount-set-state
	      this.setState({
	        isFirstRender: false
	      });
	
	      injectStyle();
	
	      // Send all functions in an object if action param is set.
	      if (this.props.action) {
	        this.props.action({
	          updateHeight: this.updateHeight
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var index = nextProps.index;
	
	
	      if (typeof index === 'number' && index !== this.props.index) {
	        if (false) {
	          (0, _reactSwipeableViewsCore.checkIndexBounds)(nextProps);
	        }
	
	        this.setIndexCurrent(index);
	        this.setState({
	          // If true, we are going to change the children. We shoudn't animate it.
	          displaySameSlide: (0, _reactSwipeableViewsCore.getDisplaySameSlide)(this.props, nextProps),
	          indexLatest: index
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.transitionListener.remove();
	      this.touchMoveListener.remove();
	    }
	  }, {
	    key: 'setIndexCurrent',
	    value: function setIndexCurrent(indexCurrent) {
	      if (!this.props.animateTransitions && this.indexCurrent !== indexCurrent) {
	        this.handleTransitionEnd();
	      }
	
	      this.indexCurrent = indexCurrent;
	
	      if (this.containerNode) {
	        var axis = this.props.axis;
	
	        var transform = axisProperties.transform[axis](indexCurrent * 100);
	        this.containerNode.style.WebkitTransform = transform;
	        this.containerNode.style.transform = transform;
	      }
	    }
	  }, {
	    key: 'handleTransitionEnd',
	    value: function handleTransitionEnd() {
	      if (!this.props.onTransitionEnd) {
	        return;
	      }
	
	      // Filters out when changing the children
	      if (this.state.displaySameSlide) {
	        return;
	      }
	
	      // The rest callback is triggered when swiping. It's just noise.
	      // We filter it out.
	      if (!this.state.isDragging) {
	        this.props.onTransitionEnd();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          action = _props.action,
	          animateHeight = _props.animateHeight,
	          animateTransitions = _props.animateTransitions,
	          axis = _props.axis,
	          children = _props.children,
	          containerStyleProp = _props.containerStyle,
	          disabled = _props.disabled,
	          disableLazyLoading = _props.disableLazyLoading,
	          enableMouseEvents = _props.enableMouseEvents,
	          hysteresis = _props.hysteresis,
	          ignoreNativeScroll = _props.ignoreNativeScroll,
	          index = _props.index,
	          onChangeIndex = _props.onChangeIndex,
	          onSwitching = _props.onSwitching,
	          onTransitionEnd = _props.onTransitionEnd,
	          resistance = _props.resistance,
	          slideStyleProp = _props.slideStyle,
	          slideClassName = _props.slideClassName,
	          springConfig = _props.springConfig,
	          style = _props.style,
	          threshold = _props.threshold,
	          other = (0, _objectWithoutProperties3.default)(_props, ['action', 'animateHeight', 'animateTransitions', 'axis', 'children', 'containerStyle', 'disabled', 'disableLazyLoading', 'enableMouseEvents', 'hysteresis', 'ignoreNativeScroll', 'index', 'onChangeIndex', 'onSwitching', 'onTransitionEnd', 'resistance', 'slideStyle', 'slideClassName', 'springConfig', 'style', 'threshold']);
	      var _state = this.state,
	          displaySameSlide = _state.displaySameSlide,
	          heightLatest = _state.heightLatest,
	          isDragging = _state.isDragging,
	          isFirstRender = _state.isFirstRender,
	          indexLatest = _state.indexLatest;
	
	      var touchEvents = !disabled ? {
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd
	      } : {};
	      var mouseEvents = !disabled && enableMouseEvents ? {
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseMove: this.handleMouseMove
	      } : {};
	
	      // There is no point to animate if we are already providing a height.
	       false ? (0, _warning2.default)(!animateHeight || !containerStyleProp || !containerStyleProp.height, 'react-swipeable-view: You are setting animateHeight to true but you are\nalso providing a custom height.\nThe custom height has a higher priority than the animateHeight property.\nSo animateHeight is most likely having no effect at all.') : void 0;
	
	      var slideStyle = (0, _extends3.default)({}, styles.slide, slideStyleProp);
	
	      var transition = void 0;
	      var WebkitTransition = void 0;
	
	      if (isDragging || !animateTransitions || displaySameSlide) {
	        transition = 'all 0s ease 0s';
	        WebkitTransition = 'all 0s ease 0s';
	      } else {
	        transition = createTransition('transform', springConfig);
	        WebkitTransition = createTransition('-webkit-transform', springConfig);
	
	        if (heightLatest !== 0) {
	          var additionalTranstion = ', ' + createTransition('height', springConfig);
	          transition += additionalTranstion;
	          WebkitTransition += additionalTranstion;
	        }
	      }
	
	      var containerStyle = {
	        height: null,
	        WebkitFlexDirection: axisProperties.flexDirection[axis],
	        flexDirection: axisProperties.flexDirection[axis],
	        WebkitTransition: WebkitTransition,
	        transition: transition
	      };
	
	      // Apply the styles for SSR considerations
	      if (disableLazyLoading || !isFirstRender) {
	        var transform = axisProperties.transform[axis](this.indexCurrent * 100);
	        containerStyle.WebkitTransform = transform;
	        containerStyle.transform = transform;
	      }
	
	      if (animateHeight) {
	        containerStyle.height = heightLatest;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({
	          ref: function ref(node) {
	            _this4.rootNode = node;
	          },
	          style: (0, _extends3.default)({}, axisProperties.root[axis], style)
	        }, other, touchEvents, mouseEvents, {
	          onScroll: this.handleScroll
	        }),
	        _react2.default.createElement(
	          'div',
	          {
	            ref: function ref(node) {
	              _this4.containerNode = node;
	            },
	            style: (0, _extends3.default)({}, containerStyle, styles.container, containerStyleProp),
	            className: 'react-swipeable-view-container'
	          },
	          _react.Children.map(children, function (child, indexChild) {
	            if (!disableLazyLoading && isFirstRender && indexChild !== indexLatest) {
	              return null;
	            }
	
	             false ? (0, _warning2.default)((0, _react.isValidElement)(child), 'react-swipeable-view: one of the children provided is invalid: ' + child + '.\nWe are expecting a valid React Element') : void 0;
	
	            var ref = void 0;
	            var hidden = true;
	
	            if (indexChild === indexLatest) {
	              hidden = false;
	
	              if (animateHeight) {
	                ref = function ref(node) {
	                  _this4.activeSlide = node;
	                  _this4.updateHeight();
	                };
	                slideStyle.overflowY = 'hidden';
	              }
	            }
	
	            return _react2.default.createElement(
	              'div',
	              {
	                ref: ref,
	                style: slideStyle,
	                className: slideClassName,
	                'aria-hidden': hidden,
	                'data-swipeable': 'true'
	              },
	              child
	            );
	          })
	        )
	      );
	    }
	  }]);
	  return SwipeableViews;
	}(_react.Component);
	
	// Added as an ads for people using the React dev tools in production.
	// So they know, the tool used to build the awesome UI they
	// are looking at/retro engineering.
	
	
	SwipeableViews.displayName = 'ReactSwipableView';
	
	SwipeableViews.propTypes =  false ? {
	  /**
	   * This is callback property. It's called by the component on mount.
	   * This is useful when you want to trigger an action programmatically.
	   * It currently only supports updateHeight() action.
	   *
	   * @param {object} actions This object contains all posible actions
	   * that can be triggered programmatically.
	   */
	  action: _propTypes2.default.func,
	  /**
	   * If `true`, the height of the container will be animated to match the current slide height.
	   * Animating another style property has a negative impact regarding performance.
	   */
	  animateHeight: _propTypes2.default.bool,
	  /**
	   * If `false`, changes to the index prop will not cause an animated transition.
	   */
	  animateTransitions: _propTypes2.default.bool,
	  /**
	   * The axis on which the slides will slide.
	   */
	  axis: _propTypes2.default.oneOf(['x', 'x-reverse', 'y', 'y-reverse']),
	  /**
	   * Use this property to provide your slides.
	   */
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * This is the inlined style that will be applied
	   * to each slide container.
	   */
	  containerStyle: _propTypes2.default.object,
	  /**
	   * If `true`, it will disable touch events.
	   * This is useful when you want to prohibit the user from changing slides.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * This is the config used to disable lazyloding,
	   * if `true` will render all the views in first rendering.
	   */
	  disableLazyLoading: _propTypes2.default.bool,
	  /**
	   * If `true`, it will enable mouse events.
	   * This will allow the user to perform the relevant swipe actions with a mouse.
	   */
	  enableMouseEvents: _propTypes2.default.bool,
	  /**
	   * Configure hysteresis between slides. This value determines how far
	   * should user swipe to switch slide.
	   */
	  hysteresis: _propTypes2.default.number,
	  /**
	   * If `true`, it will ignore native scroll container.
	   * It can be used to filter out false positive that blocks the swipe.
	   */
	  ignoreNativeScroll: _propTypes2.default.bool,
	  /**
	   * This is the index of the slide to show.
	   * This is useful when you want to change the default slide shown.
	   * Or when you have tabs linked to each slide.
	   */
	  index: _propTypes2.default.number,
	  /**
	   * This is callback prop. It's call by the
	   * component when the shown slide change after a swipe made by the user.
	   * This is useful when you have tabs linked to each slide.
	   *
	   * @param {integer} index This is the current index of the slide.
	   * @param {integer} indexLatest This is the oldest index of the slide.
	   * @param {object} meta Meta data containing more information about the event.
	   */
	  onChangeIndex: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onMouseDown: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onMouseLeave: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onMouseMove: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onMouseUp: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onScroll: _propTypes2.default.func,
	  /**
	   * This is callback prop. It's called by the
	   * component when the slide switching.
	   * This is useful when you want to implement something corresponding
	   * to the current slide position.
	   *
	   * @param {integer} index This is the current index of the slide.
	   * @param {string} type Can be either `move` or `end`.
	   */
	  onSwitching: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onTouchEnd: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onTouchMove: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * The callback that fires when the animation comes to a rest.
	   * This is useful to defer CPU intensive task.
	   */
	  onTransitionEnd: _propTypes2.default.func,
	  /**
	   * If `true`, it will add bounds effect on the edges.
	   */
	  resistance: _propTypes2.default.bool,
	  /**
	   * This is the className that will be applied
	   * on the slide component.
	   */
	  slideClassName: _propTypes2.default.string,
	  /**
	   * This is the inlined style that will be applied
	   * on the slide component.
	   */
	  slideStyle: _propTypes2.default.object,
	  /**
	   * This is the config used to create CSS transitions.
	   * This is useful to change the dynamic of the transition.
	   */
	  springConfig: _propTypes2.default.shape({
	    duration: _propTypes2.default.string,
	    easeFunction: _propTypes2.default.string,
	    delay: _propTypes2.default.string
	  }),
	  /**
	   * This is the inlined style that will be applied
	   * on the root component.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * This is the threshold used for detecting a quick swipe.
	   * If the computed speed is above this value, the index change.
	   */
	  threshold: _propTypes2.default.number
	} : {};
	
	SwipeableViews.defaultProps = {
	  animateHeight: false,
	  animateTransitions: true,
	  axis: 'x',
	  disabled: false,
	  disableLazyLoading: false,
	  enableMouseEvents: false,
	  hysteresis: 0.6,
	  ignoreNativeScroll: false,
	  index: 0,
	  threshold: 5,
	  springConfig: {
	    duration: '0.35s',
	    easeFunction: 'cubic-bezier(0.15, 0.3, 0.25, 1)',
	    delay: '0s'
	  },
	  resistance: false
	};
	
	SwipeableViews.childContextTypes = {
	  swipeableViews: _propTypes2.default.shape({
	    slideUpdateHeight: _propTypes2.default.func
	  })
	};
	
	exports.default = SwipeableViews;

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SwipeableViews = __webpack_require__(727);
	
	var _SwipeableViews2 = _interopRequireDefault(_SwipeableViews);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SwipeableViews2.default;

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _addClass = __webpack_require__(424);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(426);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _requestAnimationFrame = __webpack_require__(225);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _properties = __webpack_require__(224);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _PropTypes = __webpack_require__(316);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var events = [];
	if (_properties.transitionEnd) events.push(_properties.transitionEnd);
	if (_properties.animationEnd) events.push(_properties.animationEnd);
	
	function addEndListener(node, listener) {
	  if (events.length) {
	    events.forEach(function (e) {
	      return node.addEventListener(e, listener, false);
	    });
	  } else {
	    setTimeout(listener, 0);
	  }
	
	  return function () {
	    if (!events.length) return;
	    events.forEach(function (e) {
	      return node.removeEventListener(e, listener, false);
	    });
	  };
	}
	
	var propTypes = {
	  children: _propTypes2.default.node,
	  name: _PropTypes.nameShape.isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: _propTypes2.default.bool,
	  enter: _propTypes2.default.bool,
	  leave: _propTypes2.default.bool,
	  appearTimeout: _propTypes2.default.number,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};
	
	var CSSTransitionGroupChild = function (_React$Component) {
	  _inherits(CSSTransitionGroupChild, _React$Component);
	
	  function CSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounted = true;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
	    var node = (0, _reactDom.findDOMNode)(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timer = null;
	    var removeListeners = void 0;
	
	    (0, _addClass2.default)(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // Clean-up the animation after the specified delay
	    var finish = function finish(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timer);
	      if (removeListeners) removeListeners();
	
	      (0, _removeClass2.default)(node, className);
	      (0, _removeClass2.default)(node, activeClassName);
	
	      if (removeListeners) removeListeners();
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    if (timeout) {
	      timer = setTimeout(finish, timeout);
	      this.transitionTimeouts.push(timer);
	    } else if (_properties.transitionEnd) {
	      removeListeners = addEndListener(node, finish);
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
	    var _this2 = this;
	
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.rafHandle) {
	      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
	        return _this2.flushClassNameAndNodeQueue();
	      });
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
	    if (!this.unmounted) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        // This is for to force a repaint,
	        // which is necessary in order to transition styles when adding a class name.
	        /* eslint-disable no-unused-expressions */
	        obj.node.scrollTop;
	        /* eslint-enable no-unused-expressions */
	        (0, _addClass2.default)(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.rafHandle = null;
	  };
	
	  CSSTransitionGroupChild.prototype.render = function render() {
	    var props = _extends({}, this.props);
	    delete props.name;
	    delete props.appear;
	    delete props.enter;
	    delete props.leave;
	    delete props.appearTimeout;
	    delete props.enterTimeout;
	    delete props.leaveTimeout;
	    delete props.children;
	    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
	  };
	
	  return CSSTransitionGroupChild;
	}(_react2.default.Component);
	
	CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';
	
	
	CSSTransitionGroupChild.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransitionGroupChild;
	module.exports = exports['default'];

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	/**
	 * A collection of shims that provide minimal functionality of the ES6 collections.
	 *
	 * These implementations are not meant to be used outside of the ResizeObserver
	 * modules as they cover only a limited range of use cases.
	 */
	/* eslint-disable require-jsdoc, valid-jsdoc */
	var MapShim = (function () {
	    if (typeof Map !== 'undefined') {
	        return Map;
	    }
	
	    /**
	     * Returns index in provided array that matches the specified key.
	     *
	     * @param {Array<Array>} arr
	     * @param {*} key
	     * @returns {number}
	     */
	    function getIndex(arr, key) {
	        var result = -1;
	
	        arr.some(function (entry, index) {
	            if (entry[0] === key) {
	                result = index;
	
	                return true;
	            }
	
	            return false;
	        });
	
	        return result;
	    }
	
	    return (function () {
	        function anonymous() {
	            this.__entries__ = [];
	        }
	
	        var prototypeAccessors = { size: { configurable: true } };
	
	        /**
	         * @returns {boolean}
	         */
	        prototypeAccessors.size.get = function () {
	            return this.__entries__.length;
	        };
	
	        /**
	         * @param {*} key
	         * @returns {*}
	         */
	        anonymous.prototype.get = function (key) {
	            var index = getIndex(this.__entries__, key);
	            var entry = this.__entries__[index];
	
	            return entry && entry[1];
	        };
	
	        /**
	         * @param {*} key
	         * @param {*} value
	         * @returns {void}
	         */
	        anonymous.prototype.set = function (key, value) {
	            var index = getIndex(this.__entries__, key);
	
	            if (~index) {
	                this.__entries__[index][1] = value;
	            } else {
	                this.__entries__.push([key, value]);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.delete = function (key) {
	            var entries = this.__entries__;
	            var index = getIndex(entries, key);
	
	            if (~index) {
	                entries.splice(index, 1);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.has = function (key) {
	            return !!~getIndex(this.__entries__, key);
	        };
	
	        /**
	         * @returns {void}
	         */
	        anonymous.prototype.clear = function () {
	            this.__entries__.splice(0);
	        };
	
	        /**
	         * @param {Function} callback
	         * @param {*} [ctx=null]
	         * @returns {void}
	         */
	        anonymous.prototype.forEach = function (callback, ctx) {
	            var this$1 = this;
	            if ( ctx === void 0 ) ctx = null;
	
	            for (var i = 0, list = this$1.__entries__; i < list.length; i += 1) {
	                var entry = list[i];
	
	                callback.call(ctx, entry[1], entry[0]);
	            }
	        };
	
	        Object.defineProperties( anonymous.prototype, prototypeAccessors );
	
	        return anonymous;
	    }());
	})();
	
	/**
	 * Detects whether window and document objects are available in current environment.
	 */
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	// Returns global object of a current environment.
	var global$1 = (function () {
	    if (typeof global !== 'undefined' && global.Math === Math) {
	        return global;
	    }
	
	    if (typeof self !== 'undefined' && self.Math === Math) {
	        return self;
	    }
	
	    if (typeof window !== 'undefined' && window.Math === Math) {
	        return window;
	    }
	
	    // eslint-disable-next-line no-new-func
	    return Function('return this')();
	})();
	
	/**
	 * A shim for the requestAnimationFrame which falls back to the setTimeout if
	 * first one is not supported.
	 *
	 * @returns {number} Requests' identifier.
	 */
	var requestAnimationFrame$1 = (function () {
	    if (typeof requestAnimationFrame === 'function') {
	        // It's required to use a bounded function because IE sometimes throws
	        // an "Invalid calling object" error if rAF is invoked without the global
	        // object on the left hand side.
	        return requestAnimationFrame.bind(global$1);
	    }
	
	    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	})();
	
	// Defines minimum timeout before adding a trailing call.
	var trailingTimeout = 2;
	
	/**
	 * Creates a wrapper function which ensures that provided callback will be
	 * invoked only once during the specified delay period.
	 *
	 * @param {Function} callback - Function to be invoked after the delay period.
	 * @param {number} delay - Delay after which to invoke callback.
	 * @returns {Function}
	 */
	var throttle = function (callback, delay) {
	    var leadingCall = false,
	        trailingCall = false,
	        lastCallTime = 0;
	
	    /**
	     * Invokes the original callback function and schedules new invocation if
	     * the "proxy" was called during current request.
	     *
	     * @returns {void}
	     */
	    function resolvePending() {
	        if (leadingCall) {
	            leadingCall = false;
	
	            callback();
	        }
	
	        if (trailingCall) {
	            proxy();
	        }
	    }
	
	    /**
	     * Callback invoked after the specified delay. It will further postpone
	     * invocation of the original function delegating it to the
	     * requestAnimationFrame.
	     *
	     * @returns {void}
	     */
	    function timeoutCallback() {
	        requestAnimationFrame$1(resolvePending);
	    }
	
	    /**
	     * Schedules invocation of the original function.
	     *
	     * @returns {void}
	     */
	    function proxy() {
	        var timeStamp = Date.now();
	
	        if (leadingCall) {
	            // Reject immediately following calls.
	            if (timeStamp - lastCallTime < trailingTimeout) {
	                return;
	            }
	
	            // Schedule new call to be in invoked when the pending one is resolved.
	            // This is important for "transitions" which never actually start
	            // immediately so there is a chance that we might miss one if change
	            // happens amids the pending invocation.
	            trailingCall = true;
	        } else {
	            leadingCall = true;
	            trailingCall = false;
	
	            setTimeout(timeoutCallback, delay);
	        }
	
	        lastCallTime = timeStamp;
	    }
	
	    return proxy;
	};
	
	// Minimum delay before invoking the update of observers.
	var REFRESH_DELAY = 20;
	
	// A list of substrings of CSS properties used to find transition events that
	// might affect dimensions of observed elements.
	var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	
	// Check if MutationObserver is available.
	var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	
	/**
	 * Singleton controller class which handles updates of ResizeObserver instances.
	 */
	var ResizeObserverController = function() {
	    this.connected_ = false;
	    this.mutationEventsAdded_ = false;
	    this.mutationsObserver_ = null;
	    this.observers_ = [];
	
	    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	};
	
	/**
	 * Adds observer to observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be added.
	 * @returns {void}
	 */
	
	
	/**
	 * Holds reference to the controller's instance.
	 *
	 * @private {ResizeObserverController}
	 */
	
	
	/**
	 * Keeps reference to the instance of MutationObserver.
	 *
	 * @private {MutationObserver}
	 */
	
	/**
	 * Indicates whether DOM listeners have been added.
	 *
	 * @private {boolean}
	 */
	ResizeObserverController.prototype.addObserver = function (observer) {
	    if (!~this.observers_.indexOf(observer)) {
	        this.observers_.push(observer);
	    }
	
	    // Add listeners if they haven't been added yet.
	    if (!this.connected_) {
	        this.connect_();
	    }
	};
	
	/**
	 * Removes observer from observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be removed.
	 * @returns {void}
	 */
	ResizeObserverController.prototype.removeObserver = function (observer) {
	    var observers = this.observers_;
	    var index = observers.indexOf(observer);
	
	    // Remove observer if it's present in registry.
	    if (~index) {
	        observers.splice(index, 1);
	    }
	
	    // Remove listeners if controller has no connected observers.
	    if (!observers.length && this.connected_) {
	        this.disconnect_();
	    }
	};
	
	/**
	 * Invokes the update of observers. It will continue running updates insofar
	 * it detects changes.
	 *
	 * @returns {void}
	 */
	ResizeObserverController.prototype.refresh = function () {
	    var changesDetected = this.updateObservers_();
	
	    // Continue running updates if changes have been detected as there might
	    // be future ones caused by CSS transitions.
	    if (changesDetected) {
	        this.refresh();
	    }
	};
	
	/**
	 * Updates every observer from observers list and notifies them of queued
	 * entries.
	 *
	 * @private
	 * @returns {boolean} Returns "true" if any observer has detected changes in
	 *  dimensions of it's elements.
	 */
	ResizeObserverController.prototype.updateObservers_ = function () {
	    // Collect observers that have active observations.
	    var activeObservers = this.observers_.filter(function (observer) {
	        return observer.gatherActive(), observer.hasActive();
	    });
	
	    // Deliver notifications in a separate cycle in order to avoid any
	    // collisions between observers, e.g. when multiple instances of
	    // ResizeObserver are tracking the same element and the callback of one
	    // of them changes content dimensions of the observed target. Sometimes
	    // this may result in notifications being blocked for the rest of observers.
	    activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	
	    return activeObservers.length > 0;
	};
	
	/**
	 * Initializes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.connect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already added.
	    if (!isBrowser || this.connected_) {
	        return;
	    }
	
	    // Subscription to the "Transitionend" event is used as a workaround for
	    // delayed transitions. This way it's possible to capture at least the
	    // final state of an element.
	    document.addEventListener('transitionend', this.onTransitionEnd_);
	
	    window.addEventListener('resize', this.refresh);
	
	    if (mutationObserverSupported) {
	        this.mutationsObserver_ = new MutationObserver(this.refresh);
	
	        this.mutationsObserver_.observe(document, {
	            attributes: true,
	            childList: true,
	            characterData: true,
	            subtree: true
	        });
	    } else {
	        document.addEventListener('DOMSubtreeModified', this.refresh);
	
	        this.mutationEventsAdded_ = true;
	    }
	
	    this.connected_ = true;
	};
	
	/**
	 * Removes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.disconnect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already removed.
	    if (!isBrowser || !this.connected_) {
	        return;
	    }
	
	    document.removeEventListener('transitionend', this.onTransitionEnd_);
	    window.removeEventListener('resize', this.refresh);
	
	    if (this.mutationsObserver_) {
	        this.mutationsObserver_.disconnect();
	    }
	
	    if (this.mutationEventsAdded_) {
	        document.removeEventListener('DOMSubtreeModified', this.refresh);
	    }
	
	    this.mutationsObserver_ = null;
	    this.mutationEventsAdded_ = false;
	    this.connected_ = false;
	};
	
	/**
	 * "Transitionend" event handler.
	 *
	 * @private
	 * @param {TransitionEvent} event
	 * @returns {void}
	 */
	ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
	        var propertyName = ref.propertyName; if ( propertyName === void 0 ) propertyName = '';
	
	    // Detect whether transition may affect dimensions of an element.
	    var isReflowProperty = transitionKeys.some(function (key) {
	        return !!~propertyName.indexOf(key);
	    });
	
	    if (isReflowProperty) {
	        this.refresh();
	    }
	};
	
	/**
	 * Returns instance of the ResizeObserverController.
	 *
	 * @returns {ResizeObserverController}
	 */
	ResizeObserverController.getInstance = function () {
	    if (!this.instance_) {
	        this.instance_ = new ResizeObserverController();
	    }
	
	    return this.instance_;
	};
	
	ResizeObserverController.instance_ = null;
	
	/**
	 * Defines non-writable/enumerable properties of the provided target object.
	 *
	 * @param {Object} target - Object for which to define properties.
	 * @param {Object} props - Properties to be defined.
	 * @returns {Object} Target object.
	 */
	var defineConfigurable = (function (target, props) {
	    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
	        var key = list[i];
	
	        Object.defineProperty(target, key, {
	            value: props[key],
	            enumerable: false,
	            writable: false,
	            configurable: true
	        });
	    }
	
	    return target;
	});
	
	/**
	 * Returns the global object associated with provided element.
	 *
	 * @param {Object} target
	 * @returns {Object}
	 */
	var getWindowOf = (function (target) {
	    // Assume that the element is an instance of Node, which means that it
	    // has the "ownerDocument" property from which we can retrieve a
	    // corresponding global object.
	    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	
	    // Return the local global object if it's not possible extract one from
	    // provided element.
	    return ownerGlobal || global$1;
	});
	
	// Placeholder of an empty content rectangle.
	var emptyRect = createRectInit(0, 0, 0, 0);
	
	/**
	 * Converts provided string to a number.
	 *
	 * @param {number|string} value
	 * @returns {number}
	 */
	function toFloat(value) {
	    return parseFloat(value) || 0;
	}
	
	/**
	 * Extracts borders size from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @param {...string} positions - Borders positions (top, right, ...)
	 * @returns {number}
	 */
	function getBordersSize(styles) {
	    var positions = [], len = arguments.length - 1;
	    while ( len-- > 0 ) positions[ len ] = arguments[ len + 1 ];
	
	    return positions.reduce(function (size, position) {
	        var value = styles['border-' + position + '-width'];
	
	        return size + toFloat(value);
	    }, 0);
	}
	
	/**
	 * Extracts paddings sizes from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @returns {Object} Paddings box.
	 */
	function getPaddings(styles) {
	    var positions = ['top', 'right', 'bottom', 'left'];
	    var paddings = {};
	
	    for (var i = 0, list = positions; i < list.length; i += 1) {
	        var position = list[i];
	
	        var value = styles['padding-' + position];
	
	        paddings[position] = toFloat(value);
	    }
	
	    return paddings;
	}
	
	/**
	 * Calculates content rectangle of provided SVG element.
	 *
	 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	 *      to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getSVGContentRect(target) {
	    var bbox = target.getBBox();
	
	    return createRectInit(0, 0, bbox.width, bbox.height);
	}
	
	/**
	 * Calculates content rectangle of provided HTMLElement.
	 *
	 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	 * @returns {DOMRectInit}
	 */
	function getHTMLElementContentRect(target) {
	    // Client width & height properties can't be
	    // used exclusively as they provide rounded values.
	    var clientWidth = target.clientWidth;
	    var clientHeight = target.clientHeight;
	
	    // By this condition we can catch all non-replaced inline, hidden and
	    // detached elements. Though elements with width & height properties less
	    // than 0.5 will be discarded as well.
	    //
	    // Without it we would need to implement separate methods for each of
	    // those cases and it's not possible to perform a precise and performance
	    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	    // gives wrong results for elements with width & height less than 0.5.
	    if (!clientWidth && !clientHeight) {
	        return emptyRect;
	    }
	
	    var styles = getWindowOf(target).getComputedStyle(target);
	    var paddings = getPaddings(styles);
	    var horizPad = paddings.left + paddings.right;
	    var vertPad = paddings.top + paddings.bottom;
	
	    // Computed styles of width & height are being used because they are the
	    // only dimensions available to JS that contain non-rounded values. It could
	    // be possible to utilize the getBoundingClientRect if only it's data wasn't
	    // affected by CSS transformations let alone paddings, borders and scroll bars.
	    var width = toFloat(styles.width),
	        height = toFloat(styles.height);
	
	    // Width & height include paddings and borders when the 'border-box' box
	    // model is applied (except for IE).
	    if (styles.boxSizing === 'border-box') {
	        // Following conditions are required to handle Internet Explorer which
	        // doesn't include paddings and borders to computed CSS dimensions.
	        //
	        // We can say that if CSS dimensions + paddings are equal to the "client"
	        // properties then it's either IE, and thus we don't need to subtract
	        // anything, or an element merely doesn't have paddings/borders styles.
	        if (Math.round(width + horizPad) !== clientWidth) {
	            width -= getBordersSize(styles, 'left', 'right') + horizPad;
	        }
	
	        if (Math.round(height + vertPad) !== clientHeight) {
	            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	        }
	    }
	
	    // Following steps can't be applied to the document's root element as its
	    // client[Width/Height] properties represent viewport area of the window.
	    // Besides, it's as well not necessary as the <html> itself neither has
	    // rendered scroll bars nor it can be clipped.
	    if (!isDocumentElement(target)) {
	        // In some browsers (only in Firefox, actually) CSS width & height
	        // include scroll bars size which can be removed at this step as scroll
	        // bars are the only difference between rounded dimensions + paddings
	        // and "client" properties, though that is not always true in Chrome.
	        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	
	        // Chrome has a rather weird rounding of "client" properties.
	        // E.g. for an element with content width of 314.2px it sometimes gives
	        // the client width of 315px and for the width of 314.7px it may give
	        // 314px. And it doesn't happen all the time. So just ignore this delta
	        // as a non-relevant.
	        if (Math.abs(vertScrollbar) !== 1) {
	            width -= vertScrollbar;
	        }
	
	        if (Math.abs(horizScrollbar) !== 1) {
	            height -= horizScrollbar;
	        }
	    }
	
	    return createRectInit(paddings.left, paddings.top, width, height);
	}
	
	/**
	 * Checks whether provided element is an instance of the SVGGraphicsElement.
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	var isSVGGraphicsElement = (function () {
	    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	    // interface.
	    if (typeof SVGGraphicsElement !== 'undefined') {
	        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	    }
	
	    // If it's so, then check that element is at least an instance of the
	    // SVGElement and that it has the "getBBox" method.
	    // eslint-disable-next-line no-extra-parens
	    return function (target) { return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function'; };
	})();
	
	/**
	 * Checks whether provided element is a document element (<html>).
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	function isDocumentElement(target) {
	    return target === getWindowOf(target).document.documentElement;
	}
	
	/**
	 * Calculates an appropriate content rectangle for provided html or svg element.
	 *
	 * @param {Element} target - Element content rectangle of which needs to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getContentRect(target) {
	    if (!isBrowser) {
	        return emptyRect;
	    }
	
	    if (isSVGGraphicsElement(target)) {
	        return getSVGContentRect(target);
	    }
	
	    return getHTMLElementContentRect(target);
	}
	
	/**
	 * Creates rectangle with an interface of the DOMRectReadOnly.
	 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	 *
	 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	 * @returns {DOMRectReadOnly}
	 */
	function createReadOnlyRect(ref) {
	    var x = ref.x;
	    var y = ref.y;
	    var width = ref.width;
	    var height = ref.height;
	
	    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	    var rect = Object.create(Constr.prototype);
	
	    // Rectangle's properties are not writable and non-enumerable.
	    defineConfigurable(rect, {
	        x: x, y: y, width: width, height: height,
	        top: y,
	        right: x + width,
	        bottom: height + y,
	        left: x
	    });
	
	    return rect;
	}
	
	/**
	 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	 *
	 * @param {number} x - X coordinate.
	 * @param {number} y - Y coordinate.
	 * @param {number} width - Rectangle's width.
	 * @param {number} height - Rectangle's height.
	 * @returns {DOMRectInit}
	 */
	function createRectInit(x, y, width, height) {
	    return { x: x, y: y, width: width, height: height };
	}
	
	/**
	 * Class that is responsible for computations of the content rectangle of
	 * provided DOM element and for keeping track of it's changes.
	 */
	var ResizeObservation = function(target) {
	    this.broadcastWidth = 0;
	    this.broadcastHeight = 0;
	    this.contentRect_ = createRectInit(0, 0, 0, 0);
	
	    this.target = target;
	};
	
	/**
	 * Updates content rectangle and tells whether it's width or height properties
	 * have changed since the last broadcast.
	 *
	 * @returns {boolean}
	 */
	
	
	/**
	 * Reference to the last observed content rectangle.
	 *
	 * @private {DOMRectInit}
	 */
	
	
	/**
	 * Broadcasted width of content rectangle.
	 *
	 * @type {number}
	 */
	ResizeObservation.prototype.isActive = function () {
	    var rect = getContentRect(this.target);
	
	    this.contentRect_ = rect;
	
	    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
	};
	
	/**
	 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	 * from the corresponding properties of the last observed content rectangle.
	 *
	 * @returns {DOMRectInit} Last observed content rectangle.
	 */
	ResizeObservation.prototype.broadcastRect = function () {
	    var rect = this.contentRect_;
	
	    this.broadcastWidth = rect.width;
	    this.broadcastHeight = rect.height;
	
	    return rect;
	};
	
	var ResizeObserverEntry = function(target, rectInit) {
	    var contentRect = createReadOnlyRect(rectInit);
	
	    // According to the specification following properties are not writable
	    // and are also not enumerable in the native implementation.
	    //
	    // Property accessors are not being used as they'd require to define a
	    // private WeakMap storage which may cause memory leaks in browsers that
	    // don't support this type of collections.
	    defineConfigurable(this, { target: target, contentRect: contentRect });
	};
	
	var ResizeObserverSPI = function(callback, controller, callbackCtx) {
	    this.activeObservations_ = [];
	    this.observations_ = new MapShim();
	
	    if (typeof callback !== 'function') {
	        throw new TypeError('The callback provided as parameter 1 is not a function.');
	    }
	
	    this.callback_ = callback;
	    this.controller_ = controller;
	    this.callbackCtx_ = callbackCtx;
	};
	
	/**
	 * Starts observing provided element.
	 *
	 * @param {Element} target - Element to be observed.
	 * @returns {void}
	 */
	
	
	/**
	 * Registry of the ResizeObservation instances.
	 *
	 * @private {Map<Element, ResizeObservation>}
	 */
	
	
	/**
	 * Public ResizeObserver instance which will be passed to the callback
	 * function and used as a value of it's "this" binding.
	 *
	 * @private {ResizeObserver}
	 */
	
	/**
	 * Collection of resize observations that have detected changes in dimensions
	 * of elements.
	 *
	 * @private {Array<ResizeObservation>}
	 */
	ResizeObserverSPI.prototype.observe = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof getWindowOf(target).Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is already being observed.
	    if (observations.has(target)) {
	        return;
	    }
	
	    observations.set(target, new ResizeObservation(target));
	
	    this.controller_.addObserver(this);
	
	    // Force the update of observations.
	    this.controller_.refresh();
	};
	
	/**
	 * Stops observing provided element.
	 *
	 * @param {Element} target - Element to stop observing.
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.unobserve = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof getWindowOf(target).Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is not being observed.
	    if (!observations.has(target)) {
	        return;
	    }
	
	    observations.delete(target);
	
	    if (!observations.size) {
	        this.controller_.removeObserver(this);
	    }
	};
	
	/**
	 * Stops observing all elements.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.disconnect = function () {
	    this.clearActive();
	    this.observations_.clear();
	    this.controller_.removeObserver(this);
	};
	
	/**
	 * Collects observation instances the associated element of which has changed
	 * it's content rectangle.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.gatherActive = function () {
	        var this$1 = this;
	
	    this.clearActive();
	
	    this.observations_.forEach(function (observation) {
	        if (observation.isActive()) {
	            this$1.activeObservations_.push(observation);
	        }
	    });
	};
	
	/**
	 * Invokes initial callback function with a list of ResizeObserverEntry
	 * instances collected from active resize observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.broadcastActive = function () {
	    // Do nothing if observer doesn't have active observations.
	    if (!this.hasActive()) {
	        return;
	    }
	
	    var ctx = this.callbackCtx_;
	
	    // Create ResizeObserverEntry instance for every active observation.
	    var entries = this.activeObservations_.map(function (observation) {
	        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	    });
	
	    this.callback_.call(ctx, entries, ctx);
	    this.clearActive();
	};
	
	/**
	 * Clears the collection of active observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.clearActive = function () {
	    this.activeObservations_.splice(0);
	};
	
	/**
	 * Tells whether observer has active observations.
	 *
	 * @returns {boolean}
	 */
	ResizeObserverSPI.prototype.hasActive = function () {
	    return this.activeObservations_.length > 0;
	};
	
	// Registry of internal observers. If WeakMap is not available use current shim
	// for the Map collection as it has all required methods and because WeakMap
	// can't be fully polyfilled anyway.
	var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	
	/**
	 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	 * exposing only those methods and properties that are defined in the spec.
	 */
	var ResizeObserver = function(callback) {
	    if (!(this instanceof ResizeObserver)) {
	        throw new TypeError('Cannot call a class as a function.');
	    }
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    var controller = ResizeObserverController.getInstance();
	    var observer = new ResizeObserverSPI(callback, controller, this);
	
	    observers.set(this, observer);
	};
	
	// Expose public methods of ResizeObserver.
	['observe', 'unobserve', 'disconnect'].forEach(function (method) {
	    ResizeObserver.prototype[method] = function () {
	        return (ref = observers.get(this))[method].apply(ref, arguments);
	        var ref;
	    };
	});
	
	var index = (function () {
	    // Export existing implementation if available.
	    if (typeof global$1.ResizeObserver !== 'undefined') {
	        return global$1.ResizeObserver;
	    }
	
	    return ResizeObserver;
	})();
	
	return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 744 */,
/* 745 */,
/* 746 */
/***/ (function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/first-bus-connect.f62e21d6.png";

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/first-view-district.9eee29fe.png";

/***/ }),
/* 749 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/scanther.c7c18268.png";

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/smart-home.8382aade.png";

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toDate = __webpack_require__(193);
	
	var _toDate2 = _interopRequireDefault(_toDate);
	
	var _toFloat = __webpack_require__(331);
	
	var _toFloat2 = _interopRequireDefault(_toFloat);
	
	var _toInt = __webpack_require__(803);
	
	var _toInt2 = _interopRequireDefault(_toInt);
	
	var _toBoolean = __webpack_require__(802);
	
	var _toBoolean2 = _interopRequireDefault(_toBoolean);
	
	var _equals = __webpack_require__(754);
	
	var _equals2 = _interopRequireDefault(_equals);
	
	var _contains = __webpack_require__(753);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _matches = __webpack_require__(799);
	
	var _matches2 = _interopRequireDefault(_matches);
	
	var _isEmail = __webpack_require__(768);
	
	var _isEmail2 = _interopRequireDefault(_isEmail);
	
	var _isURL = __webpack_require__(794);
	
	var _isURL2 = _interopRequireDefault(_isURL);
	
	var _isMACAddress = __webpack_require__(784);
	
	var _isMACAddress2 = _interopRequireDefault(_isMACAddress);
	
	var _isIP = __webpack_require__(327);
	
	var _isIP2 = _interopRequireDefault(_isIP);
	
	var _isFQDN = __webpack_require__(192);
	
	var _isFQDN2 = _interopRequireDefault(_isFQDN);
	
	var _isBoolean = __webpack_require__(762);
	
	var _isBoolean2 = _interopRequireDefault(_isBoolean);
	
	var _isAlpha = __webpack_require__(757);
	
	var _isAlpha2 = _interopRequireDefault(_isAlpha);
	
	var _isAlphanumeric = __webpack_require__(758);
	
	var _isAlphanumeric2 = _interopRequireDefault(_isAlphanumeric);
	
	var _isNumeric = __webpack_require__(790);
	
	var _isNumeric2 = _interopRequireDefault(_isNumeric);
	
	var _isPort = __webpack_require__(791);
	
	var _isPort2 = _interopRequireDefault(_isPort);
	
	var _isLowercase = __webpack_require__(783);
	
	var _isLowercase2 = _interopRequireDefault(_isLowercase);
	
	var _isUppercase = __webpack_require__(796);
	
	var _isUppercase2 = _interopRequireDefault(_isUppercase);
	
	var _isAscii = __webpack_require__(759);
	
	var _isAscii2 = _interopRequireDefault(_isAscii);
	
	var _isFullWidth = __webpack_require__(324);
	
	var _isFullWidth2 = _interopRequireDefault(_isFullWidth);
	
	var _isHalfWidth = __webpack_require__(325);
	
	var _isHalfWidth2 = _interopRequireDefault(_isHalfWidth);
	
	var _isVariableWidth = __webpack_require__(797);
	
	var _isVariableWidth2 = _interopRequireDefault(_isVariableWidth);
	
	var _isMultibyte = __webpack_require__(789);
	
	var _isMultibyte2 = _interopRequireDefault(_isMultibyte);
	
	var _isSurrogatePair = __webpack_require__(793);
	
	var _isSurrogatePair2 = _interopRequireDefault(_isSurrogatePair);
	
	var _isInt = __webpack_require__(328);
	
	var _isInt2 = _interopRequireDefault(_isInt);
	
	var _isFloat = __webpack_require__(770);
	
	var _isFloat2 = _interopRequireDefault(_isFloat);
	
	var _isDecimal = __webpack_require__(766);
	
	var _isDecimal2 = _interopRequireDefault(_isDecimal);
	
	var _isHexadecimal = __webpack_require__(326);
	
	var _isHexadecimal2 = _interopRequireDefault(_isHexadecimal);
	
	var _isDivisibleBy = __webpack_require__(767);
	
	var _isDivisibleBy2 = _interopRequireDefault(_isDivisibleBy);
	
	var _isHexColor = __webpack_require__(772);
	
	var _isHexColor2 = _interopRequireDefault(_isHexColor);
	
	var _isISRC = __webpack_require__(777);
	
	var _isISRC2 = _interopRequireDefault(_isISRC);
	
	var _isMD = __webpack_require__(785);
	
	var _isMD2 = _interopRequireDefault(_isMD);
	
	var _isHash = __webpack_require__(771);
	
	var _isHash2 = _interopRequireDefault(_isHash);
	
	var _isJSON = __webpack_require__(780);
	
	var _isJSON2 = _interopRequireDefault(_isJSON);
	
	var _isEmpty = __webpack_require__(769);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _isLength = __webpack_require__(782);
	
	var _isLength2 = _interopRequireDefault(_isLength);
	
	var _isByteLength = __webpack_require__(323);
	
	var _isByteLength2 = _interopRequireDefault(_isByteLength);
	
	var _isUUID = __webpack_require__(795);
	
	var _isUUID2 = _interopRequireDefault(_isUUID);
	
	var _isMongoId = __webpack_require__(788);
	
	var _isMongoId2 = _interopRequireDefault(_isMongoId);
	
	var _isAfter = __webpack_require__(756);
	
	var _isAfter2 = _interopRequireDefault(_isAfter);
	
	var _isBefore = __webpack_require__(761);
	
	var _isBefore2 = _interopRequireDefault(_isBefore);
	
	var _isIn = __webpack_require__(779);
	
	var _isIn2 = _interopRequireDefault(_isIn);
	
	var _isCreditCard = __webpack_require__(763);
	
	var _isCreditCard2 = _interopRequireDefault(_isCreditCard);
	
	var _isISIN = __webpack_require__(774);
	
	var _isISIN2 = _interopRequireDefault(_isISIN);
	
	var _isISBN = __webpack_require__(773);
	
	var _isISBN2 = _interopRequireDefault(_isISBN);
	
	var _isISSN = __webpack_require__(778);
	
	var _isISSN2 = _interopRequireDefault(_isISSN);
	
	var _isMobilePhone = __webpack_require__(787);
	
	var _isMobilePhone2 = _interopRequireDefault(_isMobilePhone);
	
	var _isCurrency = __webpack_require__(764);
	
	var _isCurrency2 = _interopRequireDefault(_isCurrency);
	
	var _isISO = __webpack_require__(776);
	
	var _isISO2 = _interopRequireDefault(_isISO);
	
	var _isISO31661Alpha = __webpack_require__(775);
	
	var _isISO31661Alpha2 = _interopRequireDefault(_isISO31661Alpha);
	
	var _isBase = __webpack_require__(760);
	
	var _isBase2 = _interopRequireDefault(_isBase);
	
	var _isDataURI = __webpack_require__(765);
	
	var _isDataURI2 = _interopRequireDefault(_isDataURI);
	
	var _isMimeType = __webpack_require__(786);
	
	var _isMimeType2 = _interopRequireDefault(_isMimeType);
	
	var _isLatLong = __webpack_require__(781);
	
	var _isLatLong2 = _interopRequireDefault(_isLatLong);
	
	var _isPostalCode = __webpack_require__(792);
	
	var _isPostalCode2 = _interopRequireDefault(_isPostalCode);
	
	var _ltrim = __webpack_require__(329);
	
	var _ltrim2 = _interopRequireDefault(_ltrim);
	
	var _rtrim = __webpack_require__(330);
	
	var _rtrim2 = _interopRequireDefault(_rtrim);
	
	var _trim = __webpack_require__(804);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	var _escape = __webpack_require__(755);
	
	var _escape2 = _interopRequireDefault(_escape);
	
	var _unescape = __webpack_require__(805);
	
	var _unescape2 = _interopRequireDefault(_unescape);
	
	var _stripLow = __webpack_require__(801);
	
	var _stripLow2 = _interopRequireDefault(_stripLow);
	
	var _whitelist = __webpack_require__(806);
	
	var _whitelist2 = _interopRequireDefault(_whitelist);
	
	var _blacklist = __webpack_require__(322);
	
	var _blacklist2 = _interopRequireDefault(_blacklist);
	
	var _isWhitelisted = __webpack_require__(798);
	
	var _isWhitelisted2 = _interopRequireDefault(_isWhitelisted);
	
	var _normalizeEmail = __webpack_require__(800);
	
	var _normalizeEmail2 = _interopRequireDefault(_normalizeEmail);
	
	var _toString = __webpack_require__(194);
	
	var _toString2 = _interopRequireDefault(_toString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var version = '9.2.0';
	
	var validator = {
	  version: version,
	  toDate: _toDate2.default,
	  toFloat: _toFloat2.default,
	  toInt: _toInt2.default,
	  toBoolean: _toBoolean2.default,
	  equals: _equals2.default,
	  contains: _contains2.default,
	  matches: _matches2.default,
	  isEmail: _isEmail2.default,
	  isURL: _isURL2.default,
	  isMACAddress: _isMACAddress2.default,
	  isIP: _isIP2.default,
	  isFQDN: _isFQDN2.default,
	  isBoolean: _isBoolean2.default,
	  isAlpha: _isAlpha2.default,
	  isAlphanumeric: _isAlphanumeric2.default,
	  isNumeric: _isNumeric2.default,
	  isPort: _isPort2.default,
	  isLowercase: _isLowercase2.default,
	  isUppercase: _isUppercase2.default,
	  isAscii: _isAscii2.default,
	  isFullWidth: _isFullWidth2.default,
	  isHalfWidth: _isHalfWidth2.default,
	  isVariableWidth: _isVariableWidth2.default,
	  isMultibyte: _isMultibyte2.default,
	  isSurrogatePair: _isSurrogatePair2.default,
	  isInt: _isInt2.default,
	  isFloat: _isFloat2.default,
	  isDecimal: _isDecimal2.default,
	  isHexadecimal: _isHexadecimal2.default,
	  isDivisibleBy: _isDivisibleBy2.default,
	  isHexColor: _isHexColor2.default,
	  isISRC: _isISRC2.default,
	  isMD5: _isMD2.default,
	  isHash: _isHash2.default,
	  isJSON: _isJSON2.default,
	  isEmpty: _isEmpty2.default,
	  isLength: _isLength2.default,
	  isByteLength: _isByteLength2.default,
	  isUUID: _isUUID2.default,
	  isMongoId: _isMongoId2.default,
	  isAfter: _isAfter2.default,
	  isBefore: _isBefore2.default,
	  isIn: _isIn2.default,
	  isCreditCard: _isCreditCard2.default,
	  isISIN: _isISIN2.default,
	  isISBN: _isISBN2.default,
	  isISSN: _isISSN2.default,
	  isMobilePhone: _isMobilePhone2.default,
	  isPostalCode: _isPostalCode2.default,
	  isCurrency: _isCurrency2.default,
	  isISO8601: _isISO2.default,
	  isISO31661Alpha2: _isISO31661Alpha2.default,
	  isBase64: _isBase2.default,
	  isDataURI: _isDataURI2.default,
	  isMimeType: _isMimeType2.default,
	  isLatLong: _isLatLong2.default,
	  ltrim: _ltrim2.default,
	  rtrim: _rtrim2.default,
	  trim: _trim2.default,
	  escape: _escape2.default,
	  unescape: _unescape2.default,
	  stripLow: _stripLow2.default,
	  whitelist: _whitelist2.default,
	  blacklist: _blacklist2.default,
	  isWhitelisted: _isWhitelisted2.default,
	  normalizeEmail: _normalizeEmail2.default,
	  toString: _toString2.default
	};
	
	exports.default = validator;
	module.exports = exports['default'];

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = contains;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _toString = __webpack_require__(194);
	
	var _toString2 = _interopRequireDefault(_toString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function contains(str, elem) {
	  (0, _assertString2.default)(str);
	  return str.indexOf((0, _toString2.default)(elem)) >= 0;
	}
	module.exports = exports['default'];

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = equals;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function equals(str, comparison) {
	  (0, _assertString2.default)(str);
	  return str === comparison;
	}
	module.exports = exports['default'];

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = escape;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escape(str) {
	  (0, _assertString2.default)(str);
	  return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\//g, '&#x2F;').replace(/\\/g, '&#x5C;').replace(/`/g, '&#96;');
	}
	module.exports = exports['default'];

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAfter;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _toDate = __webpack_require__(193);
	
	var _toDate2 = _interopRequireDefault(_toDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAfter(str) {
	  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
	
	  (0, _assertString2.default)(str);
	  var comparison = (0, _toDate2.default)(date);
	  var original = (0, _toDate2.default)(str);
	  return !!(original && comparison && original > comparison);
	}
	module.exports = exports['default'];

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAlpha;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _alpha = __webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAlpha(str) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
	
	  (0, _assertString2.default)(str);
	  if (locale in _alpha.alpha) {
	    return _alpha.alpha[locale].test(str);
	  }
	  throw new Error('Invalid locale \'' + locale + '\'');
	}
	module.exports = exports['default'];

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAlphanumeric;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _alpha = __webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAlphanumeric(str) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
	
	  (0, _assertString2.default)(str);
	  if (locale in _alpha.alphanumeric) {
	    return _alpha.alphanumeric[locale].test(str);
	  }
	  throw new Error('Invalid locale \'' + locale + '\'');
	}
	module.exports = exports['default'];

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAscii;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-control-regex */
	var ascii = /^[\x00-\x7F]+$/;
	/* eslint-enable no-control-regex */
	
	function isAscii(str) {
	  (0, _assertString2.default)(str);
	  return ascii.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBase64;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var notBase64 = /[^A-Z0-9+\/=]/i;
	
	function isBase64(str) {
	  (0, _assertString2.default)(str);
	  var len = str.length;
	  if (!len || len % 4 !== 0 || notBase64.test(str)) {
	    return false;
	  }
	  var firstPaddingChar = str.indexOf('=');
	  return firstPaddingChar === -1 || firstPaddingChar === len - 1 || firstPaddingChar === len - 2 && str[len - 1] === '=';
	}
	module.exports = exports['default'];

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBefore;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _toDate = __webpack_require__(193);
	
	var _toDate2 = _interopRequireDefault(_toDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBefore(str) {
	  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
	
	  (0, _assertString2.default)(str);
	  var comparison = (0, _toDate2.default)(date);
	  var original = (0, _toDate2.default)(str);
	  return !!(original && comparison && original < comparison);
	}
	module.exports = exports['default'];

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBoolean;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBoolean(str) {
	  (0, _assertString2.default)(str);
	  return ['true', 'false', '1', '0'].indexOf(str) >= 0;
	}
	module.exports = exports['default'];

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isCreditCard;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|62[0-9]{14})$/;
	/* eslint-enable max-len */
	
	function isCreditCard(str) {
	  (0, _assertString2.default)(str);
	  var sanitized = str.replace(/[- ]+/g, '');
	  if (!creditCard.test(sanitized)) {
	    return false;
	  }
	  var sum = 0;
	  var digit = void 0;
	  var tmpNum = void 0;
	  var shouldDouble = void 0;
	  for (var i = sanitized.length - 1; i >= 0; i--) {
	    digit = sanitized.substring(i, i + 1);
	    tmpNum = parseInt(digit, 10);
	    if (shouldDouble) {
	      tmpNum *= 2;
	      if (tmpNum >= 10) {
	        sum += tmpNum % 10 + 1;
	      } else {
	        sum += tmpNum;
	      }
	    } else {
	      sum += tmpNum;
	    }
	    shouldDouble = !shouldDouble;
	  }
	  return !!(sum % 10 === 0 ? sanitized : false);
	}
	module.exports = exports['default'];

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isCurrency;
	
	var _merge = __webpack_require__(68);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function currencyRegex(options) {
	  var decimal_digits = '\\d{' + options.digits_after_decimal[0] + '}';
	  options.digits_after_decimal.forEach(function (digit, index) {
	    if (index !== 0) decimal_digits = decimal_digits + '|\\d{' + digit + '}';
	  });
	  var symbol = '(\\' + options.symbol.replace(/\./g, '\\.') + ')' + (options.require_symbol ? '' : '?'),
	      negative = '-?',
	      whole_dollar_amount_without_sep = '[1-9]\\d*',
	      whole_dollar_amount_with_sep = '[1-9]\\d{0,2}(\\' + options.thousands_separator + '\\d{3})*',
	      valid_whole_dollar_amounts = ['0', whole_dollar_amount_without_sep, whole_dollar_amount_with_sep],
	      whole_dollar_amount = '(' + valid_whole_dollar_amounts.join('|') + ')?',
	      decimal_amount = '(\\' + options.decimal_separator + '(' + decimal_digits + '))' + (options.require_decimal ? '' : '?');
	  var pattern = whole_dollar_amount + (options.allow_decimal || options.require_decimal ? decimal_amount : '');
	
	  // default is negative sign before symbol, but there are two other options (besides parens)
	  if (options.allow_negatives && !options.parens_for_negatives) {
	    if (options.negative_sign_after_digits) {
	      pattern += negative;
	    } else if (options.negative_sign_before_digits) {
	      pattern = negative + pattern;
	    }
	  }
	
	  // South African Rand, for example, uses R 123 (space) and R-123 (no space)
	  if (options.allow_negative_sign_placeholder) {
	    pattern = '( (?!\\-))?' + pattern;
	  } else if (options.allow_space_after_symbol) {
	    pattern = ' ?' + pattern;
	  } else if (options.allow_space_after_digits) {
	    pattern += '( (?!$))?';
	  }
	
	  if (options.symbol_after_digits) {
	    pattern += symbol;
	  } else {
	    pattern = symbol + pattern;
	  }
	
	  if (options.allow_negatives) {
	    if (options.parens_for_negatives) {
	      pattern = '(\\(' + pattern + '\\)|' + pattern + ')';
	    } else if (!(options.negative_sign_before_digits || options.negative_sign_after_digits)) {
	      pattern = negative + pattern;
	    }
	  }
	
	  // ensure there's a dollar and/or decimal amount, and that
	  // it doesn't start with a space or a negative sign followed by a space
	  return new RegExp('^(?!-? )(?=.*\\d)' + pattern + '$');
	}
	
	var default_currency_options = {
	  symbol: '$',
	  require_symbol: false,
	  allow_space_after_symbol: false,
	  symbol_after_digits: false,
	  allow_negatives: true,
	  parens_for_negatives: false,
	  negative_sign_before_digits: false,
	  negative_sign_after_digits: false,
	  allow_negative_sign_placeholder: false,
	  thousands_separator: ',',
	  decimal_separator: '.',
	  allow_decimal: true,
	  require_decimal: false,
	  digits_after_decimal: [2],
	  allow_space_after_digits: false
	};
	
	function isCurrency(str, options) {
	  (0, _assertString2.default)(str);
	  options = (0, _merge2.default)(options, default_currency_options);
	  return currencyRegex(options).test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDataURI;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dataURI = /^\s*data:([a-z]+\/[a-z0-9\-\+]+(;[a-z\-]+=[a-z0-9\-]+)?)?(;base64)?,[a-z0-9!\$&',\(\)\*\+,;=\-\._~:@\/\?%\s]*\s*$/i; // eslint-disable-line max-len
	
	function isDataURI(str) {
	  (0, _assertString2.default)(str);
	  return dataURI.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDecimal;
	
	var _merge = __webpack_require__(68);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _alpha = __webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function decimalRegExp(options) {
	  var regExp = new RegExp('^[-+]?([0-9]+)?(\\' + _alpha.decimal[options.locale] + '[0-9]{' + options.decimal_digits + '})' + (options.force_decimal ? '' : '?') + '$');
	  return regExp;
	}
	
	var default_decimal_options = {
	  force_decimal: false,
	  decimal_digits: '1,',
	  locale: 'en-US'
	};
	
	var blacklist = ['', '-', '+'];
	
	function isDecimal(str, options) {
	  (0, _assertString2.default)(str);
	  options = (0, _merge2.default)(options, default_decimal_options);
	  if (options.locale in _alpha.decimal) {
	    return !blacklist.includes(str.replace(/ /g, '')) && decimalRegExp(options).test(str);
	  }
	  throw new Error('Invalid locale \'' + options.locale + '\'');
	}
	module.exports = exports['default'];

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDivisibleBy;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _toFloat = __webpack_require__(331);
	
	var _toFloat2 = _interopRequireDefault(_toFloat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isDivisibleBy(str, num) {
	  (0, _assertString2.default)(str);
	  return (0, _toFloat2.default)(str) % parseInt(num, 10) === 0;
	}
	module.exports = exports['default'];

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmail;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _merge = __webpack_require__(68);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _isByteLength = __webpack_require__(323);
	
	var _isByteLength2 = _interopRequireDefault(_isByteLength);
	
	var _isFQDN = __webpack_require__(192);
	
	var _isFQDN2 = _interopRequireDefault(_isFQDN);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_email_options = {
	  allow_display_name: false,
	  require_display_name: false,
	  allow_utf8_local_part: true,
	  require_tld: true
	};
	
	/* eslint-disable max-len */
	/* eslint-disable no-control-regex */
	var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\,\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
	var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
	var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
	var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
	var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
	/* eslint-enable max-len */
	/* eslint-enable no-control-regex */
	
	function isEmail(str, options) {
	  (0, _assertString2.default)(str);
	  options = (0, _merge2.default)(options, default_email_options);
	
	  if (options.require_display_name || options.allow_display_name) {
	    var display_email = str.match(displayName);
	    if (display_email) {
	      str = display_email[1];
	    } else if (options.require_display_name) {
	      return false;
	    }
	  }
	
	  var parts = str.split('@');
	  var domain = parts.pop();
	  var user = parts.join('@');
	
	  var lower_domain = domain.toLowerCase();
	  if (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com') {
	    user = user.replace(/\./g, '').toLowerCase();
	  }
	
	  if (!(0, _isByteLength2.default)(user, { max: 64 }) || !(0, _isByteLength2.default)(domain, { max: 254 })) {
	    return false;
	  }
	
	  if (!(0, _isFQDN2.default)(domain, { require_tld: options.require_tld })) {
	    return false;
	  }
	
	  if (user[0] === '"') {
	    user = user.slice(1, user.length - 1);
	    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
	  }
	
	  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
	
	  var user_parts = user.split('.');
	  for (var i = 0; i < user_parts.length; i++) {
	    if (!pattern.test(user_parts[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	module.exports = exports['default'];

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmpty;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isEmpty(str) {
	  (0, _assertString2.default)(str);
	  return str.length === 0;
	}
	module.exports = exports['default'];

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFloat;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _alpha = __webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isFloat(str, options) {
	  (0, _assertString2.default)(str);
	  options = options || {};
	  var float = new RegExp('^(?:[-+])?(?:[0-9]+)?(?:\\' + (options.locale ? _alpha.decimal[options.locale] : '.') + '[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$');
	  if (str === '' || str === '.' || str === '-' || str === '+') {
	    return false;
	  }
	  return float.test(str) && (!options.hasOwnProperty('min') || str >= options.min) && (!options.hasOwnProperty('max') || str <= options.max) && (!options.hasOwnProperty('lt') || str < options.lt) && (!options.hasOwnProperty('gt') || str > options.gt);
	}
	module.exports = exports['default'];

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isHash;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lengths = {
	  md5: 32,
	  md4: 32,
	  sha1: 40,
	  sha256: 64,
	  sha384: 96,
	  sha512: 128,
	  ripemd128: 32,
	  ripemd160: 40,
	  tiger128: 32,
	  tiger160: 40,
	  tiger192: 48,
	  crc32: 8,
	  crc32b: 8
	};
	
	function isHash(str, algorithm) {
	  (0, _assertString2.default)(str);
	  var hash = new RegExp('^[a-f0-9]{' + lengths[algorithm] + '}$');
	  return hash.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isHexColor;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hexcolor = /^#?([0-9A-F]{3}|[0-9A-F]{6})$/i;
	
	function isHexColor(str) {
	  (0, _assertString2.default)(str);
	  return hexcolor.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISBN;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isbn10Maybe = /^(?:[0-9]{9}X|[0-9]{10})$/;
	var isbn13Maybe = /^(?:[0-9]{13})$/;
	var factor = [1, 3];
	
	function isISBN(str) {
	  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  (0, _assertString2.default)(str);
	  version = String(version);
	  if (!version) {
	    return isISBN(str, 10) || isISBN(str, 13);
	  }
	  var sanitized = str.replace(/[\s-]+/g, '');
	  var checksum = 0;
	  var i = void 0;
	  if (version === '10') {
	    if (!isbn10Maybe.test(sanitized)) {
	      return false;
	    }
	    for (i = 0; i < 9; i++) {
	      checksum += (i + 1) * sanitized.charAt(i);
	    }
	    if (sanitized.charAt(9) === 'X') {
	      checksum += 10 * 10;
	    } else {
	      checksum += 10 * sanitized.charAt(9);
	    }
	    if (checksum % 11 === 0) {
	      return !!sanitized;
	    }
	  } else if (version === '13') {
	    if (!isbn13Maybe.test(sanitized)) {
	      return false;
	    }
	    for (i = 0; i < 12; i++) {
	      checksum += factor[i % 2] * sanitized.charAt(i);
	    }
	    if (sanitized.charAt(12) - (10 - checksum % 10) % 10 === 0) {
	      return !!sanitized;
	    }
	  }
	  return false;
	}
	module.exports = exports['default'];

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISIN;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isin = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/;
	
	function isISIN(str) {
	  (0, _assertString2.default)(str);
	  if (!isin.test(str)) {
	    return false;
	  }
	
	  var checksumStr = str.replace(/[A-Z]/g, function (character) {
	    return parseInt(character, 36);
	  });
	
	  var sum = 0;
	  var digit = void 0;
	  var tmpNum = void 0;
	  var shouldDouble = true;
	  for (var i = checksumStr.length - 2; i >= 0; i--) {
	    digit = checksumStr.substring(i, i + 1);
	    tmpNum = parseInt(digit, 10);
	    if (shouldDouble) {
	      tmpNum *= 2;
	      if (tmpNum >= 10) {
	        sum += tmpNum + 1;
	      } else {
	        sum += tmpNum;
	      }
	    } else {
	      sum += tmpNum;
	    }
	    shouldDouble = !shouldDouble;
	  }
	
	  return parseInt(str.substr(str.length - 1), 10) === (10000 - sum) % 10;
	}
	module.exports = exports['default'];

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISO31661Alpha2;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
	var validISO31661Alpha2CountriesCodes = ['AD', 'AE', 'AF', 'AG', 'AI', 'AL', 'AM', 'AO', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AW', 'AX', 'AZ', 'BA', 'BB', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BL', 'BM', 'BN', 'BO', 'BQ', 'BR', 'BS', 'BT', 'BV', 'BW', 'BY', 'BZ', 'CA', 'CC', 'CD', 'CF', 'CG', 'CH', 'CI', 'CK', 'CL', 'CM', 'CN', 'CO', 'CR', 'CU', 'CV', 'CW', 'CX', 'CY', 'CZ', 'DE', 'DJ', 'DK', 'DM', 'DO', 'DZ', 'EC', 'EE', 'EG', 'EH', 'ER', 'ES', 'ET', 'FI', 'FJ', 'FK', 'FM', 'FO', 'FR', 'GA', 'GB', 'GD', 'GE', 'GF', 'GG', 'GH', 'GI', 'GL', 'GM', 'GN', 'GP', 'GQ', 'GR', 'GS', 'GT', 'GU', 'GW', 'GY', 'HK', 'HM', 'HN', 'HR', 'HT', 'HU', 'ID', 'IE', 'IL', 'IM', 'IN', 'IO', 'IQ', 'IR', 'IS', 'IT', 'JE', 'JM', 'JO', 'JP', 'KE', 'KG', 'KH', 'KI', 'KM', 'KN', 'KP', 'KR', 'KW', 'KY', 'KZ', 'LA', 'LB', 'LC', 'LI', 'LK', 'LR', 'LS', 'LT', 'LU', 'LV', 'LY', 'MA', 'MC', 'MD', 'ME', 'MF', 'MG', 'MH', 'MK', 'ML', 'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS', 'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NC', 'NE', 'NF', 'NG', 'NI', 'NL', 'NO', 'NP', 'NR', 'NU', 'NZ', 'OM', 'PA', 'PE', 'PF', 'PG', 'PH', 'PK', 'PL', 'PM', 'PN', 'PR', 'PS', 'PT', 'PW', 'PY', 'QA', 'RE', 'RO', 'RS', 'RU', 'RW', 'SA', 'SB', 'SC', 'SD', 'SE', 'SG', 'SH', 'SI', 'SJ', 'SK', 'SL', 'SM', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SX', 'SY', 'SZ', 'TC', 'TD', 'TF', 'TG', 'TH', 'TJ', 'TK', 'TL', 'TM', 'TN', 'TO', 'TR', 'TT', 'TV', 'TW', 'TZ', 'UA', 'UG', 'UM', 'US', 'UY', 'UZ', 'VA', 'VC', 'VE', 'VG', 'VI', 'VN', 'VU', 'WF', 'WS', 'YE', 'YT', 'ZA', 'ZM', 'ZW'];
	
	function isISO31661Alpha2(str) {
	  (0, _assertString2.default)(str);
	  return validISO31661Alpha2CountriesCodes.includes(str.toUpperCase());
	}
	module.exports = exports['default'];

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISO8601;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	// from http://goo.gl/0ejHHW
	var iso8601 = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
	/* eslint-enable max-len */
	
	function isISO8601(str) {
	  (0, _assertString2.default)(str);
	  return iso8601.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISRC;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// see http://isrc.ifpi.org/en/isrc-standard/code-syntax
	var isrc = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;
	
	function isISRC(str) {
	  (0, _assertString2.default)(str);
	  return isrc.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISSN;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var issn = '^\\d{4}-?\\d{3}[\\dX]$';
	
	function isISSN(str) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  (0, _assertString2.default)(str);
	  var testIssn = issn;
	  testIssn = options.require_hyphen ? testIssn.replace('?', '') : testIssn;
	  testIssn = options.case_sensitive ? new RegExp(testIssn) : new RegExp(testIssn, 'i');
	  if (!testIssn.test(str)) {
	    return false;
	  }
	  var issnDigits = str.replace('-', '');
	  var position = 8;
	  var checksum = 0;
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = issnDigits[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var digit = _step.value;
	
	      var digitValue = digit.toUpperCase() === 'X' ? 10 : +digit;
	      checksum += digitValue * position;
	      --position;
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return checksum % 11 === 0;
	}
	module.exports = exports['default'];

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isIn;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _toString = __webpack_require__(194);
	
	var _toString2 = _interopRequireDefault(_toString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isIn(str, options) {
	  (0, _assertString2.default)(str);
	  var i = void 0;
	  if (Object.prototype.toString.call(options) === '[object Array]') {
	    var array = [];
	    for (i in options) {
	      if ({}.hasOwnProperty.call(options, i)) {
	        array[i] = (0, _toString2.default)(options[i]);
	      }
	    }
	    return array.indexOf(str) >= 0;
	  } else if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	    return options.hasOwnProperty(str);
	  } else if (options && typeof options.indexOf === 'function') {
	    return options.indexOf(str) >= 0;
	  }
	  return false;
	}
	module.exports = exports['default'];

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isJSON;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isJSON(str) {
	  (0, _assertString2.default)(str);
	  try {
	    var obj = JSON.parse(str);
	    return !!obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
	  } catch (e) {/* ignore */}
	  return false;
	}
	module.exports = exports['default'];

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (str) {
	  (0, _assertString2.default)(str);
	  if (!str.includes(',')) return false;
	  var pair = str.split(',');
	  return lat.test(pair[0]) && long.test(pair[1]);
	};
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lat = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/;
	var long = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/;
	
	module.exports = exports['default'];

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isLength;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable prefer-rest-params */
	function isLength(str, options) {
	  (0, _assertString2.default)(str);
	  var min = void 0;
	  var max = void 0;
	  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	    min = options.min || 0;
	    max = options.max;
	  } else {
	    // backwards compatibility: isLength(str, min [, max])
	    min = arguments[1];
	    max = arguments[2];
	  }
	  var surrogatePairs = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
	  var len = str.length - surrogatePairs.length;
	  return len >= min && (typeof max === 'undefined' || len <= max);
	}
	module.exports = exports['default'];

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isLowercase;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isLowercase(str) {
	  (0, _assertString2.default)(str);
	  return str === str.toLowerCase();
	}
	module.exports = exports['default'];

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMACAddress;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var macAddress = /^([0-9a-fA-F][0-9a-fA-F]:){5}([0-9a-fA-F][0-9a-fA-F])$/;
	
	function isMACAddress(str) {
	  (0, _assertString2.default)(str);
	  return macAddress.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMD5;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var md5 = /^[a-f0-9]{32}$/;
	
	function isMD5(str) {
	  (0, _assertString2.default)(str);
	  return md5.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMimeType;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	  Checks if the provided string matches to a correct Media type format (MIME type)
	
	  This function only checks is the string format follows the
	  etablished rules by the according RFC specifications.
	  This function supports 'charset' in textual media types
	  (https://tools.ietf.org/html/rfc6657).
	
	  This function does not check against all the media types listed
	  by the IANA (https://www.iana.org/assignments/media-types/media-types.xhtml)
	  because of lightness purposes : it would require to include
	  all these MIME types in this librairy, which would weigh it
	  significantly. This kind of effort maybe is not worth for the use that
	  this function has in this entire librairy.
	
	  More informations in the RFC specifications :
	  - https://tools.ietf.org/html/rfc2045
	  - https://tools.ietf.org/html/rfc2046
	  - https://tools.ietf.org/html/rfc7231#section-3.1.1.1
	  - https://tools.ietf.org/html/rfc7231#section-3.1.1.5
	*/
	
	// Match simple MIME types
	// NB :
	//   Subtype length must not exceed 100 characters.
	//   This rule does not comply to the RFC specs (what is the max length ?).
	var mimeTypeSimple = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+]{1,100}$/i; // eslint-disable-line max-len
	
	// Handle "charset" in "text/*"
	var mimeTypeText = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i; // eslint-disable-line max-len
	
	// Handle "boundary" in "multipart/*"
	var mimeTypeMultipart = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i; // eslint-disable-line max-len
	
	function isMimeType(str) {
	  (0, _assertString2.default)(str);
	  return mimeTypeSimple.test(str) || mimeTypeText.test(str) || mimeTypeMultipart.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMobilePhone;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	var phones = {
	  'ar-AE': /^((\+?971)|0)?5[024568]\d{7}$/,
	  'ar-DZ': /^(\+?213|0)(5|6|7)\d{8}$/,
	  'ar-EG': /^((\+?20)|0)?1[012]\d{8}$/,
	  'ar-JO': /^(\+?962|0)?7[789]\d{7}$/,
	  'ar-SA': /^(!?(\+?966)|0)?5\d{8}$/,
	  'ar-SY': /^(!?(\+?963)|0)?9\d{8}$/,
	  'cs-CZ': /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
	  'da-DK': /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
	  'de-DE': /^(\+?49[ \.\-])?([\(]{1}[0-9]{1,6}[\)])?([0-9 \.\-\/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/,
	  'el-GR': /^(\+?30|0)?(69\d{8})$/,
	  'en-AU': /^(\+?61|0)4\d{8}$/,
	  'en-GB': /^(\+?44|0)7\d{9}$/,
	  'en-HK': /^(\+?852\-?)?[456789]\d{3}\-?\d{4}$/,
	  'en-IN': /^(\+?91|0)?[789]\d{9}$/,
	  'en-KE': /^(\+?254|0)?[7]\d{8}$/,
	  'en-NG': /^(\+?234|0)?[789]\d{9}$/,
	  'en-NZ': /^(\+?64|0)2\d{7,9}$/,
	  'en-PK': /^((\+92)|(0092))-{0,1}\d{3}-{0,1}\d{7}$|^\d{11}$|^\d{4}-\d{7}$/,
	  'en-RW': /^(\+?250|0)?[7]\d{8}$/,
	  'en-SG': /^(\+65)?[89]\d{7}$/,
	  'en-TZ': /^(\+?255|0)?[67]\d{8}$/,
	  'en-UG': /^(\+?256|0)?[7]\d{8}$/,
	  'en-US': /^(\+?1)?[2-9]\d{2}[2-9](?!11)\d{6}$/,
	  'en-ZA': /^(\+?27|0)\d{9}$/,
	  'en-ZM': /^(\+?26)?09[567]\d{7}$/,
	  'es-ES': /^(\+?34)?(6\d{1}|7[1234])\d{7}$/,
	  'et-EE': /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
	  'fa-IR': /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
	  'fi-FI': /^(\+?358|0)\s?(4(0|1|2|4|5|6)?|50)\s?(\d\s?){4,8}\d$/,
	  'fo-FO': /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
	  'fr-FR': /^(\+?33|0)[67]\d{8}$/,
	  'he-IL': /^(\+972|0)([23489]|5[0248]|77)[1-9]\d{6}/,
	  'hu-HU': /^(\+?36)(20|30|70)\d{7}$/,
	  'id-ID': /^(\+?62|0[1-9])[\s|\d]+$/,
	  'it-IT': /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
	  'ja-JP': /^(\+?81|0)[789]0[ \-]?[1-9]\d{2}[ \-]?\d{5}$/,
	  'kl-GL': /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
	  'ko-KR': /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
	  'lt-LT': /^(\+370|8)\d{8}$/,
	  'ms-MY': /^(\+?6?01){1}(([145]{1}(\-|\s)?\d{7,8})|([236789]{1}(\s|\-)?\d{7}))$/,
	  'nb-NO': /^(\+?47)?[49]\d{7}$/,
	  'nl-BE': /^(\+?32|0)4?\d{8}$/,
	  'nn-NO': /^(\+?47)?[49]\d{7}$/,
	  'pl-PL': /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
	  'pt-BR': /^(\+?55|0)\-?[1-9]{2}\-?[2-9]{1}\d{3,4}\-?\d{4}$/,
	  'pt-PT': /^(\+?351)?9[1236]\d{7}$/,
	  'ro-RO': /^(\+?4?0)\s?7\d{2}(\/|\s|\.|\-)?\d{3}(\s|\.|\-)?\d{3}$/,
	  'ru-RU': /^(\+?7|8)?9\d{9}$/,
	  'sk-SK': /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
	  'sr-RS': /^(\+3816|06)[- \d]{5,9}$/,
	  'tr-TR': /^(\+?90|0)?5\d{9}$/,
	  'uk-UA': /^(\+?38|8)?0\d{9}$/,
	  'vi-VN': /^(\+?84|0)?((1(2([0-9])|6([2-9])|88|99))|(9((?!5)[0-9])))([0-9]{7})$/,
	  'zh-CN': /^(\+?0?86\-?)?1[345789]\d{9}$/,
	  'zh-TW': /^(\+?886\-?|0)?9\d{8}$/
	};
	/* eslint-enable max-len */
	
	// aliases
	phones['en-CA'] = phones['en-US'];
	phones['fr-BE'] = phones['nl-BE'];
	phones['zh-HK'] = phones['en-HK'];
	
	function isMobilePhone(str, locale) {
	  (0, _assertString2.default)(str);
	  if (locale in phones) {
	    return phones[locale].test(str);
	  } else if (locale === 'any') {
	    for (var key in phones) {
	      if (phones.hasOwnProperty(key)) {
	        var phone = phones[key];
	        if (phone.test(str)) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	  throw new Error('Invalid locale \'' + locale + '\'');
	}
	module.exports = exports['default'];

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMongoId;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _isHexadecimal = __webpack_require__(326);
	
	var _isHexadecimal2 = _interopRequireDefault(_isHexadecimal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isMongoId(str) {
	  (0, _assertString2.default)(str);
	  return (0, _isHexadecimal2.default)(str) && str.length === 24;
	}
	module.exports = exports['default'];

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMultibyte;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-control-regex */
	var multibyte = /[^\x00-\x7F]/;
	/* eslint-enable no-control-regex */
	
	function isMultibyte(str) {
	  (0, _assertString2.default)(str);
	  return multibyte.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isNumeric;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var numeric = /^[-+]?[0-9]+$/;
	
	function isNumeric(str) {
	  (0, _assertString2.default)(str);
	  return numeric.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPort;
	
	var _isInt = __webpack_require__(328);
	
	var _isInt2 = _interopRequireDefault(_isInt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isPort(str) {
	  return (0, _isInt2.default)(str, { min: 0, max: 65535 });
	}
	module.exports = exports['default'];

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.locales = undefined;
	
	exports.default = function (str, locale) {
	  (0, _assertString2.default)(str);
	  if (locale in patterns) {
	    return patterns[locale].test(str);
	  } else if (locale === 'any') {
	    for (var key in patterns) {
	      if (patterns.hasOwnProperty(key)) {
	        var pattern = patterns[key];
	        if (pattern.test(str)) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	  throw new Error('Invalid locale \'' + locale + '\'');
	};
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// common patterns
	var threeDigit = /^\d{3}$/;
	var fourDigit = /^\d{4}$/;
	var fiveDigit = /^\d{5}$/;
	var sixDigit = /^\d{6}$/;
	
	var patterns = {
	  AT: fourDigit,
	  AU: fourDigit,
	  BE: fourDigit,
	  CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
	  CH: fourDigit,
	  CZ: /^\d{3}\s?\d{2}$/,
	  DE: fiveDigit,
	  DK: fourDigit,
	  DZ: fiveDigit,
	  ES: fiveDigit,
	  FI: fiveDigit,
	  FR: /^\d{2}\s?\d{3}$/,
	  GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
	  GR: /^\d{3}\s?\d{2}$/,
	  IL: fiveDigit,
	  IN: sixDigit,
	  IS: threeDigit,
	  IT: fiveDigit,
	  JP: /^\d{3}\-\d{4}$/,
	  KE: fiveDigit,
	  LI: /^(948[5-9]|949[0-7])$/,
	  MX: fiveDigit,
	  NL: /^\d{4}\s?[a-z]{2}$/i,
	  NO: fourDigit,
	  PL: /^\d{2}\-\d{3}$/,
	  PT: /^\d{4}\-\d{3}?$/,
	  RO: sixDigit,
	  RU: sixDigit,
	  SA: fiveDigit,
	  SE: /^\d{3}\s?\d{2}$/,
	  TW: /^\d{3}(\d{2})?$/,
	  US: /^\d{5}(-\d{4})?$/,
	  ZA: fourDigit,
	  ZM: fiveDigit
	};
	
	var locales = exports.locales = Object.keys(patterns);

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSurrogatePair;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
	
	function isSurrogatePair(str) {
	  (0, _assertString2.default)(str);
	  return surrogatePair.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isURL;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _isFQDN = __webpack_require__(192);
	
	var _isFQDN2 = _interopRequireDefault(_isFQDN);
	
	var _isIP = __webpack_require__(327);
	
	var _isIP2 = _interopRequireDefault(_isIP);
	
	var _merge = __webpack_require__(68);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_url_options = {
	  protocols: ['http', 'https', 'ftp'],
	  require_tld: true,
	  require_protocol: false,
	  require_host: true,
	  require_valid_protocol: true,
	  allow_underscores: false,
	  allow_trailing_dot: false,
	  allow_protocol_relative_urls: false
	};
	
	var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;
	
	function isRegExp(obj) {
	  return Object.prototype.toString.call(obj) === '[object RegExp]';
	}
	
	function checkHost(host, matches) {
	  for (var i = 0; i < matches.length; i++) {
	    var match = matches[i];
	    if (host === match || isRegExp(match) && match.test(host)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	function isURL(url, options) {
	  (0, _assertString2.default)(url);
	  if (!url || url.length >= 2083 || /[\s<>]/.test(url)) {
	    return false;
	  }
	  if (url.indexOf('mailto:') === 0) {
	    return false;
	  }
	  options = (0, _merge2.default)(options, default_url_options);
	  var protocol = void 0,
	      auth = void 0,
	      host = void 0,
	      hostname = void 0,
	      port = void 0,
	      port_str = void 0,
	      split = void 0,
	      ipv6 = void 0;
	
	  split = url.split('#');
	  url = split.shift();
	
	  split = url.split('?');
	  url = split.shift();
	
	  split = url.split('://');
	  if (split.length > 1) {
	    protocol = split.shift();
	    if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
	      return false;
	    }
	  } else if (options.require_protocol) {
	    return false;
	  } else if (options.allow_protocol_relative_urls && url.substr(0, 2) === '//') {
	    split[0] = url.substr(2);
	  }
	  url = split.join('://');
	
	  if (url === '') {
	    return false;
	  }
	
	  split = url.split('/');
	  url = split.shift();
	
	  if (url === '' && !options.require_host) {
	    return true;
	  }
	
	  split = url.split('@');
	  if (split.length > 1) {
	    auth = split.shift();
	    if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
	      return false;
	    }
	  }
	  hostname = split.join('@');
	
	  port_str = null;
	  ipv6 = null;
	  var ipv6_match = hostname.match(wrapped_ipv6);
	  if (ipv6_match) {
	    host = '';
	    ipv6 = ipv6_match[1];
	    port_str = ipv6_match[2] || null;
	  } else {
	    split = hostname.split(':');
	    host = split.shift();
	    if (split.length) {
	      port_str = split.join(':');
	    }
	  }
	
	  if (port_str !== null) {
	    port = parseInt(port_str, 10);
	    if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
	      return false;
	    }
	  }
	
	  if (!(0, _isIP2.default)(host) && !(0, _isFQDN2.default)(host, options) && (!ipv6 || !(0, _isIP2.default)(ipv6, 6))) {
	    return false;
	  }
	
	  host = host || ipv6;
	
	  if (options.host_whitelist && !checkHost(host, options.host_whitelist)) {
	    return false;
	  }
	  if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
	    return false;
	  }
	
	  return true;
	}
	module.exports = exports['default'];

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isUUID;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uuid = {
	  3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
	  4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
	  5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
	  all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
	};
	
	function isUUID(str) {
	  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';
	
	  (0, _assertString2.default)(str);
	  var pattern = uuid[version];
	  return pattern && pattern.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isUppercase;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isUppercase(str) {
	  (0, _assertString2.default)(str);
	  return str === str.toUpperCase();
	}
	module.exports = exports['default'];

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isVariableWidth;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _isFullWidth = __webpack_require__(324);
	
	var _isHalfWidth = __webpack_require__(325);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isVariableWidth(str) {
	  (0, _assertString2.default)(str);
	  return _isFullWidth.fullWidth.test(str) && _isHalfWidth.halfWidth.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWhitelisted;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isWhitelisted(str, chars) {
	  (0, _assertString2.default)(str);
	  for (var i = str.length - 1; i >= 0; i--) {
	    if (chars.indexOf(str[i]) === -1) {
	      return false;
	    }
	  }
	  return true;
	}
	module.exports = exports['default'];

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = matches;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function matches(str, pattern, modifiers) {
	  (0, _assertString2.default)(str);
	  if (Object.prototype.toString.call(pattern) !== '[object RegExp]') {
	    pattern = new RegExp(pattern, modifiers);
	  }
	  return pattern.test(str);
	}
	module.exports = exports['default'];

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = normalizeEmail;
	
	var _merge = __webpack_require__(68);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_normalize_email_options = {
	  // The following options apply to all email addresses
	  // Lowercases the local part of the email address.
	  // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
	  // The domain is always lowercased, as per RFC 1035
	  all_lowercase: true,
	
	  // The following conversions are specific to GMail
	  // Lowercases the local part of the GMail address (known to be case-insensitive)
	  gmail_lowercase: true,
	  // Removes dots from the local part of the email address, as that's ignored by GMail
	  gmail_remove_dots: true,
	  // Removes the subaddress (e.g. "+foo") from the email address
	  gmail_remove_subaddress: true,
	  // Conversts the googlemail.com domain to gmail.com
	  gmail_convert_googlemaildotcom: true,
	
	  // The following conversions are specific to Outlook.com / Windows Live / Hotmail
	  // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
	  outlookdotcom_lowercase: true,
	  // Removes the subaddress (e.g. "+foo") from the email address
	  outlookdotcom_remove_subaddress: true,
	
	  // The following conversions are specific to Yahoo
	  // Lowercases the local part of the Yahoo address (known to be case-insensitive)
	  yahoo_lowercase: true,
	  // Removes the subaddress (e.g. "-foo") from the email address
	  yahoo_remove_subaddress: true,
	
	  // The following conversions are specific to iCloud
	  // Lowercases the local part of the iCloud address (known to be case-insensitive)
	  icloud_lowercase: true,
	  // Removes the subaddress (e.g. "+foo") from the email address
	  icloud_remove_subaddress: true
	};
	
	// List of domains used by iCloud
	var icloud_domains = ['icloud.com', 'me.com'];
	
	// List of domains used by Outlook.com and its predecessors
	// This list is likely incomplete.
	// Partial reference:
	// https://blogs.office.com/2013/04/17/outlook-com-gets-two-step-verification-sign-in-by-alias-and-new-international-domains/
	var outlookdotcom_domains = ['hotmail.at', 'hotmail.be', 'hotmail.ca', 'hotmail.cl', 'hotmail.co.il', 'hotmail.co.nz', 'hotmail.co.th', 'hotmail.co.uk', 'hotmail.com', 'hotmail.com.ar', 'hotmail.com.au', 'hotmail.com.br', 'hotmail.com.gr', 'hotmail.com.mx', 'hotmail.com.pe', 'hotmail.com.tr', 'hotmail.com.vn', 'hotmail.cz', 'hotmail.de', 'hotmail.dk', 'hotmail.es', 'hotmail.fr', 'hotmail.hu', 'hotmail.id', 'hotmail.ie', 'hotmail.in', 'hotmail.it', 'hotmail.jp', 'hotmail.kr', 'hotmail.lv', 'hotmail.my', 'hotmail.ph', 'hotmail.pt', 'hotmail.sa', 'hotmail.sg', 'hotmail.sk', 'live.be', 'live.co.uk', 'live.com', 'live.com.ar', 'live.com.mx', 'live.de', 'live.es', 'live.eu', 'live.fr', 'live.it', 'live.nl', 'msn.com', 'outlook.at', 'outlook.be', 'outlook.cl', 'outlook.co.il', 'outlook.co.nz', 'outlook.co.th', 'outlook.com', 'outlook.com.ar', 'outlook.com.au', 'outlook.com.br', 'outlook.com.gr', 'outlook.com.pe', 'outlook.com.tr', 'outlook.com.vn', 'outlook.cz', 'outlook.de', 'outlook.dk', 'outlook.es', 'outlook.fr', 'outlook.hu', 'outlook.id', 'outlook.ie', 'outlook.in', 'outlook.it', 'outlook.jp', 'outlook.kr', 'outlook.lv', 'outlook.my', 'outlook.ph', 'outlook.pt', 'outlook.sa', 'outlook.sg', 'outlook.sk', 'passport.com'];
	
	// List of domains used by Yahoo Mail
	// This list is likely incomplete
	var yahoo_domains = ['rocketmail.com', 'yahoo.ca', 'yahoo.co.uk', 'yahoo.com', 'yahoo.de', 'yahoo.fr', 'yahoo.in', 'yahoo.it', 'ymail.com'];
	
	function normalizeEmail(email, options) {
	  options = (0, _merge2.default)(options, default_normalize_email_options);
	
	  var raw_parts = email.split('@');
	  var domain = raw_parts.pop();
	  var user = raw_parts.join('@');
	  var parts = [user, domain];
	
	  // The domain is always lowercased, as it's case-insensitive per RFC 1035
	  parts[1] = parts[1].toLowerCase();
	
	  if (parts[1] === 'gmail.com' || parts[1] === 'googlemail.com') {
	    // Address is GMail
	    if (options.gmail_remove_subaddress) {
	      parts[0] = parts[0].split('+')[0];
	    }
	    if (options.gmail_remove_dots) {
	      parts[0] = parts[0].replace(/\./g, '');
	    }
	    if (!parts[0].length) {
	      return false;
	    }
	    if (options.all_lowercase || options.gmail_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	    parts[1] = options.gmail_convert_googlemaildotcom ? 'gmail.com' : parts[1];
	  } else if (~icloud_domains.indexOf(parts[1])) {
	    // Address is iCloud
	    if (options.icloud_remove_subaddress) {
	      parts[0] = parts[0].split('+')[0];
	    }
	    if (!parts[0].length) {
	      return false;
	    }
	    if (options.all_lowercase || options.icloud_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	  } else if (~outlookdotcom_domains.indexOf(parts[1])) {
	    // Address is Outlook.com
	    if (options.outlookdotcom_remove_subaddress) {
	      parts[0] = parts[0].split('+')[0];
	    }
	    if (!parts[0].length) {
	      return false;
	    }
	    if (options.all_lowercase || options.outlookdotcom_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	  } else if (~yahoo_domains.indexOf(parts[1])) {
	    // Address is Yahoo
	    if (options.yahoo_remove_subaddress) {
	      var components = parts[0].split('-');
	      parts[0] = components.length > 1 ? components.slice(0, -1).join('-') : components[0];
	    }
	    if (!parts[0].length) {
	      return false;
	    }
	    if (options.all_lowercase || options.yahoo_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	  } else if (options.all_lowercase) {
	    // Any other address
	    parts[0] = parts[0].toLowerCase();
	  }
	  return parts.join('@');
	}
	module.exports = exports['default'];

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stripLow;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _blacklist = __webpack_require__(322);
	
	var _blacklist2 = _interopRequireDefault(_blacklist);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function stripLow(str, keep_new_lines) {
	  (0, _assertString2.default)(str);
	  var chars = keep_new_lines ? '\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F' : '\\x00-\\x1F\\x7F';
	  return (0, _blacklist2.default)(str, chars);
	}
	module.exports = exports['default'];

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toBoolean;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toBoolean(str, strict) {
	  (0, _assertString2.default)(str);
	  if (strict) {
	    return str === '1' || str === 'true';
	  }
	  return str !== '0' && str !== 'false' && str !== '';
	}
	module.exports = exports['default'];

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toInt;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toInt(str, radix) {
	  (0, _assertString2.default)(str);
	  return parseInt(str, radix || 10);
	}
	module.exports = exports['default'];

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = trim;
	
	var _rtrim = __webpack_require__(330);
	
	var _rtrim2 = _interopRequireDefault(_rtrim);
	
	var _ltrim = __webpack_require__(329);
	
	var _ltrim2 = _interopRequireDefault(_ltrim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function trim(str, chars) {
	  return (0, _rtrim2.default)((0, _ltrim2.default)(str, chars), chars);
	}
	module.exports = exports['default'];

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = unescape;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function unescape(str) {
	  (0, _assertString2.default)(str);
	  return str.replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#x2F;/g, '/').replace(/&#x5C;/g, '\\').replace(/&#96;/g, '`');
	}
	module.exports = exports['default'];

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = whitelist;
	
	var _assertString = __webpack_require__(4);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function whitelist(str, chars) {
	  (0, _assertString2.default)(str);
	  return str.replace(new RegExp('[^' + chars + ']+', 'g'), '');
	}
	module.exports = exports['default'];

/***/ }),
/* 807 */,
/* 808 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ })
]);


// WEBPACK FOOTER //
// component---src-pages-index-js-c0a96bcdd8240ae30768.js